var GG = Object.defineProperty;
var G$ = (c) => {
  throw TypeError(c);
};
var QG = (c, s, t) => s in c ? GG(c, s, { enumerable: !0, configurable: !0, writable: !0, value: t }) : c[s] = t;
var I = (c, s, t) => QG(c, typeof s != "symbol" ? s + "" : s, t), X4 = (c, s, t) => s.has(c) || G$("Cannot " + t);
var l = (c, s, t) => (X4(c, s, "read from private field"), t ? t.call(c) : s.get(c)), k = (c, s, t) => s.has(c) ? G$("Cannot add the same private member more than once") : s instanceof WeakSet ? s.add(c) : s.set(c, t), L = (c, s, t, r) => (X4(c, s, "write to private field"), r ? r.call(c, t) : s.set(c, t), t), m = (c, s, t) => (X4(c, s, "access private method"), t);
var Q$ = (c, s, t, r) => ({
  set _(f) {
    L(c, s, f, t);
  },
  get _() {
    return l(c, s, r);
  }
});
import * as _ from "react";
import QD from "react";
const ll = typeof document > "u", du = Symbol(0);
let x9 = !1, k7 = !1, rl = null, og = null, fo = null, $s = 0, ig = [], vk = {};
const YG = () => {
}, A1 = 0, YD = 1, R9 = 2, lw = 3;
function WG() {
  x9 = !0, queueMicrotask(WD);
}
function WD() {
  if (!ig.length) {
    x9 = !1;
    return;
  }
  k7 = !0;
  for (let c = 0; c < ig.length; c++)
    ig[c].$st !== A1 && KG(ig[c]);
  ig = [], x9 = !1, k7 = !1;
}
function KG(c) {
  let s = [c];
  for (; c = c[du]; )
    c.$e && c.$st !== A1 && s.push(c);
  for (let t = s.length - 1; t >= 0; t--)
    Tk(s[t]);
}
function ZG(c) {
  const s = Xc();
  return P0(s, c.length ? c.bind(null, k1.bind(s)) : c, null);
}
function fe(c) {
  return P0(rl, c, null);
}
function Gm(c) {
  return P0(null, c, null);
}
function al() {
  k7 || WD();
}
function A0() {
  return rl;
}
function la(c, s) {
  try {
    return P0(s, c, null);
  } catch (t) {
    gk(s, t);
    return;
  }
}
function yk(c, s = rl) {
  return s == null ? void 0 : s.$cx[c];
}
function XG(c, s, t = rl) {
  t && (t.$cx = { ...t.$cx, [c]: s });
}
function bt(c) {
  if (!c || !rl)
    return c || YG;
  const s = rl;
  return s.$d ? Array.isArray(s.$d) ? s.$d.push(c) : s.$d = [s.$d, c] : s.$d = c, function() {
    s.$st !== lw && (c.call(null), uw(s.$d) ? s.$d = null : Array.isArray(s.$d) && s.$d.splice(s.$d.indexOf(c), 1));
  };
}
function k1(c = !0) {
  if (this.$st !== lw) {
    if (this.$h)
      if (Array.isArray(this.$h))
        for (let s = this.$h.length - 1; s >= 0; s--)
          k1.call(this.$h[s]);
      else
        k1.call(this.$h);
    if (c) {
      const s = this[du];
      s && (Array.isArray(s.$h) ? s.$h.splice(s.$h.indexOf(this), 1) : s.$h = null), JG(this);
    }
  }
}
function JG(c) {
  c.$st = lw, c.$d && KD(c), c.$s && x7(c, 0), c[du] = null, c.$s = null, c.$o = null, c.$h = null, c.$cx = vk, c.$eh = null;
}
function KD(c) {
  try {
    if (Array.isArray(c.$d))
      for (let s = c.$d.length - 1; s >= 0; s--) {
        const t = c.$d[s];
        t.call(t);
      }
    else
      c.$d.call(c.$d);
    c.$d = null;
  } catch (s) {
    gk(c, s);
  }
}
function P0(c, s, t) {
  const r = rl, f = og;
  rl = c, og = t;
  try {
    return s.call(c);
  } finally {
    rl = r, og = f;
  }
}
function gk(c, s) {
  if (!c || !c.$eh)
    throw s;
  let t = 0, r = c.$eh.length, f = s;
  for (t = 0; t < r; t++)
    try {
      c.$eh[t](f);
      break;
    } catch (v) {
      f = v;
    }
  if (t === r)
    throw f;
}
function Ck() {
  return this.$st === lw ? this.$v : (og && !this.$e && (!fo && og.$s && og.$s[$s] == this ? $s++ : fo ? fo.push(this) : fo = [this]), this.$c && Tk(this), this.$v);
}
function ZD(c) {
  const s = uw(c) ? c(this.$v) : c;
  if (this.$ch(this.$v, s) && (this.$v = s, this.$o))
    for (let t = 0; t < this.$o.length; t++)
      eM(this.$o[t], R9);
  return this.$v;
}
const Sk = function() {
  this[du] = null, this.$h = null, rl && rl.append(this);
}, ev = Sk.prototype;
ev.$cx = vk;
ev.$eh = null;
ev.$c = null;
ev.$d = null;
ev.append = function(c) {
  c[du] = this, this.$h ? Array.isArray(this.$h) ? this.$h.push(c) : this.$h = [this.$h, c] : this.$h = c, c.$cx = c.$cx === vk ? this.$cx : { ...this.$cx, ...c.$cx }, this.$eh && (c.$eh = c.$eh ? [...c.$eh, ...this.$eh] : this.$eh);
};
ev.dispose = function() {
  k1.call(this);
};
function Xc() {
  return new Sk();
}
const XD = function(s, t, r) {
  Sk.call(this), this.$st = t ? R9 : A1, this.$i = !1, this.$e = !1, this.$s = null, this.$o = null, this.$v = s, t && (this.$c = t), r && r.dirty && (this.$ch = r.dirty);
}, bk = XD.prototype;
Object.setPrototypeOf(bk, ev);
bk.$ch = eQ;
bk.call = Ck;
function wk(c, s, t) {
  return new XD(c, s, t);
}
function eQ(c, s) {
  return c !== s;
}
function uw(c) {
  return typeof c == "function";
}
function Tk(c) {
  if (c.$st === YD)
    for (let s = 0; s < c.$s.length && (Tk(c.$s[s]), c.$st !== R9); s++)
      ;
  c.$st === R9 ? JD(c) : c.$st = A1;
}
function tQ(c) {
  c.$h && k1.call(c, !1), c.$d && KD(c), c.$eh = c[du] ? c[du].$eh : null;
}
function JD(c) {
  let s = fo, t = $s;
  fo = null, $s = 0;
  try {
    tQ(c);
    const r = P0(c, c.$c, c);
    Y$(c), !c.$e && c.$i ? ZD.call(c, r) : (c.$v = r, c.$i = !0);
  } catch (r) {
    Y$(c), gk(c, r);
  } finally {
    fo = s, $s = t, c.$st = A1;
  }
}
function Y$(c) {
  if (fo) {
    if (c.$s && x7(c, $s), c.$s && $s > 0) {
      c.$s.length = $s + fo.length;
      for (let t = 0; t < fo.length; t++)
        c.$s[$s + t] = fo[t];
    } else
      c.$s = fo;
    let s;
    for (let t = $s; t < c.$s.length; t++)
      s = c.$s[t], s.$o ? s.$o.push(c) : s.$o = [c];
  } else c.$s && $s < c.$s.length && (x7(c, $s), c.$s.length = $s);
}
function eM(c, s) {
  if (!(c.$st >= s) && (c.$e && c.$st === A1 && (ig.push(c), x9 || WG()), c.$st = s, c.$o))
    for (let t = 0; t < c.$o.length; t++)
      eM(c.$o[t], YD);
}
function x7(c, s) {
  let t, r;
  for (let f = s; f < c.$s.length; f++)
    t = c.$s[f], t.$o && (r = t.$o.indexOf(c), t.$o[r] = t.$o[t.$o.length - 1], t.$o.pop());
}
function nt(c, s) {
  const t = wk(c, null, s), r = Ck.bind(t);
  return r[du] = !0, r.set = ZD.bind(t), r;
}
function nQ(c) {
  return uw(c) && du in c;
}
function sh(c, s) {
  const t = wk(
    s == null ? void 0 : s.initial,
    c,
    s
  ), r = Ck.bind(t);
  return r[du] = !0, r;
}
function Ek(c, s) {
  const t = wk(
    null,
    function() {
      let f = c();
      return uw(f) && bt(f), null;
    },
    void 0
  );
  return t.$e = !0, JD(t), k1.bind(t, !0);
}
function tM(c) {
  return nQ(c) && "set" in c;
}
function Ms(...c) {
}
function sl(c) {
  return c === null;
}
function Di(c) {
  return typeof c > "u";
}
function nM(c) {
  return sl(c) || Di(c);
}
function kk(c) {
  return (c == null ? void 0 : c.constructor) === Object;
}
function ar(c) {
  return typeof c == "number" && !Number.isNaN(c);
}
function qe(c) {
  return typeof c == "string";
}
function iM(c) {
  return typeof c == "boolean";
}
function Ma(c) {
  return typeof c == "function";
}
function vr(c) {
  return Array.isArray(c);
}
const K = ll ? iQ : Ek;
function iQ(c, s) {
  var t;
  return typeof process < "u" && ((t = process.env) == null ? void 0 : t.NODE_ENV) === "test" ? Ek(c) : Ms;
}
const rQ = ll ? class {
} : Event, rM = Symbol("DOM_EVENT");
var VD, UD;
class St extends (UD = rQ, VD = rM, UD) {
  constructor(t, ...r) {
    var v, g;
    super(t, r[0]);
    I(this, VD, !0);
    /**
     * The event detail.
     */
    I(this, "detail");
    /**
     * The event trigger chain.
     */
    I(this, "triggers", new aQ());
    this.detail = (v = r[0]) == null ? void 0 : v.detail;
    const f = (g = r[0]) == null ? void 0 : g.trigger;
    f && this.triggers.add(f);
  }
  /**
   * The preceding event that was responsible for this event being fired.
   */
  get trigger() {
    return this.triggers.source;
  }
  /**
   * The origin event that lead to this event being fired.
   */
  get originEvent() {
    return this.triggers.origin;
  }
  /**
   * Whether the origin event was triggered by the user.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Event/isTrusted}
   */
  get isOriginTrusted() {
    var t;
    return ((t = this.triggers.origin) == null ? void 0 : t.isTrusted) ?? !1;
  }
}
class aQ {
  constructor() {
    I(this, "chain", []);
  }
  get source() {
    return this.chain[0];
  }
  get origin() {
    return this.chain[this.chain.length - 1];
  }
  /**
   * Appends the event to the end of the chain.
   */
  add(s) {
    this.chain.push(s), xk(s) && this.chain.push(...s.triggers);
  }
  /**
   * Removes the event from the chain and returns it (if found).
   */
  remove(s) {
    return this.chain.splice(this.chain.indexOf(s), 1)[0];
  }
  /**
   * Returns whether the chain contains the given `event`.
   */
  has(s) {
    return this.chain.some((t) => t === s);
  }
  /**
   * Returns whether the chain contains the given event type.
   */
  hasType(s) {
    return !!this.findType(s);
  }
  /**
   * Returns the first event with the given `type` found in the chain.
   */
  findType(s) {
    return this.chain.find((t) => t.type === s);
  }
  /**
   * Walks an event chain on a given `event`, and invokes the given `callback` for each trigger event.
   */
  walk(s) {
    for (const t of this.chain) {
      const r = s(t);
      if (r) return [t, r];
    }
  }
  [Symbol.iterator]() {
    return this.chain.values();
  }
}
function xk(c) {
  return !!(c != null && c[rM]);
}
function sQ(c, s) {
  if (xk(c))
    return c.triggers.walk(s);
}
function aM(c, s) {
  return xk(c) ? c.triggers.findType(s) : void 0;
}
function oQ(c, s) {
  return !!aM(c, s);
}
function lQ(c, s) {
  s && c.triggers.add(s);
}
class Rk extends EventTarget {
  constructor() {
    super(...arguments);
    /** @internal type only */
    I(this, "$ts__events");
  }
  addEventListener(t, r, f) {
    return super.addEventListener(t, r, f);
  }
  removeEventListener(t, r, f) {
    return super.removeEventListener(t, r, f);
  }
}
function sn(c, s, t, r) {
  return ll ? Ms : (c.addEventListener(s, t, r), bt(() => c.removeEventListener(s, t, r)));
}
var ug, cg;
class Cn {
  constructor(s) {
    k(this, ug);
    k(this, cg);
    L(this, ug, s), L(this, cg, new AbortController()), bt(this.abort.bind(this));
  }
  get signal() {
    return l(this, cg).signal;
  }
  add(s, t, r) {
    if (this.signal.aborted) throw Error("aborted");
    return l(this, ug).addEventListener(s, t, {
      ...r,
      signal: r != null && r.signal ? uQ(this.signal, r.signal) : this.signal
    }), this;
  }
  remove(s, t) {
    return l(this, ug).removeEventListener(s, t), this;
  }
  abort(s) {
    l(this, cg).abort(s);
  }
}
ug = new WeakMap(), cg = new WeakMap();
function uQ(...c) {
  const s = new AbortController(), t = { signal: s.signal };
  function r(f) {
    s.abort(f.target.reason);
  }
  for (const f of c) {
    if (f.aborted) {
      s.abort(f.reason);
      break;
    }
    f.addEventListener("abort", r, t);
  }
  return s.signal;
}
function R7(c) {
  return !!(c != null && c.type.startsWith("pointer"));
}
function v2(c) {
  return !!(c != null && c.type.startsWith("touch"));
}
function sM(c) {
  return /^(click|mouse)/.test((c == null ? void 0 : c.type) ?? "");
}
function O0(c) {
  return !!(c != null && c.type.startsWith("key"));
}
function oM(c) {
  return O0(c) && c.key === "Enter";
}
function Lk(c) {
  return O0(c) && (c.key === "Enter" || c.key === " ");
}
function lM(c) {
  return c instanceof Node;
}
function lt(c, s, t) {
  if (c) if (!t && t !== "" && t !== 0)
    c.removeAttribute(s);
  else {
    const r = t === !0 ? "" : t + "";
    c.getAttribute(s) !== r && c.setAttribute(s, r);
  }
  else return;
}
function Aa(c, s, t) {
  if (c) !t && t !== 0 ? c.style.removeProperty(s) : c.style.setProperty(s, t + "");
  else return;
}
function cQ(c, s, t) {
  c.classList[t ? "add" : "remove"](s);
}
function W$(c) {
  let s = c;
  for (; typeof s == "function"; ) s = s.call(this);
  return s;
}
function ad(c) {
  return { id: Symbol(), provide: c };
}
function Ps(c, s, t = A0()) {
  var f;
  const r = !Di(s);
  XG(c.id, r ? s : (f = c.provide) == null ? void 0 : f.call(c), t);
}
function gi(c) {
  return yk(c.id);
}
function fu(c) {
  return !Di(yk(c.id));
}
const J4 = /* @__PURE__ */ Symbol(0), e7 = /* @__PURE__ */ Symbol(0), cw = /* @__PURE__ */ Symbol(0), t7 = {};
var zD, dg, fg, Yp, hg, pu, uM, cM, dM, fM;
zD = cw;
class dQ {
  constructor(s, t, r) {
    k(this, pu);
    /** @internal type only */
    I(this, "$ts__events");
    /** @internal type only */
    I(this, "$ts__vars");
    /* @internal */
    I(this, zD, null);
    I(this, "$el", nt(null));
    I(this, "el", null);
    I(this, "scope", null);
    I(this, "attachScope", null);
    I(this, "connectScope", null);
    I(this, "component", null);
    I(this, "destroyed", !1);
    I(this, "props", t7);
    I(this, "attrs", null);
    I(this, "styles", null);
    I(this, "state");
    I(this, "$state");
    k(this, dg, []);
    k(this, fg, []);
    k(this, Yp, []);
    k(this, hg, []);
    var g;
    this.scope = t, r != null && r.scope && r.scope.append(t);
    let f = s.state, v = s.props;
    if (f && (this.$state = f.create(), this.state = new Proxy(this.$state, {
      get: (T, x) => this.$state[x]()
    }), Ps(f, this.$state)), v && (this.props = fQ(v), r != null && r.props))
      for (const T of Object.keys(r.props))
        (g = this.props[T]) == null || g.set(r.props[T]);
    bt(this.destroy.bind(this));
  }
  setup() {
    la(() => {
      for (const s of l(this, dg)) s();
    }, this.scope);
  }
  attach(s) {
    this.el || (this.el = s, this.$el.set(s), la(() => {
      this.attachScope = Xc(), la(() => {
        for (const t of l(this, fg)) t(this.el);
        m(this, pu, uM).call(this), m(this, pu, cM).call(this);
      }, this.attachScope);
    }, this.scope), s.dispatchEvent(new Event("attached")));
  }
  detach() {
    var s;
    (s = this.attachScope) == null || s.dispose(), this.attachScope = null, this.connectScope = null, this.el = null, this.$el.set(null);
  }
  connect() {
    !this.el || !this.attachScope || !l(this, Yp).length || la(() => {
      this.connectScope = Xc(), la(() => {
        for (const s of l(this, Yp)) s(this.el);
      }, this.connectScope);
    }, this.attachScope);
  }
  disconnect() {
    var s;
    (s = this.connectScope) == null || s.dispose(), this.connectScope = null;
  }
  destroy() {
    if (this.destroyed) return;
    this.destroyed = !0, la(() => {
      for (const t of l(this, hg)) t(this.el);
    }, this.scope);
    const s = this.el;
    this.detach(), this.scope.dispose(), l(this, dg).length = 0, l(this, fg).length = 0, l(this, Yp).length = 0, l(this, hg).length = 0, this.component = null, this.attrs = null, this.styles = null, this.props = t7, this.scope = null, this.state = t7, this.$state = null, s && delete s.$;
  }
  addHooks(s) {
    s.onSetup && l(this, dg).push(s.onSetup.bind(s)), s.onAttach && l(this, fg).push(s.onAttach.bind(s)), s.onConnect && l(this, Yp).push(s.onConnect.bind(s)), s.onDestroy && l(this, hg).push(s.onDestroy.bind(s));
  }
}
dg = new WeakMap(), fg = new WeakMap(), Yp = new WeakMap(), hg = new WeakMap(), pu = new WeakSet(), uM = function() {
  if (this.attrs)
    for (const s of Object.keys(this.attrs))
      ll ? lt(this.el, s, W$.call(this.component, this.attrs[s])) : Ma(this.attrs[s]) ? K(m(this, pu, dM).bind(this, s)) : lt(this.el, s, this.attrs[s]);
}, cM = function() {
  if (this.styles)
    for (const s of Object.keys(this.styles))
      ll ? Aa(this.el, s, W$.call(this.component, this.styles[s])) : Ma(this.styles[s]) ? K(m(this, pu, fM).bind(this, s)) : Aa(this.el, s, this.styles[s]);
}, dM = function(s) {
  lt(this.el, s, this.attrs[s].call(this.component));
}, fM = function(s) {
  Aa(this.el, s, this.styles[s].call(this.component));
};
function fQ(c) {
  const s = {};
  for (const t of Object.keys(c)) {
    const r = c[t];
    s[t] = nt(r, r);
  }
  return s;
}
let y2 = { $$: null };
function hM(c, s) {
  return ZG(() => {
    y2.$$ = new dQ(c, A0(), s);
    const t = new c();
    return y2.$$.component = t, y2.$$ = null, t;
  });
}
class Vs extends EventTarget {
  constructor() {
    super();
    /** @internal */
    I(this, "$$");
    y2.$$ && this.attach(y2);
  }
  get el() {
    return this.$$.el;
  }
  get $el() {
    return this.$$.$el();
  }
  get scope() {
    return this.$$.scope;
  }
  get attachScope() {
    return this.$$.attachScope;
  }
  get connectScope() {
    return this.$$.connectScope;
  }
  /** @internal */
  get $props() {
    return this.$$.props;
  }
  /** @internal */
  get $state() {
    return this.$$.$state;
  }
  get state() {
    return this.$$.state;
  }
  attach({ $$: t }) {
    return this.$$ = t, t.addHooks(this), this;
  }
  addEventListener(t, r, f) {
    this.listen(t, r, f);
  }
  removeEventListener(t, r, f) {
    var v;
    (v = this.el) == null || v.removeEventListener(t, r, f);
  }
  /**
   * The given callback is invoked when the component is ready to be set up.
   *
   * - This hook will run once.
   * - This hook is called both client-side and server-side.
   * - It's safe to use context inside this hook.
   * - The host element has not attached yet - wait for `onAttach`.
   */
  /**
   * This method can be used to specify attributes that should be set on the host element. Any
   * attributes that are assigned to a function will be considered a signal and updated accordingly.
   */
  setAttributes(t) {
    this.$$.attrs || (this.$$.attrs = {}), Object.assign(this.$$.attrs, t);
  }
  /**
   * This method can be used to specify styles that should set be set on the host element. Any
   * styles that are assigned to a function will be considered a signal and updated accordingly.
   */
  setStyles(t) {
    this.$$.styles || (this.$$.styles = {}), Object.assign(this.$$.styles, t);
  }
  /**
   * This method is used to satisfy the CSS variables contract specified on the current
   * component. Other CSS variables can be set via the `setStyles` method.
   */
  setCSSVars(t) {
    this.setStyles(t);
  }
  /**
   * Type-safe utility for creating component DOM events.
   */
  createEvent(t, ...r) {
    return new St(t, r[0]);
  }
  /**
   * Creates a `DOMEvent` and dispatches it from the host element. This method is typed to
   * match all component events.
   */
  dispatch(t, ...r) {
    if (ll || !this.el) return !1;
    const f = t instanceof Event ? t : new St(t, r[0]);
    return Object.defineProperty(f, "target", {
      get: () => this.$$.component
    }), Gm(() => {
      var v, g;
      return (g = (v = this.$$)[cw]) == null || g.call(v, f), this.el.dispatchEvent(f);
    });
  }
  dispatchEvent(t) {
    return this.dispatch(t);
  }
  /**
   * Adds an event listener for the given `type` and returns a function which can be invoked to
   * remove the event listener.
   *
   * - The listener is removed if the current scope is disposed.
   * - This method is safe to use on the server (noop).
   */
  listen(t, r, f) {
    return ll || !this.el ? Ms : sn(this.el, t, r, f);
  }
}
class Et extends Vs {
  subscribe(s) {
    return la(() => K(() => s(this.state)), this.$$.scope);
  }
  destroy() {
    this.$$.destroy();
  }
}
function on(c, s, t) {
  c[J4] || (c[J4] = /* @__PURE__ */ new Set()), c[J4].add(s);
}
function Fi(c, s, t) {
  c[e7] || (c[e7] = /* @__PURE__ */ new Set()), c[e7].add(s);
}
var pg;
class sd {
  constructor(s) {
    I(this, "id", Symbol(0));
    I(this, "record");
    k(this, pg);
    this.record = s, L(this, pg, Object.getOwnPropertyDescriptors(s));
  }
  create() {
    const s = {}, t = new Proxy(s, { get: (r, f) => s[f]() });
    for (const r of Object.keys(this.record)) {
      const f = l(this, pg)[r].get;
      s[r] = f ? sh(f.bind(t)) : nt(this.record[r]);
    }
    return s;
  }
  reset(s, t) {
    for (const r of Object.keys(s))
      !l(this, pg)[r].get && (!t || t(r)) && s[r].set(this.record[r]);
  }
}
pg = new WeakMap();
function P1(c) {
  return gi(c);
}
function _0(c) {
  return c.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function $k(c) {
  return c.replace(/-./g, (s) => s[1].toUpperCase());
}
function hQ(c) {
  return pQ(c).replace(/\s/g, "");
}
function pQ(c) {
  return Dk(c.replace(/-./g, (s) => " " + s[1].toUpperCase()));
}
function Dk(c) {
  return c.charAt(0).toUpperCase() + c.slice(1);
}
const N0 = _.createContext({ current: null });
N0.displayName = "Scope";
function pM(c, ...s) {
  return _.createElement(N0.Provider, { value: c }, ...s);
}
function mM() {
  return _.useContext(N0).current;
}
function Mk(c) {
  const s = mM();
  return _.useMemo(() => yk(c.id, s), [s]);
}
function vM(c, s) {
  typeof c == "function" ? c(s) : c && (c.current = s);
}
function pn(...c) {
  return (s) => c.forEach((t) => vM(t, s));
}
function mQ(c, s) {
  const t = _.forwardRef((r, f) => {
    var ce, De, Ne, Se, je, Me, Ct, Ge;
    let v = _.useContext(N0), g = _.useRef(null), T = _.useRef();
    if (!T.current) {
      const he = yQ(), Ze = X$(c, he, r, v.current);
      he.component = Ze, T.current = he, g.current = Ze.scope;
    }
    function x() {
      let he = T.current, Ze = v.current;
      if (window.cancelAnimationFrame(he.destroyId), he.destroyId = -1, he.component.$$.destroyed) {
        const pt = X$(c, he, r, Ze);
        he.component = pt, he.attached = !1, he.forwardRef = !1, g.current = pt.scope;
      }
      return he.el && Z$(he, he.el), he.forwardRef || (vM(f, he.component), he.forwardRef = !0), () => t9(he);
    }
    function $(he) {
      const Ze = T.current;
      if (!Ze.forwardRef) {
        Ze.el = he;
        return;
      }
      window.cancelAnimationFrame(Ze.refChangeId), Ze.refChangeId = window.requestAnimationFrame(() => {
        const pt = T.current;
        pt.refChangeId = -1, pt.el !== he && (t9(pt), he && Z$(pt, he), pt.el = he);
      });
    }
    _.useEffect(() => {
      const he = T.current;
      return window.cancelAnimationFrame(he.destroyId), he.destroyId = -1, function() {
        Ma(r.children) && (window.cancelAnimationFrame(he.refChangeId), he.refChangeId = -1, window.cancelAnimationFrame(he.connectId), he.connectId = -1, window.cancelAnimationFrame(he.destroyId), he.destroyId = window.requestAnimationFrame(() => {
          he.destroyId = -1, t9(he), he.component.$$.destroy(), he.component.$$[cw] = null, he.callbacks = {}, he.domCallbacks = {}, g.current = null;
        }));
      };
    }, []), _.useEffect(al);
    let P = T.current, { children: A, ...U } = r, F = {}, Z = P.prevProps, ne = Object.keys(U);
    P.callbacks = {};
    for (const he of [...Z, ...ne])
      if (s.props.has(he))
        P.component.$props[he].set(
          // If the prop was removed we'll use the default value provided on Component creation.
          Di(U[he]) ? (ce = c.props) == null ? void 0 : ce[he] : U[he]
        );
      else if ((De = s.events) != null && De.has(he) || (Ne = s.eventsRE) != null && Ne.test(he))
        P.callbacks[he] = U[he];
      else if ((Se = s.domEvents) != null && Se.has(he) || (je = s.domEventsRE) != null && je.test(he)) {
        let Ze = _0(he.slice(2));
        P.domCallbacks[Ze] = U[he], ne.includes(he) ? P.el && !((Ge = P.listening) != null && Ge.has(Ze)) && (P.listening || (P.listening = /* @__PURE__ */ new Set()), P.listening.add(Ze), P.el.addEventListener(Ze, P.onDOMEvent)) : ((Me = P.el) == null || Me.removeEventListener(Ze, P.onDOMEvent), (Ct = P.listening) == null || Ct.delete(Ze));
      } else
        F[he] = U[he];
    return P.prevProps = ne, pM(
      g,
      _.createElement(vQ, {
        effect: x
      }),
      Ma(A) ? A == null ? void 0 : A(
        {
          ...F,
          suppressHydrationWarning: !0,
          ref: $
        },
        P.component
      ) : A
    );
  });
  return t.displayName = c.name + "Bridge", t;
}
function vQ({ effect: c }) {
  return _.useEffect(c, []), null;
}
const K$ = /* @__PURE__ */ new Map();
function yQ() {
  const c = {
    el: null,
    prevProps: [],
    callbacks: {},
    domCallbacks: {},
    refChangeId: -1,
    connectId: -1,
    destroyId: -1,
    attached: !1,
    forwardRef: !1,
    listening: null,
    onDOMEvent(s) {
      var r, f;
      const t = Di(s.detail) ? [s] : [s.detail, s];
      (f = (r = c.domCallbacks)[s.type]) == null || f.call(r, ...t);
    }
  };
  return c;
}
function Z$(c, s) {
  if (!(c.el === s && c.attached)) {
    if (c.attached && t9(c), c.domCallbacks) {
      c.listening || (c.listening = /* @__PURE__ */ new Set());
      for (const t of Object.keys(c.domCallbacks))
        c.listening.has(t) || (s.addEventListener(t, c.onDOMEvent), c.listening.add(t));
    }
    c.component.$$.attach(s), c.connectId = window.requestAnimationFrame(() => {
      c.component.$$.connect(), c.connectId = -1;
    }), c.attached = !0;
  }
}
function t9(c) {
  if (c.attached && (window.cancelAnimationFrame(c.connectId), c.connectId = -1, c.component.$$.detach(), c.attached = !1, c.el && c.listening)) {
    for (const s of c.listening)
      c.el.removeEventListener(s, c.onDOMEvent);
    c.listening.clear();
  }
}
function gQ(c) {
  var r, f;
  let s = K$.get(c.type), t = Di(c.detail) ? [c] : [c.detail, c];
  s || K$.set(c.type, s = `on${hQ(c.type)}`), (f = (r = this.callbacks)[s]) == null || f.call(r, ...t);
}
function X$(c, s, t, r) {
  const f = hM(c, { props: t, scope: r });
  return f.$$[cw] = gQ.bind(s), f.$$.setup(), f;
}
function yM(c, s = !1) {
  const t = typeof c;
  if (t !== "string")
    return !s && t === "function" ? yM(c()) : s && t === "boolean" ? c + "" : c;
  const r = s ? '"' : "<", f = s ? "&quot;" : "&lt;";
  let v = c.indexOf(r), g = c.indexOf("&");
  if (v < 0 && g < 0) return c;
  let T = 0, x = "";
  for (; v >= 0 && g >= 0; )
    v < g ? (T < v && (x += c.substring(T, v)), x += f, T = v + 1, v = c.indexOf(r, T)) : (T < g && (x += c.substring(T, g)), x += "&amp;", T = g + 1, g = c.indexOf("&", T));
  if (v >= 0)
    do
      T < v && (x += c.substring(T, v)), x += f, T = v + 1, v = c.indexOf(r, T);
    while (v >= 0);
  else
    for (; g >= 0; )
      T < g && (x += c.substring(T, g)), x += "&amp;", T = g + 1, g = c.indexOf("&", T);
  return T < c.length ? x + c.substring(T) : x;
}
const CQ = /* @__PURE__ */ Symbol(0), SQ = /\s+/;
function bQ(c, s) {
  const t = s.trim().split(SQ);
  for (const r of t) c.add(r);
}
const wQ = /\s*:\s*/, TQ = /\s*;\s*/;
function EQ(c, s) {
  const t = s.trim().split(TQ);
  for (let r = 0; r < t.length; r++) {
    if (t[r] === "") continue;
    const [f, v] = t[r].split(wQ);
    c.set(f, v);
  }
}
class kQ {
  constructor(s) {
    I(this, "keepAlive", !1);
    I(this, "forwardKeepAlive", !0);
    I(this, "$");
    I(this, "attributes", new xQ());
    I(this, "style", new RQ());
    I(this, "classList", new LQ());
    this.$ = s;
  }
  get $props() {
    return this.$.$$.props;
  }
  get $state() {
    return this.$.$$.$state;
  }
  get state() {
    return this.$.state;
  }
  setup() {
    const s = this.$.$$;
    la(() => {
      this.hasAttribute("class") && bQ(this.classList.tokens, this.getAttribute("class")), this.hasAttribute("style") && EQ(this.style.tokens, this.getAttribute("style")), s.setup(), s.attach(this), this.classList.length > 0 && this.setAttribute("class", this.classList.toString()), this.style.length > 0 && this.setAttribute("style", this.style.toString()), this.keepAlive && this.setAttribute("keep-alive", "");
    }, s.scope);
  }
  getAttribute(s) {
    return this.attributes.getAttribute(s);
  }
  setAttribute(s, t) {
    this.attributes.setAttribute(s, t);
  }
  hasAttribute(s) {
    return this.attributes.hasAttribute(s);
  }
  removeAttribute(s) {
    return this.attributes.removeAttribute(s);
  }
  [CQ]() {
  }
  addEventListener() {
  }
  removeEventListener() {
  }
  dispatchEvent() {
    return !1;
  }
  subscribe() {
    return Ms;
  }
  destroy() {
    this.$.destroy();
  }
}
var qo;
class xQ {
  constructor() {
    k(this, qo, /* @__PURE__ */ new Map());
  }
  get length() {
    return l(this, qo).size;
  }
  get tokens() {
    return l(this, qo);
  }
  getAttribute(s) {
    return l(this, qo).get(s) ?? null;
  }
  hasAttribute(s) {
    return l(this, qo).has(s);
  }
  setAttribute(s, t) {
    l(this, qo).set(s, t + "");
  }
  removeAttribute(s) {
    l(this, qo).delete(s);
  }
  toString() {
    if (l(this, qo).size === 0) return "";
    let s = "";
    for (const [t, r] of l(this, qo))
      s += ` ${t}="${yM(r, !0)}"`;
    return s;
  }
}
qo = new WeakMap();
var jo;
class RQ {
  constructor() {
    k(this, jo, /* @__PURE__ */ new Map());
  }
  get length() {
    return l(this, jo).size;
  }
  get tokens() {
    return l(this, jo);
  }
  getPropertyValue(s) {
    return l(this, jo).get(s) ?? "";
  }
  setProperty(s, t) {
    l(this, jo).set(s, t ?? "");
  }
  removeProperty(s) {
    const t = l(this, jo).get(s);
    return l(this, jo).delete(s), t ?? "";
  }
  toString() {
    if (l(this, jo).size === 0) return "";
    let s = "";
    for (const [t, r] of l(this, jo))
      s += `${t}: ${r};`;
    return s;
  }
}
jo = new WeakMap();
var xa;
class LQ {
  constructor() {
    k(this, xa, /* @__PURE__ */ new Set());
  }
  get length() {
    return l(this, xa).size;
  }
  get tokens() {
    return l(this, xa);
  }
  add(...s) {
    for (const t of s)
      l(this, xa).add(t);
  }
  contains(s) {
    return l(this, xa).has(s);
  }
  remove(s) {
    l(this, xa).delete(s);
  }
  replace(s, t) {
    return l(this, xa).has(s) ? (l(this, xa).delete(s), l(this, xa).add(t), !0) : !1;
  }
  toggle(s, t) {
    return t !== !0 && (l(this, xa).has(s) || t === !1) ? (l(this, xa).delete(s), !1) : (l(this, xa).add(s), !0);
  }
  toString() {
    return Array.from(l(this, xa)).join(" ");
  }
}
xa = new WeakMap();
const $Q = {
  acceptcharset: "acceptCharset",
  "accept-charset": "acceptCharset",
  accesskey: "accessKey",
  allowfullscreen: "allowFullScreen",
  autocapitalize: "autoCapitalize",
  autocomplete: "autoComplete",
  autocorrect: "autoCorrect",
  autofocus: "autoFocus",
  autoplay: "autoPlay",
  autosave: "autoSave",
  cellpadding: "cellPadding",
  cellspacing: "cellSpacing",
  charset: "charSet",
  class: "className",
  classid: "classID",
  classname: "className",
  colspan: "colSpan",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  controlslist: "controlsList",
  crossorigin: "crossOrigin",
  dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
  datetime: "dateTime",
  defaultchecked: "defaultChecked",
  defaultvalue: "defaultValue",
  disablepictureinpicture: "disablePictureInPicture",
  disableremoteplayback: "disableRemotePlayback",
  enctype: "encType",
  enterkeyhint: "enterKeyHint",
  fetchpriority: "fetchPriority",
  for: "htmlFor",
  formmethod: "formMethod",
  formaction: "formAction",
  formenctype: "formEncType",
  formnovalidate: "formNoValidate",
  formtarget: "formTarget",
  frameborder: "frameBorder",
  hreflang: "hrefLang",
  htmlfor: "htmlFor",
  httpequiv: "httpEquiv",
  "http-equiv": "httpEquiv",
  imagesizes: "imageSizes",
  imagesrcset: "imageSrcSet",
  innerhtml: "innerHTML",
  inputmode: "inputMode",
  itemid: "itemID",
  itemprop: "itemProp",
  itemref: "itemRef",
  itemscope: "itemScope",
  itemtype: "itemType",
  keyparams: "keyParams",
  keytype: "keyType",
  marginwidth: "marginWidth",
  marginheight: "marginHeight",
  maxlength: "maxLength",
  mediagroup: "mediaGroup",
  minlength: "minLength",
  nomodule: "noModule",
  novalidate: "noValidate",
  playsinline: "playsInline",
  radiogroup: "radioGroup",
  readonly: "readOnly",
  referrerpolicy: "referrerPolicy",
  rowspan: "rowSpan",
  spellcheck: "spellCheck",
  srcdoc: "srcDoc",
  srclang: "srcLang",
  srcset: "srcSet",
  tabindex: "tabIndex",
  usemap: "useMap"
};
function DQ(c, s) {
  function t(r) {
    let f = _.useContext(N0), v = hM(c, {
      props: r,
      scope: f.current
    }), g = new kQ(v), T = {}, { style: x = {}, children: $, forwardRef: P, ...A } = r;
    if (s.props.size)
      for (const U of Object.keys(A))
        s.props.has(U) || (T[U] = A[U]);
    else
      T = A;
    if (g.setup(), g.hasAttribute("style")) {
      for (const [U, F] of g.style.tokens)
        x[U.startsWith("--") ? U : $k(U)] = F;
      g.removeAttribute("style");
    }
    for (const [U, F] of g.attributes.tokens) {
      const Z = $Q[U];
      Z && (Z in T || (T[Z] = F), g.removeAttribute(U));
    }
    return pM(
      { current: v.$$.scope },
      Ma($) ? $ == null ? void 0 : $(
        {
          ...Object.fromEntries(g.attributes.tokens),
          ...T,
          style: x
        },
        v
      ) : $,
      _.createElement(() => (g.destroy(), null))
    );
  }
  return t.displayName = c.name + "Bridge", t;
}
function tv(c) {
  return Mk(c);
}
function cn(c, s) {
  const [, t] = _.useState();
  return _.useEffect(() => Ek(() => {
    c(), t({});
  }), [s ?? c]), c();
}
function b2(c) {
  return c ? "true" : "false";
}
function MQ() {
  const c = /* @__PURE__ */ new Set();
  return {
    add(...s) {
      for (const t of s) c.add(t);
    },
    empty() {
      for (const s of c) s();
      c.clear();
    }
  };
}
function L7(c) {
  return Object.keys(c);
}
function Qm() {
  let c, s;
  return { promise: new Promise((r, f) => {
    c = r, s = f;
  }), resolve: c, reject: s };
}
function gM(c) {
  return new Promise((s) => setTimeout(s, c));
}
function nv(c) {
  if (ll) return Ms;
  let s = -1, t;
  function r(...f) {
    t = f, !(s >= 0) && (s = window.requestAnimationFrame(() => {
      c.apply(this, t), s = -1, t = void 0;
    }));
  }
  return r;
}
const AQ = ll ? Ms : typeof window < "u" ? "requestIdleCallback" in window ? window.requestIdleCallback : (c) => window.setTimeout(c, 1) : Ms;
function CM(c, s) {
  return ll ? Promise.resolve() : new Promise((t) => {
    AQ((r) => {
      c == null || c(r), t();
    }, s);
  });
}
function SM(c) {
  const [, s] = _.useState(), t = _.useRef(null);
  return t.current == null && (t.current = {
    state: {},
    $update: nt({}),
    props: /* @__PURE__ */ new Set()
  }), _.useEffect(() => {
    let { state: r, $update: f, props: v } = t.current;
    return K(() => {
      for (const g of v) {
        const T = c[g]();
        r[g] = vr(T) ? [...T] : T;
      }
      f(), s({});
    });
  }, [c]), _.useMemo(() => {
    let { state: r, $update: f, props: v } = t.current, g = !1;
    return v.clear(), new Proxy(r, {
      get(T, x) {
        if (!v.has(x) && x in c) {
          v.add(x);
          const $ = c[x]();
          r[x] = vr($) ? [...$] : $, g || (f.set({}), g = !0, queueMicrotask(() => g = !1));
        }
        return r[x];
      },
      set(T, x, $) {
        return x in c || (r[x] = $), !0;
      }
    });
  }, [c]);
}
function xt(c, s) {
  return ll ? DQ(c, {
    props: new Set(Object.keys(c.props || {}))
  }) : mQ(c, {
    props: new Set(Object.keys(c.props || {})),
    events: new Set(s == null ? void 0 : s.events),
    eventsRE: s == null ? void 0 : s.eventsRegex,
    domEvents: s == null ? void 0 : s.domEvents,
    domEventsRE: s == null ? void 0 : s.domEventsRegex
  });
}
var Ts = {
  fullscreenEnabled: 0,
  fullscreenElement: 1,
  requestFullscreen: 2,
  exitFullscreen: 3,
  fullscreenchange: 4,
  fullscreenerror: 5,
  fullscreen: 6
}, J$ = [
  "webkitFullscreenEnabled",
  "webkitFullscreenElement",
  "webkitRequestFullscreen",
  "webkitExitFullscreen",
  "webkitfullscreenchange",
  "webkitfullscreenerror",
  "-webkit-full-screen"
], eD = [
  "mozFullScreenEnabled",
  "mozFullScreenElement",
  "mozRequestFullScreen",
  "mozCancelFullScreen",
  "mozfullscreenchange",
  "mozfullscreenerror",
  "-moz-full-screen"
], tD = [
  "msFullscreenEnabled",
  "msFullscreenElement",
  "msRequestFullscreen",
  "msExitFullscreen",
  "MSFullscreenChange",
  "MSFullscreenError",
  "-ms-fullscreen"
], ss = typeof window < "u" && typeof window.document < "u" ? window.document : {}, ao = "fullscreenEnabled" in ss && Object.keys(Ts) || J$[0] in ss && J$ || eD[0] in ss && eD || tD[0] in ss && tD || [], rh = {
  requestFullscreen: function(c) {
    return c[ao[Ts.requestFullscreen]]();
  },
  requestFullscreenFunction: function(c) {
    return c[ao[Ts.requestFullscreen]];
  },
  get exitFullscreen() {
    return ss[ao[Ts.exitFullscreen]].bind(ss);
  },
  get fullscreenPseudoClass() {
    return ":" + ao[Ts.fullscreen];
  },
  addEventListener: function(c, s, t) {
    return ss.addEventListener(ao[Ts[c]], s, t);
  },
  removeEventListener: function(c, s, t) {
    return ss.removeEventListener(ao[Ts[c]], s, t);
  },
  get fullscreenEnabled() {
    return !!ss[ao[Ts.fullscreenEnabled]];
  },
  set fullscreenEnabled(c) {
  },
  get fullscreenElement() {
    return ss[ao[Ts.fullscreenElement]];
  },
  set fullscreenElement(c) {
  },
  get onfullscreenchange() {
    return ss[("on" + ao[Ts.fullscreenchange]).toLowerCase()];
  },
  set onfullscreenchange(c) {
    return ss[("on" + ao[Ts.fullscreenchange]).toLowerCase()] = c;
  },
  get onfullscreenerror() {
    return ss[("on" + ao[Ts.fullscreenerror]).toLowerCase()];
  },
  set onfullscreenerror(c) {
    return ss[("on" + ao[Ts.fullscreenerror]).toLowerCase()] = c;
  }
}, mh = PQ;
function PQ(c, s, t) {
  var r = null, f = null, v = t && t.leading, g = t && t.trailing;
  v == null && (v = !0), g == null && (g = !v), v == !0 && (g = !1);
  var T = function() {
    r && (clearTimeout(r), r = null);
  }, x = function() {
    var P = f;
    T(), P && P();
  }, $ = function() {
    var P = v && !r, A = this, U = arguments;
    if (f = function() {
      return c.apply(A, U);
    }, r || (r = setTimeout(function() {
      if (r = null, g)
        return f();
    }, s)), P)
      return P = !1, f();
  };
  return $.cancel = T, $.flush = x, $;
}
var dw = OQ;
function OQ(c, s, t) {
  var r = null, f = null, v = function() {
    r && (clearTimeout(r), f = null, r = null);
  }, g = function() {
    var x = f;
    v(), x && x();
  }, T = function() {
    if (!s)
      return c.apply(this, arguments);
    var x = this, $ = arguments, P = t && !r;
    if (v(), f = function() {
      c.apply(x, $);
    }, r = setTimeout(function() {
      if (r = null, !P) {
        var A = f;
        return f = null, A();
      }
    }, s), P)
      return f();
  };
  return T.cancel = v, T.flush = g, T;
}
const nD = (c) => typeof c == "object" && c != null && c.nodeType === 1, iD = (c, s) => (!s || c !== "hidden") && c !== "visible" && c !== "clip", Fb = (c, s) => {
  if (c.clientHeight < c.scrollHeight || c.clientWidth < c.scrollWidth) {
    const t = getComputedStyle(c, null);
    return iD(t.overflowY, s) || iD(t.overflowX, s) || ((r) => {
      const f = ((v) => {
        if (!v.ownerDocument || !v.ownerDocument.defaultView) return null;
        try {
          return v.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!f && (f.clientHeight < r.scrollHeight || f.clientWidth < r.scrollWidth);
    })(c);
  }
  return !1;
}, Ib = (c, s, t, r, f, v, g, T) => v < c && g > s || v > c && g < s ? 0 : v <= c && T <= t || g >= s && T >= t ? v - c - r : g > s && T < t || v < c && T > t ? g - s + f : 0, _Q = (c) => {
  const s = c.parentElement;
  return s ?? (c.getRootNode().host || null);
}, bM = (c, s) => {
  var t, r, f, v;
  if (typeof document > "u") return [];
  const { scrollMode: g, block: T, inline: x, boundary: $, skipOverflowHiddenElements: P } = s, A = typeof $ == "function" ? $ : (Ye) => Ye !== $;
  if (!nD(c)) throw new TypeError("Invalid target");
  const U = document.scrollingElement || document.documentElement, F = [];
  let Z = c;
  for (; nD(Z) && A(Z); ) {
    if (Z = _Q(Z), Z === U) {
      F.push(Z);
      break;
    }
    Z != null && Z === document.body && Fb(Z) && !Fb(document.documentElement) || Z != null && Fb(Z, P) && F.push(Z);
  }
  const ne = (r = (t = window.visualViewport) == null ? void 0 : t.width) != null ? r : innerWidth, ce = (v = (f = window.visualViewport) == null ? void 0 : f.height) != null ? v : innerHeight, { scrollX: De, scrollY: Ne } = window, { height: Se, width: je, top: Me, right: Ct, bottom: Ge, left: he } = c.getBoundingClientRect(), { top: Ze, right: pt, bottom: Gt, left: Lt } = ((Ye) => {
    const rt = window.getComputedStyle(Ye);
    return { top: parseFloat(rt.scrollMarginTop) || 0, right: parseFloat(rt.scrollMarginRight) || 0, bottom: parseFloat(rt.scrollMarginBottom) || 0, left: parseFloat(rt.scrollMarginLeft) || 0 };
  })(c);
  let Ve = T === "start" || T === "nearest" ? Me - Ze : T === "end" ? Ge + Gt : Me + Se / 2 - Ze + Gt, mt = x === "center" ? he + je / 2 - Lt + pt : x === "end" ? Ct + pt : he - Lt;
  const wn = [];
  for (let Ye = 0; Ye < F.length; Ye++) {
    const rt = F[Ye], { height: se, width: Le, top: me, right: At, bottom: Qt, left: ur } = rt.getBoundingClientRect();
    if (g === "if-needed" && Me >= 0 && he >= 0 && Ge <= ce && Ct <= ne && (rt === U && !Fb(rt) || Me >= me && Ge <= Qt && he >= ur && Ct <= At)) return wn;
    const ri = getComputedStyle(rt), Oa = parseInt(ri.borderLeftWidth, 10), Ci = parseInt(ri.borderTopWidth, 10), Si = parseInt(ri.borderRightWidth, 10), Ii = parseInt(ri.borderBottomWidth, 10);
    let bi = 0, Bi = 0;
    const Wn = "offsetWidth" in rt ? rt.offsetWidth - rt.clientWidth - Oa - Si : 0, Cr = "offsetHeight" in rt ? rt.offsetHeight - rt.clientHeight - Ci - Ii : 0, Pi = "offsetWidth" in rt ? rt.offsetWidth === 0 ? 0 : Le / rt.offsetWidth : 0, qi = "offsetHeight" in rt ? rt.offsetHeight === 0 ? 0 : se / rt.offsetHeight : 0;
    if (U === rt) bi = T === "start" ? Ve : T === "end" ? Ve - ce : T === "nearest" ? Ib(Ne, Ne + ce, ce, Ci, Ii, Ne + Ve, Ne + Ve + Se, Se) : Ve - ce / 2, Bi = x === "start" ? mt : x === "center" ? mt - ne / 2 : x === "end" ? mt - ne : Ib(De, De + ne, ne, Oa, Si, De + mt, De + mt + je, je), bi = Math.max(0, bi + Ne), Bi = Math.max(0, Bi + De);
    else {
      bi = T === "start" ? Ve - me - Ci : T === "end" ? Ve - Qt + Ii + Cr : T === "nearest" ? Ib(me, Qt, se, Ci, Ii + Cr, Ve, Ve + Se, Se) : Ve - (me + se / 2) + Cr / 2, Bi = x === "start" ? mt - ur - Oa : x === "center" ? mt - (ur + Le / 2) + Wn / 2 : x === "end" ? mt - At + Si + Wn : Ib(ur, At, Le, Oa, Si + Wn, mt, mt + je, je);
      const { scrollLeft: Sr, scrollTop: da } = rt;
      bi = qi === 0 ? 0 : Math.max(0, Math.min(da + bi / qi, rt.scrollHeight - se / qi + Cr)), Bi = Pi === 0 ? 0 : Math.max(0, Math.min(Sr + Bi / Pi, rt.scrollWidth - Le / Pi + Wn)), Ve += da - bi, mt += Sr - Bi;
    }
    wn.push({ el: rt, top: bi, left: Bi });
  }
  return wn;
};
var NQ = '<path fill-rule="evenodd" clip-rule="evenodd" d="M15.0007 28.7923C15.0007 29.0152 14.9774 29.096 14.9339 29.1775C14.8903 29.259 14.8263 29.323 14.7449 29.3665C14.6634 29.4101 14.5826 29.4333 14.3597 29.4333H12.575C12.3521 29.4333 12.2713 29.4101 12.1898 29.3665C12.1083 29.323 12.0443 29.259 12.0008 29.1775C11.9572 29.096 11.934 29.0152 11.934 28.7923V12.2993L5.97496 12.3C5.75208 12.3 5.67125 12.2768 5.58977 12.2332C5.50829 12.1896 5.44434 12.1257 5.40077 12.0442C5.35719 11.9627 5.33398 11.8819 5.33398 11.659V9.87429C5.33398 9.65141 5.35719 9.57059 5.40077 9.48911C5.44434 9.40762 5.50829 9.34368 5.58977 9.3001C5.67125 9.25652 5.75208 9.23332 5.97496 9.23332H26.0263C26.2492 9.23332 26.33 9.25652 26.4115 9.3001C26.493 9.34368 26.557 9.40762 26.6005 9.48911C26.6441 9.57059 26.6673 9.65141 26.6673 9.87429V11.659C26.6673 11.8819 26.6441 11.9627 26.6005 12.0442C26.557 12.1257 26.493 12.1896 26.4115 12.2332C26.33 12.2768 26.2492 12.3 26.0263 12.3L20.067 12.2993L20.0673 28.7923C20.0673 29.0152 20.0441 29.096 20.0005 29.1775C19.957 29.259 19.893 29.323 19.8115 29.3665C19.73 29.4101 19.6492 29.4333 19.4263 29.4333H17.6416C17.4187 29.4333 17.3379 29.4101 17.2564 29.3665C17.175 29.323 17.111 29.259 17.0674 29.1775C17.0239 29.096 17.0007 29.0152 17.0007 28.7923L17 22.7663H15L15.0007 28.7923Z" fill="currentColor"/> <path d="M16.0007 7.89998C17.4734 7.89998 18.6673 6.70608 18.6673 5.23332C18.6673 3.76056 17.4734 2.56665 16.0007 2.56665C14.5279 2.56665 13.334 3.76056 13.334 5.23332C13.334 6.70608 14.5279 7.89998 16.0007 7.89998Z" fill="currentColor"/>', VQ = '<path d="M5.33334 6.00001C5.33334 5.63182 5.63181 5.33334 6 5.33334H26C26.3682 5.33334 26.6667 5.63182 26.6667 6.00001V20.6667C26.6667 21.0349 26.3682 21.3333 26 21.3333H23.7072C23.4956 21.3333 23.2966 21.233 23.171 21.0628L22.1859 19.7295C21.8607 19.2894 22.1749 18.6667 22.7221 18.6667H23.3333C23.7015 18.6667 24 18.3682 24 18V8.66668C24 8.29849 23.7015 8.00001 23.3333 8.00001H8.66667C8.29848 8.00001 8 8.29849 8 8.66668V18C8 18.3682 8.29848 18.6667 8.66667 18.6667H9.29357C9.84072 18.6667 10.1549 19.2894 9.82976 19.7295L8.84467 21.0628C8.71898 21.233 8.52 21.3333 8.30848 21.3333H6C5.63181 21.3333 5.33334 21.0349 5.33334 20.6667V6.00001Z" fill="currentColor"/> <path d="M8.78528 25.6038C8.46013 26.0439 8.77431 26.6667 9.32147 26.6667L22.6785 26.6667C23.2256 26.6667 23.5398 26.0439 23.2146 25.6038L16.5358 16.5653C16.2693 16.2046 15.73 16.2047 15.4635 16.5653L8.78528 25.6038Z" fill="currentColor"/>', UQ = '<path d="M17.4853 18.9093C17.4853 19.0281 17.6289 19.0875 17.7129 19.0035L22.4185 14.2979C22.6788 14.0376 23.1009 14.0376 23.3613 14.2979L24.7755 15.7122C25.0359 15.9725 25.0359 16.3946 24.7755 16.655L16.2902 25.1403C16.0299 25.4006 15.6078 25.4006 15.3474 25.1403L13.9332 23.726L13.9319 23.7247L6.86189 16.6547C6.60154 16.3944 6.60154 15.9723 6.86189 15.7119L8.2761 14.2977C8.53645 14.0373 8.95856 14.0373 9.21891 14.2977L13.9243 19.0031C14.0083 19.0871 14.1519 19.0276 14.1519 18.9088L14.1519 6.00004C14.1519 5.63185 14.4504 5.33337 14.8186 5.33337L16.8186 5.33337C17.1868 5.33337 17.4853 5.63185 17.4853 6.00004L17.4853 18.9093Z" fill="currentColor"/>', zQ = '<path d="M13.0908 14.3334C12.972 14.3334 12.9125 14.1898 12.9965 14.1058L17.7021 9.40022C17.9625 9.13987 17.9625 8.71776 17.7021 8.45741L16.2879 7.04319C16.0275 6.78284 15.6054 6.78284 15.3451 7.04319L6.8598 15.5285C6.59945 15.7888 6.59945 16.2109 6.8598 16.4713L8.27401 17.8855L8.27536 17.8868L15.3453 24.9568C15.6057 25.2172 16.0278 25.2172 16.2881 24.9568L17.7024 23.5426C17.9627 23.2822 17.9627 22.8601 17.7024 22.5998L12.9969 17.8944C12.9129 17.8104 12.9724 17.6668 13.0912 17.6668L26 17.6668C26.3682 17.6668 26.6667 17.3683 26.6667 17.0001V15.0001C26.6667 14.6319 26.3682 14.3334 26 14.3334L13.0908 14.3334Z" fill="currentColor"/>', HQ = '<path d="M14.1521 13.0929C14.1521 12.9741 14.0085 12.9147 13.9245 12.9987L9.21891 17.7043C8.95856 17.9646 8.53645 17.9646 8.2761 17.7043L6.86189 16.29C6.60154 16.0297 6.60154 15.6076 6.86189 15.3472L15.3472 6.86195C15.6075 6.6016 16.0296 6.6016 16.29 6.86195L17.7042 8.27616L17.7055 8.27751L24.7755 15.3475C25.0359 15.6078 25.0359 16.0299 24.7755 16.2903L23.3613 17.7045C23.1009 17.9649 22.6788 17.9649 22.4185 17.7045L17.7131 12.9991C17.6291 12.9151 17.4855 12.9746 17.4855 13.0934V26.0022C17.4855 26.3704 17.187 26.6688 16.8188 26.6688H14.8188C14.4506 26.6688 14.1521 26.3704 14.1521 26.0022L14.1521 13.0929Z" fill="currentColor"/>', FQ = '<path d="M16.6927 25.3346C16.3245 25.3346 16.026 25.0361 16.026 24.6679L16.026 7.3346C16.026 6.96641 16.3245 6.66794 16.6927 6.66794L18.6927 6.66794C19.0609 6.66794 19.3594 6.96642 19.3594 7.3346L19.3594 24.6679C19.3594 25.0361 19.0609 25.3346 18.6927 25.3346H16.6927Z" fill="currentColor"/> <path d="M24.026 25.3346C23.6578 25.3346 23.3594 25.0361 23.3594 24.6679L23.3594 7.3346C23.3594 6.96641 23.6578 6.66794 24.026 6.66794L26.026 6.66794C26.3942 6.66794 26.6927 6.96642 26.6927 7.3346V24.6679C26.6927 25.0361 26.3942 25.3346 26.026 25.3346H24.026Z" fill="currentColor"/> <path d="M5.48113 23.9407C5.38584 24.2963 5.59689 24.6619 5.95254 24.7572L7.88439 25.2748C8.24003 25.3701 8.60559 25.159 8.70089 24.8034L13.1871 8.06067C13.2824 7.70503 13.0713 7.33947 12.7157 7.24417L10.7838 6.72654C10.4282 6.63124 10.0626 6.8423 9.96733 7.19794L5.48113 23.9407Z" fill="currentColor"/>', IQ = '<path fill-rule="evenodd" clip-rule="evenodd" d="M24.9266 7.57992C25.015 7.60672 25.0886 7.64746 25.2462 7.80506L26.956 9.51488C27.1136 9.67248 27.1543 9.74604 27.1811 9.83447C27.2079 9.9229 27.2079 10.0133 27.1811 10.1018C27.1543 10.1902 27.1136 10.2638 26.956 10.4214L13.1822 24.1951C13.0246 24.3527 12.951 24.3935 12.8626 24.4203C12.797 24.4402 12.7304 24.4453 12.6642 24.4357L12.7319 24.4203C12.6435 24.4471 12.553 24.4471 12.4646 24.4203C12.3762 24.3935 12.3026 24.3527 12.145 24.1951L5.04407 17.0942C4.88647 16.9366 4.84573 16.863 4.81893 16.7746C4.79213 16.6862 4.79213 16.5957 4.81893 16.5073C4.84573 16.4189 4.88647 16.3453 5.04407 16.1877L6.7539 14.4779C6.9115 14.3203 6.98506 14.2796 7.07349 14.2528C7.16191 14.226 7.25235 14.226 7.34078 14.2528C7.42921 14.2796 7.50277 14.3203 7.66037 14.4779L12.6628 19.4808L24.3397 7.80506C24.4973 7.64746 24.5709 7.60672 24.6593 7.57992C24.7477 7.55311 24.8382 7.55311 24.9266 7.57992Z" fill="currentColor"/>', BQ = '<path d="M17.947 16.095C17.999 16.043 17.999 15.9585 17.947 15.9065L11.6295 9.58899C11.3691 9.32864 11.3691 8.90653 11.6295 8.64618L13.2323 7.04341C13.4926 6.78306 13.9147 6.78306 14.1751 7.04341L21.0289 13.8973C21.0392 13.9064 21.0493 13.9158 21.0591 13.9257L22.6619 15.5285C22.9223 15.7888 22.9223 16.2109 22.6619 16.4713L14.1766 24.9565C13.9163 25.2169 13.4942 25.2169 13.2338 24.9565L11.631 23.3538C11.3707 23.0934 11.3707 22.6713 11.631 22.411L17.947 16.095Z" fill="currentColor"/>', wM = '<path fill-rule="evenodd" clip-rule="evenodd" d="M6 7C5.63181 7 5.33333 7.29848 5.33333 7.66667V14.8667C5.33333 14.9403 5.39361 14.9999 5.46724 15.0009C10.8844 15.0719 15.2614 19.449 15.3325 24.8661C15.3334 24.9397 15.393 25 15.4667 25H26C26.3682 25 26.6667 24.7015 26.6667 24.3333V7.66667C26.6667 7.29848 26.3682 7 26 7H6ZM17.0119 22.2294C17.0263 22.29 17.0802 22.3333 17.1425 22.3333H23.3333C23.7015 22.3333 24 22.0349 24 21.6667V10.3333C24 9.96514 23.7015 9.66667 23.3333 9.66667H8.66667C8.29848 9.66667 8 9.96514 8 10.3333V13.1909C8 13.2531 8.04332 13.3071 8.10392 13.3214C12.5063 14.3618 15.9715 17.827 17.0119 22.2294Z" fill="currentColor"/> <path d="M13.2 25C13.2736 25 13.3334 24.9398 13.3322 24.8661C13.2615 20.5544 9.77889 17.0718 5.46718 17.0011C5.39356 16.9999 5.33333 17.0597 5.33333 17.1333V18.8667C5.33333 18.9403 5.39348 18.9999 5.4671 19.0015C8.67465 19.0716 11.2617 21.6587 11.3319 24.8662C11.3335 24.9399 11.393 25 11.4667 25H13.2Z" fill="currentColor"/> <path d="M5.33333 21.1333C5.33333 21.0597 5.39332 20.9998 5.46692 21.0022C7.57033 21.0712 9.26217 22.763 9.33114 24.8664C9.33356 24.94 9.27364 25 9.2 25H6C5.63181 25 5.33333 24.7015 5.33333 24.3333V21.1333Z" fill="currentColor"/>', qQ = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: wM
}), jQ = '<path d="M8 28.0003C8 27.6321 8.29848 27.3336 8.66667 27.3336H23.3333C23.7015 27.3336 24 27.6321 24 28.0003V29.3336C24 29.7018 23.7015 30.0003 23.3333 30.0003H8.66667C8.29848 30.0003 8 29.7018 8 29.3336V28.0003Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66602 6.66699C4.29783 6.66699 3.99935 6.96547 3.99935 7.33366V24.667C3.99935 25.0352 4.29783 25.3337 4.66602 25.3337H27.3327C27.7009 25.3337 27.9994 25.0352 27.9994 24.667V7.33366C27.9994 6.96547 27.7009 6.66699 27.3327 6.66699H4.66602ZM8.66659 21.3333C8.2984 21.3333 7.99992 21.0349 7.99992 20.6667V11.3333C7.99992 10.9651 8.2984 10.6667 8.66659 10.6667H13.9999C14.3681 10.6667 14.6666 10.9651 14.6666 11.3333V12.6667C14.6666 13.0349 14.3681 13.3333 13.9999 13.3333H10.7999C10.7263 13.3333 10.6666 13.393 10.6666 13.4667V18.5333C10.6666 18.607 10.7263 18.6667 10.7999 18.6667H13.9999C14.3681 18.6667 14.6666 18.9651 14.6666 19.3333V20.6667C14.6666 21.0349 14.3681 21.3333 13.9999 21.3333H8.66659ZM17.9999 21.3333C17.6317 21.3333 17.3333 21.0349 17.3333 20.6667V11.3333C17.3333 10.9651 17.6317 10.6667 17.9999 10.6667H23.3333C23.7014 10.6667 23.9999 10.9651 23.9999 11.3333V12.6667C23.9999 13.0349 23.7014 13.3333 23.3333 13.3333H20.1333C20.0596 13.3333 19.9999 13.393 19.9999 13.4667V18.5333C19.9999 18.607 20.0596 18.6667 20.1333 18.6667H23.3333C23.7014 18.6667 23.9999 18.9651 23.9999 19.3333V20.6667C23.9999 21.0349 23.7014 21.3333 23.3333 21.3333H17.9999Z" fill="currentColor"/>', GQ = '<path fill-rule="evenodd" clip-rule="evenodd" d="M4.6661 6.66699C4.29791 6.66699 3.99943 6.96547 3.99943 7.33366V24.667C3.99943 25.0352 4.29791 25.3337 4.6661 25.3337H27.3328C27.701 25.3337 27.9994 25.0352 27.9994 24.667V7.33366C27.9994 6.96547 27.701 6.66699 27.3328 6.66699H4.6661ZM8.66667 21.3333C8.29848 21.3333 8 21.0349 8 20.6667V11.3333C8 10.9651 8.29848 10.6667 8.66667 10.6667H14C14.3682 10.6667 14.6667 10.9651 14.6667 11.3333V12.6667C14.6667 13.0349 14.3682 13.3333 14 13.3333H10.8C10.7264 13.3333 10.6667 13.393 10.6667 13.4667V18.5333C10.6667 18.607 10.7264 18.6667 10.8 18.6667H14C14.3682 18.6667 14.6667 18.9651 14.6667 19.3333V20.6667C14.6667 21.0349 14.3682 21.3333 14 21.3333H8.66667ZM18 21.3333C17.6318 21.3333 17.3333 21.0349 17.3333 20.6667V11.3333C17.3333 10.9651 17.6318 10.6667 18 10.6667H23.3333C23.7015 10.6667 24 10.9651 24 11.3333V12.6667C24 13.0349 23.7015 13.3333 23.3333 13.3333H20.1333C20.0597 13.3333 20 13.393 20 13.4667V18.5333C20 18.607 20.0597 18.6667 20.1333 18.6667H23.3333C23.7015 18.6667 24 18.9651 24 19.3333V20.6667C24 21.0349 23.7015 21.3333 23.3333 21.3333H18Z" fill="currentColor"/>', QQ = '<path d="M14.2225 13.7867C14.3065 13.8706 14.4501 13.8112 14.4501 13.6924V5.99955C14.4501 5.63136 14.7486 5.33289 15.1167 5.33289H16.8501C17.2183 5.33289 17.5167 5.63136 17.5167 5.99955V13.6916C17.5167 13.8104 17.6604 13.8699 17.7444 13.7859L19.9433 11.5869C20.2037 11.3266 20.6258 11.3266 20.8861 11.5869L22.1118 12.8126C22.3722 13.0729 22.3722 13.4951 22.1118 13.7554L16.4549 19.4123C16.1946 19.6726 15.772 19.6731 15.5116 19.4128L9.85479 13.7559C9.59444 13.4956 9.59444 13.0734 9.85479 12.8131L11.0804 11.5874C11.3408 11.3271 11.7629 11.3271 12.0233 11.5874L14.2225 13.7867Z" fill="currentColor"/> <path d="M5.99998 20.267C5.63179 20.267 5.33331 20.5654 5.33331 20.9336V25.9997C5.33331 26.3678 5.63179 26.6663 5.99998 26.6663H26C26.3682 26.6663 26.6666 26.3678 26.6666 25.9997V20.9336C26.6666 20.5654 26.3682 20.267 26 20.267H24.2666C23.8985 20.267 23.6 20.5654 23.6 20.9336V22.9333C23.6 23.3014 23.3015 23.5999 22.9333 23.5999H9.06638C8.69819 23.5999 8.39972 23.3014 8.39972 22.9333V20.9336C8.39972 20.5654 8.10124 20.267 7.73305 20.267H5.99998Z" fill="currentColor"/>', YQ = '<path d="M16 20C18.2091 20 20 18.2092 20 16C20 13.7909 18.2091 12 16 12C13.7909 12 12 13.7909 12 16C12 18.2092 13.7909 20 16 20Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M28 16.0058C28 18.671 23.5 25.3334 16 25.3334C8.5 25.3334 4 18.6762 4 16.0058C4 13.3354 8.50447 6.66669 16 6.66669C23.4955 6.66669 28 13.3406 28 16.0058ZM25.3318 15.9934C25.3328 16.0017 25.3328 16.0099 25.3318 16.0182C25.3274 16.0571 25.3108 16.1728 25.2485 16.3708C25.1691 16.6229 25.0352 16.9462 24.8327 17.3216C24.4264 18.0749 23.7969 18.9398 22.9567 19.754C21.2791 21.3798 18.9148 22.6667 16 22.6667C13.0845 22.6667 10.7202 21.3805 9.04298 19.7557C8.20295 18.9419 7.57362 18.0773 7.16745 17.3241C6.96499 16.9486 6.83114 16.6252 6.75172 16.3729C6.67942 16.1431 6.66856 16.0243 6.66695 16.0066L6.66695 16.005C6.66859 15.9871 6.67951 15.8682 6.75188 15.6383C6.83145 15.3854 6.96554 15.0614 7.16831 14.6853C7.57507 13.9306 8.20514 13.0644 9.04577 12.249C10.7245 10.6208 13.0886 9.33335 16 9.33335C18.9108 9.33335 21.2748 10.6215 22.9539 12.2507C23.7947 13.0664 24.4249 13.933 24.8318 14.6877C25.0346 15.0639 25.1688 15.3878 25.2483 15.6404C25.3107 15.8386 25.3274 15.9545 25.3318 15.9934Z" fill="currentColor"/>', WQ = '<path d="M15.8747 8.11857C16.3148 7.79342 16.9375 8.10759 16.9375 8.65476V14.2575C16.9375 14.3669 17.0621 14.4297 17.1501 14.3647L25.6038 8.11857C26.0439 7.79342 26.6667 8.10759 26.6667 8.65476V23.3451C26.6667 23.8923 26.0439 24.2064 25.6038 23.8813L17.1501 17.6346C17.0621 17.5695 16.9375 17.6324 16.9375 17.7418L16.9375 23.3451C16.9375 23.8923 16.3147 24.2064 15.8747 23.8813L5.93387 16.5358C5.57322 16.2693 5.57323 15.7299 5.93389 15.4634L15.8747 8.11857Z" fill="currentColor"/>', KQ = '<path d="M16.1253 8.11866C15.6852 7.7935 15.0625 8.10768 15.0625 8.65484V14.2576C15.0625 14.367 14.9379 14.4298 14.8499 14.3648L6.39615 8.11866C5.95607 7.7935 5.33331 8.10768 5.33331 8.65484V23.3452C5.33331 23.8923 5.9561 24.2065 6.39617 23.8813L14.8499 17.6347C14.9379 17.5696 15.0625 17.6325 15.0625 17.7419L15.0625 23.3452C15.0625 23.8923 15.6853 24.2065 16.1253 23.8813L26.0661 16.5358C26.4268 16.2694 26.4268 15.73 26.0661 15.4635L16.1253 8.11866Z" fill="currentColor"/>', ZQ = '<path d="M19.3334 13.3333C18.9652 13.3333 18.6667 13.0349 18.6667 12.6667L18.6667 7.33333C18.6667 6.96514 18.9652 6.66666 19.3334 6.66666H21.3334C21.7015 6.66666 22 6.96514 22 7.33333V9.86666C22 9.9403 22.0597 10 22.1334 10L24.6667 10C25.0349 10 25.3334 10.2985 25.3334 10.6667V12.6667C25.3334 13.0349 25.0349 13.3333 24.6667 13.3333L19.3334 13.3333Z" fill="currentColor"/> <path d="M13.3334 19.3333C13.3334 18.9651 13.0349 18.6667 12.6667 18.6667H7.33335C6.96516 18.6667 6.66669 18.9651 6.66669 19.3333V21.3333C6.66669 21.7015 6.96516 22 7.33335 22H9.86669C9.94032 22 10 22.0597 10 22.1333L10 24.6667C10 25.0349 10.2985 25.3333 10.6667 25.3333H12.6667C13.0349 25.3333 13.3334 25.0349 13.3334 24.6667L13.3334 19.3333Z" fill="currentColor"/> <path d="M18.6667 24.6667C18.6667 25.0349 18.9652 25.3333 19.3334 25.3333H21.3334C21.7015 25.3333 22 25.0349 22 24.6667V22.1333C22 22.0597 22.0597 22 22.1334 22H24.6667C25.0349 22 25.3334 21.7015 25.3334 21.3333V19.3333C25.3334 18.9651 25.0349 18.6667 24.6667 18.6667L19.3334 18.6667C18.9652 18.6667 18.6667 18.9651 18.6667 19.3333L18.6667 24.6667Z" fill="currentColor"/> <path d="M10.6667 13.3333H12.6667C13.0349 13.3333 13.3334 13.0349 13.3334 12.6667L13.3334 10.6667V7.33333C13.3334 6.96514 13.0349 6.66666 12.6667 6.66666H10.6667C10.2985 6.66666 10 6.96514 10 7.33333L10 9.86666C10 9.9403 9.94033 10 9.86669 10L7.33335 10C6.96516 10 6.66669 10.2985 6.66669 10.6667V12.6667C6.66669 13.0349 6.96516 13.3333 7.33335 13.3333L10.6667 13.3333Z" fill="currentColor"/>', XQ = '<path d="M25.3299 7.26517C25.2958 6.929 25.0119 6.66666 24.6667 6.66666H19.3334C18.9652 6.66666 18.6667 6.96514 18.6667 7.33333V9.33333C18.6667 9.70152 18.9652 10 19.3334 10L21.8667 10C21.9403 10 22 10.0597 22 10.1333V12.6667C22 13.0349 22.2985 13.3333 22.6667 13.3333H24.6667C25.0349 13.3333 25.3334 13.0349 25.3334 12.6667V7.33333C25.3334 7.31032 25.3322 7.28758 25.3299 7.26517Z" fill="currentColor"/> <path d="M22 21.8667C22 21.9403 21.9403 22 21.8667 22L19.3334 22C18.9652 22 18.6667 22.2985 18.6667 22.6667V24.6667C18.6667 25.0349 18.9652 25.3333 19.3334 25.3333L24.6667 25.3333C25.0349 25.3333 25.3334 25.0349 25.3334 24.6667V19.3333C25.3334 18.9651 25.0349 18.6667 24.6667 18.6667H22.6667C22.2985 18.6667 22 18.9651 22 19.3333V21.8667Z" fill="currentColor"/> <path d="M12.6667 22H10.1334C10.0597 22 10 21.9403 10 21.8667V19.3333C10 18.9651 9.70154 18.6667 9.33335 18.6667H7.33335C6.96516 18.6667 6.66669 18.9651 6.66669 19.3333V24.6667C6.66669 25.0349 6.96516 25.3333 7.33335 25.3333H12.6667C13.0349 25.3333 13.3334 25.0349 13.3334 24.6667V22.6667C13.3334 22.2985 13.0349 22 12.6667 22Z" fill="currentColor"/> <path d="M10 12.6667V10.1333C10 10.0597 10.0597 10 10.1334 10L12.6667 10C13.0349 10 13.3334 9.70152 13.3334 9.33333V7.33333C13.3334 6.96514 13.0349 6.66666 12.6667 6.66666H7.33335C6.96516 6.66666 6.66669 6.96514 6.66669 7.33333V12.6667C6.66669 13.0349 6.96516 13.3333 7.33335 13.3333H9.33335C9.70154 13.3333 10 13.0349 10 12.6667Z" fill="currentColor"/>', JQ = '<path fill-rule="evenodd" clip-rule="evenodd" d="M26.6667 5.99998C26.6667 5.63179 26.3682 5.33331 26 5.33331H11.3333C10.9651 5.33331 10.6667 5.63179 10.6667 5.99998V17.5714C10.6667 17.6694 10.5644 17.7342 10.4741 17.6962C9.91823 17.4625 9.30754 17.3333 8.66667 17.3333C6.08934 17.3333 4 19.4226 4 22C4 24.5773 6.08934 26.6666 8.66667 26.6666C11.244 26.6666 13.3333 24.5773 13.3333 22V8.66665C13.3333 8.29846 13.6318 7.99998 14 7.99998L23.3333 7.99998C23.7015 7.99998 24 8.29846 24 8.66665V14.9048C24 15.0027 23.8978 15.0675 23.8075 15.0296C23.2516 14.7958 22.6409 14.6666 22 14.6666C19.4227 14.6666 17.3333 16.756 17.3333 19.3333C17.3333 21.9106 19.4227 24 22 24C24.5773 24 26.6667 21.9106 26.6667 19.3333V5.99998ZM22 21.3333C23.1046 21.3333 24 20.4379 24 19.3333C24 18.2287 23.1046 17.3333 22 17.3333C20.8954 17.3333 20 18.2287 20 19.3333C20 20.4379 20.8954 21.3333 22 21.3333ZM8.66667 24C9.77124 24 10.6667 23.1045 10.6667 22C10.6667 20.8954 9.77124 20 8.66667 20C7.5621 20 6.66667 20.8954 6.66667 22C6.66667 23.1045 7.5621 24 8.66667 24Z" fill="currentColor"/>', eY = '<path d="M17.5091 24.6594C17.5091 25.2066 16.8864 25.5208 16.4463 25.1956L9.44847 20.0252C9.42553 20.0083 9.39776 19.9991 9.36923 19.9991H4.66667C4.29848 19.9991 4 19.7006 4 19.3325V12.6658C4 12.2976 4.29848 11.9991 4.66667 11.9991H9.37115C9.39967 11.9991 9.42745 11.99 9.45039 11.973L16.4463 6.8036C16.8863 6.47842 17.5091 6.79259 17.5091 7.33977L17.5091 24.6594Z" fill="currentColor"/> <path d="M28.8621 13.6422C29.1225 13.3818 29.1225 12.9597 28.8621 12.6994L27.9193 11.7566C27.659 11.4962 27.2368 11.4962 26.9765 11.7566L24.7134 14.0197C24.6613 14.0717 24.5769 14.0717 24.5248 14.0197L22.262 11.7568C22.0016 11.4964 21.5795 11.4964 21.3191 11.7568L20.3763 12.6996C20.116 12.9599 20.116 13.382 20.3763 13.6424L22.6392 15.9053C22.6913 15.9573 22.6913 16.0418 22.6392 16.0938L20.3768 18.3562C20.1165 18.6166 20.1165 19.0387 20.3768 19.299L21.3196 20.2419C21.58 20.5022 22.0021 20.5022 22.2624 20.2418L24.5248 17.9795C24.5769 17.9274 24.6613 17.9274 24.7134 17.9795L26.976 20.2421C27.2363 20.5024 27.6585 20.5024 27.9188 20.2421L28.8616 19.2992C29.122 19.0389 29.122 18.6168 28.8616 18.3564L26.599 16.0938C26.547 16.0418 26.547 15.9573 26.599 15.9053L28.8621 13.6422Z" fill="currentColor"/>', tY = '<path d="M26.6009 16.0725C26.6009 16.424 26.4302 17.1125 25.9409 18.0213C25.4676 18.8976 24.7542 19.8715 23.8182 20.7783C21.9489 22.5905 19.2662 24.0667 15.9342 24.0667C12.6009 24.0667 9.91958 22.5915 8.04891 20.78C7.11424 19.8736 6.40091 18.9 5.92758 18.0236C5.43824 17.1149 5.26758 16.4257 5.26758 16.0725C5.26758 15.7193 5.43824 15.0293 5.92891 14.1193C6.40224 13.2416 7.11558 12.2665 8.05158 11.3587C9.92224 9.54398 12.6049 8.06665 15.9342 8.06665C19.2636 8.06665 21.9449 9.54505 23.8169 11.3604C24.7529 12.2687 25.4662 13.2441 25.9396 14.1216C26.4302 15.0317 26.6009 15.7209 26.6009 16.0725Z" stroke="currentColor" stroke-width="3"/> <path d="M15.9336 20.0667C18.1427 20.0667 19.9336 18.2758 19.9336 16.0667C19.9336 13.8575 18.1427 12.0667 15.9336 12.0667C13.7245 12.0667 11.9336 13.8575 11.9336 16.0667C11.9336 18.2758 13.7245 20.0667 15.9336 20.0667Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M27.2323 25.0624L6.93878 4.76886C6.78118 4.61126 6.70762 4.57052 6.61919 4.54372C6.53077 4.51692 6.44033 4.51691 6.3519 4.54372C6.26347 4.57052 6.18991 4.61126 6.03231 4.76886L4.77032 6.03085C4.61272 6.18845 4.57198 6.26201 4.54518 6.35044C4.51838 6.43887 4.51838 6.5293 4.54518 6.61773C4.57198 6.70616 4.61272 6.77972 4.77032 6.93732L25.0639 27.2308C25.2215 27.3884 25.295 27.4292 25.3834 27.456C25.4719 27.4828 25.5623 27.4828 25.6507 27.456C25.7392 27.4292 25.8127 27.3885 25.9703 27.2309L27.2323 25.9689C27.3899 25.8113 27.4307 25.7377 27.4575 25.6493C27.4843 25.5608 27.4843 25.4704 27.4575 25.382C27.4307 25.2935 27.3899 25.22 27.2323 25.0624Z" fill="currentColor"/>', nY = '<path d="M8.66667 6.66667C8.29848 6.66667 8 6.96514 8 7.33333V24.6667C8 25.0349 8.29848 25.3333 8.66667 25.3333H12.6667C13.0349 25.3333 13.3333 25.0349 13.3333 24.6667V7.33333C13.3333 6.96514 13.0349 6.66667 12.6667 6.66667H8.66667Z" fill="currentColor"/> <path d="M19.3333 6.66667C18.9651 6.66667 18.6667 6.96514 18.6667 7.33333V24.6667C18.6667 25.0349 18.9651 25.3333 19.3333 25.3333H23.3333C23.7015 25.3333 24 25.0349 24 24.6667V7.33333C24 6.96514 23.7015 6.66667 23.3333 6.66667H19.3333Z" fill="currentColor"/>', iY = '<path d="M5.33334 26V19.4667C5.33334 19.393 5.39304 19.3333 5.46668 19.3333H7.86668C7.94031 19.3333 8.00001 19.393 8.00001 19.4667V23.3333C8.00001 23.7015 8.29849 24 8.66668 24H23.3333C23.7015 24 24 23.7015 24 23.3333V8.66666C24 8.29847 23.7015 7.99999 23.3333 7.99999H19.4667C19.393 7.99999 19.3333 7.9403 19.3333 7.86666V5.46666C19.3333 5.39302 19.393 5.33333 19.4667 5.33333H26C26.3682 5.33333 26.6667 5.63181 26.6667 5.99999V26C26.6667 26.3682 26.3682 26.6667 26 26.6667H6.00001C5.63182 26.6667 5.33334 26.3682 5.33334 26Z" fill="currentColor"/> <path d="M14.0098 8.42359H10.806C10.6872 8.42359 10.6277 8.56721 10.7117 8.6512L16.5491 14.4886C16.8094 14.7489 16.8094 15.171 16.5491 15.4314L15.3234 16.657C15.0631 16.9174 14.641 16.9174 14.3806 16.657L8.63739 10.9138C8.55339 10.8298 8.40978 10.8893 8.40978 11.0081V14.0236C8.40978 14.3918 8.1113 14.6903 7.74311 14.6903H6.00978C5.64159 14.6903 5.34311 14.3918 5.34311 14.0236L5.34311 6.02359C5.34311 5.6554 5.64159 5.35692 6.00978 5.35692L14.0098 5.35692C14.378 5.35692 14.6764 5.6554 14.6764 6.02359V7.75692C14.6764 8.12511 14.378 8.42359 14.0098 8.42359Z" fill="currentColor"/>', rY = '<path d="M16 15.3333C15.6318 15.3333 15.3333 15.6318 15.3333 16V20C15.3333 20.3682 15.6318 20.6667 16 20.6667H21.3333C21.7015 20.6667 22 20.3682 22 20V16C22 15.6318 21.7015 15.3333 21.3333 15.3333H16Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M5.33333 7.33334C5.33333 6.96515 5.63181 6.66667 5.99999 6.66667H26C26.3682 6.66667 26.6667 6.96515 26.6667 7.33334V24.6667C26.6667 25.0349 26.3682 25.3333 26 25.3333H5.99999C5.63181 25.3333 5.33333 25.0349 5.33333 24.6667V7.33334ZM7.99999 10C7.99999 9.63182 8.29847 9.33334 8.66666 9.33334H23.3333C23.7015 9.33334 24 9.63182 24 10V22C24 22.3682 23.7015 22.6667 23.3333 22.6667H8.66666C8.29847 22.6667 7.99999 22.3682 7.99999 22V10Z" fill="currentColor"/>', aY = '<path d="M10.6667 6.6548C10.6667 6.10764 11.2894 5.79346 11.7295 6.11862L24.377 15.4634C24.7377 15.7298 24.7377 16.2692 24.3771 16.5357L11.7295 25.8813C11.2895 26.2065 10.6667 25.8923 10.6667 25.3451L10.6667 6.6548Z" fill="currentColor"/>', sY = '<path d="M13.9213 5.53573C14.3146 5.45804 14.6666 5.76987 14.6666 6.17079V7.57215C14.6666 7.89777 14.4305 8.17277 14.114 8.24925C12.5981 8.61559 11.2506 9.41368 10.2091 10.506C9.98474 10.7414 9.62903 10.8079 9.34742 10.6453L8.14112 9.94885C7.79394 9.7484 7.69985 9.28777 7.96359 8.98585C9.48505 7.24409 11.5636 6.00143 13.9213 5.53573Z" fill="currentColor"/> <path d="M5.88974 12.5908C6.01805 12.2101 6.46491 12.0603 6.81279 12.2611L8.01201 12.9535C8.29379 13.1162 8.41396 13.4577 8.32238 13.7699C8.11252 14.4854 7.99998 15.2424 7.99998 16.0257C7.99998 16.809 8.11252 17.566 8.32238 18.2814C8.41396 18.5936 8.29378 18.9352 8.01201 19.0979L6.82742 19.7818C6.48051 19.9821 6.03488 19.8337 5.90521 19.4547C5.5345 18.3712 5.33331 17.2091 5.33331 16C5.33331 14.8078 5.5289 13.6613 5.88974 12.5908Z" fill="currentColor"/> <path d="M8.17106 22.0852C7.82291 22.2862 7.72949 22.7486 7.99532 23.0502C9.51387 24.773 11.5799 26.0017 13.9213 26.4642C14.3146 26.5419 14.6666 26.2301 14.6666 25.8291V24.4792C14.6666 24.1536 14.4305 23.8786 14.114 23.8021C12.5981 23.4358 11.2506 22.6377 10.2091 21.5453C9.98474 21.31 9.62903 21.2435 9.34742 21.4061L8.17106 22.0852Z" fill="currentColor"/> <path d="M17.3333 25.8291C17.3333 26.2301 17.6857 26.5418 18.079 26.4641C22.9748 25.4969 26.6666 21.1796 26.6666 16C26.6666 10.8204 22.9748 6.50302 18.079 5.5358C17.6857 5.4581 17.3333 5.76987 17.3333 6.17079V7.57215C17.3333 7.89777 17.5697 8.17282 17.8862 8.24932C21.3942 9.09721 24 12.2572 24 16.0257C24 19.7942 21.3942 22.9542 17.8862 23.802C17.5697 23.8785 17.3333 24.1536 17.3333 24.4792V25.8291Z" fill="currentColor"/> <path d="M14.3961 10.4163C13.9561 10.0911 13.3333 10.4053 13.3333 10.9525L13.3333 21.0474C13.3333 21.5946 13.9561 21.9087 14.3962 21.5836L21.2273 16.5359C21.5879 16.2694 21.5879 15.73 21.2273 15.4635L14.3961 10.4163Z" fill="currentColor"/>', oY = '<path d="M15.6038 12.2147C16.0439 12.5399 16.6667 12.2257 16.6667 11.6786V10.1789C16.6667 10.1001 16.7351 10.0384 16.8134 10.0479C20.1116 10.4494 22.6667 13.2593 22.6667 16.6659C22.6667 20.3481 19.6817 23.3332 15.9995 23.3332C12.542 23.3332 9.69927 20.7014 9.36509 17.332C9.32875 16.9655 9.03371 16.6662 8.66548 16.6662L6.66655 16.6666C6.29841 16.6666 5.99769 16.966 6.02187 17.3334C6.36494 22.5454 10.7012 26.6667 16 26.6667C21.5228 26.6667 26 22.1895 26 16.6667C26 11.4103 21.9444 7.10112 16.7916 6.69757C16.7216 6.69209 16.6667 6.63396 16.6667 6.56372V4.98824C16.6667 4.44106 16.0439 4.12689 15.6038 4.45206L11.0765 7.79738C10.7159 8.06387 10.7159 8.60326 11.0766 8.86973L15.6038 12.2147Z" fill="currentColor"/>', lY = '<path d="M16.6667 10.3452C16.6667 10.8924 16.0439 11.2066 15.6038 10.8814L11.0766 7.5364C10.7159 7.26993 10.7159 6.73054 11.0766 6.46405L15.6038 3.11873C16.0439 2.79356 16.6667 3.10773 16.6667 3.6549V5.22682C16.6667 5.29746 16.7223 5.35579 16.7927 5.36066C22.6821 5.76757 27.3333 10.674 27.3333 16.6667C27.3333 22.9259 22.2592 28 16 28C9.96483 28 5.03145 23.2827 4.68601 17.3341C4.66466 16.9665 4.96518 16.6673 5.33339 16.6673H7.3334C7.70157 16.6673 7.99714 16.9668 8.02743 17.3337C8.36638 21.4399 11.8064 24.6667 16 24.6667C20.4183 24.6667 24 21.085 24 16.6667C24 12.5225 20.8483 9.11428 16.8113 8.70739C16.7337 8.69957 16.6667 8.76096 16.6667 8.83893V10.3452Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0879 19.679C17.4553 19.9195 17.8928 20.0398 18.4004 20.0398C18.9099 20.0398 19.3474 19.9205 19.7129 19.6818C20.0803 19.4413 20.3635 19.0938 20.5623 18.6392C20.7612 18.1847 20.8606 17.6373 20.8606 16.9972C20.8625 16.3608 20.764 15.8192 20.5652 15.3722C20.3663 14.9252 20.0822 14.5853 19.7129 14.3523C19.3455 14.1175 18.908 14 18.4004 14C17.8928 14 17.4553 14.1175 17.0879 14.3523C16.7224 14.5853 16.4402 14.9252 16.2413 15.3722C16.0443 15.8173 15.9449 16.3589 15.943 16.9972C15.9411 17.6354 16.0396 18.1818 16.2385 18.6364C16.4373 19.089 16.7205 19.4366 17.0879 19.679ZM19.1362 18.4262C18.9487 18.7349 18.7034 18.8892 18.4004 18.8892C18.1996 18.8892 18.0226 18.8211 17.8691 18.6847C17.7157 18.5464 17.5964 18.3372 17.5112 18.0568C17.4279 17.7765 17.3871 17.4233 17.389 16.9972C17.3909 16.3684 17.4847 15.9025 17.6703 15.5995C17.8559 15.2945 18.0993 15.1421 18.4004 15.1421C18.603 15.1421 18.7801 15.2093 18.9316 15.3438C19.0832 15.4782 19.2015 15.6828 19.2868 15.9574C19.372 16.2301 19.4146 16.5767 19.4146 16.9972C19.4165 17.6392 19.3237 18.1156 19.1362 18.4262Z" fill="currentColor"/> <path d="M13.7746 19.8978C13.8482 19.8978 13.9079 19.8381 13.9079 19.7644V14.2129C13.9079 14.1393 13.8482 14.0796 13.7746 14.0796H12.642C12.6171 14.0796 12.5927 14.0865 12.5716 14.0997L11.2322 14.9325C11.1931 14.9568 11.1693 14.9996 11.1693 15.0457V15.9497C11.1693 16.0539 11.2833 16.1178 11.3722 16.0635L12.464 15.396C12.4682 15.3934 12.473 15.3921 12.4779 15.3921C12.4926 15.3921 12.5045 15.404 12.5045 15.4187V19.7644C12.5045 19.8381 12.5642 19.8978 12.6378 19.8978H13.7746Z" fill="currentColor"/>', uY = '<path d="M15.3333 10.3452C15.3333 10.8924 15.9561 11.2066 16.3962 10.8814L20.9234 7.5364C21.2841 7.26993 21.2841 6.73054 20.9235 6.46405L16.3962 3.11873C15.9561 2.79356 15.3333 3.10773 15.3333 3.6549V5.22682C15.3333 5.29746 15.2778 5.35579 15.2073 5.36066C9.31791 5.76757 4.66667 10.674 4.66667 16.6667C4.66667 22.9259 9.74078 28 16 28C22.0352 28 26.9686 23.2827 27.314 17.3341C27.3354 16.9665 27.0348 16.6673 26.6666 16.6673H24.6666C24.2984 16.6673 24.0029 16.9668 23.9726 17.3337C23.6336 21.4399 20.1937 24.6667 16 24.6667C11.5817 24.6667 8 21.085 8 16.6667C8 12.5225 11.1517 9.11428 15.1887 8.70739C15.2663 8.69957 15.3333 8.76096 15.3333 8.83893V10.3452Z" fill="currentColor"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0879 19.679C17.4553 19.9195 17.8928 20.0398 18.4004 20.0398C18.9099 20.0398 19.3474 19.9205 19.7129 19.6818C20.0803 19.4413 20.3635 19.0938 20.5623 18.6392C20.7612 18.1847 20.8606 17.6373 20.8606 16.9972C20.8625 16.3608 20.764 15.8192 20.5652 15.3722C20.3663 14.9252 20.0822 14.5853 19.7129 14.3523C19.3455 14.1175 18.908 14 18.4004 14C17.8928 14 17.4553 14.1175 17.0879 14.3523C16.7224 14.5853 16.4402 14.9252 16.2413 15.3722C16.0443 15.8173 15.9449 16.3589 15.943 16.9972C15.9411 17.6354 16.0396 18.1818 16.2385 18.6364C16.4373 19.089 16.7205 19.4366 17.0879 19.679ZM19.1362 18.4262C18.9487 18.7349 18.7034 18.8892 18.4004 18.8892C18.1996 18.8892 18.0225 18.8211 17.8691 18.6847C17.7157 18.5464 17.5964 18.3372 17.5112 18.0568C17.4278 17.7765 17.3871 17.4233 17.389 16.9972C17.3909 16.3684 17.4847 15.9025 17.6703 15.5995C17.8559 15.2945 18.0992 15.1421 18.4004 15.1421C18.603 15.1421 18.7801 15.2093 18.9316 15.3438C19.0831 15.4782 19.2015 15.6828 19.2867 15.9574C19.372 16.2301 19.4146 16.5767 19.4146 16.9972C19.4165 17.6392 19.3237 18.1156 19.1362 18.4262Z" fill="currentColor"/> <path d="M13.7746 19.8978C13.8482 19.8978 13.9079 19.8381 13.9079 19.7644V14.2129C13.9079 14.1393 13.8482 14.0796 13.7746 14.0796H12.642C12.6171 14.0796 12.5927 14.0865 12.5716 14.0997L11.2322 14.9325C11.1931 14.9568 11.1693 14.9996 11.1693 15.0457V15.9497C11.1693 16.0539 11.2833 16.1178 11.3722 16.0635L12.464 15.396C12.4682 15.3934 12.473 15.3921 12.4779 15.3921C12.4926 15.3921 12.5045 15.404 12.5045 15.4187V19.7644C12.5045 19.8381 12.5642 19.8978 12.6378 19.8978H13.7746Z" fill="currentColor"/>', cY = '<path fill-rule="evenodd" clip-rule="evenodd" d="M13.5722 5.33333C13.2429 5.33333 12.9629 5.57382 12.9132 5.89938L12.4063 9.21916C12.4 9.26058 12.3746 9.29655 12.3378 9.31672C12.2387 9.37118 12.1409 9.42779 12.0444 9.48648C12.0086 9.5083 11.9646 9.51242 11.9255 9.49718L8.79572 8.27692C8.48896 8.15732 8.14083 8.27958 7.9762 8.56472L5.5491 12.7686C5.38444 13.0538 5.45271 13.4165 5.70981 13.6223L8.33308 15.7225C8.3658 15.7487 8.38422 15.7887 8.38331 15.8306C8.38209 15.8867 8.38148 15.9429 8.38148 15.9993C8.38148 16.0558 8.3821 16.1121 8.38332 16.1684C8.38423 16.2102 8.36582 16.2503 8.33313 16.2765L5.7103 18.3778C5.45334 18.5836 5.38515 18.9462 5.54978 19.2314L7.97688 23.4352C8.14155 23.7205 8.48981 23.8427 8.79661 23.723L11.926 22.5016C11.9651 22.4864 12.009 22.4905 12.0449 22.5123C12.1412 22.5709 12.2388 22.6274 12.3378 22.6818C12.3745 22.7019 12.4 22.7379 12.4063 22.7793L12.9132 26.0993C12.9629 26.4249 13.2429 26.6654 13.5722 26.6654H18.4264C18.7556 26.6654 19.0356 26.425 19.0854 26.0995L19.5933 22.7801C19.5997 22.7386 19.6252 22.7027 19.6619 22.6825C19.7614 22.6279 19.8596 22.5711 19.9564 22.5121C19.9923 22.4903 20.0362 22.4862 20.0754 22.5015L23.2035 23.7223C23.5103 23.842 23.8585 23.7198 24.0232 23.4346L26.4503 19.2307C26.6149 18.9456 26.5467 18.583 26.2898 18.3771L23.6679 16.2766C23.6352 16.2504 23.6168 16.2104 23.6177 16.1685C23.619 16.1122 23.6196 16.0558 23.6196 15.9993C23.6196 15.9429 23.619 15.8866 23.6177 15.8305C23.6168 15.7886 23.6353 15.7486 23.668 15.7224L26.2903 13.623C26.5474 13.4172 26.6156 13.0544 26.451 12.7692L24.0239 8.56537C23.8592 8.28023 23.5111 8.15797 23.2043 8.27757L20.0758 9.49734C20.0367 9.51258 19.9927 9.50846 19.9569 9.48664C19.8599 9.42762 19.7616 9.37071 19.6618 9.31596C19.6251 9.2958 19.5997 9.25984 19.5933 9.21843L19.0854 5.89915C19.0356 5.57369 18.7556 5.33333 18.4264 5.33333H13.5722ZM16.0001 20.2854C18.3672 20.2854 20.2862 18.3664 20.2862 15.9993C20.2862 13.6322 18.3672 11.7132 16.0001 11.7132C13.6329 11.7132 11.714 13.6322 11.714 15.9993C11.714 18.3664 13.6329 20.2854 16.0001 20.2854Z" fill="currentColor"/>', dY = '<path d="M17.5091 24.6595C17.5091 25.2066 16.8864 25.5208 16.4463 25.1956L9.44847 20.0252C9.42553 20.0083 9.39776 19.9992 9.36923 19.9992H4.66667C4.29848 19.9992 4 19.7007 4 19.3325V12.6658C4 12.2976 4.29848 11.9992 4.66667 11.9992H9.37115C9.39967 11.9992 9.42745 11.99 9.45039 11.9731L16.4463 6.80363C16.8863 6.47845 17.5091 6.79262 17.5091 7.3398L17.5091 24.6595Z" fill="currentColor"/> <path d="M27.5091 9.33336C27.8773 9.33336 28.1758 9.63184 28.1758 10V22C28.1758 22.3682 27.8773 22.6667 27.5091 22.6667H26.1758C25.8076 22.6667 25.5091 22.3682 25.5091 22V10C25.5091 9.63184 25.8076 9.33336 26.1758 9.33336L27.5091 9.33336Z" fill="currentColor"/> <path d="M22.1758 12C22.544 12 22.8424 12.2985 22.8424 12.6667V19.3334C22.8424 19.7016 22.544 20 22.1758 20H20.8424C20.4743 20 20.1758 19.7016 20.1758 19.3334V12.6667C20.1758 12.2985 20.4743 12 20.8424 12H22.1758Z" fill="currentColor"/>', fY = '<path d="M17.5091 24.6594C17.5091 25.2066 16.8864 25.5207 16.4463 25.1956L9.44847 20.0252C9.42553 20.0083 9.39776 19.9991 9.36923 19.9991H4.66667C4.29848 19.9991 4 19.7006 4 19.3324V12.6658C4 12.2976 4.29848 11.9991 4.66667 11.9991H9.37115C9.39967 11.9991 9.42745 11.99 9.45039 11.973L16.4463 6.80358C16.8863 6.4784 17.5091 6.79258 17.5091 7.33975L17.5091 24.6594Z" fill="currentColor"/> <path d="M22.8424 12.6667C22.8424 12.2985 22.544 12 22.1758 12H20.8424C20.4743 12 20.1758 12.2985 20.1758 12.6667V19.3333C20.1758 19.7015 20.4743 20 20.8424 20H22.1758C22.544 20 22.8424 19.7015 22.8424 19.3333V12.6667Z" fill="currentColor"/>';
const hY = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Component: Et,
  DOMEvent: St,
  EventsController: Cn,
  EventsTarget: Rk,
  Icon$0: NQ,
  Icon$104: dY,
  Icon$105: fY,
  Icon$11: zQ,
  Icon$13: HQ,
  Icon$16: FQ,
  Icon$19: IQ,
  Icon$22: BQ,
  Icon$24: wM,
  Icon$26: jQ,
  Icon$27: GQ,
  Icon$31: QQ,
  Icon$33: YQ,
  Icon$34: WQ,
  Icon$35: KQ,
  Icon$39: ZQ,
  Icon$40: XQ,
  Icon$5: VQ,
  Icon$53: JQ,
  Icon$54: eY,
  Icon$56: tY,
  Icon$59: nY,
  Icon$60: iY,
  Icon$61: rY,
  Icon$62: aY,
  Icon$63: sY,
  Icon$74: oY,
  Icon$77: lY,
  Icon$8: UQ,
  Icon$81: uY,
  Icon$88: cY,
  State: sd,
  ViewController: Vs,
  animationFrameThrottle: nv,
  appendTriggerEvent: lQ,
  ariaBool: b2,
  camelToKebabCase: _0,
  chromecast: qQ,
  composeRefs: pn,
  computed: sh,
  createContext: ad,
  createDisposalBin: MQ,
  createReactComponent: xt,
  createScope: Xc,
  deferredPromise: Qm,
  effect: K,
  findTriggerEvent: aM,
  fscreen: rh,
  functionDebounce: dw,
  functionThrottle: mh,
  getScope: A0,
  hasProvidedContext: fu,
  hasTriggerEvent: oQ,
  isArray: vr,
  isBoolean: iM,
  isDOMNode: lM,
  isFunction: Ma,
  isKeyboardClick: Lk,
  isKeyboardEvent: O0,
  isMouseEvent: sM,
  isNil: nM,
  isNull: sl,
  isNumber: ar,
  isObject: kk,
  isPointerEvent: R7,
  isString: qe,
  isTouchEvent: v2,
  isUndefined: Di,
  isWriteSignal: tM,
  kebabToCamelCase: $k,
  keysOf: L7,
  listenEvent: sn,
  method: Fi,
  noop: Ms,
  onDispose: bt,
  peek: fe,
  prop: on,
  provideContext: Ps,
  r: bM,
  scoped: la,
  setAttribute: lt,
  setStyle: Aa,
  signal: nt,
  tick: al,
  toggleClass: cQ,
  untrack: Gm,
  uppercaseFirstChar: Dk,
  useContext: gi,
  useReactContext: Mk,
  useReactScope: mM,
  useSignal: cn,
  useSignalRecord: SM,
  useState: P1,
  useStateContext: tv,
  waitIdlePeriod: CM,
  waitTimeout: gM,
  walkTriggerEventChain: sQ,
  wasEnterKeyPressed: oM
}, Symbol.toStringTag, { value: "Module" })), L9 = Math.min, jm = Math.max, $9 = Math.round, Bb = Math.floor, oh = (c) => ({
  x: c,
  y: c
}), pY = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, mY = {
  start: "end",
  end: "start"
};
function rD(c, s, t) {
  return jm(c, L9(s, t));
}
function Ak(c, s) {
  return typeof c == "function" ? c(s) : c;
}
function x1(c) {
  return c.split("-")[0];
}
function Pk(c) {
  return c.split("-")[1];
}
function TM(c) {
  return c === "x" ? "y" : "x";
}
function EM(c) {
  return c === "y" ? "height" : "width";
}
function w2(c) {
  return ["top", "bottom"].includes(x1(c)) ? "y" : "x";
}
function kM(c) {
  return TM(w2(c));
}
function vY(c, s, t) {
  t === void 0 && (t = !1);
  const r = Pk(c), f = kM(c), v = EM(f);
  let g = f === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return s.reference[v] > s.floating[v] && (g = D9(g)), [g, D9(g)];
}
function yY(c) {
  const s = D9(c);
  return [$7(c), s, $7(s)];
}
function $7(c) {
  return c.replace(/start|end/g, (s) => mY[s]);
}
function gY(c, s, t) {
  const r = ["left", "right"], f = ["right", "left"], v = ["top", "bottom"], g = ["bottom", "top"];
  switch (c) {
    case "top":
    case "bottom":
      return t ? s ? f : r : s ? r : f;
    case "left":
    case "right":
      return s ? v : g;
    default:
      return [];
  }
}
function CY(c, s, t, r) {
  const f = Pk(c);
  let v = gY(x1(c), t === "start", r);
  return f && (v = v.map((g) => g + "-" + f), s && (v = v.concat(v.map($7)))), v;
}
function D9(c) {
  return c.replace(/left|right|bottom|top/g, (s) => pY[s]);
}
function SY(c) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...c
  };
}
function bY(c) {
  return typeof c != "number" ? SY(c) : {
    top: c,
    right: c,
    bottom: c,
    left: c
  };
}
function M9(c) {
  const {
    x: s,
    y: t,
    width: r,
    height: f
  } = c;
  return {
    width: r,
    height: f,
    top: t,
    left: s,
    right: s + r,
    bottom: t + f,
    x: s,
    y: t
  };
}
function aD(c, s, t) {
  let {
    reference: r,
    floating: f
  } = c;
  const v = w2(s), g = kM(s), T = EM(g), x = x1(s), $ = v === "y", P = r.x + r.width / 2 - f.width / 2, A = r.y + r.height / 2 - f.height / 2, U = r[T] / 2 - f[T] / 2;
  let F;
  switch (x) {
    case "top":
      F = {
        x: P,
        y: r.y - f.height
      };
      break;
    case "bottom":
      F = {
        x: P,
        y: r.y + r.height
      };
      break;
    case "right":
      F = {
        x: r.x + r.width,
        y: A
      };
      break;
    case "left":
      F = {
        x: r.x - f.width,
        y: A
      };
      break;
    default:
      F = {
        x: r.x,
        y: r.y
      };
  }
  switch (Pk(s)) {
    case "start":
      F[g] -= U * (t && $ ? -1 : 1);
      break;
    case "end":
      F[g] += U * (t && $ ? -1 : 1);
      break;
  }
  return F;
}
const wY = async (c, s, t) => {
  const {
    placement: r = "bottom",
    strategy: f = "absolute",
    middleware: v = [],
    platform: g
  } = t, T = v.filter(Boolean), x = await (g.isRTL == null ? void 0 : g.isRTL(s));
  let $ = await g.getElementRects({
    reference: c,
    floating: s,
    strategy: f
  }), {
    x: P,
    y: A
  } = aD($, r, x), U = r, F = {}, Z = 0;
  for (let ne = 0; ne < T.length; ne++) {
    const {
      name: ce,
      fn: De
    } = T[ne], {
      x: Ne,
      y: Se,
      data: je,
      reset: Me
    } = await De({
      x: P,
      y: A,
      initialPlacement: r,
      placement: U,
      strategy: f,
      middlewareData: F,
      rects: $,
      platform: g,
      elements: {
        reference: c,
        floating: s
      }
    });
    P = Ne ?? P, A = Se ?? A, F = {
      ...F,
      [ce]: {
        ...F[ce],
        ...je
      }
    }, Me && Z <= 50 && (Z++, typeof Me == "object" && (Me.placement && (U = Me.placement), Me.rects && ($ = Me.rects === !0 ? await g.getElementRects({
      reference: c,
      floating: s,
      strategy: f
    }) : Me.rects), {
      x: P,
      y: A
    } = aD($, U, x)), ne = -1);
  }
  return {
    x: P,
    y: A,
    placement: U,
    strategy: f,
    middlewareData: F
  };
};
async function xM(c, s) {
  var t;
  s === void 0 && (s = {});
  const {
    x: r,
    y: f,
    platform: v,
    rects: g,
    elements: T,
    strategy: x
  } = c, {
    boundary: $ = "clippingAncestors",
    rootBoundary: P = "viewport",
    elementContext: A = "floating",
    altBoundary: U = !1,
    padding: F = 0
  } = Ak(s, c), Z = bY(F), ce = T[U ? A === "floating" ? "reference" : "floating" : A], De = M9(await v.getClippingRect({
    element: (t = await (v.isElement == null ? void 0 : v.isElement(ce))) == null || t ? ce : ce.contextElement || await (v.getDocumentElement == null ? void 0 : v.getDocumentElement(T.floating)),
    boundary: $,
    rootBoundary: P,
    strategy: x
  })), Ne = A === "floating" ? {
    x: r,
    y: f,
    width: g.floating.width,
    height: g.floating.height
  } : g.reference, Se = await (v.getOffsetParent == null ? void 0 : v.getOffsetParent(T.floating)), je = await (v.isElement == null ? void 0 : v.isElement(Se)) ? await (v.getScale == null ? void 0 : v.getScale(Se)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, Me = M9(v.convertOffsetParentRelativeRectToViewportRelativeRect ? await v.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: T,
    rect: Ne,
    offsetParent: Se,
    strategy: x
  }) : Ne);
  return {
    top: (De.top - Me.top + Z.top) / je.y,
    bottom: (Me.bottom - De.bottom + Z.bottom) / je.y,
    left: (De.left - Me.left + Z.left) / je.x,
    right: (Me.right - De.right + Z.right) / je.x
  };
}
const TY = function(c) {
  return c === void 0 && (c = {}), {
    name: "flip",
    options: c,
    async fn(s) {
      var t, r;
      const {
        placement: f,
        middlewareData: v,
        rects: g,
        initialPlacement: T,
        platform: x,
        elements: $
      } = s, {
        mainAxis: P = !0,
        crossAxis: A = !0,
        fallbackPlacements: U,
        fallbackStrategy: F = "bestFit",
        fallbackAxisSideDirection: Z = "none",
        flipAlignment: ne = !0,
        ...ce
      } = Ak(c, s);
      if ((t = v.arrow) != null && t.alignmentOffset)
        return {};
      const De = x1(f), Ne = w2(T), Se = x1(T) === T, je = await (x.isRTL == null ? void 0 : x.isRTL($.floating)), Me = U || (Se || !ne ? [D9(T)] : yY(T)), Ct = Z !== "none";
      !U && Ct && Me.push(...CY(T, ne, Z, je));
      const Ge = [T, ...Me], he = await xM(s, ce), Ze = [];
      let pt = ((r = v.flip) == null ? void 0 : r.overflows) || [];
      if (P && Ze.push(he[De]), A) {
        const mt = vY(f, g, je);
        Ze.push(he[mt[0]], he[mt[1]]);
      }
      if (pt = [...pt, {
        placement: f,
        overflows: Ze
      }], !Ze.every((mt) => mt <= 0)) {
        var Gt, Lt;
        const mt = (((Gt = v.flip) == null ? void 0 : Gt.index) || 0) + 1, wn = Ge[mt];
        if (wn)
          return {
            data: {
              index: mt,
              overflows: pt
            },
            reset: {
              placement: wn
            }
          };
        let Ye = (Lt = pt.filter((rt) => rt.overflows[0] <= 0).sort((rt, se) => rt.overflows[1] - se.overflows[1])[0]) == null ? void 0 : Lt.placement;
        if (!Ye)
          switch (F) {
            case "bestFit": {
              var Ve;
              const rt = (Ve = pt.filter((se) => {
                if (Ct) {
                  const Le = w2(se.placement);
                  return Le === Ne || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Le === "y";
                }
                return !0;
              }).map((se) => [se.placement, se.overflows.filter((Le) => Le > 0).reduce((Le, me) => Le + me, 0)]).sort((se, Le) => se[1] - Le[1])[0]) == null ? void 0 : Ve[0];
              rt && (Ye = rt);
              break;
            }
            case "initialPlacement":
              Ye = T;
              break;
          }
        if (f !== Ye)
          return {
            reset: {
              placement: Ye
            }
          };
      }
      return {};
    }
  };
}, EY = function(c) {
  return c === void 0 && (c = {}), {
    name: "shift",
    options: c,
    async fn(s) {
      const {
        x: t,
        y: r,
        placement: f
      } = s, {
        mainAxis: v = !0,
        crossAxis: g = !1,
        limiter: T = {
          fn: (ce) => {
            let {
              x: De,
              y: Ne
            } = ce;
            return {
              x: De,
              y: Ne
            };
          }
        },
        ...x
      } = Ak(c, s), $ = {
        x: t,
        y: r
      }, P = await xM(s, x), A = w2(x1(f)), U = TM(A);
      let F = $[U], Z = $[A];
      if (v) {
        const ce = U === "y" ? "top" : "left", De = U === "y" ? "bottom" : "right", Ne = F + P[ce], Se = F - P[De];
        F = rD(Ne, F, Se);
      }
      if (g) {
        const ce = A === "y" ? "top" : "left", De = A === "y" ? "bottom" : "right", Ne = Z + P[ce], Se = Z - P[De];
        Z = rD(Ne, Z, Se);
      }
      const ne = T.fn({
        ...s,
        [U]: F,
        [A]: Z
      });
      return {
        ...ne,
        data: {
          x: ne.x - t,
          y: ne.y - r
        }
      };
    }
  };
};
function fw() {
  return typeof window < "u";
}
function O1(c) {
  return RM(c) ? (c.nodeName || "").toLowerCase() : "#document";
}
function As(c) {
  var s;
  return (c == null || (s = c.ownerDocument) == null ? void 0 : s.defaultView) || window;
}
function od(c) {
  var s;
  return (s = (RM(c) ? c.ownerDocument : c.document) || window.document) == null ? void 0 : s.documentElement;
}
function RM(c) {
  return fw() ? c instanceof Node || c instanceof As(c).Node : !1;
}
function ul(c) {
  return fw() ? c instanceof Element || c instanceof As(c).Element : !1;
}
function hu(c) {
  return fw() ? c instanceof HTMLElement || c instanceof As(c).HTMLElement : !1;
}
function sD(c) {
  return !fw() || typeof ShadowRoot > "u" ? !1 : c instanceof ShadowRoot || c instanceof As(c).ShadowRoot;
}
function V0(c) {
  const {
    overflow: s,
    overflowX: t,
    overflowY: r,
    display: f
  } = cl(c);
  return /auto|scroll|overlay|hidden|clip/.test(s + r + t) && !["inline", "contents"].includes(f);
}
function kY(c) {
  return ["table", "td", "th"].includes(O1(c));
}
function hw(c) {
  return [":popover-open", ":modal"].some((s) => {
    try {
      return c.matches(s);
    } catch {
      return !1;
    }
  });
}
function Ok(c) {
  const s = _k(), t = ul(c) ? cl(c) : c;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => t[r] ? t[r] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !s && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !s && (t.filter ? t.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (t.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (t.contain || "").includes(r));
}
function xY(c) {
  let s = lh(c);
  for (; hu(s) && !R1(s); ) {
    if (Ok(s))
      return s;
    if (hw(s))
      return null;
    s = lh(s);
  }
  return null;
}
function _k() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function R1(c) {
  return ["html", "body", "#document"].includes(O1(c));
}
function cl(c) {
  return As(c).getComputedStyle(c);
}
function pw(c) {
  return ul(c) ? {
    scrollLeft: c.scrollLeft,
    scrollTop: c.scrollTop
  } : {
    scrollLeft: c.scrollX,
    scrollTop: c.scrollY
  };
}
function lh(c) {
  if (O1(c) === "html")
    return c;
  const s = (
    // Step into the shadow DOM of the parent of a slotted node.
    c.assignedSlot || // DOM Element detected.
    c.parentNode || // ShadowRoot detected.
    sD(c) && c.host || // Fallback.
    od(c)
  );
  return sD(s) ? s.host : s;
}
function LM(c) {
  const s = lh(c);
  return R1(s) ? c.ownerDocument ? c.ownerDocument.body : c.body : hu(s) && V0(s) ? s : LM(s);
}
function T2(c, s, t) {
  var r;
  s === void 0 && (s = []), t === void 0 && (t = !0);
  const f = LM(c), v = f === ((r = c.ownerDocument) == null ? void 0 : r.body), g = As(f);
  if (v) {
    const T = D7(g);
    return s.concat(g, g.visualViewport || [], V0(f) ? f : [], T && t ? T2(T) : []);
  }
  return s.concat(f, T2(f, [], t));
}
function D7(c) {
  return c.parent && Object.getPrototypeOf(c.parent) ? c.frameElement : null;
}
function $M(c) {
  const s = cl(c);
  let t = parseFloat(s.width) || 0, r = parseFloat(s.height) || 0;
  const f = hu(c), v = f ? c.offsetWidth : t, g = f ? c.offsetHeight : r, T = $9(t) !== v || $9(r) !== g;
  return T && (t = v, r = g), {
    width: t,
    height: r,
    $: T
  };
}
function Nk(c) {
  return ul(c) ? c : c.contextElement;
}
function lg(c) {
  const s = Nk(c);
  if (!hu(s))
    return oh(1);
  const t = s.getBoundingClientRect(), {
    width: r,
    height: f,
    $: v
  } = $M(s);
  let g = (v ? $9(t.width) : t.width) / r, T = (v ? $9(t.height) : t.height) / f;
  return (!g || !Number.isFinite(g)) && (g = 1), (!T || !Number.isFinite(T)) && (T = 1), {
    x: g,
    y: T
  };
}
const RY = /* @__PURE__ */ oh(0);
function DM(c) {
  const s = As(c);
  return !_k() || !s.visualViewport ? RY : {
    x: s.visualViewport.offsetLeft,
    y: s.visualViewport.offsetTop
  };
}
function LY(c, s, t) {
  return s === void 0 && (s = !1), !t || s && t !== As(c) ? !1 : s;
}
function Ym(c, s, t, r) {
  s === void 0 && (s = !1), t === void 0 && (t = !1);
  const f = c.getBoundingClientRect(), v = Nk(c);
  let g = oh(1);
  s && (r ? ul(r) && (g = lg(r)) : g = lg(c));
  const T = LY(v, t, r) ? DM(v) : oh(0);
  let x = (f.left + T.x) / g.x, $ = (f.top + T.y) / g.y, P = f.width / g.x, A = f.height / g.y;
  if (v) {
    const U = As(v), F = r && ul(r) ? As(r) : r;
    let Z = U, ne = D7(Z);
    for (; ne && r && F !== Z; ) {
      const ce = lg(ne), De = ne.getBoundingClientRect(), Ne = cl(ne), Se = De.left + (ne.clientLeft + parseFloat(Ne.paddingLeft)) * ce.x, je = De.top + (ne.clientTop + parseFloat(Ne.paddingTop)) * ce.y;
      x *= ce.x, $ *= ce.y, P *= ce.x, A *= ce.y, x += Se, $ += je, Z = As(ne), ne = D7(Z);
    }
  }
  return M9({
    width: P,
    height: A,
    x,
    y: $
  });
}
function $Y(c) {
  let {
    elements: s,
    rect: t,
    offsetParent: r,
    strategy: f
  } = c;
  const v = f === "fixed", g = od(r), T = s ? hw(s.floating) : !1;
  if (r === g || T && v)
    return t;
  let x = {
    scrollLeft: 0,
    scrollTop: 0
  }, $ = oh(1);
  const P = oh(0), A = hu(r);
  if ((A || !A && !v) && ((O1(r) !== "body" || V0(g)) && (x = pw(r)), hu(r))) {
    const U = Ym(r);
    $ = lg(r), P.x = U.x + r.clientLeft, P.y = U.y + r.clientTop;
  }
  return {
    width: t.width * $.x,
    height: t.height * $.y,
    x: t.x * $.x - x.scrollLeft * $.x + P.x,
    y: t.y * $.y - x.scrollTop * $.y + P.y
  };
}
function DY(c) {
  return Array.from(c.getClientRects());
}
function MM(c) {
  return Ym(od(c)).left + pw(c).scrollLeft;
}
function MY(c) {
  const s = od(c), t = pw(c), r = c.ownerDocument.body, f = jm(s.scrollWidth, s.clientWidth, r.scrollWidth, r.clientWidth), v = jm(s.scrollHeight, s.clientHeight, r.scrollHeight, r.clientHeight);
  let g = -t.scrollLeft + MM(c);
  const T = -t.scrollTop;
  return cl(r).direction === "rtl" && (g += jm(s.clientWidth, r.clientWidth) - f), {
    width: f,
    height: v,
    x: g,
    y: T
  };
}
function AY(c, s) {
  const t = As(c), r = od(c), f = t.visualViewport;
  let v = r.clientWidth, g = r.clientHeight, T = 0, x = 0;
  if (f) {
    v = f.width, g = f.height;
    const $ = _k();
    (!$ || $ && s === "fixed") && (T = f.offsetLeft, x = f.offsetTop);
  }
  return {
    width: v,
    height: g,
    x: T,
    y: x
  };
}
function PY(c, s) {
  const t = Ym(c, !0, s === "fixed"), r = t.top + c.clientTop, f = t.left + c.clientLeft, v = hu(c) ? lg(c) : oh(1), g = c.clientWidth * v.x, T = c.clientHeight * v.y, x = f * v.x, $ = r * v.y;
  return {
    width: g,
    height: T,
    x,
    y: $
  };
}
function oD(c, s, t) {
  let r;
  if (s === "viewport")
    r = AY(c, t);
  else if (s === "document")
    r = MY(od(c));
  else if (ul(s))
    r = PY(s, t);
  else {
    const f = DM(c);
    r = {
      ...s,
      x: s.x - f.x,
      y: s.y - f.y
    };
  }
  return M9(r);
}
function AM(c, s) {
  const t = lh(c);
  return t === s || !ul(t) || R1(t) ? !1 : cl(t).position === "fixed" || AM(t, s);
}
function OY(c, s) {
  const t = s.get(c);
  if (t)
    return t;
  let r = T2(c, [], !1).filter((T) => ul(T) && O1(T) !== "body"), f = null;
  const v = cl(c).position === "fixed";
  let g = v ? lh(c) : c;
  for (; ul(g) && !R1(g); ) {
    const T = cl(g), x = Ok(g);
    !x && T.position === "fixed" && (f = null), (v ? !x && !f : !x && T.position === "static" && !!f && ["absolute", "fixed"].includes(f.position) || V0(g) && !x && AM(c, g)) ? r = r.filter((P) => P !== g) : f = T, g = lh(g);
  }
  return s.set(c, r), r;
}
function _Y(c) {
  let {
    element: s,
    boundary: t,
    rootBoundary: r,
    strategy: f
  } = c;
  const g = [...t === "clippingAncestors" ? hw(s) ? [] : OY(s, this._c) : [].concat(t), r], T = g[0], x = g.reduce(($, P) => {
    const A = oD(s, P, f);
    return $.top = jm(A.top, $.top), $.right = L9(A.right, $.right), $.bottom = L9(A.bottom, $.bottom), $.left = jm(A.left, $.left), $;
  }, oD(s, T, f));
  return {
    width: x.right - x.left,
    height: x.bottom - x.top,
    x: x.left,
    y: x.top
  };
}
function NY(c) {
  const {
    width: s,
    height: t
  } = $M(c);
  return {
    width: s,
    height: t
  };
}
function VY(c, s, t) {
  const r = hu(s), f = od(s), v = t === "fixed", g = Ym(c, !0, v, s);
  let T = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const x = oh(0);
  if (r || !r && !v)
    if ((O1(s) !== "body" || V0(f)) && (T = pw(s)), r) {
      const A = Ym(s, !0, v, s);
      x.x = A.x + s.clientLeft, x.y = A.y + s.clientTop;
    } else f && (x.x = MM(f));
  const $ = g.left + T.scrollLeft - x.x, P = g.top + T.scrollTop - x.y;
  return {
    x: $,
    y: P,
    width: g.width,
    height: g.height
  };
}
function n7(c) {
  return cl(c).position === "static";
}
function lD(c, s) {
  return !hu(c) || cl(c).position === "fixed" ? null : s ? s(c) : c.offsetParent;
}
function PM(c, s) {
  const t = As(c);
  if (hw(c))
    return t;
  if (!hu(c)) {
    let f = lh(c);
    for (; f && !R1(f); ) {
      if (ul(f) && !n7(f))
        return f;
      f = lh(f);
    }
    return t;
  }
  let r = lD(c, s);
  for (; r && kY(r) && n7(r); )
    r = lD(r, s);
  return r && R1(r) && n7(r) && !Ok(r) ? t : r || xY(c) || t;
}
const UY = async function(c) {
  const s = this.getOffsetParent || PM, t = this.getDimensions, r = await t(c.floating);
  return {
    reference: VY(c.reference, await s(c.floating), c.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function zY(c) {
  return cl(c).direction === "rtl";
}
const HY = {
  convertOffsetParentRelativeRectToViewportRelativeRect: $Y,
  getDocumentElement: od,
  getClippingRect: _Y,
  getOffsetParent: PM,
  getElementRects: UY,
  getClientRects: DY,
  getDimensions: NY,
  getScale: lg,
  isElement: ul,
  isRTL: zY
};
function FY(c, s) {
  let t = null, r;
  const f = od(c);
  function v() {
    var T;
    clearTimeout(r), (T = t) == null || T.disconnect(), t = null;
  }
  function g(T, x) {
    T === void 0 && (T = !1), x === void 0 && (x = 1), v();
    const {
      left: $,
      top: P,
      width: A,
      height: U
    } = c.getBoundingClientRect();
    if (T || s(), !A || !U)
      return;
    const F = Bb(P), Z = Bb(f.clientWidth - ($ + A)), ne = Bb(f.clientHeight - (P + U)), ce = Bb($), Ne = {
      rootMargin: -F + "px " + -Z + "px " + -ne + "px " + -ce + "px",
      threshold: jm(0, L9(1, x)) || 1
    };
    let Se = !0;
    function je(Me) {
      const Ct = Me[0].intersectionRatio;
      if (Ct !== x) {
        if (!Se)
          return g();
        Ct ? g(!1, Ct) : r = setTimeout(() => {
          g(!1, 1e-7);
        }, 1e3);
      }
      Se = !1;
    }
    try {
      t = new IntersectionObserver(je, {
        ...Ne,
        // Handle <iframe>s
        root: f.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(je, Ne);
    }
    t.observe(c);
  }
  return g(!0), v;
}
function IY(c, s, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: f = !0,
    ancestorResize: v = !0,
    elementResize: g = typeof ResizeObserver == "function",
    layoutShift: T = typeof IntersectionObserver == "function",
    animationFrame: x = !1
  } = r, $ = Nk(c), P = f || v ? [...$ ? T2($) : [], ...T2(s)] : [];
  P.forEach((De) => {
    f && De.addEventListener("scroll", t, {
      passive: !0
    }), v && De.addEventListener("resize", t);
  });
  const A = $ && T ? FY($, t) : null;
  let U = -1, F = null;
  g && (F = new ResizeObserver((De) => {
    let [Ne] = De;
    Ne && Ne.target === $ && F && (F.unobserve(s), cancelAnimationFrame(U), U = requestAnimationFrame(() => {
      var Se;
      (Se = F) == null || Se.observe(s);
    })), t();
  }), $ && !x && F.observe($), F.observe(s));
  let Z, ne = x ? Ym(c) : null;
  x && ce();
  function ce() {
    const De = Ym(c);
    ne && (De.x !== ne.x || De.y !== ne.y || De.width !== ne.width || De.height !== ne.height) && t(), ne = De, Z = requestAnimationFrame(ce);
  }
  return t(), () => {
    var De;
    P.forEach((Ne) => {
      f && Ne.removeEventListener("scroll", t), v && Ne.removeEventListener("resize", t);
    }), A == null || A(), (De = F) == null || De.disconnect(), F = null, x && cancelAnimationFrame(Z);
  };
}
const BY = EY, qY = TY, jY = (c, s, t) => {
  const r = /* @__PURE__ */ new Map(), f = {
    platform: HY,
    ...t
  }, v = {
    ...f.platform,
    _c: r
  };
  return wY(c, s, {
    ...f,
    platform: v
  });
};
function M7(c) {
  return !qe(c) && "width" in c && "height" in c && ar(c.width) && ar(c.height);
}
const Oe = typeof document > "u", GY = Oe ? "" : (navigator == null ? void 0 : navigator.userAgent.toLowerCase()) || "", mw = !Oe && /iphone|ipad|ipod|ios|crios|fxios/i.test(GY), OM = !Oe && /(iphone|ipod)/gi.test((navigator == null ? void 0 : navigator.platform) || ""), vw = !Oe && !!window.chrome, A9 = !Oe && (!!window.safari || mw);
function _M() {
  return QY() && Ma(screen.orientation.unlock);
}
function QY() {
  return !Oe && !Di(window.screen.orientation) && !Di(window.screen.orientation.lock);
}
function NM(c, s) {
  return Oe ? !1 : (c || (c = document.createElement("audio")), c.canPlayType(s).length > 0);
}
function VM(c, s) {
  return Oe ? !1 : (c || (c = document.createElement("video")), c.canPlayType(s).length > 0);
}
function UM(c) {
  return Oe ? !1 : (c || (c = document.createElement("video")), c.canPlayType("application/vnd.apple.mpegurl").length > 0);
}
function zM(c) {
  return Oe ? !1 : !!document.pictureInPictureEnabled && !(c != null && c.disablePictureInPicture);
}
function HM(c) {
  return Oe ? !1 : Ma(c == null ? void 0 : c.webkitSupportsPresentationMode) && Ma(c == null ? void 0 : c.webkitSetPresentationMode);
}
async function YY() {
  const c = document.createElement("video");
  return c.volume = 0.5, await gM(0), c.volume === 0.5;
}
function WY() {
  return Oe ? void 0 : (window == null ? void 0 : window.ManagedMediaSource) ?? (window == null ? void 0 : window.MediaSource) ?? (window == null ? void 0 : window.WebKitMediaSource);
}
function KY() {
  return Oe ? void 0 : (window == null ? void 0 : window.SourceBuffer) ?? (window == null ? void 0 : window.WebKitSourceBuffer);
}
function yw() {
  if (Oe) return !1;
  const c = WY();
  if (Di(c)) return !1;
  const s = c && Ma(c.isTypeSupported) && c.isTypeSupported('video/mp4; codecs="avc1.42E01E,mp4a.40.2"'), t = KY(), r = Di(t) || !Di(t.prototype) && Ma(t.prototype.appendBuffer) && Ma(t.prototype.remove);
  return !!s && !!r;
}
function FM() {
  return yw();
}
var Ec;
class Ui {
  constructor(s, t) {
    k(this, Ec);
    vr(s) ? L(this, Ec, s) : !Di(s) && !Di(t) ? L(this, Ec, [[s, t]]) : L(this, Ec, []);
  }
  get length() {
    return l(this, Ec).length;
  }
  start(s) {
    return l(this, Ec)[s][0] ?? 1 / 0;
  }
  end(s) {
    return l(this, Ec)[s][1] ?? 1 / 0;
  }
}
Ec = new WeakMap();
function uD(c) {
  if (!c.length) return null;
  let s = c.start(0);
  for (let t = 1; t < c.length; t++) {
    const r = c.start(t);
    r < s && (s = r);
  }
  return s;
}
function Gp(c) {
  if (!c.length) return null;
  let s = c.end(0);
  for (let t = 1; t < c.length; t++) {
    const r = c.end(t);
    r > s && (s = r);
  }
  return s;
}
function ZY(c) {
  if (c.length <= 1)
    return c;
  c.sort((r, f) => r[0] - f[0]);
  let s = [], t = c[0];
  for (let r = 1; r < c.length; r++) {
    const f = c[r];
    t[1] >= f[0] - 1 ? t = [t[0], Math.max(t[1], f[1])] : (s.push(t), t = f);
  }
  return s.push(t), s;
}
function XY(c, s, t) {
  let r = s[0], f = s[1];
  return t < r ? [t, -1] : t === r ? s : r === -1 ? (s[0] = t, s) : (t > r && (s[1] = t, f === -1 && c.push(s)), ZY(c), s);
}
const JY = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx|flac)($|\?)/i, eW = /* @__PURE__ */ new Set([
  "audio/mpeg",
  "audio/ogg",
  "audio/3gp",
  "audio/mp3",
  "audio/webm",
  "audio/flac",
  "audio/m4a",
  "audio/m4b",
  "audio/mp4a",
  "audio/mp4"
]), tW = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, nW = /* @__PURE__ */ new Set([
  "video/mp4",
  "video/webm",
  "video/3gp",
  "video/ogg",
  "video/avi",
  "video/mpeg"
]), iW = /\.(m3u8)($|\?)/i, rW = /\.(mpd)($|\?)/i, aW = /* @__PURE__ */ new Set([
  // Apple sanctioned
  "application/vnd.apple.mpegurl",
  // Apple sanctioned for backwards compatibility
  "audio/mpegurl",
  // Very common
  "audio/x-mpegurl",
  // Very common
  "application/x-mpegurl",
  // Included for completeness
  "video/x-mpegurl",
  "video/mpegurl",
  "application/mpegurl"
]), sW = /* @__PURE__ */ new Set(["application/dash+xml"]);
function IM({ src: c, type: s }) {
  return qe(c) ? JY.test(c) || eW.has(s) || c.startsWith("blob:") && s === "audio/object" : s === "audio/object";
}
function BM(c) {
  return qe(c.src) ? tW.test(c.src) || nW.has(c.type) || c.src.startsWith("blob:") && c.type === "video/object" || _1(c) && (Oe || UM()) : c.type === "video/object";
}
function _1({ src: c, type: s }) {
  return qe(c) && iW.test(c) || aW.has(s);
}
function Vk({ src: c, type: s }) {
  return qe(c) && rW.test(c) || sW.has(s);
}
function qM(c) {
  return qe(c.src) && (IM(c) || BM(c) || _1(c));
}
function oW(c) {
  return !Oe && typeof window.MediaStream < "u" && c instanceof window.MediaStream;
}
function lW(c, s) {
  const t = new URL(c);
  for (const r of Object.keys(s))
    t.searchParams.set(r, s[r] + "");
  return t.toString();
}
function ld(c, s = "preconnect") {
  if (Oe) return !1;
  const t = document.querySelector(`link[href="${c}"]`);
  if (!sl(t)) return !0;
  const r = document.createElement("link");
  return r.rel = s, r.href = c, r.crossOrigin = "true", document.head.append(r), !0;
}
const o2 = {};
function Uk(c) {
  if (o2[c]) return o2[c].promise;
  const s = Qm(), t = document.querySelector(`script[src="${c}"]`);
  if (!sl(t))
    return s.resolve(), s.promise;
  o2[c] = s;
  const r = document.createElement("script");
  return r.src = c, r.onload = () => {
    s.resolve(), delete o2[c];
  }, r.onerror = () => {
    s.reject(), delete o2[c];
  }, setTimeout(() => document.head.append(r), 0), s.promise;
}
function g2(c) {
  return c === "use-credentials" ? "include" : qe(c) ? "same-origin" : void 0;
}
const uW = Symbol(0), cW = Symbol(0), dW = Symbol(0), fW = Symbol(0), hW = Symbol(0), pW = Symbol(0), mW = Symbol(0), ht = {
  crossOrigin: uW,
  readyState: cW,
  updateActiveCues: dW,
  canLoad: fW,
  onModeChange: hW,
  native: pW,
  nativeHLS: mW
};
function cD(c, s) {
  return s >= c.startTime && s < c.endTime;
}
function zk(c, s, t) {
  let r = null, f = A0();
  function v() {
    const g = qe(s) ? [s] : s, T = c.toArray().find((x) => g.includes(x.kind) && x.mode === "showing");
    if (T !== r) {
      if (!T) {
        t(null), r = null;
        return;
      }
      T.readyState == 2 ? t(T) : (t(null), la(() => {
        const x = sn(
          T,
          "load",
          () => {
            t(T), x();
          },
          { once: !0 }
        );
      }, f)), r = T;
    }
  }
  return v(), sn(c, "mode-change", v);
}
var HD, FD, ID, BD, E2, kc, Wp, k2, Kp, _r, xc, $i, jM, A7, u2, P7, O7, _7;
class Jc extends Rk {
  constructor(t) {
    super();
    k(this, $i);
    I(this, "src");
    I(this, "content");
    I(this, "type");
    I(this, "encoding");
    I(this, "id", "");
    I(this, "label", "");
    I(this, "language", "");
    I(this, "kind");
    I(this, "default", !1);
    k(this, E2, !1);
    k(this, kc, 0);
    k(this, Wp, "disabled");
    k(this, k2, {});
    k(this, Kp, []);
    k(this, _r, []);
    k(this, xc, []);
    /** @internal */
    I(this, BD, 0);
    /** @internal */
    I(this, ID);
    /** @internal */
    I(this, FD, null);
    /** @internal */
    I(this, HD, null);
    for (const r of Object.keys(t)) this[r] = t[r];
    this.type || (this.type = "vtt"), !Oe && t.content ? m(this, $i, jM).call(this, t) : t.src || (this[ht.readyState] = 2);
  }
  static createId(t) {
    return `vds-${t.type}-${t.kind}-${t.src ?? t.label ?? "?"}`;
  }
  get metadata() {
    return l(this, k2);
  }
  get regions() {
    return l(this, Kp);
  }
  get cues() {
    return l(this, _r);
  }
  get activeCues() {
    return l(this, xc);
  }
  /**
   * - 0: Not Loading
   * - 1: Loading
   * - 2: Ready
   * - 3: Error
   */
  get readyState() {
    return this[ht.readyState];
  }
  get mode() {
    return l(this, Wp);
  }
  set mode(t) {
    this.setMode(t);
  }
  addCue(t, r) {
    var g;
    let f = 0, v = l(this, _r).length;
    for (f = 0; f < v && !(t.endTime <= l(this, _r)[f].startTime); f++) ;
    f === v ? l(this, _r).push(t) : l(this, _r).splice(f, 0, t), t instanceof TextTrackCue || (g = this[ht.native]) == null || g.track.addCue(t), this.dispatchEvent(new St("add-cue", { detail: t, trigger: r })), cD(t, l(this, kc)) && this[ht.updateActiveCues](l(this, kc), r);
  }
  removeCue(t, r) {
    var v;
    const f = l(this, _r).indexOf(t);
    if (f >= 0) {
      const g = l(this, xc).includes(t);
      l(this, _r).splice(f, 1), (v = this[ht.native]) == null || v.track.removeCue(t), this.dispatchEvent(new St("remove-cue", { detail: t, trigger: r })), g && this[ht.updateActiveCues](l(this, kc), r);
    }
  }
  setMode(t, r) {
    var f;
    l(this, Wp) !== t && (L(this, Wp, t), t === "disabled" ? (L(this, xc, []), m(this, $i, _7).call(this)) : this.readyState === 2 ? this[ht.updateActiveCues](l(this, kc), r) : m(this, $i, A7).call(this), this.dispatchEvent(new St("mode-change", { detail: this, trigger: r })), (f = this[ht.onModeChange]) == null || f.call(this));
  }
  /** @internal */
  [(BD = ht.readyState, ID = ht.crossOrigin, FD = ht.onModeChange, HD = ht.native, ht.updateActiveCues)](t, r) {
    if (L(this, kc, t), this.mode === "disabled" || !l(this, _r).length) return;
    const f = [];
    for (let g = 0, T = l(this, _r).length; g < T; g++) {
      const x = l(this, _r)[g];
      cD(x, t) && f.push(x);
    }
    let v = f.length !== l(this, xc).length;
    if (!v) {
      for (let g = 0; g < f.length; g++)
        if (!l(this, xc).includes(f[g])) {
          v = !0;
          break;
        }
    }
    L(this, xc, f), v && m(this, $i, _7).call(this, r);
  }
  /** @internal */
  [ht.canLoad]() {
    L(this, E2, !0), l(this, Wp) !== "disabled" && m(this, $i, A7).call(this);
  }
}
E2 = new WeakMap(), kc = new WeakMap(), Wp = new WeakMap(), k2 = new WeakMap(), Kp = new WeakMap(), _r = new WeakMap(), xc = new WeakMap(), $i = new WeakSet(), jM = function(t) {
  import("./prod-DTLJXtPo.js").then((r) => r.d).then(({ parseText: r, VTTCue: f, VTTRegion: v }) => {
    !qe(t.content) || t.type === "json" ? (m(this, $i, O7).call(this, t.content, f, v), this.readyState !== 3 && m(this, $i, u2).call(this)) : r(t.content, { type: t.type }).then(({ cues: g, regions: T }) => {
      L(this, _r, g), L(this, Kp, T), m(this, $i, u2).call(this);
    });
  });
}, A7 = async function() {
  var t, r;
  if (!(!l(this, E2) || this[ht.readyState] > 0)) {
    if (this[ht.readyState] = 1, this.dispatchEvent(new St("load-start")), !this.src) {
      m(this, $i, u2).call(this);
      return;
    }
    try {
      const { parseResponse: f, VTTCue: v, VTTRegion: g } = await import("./prod-DTLJXtPo.js").then(($) => $.d), T = (t = this[ht.crossOrigin]) == null ? void 0 : t.call(this), x = fetch(this.src, {
        headers: this.type === "json" ? { "Content-Type": "application/json" } : void 0,
        credentials: g2(T)
      });
      if (this.type === "json")
        m(this, $i, O7).call(this, await (await x).text(), v, g);
      else {
        const { errors: $, metadata: P, regions: A, cues: U } = await f(x, {
          type: this.type,
          encoding: this.encoding
        });
        if (((r = $[0]) == null ? void 0 : r.code) === 0)
          throw $[0];
        L(this, k2, P), L(this, Kp, A), L(this, _r, U);
      }
      m(this, $i, u2).call(this);
    } catch (f) {
      m(this, $i, P7).call(this, f);
    }
  }
}, u2 = function() {
  if (this[ht.readyState] = 2, !this.src || this.type !== "vtt") {
    const r = this[ht.native];
    if (r && !r.managed)
      for (const f of l(this, _r)) r.track.addCue(f);
  }
  const t = new St("load");
  this[ht.updateActiveCues](l(this, kc), t), this.dispatchEvent(t);
}, P7 = function(t) {
  this[ht.readyState] = 3, this.dispatchEvent(new St("error", { detail: t }));
}, O7 = function(t, r, f) {
  try {
    const { regions: v, cues: g } = yW(t, r, f);
    L(this, Kp, v), L(this, _r, g);
  } catch (v) {
    m(this, $i, P7).call(this, v);
  }
}, _7 = function(t) {
  this.dispatchEvent(new St("cue-change", { trigger: t }));
};
const vW = /captions|subtitles/;
function os(c) {
  return vW.test(c.kind);
}
function yW(c, s, t) {
  const r = qe(c) ? JSON.parse(c) : c;
  let f = [], v = [];
  return r.regions && t && (f = r.regions.map((g) => Object.assign(new t(), g))), (r.cues || vr(r)) && (v = (vr(r) ? r : r.cues).filter((g) => ar(g.startTime) && ar(g.endTime)).map((g) => Object.assign(new s(0, 0, ""), g))), { regions: f, cues: v };
}
const N1 = new sd({
  artist: "",
  artwork: null,
  audioTrack: null,
  audioTracks: [],
  autoPlay: !1,
  autoPlayError: null,
  audioGain: null,
  buffered: new Ui(),
  canLoad: !1,
  canLoadPoster: !1,
  canFullscreen: !1,
  canOrientScreen: _M(),
  canPictureInPicture: !1,
  canPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  get iOSControls() {
    return OM && this.mediaType === "video" && (!this.playsInline || !rh.fullscreenEnabled && this.fullscreen);
  },
  get nativeControls() {
    return this.controls || this.iOSControls;
  },
  controlsVisible: !1,
  get controlsHidden() {
    return !this.controlsVisible;
  },
  crossOrigin: null,
  ended: !1,
  error: null,
  fullscreen: !1,
  get loop() {
    return this.providedLoop || this.userPrefersLoop;
  },
  logLevel: "silent",
  mediaType: "unknown",
  muted: !1,
  paused: !0,
  played: new Ui(),
  playing: !1,
  playsInline: !1,
  pictureInPicture: !1,
  preload: "metadata",
  playbackRate: 1,
  qualities: [],
  quality: null,
  autoQuality: !1,
  canSetQuality: !0,
  canSetPlaybackRate: !0,
  canSetVolume: !1,
  canSetAudioGain: !1,
  seekable: new Ui(),
  seeking: !1,
  source: { src: "", type: "" },
  sources: [],
  started: !1,
  textTracks: [],
  textTrack: null,
  get hasCaptions() {
    return this.textTracks.filter(os).length > 0;
  },
  volume: 1,
  waiting: !1,
  realCurrentTime: 0,
  get currentTime() {
    return this.ended ? this.duration : this.clipStartTime > 0 ? Math.max(0, Math.min(this.realCurrentTime - this.clipStartTime, this.duration)) : this.realCurrentTime;
  },
  providedDuration: -1,
  intrinsicDuration: 0,
  get duration() {
    return this.seekableWindow;
  },
  get title() {
    return this.providedTitle || this.inferredTitle;
  },
  get poster() {
    return this.providedPoster || this.inferredPoster;
  },
  get viewType() {
    return this.providedViewType !== "unknown" ? this.providedViewType : this.inferredViewType;
  },
  get streamType() {
    return this.providedStreamType !== "unknown" ? this.providedStreamType : this.inferredStreamType;
  },
  get currentSrc() {
    return this.source;
  },
  get bufferedStart() {
    const c = uD(this.buffered) ?? 0;
    return Math.max(c, this.clipStartTime);
  },
  get bufferedEnd() {
    const c = Gp(this.buffered) ?? 0;
    return Math.min(this.seekableEnd, Math.max(0, c - this.clipStartTime));
  },
  get bufferedWindow() {
    return Math.max(0, this.bufferedEnd - this.bufferedStart);
  },
  get seekableStart() {
    if (this.isLiveDVR && this.liveDVRWindow > 0)
      return Math.max(0, this.seekableEnd - this.liveDVRWindow);
    const c = uD(this.seekable) ?? 0;
    return Math.max(c, this.clipStartTime);
  },
  get seekableEnd() {
    if (this.providedDuration > 0) return this.providedDuration;
    const c = this.liveSyncPosition > 0 ? this.liveSyncPosition : this.canPlay ? Gp(this.seekable) ?? 1 / 0 : 0;
    return this.clipEndTime > 0 ? Math.min(this.clipEndTime, c) : c;
  },
  get seekableWindow() {
    const c = this.seekableEnd - this.seekableStart;
    return isNaN(c) ? 1 / 0 : Math.max(0, c);
  },
  // ~~ remote playback ~~
  canAirPlay: !1,
  canGoogleCast: !1,
  remotePlaybackState: "disconnected",
  remotePlaybackType: "none",
  remotePlaybackLoader: null,
  remotePlaybackInfo: null,
  get isAirPlayConnected() {
    return this.remotePlaybackType === "airplay" && this.remotePlaybackState === "connected";
  },
  get isGoogleCastConnected() {
    return this.remotePlaybackType === "google-cast" && this.remotePlaybackState === "connected";
  },
  // ~~ responsive design ~~
  pointer: "fine",
  orientation: "landscape",
  width: 0,
  height: 0,
  mediaWidth: 0,
  mediaHeight: 0,
  lastKeyboardAction: null,
  // ~~ user props ~~
  userBehindLiveEdge: !1,
  // ~~ live props ~~
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  get canSeek() {
    return /unknown|on-demand|:dvr/.test(this.streamType) && Number.isFinite(this.duration) && (!this.isLiveDVR || this.duration >= this.liveDVRWindow);
  },
  get live() {
    return this.streamType.includes("live") || !Number.isFinite(this.duration);
  },
  get liveEdgeStart() {
    return this.live && Number.isFinite(this.seekableEnd) ? Math.max(0, this.seekableEnd - this.liveEdgeTolerance) : 0;
  },
  get liveEdge() {
    return this.live && (!this.canSeek || !this.userBehindLiveEdge && this.currentTime >= this.liveEdgeStart);
  },
  get liveEdgeWindow() {
    return this.live && Number.isFinite(this.seekableEnd) ? this.seekableEnd - this.liveEdgeStart : 0;
  },
  get isLiveDVR() {
    return /:dvr/.test(this.streamType);
  },
  get liveDVRWindow() {
    return Math.max(this.inferredLiveDVRWindow, this.minLiveDVRWindow);
  },
  // ~~ internal props ~~
  autoPlaying: !1,
  providedTitle: "",
  inferredTitle: "",
  providedLoop: !1,
  userPrefersLoop: !1,
  providedPoster: "",
  inferredPoster: "",
  inferredViewType: "unknown",
  providedViewType: "unknown",
  providedStreamType: "unknown",
  inferredStreamType: "unknown",
  liveSyncPosition: null,
  inferredLiveDVRWindow: 0,
  savedState: null
}), GM = /* @__PURE__ */ new Set([
  "autoPlayError",
  "autoPlaying",
  "buffered",
  "canPlay",
  "error",
  "paused",
  "played",
  "playing",
  "seekable",
  "seeking",
  "waiting"
]), gW = /* @__PURE__ */ new Set([
  ...GM,
  "ended",
  "inferredPoster",
  "inferredStreamType",
  "inferredTitle",
  "intrinsicDuration",
  "inferredLiveDVRWindow",
  "liveSyncPosition",
  "realCurrentTime",
  "savedState",
  "started",
  "userBehindLiveEdge"
]);
function dD(c, s = !1) {
  const t = s ? GM : gW;
  N1.reset(c, (r) => t.has(r)), al();
}
function QM(c, s) {
  const t = c + s.clipStartTime(), r = Math.floor(c) === Math.floor(s.seekableStart()), f = Math.floor(t) === Math.floor(s.seekableEnd());
  return r ? s.seekableStart() : f ? s.seekableEnd() : s.isLiveDVR() && s.liveDVRWindow() > 0 && t < s.seekableEnd() - s.liveDVRWindow() ? s.bufferedStart() : Math.min(Math.max(s.seekableStart() + 0.1, t), s.seekableEnd() - 0.1);
}
const Hk = ad();
function bn() {
  return gi(Hk);
}
var Zp, ks, mg, H9, rn, gn, CW;
class YM {
  constructor(s = void 0) {
    k(this, rn);
    k(this, Zp, null);
    k(this, ks, null);
    k(this, mg, -1);
    k(this, H9);
    L(this, H9, s);
  }
  /**
   * Set the target from which to dispatch media requests events from. The events should bubble
   * up from this target to the player element.
   *
   * @example
   * ```ts
   * const button = document.querySelector('button');
   * remote.setTarget(button);
   * ```
   */
  setTarget(s) {
    L(this, Zp, s);
  }
  /**
   * Returns the current player element. This method will attempt to find the player by
   * searching up from either the given `target` or default target set via `remote.setTarget`.
   *
   * @example
   * ```ts
   * const player = remote.getPlayer();
   * ```
   */
  getPlayer(s) {
    var t;
    return l(this, ks) ? l(this, ks) : ((t = s ?? l(this, Zp)) == null || t.dispatchEvent(
      new St("find-media-player", {
        detail: (r) => void L(this, ks, r),
        bubbles: !0,
        composed: !0
      })
    ), l(this, ks));
  }
  /**
   * Set the current player element so the remote can support toggle methods such as
   * `togglePaused` as they rely on the current media state.
   */
  setPlayer(s) {
    L(this, ks, s);
  }
  /**
   * Dispatch a request to start the media loading process. This will only work if the media
   * player has been initialized with a custom loading strategy `load="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoading(s) {
    m(this, rn, gn).call(this, "media-start-loading", s);
  }
  /**
   * Dispatch a request to start the poster loading process. This will only work if the media
   * player has been initialized with a custom poster loading strategy `posterLoad="custom">`.
   *
   * @docs {@link https://www.vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoadingPoster(s) {
    m(this, rn, gn).call(this, "media-poster-start-loading", s);
  }
  /**
   * Dispatch a request to connect to AirPlay.
   *
   * @see {@link https://www.apple.com/au/airplay}
   */
  requestAirPlay(s) {
    m(this, rn, gn).call(this, "media-airplay-request", s);
  }
  /**
   * Dispatch a request to connect to Google Cast.
   *
   * @see {@link https://developers.google.com/cast/docs/overview}
   */
  requestGoogleCast(s) {
    m(this, rn, gn).call(this, "media-google-cast-request", s);
  }
  /**
   * Dispatch a request to begin/resume media playback.
   */
  play(s) {
    m(this, rn, gn).call(this, "media-play-request", s);
  }
  /**
   * Dispatch a request to pause media playback.
   */
  pause(s) {
    m(this, rn, gn).call(this, "media-pause-request", s);
  }
  /**
   * Dispatch a request to set the media volume to mute (0).
   */
  mute(s) {
    m(this, rn, gn).call(this, "media-mute-request", s);
  }
  /**
   * Dispatch a request to unmute the media volume and set it back to it's previous state.
   */
  unmute(s) {
    m(this, rn, gn).call(this, "media-unmute-request", s);
  }
  /**
   * Dispatch a request to enter fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  enterFullscreen(s, t) {
    m(this, rn, gn).call(this, "media-enter-fullscreen-request", t, s);
  }
  /**
   * Dispatch a request to exit fullscreen.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  exitFullscreen(s, t) {
    m(this, rn, gn).call(this, "media-exit-fullscreen-request", t, s);
  }
  /**
   * Dispatch a request to lock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/screen-orientation#remote-control}
   */
  lockScreenOrientation(s, t) {
    m(this, rn, gn).call(this, "media-orientation-lock-request", t, s);
  }
  /**
   * Dispatch a request to unlock the screen orientation.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/screen-orientation#remote-control}
   */
  unlockScreenOrientation(s) {
    m(this, rn, gn).call(this, "media-orientation-unlock-request", s);
  }
  /**
   * Dispatch a request to enter picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  enterPictureInPicture(s) {
    m(this, rn, gn).call(this, "media-enter-pip-request", s);
  }
  /**
   * Dispatch a request to exit picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  exitPictureInPicture(s) {
    m(this, rn, gn).call(this, "media-exit-pip-request", s);
  }
  /**
   * Notify the media player that a seeking process is happening and to seek to the given `time`.
   */
  seeking(s, t) {
    m(this, rn, gn).call(this, "media-seeking-request", t, s);
  }
  /**
   * Notify the media player that a seeking operation has completed and to seek to the given `time`.
   * This is generally called after a series of `remote.seeking()` calls.
   */
  seek(s, t) {
    m(this, rn, gn).call(this, "media-seek-request", t, s);
  }
  seekToLiveEdge(s) {
    m(this, rn, gn).call(this, "media-live-edge-request", s);
  }
  /**
   * Dispatch a request to update the length of the media in seconds.
   *
   * @example
   * ```ts
   * remote.changeDuration(100); // 100 seconds
   * ```
   */
  changeDuration(s, t) {
    m(this, rn, gn).call(this, "media-duration-change-request", t, s);
  }
  /**
   * Dispatch a request to update the clip start time. This is the time at which media playback
   * should start at.
   *
   * @example
   * ```ts
   * remote.changeClipStart(100); // start at 100 seconds
   * ```
   */
  changeClipStart(s, t) {
    m(this, rn, gn).call(this, "media-clip-start-change-request", t, s);
  }
  /**
   * Dispatch a request to update the clip end time. This is the time at which media playback
   * should end at.
   *
   * @example
   * ```ts
   * remote.changeClipEnd(100); // end at 100 seconds
   * ```
   */
  changeClipEnd(s, t) {
    m(this, rn, gn).call(this, "media-clip-end-change-request", t, s);
  }
  /**
   * Dispatch a request to update the media volume to the given `volume` level which is a value
   * between 0 and 1.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/audio-gain#remote-control}
   * @example
   * ```ts
   * remote.changeVolume(0); // 0%
   * remote.changeVolume(0.05); // 5%
   * remote.changeVolume(0.5); // 50%
   * remote.changeVolume(0.75); // 70%
   * remote.changeVolume(1); // 100%
   * ```
   */
  changeVolume(s, t) {
    m(this, rn, gn).call(this, "media-volume-change-request", t, Math.max(0, Math.min(1, s)));
  }
  /**
   * Dispatch a request to change the current audio track.
   *
   * @example
   * ```ts
   * remote.changeAudioTrack(1); // track at index 1
   * ```
   */
  changeAudioTrack(s, t) {
    m(this, rn, gn).call(this, "media-audio-track-change-request", t, s);
  }
  /**
   * Dispatch a request to change the video quality. The special value `-1` represents auto quality
   * selection.
   *
   * @example
   * ```ts
   * remote.changeQuality(-1); // auto
   * remote.changeQuality(1); // quality at index 1
   * ```
   */
  changeQuality(s, t) {
    m(this, rn, gn).call(this, "media-quality-change-request", t, s);
  }
  /**
   * Request auto quality selection.
   */
  requestAutoQuality(s) {
    this.changeQuality(-1, s);
  }
  /**
   * Dispatch a request to change the mode of the text track at the given index.
   *
   * @example
   * ```ts
   * remote.changeTextTrackMode(1, 'showing'); // track at index 1
   * ```
   */
  changeTextTrackMode(s, t, r) {
    m(this, rn, gn).call(this, "media-text-track-change-request", r, {
      index: s,
      mode: t
    });
  }
  /**
   * Dispatch a request to change the media playback rate.
   *
   * @example
   * ```ts
   * remote.changePlaybackRate(0.5); // Half the normal speed
   * remote.changePlaybackRate(1); // Normal speed
   * remote.changePlaybackRate(1.5); // 50% faster than normal
   * remote.changePlaybackRate(2); // Double the normal speed
   * ```
   */
  changePlaybackRate(s, t) {
    m(this, rn, gn).call(this, "media-rate-change-request", t, s);
  }
  /**
   * Dispatch a request to change the media audio gain.
   *
   * @example
   * ```ts
   * remote.changeAudioGain(1); // Disable audio gain
   * remote.changeAudioGain(1.5); // 50% louder
   * remote.changeAudioGain(2); // 100% louder
   * ```
   */
  changeAudioGain(s, t) {
    m(this, rn, gn).call(this, "media-audio-gain-change-request", t, s);
  }
  /**
   * Dispatch a request to resume idle tracking on controls.
   */
  resumeControls(s) {
    m(this, rn, gn).call(this, "media-resume-controls-request", s);
  }
  /**
   * Dispatch a request to pause controls idle tracking. Pausing tracking will result in the
   * controls being visible until `remote.resumeControls()` is called. This method
   * is generally used when building custom controls and you'd like to prevent the UI from
   * disappearing.
   *
   * @example
   * ```ts
   * // Prevent controls hiding while menu is being interacted with.
   * function onSettingsOpen() {
   *   remote.pauseControls();
   * }
   *
   * function onSettingsClose() {
   *   remote.resumeControls();
   * }
   * ```
   */
  pauseControls(s) {
    m(this, rn, gn).call(this, "media-pause-controls-request", s);
  }
  /**
   * Dispatch a request to toggle the media playback state.
   */
  togglePaused(s) {
    const t = this.getPlayer(s == null ? void 0 : s.target);
    t && (t.state.paused ? this.play(s) : this.pause(s));
  }
  /**
   * Dispatch a request to toggle the controls visibility.
   */
  toggleControls(s) {
    const t = this.getPlayer(s == null ? void 0 : s.target);
    t && (t.controls.showing ? t.controls.hide(0, s) : t.controls.show(0, s));
  }
  /**
   * Dispatch a request to toggle the media muted state.
   */
  toggleMuted(s) {
    const t = this.getPlayer(s == null ? void 0 : s.target);
    t && (t.state.muted ? this.unmute(s) : this.mute(s));
  }
  /**
   * Dispatch a request to toggle the media fullscreen state.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/fullscreen#remote-control}
   */
  toggleFullscreen(s, t) {
    const r = this.getPlayer(t == null ? void 0 : t.target);
    r && (r.state.fullscreen ? this.exitFullscreen(s, t) : this.enterFullscreen(s, t));
  }
  /**
   * Dispatch a request to toggle the media picture-in-picture mode.
   *
   * @docs {@link https://www.vidstack.io/docs/player/api/picture-in-picture#remote-control}
   */
  togglePictureInPicture(s) {
    const t = this.getPlayer(s == null ? void 0 : s.target);
    t && (t.state.pictureInPicture ? this.exitPictureInPicture(s) : this.enterPictureInPicture(s));
  }
  /**
   * Show captions.
   */
  showCaptions(s) {
    const t = this.getPlayer(s == null ? void 0 : s.target);
    if (!t)
      return;
    let r = t.state.textTracks, f = l(this, mg);
    (!r[f] || !os(r[f])) && (f = -1), f === -1 && (f = r.findIndex((v) => os(v) && v.default)), f === -1 && (f = r.findIndex((v) => os(v))), f >= 0 && this.changeTextTrackMode(f, "showing", s), L(this, mg, -1);
  }
  /**
   * Turn captions off.
   */
  disableCaptions(s) {
    const t = this.getPlayer(s == null ? void 0 : s.target);
    if (!t)
      return;
    const r = t.state.textTracks, f = t.state.textTrack;
    if (f) {
      const v = r.indexOf(f);
      this.changeTextTrackMode(v, "disabled", s), L(this, mg, v);
    }
  }
  /**
   * Dispatch a request to toggle the current captions mode.
   */
  toggleCaptions(s) {
    const t = this.getPlayer(s == null ? void 0 : s.target);
    t && (t.state.textTrack ? this.disableCaptions() : this.showCaptions());
  }
  userPrefersLoopChange(s, t) {
    m(this, rn, gn).call(this, "media-user-loop-change-request", t, s);
  }
}
Zp = new WeakMap(), ks = new WeakMap(), mg = new WeakMap(), H9 = new WeakMap(), rn = new WeakSet(), gn = function(s, t, r) {
  var T, x;
  const f = new St(s, {
    bubbles: !0,
    composed: !0,
    cancelable: !0,
    detail: r,
    trigger: t
  });
  let v = (t == null ? void 0 : t.target) || null;
  v && v instanceof Et && (v = v.el), v = !v || v === document || v === window || v === document.body || ((T = l(this, ks)) == null ? void 0 : T.el) && v instanceof Node && !l(this, ks).el.contains(v) ? l(this, Zp) ?? ((x = this.getPlayer()) == null ? void 0 : x.el) : v ?? l(this, Zp), l(this, ks) ? s === "media-play-request" && !l(this, ks).state.canLoad ? v == null || v.dispatchEvent(f) : l(this, ks).canPlayQueue.enqueue(s, () => v == null ? void 0 : v.dispatchEvent(f)) : v == null || v.dispatchEvent(f);
}, CW = function(s) {
};
var yi;
class SW {
  constructor() {
    I(this, "playerId", "vds-player");
    I(this, "mediaId", null);
    k(this, yi, {
      volume: null,
      muted: null,
      audioGain: null,
      time: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null
    });
    I(this, "saveTimeThrottled", mh(this.saveTime.bind(this), 1e3));
  }
  async getVolume() {
    return l(this, yi).volume;
  }
  async setVolume(s) {
    l(this, yi).volume = s, this.save();
  }
  async getMuted() {
    return l(this, yi).muted;
  }
  async setMuted(s) {
    l(this, yi).muted = s, this.save();
  }
  async getTime() {
    return l(this, yi).time;
  }
  async setTime(s, t) {
    const r = s < 0;
    l(this, yi).time = r ? null : s, r || t ? this.saveTime() : this.saveTimeThrottled();
  }
  async getLang() {
    return l(this, yi).lang;
  }
  async setLang(s) {
    l(this, yi).lang = s, this.save();
  }
  async getCaptions() {
    return l(this, yi).captions;
  }
  async setCaptions(s) {
    l(this, yi).captions = s, this.save();
  }
  async getPlaybackRate() {
    return l(this, yi).rate;
  }
  async setPlaybackRate(s) {
    l(this, yi).rate = s, this.save();
  }
  async getAudioGain() {
    return l(this, yi).audioGain;
  }
  async setAudioGain(s) {
    l(this, yi).audioGain = s, this.save();
  }
  async getVideoQuality() {
    return l(this, yi).quality;
  }
  async setVideoQuality(s) {
    l(this, yi).quality = s, this.save();
  }
  onChange(s, t, r = "vds-player") {
    const f = r ? localStorage.getItem(r) : null, v = t ? localStorage.getItem(t) : null;
    this.playerId = r, this.mediaId = t, L(this, yi, {
      volume: null,
      muted: null,
      audioGain: null,
      lang: null,
      captions: null,
      rate: null,
      quality: null,
      ...f ? JSON.parse(f) : {},
      time: v ? +v : null
    });
  }
  save() {
    if (Oe || !this.playerId) return;
    const s = JSON.stringify({ ...l(this, yi), time: void 0 });
    localStorage.setItem(this.playerId, s);
  }
  saveTime() {
    if (Oe || !this.mediaId) return;
    const s = (l(this, yi).time ?? 0).toString();
    localStorage.setItem(this.mediaId, s);
  }
}
yi = new WeakMap();
const bW = Symbol(0), wW = Symbol(0), TW = Symbol(0), EW = Symbol(0), kW = Symbol(0), xW = Symbol(0), RW = Symbol(0), LW = Symbol(0), $W = Symbol(0), ut = {
  add: bW,
  remove: wW,
  reset: TW,
  select: EW,
  readonly: kW,
  setReadonly: xW,
  onReset: RW,
  onRemove: LW,
  onUserSelect: $W
};
var qD;
class WM extends Rk {
  constructor() {
    super(...arguments);
    I(this, "items", []);
    /** @internal */
    I(this, qD, !1);
  }
  get length() {
    return this.items.length;
  }
  get readonly() {
    return this[ut.readonly];
  }
  /**
   * Returns the index of the first occurrence of the given item, or -1 if it is not present.
   */
  indexOf(t) {
    return this.items.indexOf(t);
  }
  /**
   * Returns an item matching the given `id`, or `null` if not present.
   */
  getById(t) {
    return t === "" ? null : this.items.find((r) => r.id === t) ?? null;
  }
  /**
   * Transform list to an array.
   */
  toArray() {
    return [...this.items];
  }
  [(qD = ut.readonly, Symbol.iterator)]() {
    return this.items.values();
  }
  /** @internal */
  [ut.add](t, r) {
    const f = this.items.length;
    "" + f in this || Object.defineProperty(this, f, {
      get() {
        return this.items[f];
      }
    }), !this.items.includes(t) && (this.items.push(t), this.dispatchEvent(new St("add", { detail: t, trigger: r })));
  }
  /** @internal */
  [ut.remove](t, r) {
    var v;
    const f = this.items.indexOf(t);
    f >= 0 && ((v = this[ut.onRemove]) == null || v.call(this, t, r), this.items.splice(f, 1), this.dispatchEvent(new St("remove", { detail: t, trigger: r })));
  }
  /** @internal */
  [ut.reset](t) {
    var r;
    for (const f of [...this.items]) this[ut.remove](f, t);
    this.items = [], this[ut.setReadonly](!1, t), (r = this[ut.onReset]) == null || r.call(this);
  }
  /** @internal */
  [ut.setReadonly](t, r) {
    this[ut.readonly] !== t && (this[ut.readonly] = t, this.dispatchEvent(new St("readonly-change", { detail: t, trigger: r })));
  }
}
const l2 = Symbol(0);
class KM extends WM {
  get selected() {
    return this.items.find((s) => s.selected) ?? null;
  }
  get selectedIndex() {
    return this.items.findIndex((s) => s.selected);
  }
  /** @internal */
  [ut.onRemove](s, t) {
    this[ut.select](s, !1, t);
  }
  /** @internal */
  [ut.add](s, t) {
    s[l2] = !1, Object.defineProperty(s, "selected", {
      get() {
        return this[l2];
      },
      set: (r) => {
        var f;
        this.readonly || ((f = this[ut.onUserSelect]) == null || f.call(this), this[ut.select](s, r));
      }
    }), super[ut.add](s, t);
  }
  /** @internal */
  [ut.select](s, t, r) {
    if (t === (s == null ? void 0 : s[l2])) return;
    const f = this.selected;
    s && (s[l2] = t), (t ? f !== s : f === s) && (f && (f[l2] = !1), this.dispatchEvent(
      new St("change", {
        detail: {
          prev: f,
          current: this.selected
        },
        trigger: r
      })
    ));
  }
}
class DW extends KM {
}
function Hr(c, s = 2) {
  return Number(c.toFixed(s));
}
function N7(c) {
  var s;
  return ((s = String(c).split(".")[1]) == null ? void 0 : s.length) ?? 0;
}
function Fk(c, s, t) {
  return Math.max(c, Math.min(t, s));
}
function fD(c, s) {
  const t = s.composedPath()[0];
  return lM(t) && c.contains(t);
}
const V7 = /* @__PURE__ */ new Set();
if (!Oe) {
  let c = function() {
    for (const s of V7)
      try {
        s();
      } catch {
      }
    window.requestAnimationFrame(c);
  };
  c();
}
function MW(c) {
  return V7.add(c), () => V7.delete(c);
}
function hn(c, s, t) {
  c.hasAttribute(s) || c.setAttribute(s, t);
}
function vh(c, s) {
  if (c.hasAttribute("aria-label") || c.hasAttribute("data-no-label")) return;
  if (!Ma(s)) {
    lt(c, "aria-label", s);
    return;
  }
  function t() {
    lt(c, "aria-label", s());
  }
  Oe ? t() : K(t);
}
function ZM(c) {
  const s = getComputedStyle(c);
  return s.display !== "none" && parseInt(s.opacity) > 0;
}
function AW(c) {
  return !!c && ("checkVisibility" in c ? c.checkVisibility({ checkOpacity: !0, checkVisibilityCSS: !0 }) : ZM(c));
}
function XM(c, s) {
  return MW(() => s(AW(c)));
}
function JM(c, s, t) {
  for (; s; ) {
    if (s === c)
      return !0;
    if (t != null && t(s))
      break;
    s = s.parentElement;
  }
  return !1;
}
function uh(c, s) {
  return new Cn(c).add("pointerup", (t) => {
    t.button === 0 && !t.defaultPrevented && s(t);
  }).add("keydown", (t) => {
    Lk(t) && s(t);
  });
}
function Ik(c) {
  return v2(c) && (c.touches.length > 1 || c.changedTouches.length > 1);
}
function eA(c) {
  if (Oe) return c();
  let s = A0(), t = window.requestAnimationFrame(() => {
    la(c, s), t = -1;
  });
  return () => void window.cancelAnimationFrame(t);
}
function tA(c, s, t, {
  offsetVarName: r,
  xOffset: f,
  yOffset: v,
  ...g
}) {
  if (!c) return;
  const T = t.replace(" ", "-").replace("-center", "");
  if (Aa(c, "visibility", s ? null : "hidden"), !s) return;
  let x = t.includes("top");
  const $ = (A) => t.includes("left") ? `calc(-1 * ${A})` : A, P = (A) => x ? `calc(-1 * ${A})` : A;
  return IY(s, c, () => {
    jY(s, c, {
      placement: T,
      middleware: [
        ...g.middleware ?? [],
        qY({ fallbackAxisSideDirection: "start", crossAxis: !1 }),
        BY()
      ],
      ...g
    }).then(({ x: A, y: U, middlewareData: F }) => {
      var ne;
      const Z = !!((ne = F.flip) != null && ne.index);
      x = t.includes(Z ? "bottom" : "top"), c.setAttribute(
        "data-placement",
        Z ? t.startsWith("top") ? t.replace("top", "bottom") : t.replace("bottom", "top") : t
      ), Object.assign(c.style, {
        top: `calc(${U + "px"} + ${P(
          v ? v + "px" : `var(--${r}-y-offset, 0px)`
        )})`,
        left: `calc(${A + "px"} + ${$(
          f ? f + "px" : `var(--${r}-x-offset, 0px)`
        )})`
      });
    });
  });
}
function PW(c) {
  return getComputedStyle(c).animationName !== "none";
}
function P9(c) {
  return c instanceof HTMLElement;
}
var x2, Rc, R2, df, ho, nA, iA, U7, z7;
class OW {
  constructor() {
    k(this, ho);
    I(this, "priority", 0);
    k(this, x2, !0);
    k(this, Rc, null);
    k(this, R2, null);
    k(this, df, /* @__PURE__ */ new Set());
  }
  canRender(s, t) {
    return !!t;
  }
  attach(s) {
    L(this, Rc, s), s && (s.textTracks.onchange = m(this, ho, z7).bind(this));
  }
  addTrack(s) {
    l(this, df).add(s), m(this, ho, nA).call(this, s);
  }
  removeTrack(s) {
    var t, r;
    (r = (t = s[ht.native]) == null ? void 0 : t.remove) == null || r.call(t), s[ht.native] = null, l(this, df).delete(s);
  }
  changeTrack(s) {
    const t = s == null ? void 0 : s[ht.native];
    t && t.track.mode !== "showing" && (t.track.mode = "showing"), L(this, R2, s);
  }
  setDisplay(s) {
    L(this, x2, s), m(this, ho, z7).call(this);
  }
  detach() {
    l(this, Rc) && (l(this, Rc).textTracks.onchange = null);
    for (const s of l(this, df)) this.removeTrack(s);
    l(this, df).clear(), L(this, Rc, null), L(this, R2, null);
  }
}
x2 = new WeakMap(), Rc = new WeakMap(), R2 = new WeakMap(), df = new WeakMap(), ho = new WeakSet(), nA = function(s) {
  var r;
  if (!l(this, Rc)) return;
  const t = s[r = ht.native] ?? (s[r] = m(this, ho, iA).call(this, s));
  P9(t) && (l(this, Rc).append(t), t.track.mode = t.default ? "showing" : "disabled");
}, iA = function(s) {
  const t = document.createElement("track"), r = s.default || s.mode === "showing", f = s.src && s.type === "vtt";
  return t.id = s.id, t.src = f ? s.src : "", t.label = s.label, t.kind = s.kind, t.default = r, s.language && (t.srclang = s.language), r && !f && m(this, ho, U7).call(this, s, t.track), t;
}, U7 = function(s, t) {
  var r;
  if (!(s.src && s.type === "vtt" || (r = t.cues) != null && r.length))
    for (const f of s.cues) t.addCue(f);
}, z7 = function(s) {
  for (const t of l(this, df)) {
    const r = t[ht.native];
    if (!r) continue;
    if (!l(this, x2)) {
      r.track.mode = r.managed ? "hidden" : "disabled";
      continue;
    }
    const f = r.track.mode === "showing";
    f && m(this, ho, U7).call(this, t, r.track), t.setMode(f ? "showing" : "disabled", s);
  }
};
var Xp, vg, Jp, L2, $2, xs, Ql, Li, rA, H7, aA, sA, oA, rg, lA;
class _W {
  constructor(s) {
    k(this, Li);
    k(this, Xp, null);
    k(this, vg);
    k(this, Jp, []);
    k(this, L2);
    k(this, $2, !1);
    k(this, xs, null);
    k(this, Ql, null);
    L(this, L2, s);
    const t = s.textTracks;
    L(this, vg, t), K(m(this, Li, rA).bind(this)), bt(m(this, Li, lA).bind(this)), new Cn(t).add("add", m(this, Li, sA).bind(this)).add("remove", m(this, Li, oA).bind(this)).add("mode-change", m(this, Li, rg).bind(this));
  }
  add(s) {
    l(this, Jp).push(s), Gm(m(this, Li, rg).bind(this));
  }
  remove(s) {
    s.detach(), l(this, Jp).splice(l(this, Jp).indexOf(s), 1), Gm(m(this, Li, rg).bind(this));
  }
  /** @internal */
  attachVideo(s) {
    requestAnimationFrame(() => {
      if (L(this, Xp, s), s) {
        L(this, xs, new OW()), l(this, xs).attach(s);
        for (const t of l(this, vg)) m(this, Li, H7).call(this, t);
      }
      m(this, Li, rg).call(this);
    });
  }
}
Xp = new WeakMap(), vg = new WeakMap(), Jp = new WeakMap(), L2 = new WeakMap(), $2 = new WeakMap(), xs = new WeakMap(), Ql = new WeakMap(), Li = new WeakSet(), rA = function() {
  const { nativeControls: s } = l(this, L2).$state;
  L(this, $2, s()), m(this, Li, rg).call(this);
}, H7 = function(s) {
  var t;
  os(s) && ((t = l(this, xs)) == null || t.addTrack(s));
}, aA = function(s) {
  var t;
  os(s) && ((t = l(this, xs)) == null || t.removeTrack(s));
}, sA = function(s) {
  m(this, Li, H7).call(this, s.detail);
}, oA = function(s) {
  m(this, Li, aA).call(this, s.detail);
}, rg = function() {
  var r, f, v, g, T, x, $;
  const s = l(this, vg).selected;
  if (l(this, Xp) && (l(this, $2) || s != null && s[ht.nativeHLS])) {
    (r = l(this, Ql)) == null || r.changeTrack(null), (f = l(this, xs)) == null || f.setDisplay(!0), (v = l(this, xs)) == null || v.changeTrack(s);
    return;
  }
  if ((g = l(this, xs)) == null || g.setDisplay(!1), (T = l(this, xs)) == null || T.changeTrack(null), !s) {
    (x = l(this, Ql)) == null || x.changeTrack(null);
    return;
  }
  const t = l(this, Jp).sort((P, A) => P.priority - A.priority).find((P) => P.canRender(s, l(this, Xp)));
  l(this, Ql) !== t && (($ = l(this, Ql)) == null || $.detach(), t == null || t.attach(l(this, Xp)), L(this, Ql, t ?? null)), t == null || t.changeTrack(s);
}, lA = function() {
  var s, t;
  (s = l(this, xs)) == null || s.detach(), L(this, xs, null), (t = l(this, Ql)) == null || t.detach(), L(this, Ql, null);
};
var jD, em, Yl, Wl, Kl, D2, yg, M2, mu, uA, F7, I7;
class NW extends WM {
  constructor() {
    super();
    k(this, mu);
    k(this, em, !1);
    k(this, Yl, {});
    k(this, Wl, null);
    k(this, Kl, null);
    /** @internal */
    I(this, jD);
    k(this, D2, dw(async () => {
      var f;
      if (!l(this, em)) return;
      !l(this, Kl) && l(this, Wl) && L(this, Kl, await l(this, Wl).getLang());
      const t = await ((f = l(this, Wl)) == null ? void 0 : f.getCaptions()), r = [
        ["captions", "subtitles"],
        "chapters",
        "descriptions",
        "metadata"
      ];
      for (const v of r) {
        const g = this.getByKind(v);
        if (g.find((A) => A.mode === "showing")) continue;
        const T = l(this, Kl) ? g.find((A) => A.language === l(this, Kl)) : null, x = vr(v) ? l(this, Yl)[v.find((A) => l(this, Yl)[A]) || ""] : l(this, Yl)[v], $ = T ?? x, P = $ && os($);
        $ && (!P || t !== !1) && ($.mode = "showing", P && m(this, mu, F7).call(this, $));
      }
    }, 300));
    k(this, yg, null);
    k(this, M2, m(this, mu, uA).bind(this));
  }
  get selected() {
    return this.items.find((r) => r.mode === "showing" && os(r)) ?? null;
  }
  get selectedIndex() {
    const t = this.selected;
    return t ? this.indexOf(t) : -1;
  }
  get preferredLang() {
    return l(this, Kl);
  }
  set preferredLang(t) {
    L(this, Kl, t), m(this, mu, I7).call(this, t);
  }
  add(t, r) {
    const f = t instanceof Jc, v = f ? t : new Jc(t), g = t.kind === "captions" || t.kind === "subtitles" ? "captions" : t.kind;
    return l(this, Yl)[g] && t.default && delete t.default, v.addEventListener("mode-change", l(this, M2)), this[ut.add](v, r), v[ht.crossOrigin] = this[ht.crossOrigin], l(this, em) && v[ht.canLoad](), t.default && (l(this, Yl)[g] = v), l(this, D2).call(this), this;
  }
  remove(t, r) {
    if (L(this, yg, t), !!this.items.includes(t))
      return t === l(this, Yl)[t.kind] && delete l(this, Yl)[t.kind], t.mode = "disabled", t[ht.onModeChange] = null, t.removeEventListener("mode-change", l(this, M2)), this[ut.remove](t, r), L(this, yg, null), this;
  }
  clear(t) {
    for (const r of [...this.items])
      this.remove(r, t);
    return this;
  }
  getByKind(t) {
    const r = Array.isArray(t) ? t : [t];
    return this.items.filter((f) => r.includes(f.kind));
  }
  /** @internal */
  [(jD = ht.crossOrigin, ht.canLoad)]() {
    if (!l(this, em)) {
      for (const t of this.items) t[ht.canLoad]();
      L(this, em, !0), l(this, D2).call(this);
    }
  }
  setStorage(t) {
    L(this, Wl, t);
  }
}
em = new WeakMap(), Yl = new WeakMap(), Wl = new WeakMap(), Kl = new WeakMap(), D2 = new WeakMap(), yg = new WeakMap(), M2 = new WeakMap(), mu = new WeakSet(), uA = function(t) {
  const r = t.detail;
  if (l(this, Wl) && os(r) && r !== l(this, yg) && m(this, mu, F7).call(this, r), r.mode === "showing") {
    const f = os(r) ? ["captions", "subtitles"] : [r.kind];
    for (const v of this.items)
      v.mode === "showing" && v != r && f.includes(v.kind) && (v.mode = "disabled");
  }
  this.dispatchEvent(
    new St("mode-change", {
      detail: t.detail,
      trigger: t
    })
  );
}, F7 = function(t) {
  var r, f;
  t.mode !== "disabled" && m(this, mu, I7).call(this, t.language), (f = (r = l(this, Wl)) == null ? void 0 : r.setCaptions) == null || f.call(r, t.mode === "showing");
}, I7 = function(t) {
  var r, f;
  (f = (r = l(this, Wl)) == null ? void 0 : r.setLang) == null || f.call(r, L(this, Kl, t));
};
const VW = Symbol(0), UW = Symbol(0), zr = {
  setAuto: VW,
  enableAuto: UW
};
var GD, tm;
class zW extends KM {
  constructor() {
    super(...arguments);
    k(this, tm, !1);
    /**
     * Configures quality switching:
     *
     * - `current`: Trigger an immediate quality level switch. This will abort the current fragment
     * request if any, flush the whole buffer, and fetch fragment matching with current position
     * and requested quality level.
     *
     * - `next`: Trigger a quality level switch for next fragment. This could eventually flush
     * already buffered next fragment.
     *
     * - `load`: Set quality level for next loaded fragment.
     *
     * @see {@link https://www.vidstack.io/docs/player/api/video-quality#switch}
     * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#quality-switch-control-api}
     */
    I(this, "switch", "current");
    /** @internal */
    I(this, GD);
  }
  /**
   * Whether automatic quality selection is enabled.
   */
  get auto() {
    return l(this, tm) || this.readonly;
  }
  /** @internal */
  [(GD = zr.enableAuto, ut.onUserSelect)]() {
    this[zr.setAuto](!1);
  }
  /** @internal */
  [ut.onReset](t) {
    this[zr.enableAuto] = void 0, this[zr.setAuto](!1, t);
  }
  /**
   * Request automatic quality selection (if supported). This will be a no-op if the list is
   * `readonly` as that already implies auto-selection.
   */
  autoSelect(t) {
    var r;
    this.readonly || l(this, tm) || !this[zr.enableAuto] || ((r = this[zr.enableAuto]) == null || r.call(this, t), this[zr.setAuto](!0, t));
  }
  getBySrc(t) {
    return this.items.find((r) => r.src === t);
  }
  /** @internal */
  [zr.setAuto](t, r) {
    l(this, tm) !== t && (L(this, tm, t), this.dispatchEvent(
      new St("auto-change", {
        detail: t,
        trigger: r
      })
    ));
  }
}
tm = new WeakMap();
function cA(c, s) {
  return [...c].sort(s ? FW : HW);
}
function HW(c, s) {
  return c.height === s.height ? (c.bitrate ?? 0) - (s.bitrate ?? 0) : c.height - s.height;
}
function FW(c, s) {
  return s.height === c.height ? (s.bitrate ?? 0) - (c.bitrate ?? 0) : s.height - c.height;
}
function Wee(c) {
  return (c == null ? void 0 : c.$$PROVIDER_TYPE) === "AUDIO";
}
function Kee(c) {
  return (c == null ? void 0 : c.$$PROVIDER_TYPE) === "VIDEO";
}
function Zee(c) {
  return (c == null ? void 0 : c.$$PROVIDER_TYPE) === "DASH";
}
function Xee(c) {
  return (c == null ? void 0 : c.$$PROVIDER_TYPE) === "YOUTUBE";
}
function Jee(c) {
  return (c == null ? void 0 : c.$$PROVIDER_TYPE) === "VIMEO";
}
function IW(c) {
  return !Oe && c instanceof HTMLAudioElement;
}
function BW(c) {
  return !Oe && c instanceof HTMLVideoElement;
}
function qW(c) {
  return IW(c) || BW(c);
}
class iv extends Vs {
}
const jW = {
  togglePaused: "k Space",
  toggleMuted: "m",
  toggleFullscreen: "f",
  togglePictureInPicture: "i",
  toggleCaptions: "c",
  seekBackward: "j J ArrowLeft",
  seekForward: "l L ArrowRight",
  volumeUp: "ArrowUp",
  volumeDown: "ArrowDown",
  speedUp: ">",
  slowDown: "<"
}, c2 = /* @__PURE__ */ new Set(["Shift", "Alt", "Meta", "Ctrl"]), GW = 'button, [role="button"]', hD = 'input, textarea, select, [contenteditable], [role^="menuitem"], [role="timer"]';
var pr, Mi, dA, fA, hA, pA, n9, nm, mA, Lc, B7, vA;
class QW extends iv {
  constructor(t) {
    super();
    k(this, Mi);
    k(this, pr);
    k(this, nm);
    k(this, Lc, null);
    L(this, pr, t);
  }
  onConnect() {
    K(m(this, Mi, dA).bind(this));
  }
}
pr = new WeakMap(), Mi = new WeakSet(), dA = function() {
  const { keyDisabled: t, keyTarget: r } = this.$props;
  if (t()) return;
  const f = r() === "player" ? this.el : document, v = nt(!1);
  f === this.el ? new Cn(this.el).add("focusin", () => v.set(!0)).add("focusout", (g) => {
    this.el.contains(g.target) || v.set(!1);
  }) : (fe(v) || v.set(document.querySelector("[data-media-player]") === this.el), sn(document, "focusin", (g) => {
    const T = g.composedPath().find((x) => x instanceof Element && x.localName === "media-player");
    T !== void 0 && v.set(this.el === T);
  })), K(() => {
    v() && new Cn(f).add("keyup", m(this, Mi, fA).bind(this)).add("keydown", m(this, Mi, hA).bind(this)).add("keydown", m(this, Mi, pA).bind(this), { capture: !0 });
  });
}, fA = function(t) {
  var g, T;
  const r = document.activeElement;
  if (!t.key || !this.$state.canSeek() || r != null && r.matches(hD))
    return;
  let { method: f, value: v } = m(this, Mi, n9).call(this, t);
  if (!qe(v) && !vr(v)) {
    (g = v == null ? void 0 : v.onKeyUp) == null || g.call(v, {
      event: t,
      player: l(this, pr).player,
      remote: l(this, pr).remote
    }), (T = v == null ? void 0 : v.callback) == null || T.call(v, t, l(this, pr).remote);
    return;
  }
  if (f != null && f.startsWith("seek") && (t.preventDefault(), t.stopPropagation(), l(this, Lc) ? (m(this, Mi, B7).call(this, t, f === "seekForward"), L(this, Lc, null)) : (l(this, pr).remote.seek(l(this, nm), t), L(this, nm, void 0))), f != null && f.startsWith("volume")) {
    const x = this.el.querySelector("[data-media-volume-slider]");
    x == null || x.dispatchEvent(
      new KeyboardEvent("keyup", {
        key: f === "volumeUp" ? "Up" : "Down",
        shiftKey: t.shiftKey,
        trigger: t
      })
    );
  }
}, hA = function(t) {
  var T, x, $, P;
  if (!t.key || c2.has(t.key)) return;
  const r = document.activeElement;
  if (r != null && r.matches(hD) || Lk(t) && (r != null && r.matches(GW)))
    return;
  let { method: f, value: v } = m(this, Mi, n9).call(this, t), g = !t.metaKey && /^[0-9]$/.test(t.key);
  if (!qe(v) && !vr(v) && !g) {
    (T = v == null ? void 0 : v.onKeyDown) == null || T.call(v, {
      event: t,
      player: l(this, pr).player,
      remote: l(this, pr).remote
    }), (x = v == null ? void 0 : v.callback) == null || x.call(v, t, l(this, pr).remote);
    return;
  }
  if (!f && g && !KW(t)) {
    t.preventDefault(), t.stopPropagation(), l(this, pr).remote.seek(this.$state.duration() / 10 * Number(t.key), t);
    return;
  }
  if (f) {
    switch (t.preventDefault(), t.stopPropagation(), f) {
      case "seekForward":
      case "seekBackward":
        m(this, Mi, vA).call(this, t, f, f === "seekForward");
        break;
      case "volumeUp":
      case "volumeDown":
        const A = this.el.querySelector("[data-media-volume-slider]");
        if (A)
          A.dispatchEvent(
            new KeyboardEvent("keydown", {
              key: f === "volumeUp" ? "Up" : "Down",
              shiftKey: t.shiftKey,
              trigger: t
            })
          );
        else {
          const F = t.shiftKey ? 0.1 : 0.05;
          l(this, pr).remote.changeVolume(
            this.$state.volume() + (f === "volumeUp" ? +F : -F),
            t
          );
        }
        break;
      case "toggleFullscreen":
        l(this, pr).remote.toggleFullscreen("prefer-media", t);
        break;
      case "speedUp":
      case "slowDown":
        const U = this.$state.playbackRate();
        l(this, pr).remote.changePlaybackRate(
          Math.max(0.25, Math.min(2, U + (f === "speedUp" ? 0.25 : -0.25))),
          t
        );
        break;
      default:
        (P = ($ = l(this, pr).remote)[f]) == null || P.call($, t);
    }
    this.$state.lastKeyboardAction.set({
      action: f,
      event: t
    });
  }
}, pA = function(t) {
  qW(t.target) && m(this, Mi, n9).call(this, t).method && t.preventDefault();
}, n9 = function(t) {
  const r = {
    ...this.$props.keyShortcuts(),
    ...l(this, pr).ariaKeys
  }, f = Object.keys(r).find((v) => {
    var $;
    const g = r[v], T = vr(g) ? g.join(" ") : qe(g) ? g : g == null ? void 0 : g.keys, x = ($ = vr(T) ? T : T == null ? void 0 : T.split(" ")) == null ? void 0 : $.map(
      (P) => WW(P).replace(/Control/g, "Ctrl").split("+")
    );
    return x == null ? void 0 : x.some((P) => {
      const A = new Set(P.filter((U) => c2.has(U)));
      for (const U of c2) {
        const F = U.toLowerCase() + "Key";
        if (!A.has(U) && t[F])
          return !1;
      }
      return P.every((U) => c2.has(U) ? t[U.toLowerCase() + "Key"] : t.key === U.replace("Space", " "));
    });
  });
  return {
    method: f,
    value: f ? r[f] : null
  };
}, nm = new WeakMap(), mA = function(t, r) {
  const f = t.shiftKey ? 10 : 5;
  return L(this, nm, Math.max(
    0,
    Math.min(
      (l(this, nm) ?? this.$state.currentTime()) + (r === "seekForward" ? +f : -f),
      this.$state.duration()
    )
  ));
}, Lc = new WeakMap(), B7 = function(t, r) {
  var f;
  (f = l(this, Lc)) == null || f.dispatchEvent(
    new KeyboardEvent(t.type, {
      key: r ? "Right" : "Left",
      shiftKey: t.shiftKey,
      trigger: t
    })
  );
}, vA = function(t, r, f) {
  this.$state.canSeek() && (l(this, Lc) || L(this, Lc, this.el.querySelector("[data-media-time-slider]")), l(this, Lc) ? m(this, Mi, B7).call(this, t, f) : l(this, pr).remote.seeking(m(this, Mi, mA).call(this, t, r), t));
};
const YW = ["!", "@", "#", "$", "%", "^", "&", "*", "(", ")"];
function WW(c) {
  return c.replace(/Shift\+(\d)/g, (s, t) => YW[t - 1]);
}
function KW(c) {
  for (const s of c2)
    if (c[s.toLowerCase() + "Key"])
      return !0;
  return !1;
}
var im;
class ZW extends Vs {
  constructor(t) {
    super();
    k(this, im);
    L(this, im, t);
  }
  onAttach(t) {
    const { $props: r, ariaKeys: f } = bn(), v = t.getAttribute("aria-keyshortcuts");
    if (v) {
      f[l(this, im)] = v, Oe || bt(() => {
        delete f[l(this, im)];
      });
      return;
    }
    const g = r.keyShortcuts()[l(this, im)];
    if (g) {
      const T = vr(g) ? g.join(" ") : qe(g) ? g : g == null ? void 0 : g.keys;
      t.setAttribute("aria-keyshortcuts", vr(T) ? T.join(" ") : T);
    }
  }
}
im = new WeakMap();
var gg, $c, A2, Cg, ff, Sg, an, yA, gA, CA, SA, bA, wA, TA, EA, i9, q7, d2, j7;
class XW extends iv {
  constructor() {
    super(...arguments);
    k(this, an);
    k(this, gg, -2);
    k(this, $c, !1);
    k(this, A2, nt(!1));
    k(this, Cg, nt(!1));
    k(this, ff, null);
    k(this, Sg, nt(!0));
    /**
     * The default amount of delay in milliseconds while media playback is progressing without user
     * activity to indicate an idle state (i.e., hide controls).
     *
     * @defaultValue 2000
     */
    I(this, "defaultDelay", 2e3);
  }
  /**
   * Whether controls can hide after a delay in user interaction. If this is false, controls will
   * not hide and be user controlled.
   */
  get canIdle() {
    return l(this, Sg).call(this);
  }
  set canIdle(t) {
    l(this, Sg).set(t);
  }
  /**
   * Whether controls visibility should be toggled when the mouse enters and leaves the player
   * container.
   *
   * @defaultValue false
   */
  get hideOnMouseLeave() {
    const { hideControlsOnMouseLeave: t } = this.$props;
    return l(this, A2).call(this) || t();
  }
  set hideOnMouseLeave(t) {
    l(this, A2).set(t);
  }
  /**
   * Whether media controls are currently visible.
   */
  get showing() {
    return this.$state.controlsVisible();
  }
  /**
   * Show controls.
   */
  show(t = 0, r) {
    m(this, an, i9).call(this), l(this, $c) || m(this, an, d2).call(this, !0, t, r);
  }
  /**
   * Hide controls.
   */
  hide(t = this.defaultDelay, r) {
    m(this, an, i9).call(this), l(this, $c) || m(this, an, d2).call(this, !1, t, r);
  }
  /**
   * Whether all idle tracking on controls should be paused until resumed again.
   */
  pause(t) {
    L(this, $c, !0), m(this, an, i9).call(this), m(this, an, d2).call(this, !0, 0, t);
  }
  resume(t) {
    L(this, $c, !1), !this.$state.paused() && m(this, an, d2).call(this, !1, this.defaultDelay, t);
  }
  onConnect() {
    K(m(this, an, yA).bind(this));
  }
}
gg = new WeakMap(), $c = new WeakMap(), A2 = new WeakMap(), Cg = new WeakMap(), ff = new WeakMap(), Sg = new WeakMap(), an = new WeakSet(), yA = function() {
  const { viewType: t } = this.$state;
  if (!this.el || !l(this, Sg).call(this)) return;
  if (t() === "audio") {
    this.show();
    return;
  }
  K(m(this, an, gA).bind(this)), K(m(this, an, CA).bind(this));
  const r = m(this, an, SA).bind(this), f = m(this, an, bA).bind(this), v = m(this, an, wA).bind(this);
  new Cn(this.el).add("can-play", (g) => this.show(0, g)).add("play", r).add("pause", f).add("end", v).add("auto-play-fail", f);
}, gA = function() {
  if (!this.el) return;
  const { started: t, pointer: r, paused: f } = this.$state;
  if (!t() || r() !== "fine") return;
  const v = new Cn(this.el), g = this.hideOnMouseLeave;
  (!g || !l(this, Cg).call(this)) && K(() => {
    f() || v.add("pointermove", m(this, an, q7).bind(this));
  }), g && v.add("mouseenter", m(this, an, TA).bind(this)).add("mouseleave", m(this, an, EA).bind(this));
}, CA = function() {
  const { paused: t, started: r, autoPlayError: f } = this.$state;
  if (t() || f() && !r()) return;
  const v = m(this, an, q7).bind(this);
  K(() => {
    if (!this.el) return;
    const g = this.$state.pointer(), T = g === "coarse", x = new Cn(this.el), $ = [T ? "touchend" : "pointerup", "keydown"];
    for (const P of $)
      x.add(P, v, { passive: !1 });
  });
}, SA = function(t) {
  t.triggers.hasType("ended") || (this.show(0, t), this.hide(void 0, t));
}, bA = function(t) {
  this.show(0, t);
}, wA = function(t) {
  const { loop: r } = this.$state;
  r() && this.hide(0, t);
}, TA = function(t) {
  l(this, Cg).set(!1), this.show(0, t), this.hide(void 0, t);
}, EA = function(t) {
  l(this, Cg).set(!0), this.hide(0, t);
}, i9 = function() {
  window.clearTimeout(l(this, gg)), L(this, gg, -1);
}, q7 = function(t) {
  var r;
  // @ts-expect-error
  t.MEDIA_GESTURE || l(this, $c) || Ik(t) || (O0(t) && (t.key === "Escape" ? ((r = this.el) == null || r.focus(), L(this, ff, null)) : l(this, ff) && (t.preventDefault(), requestAnimationFrame(() => {
    var f;
    (f = l(this, ff)) == null || f.focus(), L(this, ff, null);
  }))), this.show(0, t), this.hide(this.defaultDelay, t));
}, d2 = function(t, r, f) {
  if (r === 0) {
    m(this, an, j7).call(this, t, f);
    return;
  }
  L(this, gg, window.setTimeout(() => {
    this.scope && m(this, an, j7).call(this, t && !l(this, $c), f);
  }, r));
}, j7 = function(t, r) {
  var f;
  this.$state.controlsVisible() !== t && (this.$state.controlsVisible.set(t), !t && document.activeElement && ((f = this.el) != null && f.contains(document.activeElement)) && (L(this, ff, document.activeElement), requestAnimationFrame(() => {
    var v;
    (v = this.el) == null || v.focus({ preventScroll: !0 });
  })), this.dispatch("controls-change", {
    detail: t,
    trigger: r
  }));
};
const G7 = rh.fullscreenEnabled;
var hf, bg, ch, kA, xA, RA;
class JW extends Vs {
  constructor() {
    super(...arguments);
    k(this, ch);
    /**
     * Tracks whether we're the active fullscreen event listener. Fullscreen events can only be
     * listened to globally on the document so we need to know if they relate to the current host
     * element or not.
     */
    k(this, hf, !1);
    k(this, bg, !1);
  }
  get active() {
    return l(this, bg);
  }
  get supported() {
    return G7;
  }
  onConnect() {
    new Cn(rh).add("fullscreenchange", m(this, ch, xA).bind(this)).add("fullscreenerror", m(this, ch, RA).bind(this)), bt(m(this, ch, kA).bind(this));
  }
  async enter() {
    try {
      return L(this, hf, !0), !this.el || i7(this.el) ? void 0 : (pD(), rh.requestFullscreen(this.el));
    } catch (t) {
      throw L(this, hf, !1), t;
    }
  }
  async exit() {
    if (!(!this.el || !i7(this.el)))
      return pD(), rh.exitFullscreen();
  }
}
hf = new WeakMap(), bg = new WeakMap(), ch = new WeakSet(), kA = async function() {
  G7 && await this.exit();
}, xA = function(t) {
  const r = i7(this.el);
  r !== l(this, bg) && (r || L(this, hf, !1), L(this, bg, r), this.dispatch("fullscreen-change", { detail: r, trigger: t }));
}, RA = function(t) {
  l(this, hf) && (this.dispatch("fullscreen-error", { detail: null, trigger: t }), L(this, hf, !1));
};
function i7(c) {
  if (rh.fullscreenElement === c) return !0;
  try {
    return c.matches(
      // @ts-expect-error - `fullscreenPseudoClass` is missing from `@types/fscreen`.
      rh.fullscreenPseudoClass
    );
  } catch {
    return !1;
  }
}
function pD() {
  if (!G7)
    throw Error(
      "[vidstack] no fullscreen API"
    );
}
var pf, Dc, rm, _s, LA, Q7, Y7, W7;
const F9 = class F9 extends Vs {
  constructor() {
    super(...arguments);
    k(this, _s);
    k(this, pf, nt(m(this, _s, W7).call(this)));
    k(this, Dc, nt(!1));
    k(this, rm);
  }
  /**
   * The current screen orientation type.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get type() {
    return l(this, pf).call(this);
  }
  /**
   * Whether the screen orientation is currently locked.
   *
   * @signal
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/ScreenOrientation}
   * @see https://w3c.github.io/screen-orientation/#screen-orientation-types-and-locks
   */
  get locked() {
    return l(this, Dc).call(this);
  }
  /**
   * Whether the viewport is in a portrait orientation.
   *
   * @signal
   */
  get portrait() {
    return l(this, pf).call(this).startsWith("portrait");
  }
  /**
   * Whether the viewport is in a landscape orientation.
   *
   * @signal
   */
  get landscape() {
    return l(this, pf).call(this).startsWith("landscape");
  }
  /**
   * Whether the native Screen Orientation API is available.
   */
  get supported() {
    return F9.supported;
  }
  onConnect() {
    if (this.supported)
      sn(screen.orientation, "change", m(this, _s, Q7).bind(this));
    else {
      const t = window.matchMedia("(orientation: landscape)");
      t.onchange = m(this, _s, Q7).bind(this), bt(() => t.onchange = null);
    }
    bt(m(this, _s, LA).bind(this));
  }
  /**
   * Locks the orientation of the screen to the desired orientation type using the
   * Screen Orientation API.
   *
   * @param lockType - The screen lock orientation type.
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async lock(t) {
    fe(l(this, Dc)) || l(this, rm) === t || (m(this, _s, Y7).call(this), await screen.orientation.lock(t), l(this, Dc).set(!0), L(this, rm, t));
  }
  /**
   * Unlocks the orientation of the screen to it's default state using the Screen Orientation
   * API. This method will throw an error if the API is unavailable.
   *
   * @throws Error - If screen orientation API is unavailable.
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Screen/orientation}
   * @see {@link https://w3c.github.io/screen-orientation}
   */
  async unlock() {
    fe(l(this, Dc)) && (m(this, _s, Y7).call(this), L(this, rm, void 0), await screen.orientation.unlock(), l(this, Dc).set(!1));
  }
};
pf = new WeakMap(), Dc = new WeakMap(), rm = new WeakMap(), _s = new WeakSet(), LA = async function() {
  this.supported && l(this, Dc).call(this) && await this.unlock();
}, Q7 = function(t) {
  l(this, pf).set(m(this, _s, W7).call(this)), this.dispatch("orientation-change", {
    detail: {
      orientation: fe(l(this, pf)),
      lock: l(this, rm)
    },
    trigger: t
  });
}, Y7 = function() {
  if (!this.supported)
    throw Error(
      "[vidstack] no orientation API"
    );
}, W7 = function() {
  return Oe ? "portrait-primary" : this.supported ? window.screen.orientation.type : window.innerWidth >= window.innerHeight ? "landscape-primary" : "portrait-primary";
}, /**
 * Whether the native Screen Orientation API is available.
 */
I(F9, "supported", _M());
let O9 = F9;
class eK {
  constructor() {
    I(this, "name", "audio");
    I(this, "target");
  }
  canPlay(s) {
    return IM(s) ? Oe || !qe(s.src) || s.type === "?" || NM(this.target, s.type) : !1;
  }
  mediaType() {
    return "audio";
  }
  async load(s) {
    if (Oe)
      throw Error("[vidstack] can not load audio provider server-side");
    return new (await Promise.resolve().then(() => dee)).AudioProvider(this.target, s);
  }
}
class Bk {
  constructor() {
    I(this, "name", "video");
    I(this, "target");
  }
  canPlay(s) {
    return BM(s) ? Oe || !qe(s.src) || s.type === "?" || VM(this.target, s.type) : !1;
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    if (Oe)
      throw Error("[vidstack] can not load video provider server-side");
    return new (await Promise.resolve().then(function() {
      return gK;
    })).VideoProvider(this.target, s);
  }
}
const I9 = class I9 extends Bk {
  constructor() {
    super(...arguments);
    I(this, "name", "hls");
  }
  canPlay(t) {
    return I9.supported && _1(t);
  }
  async load(t) {
    if (Oe)
      throw Error("[vidstack] can not load hls provider server-side");
    return new (await Promise.resolve().then(() => gee)).HLSProvider(this.target, t);
  }
};
I(I9, "supported", yw());
let K7 = I9, r9 = null, _9 = [], N9 = [];
function qk() {
  return r9 ?? (r9 = new AudioContext());
}
function tK() {
  const c = qk(), s = c.createGain();
  return s.connect(c.destination), _9.push(s), s;
}
function nK(c, s) {
  const t = qk(), r = t.createMediaElementSource(c);
  return s && r.connect(s), N9.push(r), r;
}
function iK(c) {
  const s = _9.indexOf(c);
  s !== -1 && (_9.splice(s, 1), c.disconnect(), $A());
}
function rK(c) {
  const s = N9.indexOf(c);
  s !== -1 && (N9.splice(s, 1), c.disconnect(), $A());
}
function $A() {
  r9 && _9.length === 0 && N9.length === 0 && r9.close().then(() => {
    r9 = null;
  });
}
var P2, wg, Rs, so, Km, DA, Z7;
class aK {
  constructor(s, t) {
    k(this, Km);
    k(this, P2);
    k(this, wg);
    k(this, Rs, null);
    k(this, so, null);
    L(this, P2, s), L(this, wg, t);
  }
  get currentGain() {
    var s, t;
    return ((t = (s = l(this, Rs)) == null ? void 0 : s.gain) == null ? void 0 : t.value) ?? null;
  }
  get supported() {
    return !0;
  }
  setGain(s) {
    const t = this.currentGain;
    if (s !== this.currentGain) {
      if (s === 1 && t !== 1) {
        this.removeGain();
        return;
      }
      l(this, Rs) || (L(this, Rs, tK()), l(this, so) && l(this, so).connect(l(this, Rs))), l(this, so) || L(this, so, nK(l(this, P2), l(this, Rs))), l(this, Rs).gain.value = s, l(this, wg).call(this, s);
    }
  }
  removeGain() {
    l(this, Rs) && (l(this, so) && l(this, so).connect(qk().destination), m(this, Km, Z7).call(this), l(this, wg).call(this, null));
  }
  destroy() {
    m(this, Km, DA).call(this), m(this, Km, Z7).call(this);
  }
}
P2 = new WeakMap(), wg = new WeakMap(), Rs = new WeakMap(), so = new WeakMap(), Km = new WeakSet(), DA = function() {
  if (l(this, so))
    try {
      rK(l(this, so));
    } catch {
    } finally {
      L(this, so, null);
    }
}, Z7 = function() {
  if (l(this, Rs))
    try {
      iK(l(this, Rs));
    } catch {
    } finally {
      L(this, Rs, null);
    }
};
const sK = ["focus", "blur", "visibilitychange", "pageshow", "pagehide"];
var am, Tg, O2, B9, MA;
class oK {
  constructor() {
    k(this, B9);
    k(this, am, nt(mD()));
    k(this, Tg, nt(Oe ? "visible" : document.visibilityState));
    k(this, O2);
  }
  connect() {
    const s = new Cn(window), t = m(this, B9, MA).bind(this);
    for (const r of sK)
      s.add(r, t);
    A9 && s.add("beforeunload", (r) => {
      L(this, O2, setTimeout(() => {
        r.defaultPrevented || r.returnValue.length > 0 || (l(this, am).set("hidden"), l(this, Tg).set("hidden"));
      }, 0));
    });
  }
  /**
   * The current page state. Important to note we only account for a subset of page states, as
   * the rest aren't valuable to the player at the moment.
   *
   * - **active:** A page is in the active state if it is visible and has input focus.
   * - **passive:** A page is in the passive state if it is visible and does not have input focus.
   * - **hidden:** A page is in the hidden state if it is not visible.
   *
   * @see https://developers.google.com/web/updates/2018/07/page-lifecycle-api#states
   */
  get pageState() {
    return l(this, am).call(this);
  }
  /**
   * The current document visibility state.
   *
   * - **visible:** The page content may be at least partially visible. In practice, this means that
   * the page is the foreground tab of a non-minimized window.
   * - **hidden:** The page content is not visible to the user. In practice this means that the
   * document is either a background tab or part of a minimized window, or the OS screen lock is
   * active.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilityState
   */
  get visibility() {
    return l(this, Tg).call(this);
  }
}
am = new WeakMap(), Tg = new WeakMap(), O2 = new WeakMap(), B9 = new WeakSet(), MA = function(s) {
  A9 && window.clearTimeout(l(this, O2)), (s.type !== "blur" || l(this, am).call(this) === "active") && (l(this, am).set(mD(s)), l(this, Tg).set(document.visibilityState == "hidden" ? "hidden" : "visible"));
};
function mD(c) {
  return Oe || (c == null ? void 0 : c.type) === "blur" || document.visibilityState === "hidden" ? "hidden" : document.hasFocus() ? "active" : "passive";
}
var Mc, _2, N2, X7;
class U0 {
  constructor(s) {
    k(this, N2);
    k(this, Mc);
    k(this, _2);
    L(this, _2, s);
  }
  start() {
    Di(l(this, Mc)) && m(this, N2, X7).call(this);
  }
  stop() {
    ar(l(this, Mc)) && window.cancelAnimationFrame(l(this, Mc)), L(this, Mc, void 0);
  }
}
Mc = new WeakMap(), _2 = new WeakMap(), N2 = new WeakSet(), X7 = function() {
  L(this, Mc, window.requestAnimationFrame(() => {
    Di(l(this, Mc)) || (l(this, _2).call(this), m(this, N2, X7).call(this));
  }));
};
var V2, zt, mf, Eg, kg, sm, U2, xg, ee, nn, AA, Rg, Lg, PA, OA, _A, NA, q9, pk, vi, uK, Hp, VA, J7, UA, zA, HA, a9, FA, IA, BA, qA, jA, GA, QA, YA, WA, KA, ZA, XA, JA, eP, tP, nP, iP, rP;
class lK {
  constructor(s, t) {
    k(this, ee);
    k(this, V2);
    k(this, zt);
    k(this, mf, !1);
    k(this, Eg, !1);
    k(this, kg, !1);
    k(this, sm, new U0(m(this, ee, PA).bind(this)));
    k(this, U2, new oK());
    k(this, xg);
    /**
     * The `timeupdate` event fires surprisingly infrequently during playback, meaning your progress
     * bar (or whatever else is synced to the currentTime) moves in a choppy fashion. This helps
     * resolve that by retrieving time updates in a request animation frame loop.
     */
    k(this, Rg, 0);
    k(this, Lg, -1);
    k(this, q9);
    k(this, pk);
    L(this, V2, s), L(this, zt, t), L(this, xg, new Cn(s.media)), m(this, ee, OA).call(this), l(this, U2).connect(), K(m(this, ee, WA).bind(this)), bt(m(this, ee, AA).bind(this));
  }
}
V2 = new WeakMap(), zt = new WeakMap(), mf = new WeakMap(), Eg = new WeakMap(), kg = new WeakMap(), sm = new WeakMap(), U2 = new WeakMap(), xg = new WeakMap(), ee = new WeakSet(), nn = function() {
  return l(this, V2).media;
}, AA = function() {
  var s;
  L(this, Eg, !1), L(this, kg, !1), l(this, sm).stop(), l(this, xg).abort(), (s = l(this, q9)) == null || s.clear();
}, Rg = new WeakMap(), Lg = new WeakMap(), PA = function() {
  const s = l(this, ee, nn).currentTime;
  !(A9 && s - l(this, Lg) < 0.35) && l(this, Rg) !== s && (m(this, ee, Hp).call(this, s), L(this, Rg, s));
}, OA = function() {
  m(this, ee, vi).call(this, "loadstart", m(this, ee, VA)), m(this, ee, vi).call(this, "abort", m(this, ee, J7)), m(this, ee, vi).call(this, "emptied", m(this, ee, UA)), m(this, ee, vi).call(this, "error", m(this, ee, rP)), m(this, ee, vi).call(this, "volumechange", m(this, ee, XA));
}, _A = function() {
  l(this, Eg) || (m(this, ee, vi).call(this, "loadeddata", m(this, ee, zA)), m(this, ee, vi).call(this, "loadedmetadata", m(this, ee, HA)), m(this, ee, vi).call(this, "canplay", m(this, ee, BA)), m(this, ee, vi).call(this, "canplaythrough", m(this, ee, qA)), m(this, ee, vi).call(this, "durationchange", m(this, ee, ZA)), m(this, ee, vi).call(this, "play", m(this, ee, FA)), m(this, ee, vi).call(this, "progress", m(this, ee, tP)), m(this, ee, vi).call(this, "stalled", m(this, ee, GA)), m(this, ee, vi).call(this, "suspend", m(this, ee, nP)), m(this, ee, vi).call(this, "ratechange", m(this, ee, iP)), L(this, Eg, !0));
}, NA = function() {
  l(this, kg) || (m(this, ee, vi).call(this, "pause", m(this, ee, IA)), m(this, ee, vi).call(this, "playing", m(this, ee, jA)), m(this, ee, vi).call(this, "seeked", m(this, ee, JA)), m(this, ee, vi).call(this, "seeking", m(this, ee, eP)), m(this, ee, vi).call(this, "ended", m(this, ee, YA)), m(this, ee, vi).call(this, "waiting", m(this, ee, QA)), L(this, kg, !0));
}, q9 = new WeakMap(), pk = new WeakMap(), vi = function(s, t) {
  l(this, xg).add(s, t.bind(this));
}, uK = function(s) {
}, Hp = function(s, t) {
  const r = Math.min(s, l(this, zt).$state.seekableEnd());
  l(this, zt).notify("time-change", r, t);
}, VA = function(s) {
  if (l(this, ee, nn).networkState === 3) {
    m(this, ee, J7).call(this, s);
    return;
  }
  m(this, ee, _A).call(this), l(this, zt).notify("load-start", void 0, s);
}, J7 = function(s) {
  l(this, zt).notify("abort", void 0, s);
}, UA = function() {
  l(this, zt).notify("emptied", void 0, event);
}, zA = function(s) {
  l(this, zt).notify("loaded-data", void 0, s);
}, HA = function(s) {
  L(this, Rg, 0), L(this, Lg, -1), m(this, ee, NA).call(this), l(this, zt).notify("loaded-metadata", void 0, s), (mw || A9 && _1(l(this, zt).$state.source())) && l(this, zt).delegate.ready(m(this, ee, a9).call(this), s);
}, a9 = function() {
  return {
    provider: fe(l(this, zt).$provider),
    duration: l(this, ee, nn).duration,
    buffered: l(this, ee, nn).buffered,
    seekable: l(this, ee, nn).seekable
  };
}, FA = function(s) {
  l(this, zt).$state.canPlay && l(this, zt).notify("play", void 0, s);
}, IA = function(s) {
  l(this, ee, nn).readyState === 1 && !l(this, mf) || (L(this, mf, !1), l(this, sm).stop(), l(this, zt).notify("pause", void 0, s));
}, BA = function(s) {
  l(this, zt).delegate.ready(m(this, ee, a9).call(this), s);
}, qA = function(s) {
  l(this, zt).$state.started() || l(this, zt).notify("can-play-through", m(this, ee, a9).call(this), s);
}, jA = function(s) {
  l(this, ee, nn).paused || (L(this, mf, !1), l(this, zt).notify("playing", void 0, s), l(this, sm).start());
}, GA = function(s) {
  l(this, zt).notify("stalled", void 0, s), l(this, ee, nn).readyState < 3 && (L(this, mf, !0), l(this, zt).notify("waiting", void 0, s));
}, QA = function(s) {
  l(this, ee, nn).readyState < 3 && (L(this, mf, !0), l(this, zt).notify("waiting", void 0, s));
}, YA = function(s) {
  l(this, sm).stop(), m(this, ee, Hp).call(this, l(this, ee, nn).duration, s), l(this, zt).notify("end", void 0, s), l(this, zt).$state.loop() && nM(l(this, ee, nn).controls) && (l(this, ee, nn).controls = !1);
}, WA = function() {
  const s = l(this, zt).$state.paused(), t = l(this, U2).visibility === "hidden";
  (s || t) && sn(l(this, ee, nn), "timeupdate", m(this, ee, KA).bind(this));
}, KA = function(s) {
  m(this, ee, Hp).call(this, l(this, ee, nn).currentTime, s);
}, ZA = function(s) {
  l(this, zt).$state.ended() && m(this, ee, Hp).call(this, l(this, ee, nn).duration, s), l(this, zt).notify("duration-change", l(this, ee, nn).duration, s);
}, XA = function(s) {
  const t = {
    volume: l(this, ee, nn).volume,
    muted: l(this, ee, nn).muted
  };
  l(this, zt).notify("volume-change", t, s);
}, JA = function(s) {
  L(this, Lg, l(this, ee, nn).currentTime), m(this, ee, Hp).call(this, l(this, ee, nn).currentTime, s), l(this, zt).notify("seeked", l(this, ee, nn).currentTime, s), Math.trunc(l(this, ee, nn).currentTime) === Math.trunc(l(this, ee, nn).duration) && N7(l(this, ee, nn).duration) > N7(l(this, ee, nn).currentTime) && (m(this, ee, Hp).call(this, l(this, ee, nn).duration, s), l(this, ee, nn).ended || l(this, zt).player.dispatch(
    new St("media-play-request", {
      trigger: s
    })
  ));
}, eP = function(s) {
  l(this, zt).notify("seeking", l(this, ee, nn).currentTime, s);
}, tP = function(s) {
  const t = {
    buffered: l(this, ee, nn).buffered,
    seekable: l(this, ee, nn).seekable
  };
  l(this, zt).notify("progress", t, s);
}, nP = function(s) {
  l(this, zt).notify("suspend", void 0, s);
}, iP = function(s) {
  l(this, zt).notify("rate-change", l(this, ee, nn).playbackRate, s);
}, rP = function(s) {
  const t = l(this, ee, nn).error;
  if (!t) return;
  const r = {
    message: t.message,
    code: t.code,
    mediaError: t
  };
  l(this, zt).notify("error", r, s);
};
var z2, Go, sr, ag, aP, sP, oP, e5, lP;
class cK {
  constructor(s, t) {
    k(this, sr);
    k(this, z2);
    k(this, Go);
    L(this, z2, s), L(this, Go, t), l(this, sr, ag).onaddtrack = m(this, sr, aP).bind(this), l(this, sr, ag).onremovetrack = m(this, sr, sP).bind(this), l(this, sr, ag).onchange = m(this, sr, oP).bind(this), sn(l(this, Go).audioTracks, "change", m(this, sr, lP).bind(this));
  }
}
z2 = new WeakMap(), Go = new WeakMap(), sr = new WeakSet(), ag = function() {
  return l(this, z2).media.audioTracks;
}, aP = function(s) {
  const t = s.track;
  if (t.label === "") return;
  const r = t.id.toString() || `native-audio-${l(this, Go).audioTracks.length}`, f = {
    id: r,
    label: t.label,
    language: t.language,
    kind: t.kind,
    selected: !1
  };
  l(this, Go).audioTracks[ut.add](f, s), t.enabled && (f.selected = !0);
}, sP = function(s) {
  const t = l(this, Go).audioTracks.getById(s.track.id);
  t && l(this, Go).audioTracks[ut.remove](t, s);
}, oP = function(s) {
  let t = m(this, sr, e5).call(this);
  if (!t) return;
  const r = l(this, Go).audioTracks.getById(t.id);
  r && l(this, Go).audioTracks[ut.select](r, !0, s);
}, e5 = function() {
  return Array.from(l(this, sr, ag)).find((s) => s.enabled);
}, lP = function(s) {
  const { current: t } = s.detail;
  if (!t) return;
  const r = l(this, sr, ag).getTrackById(t.id);
  if (r) {
    const f = m(this, sr, e5).call(this);
    f && (f.enabled = !1), r.enabled = !0;
  }
};
var H2, t5;
class uP {
  constructor(s, t) {
    k(this, H2);
    I(this, "scope", Xc());
    I(this, "currentSrc", null);
    I(this, "audioGain");
    this.media = s, this.ctx = t, this.audioGain = new aK(s, (r) => {
      this.ctx.notify("audio-gain-change", r);
    });
  }
  setup() {
    new lK(this, this.ctx), "audioTracks" in this.media && new cK(this, this.ctx), bt(() => {
      this.audioGain.destroy(), this.media.srcObject = null, this.media.removeAttribute("src");
      for (const s of this.media.querySelectorAll("source")) s.remove();
      this.media.load();
    });
  }
  get type() {
    return "";
  }
  setPlaybackRate(s) {
    this.media.playbackRate = s;
  }
  async play() {
    return this.media.play();
  }
  async pause() {
    return this.media.pause();
  }
  setMuted(s) {
    this.media.muted = s;
  }
  setVolume(s) {
    this.media.volume = s;
  }
  setCurrentTime(s) {
    this.media.currentTime = s;
  }
  setPlaysInline(s) {
    lt(this.media, "playsinline", s);
  }
  async loadSource({ src: s, type: t }, r) {
    this.media.preload = r || "", oW(s) ? (this.removeSource(), this.media.srcObject = s) : (this.media.srcObject = null, qe(s) ? t !== "?" ? this.appendSource({ src: s, type: t }) : (this.removeSource(), this.media.src = m(this, H2, t5).call(this, s)) : (this.removeSource(), this.media.src = window.URL.createObjectURL(s))), this.media.load(), this.currentSrc = { src: s, type: t };
  }
  /**
   * Append source so it works when requesting AirPlay since hls.js will remove it.
   */
  appendSource(s, t) {
    const r = this.media.querySelector("source[data-vds]"), f = r ?? document.createElement("source");
    lt(f, "src", m(this, H2, t5).call(this, s.src)), lt(f, "type", s.type !== "?" ? s.type : t), lt(f, "data-vds", ""), r || this.media.append(f);
  }
  removeSource() {
    var s;
    (s = this.media.querySelector("source[data-vds]")) == null || s.remove();
  }
}
H2 = new WeakSet(), t5 = function(s) {
  const { clipStartTime: t, clipEndTime: r } = this.ctx.$state, f = t(), v = r();
  return f > 0 && v > 0 ? `${s}#t=${f},${v}` : f > 0 ? `${s}#t=${f}` : v > 0 ? `${s}#t=0,${v}` : s;
};
var oo, F2, I2, om, dh, cP, dP, fP;
class dK {
  constructor(s, t) {
    k(this, dh);
    k(this, oo);
    k(this, F2);
    k(this, I2);
    k(this, om, nt(!1));
    L(this, oo, s), L(this, F2, t), m(this, dh, cP).call(this);
  }
  get supported() {
    return l(this, om).call(this);
  }
  async prompt() {
    if (!this.supported) throw Error("Not supported on this platform.");
    return this.type === "airplay" && l(this, oo).webkitShowPlaybackTargetPicker ? l(this, oo).webkitShowPlaybackTargetPicker() : l(this, oo).remote.prompt();
  }
}
oo = new WeakMap(), F2 = new WeakMap(), I2 = new WeakMap(), om = new WeakMap(), dh = new WeakSet(), cP = function() {
  var s;
  Oe || !((s = l(this, oo)) != null && s.remote) || !this.canPrompt || (l(this, oo).remote.watchAvailability((t) => {
    l(this, om).set(t);
  }).catch(() => {
    l(this, om).set(!1);
  }), K(m(this, dh, dP).bind(this)));
}, dP = function() {
  if (!l(this, om).call(this)) return;
  const s = ["connecting", "connect", "disconnect"], t = m(this, dh, fP).bind(this);
  t(), sn(l(this, oo), "playing", t);
  const r = new Cn(l(this, oo).remote);
  for (const f of s)
    r.add(f, t);
}, fP = function(s) {
  const t = l(this, oo).remote.state;
  if (t === l(this, I2)) return;
  const r = { type: this.type, state: t };
  l(this, F2).notify("remote-playback-change", r, s), L(this, I2, t);
};
class hP extends dK {
  constructor() {
    super(...arguments);
    I(this, "type", "airplay");
  }
  get canPrompt() {
    return "WebKitPlaybackTargetAvailabilityEvent" in window;
  }
}
var $g, Dg, $1, pP, mP;
class fK {
  constructor(s, t) {
    k(this, $1);
    k(this, $g);
    k(this, Dg);
    L(this, $g, s), L(this, Dg, t), s.textTracks.onaddtrack = m(this, $1, pP).bind(this), bt(m(this, $1, mP).bind(this));
  }
}
$g = new WeakMap(), Dg = new WeakMap(), $1 = new WeakSet(), pP = function(s) {
  const t = s.track;
  if (!t || hK(l(this, $g), t)) return;
  const r = new Jc({
    id: t.id,
    kind: t.kind,
    label: t.label ?? "",
    language: t.language,
    type: "vtt"
  });
  r[ht.native] = { track: t }, r[ht.readyState] = 2, r[ht.nativeHLS] = !0;
  let f = 0;
  const v = (g) => {
    if (t.cues)
      for (let T = f; T < t.cues.length; T++)
        r.addCue(t.cues[T], g), f++;
  };
  v(s), t.oncuechange = v, l(this, Dg).textTracks.add(r, s), r.setMode(t.mode, s);
}, mP = function() {
  var s;
  l(this, $g).textTracks.onaddtrack = null;
  for (const t of l(this, Dg).textTracks) {
    const r = (s = t[ht.native]) == null ? void 0 : s.track;
    r != null && r.oncuechange && (r.oncuechange = null);
  }
};
function hK(c, s) {
  return Array.from(c.children).find((t) => t.track === s);
}
var lm, B2, D1, vP, yP, q2;
class pK {
  constructor(s, t) {
    k(this, D1);
    k(this, lm);
    k(this, B2);
    k(this, q2, (s, t) => {
      l(this, B2).notify("picture-in-picture-change", s, t);
    });
    L(this, lm, s), L(this, B2, t), new Cn(s).add("enterpictureinpicture", m(this, D1, vP).bind(this)).add("leavepictureinpicture", m(this, D1, yP).bind(this));
  }
  get active() {
    return document.pictureInPictureElement === l(this, lm);
  }
  get supported() {
    return zM(l(this, lm));
  }
  async enter() {
    return l(this, lm).requestPictureInPicture();
  }
  exit() {
    return document.exitPictureInPicture();
  }
}
lm = new WeakMap(), B2 = new WeakMap(), D1 = new WeakSet(), vP = function(s) {
  l(this, q2).call(this, !0, s);
}, yP = function(s) {
  l(this, q2).call(this, !1, s);
}, q2 = new WeakMap();
var um, Mg, Zl, j9, gP;
class mK {
  constructor(s, t) {
    k(this, j9);
    k(this, um);
    k(this, Mg);
    k(this, Zl, "inline");
    L(this, um, s), L(this, Mg, t), sn(s, "webkitpresentationmodechanged", m(this, j9, gP).bind(this));
  }
  get mode() {
    return l(this, Zl);
  }
  get supported() {
    return HM(l(this, um));
  }
  async setPresentationMode(s) {
    l(this, Zl) !== s && l(this, um).webkitSetPresentationMode(s);
  }
}
um = new WeakMap(), Mg = new WeakMap(), Zl = new WeakMap(), j9 = new WeakSet(), gP = function(s) {
  var r;
  const t = l(this, Zl);
  L(this, Zl, l(this, um).webkitPresentationMode), (r = l(this, Mg).player) == null || r.dispatch(
    new St("video-presentation-change", {
      detail: l(this, Zl),
      trigger: s
    })
  ), ["fullscreen", "picture-in-picture"].forEach((f) => {
    (l(this, Zl) === f || t === f) && l(this, Mg).notify(`${f}-change`, l(this, Zl) === f, s);
  });
};
var vf;
class vK {
  constructor(s) {
    k(this, vf);
    L(this, vf, s);
  }
  get active() {
    return l(this, vf).mode === "fullscreen";
  }
  get supported() {
    return l(this, vf).supported;
  }
  async enter() {
    l(this, vf).setPresentationMode("fullscreen");
  }
  async exit() {
    l(this, vf).setPresentationMode("inline");
  }
}
vf = new WeakMap();
var yf;
class yK {
  constructor(s) {
    k(this, yf);
    L(this, yf, s);
  }
  get active() {
    return l(this, yf).mode === "picture-in-picture";
  }
  get supported() {
    return l(this, yf).supported;
  }
  async enter() {
    l(this, yf).setPresentationMode("picture-in-picture");
  }
  async exit() {
    l(this, yf).setPresentationMode("inline");
  }
}
yf = new WeakMap();
let jk = class extends uP {
  constructor(t, r) {
    super(t, r);
    I(this, "$$PROVIDER_TYPE", "VIDEO");
    I(this, "airPlay");
    I(this, "fullscreen");
    I(this, "pictureInPicture");
    la(() => {
      if (this.airPlay = new hP(t, r), HM(t)) {
        const f = new mK(t, r);
        this.fullscreen = new vK(f), this.pictureInPicture = new yK(f);
      } else zM(t) && (this.pictureInPicture = new pK(t, r));
    }, this.scope);
  }
  get type() {
    return "video";
  }
  setup() {
    super.setup(), UM(this.video) && new fK(this.video, this.ctx), this.ctx.textRenderers.attachVideo(this.video), bt(() => {
      this.ctx.textRenderers.attachVideo(null);
    }), this.type === "video" && this.ctx.notify("provider-setup", this);
  }
  /**
   * The native HTML `<video>` element.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLVideoElement}
   */
  get video() {
    return this.media;
  }
};
var gK = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  VideoProvider: jk
});
function vD(c) {
  try {
    return new Intl.DisplayNames(navigator.languages, { type: "language" }).of(c) ?? null;
  } catch {
    return null;
  }
}
const CK = (c) => `dash-${_0(c)}`;
var gf, Rn, Mt, Ag, Pg, it, Fp, CP, SP, bP, Ac, Og, wP, TP, EP, kP, xP, RP, LP, $P, Cf, DP, s9, n5, MP, i5, AP, PP, r5;
class SK {
  constructor(s, t) {
    k(this, it);
    k(this, gf);
    k(this, Rn);
    k(this, Mt, null);
    k(this, Ag, /* @__PURE__ */ new Set());
    k(this, Pg, null);
    I(this, "config", {});
    k(this, Ac, null);
    k(this, Og, {});
    k(this, Cf, -1);
    L(this, gf, s), L(this, Rn, t);
  }
  get instance() {
    return l(this, Mt);
  }
  setup(s) {
    L(this, Mt, s().create());
    const t = m(this, it, bP).bind(this);
    for (const r of Object.values(s.events)) l(this, Mt).on(r, t);
    l(this, Mt).on(s.events.ERROR, m(this, it, RP).bind(this));
    for (const r of l(this, Ag)) r(l(this, Mt));
    l(this, Rn).player.dispatch("dash-instance", {
      detail: l(this, Mt)
    }), l(this, Mt).initialize(l(this, gf), void 0, !1), l(this, Mt).updateSettings({
      streaming: {
        text: {
          // Disabling text rendering by dash.
          defaultEnabled: !1,
          dispatchForManualRendering: !0
        },
        buffer: {
          /// Enables buffer replacement when switching bitrates for faster switching.
          fastSwitchEnabled: !0
        }
      },
      ...this.config
    }), l(this, Mt).on(s.events.FRAGMENT_LOADING_STARTED, m(this, it, LP).bind(this)), l(this, Mt).on(
      s.events.FRAGMENT_LOADING_COMPLETED,
      m(this, it, $P).bind(this)
    ), l(this, Mt).on(s.events.MANIFEST_LOADED, m(this, it, xP).bind(this)), l(this, Mt).on(s.events.QUALITY_CHANGE_RENDERED, m(this, it, kP).bind(this)), l(this, Mt).on(s.events.TEXT_TRACKS_ADDED, m(this, it, TP).bind(this)), l(this, Mt).on(s.events.TRACK_CHANGE_RENDERED, m(this, it, EP).bind(this)), l(this, Rn).qualities[zr.enableAuto] = m(this, it, MP).bind(this), sn(l(this, Rn).qualities, "change", m(this, it, AP).bind(this)), sn(l(this, Rn).audioTracks, "change", m(this, it, PP).bind(this)), L(this, Pg, K(m(this, it, CP).bind(this)));
  }
  onInstance(s) {
    return l(this, Ag).add(s), () => l(this, Ag).delete(s);
  }
  loadSource(s) {
    var t;
    m(this, it, r5).call(this), qe(s.src) && ((t = l(this, Mt)) == null || t.attachSource(s.src));
  }
  destroy() {
    var s, t;
    m(this, it, r5).call(this), (s = l(this, Mt)) == null || s.destroy(), L(this, Mt, null), (t = l(this, Pg)) == null || t.call(this), L(this, Pg, null);
  }
}
gf = new WeakMap(), Rn = new WeakMap(), Mt = new WeakMap(), Ag = new WeakMap(), Pg = new WeakMap(), it = new WeakSet(), Fp = function(s) {
  return new St(CK(s.type), { detail: s });
}, CP = function() {
  if (!l(this, Rn).$state.live()) return;
  const s = new U0(m(this, it, SP).bind(this));
  return s.start(), s.stop.bind(s);
}, SP = function() {
  if (!l(this, Mt)) return;
  const s = l(this, Mt).duration() - l(this, Mt).time();
  l(this, Rn).$state.liveSyncPosition.set(isNaN(s) ? 1 / 0 : s);
}, bP = function(s) {
  var t;
  (t = l(this, Rn).player) == null || t.dispatch(m(this, it, Fp).call(this, s));
}, Ac = new WeakMap(), Og = new WeakMap(), wP = function(s) {
  var T;
  const t = (T = l(this, Ac)) == null ? void 0 : T[ht.native], r = (t == null ? void 0 : t.track).cues;
  if (!t || !r) return;
  const f = l(this, Ac).id, v = l(this, Og)[f] ?? 0, g = m(this, it, Fp).call(this, s);
  for (let x = v; x < r.length; x++) {
    const $ = r[x];
    $.positionAlign || ($.positionAlign = "auto"), l(this, Ac).addCue($, g);
  }
  l(this, Og)[f] = r.length;
}, TP = function(s) {
  var v;
  if (!l(this, Mt)) return;
  const t = s.tracks, r = [...l(this, gf).textTracks].filter((g) => "manualMode" in g), f = m(this, it, Fp).call(this, s);
  for (let g = 0; g < r.length; g++) {
    const T = t[g], x = r[g], $ = `dash-${T.kind}-${g}`, P = new Jc({
      id: $,
      label: (T == null ? void 0 : T.label) ?? ((v = T.labels.find((A) => A.text)) == null ? void 0 : v.text) ?? ((T == null ? void 0 : T.lang) && vD(T.lang)) ?? (T == null ? void 0 : T.lang) ?? void 0,
      language: T.lang ?? void 0,
      kind: T.kind,
      default: T.defaultTrack
    });
    P[ht.native] = {
      managed: !0,
      track: x
    }, P[ht.readyState] = 2, P[ht.onModeChange] = () => {
      l(this, Mt) && (P.mode === "showing" ? (l(this, Mt).setTextTrack(g), L(this, Ac, P)) : (l(this, Mt).setTextTrack(-1), L(this, Ac, null)));
    }, l(this, Rn).textTracks.add(P, f);
  }
}, EP = function(s) {
  const { mediaType: t, newMediaInfo: r } = s;
  if (t === "audio") {
    const f = l(this, Rn).audioTracks.getById(`dash-audio-${r.index}`);
    if (f) {
      const v = m(this, it, Fp).call(this, s);
      l(this, Rn).audioTracks[ut.select](f, !0, v);
    }
  }
}, kP = function(s) {
  if (s.mediaType !== "video") return;
  const t = l(this, Rn).qualities[s.newQuality];
  if (t) {
    const r = m(this, it, Fp).call(this, s);
    l(this, Rn).qualities[ut.select](t, !0, r);
  }
}, xP = function(s) {
  if (l(this, Rn).$state.canPlay() || !l(this, Mt)) return;
  const { type: t, mediaPresentationDuration: r } = s.data, f = m(this, it, Fp).call(this, s);
  l(this, Rn).notify("stream-type-change", t !== "static" ? "live" : "on-demand", f), l(this, Rn).notify("duration-change", r, f), l(this, Rn).qualities[zr.setAuto](!0, f);
  const v = l(this, Mt).getVideoElement(), g = l(this, Mt).getTracksForTypeFromManifest(
    "video",
    s.data
  ), T = [...new Set(g.map((A) => A.mimeType))].find(
    (A) => A && VM(v, A)
  ), x = g.filter(
    (A) => T === A.mimeType
  )[0];
  let $ = l(this, Mt).getTracksForTypeFromManifest(
    "audio",
    s.data
  );
  const P = [...new Set($.map((A) => A.mimeType))].find(
    (A) => A && NM(v, A)
  );
  if ($ = $.filter((A) => P === A.mimeType), x == null || x.bitrateList.forEach((A, U) => {
    var Z;
    const F = {
      id: ((Z = A.id) == null ? void 0 : Z.toString()) ?? `dash-bitrate-${U}`,
      width: A.width ?? 0,
      height: A.height ?? 0,
      bitrate: A.bandwidth ?? 0,
      codec: x.codec,
      index: U
    };
    l(this, Rn).qualities[ut.add](F, f);
  }), ar(x == null ? void 0 : x.index)) {
    const A = l(this, Rn).qualities[x.index];
    A && l(this, Rn).qualities[ut.select](A, !0, f);
  }
  $.forEach((A, U) => {
    const Z = A.labels.find((ce) => navigator.languages.some((De) => ce.lang && De.toLowerCase().startsWith(ce.lang.toLowerCase()))) || A.labels[0], ne = {
      id: `dash-audio-${A == null ? void 0 : A.index}`,
      label: (Z == null ? void 0 : Z.text) ?? (A.lang && vD(A.lang)) ?? A.lang ?? "",
      language: A.lang ?? "",
      kind: "main",
      mimeType: A.mimeType,
      codec: A.codec,
      index: U
    };
    l(this, Rn).audioTracks[ut.add](ne, f);
  }), v.dispatchEvent(new St("canplay", { trigger: f }));
}, RP = function(s) {
  const { type: t, error: r } = s;
  switch (r.code) {
    case 27:
      m(this, it, DP).call(this, r);
      break;
    default:
      m(this, it, n5).call(this, r);
      break;
  }
}, LP = function() {
  l(this, Cf) >= 0 && m(this, it, s9).call(this);
}, $P = function(s) {
  s.mediaType === "text" && requestAnimationFrame(m(this, it, wP).bind(this, s));
}, Cf = new WeakMap(), DP = function(s) {
  var t;
  m(this, it, s9).call(this), (t = l(this, Mt)) == null || t.play(), L(this, Cf, window.setTimeout(() => {
    L(this, Cf, -1), m(this, it, n5).call(this, s);
  }, 5e3));
}, s9 = function() {
  clearTimeout(l(this, Cf)), L(this, Cf, -1);
}, n5 = function(s) {
  l(this, Rn).notify("error", {
    message: s.message ?? "",
    code: 1,
    error: s
  });
}, MP = function() {
  var t;
  m(this, it, i5).call(this, "video", !0);
  const { qualities: s } = l(this, Rn);
  (t = l(this, Mt)) == null || t.setQualityFor("video", s.selectedIndex, !0);
}, i5 = function(s, t) {
  var r;
  (r = l(this, Mt)) == null || r.updateSettings({
    streaming: { abr: { autoSwitchBitrate: { [s]: t } } }
  });
}, AP = function() {
  const { qualities: s } = l(this, Rn);
  !l(this, Mt) || s.auto || !s.selected || (m(this, it, i5).call(this, "video", !1), l(this, Mt).setQualityFor("video", s.selectedIndex, s.switch === "current"), vw && (l(this, gf).currentTime = l(this, gf).currentTime));
}, PP = function() {
  if (!l(this, Mt)) return;
  const { audioTracks: s } = l(this, Rn), t = l(this, Mt).getTracksFor("audio").find(
    (r) => s.selected && s.selected.id === `dash-audio-${r.index}`
  );
  t && l(this, Mt).setCurrentTrack(t);
}, r5 = function() {
  m(this, it, s9).call(this), L(this, Ac, null), L(this, Og, {});
};
function C2(c) {
  return c instanceof Error ? c : Error(typeof c == "string" ? c : JSON.stringify(c));
}
function bc(c, s) {
  if (!c)
    throw Error("Assertion failed.");
}
var cm, Xl, j2, vu, OP, _P, NP, VP;
class bK {
  constructor(s, t, r) {
    k(this, vu);
    k(this, cm);
    k(this, Xl);
    k(this, j2);
    L(this, cm, s), L(this, Xl, t), L(this, j2, r), m(this, vu, OP).call(this);
  }
}
cm = new WeakMap(), Xl = new WeakMap(), j2 = new WeakMap(), vu = new WeakSet(), OP = async function() {
  const s = {
    onLoadStart: m(this, vu, _P).bind(this),
    onLoaded: m(this, vu, NP).bind(this),
    onLoadError: m(this, vu, VP).bind(this)
  };
  let t = await TK(l(this, cm), s);
  if (Di(t) && !qe(l(this, cm)) && (t = await wK(l(this, cm), s)), !t) return null;
  if (!window.dashjs.supportsMediaSource()) {
    const r = "[vidstack] `dash.js` is not supported in this environment";
    return l(this, Xl).player.dispatch(new St("dash-unsupported")), l(this, Xl).notify("error", { message: r, code: 4 }), null;
  }
  return t;
}, _P = function() {
  l(this, Xl).player.dispatch(new St("dash-lib-load-start"));
}, NP = function(s) {
  l(this, Xl).player.dispatch(
    new St("dash-lib-loaded", {
      detail: s
    })
  ), l(this, j2).call(this, s);
}, VP = function(s) {
  const t = C2(s);
  l(this, Xl).player.dispatch(
    new St("dash-lib-load-error", {
      detail: t
    })
  ), l(this, Xl).notify("error", {
    message: t.message,
    code: 4,
    error: t
  });
};
async function wK(c, s = {}) {
  var t, r, f, v, g, T, x;
  if (!Di(c)) {
    if ((t = s.onLoadStart) == null || t.call(s), EK(c))
      return (r = s.onLoaded) == null || r.call(s, c), c;
    if (yD(c)) {
      const $ = c.MediaPlayer;
      return (f = s.onLoaded) == null || f.call(s, $), $;
    }
    try {
      const $ = (v = await c()) == null ? void 0 : v.default;
      if (yD($))
        return (g = s.onLoaded) == null || g.call(s, $.MediaPlayer), $.MediaPlayer;
      if ($)
        (T = s.onLoaded) == null || T.call(s, $);
      else
        throw Error(
          ""
        );
      return $;
    } catch ($) {
      (x = s.onLoadError) == null || x.call(s, $);
    }
  }
}
async function TK(c, s = {}) {
  var t, r, f;
  if (qe(c)) {
    (t = s.onLoadStart) == null || t.call(s);
    try {
      if (await Uk(c), !Ma(window.dashjs.MediaPlayer))
        throw Error(
          ""
        );
      const v = window.dashjs.MediaPlayer;
      return (r = s.onLoaded) == null || r.call(s, v), v;
    } catch (v) {
      (f = s.onLoadError) == null || f.call(s, v);
    }
  }
}
function EK(c) {
  return c && c.prototype && c.prototype !== Function;
}
function yD(c) {
  return c && "MediaPlayer" in c;
}
const kK = "https://cdn.jsdelivr.net";
var G2, Qo, Sf;
class UP extends jk {
  constructor() {
    super(...arguments);
    I(this, "$$PROVIDER_TYPE", "DASH");
    k(this, G2, null);
    k(this, Qo, new SK(this.video, this.ctx));
    k(this, Sf, `${kK}/npm/dashjs@4.7.4/dist/dash.all.min.js`);
  }
  /**
   * The `dash.js` constructor.
   */
  get ctor() {
    return l(this, G2);
  }
  /**
   * The current `dash.js` instance.
   */
  get instance() {
    return l(this, Qo).instance;
  }
  get type() {
    return "dash";
  }
  get canLiveSync() {
    return !0;
  }
  /**
   * The `dash.js` configuration object.
   *
   * @see {@link https://cdn.dashjs.org/latest/jsdoc/module-Settings.html}
   */
  get config() {
    return l(this, Qo).config;
  }
  set config(t) {
    l(this, Qo).config = t;
  }
  /**
   * The `dash.js` constructor (supports dynamic imports) or a URL of where it can be found.
   *
   * @defaultValue `https://cdn.jsdelivr.net/npm/dashjs@4.7.4/dist/dash.all.min.js`
   */
  get library() {
    return l(this, Sf);
  }
  set library(t) {
    L(this, Sf, t);
  }
  preconnect() {
    qe(l(this, Sf)) && ld(l(this, Sf));
  }
  setup() {
    super.setup(), new bK(l(this, Sf), this.ctx, (t) => {
      L(this, G2, t), l(this, Qo).setup(t), this.ctx.notify("provider-setup", this);
      const r = fe(this.ctx.$state.source);
      r && this.loadSource(r);
    });
  }
  async loadSource(t, r) {
    if (!qe(t.src)) {
      this.removeSource();
      return;
    }
    this.media.preload = r || "", this.appendSource(t, "application/x-mpegurl"), l(this, Qo).loadSource(t), this.currentSrc = t;
  }
  /**
   * The given callback is invoked when a new `dash.js` instance is created and right before it's
   * attached to media.
   */
  onInstance(t) {
    const r = l(this, Qo).instance;
    return r && t(r), l(this, Qo).onInstance(t);
  }
  destroy() {
    l(this, Qo).destroy();
  }
}
G2 = new WeakMap(), Qo = new WeakMap(), Sf = new WeakMap(), /**
 * Whether `dash.js` is supported in this environment.
 */
I(UP, "supported", FM());
var xK = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  DASHProvider: UP
});
const G9 = class G9 extends Bk {
  constructor() {
    super(...arguments);
    I(this, "name", "dash");
  }
  canPlay(t) {
    return G9.supported && Vk(t);
  }
  async load(t) {
    if (Oe)
      throw Error("[vidstack] can not load dash provider server-side");
    return new (await Promise.resolve().then(function() {
      return xK;
    })).DASHProvider(this.target, t);
  }
};
I(G9, "supported", FM());
let a5 = G9;
class RK {
  constructor() {
    I(this, "name", "vimeo");
    I(this, "target");
  }
  preconnect() {
    const s = [
      "https://i.vimeocdn.com",
      "https://f.vimeocdn.com",
      "https://fresnel.vimeocdn.com"
    ];
    for (const t of s)
      ld(t);
  }
  canPlay(s) {
    return qe(s.src) && s.type === "video/vimeo";
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    if (Oe)
      throw Error("[vidstack] can not load vimeo provider server-side");
    return new (await Promise.resolve().then(() => Tee)).VimeoProvider(this.target, s);
  }
  async loadPoster(s, t, r) {
    const { resolveVimeoVideoId: f, getVimeoVideoInfo: v } = await Promise.resolve().then(() => See);
    if (!qe(s.src)) return null;
    const { videoId: g, hash: T } = f(s.src);
    return g ? v(g, r, T).then((x) => x ? x.poster : null) : null;
  }
}
class LK {
  constructor() {
    I(this, "name", "youtube");
    I(this, "target");
  }
  preconnect() {
    const s = [
      // Botguard script.
      "https://www.google.com",
      // Posters.
      "https://i.ytimg.com",
      // Ads.
      "https://googleads.g.doubleclick.net",
      "https://static.doubleclick.net"
    ];
    for (const t of s)
      ld(t);
  }
  canPlay(s) {
    return qe(s.src) && s.type === "video/youtube";
  }
  mediaType() {
    return "video";
  }
  async load(s) {
    if (Oe)
      throw Error("[vidstack] can not load youtube provider server-side");
    return new (await Promise.resolve().then(() => Mee)).YouTubeProvider(this.target, s);
  }
  async loadPoster(s, t, r) {
    const { findYouTubePoster: f, resolveYouTubeVideoId: v } = await Promise.resolve().then(() => Ree), g = qe(s.src) && v(s.src);
    return g ? f(g, r) : null;
  }
}
function r7(c, s) {
  const t = String(c), r = t.length;
  if (r < s) {
    const v = s - r;
    return `${"0".repeat(v)}${c}`;
  }
  return t;
}
function zP(c) {
  const s = Math.trunc(c / 3600), t = Math.trunc(c % 3600 / 60), r = Math.trunc(c % 60), f = Number((c - Math.trunc(c)).toPrecision(3));
  return {
    hours: s,
    minutes: t,
    seconds: r,
    fraction: f
  };
}
function Gk(c, { padHrs: s = null, padMins: t = null, showHrs: r = !1, showMs: f = !1 } = {}) {
  const { hours: v, minutes: g, seconds: T, fraction: x } = zP(c), $ = s ? r7(v, 2) : v, P = t || sl(t) && c >= 3600 ? r7(g, 2) : g, A = r7(T, 2), U = f && x > 0 ? `.${String(x).replace(/^0?\./, "")}` : "", F = `${P}:${A}${U}`;
  return v > 0 || r ? `${$}:${F}` : F;
}
function s5(c) {
  const s = [], { hours: t, minutes: r, seconds: f } = zP(c);
  return t > 0 && s.push(`${t} hour`), r > 0 && s.push(`${r} min`), (f > 0 || s.length === 0) && s.push(`${f} sec`), s.join(" ");
}
const a7 = Symbol(0), $K = [
  "autoPlay",
  "canAirPlay",
  "canFullscreen",
  "canGoogleCast",
  "canLoad",
  "canLoadPoster",
  "canPictureInPicture",
  "canPlay",
  "canSeek",
  "ended",
  "fullscreen",
  "isAirPlayConnected",
  "isGoogleCastConnected",
  "live",
  "liveEdge",
  "loop",
  "mediaType",
  "muted",
  "paused",
  "pictureInPicture",
  "playing",
  "playsInline",
  "remotePlaybackState",
  "remotePlaybackType",
  "seeking",
  "started",
  "streamType",
  "viewType",
  "waiting"
], DK = {
  artist: "",
  artwork: null,
  autoplay: !1,
  autoPlay: !1,
  clipStartTime: 0,
  clipEndTime: 0,
  controls: !1,
  currentTime: 0,
  crossorigin: null,
  crossOrigin: null,
  duration: -1,
  fullscreenOrientation: "landscape",
  googleCast: {},
  load: "visible",
  posterLoad: "visible",
  logLevel: "silent",
  loop: !1,
  muted: !1,
  paused: !0,
  playsinline: !1,
  playsInline: !1,
  playbackRate: 1,
  poster: "",
  preload: "metadata",
  preferNativeHLS: !1,
  src: "",
  title: "",
  controlsDelay: 2e3,
  hideControlsOnMouseLeave: !1,
  viewType: "unknown",
  streamType: "unknown",
  volume: 1,
  liveEdgeTolerance: 10,
  minLiveDVRWindow: 60,
  keyDisabled: !1,
  keyTarget: "player",
  keyShortcuts: jW,
  storage: null
};
var Q2, dm;
class gD extends iv {
  constructor(t, r) {
    super();
    k(this, Q2);
    k(this, dm);
    L(this, Q2, t), L(this, dm, r);
  }
  async onAttach(t) {
    if (Oe) return;
    const r = this.$props[l(this, Q2)]();
    if (r === "eager")
      requestAnimationFrame(l(this, dm));
    else if (r === "idle")
      CM(l(this, dm));
    else if (r === "visible") {
      let f, v = new IntersectionObserver((g) => {
        this.scope && g[0].isIntersecting && (f == null || f(), f = void 0, l(this, dm).call(this));
      });
      v.observe(t), f = bt(() => v.disconnect());
    }
  }
}
Q2 = new WeakMap(), dm = new WeakMap();
var Y2, Yo, Q9, HP;
class MK {
  constructor(s, t) {
    k(this, Q9);
    k(this, Y2);
    k(this, Yo);
    L(this, Y2, s), L(this, Yo, t);
  }
  notify(s, ...t) {
    Oe || l(this, Y2).call(this, new St(s, {
      detail: t == null ? void 0 : t[0],
      trigger: t == null ? void 0 : t[1]
    }));
  }
  async ready(s, t) {
    if (!Oe)
      return Gm(async () => {
        var Gt, Lt, Ve, mt, wn, Ye, rt;
        l(this, Yo);
        const {
          autoPlay: r,
          canPlay: f,
          started: v,
          duration: g,
          seekable: T,
          buffered: x,
          remotePlaybackInfo: $,
          playsInline: P,
          savedState: A,
          source: U
        } = l(this, Yo).$state;
        if (f()) return;
        const F = {
          duration: (s == null ? void 0 : s.duration) ?? g(),
          seekable: (s == null ? void 0 : s.seekable) ?? T(),
          buffered: (s == null ? void 0 : s.buffered) ?? x(),
          provider: l(this, Yo).$provider()
        };
        this.notify("can-play", F, t), al();
        let Z = l(this, Yo).$provider(), { storage: ne, qualities: ce } = l(this, Yo), { muted: De, volume: Ne, clipStartTime: Se, playbackRate: je } = l(this, Yo).$props;
        await ((Gt = ne == null ? void 0 : ne.onLoad) == null ? void 0 : Gt.call(ne, U()));
        const Me = (Lt = A()) == null ? void 0 : Lt.currentTime, Ct = (Ve = A()) == null ? void 0 : Ve.paused, Ge = await (ne == null ? void 0 : ne.getTime()), he = Me ?? Ge ?? Se(), Ze = Ct === !1 || Ct !== !0 && !v() && r();
        if (Z) {
          Z.setVolume(await (ne == null ? void 0 : ne.getVolume()) ?? Ne()), Z.setMuted(De() || !!await (ne == null ? void 0 : ne.getMuted()));
          const se = await (ne == null ? void 0 : ne.getAudioGain()) ?? 1;
          se > 1 && ((wn = (mt = Z.audioGain) == null ? void 0 : mt.setGain) == null || wn.call(mt, se)), (Ye = Z.setPlaybackRate) == null || Ye.call(Z, await (ne == null ? void 0 : ne.getPlaybackRate()) ?? je()), (rt = Z.setPlaysInline) == null || rt.call(Z, P()), he > 0 && Z.setCurrentTime(he);
        }
        const pt = await (ne == null ? void 0 : ne.getVideoQuality());
        if (pt && ce.length) {
          let se = null, Le = 1 / 0;
          for (const me of ce) {
            const At = Math.abs(pt.width - me.width) + Math.abs(pt.height - me.height) + (pt.bitrate ? Math.abs(pt.bitrate - (me.bitrate ?? 0)) : 0);
            At < Le && (se = me, Le = At);
          }
          se && (se.selected = !0);
        }
        f() && Ze ? await m(this, Q9, HP).call(this, t) : Ge && Ge > 0 && this.notify("started", void 0, t), $.set(null);
      });
  }
}
Y2 = new WeakMap(), Yo = new WeakMap(), Q9 = new WeakSet(), HP = async function(s) {
  const {
    player: t,
    $state: { autoPlaying: r, muted: f }
  } = l(this, Yo);
  r.set(!0);
  const v = new St("auto-play-attempt", { trigger: s });
  try {
    await t.play(v);
  } catch {
  }
};
var bf;
class AK {
  constructor() {
    k(this, bf, /* @__PURE__ */ new Map());
  }
  /**
   * Queue the given `item` under the given `key` to be processed at a later time by calling
   * `serve(key)`.
   */
  enqueue(s, t) {
    l(this, bf).set(s, t);
  }
  /**
   * Process item in queue for the given `key`.
   */
  serve(s) {
    const t = this.peek(s);
    return l(this, bf).delete(s), t;
  }
  /**
   * Peek at item in queue for the given `key`.
   */
  peek(s) {
    return l(this, bf).get(s);
  }
  /**
   * Removes queued item under the given `key`.
   */
  delete(s) {
    l(this, bf).delete(s);
  }
  /**
   * Clear all items in the queue.
   */
  clear() {
    l(this, bf).clear();
  }
}
bf = new WeakMap();
var wf, _g, Wo, fh, o5, l5;
class FP {
  constructor() {
    k(this, fh);
    k(this, wf, !1);
    k(this, _g, Qm());
    k(this, Wo, /* @__PURE__ */ new Map());
  }
  /**
   * The number of callbacks that are currently in queue.
   */
  get size() {
    return l(this, Wo).size;
  }
  /**
   * Whether items in the queue are being served immediately, otherwise they're queued to
   * be processed later.
   */
  get isServing() {
    return l(this, wf);
  }
  /**
   * Waits for the queue to be flushed (ie: start serving).
   */
  async waitForFlush() {
    l(this, wf) || await l(this, _g).promise;
  }
  /**
   * Queue the given `callback` to be invoked at a later time by either calling the `serve()` or
   * `start()` methods. If the queue has started serving (i.e., `start()` was already called),
   * then the callback will be invoked immediately.
   *
   * @param key - Uniquely identifies this callback so duplicates are ignored.
   * @param callback - The function to call when this item in the queue is being served.
   */
  enqueue(s, t) {
    if (l(this, wf)) {
      t();
      return;
    }
    l(this, Wo).delete(s), l(this, Wo).set(s, t);
  }
  /**
   * Invokes the callback with the given `key` in the queue (if it exists).
   */
  serve(s) {
    var t;
    (t = l(this, Wo).get(s)) == null || t(), l(this, Wo).delete(s);
  }
  /**
   * Flush all queued items and start serving future requests immediately until `stop()` is called.
   */
  start() {
    m(this, fh, o5).call(this), L(this, wf, !0), l(this, Wo).size > 0 && m(this, fh, o5).call(this);
  }
  /**
   * Stop serving requests, they'll be queued until you begin processing again by calling `start()`.
   */
  stop() {
    L(this, wf, !1);
  }
  /**
   * Stop serving requests, empty the request queue, and release any promises waiting for the
   * queue to flush.
   */
  reset() {
    this.stop(), l(this, Wo).clear(), m(this, fh, l5).call(this);
  }
}
wf = new WeakMap(), _g = new WeakMap(), Wo = new WeakMap(), fh = new WeakSet(), o5 = function() {
  for (const s of l(this, Wo).keys()) this.serve(s);
  m(this, fh, l5).call(this);
}, l5 = function() {
  l(this, _g).resolve(), L(this, _g, Qm());
};
function PK(c) {
  return c ? "true" : "false";
}
function Fr(c) {
  return () => PK(c());
}
function OK() {
  return typeof window > "u" ? !1 : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
var Pc, gt, Oc, fm, _c, Fn, Tf, Ot, IP, BP, qP, u5, Ng, c5, d5, jP, GP, QP, YP, WP, KP, hm, ZP, f5, h5, NK;
class _K extends iv {
  constructor(t, r, f) {
    super();
    k(this, Ot);
    k(this, Pc);
    k(this, gt);
    k(this, Oc);
    I(this, "controls");
    k(this, fm);
    k(this, _c);
    k(this, Fn);
    k(this, Tf, new FP());
    k(this, Ng, !1);
    k(this, hm);
    L(this, Pc, t), L(this, gt, r), L(this, Oc, f), L(this, Fn, f.$provider), this.controls = new XW(), L(this, fm, new JW()), L(this, _c, new O9());
  }
  onAttach() {
    this.listen("fullscreen-change", m(this, Ot, ZP).bind(this));
  }
  onConnect(t) {
    const r = Object.getOwnPropertyNames(Object.getPrototypeOf(this)), f = new Cn(t), v = m(this, Ot, qP).bind(this);
    for (const g of r)
      g.startsWith("media-") && f.add(g, v);
    m(this, Ot, IP).call(this), K(m(this, Ot, BP).bind(this)), K(m(this, Ot, jP).bind(this)), K(m(this, Ot, GP).bind(this)), K(m(this, Ot, QP).bind(this)), K(m(this, Ot, YP).bind(this)), K(m(this, Ot, WP).bind(this)), K(m(this, Ot, KP).bind(this));
  }
  onDestroy() {
    try {
      const t = this.createEvent("destroy"), { pictureInPicture: r, fullscreen: f } = this.$state;
      f() && this.exitFullscreen("prefer-media", t), r() && this.exitPictureInPicture(t);
    } catch {
    }
    l(this, Tf).reset();
  }
  async play(t) {
    if (Oe) return;
    const { canPlay: r, paused: f, autoPlaying: v } = this.$state;
    if (m(this, Ot, u5).call(this, t) || !fe(f)) return;
    t && l(this, gt).queue.enqueue("media-play-request", t);
    const g = fe(v);
    try {
      const T = fe(l(this, Fn));
      return s7(T, fe(r)), VK(g), await T.play();
    } catch (T) {
      const x = this.createEvent("play-fail", {
        detail: C2(T),
        trigger: t
      });
      throw x.autoPlay = g, l(this, Pc).handle(x), T;
    }
  }
  async pause(t) {
    if (Oe) return;
    const { canPlay: r, paused: f } = this.$state;
    if (!fe(f)) {
      t && l(this, gt).queue.enqueue("media-pause-request", t);
      try {
        const v = fe(l(this, Fn));
        return s7(v, fe(r)), await v.pause();
      } catch (v) {
        throw l(this, gt).queue.delete("media-pause-request"), v;
      }
    }
  }
  setAudioGain(t, r) {
    const { audioGain: f, canSetAudioGain: v } = this.$state;
    if (f() === t) return;
    const g = l(this, Fn).call(this);
    if (!(g != null && g.audioGain) || !v())
      throw Error("[vidstack] audio gain api not available");
    r && l(this, gt).queue.enqueue("media-audio-gain-change-request", r), g.audioGain.setGain(t);
  }
  seekToLiveEdge(t) {
    if (Oe) return;
    const { canPlay: r, live: f, liveEdge: v, canSeek: g, liveSyncPosition: T, seekableEnd: x, userBehindLiveEdge: $ } = this.$state;
    if ($.set(!1), fe(() => !f() || v() || !g())) return;
    const P = fe(l(this, Fn));
    s7(P, fe(r)), t && l(this, gt).queue.enqueue("media-seek-request", t);
    const A = x() - 2;
    P.setCurrentTime(Math.min(A, T() ?? A));
  }
  async enterFullscreen(t = "prefer-media", r) {
    if (Oe) return;
    const f = m(this, Ot, c5).call(this, t);
    if (CD(t, f), !f.active)
      return fe(this.$state.pictureInPicture) && (L(this, Ng, !0), await this.exitPictureInPicture(r)), r && l(this, gt).queue.enqueue("media-enter-fullscreen-request", r), f.enter();
  }
  async exitFullscreen(t = "prefer-media", r) {
    if (Oe) return;
    const f = m(this, Ot, c5).call(this, t);
    if (CD(t, f), !!f.active) {
      r && l(this, gt).queue.enqueue("media-exit-fullscreen-request", r);
      try {
        const v = await f.exit();
        return l(this, Ng) && fe(this.$state.canPictureInPicture) && await this.enterPictureInPicture(), v;
      } finally {
        L(this, Ng, !1);
      }
    }
  }
  async enterPictureInPicture(t) {
    if (!Oe && (m(this, Ot, d5).call(this), !this.$state.pictureInPicture()))
      return t && l(this, gt).queue.enqueue("media-enter-pip-request", t), await l(this, Fn).call(this).pictureInPicture.enter();
  }
  async exitPictureInPicture(t) {
    if (!Oe && (m(this, Ot, d5).call(this), !!this.$state.pictureInPicture()))
      return t && l(this, gt).queue.enqueue("media-exit-pip-request", t), await l(this, Fn).call(this).pictureInPicture.exit();
  }
  async "media-airplay-request"(t) {
    try {
      await this.requestAirPlay(t);
    } catch {
    }
  }
  async requestAirPlay(t) {
    var r;
    try {
      const f = (r = l(this, Fn).call(this)) == null ? void 0 : r.airPlay;
      if (!(f != null && f.supported))
        throw Error("No AirPlay adapter.");
      return t && l(this, gt).queue.enqueue("media-airplay-request", t), await f.prompt();
    } catch (f) {
      throw l(this, gt).queue.delete("media-airplay-request"), f;
    }
  }
  async "media-google-cast-request"(t) {
    try {
      await this.requestGoogleCast(t);
    } catch {
    }
  }
  async requestGoogleCast(t) {
    try {
      const { canGoogleCast: r } = this.$state;
      if (!fe(r)) {
        const v = Error(
          "Cast not available."
        );
        throw v.code = "CAST_NOT_AVAILABLE", v;
      }
      if (ld("https://www.gstatic.com"), !l(this, hm)) {
        const v = await Promise.resolve().then(() => Uee).then(function(g) {
          return g.loader;
        });
        L(this, hm, new v.GoogleCastLoader());
      }
      await l(this, hm).prompt(l(this, Oc)), t && l(this, gt).queue.enqueue("media-google-cast-request", t);
      const f = fe(this.$state.remotePlaybackState) !== "disconnected";
      f && this.$state.savedState.set({
        paused: fe(this.$state.paused),
        currentTime: fe(this.$state.currentTime)
      }), this.$state.remotePlaybackLoader.set(f ? l(this, hm) : null);
    } catch (r) {
      throw l(this, gt).queue.delete("media-google-cast-request"), r;
    }
  }
  "media-clip-start-change-request"(t) {
    const { clipStartTime: r } = this.$state;
    r.set(t.detail);
  }
  "media-clip-end-change-request"(t) {
    const { clipEndTime: r } = this.$state;
    r.set(t.detail), this.dispatch("duration-change", {
      detail: t.detail,
      trigger: t
    });
  }
  "media-duration-change-request"(t) {
    const { providedDuration: r, clipEndTime: f } = this.$state;
    r.set(t.detail), f() <= 0 && this.dispatch("duration-change", {
      detail: t.detail,
      trigger: t
    });
  }
  "media-audio-track-change-request"(t) {
    const { logger: r, audioTracks: f } = l(this, Oc);
    if (f.readonly)
      return;
    const v = t.detail, g = f[v];
    if (g) {
      const T = t.type;
      l(this, gt).queue.enqueue(T, t), g.selected = !0;
    }
  }
  async "media-enter-fullscreen-request"(t) {
    try {
      await this.enterFullscreen(t.detail, t);
    } catch (r) {
      m(this, Ot, f5).call(this, r, t);
    }
  }
  async "media-exit-fullscreen-request"(t) {
    try {
      await this.exitFullscreen(t.detail, t);
    } catch (r) {
      m(this, Ot, f5).call(this, r, t);
    }
  }
  async "media-orientation-lock-request"(t) {
    const r = t.type;
    try {
      l(this, gt).queue.enqueue(r, t), await l(this, _c).lock(t.detail);
    } catch {
      l(this, gt).queue.delete(r);
    }
  }
  async "media-orientation-unlock-request"(t) {
    const r = t.type;
    try {
      l(this, gt).queue.enqueue(r, t), await l(this, _c).unlock();
    } catch {
      l(this, gt).queue.delete(r);
    }
  }
  async "media-enter-pip-request"(t) {
    try {
      await this.enterPictureInPicture(t);
    } catch (r) {
      m(this, Ot, h5).call(this, r, t);
    }
  }
  async "media-exit-pip-request"(t) {
    try {
      await this.exitPictureInPicture(t);
    } catch (r) {
      m(this, Ot, h5).call(this, r, t);
    }
  }
  "media-live-edge-request"(t) {
    const { live: r, liveEdge: f, canSeek: v } = this.$state;
    if (!(!r() || f() || !v())) {
      l(this, gt).queue.enqueue("media-seek-request", t);
      try {
        this.seekToLiveEdge();
      } catch {
        l(this, gt).queue.delete("media-seek-request");
      }
    }
  }
  async "media-loop-request"(t) {
    try {
      l(this, gt).looping = !0, l(this, gt).replaying = !0, await this.play(t);
    } catch {
      l(this, gt).looping = !1;
    }
  }
  "media-user-loop-change-request"(t) {
    this.$state.userPrefersLoop.set(t.detail);
  }
  async "media-pause-request"(t) {
    if (!this.$state.paused())
      try {
        await this.pause(t);
      } catch {
      }
  }
  async "media-play-request"(t) {
    if (this.$state.paused())
      try {
        await this.play(t);
      } catch {
      }
  }
  "media-rate-change-request"(t) {
    const { playbackRate: r, canSetPlaybackRate: f } = this.$state;
    if (r() === t.detail || !f()) return;
    const v = l(this, Fn).call(this);
    v != null && v.setPlaybackRate && (l(this, gt).queue.enqueue("media-rate-change-request", t), v.setPlaybackRate(t.detail));
  }
  "media-audio-gain-change-request"(t) {
    try {
      this.setAudioGain(t.detail, t);
    } catch {
    }
  }
  "media-quality-change-request"(t) {
    var T, x;
    const { qualities: r, storage: f, logger: v } = l(this, Oc);
    if (r.readonly)
      return;
    l(this, gt).queue.enqueue("media-quality-change-request", t);
    const g = t.detail;
    if (g < 0)
      r.autoSelect(t), t.isOriginTrusted && ((T = f == null ? void 0 : f.setVideoQuality) == null || T.call(f, null));
    else {
      const $ = r[g];
      $ && ($.selected = !0, t.isOriginTrusted && ((x = f == null ? void 0 : f.setVideoQuality) == null || x.call(f, {
        id: $.id,
        width: $.width,
        height: $.height,
        bitrate: $.bitrate
      })));
    }
  }
  "media-pause-controls-request"(t) {
    const r = t.type;
    l(this, gt).queue.enqueue(r, t), this.controls.pause(t);
  }
  "media-resume-controls-request"(t) {
    const r = t.type;
    l(this, gt).queue.enqueue(r, t), this.controls.resume(t);
  }
  "media-seek-request"(t) {
    const { canSeek: r, ended: f, live: v, seekableEnd: g, userBehindLiveEdge: T } = this.$state, x = t.detail;
    f() && (l(this, gt).replaying = !0);
    const $ = t.type;
    l(this, gt).seeking = !1, l(this, gt).queue.delete($);
    const P = QM(x, this.$state);
    !Number.isFinite(P) || !r() || (l(this, gt).queue.enqueue($, t), l(this, Fn).call(this).setCurrentTime(P), v() && t.isOriginTrusted && Math.abs(g() - P) >= 2 && T.set(!0));
  }
  "media-seeking-request"(t) {
    const r = t.type;
    l(this, gt).queue.enqueue(r, t), this.$state.seeking.set(!0), l(this, gt).seeking = !0;
  }
  "media-start-loading"(t) {
    if (this.$state.canLoad()) return;
    const r = t.type;
    l(this, gt).queue.enqueue(r, t), l(this, Pc).handle(this.createEvent("can-load"));
  }
  "media-poster-start-loading"(t) {
    if (this.$state.canLoadPoster()) return;
    const r = t.type;
    l(this, gt).queue.enqueue(r, t), l(this, Pc).handle(this.createEvent("can-load-poster"));
  }
  "media-text-track-change-request"(t) {
    const { index: r, mode: f } = t.detail, v = l(this, Oc).textTracks[r];
    if (v) {
      const g = t.type;
      l(this, gt).queue.enqueue(g, t), v.setMode(f, t);
    }
  }
  "media-mute-request"(t) {
    if (this.$state.muted()) return;
    const r = t.type;
    l(this, gt).queue.enqueue(r, t), l(this, Fn).call(this).setMuted(!0);
  }
  "media-unmute-request"(t) {
    const { muted: r, volume: f } = this.$state;
    if (!r()) return;
    const v = t.type;
    l(this, gt).queue.enqueue(v, t), l(this, Oc).$provider().setMuted(!1), f() === 0 && (l(this, gt).queue.enqueue(v, t), l(this, Fn).call(this).setVolume(0.25));
  }
  "media-volume-change-request"(t) {
    const { muted: r, volume: f } = this.$state, v = t.detail;
    if (f() === v) return;
    const g = t.type;
    l(this, gt).queue.enqueue(g, t), l(this, Fn).call(this).setVolume(v), v > 0 && r() && (l(this, gt).queue.enqueue(g, t), l(this, Fn).call(this).setMuted(!1));
  }
}
Pc = new WeakMap(), gt = new WeakMap(), Oc = new WeakMap(), fm = new WeakMap(), _c = new WeakMap(), Fn = new WeakMap(), Tf = new WeakMap(), Ot = new WeakSet(), IP = function() {
  const { load: t } = this.$props, { canLoad: r } = this.$state;
  if (t() !== "play" || r()) return;
  const f = this.listen("media-play-request", (v) => {
    m(this, Ot, u5).call(this, v), f();
  });
}, BP = function() {
  const t = l(this, Fn).call(this), r = this.$state.canPlay();
  return t && r && l(this, Tf).start(), () => {
    l(this, Tf).stop();
  };
}, qP = function(t) {
  t.stopPropagation(), !t.defaultPrevented && this[t.type] && (fe(l(this, Fn)) ? this[t.type](t) : l(this, Tf).enqueue(t.type, () => {
    fe(l(this, Fn)) && this[t.type](t);
  }));
}, u5 = function(t) {
  const { load: r } = this.$props, { canLoad: f } = this.$state;
  if (r() === "play" && !f()) {
    const v = this.createEvent("media-start-loading", { trigger: t });
    return this.dispatchEvent(v), l(this, Tf).enqueue("media-play-request", async () => {
      try {
        await this.play(v);
      } catch {
      }
    }), !0;
  }
  return !1;
}, Ng = new WeakMap(), c5 = function(t) {
  const r = fe(l(this, Fn));
  return t === "prefer-media" && l(this, fm).supported || t === "media" ? l(this, fm) : r == null ? void 0 : r.fullscreen;
}, d5 = function() {
  if (!this.$state.canPictureInPicture())
    throw Error(
      "[vidstack] no pip support"
    );
}, jP = function() {
  this.controls.defaultDelay = this.$props.controlsDelay();
}, GP = function() {
  var f, v;
  const { canSetAudioGain: t } = this.$state, r = !!((v = (f = l(this, Fn).call(this)) == null ? void 0 : f.audioGain) != null && v.supported);
  t.set(r);
}, QP = function() {
  var f, v;
  const { canAirPlay: t } = this.$state, r = !!((v = (f = l(this, Fn).call(this)) == null ? void 0 : f.airPlay) != null && v.supported);
  t.set(r);
}, YP = function() {
  const { canGoogleCast: t, source: r } = this.$state, f = vw && !mw && qM(r());
  t.set(f);
}, WP = function() {
  var f, v;
  const { canFullscreen: t } = this.$state, r = l(this, fm).supported || !!((v = (f = l(this, Fn).call(this)) == null ? void 0 : f.fullscreen) != null && v.supported);
  t.set(r);
}, KP = function() {
  var f, v;
  const { canPictureInPicture: t } = this.$state, r = !!((v = (f = l(this, Fn).call(this)) == null ? void 0 : f.pictureInPicture) != null && v.supported);
  t.set(r);
}, hm = new WeakMap(), ZP = async function(t) {
  const r = fe(this.$props.fullscreenOrientation), f = t.detail;
  if (!(Di(r) || r === "none" || !l(this, _c).supported))
    if (f) {
      if (l(this, _c).locked) return;
      this.dispatch("media-orientation-lock-request", {
        detail: r,
        trigger: t
      });
    } else l(this, _c).locked && this.dispatch("media-orientation-unlock-request", {
      trigger: t
    });
}, f5 = function(t, r) {
  l(this, Pc).handle(
    this.createEvent("fullscreen-error", {
      detail: C2(t)
    })
  );
}, h5 = function(t, r) {
  l(this, Pc).handle(
    this.createEvent("picture-in-picture-error", {
      detail: C2(t)
    })
  );
}, NK = function(t, r, f) {
};
function s7(c, s) {
  if (!(c && s))
    throw Error(
      "[vidstack] media not ready"
    );
}
function CD(c, s) {
  if (!(s != null && s.supported))
    throw Error(
      "[vidstack] no fullscreen support"
    );
}
function VK(c) {
  if (!(!OK() || !c))
    throw Error(
      "[vidstack] autoplay blocked"
    );
}
class UK {
  constructor() {
    I(this, "seeking", !1);
    I(this, "looping", !1);
    I(this, "replaying", !1);
    I(this, "queue", new AK());
  }
}
const zK = /* @__PURE__ */ new Set([
  "auto-play",
  "auto-play-fail",
  "can-load",
  "sources-change",
  "source-change",
  "load-start",
  "abort",
  "error",
  "loaded-metadata",
  "loaded-data",
  "can-play",
  "play",
  "play-fail",
  "pause",
  "playing",
  "seeking",
  "seeked",
  "waiting"
]);
var Ra, Jt, Ln, pm, Vg, mm, vm, Nc, Ef, ue, XP, JP, of, ii, eO, tO, nO, o9, p5, m5, iO, v5, rO, aO, Ug, y5, l9, sO, oO, lO, g5, C5, S5, uO, b5, cO, zg, dO, w5;
class HK extends iv {
  constructor(t, r) {
    super();
    k(this, ue);
    k(this, Ra);
    k(this, Jt);
    k(this, Ln, /* @__PURE__ */ new Map());
    k(this, pm, !1);
    k(this, Vg, []);
    k(this, mm, [-1, -1]);
    k(this, vm, !1);
    k(this, Nc);
    k(this, Ef, !1);
    k(this, Ug, null);
    I(this, "seeking", mh(
      (t) => {
        const { seeking: r, realCurrentTime: f, paused: v } = this.$state;
        r.set(!0), f.set(t.detail), m(this, ue, ii).call(this, "media-seeking-request", t), v() && (L(this, Nc, t), l(this, zg).call(this)), L(this, mm, [-1, -1]);
      },
      150,
      { leading: !0 }
    ));
    k(this, zg, dw(() => {
      if (!l(this, Nc)) return;
      L(this, vm, !0);
      const { waiting: t, playing: r } = this.$state;
      t.set(!0), r.set(!1);
      const f = this.createEvent("waiting", { trigger: l(this, Nc) });
      l(this, Ln).set("waiting", f), this.dispatch(f), L(this, Nc, void 0), L(this, vm, !1);
    }, 300));
    L(this, Ra, t), L(this, Jt, r);
  }
  onAttach(t) {
    t.setAttribute("aria-busy", "true"), new Cn(this).add("fullscreen-change", this["fullscreen-change"].bind(this)).add("fullscreen-error", this["fullscreen-error"].bind(this)).add("orientation-change", this["orientation-change"].bind(this));
  }
  onConnect(t) {
    K(m(this, ue, oO).bind(this)), m(this, ue, eO).call(this), m(this, ue, tO).call(this), m(this, ue, nO).call(this), m(this, ue, XP).call(this), bt(m(this, ue, JP).bind(this));
  }
  onDestroy() {
    const { audioTracks: t, qualities: r, textTracks: f } = l(this, Jt);
    t[ut.reset](), r[ut.reset](), f[ut.reset](), m(this, ue, l9).call(this);
  }
  handle(t) {
    if (!this.scope) return;
    const r = t.type;
    Gm(() => {
      var f;
      return (f = this[t.type]) == null ? void 0 : f.call(this, t);
    }), Oe || (zK.has(r) && l(this, Ln).set(r, t), this.dispatch(t));
  }
  "provider-change"(t) {
    var v, g;
    const r = l(this, Jt).$provider(), f = t.detail;
    (r == null ? void 0 : r.type) !== (f == null ? void 0 : f.type) && ((v = r == null ? void 0 : r.destroy) == null || v.call(r), (g = r == null ? void 0 : r.scope) == null || g.dispose(), l(this, Jt).$provider.set(t.detail), r && t.detail === null && m(this, ue, g5).call(this, t));
  }
  "provider-loader-change"(t) {
  }
  "auto-play"(t) {
    this.$state.autoPlayError.set(null);
  }
  "auto-play-fail"(t) {
    this.$state.autoPlayError.set(t.detail), m(this, ue, of).call(this);
  }
  "can-load"(t) {
    this.$state.canLoad.set(!0), l(this, Ln).set("can-load", t), l(this, Jt).textTracks[ht.canLoad](), m(this, ue, ii).call(this, "media-start-loading", t);
  }
  "can-load-poster"(t) {
    this.$state.canLoadPoster.set(!0), l(this, Ln).set("can-load-poster", t), m(this, ue, ii).call(this, "media-poster-start-loading", t);
  }
  "media-type-change"(t) {
    const r = l(this, Ln).get("source-change");
    r && t.triggers.add(r);
    const f = this.$state.viewType();
    this.$state.mediaType.set(t.detail);
    const v = this.$state.providedViewType(), g = v === "unknown" ? t.detail : v;
    f !== g && (Oe ? this.$state.inferredViewType.set(g) : setTimeout(() => {
      requestAnimationFrame(() => {
        this.scope && (this.$state.inferredViewType.set(t.detail), this.dispatch("view-type-change", {
          detail: g,
          trigger: t
        }));
      });
    }, 0));
  }
  "stream-type-change"(t) {
    const r = l(this, Ln).get("source-change");
    r && t.triggers.add(r);
    const { streamType: f, inferredStreamType: v } = this.$state;
    v.set(t.detail), t.detail = f();
  }
  "rate-change"(t) {
    var v;
    const { storage: r } = l(this, Jt), { canPlay: f } = this.$state;
    this.$state.playbackRate.set(t.detail), m(this, ue, ii).call(this, "media-rate-change-request", t), f() && ((v = r == null ? void 0 : r.setPlaybackRate) == null || v.call(r, t.detail));
  }
  "remote-playback-change"(t) {
    const { remotePlaybackState: r, remotePlaybackType: f } = this.$state, { type: v, state: g } = t.detail, T = g === "connected";
    f.set(v), r.set(g);
    const x = v === "airplay" ? "media-airplay-request" : "media-google-cast-request";
    if (T)
      m(this, ue, ii).call(this, x, t);
    else {
      const $ = l(this, Ra).queue.peek(x);
      $ && (t.request = $, t.triggers.add($));
    }
  }
  "sources-change"(t) {
    const r = this.$state.sources(), f = t.detail;
    this.$state.sources.set(f), m(this, ue, lO).call(this, r, f, t);
  }
  "source-change"(t) {
    var f, v;
    t.isQualityChange = ((f = t.originEvent) == null ? void 0 : f.type) === "quality-change";
    const r = t.detail;
    m(this, ue, g5).call(this, t, t.isQualityChange), l(this, Ln).set(t.type, t), this.$state.source.set(r), (v = this.el) == null || v.setAttribute("aria-busy", "true");
  }
  abort(t) {
    const r = l(this, Ln).get("source-change");
    r && t.triggers.add(r);
    const f = l(this, Ln).get("can-load");
    f && !t.triggers.hasType("can-load") && t.triggers.add(f);
  }
  "load-start"(t) {
    const r = l(this, Ln).get("source-change");
    r && t.triggers.add(r);
  }
  error(t) {
    this.$state.error.set(t.detail);
    const r = l(this, Ln).get("abort");
    r && t.triggers.add(r);
  }
  "loaded-metadata"(t) {
    const r = l(this, Ln).get("load-start");
    r && t.triggers.add(r);
  }
  "loaded-data"(t) {
    const r = l(this, Ln).get("load-start");
    r && t.triggers.add(r);
  }
  "can-play"(t) {
    var f;
    const r = l(this, Ln).get("loaded-metadata");
    r && t.triggers.add(r), m(this, ue, C5).call(this, t.detail), (f = this.el) == null || f.setAttribute("aria-busy", "false");
  }
  "can-play-through"(t) {
    m(this, ue, C5).call(this, t.detail);
    const r = l(this, Ln).get("can-play");
    r && t.triggers.add(r);
  }
  "duration-change"(t) {
    const { live: r, intrinsicDuration: f, providedDuration: v, clipEndTime: g, ended: T } = this.$state, x = t.detail;
    if (!r()) {
      const $ = Number.isNaN(x) ? 0 : x;
      f.set($), T() && m(this, ue, b5).call(this, t);
    }
    (v() > 0 || g() > 0) && t.stopImmediatePropagation();
  }
  progress(t) {
    const { buffered: r, seekable: f } = this.$state, { buffered: v, seekable: g } = t.detail, T = Gp(v), x = v.length !== r().length, $ = T !== Gp(r()), P = Gp(g), A = g.length !== f().length, U = P !== Gp(f());
    (x || $) && r.set(v), (A || U) && f.set(g);
  }
  play(t) {
    const {
      paused: r,
      autoPlayError: f,
      ended: v,
      autoPlaying: g,
      playsInline: T,
      pointer: x,
      muted: $,
      viewType: P,
      live: A,
      userBehindLiveEdge: U
    } = this.$state;
    if (m(this, ue, S5).call(this), !r()) {
      t.stopImmediatePropagation();
      return;
    }
    t.autoPlay = g();
    const F = l(this, Ln).get("waiting");
    F && t.triggers.add(F), m(this, ue, ii).call(this, "media-play-request", t), l(this, Ln).set("play", t), r.set(!1), f.set(null), t.autoPlay && (this.handle(
      this.createEvent("auto-play", {
        detail: { muted: $() },
        trigger: t
      })
    ), g.set(!1)), (v() || l(this, Ra).replaying) && (l(this, Ra).replaying = !1, v.set(!1), this.handle(this.createEvent("replay", { trigger: t }))), !T() && P() === "video" && x() === "coarse" && l(this, Jt).remote.enterFullscreen("prefer-media", t), A() && !U() && l(this, Jt).remote.seekToLiveEdge(t);
  }
  "play-fail"(t) {
    const { muted: r, autoPlaying: f } = this.$state, v = l(this, Ln).get("play");
    v && t.triggers.add(v), m(this, ue, ii).call(this, "media-play-request", t);
    const { paused: g, playing: T } = this.$state;
    g.set(!0), T.set(!1), m(this, ue, of).call(this), l(this, Ln).set("play-fail", t), t.autoPlay && (this.handle(
      this.createEvent("auto-play-fail", {
        detail: {
          muted: r(),
          error: t.detail
        },
        trigger: t
      })
    ), f.set(!1));
  }
  playing(t) {
    const r = l(this, Ln).get("play"), f = l(this, Ln).get("seeked");
    r ? t.triggers.add(r) : f && t.triggers.add(f), setTimeout(() => m(this, ue, of).call(this), 0);
    const {
      paused: v,
      playing: g,
      live: T,
      liveSyncPosition: x,
      seekableEnd: $,
      started: P,
      currentTime: A,
      seeking: U,
      ended: F
    } = this.$state;
    if (v.set(!1), g.set(!0), U.set(!1), F.set(!1), l(this, Ra).looping) {
      l(this, Ra).looping = !1;
      return;
    }
    if (T() && !P() && A() === 0) {
      const Z = x() ?? $() - 2;
      Number.isFinite(Z) && l(this, Jt).$provider().setCurrentTime(Z);
    }
    this.started(t);
  }
  started(t) {
    const { started: r } = this.$state;
    r() || (r.set(!0), this.handle(this.createEvent("started", { trigger: t })));
  }
  pause(t) {
    var g;
    (g = this.el) != null && g.isConnected || L(this, Ef, !0), m(this, ue, ii).call(this, "media-pause-request", t);
    const r = l(this, Ln).get("seeked");
    r && t.triggers.add(r);
    const { paused: f, playing: v } = this.$state;
    f.set(!0), v.set(!1), l(this, pm) && setTimeout(() => {
      this.handle(this.createEvent("end", { trigger: t })), L(this, pm, !1);
    }, 0), m(this, ue, of).call(this);
  }
  "time-change"(t) {
    if (l(this, Ra).looping) {
      t.stopImmediatePropagation();
      return;
    }
    let { waiting: r, played: f, clipEndTime: v, realCurrentTime: g, currentTime: T } = this.$state, x = t.detail, $ = v();
    g.set(x), m(this, ue, uO).call(this), r.set(!1);
    for (const P of l(this, Jt).textTracks)
      P[ht.updateActiveCues](x, t);
    $ > 0 && x >= $ && (L(this, pm, !0), this.dispatch("media-pause-request", { trigger: t })), m(this, ue, cO).call(this), this.dispatch("time-update", {
      detail: { currentTime: T(), played: f() },
      trigger: t
    });
  }
  "audio-gain-change"(t) {
    var g;
    const { storage: r } = l(this, Jt), { canPlay: f, audioGain: v } = this.$state;
    v.set(t.detail), m(this, ue, ii).call(this, "media-audio-gain-change-request", t), f() && ((g = r == null ? void 0 : r.setAudioGain) == null || g.call(r, v()));
  }
  "volume-change"(t) {
    var x, $;
    const { storage: r } = l(this, Jt), { volume: f, muted: v, canPlay: g } = this.$state, T = t.detail;
    f.set(T.volume), v.set(T.muted || T.volume === 0), m(this, ue, ii).call(this, "media-volume-change-request", t), m(this, ue, ii).call(this, T.muted ? "media-mute-request" : "media-unmute-request", t), g() && ((x = r == null ? void 0 : r.setVolume) == null || x.call(r, f()), ($ = r == null ? void 0 : r.setMuted) == null || $.call(r, v()));
  }
  seeked(t) {
    const { seeking: r, currentTime: f, realCurrentTime: v, paused: g, seekableEnd: T, ended: x, live: $ } = this.$state;
    if (l(this, Ra).seeking)
      r.set(!0), t.stopImmediatePropagation();
    else if (r()) {
      const P = l(this, Ln).get("waiting");
      P && t.triggers.add(P);
      const A = l(this, Ln).get("seeking");
      A && !t.triggers.has(A) && t.triggers.add(A), g() && m(this, ue, w5).call(this), r.set(!1), v.set(t.detail), m(this, ue, ii).call(this, "media-seek-request", t);
      const U = t == null ? void 0 : t.originEvent;
      U != null && U.isTrusted && !(U instanceof MessageEvent) && !/seek/.test(U.type) && this.started(t);
    }
    $() || (Math.floor(f()) !== Math.floor(T()) ? x.set(!1) : this.end(t));
  }
  waiting(t) {
    l(this, vm) || l(this, Ra).seeking || (t.stopImmediatePropagation(), L(this, Nc, t), l(this, zg).call(this));
  }
  end(t) {
    const { loop: r, ended: f } = this.$state;
    if (!(!r() && f())) {
      if (r()) {
        setTimeout(() => {
          requestAnimationFrame(() => {
            m(this, ue, S5).call(this, t), this.dispatch("media-loop-request", { trigger: t });
          });
        }, 10);
        return;
      }
      setTimeout(() => m(this, ue, dO).call(this, t), 0);
    }
  }
  "fullscreen-change"(t) {
    const r = t.detail;
    this.$state.fullscreen.set(r), m(this, ue, ii).call(this, r ? "media-enter-fullscreen-request" : "media-exit-fullscreen-request", t);
  }
  "fullscreen-error"(t) {
    m(this, ue, ii).call(this, "media-enter-fullscreen-request", t), m(this, ue, ii).call(this, "media-exit-fullscreen-request", t);
  }
  "orientation-change"(t) {
    const r = t.detail.lock;
    m(this, ue, ii).call(this, r ? "media-orientation-lock-request" : "media-orientation-unlock-request", t);
  }
  "picture-in-picture-change"(t) {
    const r = t.detail;
    this.$state.pictureInPicture.set(r), m(this, ue, ii).call(this, r ? "media-enter-pip-request" : "media-exit-pip-request", t);
  }
  "picture-in-picture-error"(t) {
    m(this, ue, ii).call(this, "media-enter-pip-request", t), m(this, ue, ii).call(this, "media-exit-pip-request", t);
  }
  "title-change"(t) {
    t.trigger && (t.stopImmediatePropagation(), this.$state.inferredTitle.set(t.detail));
  }
  "poster-change"(t) {
    t.trigger && (t.stopImmediatePropagation(), this.$state.inferredPoster.set(t.detail));
  }
}
Ra = new WeakMap(), Jt = new WeakMap(), Ln = new WeakMap(), pm = new WeakMap(), Vg = new WeakMap(), mm = new WeakMap(), vm = new WeakMap(), Nc = new WeakMap(), Ef = new WeakMap(), ue = new WeakSet(), XP = function() {
  l(this, Ef) && (requestAnimationFrame(() => {
    this.scope && l(this, Jt).remote.play(new St("dom-connect"));
  }), L(this, Ef, !1));
}, JP = function() {
  var t;
  l(this, Ef) || (L(this, Ef, !this.$state.paused()), (t = l(this, Jt).$provider()) == null || t.pause());
}, of = function() {
  m(this, ue, w5).call(this), L(this, pm, !1), l(this, Ra).replaying = !1, l(this, Ra).looping = !1, L(this, vm, !1), L(this, Nc, void 0), l(this, Ln).clear();
}, ii = function(t, r) {
  const f = l(this, Ra).queue.serve(t);
  f && (r.request = f, r.triggers.add(f));
}, eO = function() {
  m(this, ue, o9).call(this), m(this, ue, p5).call(this);
  const t = l(this, Jt).textTracks;
  new Cn(t).add("add", m(this, ue, o9).bind(this)).add("remove", m(this, ue, o9).bind(this)).add("mode-change", m(this, ue, p5).bind(this));
}, tO = function() {
  const t = l(this, Jt).qualities;
  new Cn(t).add("add", m(this, ue, v5).bind(this)).add("remove", m(this, ue, v5).bind(this)).add("change", m(this, ue, rO).bind(this)).add("auto-change", m(this, ue, aO).bind(this)).add("readonly-change", m(this, ue, sO).bind(this));
}, nO = function() {
  const t = l(this, Jt).audioTracks;
  new Cn(t).add("add", m(this, ue, m5).bind(this)).add("remove", m(this, ue, m5).bind(this)).add("change", m(this, ue, iO).bind(this));
}, o9 = function(t) {
  const { textTracks: r } = this.$state;
  r.set(l(this, Jt).textTracks.toArray()), this.dispatch("text-tracks-change", {
    detail: r(),
    trigger: t
  });
}, p5 = function(t) {
  t && m(this, ue, ii).call(this, "media-text-track-change-request", t);
  const r = l(this, Jt).textTracks.selected, { textTrack: f } = this.$state;
  f() !== r && (f.set(r), this.dispatch("text-track-change", {
    detail: r,
    trigger: t
  }));
}, m5 = function(t) {
  const { audioTracks: r } = this.$state;
  r.set(l(this, Jt).audioTracks.toArray()), this.dispatch("audio-tracks-change", {
    detail: r(),
    trigger: t
  });
}, iO = function(t) {
  const { audioTrack: r } = this.$state;
  r.set(l(this, Jt).audioTracks.selected), t && m(this, ue, ii).call(this, "media-audio-track-change-request", t), this.dispatch("audio-track-change", {
    detail: r(),
    trigger: t
  });
}, v5 = function(t) {
  const { qualities: r } = this.$state;
  r.set(l(this, Jt).qualities.toArray()), this.dispatch("qualities-change", {
    detail: r(),
    trigger: t
  });
}, rO = function(t) {
  const { quality: r } = this.$state;
  r.set(l(this, Jt).qualities.selected), t && m(this, ue, ii).call(this, "media-quality-change-request", t), this.dispatch("quality-change", {
    detail: r(),
    trigger: t
  });
}, aO = function() {
  const { qualities: t } = l(this, Jt), r = t.auto;
  this.$state.autoQuality.set(r), r || m(this, ue, l9).call(this);
}, Ug = new WeakMap(), y5 = function() {
  m(this, ue, l9).call(this), L(this, Ug, K(() => {
    const { qualities: t } = l(this, Jt), { mediaWidth: r, mediaHeight: f } = this.$state, v = r(), g = f();
    if (v === 0 || g === 0) return;
    let T = null, x = 1 / 0;
    for (const $ of t) {
      const P = Math.abs($.width - v) + Math.abs($.height - g);
      P < x && (x = P, T = $);
    }
    T && t[ut.select](
      T,
      !0,
      new St("resize", { detail: { width: v, height: g } })
    );
  }));
}, l9 = function() {
  var t;
  (t = l(this, Ug)) == null || t.call(this), L(this, Ug, null);
}, sO = function() {
  this.$state.canSetQuality.set(!l(this, Jt).qualities.readonly);
}, oO = function() {
  const { canSetVolume: t, isGoogleCastConnected: r } = this.$state;
  if (r()) {
    t.set(!1);
    return;
  }
  YY().then(t.set);
}, lO = function(t, r, f) {
  let { qualities: v } = l(this, Jt), g = !1, T = !1;
  for (const x of t) {
    if (!M7(x)) continue;
    if (!r.some((P) => P.src === x.src)) {
      const P = v.getBySrc(x.src);
      P && (v[ut.remove](P, f), T = !0);
    }
  }
  T && !v.length && (this.$state.savedState.set(null), v[ut.reset](f));
  for (const x of r) {
    if (!M7(x) || v.getBySrc(x.src)) continue;
    const $ = {
      id: x.id ?? x.height + "p",
      bitrate: null,
      codec: null,
      ...x,
      selected: !1
    };
    v[ut.add]($, f), g = !0;
  }
  g && !v[zr.enableAuto] && (m(this, ue, y5).call(this), v[zr.enableAuto] = m(this, ue, y5).bind(this), v[zr.setAuto](!0, f));
}, g5 = function(t, r = !1) {
  const { audioTracks: f, qualities: v } = l(this, Jt);
  if (!r) {
    L(this, Vg, []), L(this, mm, [-1, -1]), f[ut.reset](t), v[ut.reset](t), dD(this.$state, r), m(this, ue, of).call(this);
    return;
  }
  dD(this.$state, r), m(this, ue, of).call(this);
}, C5 = function(t) {
  const { seekable: r, buffered: f, intrinsicDuration: v, canPlay: g } = this.$state;
  g.set(!0), f.set(t.buffered), r.set(t.seekable);
  const T = Gp(t.seekable) ?? 1 / 0;
  v.set(T);
}, S5 = function(t) {
  if (!fe(l(this, Jt).$provider)) return;
  const { ended: f, seekableStart: v, clipEndTime: g, currentTime: T, realCurrentTime: x, duration: $ } = this.$state, P = f() || x() < v() || g() > 0 && x() >= g() || Math.abs(T() - $()) < 0.1;
  return P && this.dispatch("media-seek-request", {
    detail: v(),
    trigger: t
  }), P;
}, uO = function() {
  const { currentTime: t, played: r, paused: f } = this.$state;
  f() || (L(this, mm, XY(
    l(this, Vg),
    l(this, mm),
    t()
  )), r.set(new Ui(l(this, Vg))));
}, // Called to update time again incase duration precision has changed.
b5 = function(t) {
  const { clipStartTime: r, clipEndTime: f, duration: v } = this.$state;
  r() > 0 || f() > 0 || this.handle(
    this.createEvent("time-change", {
      detail: v(),
      trigger: t
    })
  );
}, cO = function() {
  var v;
  const { storage: t } = l(this, Jt), { canPlay: r, realCurrentTime: f } = this.$state;
  r() && ((v = t == null ? void 0 : t.setTime) == null || v.call(t, f()));
}, zg = new WeakMap(), dO = function(t) {
  var x;
  const { storage: r } = l(this, Jt), { paused: f, seeking: v, ended: g, duration: T } = this.$state;
  m(this, ue, b5).call(this, t), f() || this.dispatch("pause", { trigger: t }), v() && this.dispatch("seeked", {
    detail: T(),
    trigger: t
  }), g.set(!0), m(this, ue, of).call(this), (x = r == null ? void 0 : r.setTime) == null || x.call(r, T(), !0), this.dispatch("ended", {
    trigger: t
  });
}, w5 = function() {
  l(this, zg).cancel(), this.$state.waiting.set(!1);
};
var jt, fO, hO, IK, pO, mO, vO, yO, gO, CO, SO, bO, wO, TO, EO, kO, xO, RO;
class FK extends iv {
  constructor() {
    super(...arguments);
    k(this, jt);
  }
  onSetup() {
    if (m(this, jt, fO).call(this), Oe) return;
    const t = [
      m(this, jt, pO),
      m(this, jt, vO),
      m(this, jt, TO),
      m(this, jt, EO),
      m(this, jt, gO),
      m(this, jt, SO),
      m(this, jt, bO),
      m(this, jt, kO),
      m(this, jt, RO),
      m(this, jt, xO),
      m(this, jt, yO),
      m(this, jt, wO),
      m(this, jt, CO),
      m(this, jt, hO),
      m(this, jt, mO)
    ];
    for (const r of t)
      K(r.bind(this));
  }
}
jt = new WeakSet(), fO = function() {
  var f;
  const t = {
    duration: "providedDuration",
    loop: "providedLoop",
    poster: "providedPoster",
    streamType: "providedStreamType",
    title: "providedTitle",
    viewType: "providedViewType"
  }, r = /* @__PURE__ */ new Set([
    "currentTime",
    "paused",
    "playbackRate",
    "volume"
  ]);
  for (const v of Object.keys(this.$props))
    r.has(v) || (f = this.$state[t[v] ?? v]) == null || f.set(this.$props[v]());
  this.$state.muted.set(this.$props.muted() || this.$props.volume() === 0);
}, // Sync "provided" props with internal state. Provided props are used to differentiate from
// provider inferred values.
hO = function() {
  const { viewType: t, streamType: r, title: f, poster: v, loop: g } = this.$props, T = this.$state;
  T.providedPoster.set(v()), T.providedStreamType.set(r()), T.providedViewType.set(t()), T.providedTitle.set(f()), T.providedLoop.set(g());
}, IK = function() {
}, pO = function() {
  const { artist: t, artwork: r } = this.$props;
  this.$state.artist.set(t()), this.$state.artwork.set(r());
}, mO = function() {
  const { title: t } = this.$state;
  this.dispatch("title-change", { detail: t() });
}, vO = function() {
  const t = this.$props.autoPlay() || this.$props.autoplay();
  this.$state.autoPlay.set(t), this.dispatch("auto-play-change", { detail: t });
}, yO = function() {
  const t = this.$state.loop();
  this.dispatch("loop-change", { detail: t });
}, gO = function() {
  const t = this.$props.controls();
  this.$state.controls.set(t);
}, CO = function() {
  const { poster: t } = this.$state;
  this.dispatch("poster-change", { detail: t() });
}, SO = function() {
  const t = this.$props.crossOrigin() ?? this.$props.crossorigin(), r = t === !0 ? "" : t;
  this.$state.crossOrigin.set(r);
}, bO = function() {
  const { duration: t } = this.$props;
  this.dispatch("media-duration-change-request", {
    detail: t()
  });
}, wO = function() {
  const t = this.$props.playsInline() || this.$props.playsinline();
  this.$state.playsInline.set(t), this.dispatch("plays-inline-change", { detail: t });
}, TO = function() {
  const { clipStartTime: t } = this.$props;
  this.dispatch("media-clip-start-change-request", {
    detail: t()
  });
}, EO = function() {
  const { clipEndTime: t } = this.$props;
  this.dispatch("media-clip-end-change-request", {
    detail: t()
  });
}, kO = function() {
  this.dispatch("live-change", { detail: this.$state.live() });
}, xO = function() {
  this.$state.liveEdgeTolerance.set(this.$props.liveEdgeTolerance()), this.$state.minLiveDVRWindow.set(this.$props.minLiveDVRWindow());
}, RO = function() {
  this.dispatch("live-edge-change", { detail: this.$state.liveEdge() });
};
const SD = ["play", "pause", "seekforward", "seekbackward", "seekto"];
var yu, LO, $O, DO, MO;
class BK extends iv {
  constructor() {
    super(...arguments);
    k(this, yu);
  }
  onConnect() {
    K(m(this, yu, $O).bind(this)), K(m(this, yu, DO).bind(this));
    const t = m(this, yu, MO).bind(this);
    for (const r of SD)
      navigator.mediaSession.setActionHandler(r, t);
    bt(m(this, yu, LO).bind(this));
  }
}
yu = new WeakSet(), LO = function() {
  for (const t of SD)
    navigator.mediaSession.setActionHandler(t, null);
}, $O = function() {
  const { title: t, artist: r, artwork: f, poster: v } = this.$state;
  navigator.mediaSession.metadata = new MediaMetadata({
    title: t(),
    artist: r(),
    artwork: f() ?? [{ src: v() }]
  });
}, DO = function() {
  const { canPlay: t, paused: r } = this.$state;
  navigator.mediaSession.playbackState = t() ? r() ? "paused" : "playing" : "none";
}, MO = function(t) {
  const r = new St("media-session-action", { detail: t });
  switch (t.action) {
    case "play":
      this.dispatch("media-play-request", { trigger: r });
      break;
    case "pause":
      this.dispatch("media-pause-request", { trigger: r });
      break;
    case "seekto":
    case "seekforward":
    case "seekbackward":
      this.dispatch("media-seek-request", {
        detail: ar(t.seekTime) ? t.seekTime : this.$state.currentTime() + (t.seekOffset ?? (t.action === "seekforward" ? 10 : -10)),
        trigger: r
      });
      break;
  }
};
let V9 = nt(!1);
Oe || (sn(document, "pointerdown", () => {
  V9.set(!1);
}), sn(document, "keydown", (c) => {
  c.metaKey || c.altKey || c.ctrlKey || V9.set(!0);
}));
var kf, gu, AO, PO, OO, _O;
class dl extends Vs {
  constructor() {
    super(...arguments);
    k(this, gu);
    k(this, kf, nt(!1));
  }
  onConnect(t) {
    K(() => {
      const r = new Cn(t);
      if (!V9()) {
        l(this, kf).set(!1), qb(t, !1), r.add("pointerenter", m(this, gu, OO).bind(this)).add("pointerleave", m(this, gu, _O).bind(this));
        return;
      }
      const f = document.activeElement === t;
      l(this, kf).set(f), qb(t, f), r.add("focus", m(this, gu, AO).bind(this)).add("blur", m(this, gu, PO).bind(this));
    });
  }
  focused() {
    return l(this, kf).call(this);
  }
}
kf = new WeakMap(), gu = new WeakSet(), AO = function() {
  l(this, kf).set(!0), qb(this.el, !0);
}, PO = function() {
  l(this, kf).set(!1), qb(this.el, !1);
}, OO = function() {
  bD(this.el, !0);
}, _O = function() {
  bD(this.el, !1);
};
function qb(c, s) {
  lt(c, "data-focus", s), lt(c, "data-hocus", s);
}
function bD(c, s) {
  lt(c, "data-hocus", s), lt(c, "data-hover", s);
}
var uu, Nr, ym, Vr, ke, Es, u9, Hg, T5, E5, VO, UO, zO, f2, k5, HO, x5, FO, R5, IO, L5, BO, $5, qO, D5, jO, GO, QO, YO;
let NO = (uu = class extends Et {
  constructor() {
    super();
    k(this, ke);
    k(this, Nr);
    k(this, ym);
    k(this, Vr);
    I(this, "canPlayQueue", new FP());
    I(this, "remoteControl");
    k(this, Hg, !1);
    /**
     * Controls the screen orientation of the current browser window and dispatches orientation
     * change events on the player.
     */
    I(this, "orientation");
    new FK();
    const t = {
      player: this,
      qualities: new zW(),
      audioTracks: new DW(),
      storage: null,
      $provider: nt(null),
      $providerSetup: nt(!1),
      $props: this.$props,
      $state: this.$state
    };
    t.remote = this.remoteControl = new YM(
      void 0
    ), t.remote.setPlayer(this), t.textTracks = new NW(), t.textTracks[ht.crossOrigin] = this.$state.crossOrigin, t.textRenderers = new _W(t), t.ariaKeys = {}, L(this, Nr, t), Ps(Hk, t), this.orientation = new O9(), new dl(), new QW(t);
    const r = new UK();
    L(this, ym, new HK(r, t)), L(this, Vr, new _K(l(this, ym), r, t)), t.delegate = new MK(l(this, ym).handle.bind(l(this, ym)), t), t.notify = t.delegate.notify.bind(t.delegate), typeof navigator < "u" && "mediaSession" in navigator && new BK(), new gD("load", this.startLoading.bind(this)), new gD("posterLoad", this.startLoadingPoster.bind(this));
  }
  onSetup() {
    m(this, ke, UO).call(this), K(m(this, ke, VO).bind(this)), K(m(this, ke, FO).bind(this)), K(m(this, ke, HO).bind(this)), K(m(this, ke, BO).bind(this)), K(m(this, ke, IO).bind(this)), K(m(this, ke, jO).bind(this)), K(m(this, ke, qO).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-player", ""), hn(t, "tabindex", "0"), hn(t, "role", "region"), K(m(this, ke, QO).bind(this)), Oe ? m(this, ke, T5).call(this) : K(m(this, ke, T5).bind(this)), Oe ? m(this, ke, E5).call(this) : K(m(this, ke, E5).bind(this)), sn(t, "find-media-player", m(this, ke, zO).bind(this));
  }
  onConnect(t) {
    OM && lt(t, "data-iphone", "");
    const r = window.matchMedia("(pointer: coarse)");
    m(this, ke, k5).call(this, r), r.onchange = m(this, ke, k5).bind(this);
    const f = new ResizeObserver(nv(m(this, ke, f2).bind(this)));
    f.observe(t), K(m(this, ke, f2).bind(this)), this.dispatch("media-player-connect", {
      detail: this,
      bubbles: !0,
      composed: !0
    }), bt(() => {
      f.disconnect(), r.onchange = null;
    });
  }
  onDestroy() {
    l(this, Nr).player = null, this.canPlayQueue.reset();
  }
  /**
   * The current media provider.
   */
  get provider() {
    return l(this, ke, Es);
  }
  /**
   * Media controls settings.
   */
  get controls() {
    return l(this, Vr).controls;
  }
  set controls(t) {
    l(this, ke, u9).controls.set(t);
  }
  /**
   * The title of the current media.
   */
  get title() {
    return fe(this.$state.title);
  }
  set title(t) {
    if (l(this, Hg)) {
      L(this, Hg, !1);
      return;
    }
    l(this, ke, u9).title.set(t);
  }
  /**
   * A list of all `VideoQuality` objects representing the set of available video renditions.
   *
   * @see {@link https://vidstack.io/docs/player/api/video-quality}
   */
  get qualities() {
    return l(this, Nr).qualities;
  }
  /**
   * A list of all `AudioTrack` objects representing the set of available audio tracks.
   *
   * @see {@link https://vidstack.io/docs/player/api/audio-tracks}
   */
  get audioTracks() {
    return l(this, Nr).audioTracks;
  }
  /**
   * A list of all `TextTrack` objects representing the set of available text tracks.
   *
   * @see {@link https://vidstack.io/docs/player/api/text-tracks}
   */
  get textTracks() {
    return l(this, Nr).textTracks;
  }
  /**
   * Contains text renderers which are responsible for loading, parsing, and rendering text
   * tracks.
   */
  get textRenderers() {
    return l(this, Nr).textRenderers;
  }
  get duration() {
    return this.$state.duration();
  }
  set duration(t) {
    l(this, ke, u9).duration.set(t);
  }
  get paused() {
    return fe(this.$state.paused);
  }
  set paused(t) {
    m(this, ke, x5).call(this, t);
  }
  get muted() {
    return fe(this.$state.muted);
  }
  set muted(t) {
    m(this, ke, R5).call(this, t);
  }
  get currentTime() {
    return fe(this.$state.currentTime);
  }
  set currentTime(t) {
    m(this, ke, L5).call(this, t);
  }
  get volume() {
    return fe(this.$state.volume);
  }
  set volume(t) {
    m(this, ke, $5).call(this, t);
  }
  get playbackRate() {
    return fe(this.$state.playbackRate);
  }
  set playbackRate(t) {
    m(this, ke, D5).call(this, t);
  }
  /**
   * Begins/resumes playback of the media. If this method is called programmatically before the
   * user has interacted with the player, the promise may be rejected subject to the browser's
   * autoplay policies. This method will throw if called before media is ready for playback.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play}
   */
  async play(t) {
    return l(this, Vr).play(t);
  }
  /**
   * Pauses playback of the media. This method will throw if called before media is ready for
   * playback.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/pause}
   */
  async pause(t) {
    return l(this, Vr).pause(t);
  }
  /**
   * Attempts to display the player in fullscreen. The promise will resolve if successful, and
   * reject if not. This method will throw if any fullscreen API is _not_ currently available.
   *
   * @see {@link https://vidstack.io/docs/player/api/fullscreen}
   */
  async enterFullscreen(t, r) {
    return l(this, Vr).enterFullscreen(t, r);
  }
  /**
   * Attempts to display the player inline by exiting fullscreen. This method will throw if any
   * fullscreen API is _not_ currently available.
   *
   * @see {@link https://vidstack.io/docs/player/api/fullscreen}
   */
  async exitFullscreen(t, r) {
    return l(this, Vr).exitFullscreen(t, r);
  }
  /**
   * Attempts to display the player in picture-in-picture mode. This method will throw if PIP is
   * not supported. This method will also return a `PictureInPictureWindow` if the current
   * provider supports it.
   *
   * @see {@link https://vidstack.io/docs/player/api/picture-in-picture}
   */
  enterPictureInPicture(t) {
    return l(this, Vr).enterPictureInPicture(t);
  }
  /**
   * Attempts to display the player in inline by exiting picture-in-picture mode. This method
   * will throw if not supported.
   *
   * @see {@link https://vidstack.io/docs/player/api/picture-in-picture}
   */
  exitPictureInPicture(t) {
    return l(this, Vr).exitPictureInPicture(t);
  }
  /**
   * Sets the current time to the live edge (i.e., `duration`). This is a no-op for non-live
   * streams and will throw if called before media is ready for playback.
   *
   * @see {@link https://vidstack.io/docs/player/api/live}
   */
  seekToLiveEdge(t) {
    l(this, Vr).seekToLiveEdge(t);
  }
  /**
   * Called when media can begin loading. Calling this method will trigger the initial provider
   * loading process. Calling it more than once has no effect.
   *
   * @see {@link https://vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoading(t) {
    l(this, Nr).notify("can-load", void 0, t);
  }
  /**
   * Called when the poster image can begin loading. Calling it more than once has no effect.
   *
   * @see {@link https://vidstack.io/docs/player/core-concepts/loading#load-strategies}
   */
  startLoadingPoster(t) {
    l(this, Nr).notify("can-load-poster", void 0, t);
  }
  /**
   * Request Apple AirPlay picker to open.
   */
  requestAirPlay(t) {
    return l(this, Vr).requestAirPlay(t);
  }
  /**
   * Request Google Cast device picker to open. The Google Cast framework will be loaded if it
   * hasn't yet.
   */
  requestGoogleCast(t) {
    return l(this, Vr).requestGoogleCast(t);
  }
  /**
   * Set the audio gain, amplifying volume and enabling a maximum volume above 100%.
   *
   * @see {@link https://vidstack.io/docs/player/api/audio-gain}
   */
  setAudioGain(t, r) {
    return l(this, Vr).setAudioGain(t, r);
  }
  destroy() {
    super.destroy(), l(this, Nr).remote.setPlayer(null), this.dispatch("destroy");
  }
}, Nr = new WeakMap(), ym = new WeakMap(), Vr = new WeakMap(), ke = new WeakSet(), Es = function() {
  return l(this, Nr).$provider();
}, u9 = function() {
  return this.$props;
}, Hg = new WeakMap(), T5 = function() {
  const t = this.$el, { title: r, live: f, viewType: v, providedTitle: g } = this.$state, T = f(), x = Dk(v()), $ = x !== "Unknown" ? `${T ? "Live " : ""}${x}` : T ? "Live" : "Media", P = r();
  lt(
    this.el,
    "aria-label",
    `${$} Player` + (P ? ` - ${P}` : "")
  ), !Oe && (t != null && t.hasAttribute("title")) && (L(this, Hg, !0), t == null || t.removeAttribute("title"));
}, E5 = function() {
  const t = this.orientation.landscape ? "landscape" : "portrait";
  this.$state.orientation.set(t), lt(this.el, "data-orientation", t), m(this, ke, f2).call(this);
}, VO = function() {
  this.$state.canPlay() && l(this, ke, Es) ? this.canPlayQueue.start() : this.canPlayQueue.stop();
}, UO = function() {
  if (uu[a7]) {
    this.setAttributes(uu[a7]);
    return;
  }
  const t = {
    "data-load": function() {
      return this.$props.load();
    },
    "data-captions": function() {
      const f = this.$state.textTrack();
      return !!f && os(f);
    },
    "data-ios-controls": function() {
      return this.$state.iOSControls();
    },
    "data-controls": function() {
      return this.controls.showing;
    },
    "data-buffering": function() {
      const { canLoad: f, canPlay: v, waiting: g } = this.$state;
      return f() && (!v() || g());
    },
    "data-error": function() {
      const { error: f } = this.$state;
      return !!f();
    },
    "data-autoplay-error": function() {
      const { autoPlayError: f } = this.$state;
      return !!f();
    }
  }, r = {
    autoPlay: "autoplay",
    canAirPlay: "can-airplay",
    canPictureInPicture: "can-pip",
    pictureInPicture: "pip",
    playsInline: "playsinline",
    remotePlaybackState: "remote-state",
    remotePlaybackType: "remote-type",
    isAirPlayConnected: "airplay",
    isGoogleCastConnected: "google-cast"
  };
  for (const f of $K) {
    const v = "data-" + (r[f] ?? _0(f));
    t[v] = function() {
      return this.$state[f]();
    };
  }
  delete t.title, uu[a7] = t, this.setAttributes(t);
}, zO = function(t) {
  t.detail(this);
}, f2 = function() {
  if (Oe || !this.el) return;
  const t = this.el.clientWidth, r = this.el.clientHeight;
  this.$state.width.set(t), this.$state.height.set(r), Aa(this.el, "--player-width", t + "px"), Aa(this.el, "--player-height", r + "px");
}, k5 = function(t) {
  if (Oe) return;
  const r = t.matches ? "coarse" : "fine";
  lt(this.el, "data-pointer", r), this.$state.pointer.set(r), m(this, ke, f2).call(this);
}, HO = function() {
  m(this, ke, x5).call(this, this.$props.paused());
}, x5 = function(t) {
  t ? this.canPlayQueue.enqueue("paused", () => l(this, Vr).pause()) : this.canPlayQueue.enqueue("paused", () => l(this, Vr).play());
}, FO = function() {
  m(this, ke, R5).call(this, this.$props.muted());
}, R5 = function(t) {
  this.canPlayQueue.enqueue("muted", () => {
    l(this, ke, Es) && l(this, ke, Es).setMuted(t);
  });
}, IO = function() {
  m(this, ke, L5).call(this, this.$props.currentTime());
}, L5 = function(t) {
  this.canPlayQueue.enqueue("currentTime", () => {
    const { currentTime: r } = this.$state;
    t !== fe(r) && fe(() => {
      if (!l(this, ke, Es)) return;
      const f = QM(t, this.$state);
      Number.isFinite(f) && l(this, ke, Es).setCurrentTime(f);
    });
  });
}, BO = function() {
  m(this, ke, $5).call(this, this.$props.volume());
}, $5 = function(t) {
  const r = Fk(0, t, 1);
  this.canPlayQueue.enqueue("volume", () => {
    l(this, ke, Es) && l(this, ke, Es).setVolume(r);
  });
}, qO = function() {
  m(this, ke, D5).call(this, this.$props.playbackRate());
}, D5 = function(t) {
  this.canPlayQueue.enqueue("rate", () => {
    var r, f;
    l(this, ke, Es) && ((f = (r = l(this, ke, Es)).setPlaybackRate) == null || f.call(r, t));
  });
}, jO = function() {
  m(this, ke, GO).call(this, this.$props.playsInline());
}, GO = function(t) {
  this.canPlayQueue.enqueue("playsinline", () => {
    var r, f;
    l(this, ke, Es) && ((f = (r = l(this, ke, Es)).setPlaysInline) == null || f.call(r, t));
  });
}, QO = function() {
  var f;
  let t = this.$props.storage(), r = qe(t) ? new SW() : t;
  if (r != null && r.onChange) {
    const { source: v } = this.$state, g = qe(t) ? t : (f = this.el) == null ? void 0 : f.id, T = sh(m(this, ke, YO).bind(this));
    K(() => r.onChange(v(), T(), g || void 0));
  }
  l(this, Nr).storage = r, l(this, Nr).textTracks.setStorage(r), bt(() => {
    var v;
    (v = r == null ? void 0 : r.onDestroy) == null || v.call(r), l(this, Nr).storage = null, l(this, Nr).textTracks.setStorage(null);
  });
}, YO = function() {
  const { clipStartTime: t, clipEndTime: r } = this.$props, { source: f } = this.$state, v = f();
  return v.src ? `${v.src}:${t()}:${r()}` : null;
}, I(uu, "props", DK), I(uu, "state", N1), uu);
const Dn = NO.prototype;
on(Dn, "canPlayQueue");
on(Dn, "remoteControl");
on(Dn, "provider");
on(Dn, "controls");
on(Dn, "orientation");
on(Dn, "title");
on(Dn, "qualities");
on(Dn, "audioTracks");
on(Dn, "textTracks");
on(Dn, "textRenderers");
on(Dn, "duration");
on(Dn, "paused");
on(Dn, "muted");
on(Dn, "currentTime");
on(Dn, "volume");
on(Dn, "playbackRate");
Fi(Dn, "play");
Fi(Dn, "pause");
Fi(Dn, "enterFullscreen");
Fi(Dn, "exitFullscreen");
Fi(Dn, "enterPictureInPicture");
Fi(Dn, "exitPictureInPicture");
Fi(Dn, "seekToLiveEdge");
Fi(Dn, "startLoading");
Fi(Dn, "startLoadingPoster");
Fi(Dn, "requestAirPlay");
Fi(Dn, "requestGoogleCast");
Fi(Dn, "setAudioGain");
function qK(c, s) {
  return fetch(c, s).then((t) => t.text()).then((t) => /type="static"/.test(t) ? "on-demand" : "live");
}
function WO(c, s) {
  return fetch(c, s).then((t) => t.text()).then((t) => {
    const r = jK(t);
    if (r)
      return WO(
        /^https?:/.test(r) ? r : new URL(r, c).href,
        s
      );
    const f = /EXT-X-PLAYLIST-TYPE:\s*VOD/.test(t) ? "on-demand" : "live";
    return f === "live" && GK(t) >= 10 && (/#EXT-X-DVR-ENABLED:\s*true/.test(t) || t.includes("#EXT-X-DISCONTINUITY")) ? "live:dvr" : f;
  });
}
function jK(c) {
  const s = c.match(/#EXT-X-STREAM-INF:[^\n]+(\n[^\n]+)*/g);
  return s ? s[0].split(`
`)[1].trim() : null;
}
function GK(c) {
  const s = c.split(`
`);
  for (const t of s)
    if (t.startsWith("#EXT-X-TARGETDURATION")) {
      const r = parseFloat(t.split(":")[1]);
      if (!isNaN(r))
        return r;
    }
  return -1;
}
const M5 = /* @__PURE__ */ new Map();
var Fg, Ig, W2, en, Vc, Ai, KO, ZO, A5, P5, O5, XO, JO, e_;
class QK {
  constructor(s, t, r, f = []) {
    k(this, Ai);
    k(this, Fg, !1);
    k(this, Ig);
    k(this, W2);
    k(this, en);
    k(this, Vc);
    L(this, W2, s), L(this, en, t), L(this, Vc, r);
    const v = new a5(), g = new K7(), T = new Bk(), x = new eK(), $ = new LK(), P = new RK(), A = [$, P];
    L(this, Ig, sh(() => {
      const F = t.$state.remotePlaybackLoader(), Z = t.$props.preferNativeHLS() ? [T, x, v, g, ...A, ...f] : [g, T, x, v, ...A, ...f];
      return F ? [F, ...Z] : Z;
    }));
    const { $state: U } = t;
    U.sources.set(wD(t.$props.src()));
    for (const F of U.sources()) {
      const Z = l(this, Ig).call(this).find((ce) => ce.canPlay(F));
      if (!Z) continue;
      const ne = Z.mediaType(F);
      t.$state.source.set(F), t.$state.mediaType.set(ne), t.$state.inferredViewType.set(ne), l(this, Vc).set(Z), L(this, Fg, !0);
      break;
    }
  }
  connect() {
    const s = l(this, Vc).call(this);
    l(this, Fg) && (m(this, Ai, P5).call(this, l(this, en).$state.source(), s), m(this, Ai, O5).call(this, s), L(this, Fg, !1)), K(m(this, Ai, KO).bind(this)), K(m(this, Ai, ZO).bind(this)), K(m(this, Ai, XO).bind(this)), K(m(this, Ai, JO).bind(this)), K(m(this, Ai, e_).bind(this));
  }
}
Fg = new WeakMap(), Ig = new WeakMap(), W2 = new WeakMap(), en = new WeakMap(), Vc = new WeakMap(), Ai = new WeakSet(), KO = function() {
  l(this, en).notify("sources-change", [
    ...wD(l(this, en).$props.src()),
    ...l(this, W2).call(this)
  ]);
}, ZO = function() {
  var g;
  const { $state: s } = l(this, en), t = s.sources(), r = fe(s.source), f = m(this, Ai, A5).call(this, r, t);
  if (((g = t[0]) == null ? void 0 : g.src) && !f.src && !f.type) {
    const { crossOrigin: T } = s, x = g2(T()), $ = new AbortController();
    return Promise.all(
      t.map(
        (P) => qe(P.src) && P.type === "?" ? fetch(P.src, {
          method: "HEAD",
          credentials: x,
          signal: $.signal
        }).then((A) => (P.type = A.headers.get("content-type") || "??", M5.set(P.src, P.type), P)).catch(() => P) : P
      )
    ).then((P) => {
      if ($.signal.aborted) return;
      const A = m(this, Ai, A5).call(this, fe(s.source), P);
      al(), A.src || l(this, en).notify("error", {
        message: "Failed to load resource.",
        code: 4
      });
    }), () => $.abort();
  }
  al();
}, A5 = function(s, t) {
  let r = { src: "", type: "" }, f = null, v = new St("sources-change", { detail: { sources: t } }), g = l(this, Ig).call(this), { started: T, paused: x, currentTime: $, quality: P, savedState: A } = l(this, en).$state;
  for (const U of t) {
    const F = g.find((Z) => Z.canPlay(U));
    if (F) {
      r = U, f = F;
      break;
    }
  }
  if (M7(r)) {
    const U = P(), F = t.find((Z) => Z.src === (U == null ? void 0 : U.src));
    fe(T) ? A.set({
      paused: fe(x),
      currentTime: fe($)
    }) : A.set(null), F && (r = F, v = new St("quality-change", {
      detail: { quality: U }
    }));
  }
  return ED(s, r) || m(this, Ai, P5).call(this, r, f, v), f !== fe(l(this, Vc)) && m(this, Ai, O5).call(this, f, v), r;
}, P5 = function(s, t, r) {
  l(this, en).notify("source-change", s, r), l(this, en).notify("media-type-change", (t == null ? void 0 : t.mediaType(s)) || "unknown", r);
}, O5 = function(s, t) {
  l(this, en).$providerSetup.set(!1), l(this, en).notify("provider-change", null, t), s && fe(() => {
    var r;
    return (r = s.preconnect) == null ? void 0 : r.call(s, l(this, en));
  }), l(this, Vc).set(s), l(this, en).notify("provider-loader-change", s, t);
}, XO = function() {
  const s = l(this, en).$provider();
  if (!(!s || fe(l(this, en).$providerSetup))) {
    if (l(this, en).$state.canLoad()) {
      la(() => s.setup(), s.scope), l(this, en).$providerSetup.set(!0);
      return;
    }
    fe(() => {
      var t;
      return (t = s.preconnect) == null ? void 0 : t.call(s);
    });
  }
}, JO = function() {
  if (!l(this, en).$providerSetup()) return;
  const s = l(this, en).$provider(), t = l(this, en).$state.source(), r = fe(l(this, en).$state.crossOrigin), f = fe(l(this, en).$props.preferNativeHLS);
  if (!ED(s == null ? void 0 : s.currentSrc, t)) {
    if (l(this, en).$state.canLoad()) {
      const v = new AbortController();
      return _1(t) ? (f || !yw()) && WO(t.src, {
        credentials: g2(r),
        signal: v.signal
      }).then((g) => {
        l(this, en).notify("stream-type-change", g);
      }).catch(Ms) : Vk(t) ? qK(t.src, {
        credentials: g2(r),
        signal: v.signal
      }).then((g) => {
        l(this, en).notify("stream-type-change", g);
      }).catch(Ms) : l(this, en).notify("stream-type-change", "on-demand"), fe(() => {
        const g = fe(l(this, en).$state.preload);
        return s == null ? void 0 : s.loadSource(t, g).catch((T) => {
        });
      }), () => v.abort();
    }
    try {
      qe(t.src) && ld(new URL(t.src).origin);
    } catch {
    }
  }
}, e_ = function() {
  const s = l(this, Vc).call(this), { providedPoster: t, source: r, canLoadPoster: f } = l(this, en).$state;
  if (!s || !s.loadPoster || !r() || !f() || t()) return;
  const v = new AbortController(), g = new St("source-change", { detail: r });
  return s.loadPoster(r(), l(this, en), v).then((T) => {
    l(this, en).notify("poster-change", T || "", g);
  }).catch(() => {
    l(this, en).notify("poster-change", "", g);
  }), () => {
    v.abort();
  };
};
function wD(c) {
  return (vr(c) ? c : [c]).map((s) => qe(s) ? { src: s, type: TD(s) } : { ...s, type: TD(s.src, s.type) });
}
function TD(c, s) {
  return qe(s) && s.length ? s : qe(c) && M5.has(c) ? M5.get(c) : !s && _1({ src: c, type: "" }) ? "application/x-mpegurl" : !s && Vk({ src: c, type: "" }) ? "application/dash+xml" : !qe(c) || c.startsWith("blob:") ? "video/object" : c.includes("youtube") || c.includes("youtu.be") ? "video/youtube" : c.includes("vimeo") && !c.includes("progressive_redirect") && !c.includes(".m3u8") ? "video/vimeo" : "?";
}
function ED(c, s) {
  return (c == null ? void 0 : c.src) === (s == null ? void 0 : s.src) && (c == null ? void 0 : c.type) === (s == null ? void 0 : s.type);
}
var K2, xf, Z2, Y9, t_;
class YK {
  constructor(s, t) {
    k(this, Y9);
    k(this, K2);
    k(this, xf);
    k(this, Z2, []);
    L(this, K2, s), L(this, xf, t), K(m(this, Y9, t_).bind(this));
  }
}
K2 = new WeakMap(), xf = new WeakMap(), Z2 = new WeakMap(), Y9 = new WeakSet(), t_ = function() {
  const s = l(this, K2).call(this);
  for (const t of l(this, Z2))
    if (!s.some((r) => r.id === t.id)) {
      const r = t.id && l(this, xf).textTracks.getById(t.id);
      r && l(this, xf).textTracks.remove(r);
    }
  for (const t of s) {
    const r = t.id || Jc.createId(t);
    l(this, xf).textTracks.getById(r) || (t.id = r, l(this, xf).textTracks.add(t));
  }
  L(this, Z2, s);
};
var Kb, Ko, X2, J2, e0, Bg, qg, Ns, i_, _5, N5, V5;
let n_ = (Kb = class extends Et {
  constructor() {
    super(...arguments);
    k(this, Ns);
    k(this, Ko);
    k(this, X2);
    k(this, J2, nt([]));
    k(this, e0, nt([]));
    k(this, Bg, null);
    k(this, qg, -1);
  }
  onSetup() {
    L(this, Ko, bn()), L(this, X2, new QK(
      l(this, J2),
      l(this, Ko),
      this.$state.loader,
      this.$props.loaders()
    ));
  }
  onAttach(t) {
    t.setAttribute("data-media-provider", "");
  }
  onConnect(t) {
    l(this, X2).connect(), new YK(l(this, e0), l(this, Ko));
    const r = new ResizeObserver(nv(m(this, Ns, N5).bind(this)));
    r.observe(t);
    const f = new MutationObserver(m(this, Ns, V5).bind(this));
    f.observe(t, { attributes: !0, childList: !0 }), m(this, Ns, N5).call(this), m(this, Ns, V5).call(this), bt(() => {
      r.disconnect(), f.disconnect();
    });
  }
  load(t) {
    t == null || t.setAttribute("aria-hidden", "true"), window.cancelAnimationFrame(l(this, qg)), L(this, qg, requestAnimationFrame(() => m(this, Ns, i_).call(this, t))), bt(() => {
      window.cancelAnimationFrame(l(this, qg));
    });
  }
  onDestroy() {
    L(this, Bg, null), m(this, Ns, _5).call(this);
  }
}, Ko = new WeakMap(), X2 = new WeakMap(), J2 = new WeakMap(), e0 = new WeakMap(), Bg = new WeakMap(), qg = new WeakMap(), Ns = new WeakSet(), i_ = function(t) {
  if (!this.scope) return;
  const r = this.$state.loader(), { $provider: f } = l(this, Ko);
  l(this, Bg) === r && (r == null ? void 0 : r.target) === t && fe(f) || (m(this, Ns, _5).call(this), L(this, Bg, r), r && (r.target = t || null), !(!r || !t) && r.load(l(this, Ko)).then((v) => {
    this.scope && fe(this.$state.loader) === r && l(this, Ko).notify("provider-change", v);
  }));
}, _5 = function() {
  var t;
  (t = l(this, Ko)) == null || t.notify("provider-change", null);
}, N5 = function() {
  if (!this.el) return;
  const { player: t, $state: r } = l(this, Ko), f = this.el.offsetWidth, v = this.el.offsetHeight;
  t && (r.mediaWidth.set(f), r.mediaHeight.set(v), t.el && (Aa(t.el, "--media-width", f + "px"), Aa(t.el, "--media-height", v + "px")));
}, V5 = function() {
  const t = [], r = [], f = this.el.children;
  for (const v of f)
    if (!v.hasAttribute("data-vds")) {
      if (v instanceof HTMLSourceElement) {
        const g = {
          id: v.id,
          src: v.src,
          type: v.type
        };
        for (const T of ["id", "src", "width", "height", "bitrate", "codec"]) {
          const x = v.getAttribute(`data-${T}`);
          qe(x) && (g[T] = /id|src|codec/.test(T) ? x : Number(x));
        }
        t.push(g);
      } else if (v instanceof HTMLTrackElement) {
        const g = {
          src: v.src,
          kind: v.track.kind,
          language: v.srclang,
          label: v.label,
          default: v.default,
          type: v.getAttribute("data-type")
        };
        r.push({
          id: v.id || Jc.createId(g),
          ...g
        });
      }
    }
  l(this, J2).set(t), l(this, e0).set(r), al();
}, I(Kb, "props", {
  loaders: []
}), I(Kb, "state", new sd({
  loader: null
})), Kb);
const WK = n_.prototype;
Fi(WK, "load");
var Zb, Jl, jg, Pn, r_, a_, s_, o_, l_, Rf, Gg, u_, c9, c_, Ip;
let KK = (Zb = class extends Et {
  constructor() {
    super(...arguments);
    k(this, Pn);
    k(this, Jl);
    k(this, jg, !1);
    k(this, Rf, -1);
    k(this, Gg, -1);
  }
  onSetup() {
    L(this, Jl, bn());
  }
  onAttach(t) {
    t.style.display = "contents";
  }
  onConnect(t) {
    t.setAttribute("data-media-announcer", ""), hn(t, "role", "status"), hn(t, "aria-live", "polite");
    const { busy: r } = this.$state;
    this.setAttributes({
      "aria-busy": () => r() ? "true" : null
    }), L(this, jg, !0), K(m(this, Pn, r_).bind(this)), K(m(this, Pn, l_).bind(this)), K(m(this, Pn, o_).bind(this)), K(m(this, Pn, a_).bind(this)), K(m(this, Pn, s_).bind(this)), K(m(this, Pn, u_).bind(this)), K(m(this, Pn, c_).bind(this)), al(), L(this, jg, !1);
  }
}, Jl = new WeakMap(), jg = new WeakMap(), Pn = new WeakSet(), r_ = function() {
  const { paused: t } = l(this, Jl).$state;
  m(this, Pn, Ip).call(this, t() ? "Pause" : "Play");
}, a_ = function() {
  const { fullscreen: t } = l(this, Jl).$state;
  m(this, Pn, Ip).call(this, t() ? "Enter Fullscreen" : "Exit Fullscreen");
}, s_ = function() {
  const { pictureInPicture: t } = l(this, Jl).$state;
  m(this, Pn, Ip).call(this, t() ? "Enter PiP" : "Exit PiP");
}, o_ = function() {
  const { textTrack: t } = l(this, Jl).$state;
  m(this, Pn, Ip).call(this, t() ? "Closed-Captions On" : "Closed-Captions Off");
}, l_ = function() {
  const { muted: t, volume: r, audioGain: f } = l(this, Jl).$state;
  m(this, Pn, Ip).call(this, t() || r() === 0 ? "Mute" : `${Math.round(r() * (f() ?? 1) * 100)}% ${m(this, Pn, c9).call(this, "Volume")}`);
}, Rf = new WeakMap(), Gg = new WeakMap(), u_ = function() {
  const { seeking: t, currentTime: r } = l(this, Jl).$state, f = t();
  l(this, Rf) > 0 ? (window.clearTimeout(l(this, Gg)), L(this, Gg, window.setTimeout(() => {
    if (!this.scope) return;
    const v = fe(r), g = Math.abs(v - l(this, Rf));
    if (g >= 1) {
      const T = v >= l(this, Rf), x = s5(g);
      m(this, Pn, Ip).call(this, `${m(this, Pn, c9).call(this, T ? "Seek Forward" : "Seek Backward")} ${x}`);
    }
    L(this, Rf, -1), L(this, Gg, -1);
  }, 300))) : f && L(this, Rf, fe(r));
}, c9 = function(t) {
  var f;
  const { translations: r } = this.$props;
  return ((f = r == null ? void 0 : r()) == null ? void 0 : f[t || ""]) ?? t;
}, c_ = function() {
  const { label: t, busy: r } = this.$state, f = m(this, Pn, c9).call(this, t());
  if (l(this, jg)) return;
  r.set(!0);
  const v = window.setTimeout(() => void r.set(!1), 150);
  return this.el && lt(this.el, "aria-label", f), qe(f) && this.dispatch("change", { detail: f }), () => window.clearTimeout(v);
}, Ip = function(t) {
  const { label: r } = this.$state;
  r.set(t);
}, I(Zb, "props", {
  translations: null
}), I(Zb, "state", new sd({
  label: null,
  busy: !1
})), Zb);
var Uc, ed, f_, h_, U5;
class d_ extends Et {
  constructor() {
    super(...arguments);
    k(this, ed);
    k(this, Uc);
  }
  onSetup() {
    L(this, Uc, bn()), K(m(this, ed, h_).bind(this));
  }
  onAttach(t) {
    const { pictureInPicture: r, fullscreen: f } = l(this, Uc).$state;
    Aa(t, "pointer-events", "none"), hn(t, "role", "group"), this.setAttributes({
      "data-visible": m(this, ed, U5).bind(this),
      "data-fullscreen": f,
      "data-pip": r
    }), K(() => {
      this.dispatch("change", { detail: m(this, ed, U5).call(this) });
    }), K(m(this, ed, f_).bind(this)), K(() => {
      const v = f();
      for (const g of ["top", "right", "bottom", "left"])
        Aa(t, `padding-${g}`, v && `env(safe-area-inset-${g})`);
    });
  }
}
Uc = new WeakMap(), ed = new WeakSet(), f_ = function() {
  if (!this.el) return;
  const { nativeControls: t } = l(this, Uc).$state, r = t();
  lt(this.el, "aria-hidden", r ? "true" : null), Aa(this.el, "display", r ? "none" : null);
}, h_ = function() {
  const { controls: t } = l(this, Uc).player, { hideDelay: r, hideOnMouseLeave: f } = this.$props;
  t.defaultDelay = r() === 2e3 ? l(this, Uc).$props.controlsDelay() : r(), t.hideOnMouseLeave = f();
}, U5 = function() {
  const { controlsVisible: t } = l(this, Uc).$state;
  return t();
}, I(d_, "props", {
  hideDelay: 2e3,
  hideOnMouseLeave: !1
});
class ZK extends Et {
  onAttach(s) {
    s.style.pointerEvents || Aa(s, "pointer-events", "auto");
  }
}
var Zo, ah, m_, gm, Cm, eu, d9;
class p_ extends Vs {
  constructor(t) {
    super();
    k(this, ah);
    k(this, Zo);
    k(this, gm, -1);
    k(this, Cm, -1);
    k(this, eu, null);
    L(this, Zo, t), K(m(this, ah, m_).bind(this));
  }
  onDestroy() {
    var t;
    (t = l(this, eu)) == null || t.call(this), L(this, eu, null);
  }
  show(t) {
    var r, f, v;
    m(this, ah, d9).call(this), window.cancelAnimationFrame(l(this, Cm)), L(this, Cm, -1), (r = l(this, eu)) == null || r.call(this), L(this, eu, null), L(this, gm, window.setTimeout(() => {
      L(this, gm, -1);
      const g = l(this, Zo).content();
      g && g.style.removeProperty("display"), fe(() => l(this, Zo).onChange(!0, t));
    }, ((v = (f = l(this, Zo)).showDelay) == null ? void 0 : v.call(f)) ?? 0));
  }
  hide(t) {
    m(this, ah, d9).call(this), fe(() => l(this, Zo).onChange(!1, t)), L(this, Cm, requestAnimationFrame(() => {
      var f;
      m(this, ah, d9).call(this), L(this, Cm, -1);
      const r = l(this, Zo).content();
      if (r) {
        const v = () => {
          r.style.display = "none", L(this, eu, null);
        };
        if (PW(r)) {
          (f = l(this, eu)) == null || f.call(this);
          const T = sn(r, "animationend", v, { once: !0 });
          L(this, eu, T);
        } else
          v();
      }
    }));
  }
}
Zo = new WeakMap(), ah = new WeakSet(), m_ = function() {
  const t = l(this, Zo).trigger();
  if (!t) {
    this.hide();
    return;
  }
  const r = this.show.bind(this), f = this.hide.bind(this);
  l(this, Zo).listen(t, r, f);
}, gm = new WeakMap(), Cm = new WeakMap(), eu = new WeakMap(), d9 = function() {
  window.clearTimeout(l(this, gm)), L(this, gm, -1);
};
const Qp = ad();
let XK = 0;
var Qg, Lf, $f, t0, po, y_, g_, C_, S_, b_;
class v_ extends Et {
  constructor() {
    super();
    k(this, po);
    k(this, Qg, `media-tooltip-${++XK}`);
    k(this, Lf, nt(null));
    k(this, $f, nt(null));
    k(this, t0, nt(!1));
    new dl();
    const { showDelay: t } = this.$props;
    new p_({
      trigger: l(this, Lf),
      content: l(this, $f),
      showDelay: t,
      listen(r, f, v) {
        K(() => {
          V9() && sn(r, "focus", f), sn(r, "blur", v);
        }), new Cn(r).add("touchstart", (g) => g.preventDefault(), { passive: !1 }).add("mouseenter", f).add("mouseleave", v);
      },
      onChange: m(this, po, b_).bind(this)
    });
  }
  onAttach(t) {
    t.style.setProperty("display", "contents");
  }
  onSetup() {
    Ps(Qp, {
      trigger: l(this, Lf),
      content: l(this, $f),
      showing: l(this, t0),
      attachTrigger: m(this, po, y_).bind(this),
      detachTrigger: m(this, po, g_).bind(this),
      attachContent: m(this, po, C_).bind(this),
      detachContent: m(this, po, S_).bind(this)
    });
  }
}
Qg = new WeakMap(), Lf = new WeakMap(), $f = new WeakMap(), t0 = new WeakMap(), po = new WeakSet(), y_ = function(t) {
  var f;
  l(this, Lf).set(t);
  let r = t.getAttribute("data-media-tooltip");
  r && ((f = this.el) == null || f.setAttribute(`data-media-${r}-tooltip`, "")), lt(t, "data-describedby", l(this, Qg));
}, g_ = function(t) {
  t.removeAttribute("data-describedby"), t.removeAttribute("aria-describedby"), l(this, Lf).set(null);
}, C_ = function(t) {
  t.setAttribute("id", l(this, Qg)), t.style.display = "none", hn(t, "role", "tooltip"), l(this, $f).set(t);
}, S_ = function(t) {
  t.removeAttribute("id"), t.removeAttribute("role"), l(this, $f).set(null);
}, b_ = function(t) {
  const r = l(this, Lf).call(this), f = l(this, $f).call(this);
  r && lt(r, "aria-describedby", t ? l(this, Qg) : null);
  for (const v of [this.el, r, f])
    v && lt(v, "data-visible", t);
  l(this, t0).set(t);
}, I(v_, "props", {
  showDelay: 700
});
var Zm, w_, z5;
class JK extends Et {
  constructor() {
    super();
    k(this, Zm);
    new dl();
  }
  onConnect(t) {
    bt(
      eA(() => {
        if (!this.connectScope) return;
        m(this, Zm, w_).call(this);
        const r = gi(Qp);
        bt(() => {
          const f = m(this, Zm, z5).call(this);
          f && r.detachTrigger(f);
        });
      })
    );
  }
}
Zm = new WeakSet(), w_ = function() {
  const t = m(this, Zm, z5).call(this), r = gi(Qp);
  t && r.attachTrigger(t);
}, z5 = function() {
  const t = this.el.firstElementChild;
  return (t == null ? void 0 : t.localName) === "button" || (t == null ? void 0 : t.getAttribute("role")) === "button" ? t : this.el;
};
var td, H5, E_, k_;
class T_ extends Et {
  constructor() {
    super();
    k(this, td);
    new dl();
    const { placement: t } = this.$props;
    this.setAttributes({
      "data-placement": t
    });
  }
  onAttach(t) {
    m(this, td, H5).call(this, t), Object.assign(t.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "max-content"
    });
  }
  onConnect(t) {
    m(this, td, H5).call(this, t);
    const r = gi(Qp);
    bt(() => r.detachContent(t)), bt(
      eA(() => {
        this.connectScope && K(m(this, td, E_).bind(this));
      })
    );
  }
}
td = new WeakSet(), H5 = function(t) {
  gi(Qp).attachContent(t);
}, E_ = function() {
  const { showing: t } = gi(Qp);
  if (!t()) return;
  const { placement: r, offset: f, alignOffset: v } = this.$props;
  return tA(this.el, m(this, td, k_).call(this), r(), {
    offsetVarName: "media-tooltip",
    xOffset: v(),
    yOffset: f()
  });
}, k_ = function() {
  return gi(Qp).trigger();
}, I(T_, "props", {
  placement: "top center",
  offset: 0,
  alignOffset: 0
});
var zc, Cu, x_, R_, L_, $_;
class ca extends Vs {
  constructor(t) {
    super();
    k(this, Cu);
    k(this, zc);
    L(this, zc, t), new dl(), t.keyShortcut && new ZW(t.keyShortcut);
  }
  onSetup() {
    const { disabled: t } = this.$props;
    this.setAttributes({
      "data-pressed": l(this, zc).isPresssed,
      "aria-pressed": m(this, Cu, x_).bind(this),
      "aria-disabled": () => t() ? "true" : null
    });
  }
  onAttach(t) {
    hn(t, "tabindex", "0"), hn(t, "role", "button"), hn(t, "type", "button");
  }
  onConnect(t) {
    const r = uh(t, m(this, Cu, L_).bind(this));
    for (const f of ["click", "touchstart"])
      r.add(f, m(this, Cu, $_).bind(this), {
        passive: !0
      });
  }
}
zc = new WeakMap(), Cu = new WeakSet(), x_ = function() {
  return b2(l(this, zc).isPresssed());
}, R_ = function(t) {
  tM(l(this, zc).isPresssed) && l(this, zc).isPresssed.set((r) => !r);
}, L_ = function(t) {
  if (this.$props.disabled() || this.el.hasAttribute("data-disabled")) {
    t.preventDefault(), t.stopImmediatePropagation();
    return;
  }
  t.preventDefault(), (l(this, zc).onPress ?? m(this, Cu, R_)).call(this, t);
}, $_ = function(t) {
  this.$props.disabled() && (t.preventDefault(), t.stopImmediatePropagation());
}, I(ca, "props", {
  disabled: !1
});
var p7, n0;
let D_ = (p7 = class extends Et {
  constructor() {
    super();
    k(this, n0, nt(!1));
    new ca({
      isPresssed: l(this, n0)
    });
  }
  /**
   * Whether the toggle is currently in a `pressed` state.
   */
  get pressed() {
    return l(this, n0).call(this);
  }
}, n0 = new WeakMap(), I(p7, "props", {
  disabled: !1,
  defaultPressed: !1
}), p7);
const eZ = D_.prototype;
on(eZ, "pressed");
var m7, Hc, Su, M_, A_, P_, O_;
let tZ = (m7 = class extends Et {
  constructor() {
    super();
    k(this, Su);
    k(this, Hc);
    new ca({
      isPresssed: m(this, Su, A_).bind(this),
      onPress: m(this, Su, M_).bind(this)
    });
  }
  onSetup() {
    L(this, Hc, bn());
    const { canAirPlay: t, isAirPlayConnected: r } = l(this, Hc).$state;
    this.setAttributes({
      "data-active": r,
      "data-supported": t,
      "data-state": m(this, Su, P_).bind(this),
      "aria-hidden": Fr(() => !t())
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-tooltip", "airplay"), vh(t, m(this, Su, O_).bind(this));
  }
}, Hc = new WeakMap(), Su = new WeakSet(), M_ = function(t) {
  l(this, Hc).remote.requestAirPlay(t);
}, A_ = function() {
  const { remotePlaybackType: t, remotePlaybackState: r } = l(this, Hc).$state;
  return t() === "airplay" && r() !== "disconnected";
}, P_ = function() {
  const { remotePlaybackType: t, remotePlaybackState: r } = l(this, Hc).$state;
  return t() === "airplay" && r();
}, O_ = function() {
  const { remotePlaybackState: t } = l(this, Hc).$state;
  return `AirPlay ${t()}`;
}, I(m7, "props", ca.props), m7);
var v7, Fc, bu, __, N_, V_, U_;
let nZ = (v7 = class extends Et {
  constructor() {
    super();
    k(this, bu);
    k(this, Fc);
    new ca({
      isPresssed: m(this, bu, N_).bind(this),
      onPress: m(this, bu, __).bind(this)
    });
  }
  onSetup() {
    L(this, Fc, bn());
    const { canGoogleCast: t, isGoogleCastConnected: r } = l(this, Fc).$state;
    this.setAttributes({
      "data-active": r,
      "data-supported": t,
      "data-state": m(this, bu, V_).bind(this),
      "aria-hidden": Fr(() => !t())
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-tooltip", "google-cast"), vh(t, m(this, bu, U_).bind(this));
  }
}, Fc = new WeakMap(), bu = new WeakSet(), __ = function(t) {
  l(this, Fc).remote.requestGoogleCast(t);
}, N_ = function() {
  const { remotePlaybackType: t, remotePlaybackState: r } = l(this, Fc).$state;
  return t() === "google-cast" && r() !== "disconnected";
}, V_ = function() {
  const { remotePlaybackType: t, remotePlaybackState: r } = l(this, Fc).$state;
  return t() === "google-cast" && r();
}, U_ = function() {
  const { remotePlaybackState: t } = l(this, Fc).$state;
  return `Google Cast ${t()}`;
}, I(v7, "props", ca.props), v7);
var y7, Sm, Xm, z_, F5;
let iZ = (y7 = class extends Et {
  constructor() {
    super();
    k(this, Xm);
    k(this, Sm);
    new ca({
      isPresssed: m(this, Xm, F5).bind(this),
      keyShortcut: "togglePaused",
      onPress: m(this, Xm, z_).bind(this)
    });
  }
  onSetup() {
    L(this, Sm, bn());
    const { paused: t, ended: r } = l(this, Sm).$state;
    this.setAttributes({
      "data-paused": t,
      "data-ended": r
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-tooltip", "play"), vh(t, "Play");
  }
}, Sm = new WeakMap(), Xm = new WeakSet(), z_ = function(t) {
  const r = l(this, Sm).remote;
  m(this, Xm, F5).call(this) ? r.pause(t) : r.play(t);
}, F5 = function() {
  const { paused: t } = l(this, Sm).$state;
  return !t();
}, I(y7, "props", ca.props), y7);
var g7, bm, wu, H_, I5, B5;
let rZ = (g7 = class extends Et {
  constructor() {
    super();
    k(this, wu);
    k(this, bm);
    new ca({
      isPresssed: m(this, wu, I5).bind(this),
      keyShortcut: "toggleCaptions",
      onPress: m(this, wu, H_).bind(this)
    });
  }
  onSetup() {
    L(this, bm, bn()), this.setAttributes({
      "data-active": m(this, wu, I5).bind(this),
      "data-supported": () => !m(this, wu, B5).call(this),
      "aria-hidden": Fr(m(this, wu, B5).bind(this))
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-tooltip", "caption"), vh(t, "Captions");
  }
}, bm = new WeakMap(), wu = new WeakSet(), H_ = function(t) {
  l(this, bm).remote.toggleCaptions(t);
}, I5 = function() {
  const { textTrack: t } = l(this, bm).$state, r = t();
  return !!r && os(r);
}, B5 = function() {
  const { hasCaptions: t } = l(this, bm).$state;
  return !t();
}, I(g7, "props", ca.props), g7);
var C7, Df, nd, F_, q5, I_;
let aZ = (C7 = class extends Et {
  constructor() {
    super();
    k(this, nd);
    k(this, Df);
    new ca({
      isPresssed: m(this, nd, q5).bind(this),
      keyShortcut: "toggleFullscreen",
      onPress: m(this, nd, F_).bind(this)
    });
  }
  onSetup() {
    L(this, Df, bn());
    const { fullscreen: t } = l(this, Df).$state, r = m(this, nd, I_).bind(this);
    this.setAttributes({
      "data-active": t,
      "data-supported": r,
      "aria-hidden": Fr(() => !r())
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-tooltip", "fullscreen"), vh(t, "Fullscreen");
  }
}, Df = new WeakMap(), nd = new WeakSet(), F_ = function(t) {
  const r = l(this, Df).remote, f = this.$props.target();
  m(this, nd, q5).call(this) ? r.exitFullscreen(f, t) : r.enterFullscreen(f, t);
}, q5 = function() {
  const { fullscreen: t } = l(this, Df).$state;
  return t();
}, I_ = function() {
  const { canFullscreen: t } = l(this, Df).$state;
  return t();
}, I(C7, "props", {
  ...ca.props,
  target: "prefer-media"
}), C7);
var S7, wm, cu, B_, f9, q_;
let sZ = (S7 = class extends Et {
  constructor() {
    super();
    k(this, cu);
    k(this, wm);
    new ca({
      isPresssed: m(this, cu, f9).bind(this),
      keyShortcut: "toggleMuted",
      onPress: m(this, cu, B_).bind(this)
    });
  }
  onSetup() {
    L(this, wm, bn()), this.setAttributes({
      "data-muted": m(this, cu, f9).bind(this),
      "data-state": m(this, cu, q_).bind(this)
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-mute-button", ""), t.setAttribute("data-media-tooltip", "mute"), vh(t, "Mute");
  }
}, wm = new WeakMap(), cu = new WeakSet(), B_ = function(t) {
  const r = l(this, wm).remote;
  m(this, cu, f9).call(this) ? r.unmute(t) : r.mute(t);
}, f9 = function() {
  const { muted: t, volume: r } = l(this, wm).$state;
  return t() || r() === 0;
}, q_ = function() {
  const { muted: t, volume: r } = l(this, wm).$state, f = r();
  if (t() || f === 0) return "muted";
  if (f >= 0.5) return "high";
  if (f < 0.5) return "low";
}, I(S7, "props", ca.props), S7);
var b7, Mf, id, j_, j5, G_;
let oZ = (b7 = class extends Et {
  constructor() {
    super();
    k(this, id);
    k(this, Mf);
    new ca({
      isPresssed: m(this, id, j5).bind(this),
      keyShortcut: "togglePictureInPicture",
      onPress: m(this, id, j_).bind(this)
    });
  }
  onSetup() {
    L(this, Mf, bn());
    const { pictureInPicture: t } = l(this, Mf).$state, r = m(this, id, G_).bind(this);
    this.setAttributes({
      "data-active": t,
      "data-supported": r,
      "aria-hidden": Fr(() => !r())
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-tooltip", "pip"), vh(t, "PiP");
  }
}, Mf = new WeakMap(), id = new WeakSet(), j_ = function(t) {
  const r = l(this, Mf).remote;
  m(this, id, j5).call(this) ? r.exitPictureInPicture(t) : r.enterPictureInPicture(t);
}, j5 = function() {
  const { pictureInPicture: t } = l(this, Mf).$state;
  return t();
}, G_ = function() {
  const { canPictureInPicture: t } = l(this, Mf).$state;
  return t();
}, I(b7, "props", ca.props), b7);
var w7, Af, hh, Q_, Y_, W_;
let lZ = (w7 = class extends Et {
  constructor() {
    super();
    k(this, hh);
    k(this, Af);
    new dl();
  }
  onSetup() {
    L(this, Af, bn());
    const { seeking: t } = l(this, Af).$state, { seconds: r } = this.$props, f = m(this, hh, Q_).bind(this);
    this.setAttributes({
      seconds: r,
      "data-seeking": t,
      "data-supported": f,
      "aria-hidden": Fr(() => !f())
    });
  }
  onAttach(t) {
    hn(t, "tabindex", "0"), hn(t, "role", "button"), hn(t, "type", "button"), t.setAttribute("data-media-tooltip", "seek"), vh(t, m(this, hh, Y_).bind(this));
  }
  onConnect(t) {
    uh(t, m(this, hh, W_).bind(this));
  }
}, Af = new WeakMap(), hh = new WeakSet(), Q_ = function() {
  const { canSeek: t } = l(this, Af).$state;
  return t();
}, Y_ = function() {
  const { seconds: t } = this.$props;
  return `Seek ${t() > 0 ? "forward" : "backward"} ${t()} seconds`;
}, W_ = function(t) {
  const { seconds: r, disabled: f } = this.$props;
  if (f()) return;
  const { currentTime: v } = l(this, Af).$state, g = v() + r();
  l(this, Af).remote.seek(g, t);
}, I(w7, "props", {
  disabled: !1,
  seconds: 30
}), w7);
var T7, Tm, W9, K_;
let uZ = (T7 = class extends Et {
  constructor() {
    super();
    k(this, W9);
    k(this, Tm);
    new dl();
  }
  onSetup() {
    L(this, Tm, bn());
    const { disabled: t } = this.$props, { live: r, liveEdge: f } = l(this, Tm).$state, v = () => !r();
    this.setAttributes({
      "data-edge": f,
      "data-hidden": v,
      "aria-disabled": Fr(() => t() || f()),
      "aria-hidden": Fr(v)
    });
  }
  onAttach(t) {
    hn(t, "tabindex", "0"), hn(t, "role", "button"), hn(t, "type", "button"), t.setAttribute("data-media-tooltip", "live");
  }
  onConnect(t) {
    uh(t, m(this, W9, K_).bind(this));
  }
}, Tm = new WeakMap(), W9 = new WeakSet(), K_ = function(t) {
  const { disabled: r } = this.$props, { liveEdge: f } = l(this, Tm).$state;
  r() || f() || l(this, Tm).remote.seekToLiveEdge(t);
}, I(T7, "props", {
  disabled: !1
}), T7);
const rv = new sd({
  min: 0,
  max: 100,
  value: 0,
  step: 1,
  pointerValue: 0,
  focused: !1,
  dragging: !1,
  pointing: !1,
  hidden: !1,
  get active() {
    return this.dragging || this.focused || this.pointing;
  },
  get fillRate() {
    return kD(this.min, this.max, this.value);
  },
  get fillPercent() {
    return this.fillRate * 100;
  },
  get pointerRate() {
    return kD(this.min, this.max, this.pointerValue);
  },
  get pointerPercent() {
    return this.pointerRate * 100;
  }
});
function kD(c, s, t) {
  const r = s - c, f = t - c;
  return r > 0 ? f / r : 0;
}
var Yg, Pf, K9, X_;
class Z_ extends Vs {
  constructor(t) {
    super();
    k(this, K9);
    k(this, Yg);
    k(this, Pf);
    L(this, Yg, t);
  }
  onConnect(t) {
    L(this, Pf, new IntersectionObserver((r) => {
      var f, v;
      (v = (f = l(this, Yg)).callback) == null || v.call(f, r, l(this, Pf));
    }, l(this, Yg))), l(this, Pf).observe(t), bt(m(this, K9, X_).bind(this));
  }
}
Yg = new WeakMap(), Pf = new WeakMap(), K9 = new WeakSet(), /**
 * Disconnect any active intersection observers.
 */
X_ = function() {
  var t;
  (t = l(this, Pf)) == null || t.disconnect(), L(this, Pf, void 0);
};
const Qk = ad(), S2 = ad();
function cZ(c, s, t, r) {
  return Fk(c, Hr(t, N7(r)), s);
}
function dZ(c, s, t, r) {
  const f = Fk(0, t, 1), v = s - c, g = v * f, T = g / r, x = r * Math.round(T);
  return c + x;
}
const o7 = {
  Left: -1,
  ArrowLeft: -1,
  Up: 1,
  ArrowUp: 1,
  Right: 1,
  ArrowRight: 1,
  Down: -1,
  ArrowDown: -1
};
var Ur, Of, Wg, ze, J_, _f, Xo, Ic, eN, tN, nN, iN, rN, h9, lf, h2, aN, sN, oN, lN, p9, G5, Kg, Bc, uN, cN, Q5, Y5, dN, fN, Z9;
class fZ extends Vs {
  constructor(t, r) {
    super();
    k(this, ze);
    k(this, Ur);
    k(this, Of);
    k(this, Wg);
    k(this, _f, null);
    k(this, Xo, null);
    k(this, Ic, null);
    // -------------------------------------------------------------------------------------------
    // Keyboard Events
    // -------------------------------------------------------------------------------------------
    k(this, Kg);
    k(this, Bc, !1);
    k(this, Z9, mh(
      (t) => {
        m(this, ze, lf).call(this, m(this, ze, h2).call(this, t), t);
      },
      20,
      { leading: !0 }
    ));
    L(this, Ur, t), L(this, Of, r);
  }
  onSetup() {
    fu(S2) && L(this, Wg, gi(S2));
  }
  onConnect(t) {
    K(m(this, ze, nN).bind(this, t)), K(m(this, ze, iN).bind(this, t)), l(this, Ur).swipeGesture && K(m(this, ze, J_).bind(this));
  }
}
Ur = new WeakMap(), Of = new WeakMap(), Wg = new WeakMap(), ze = new WeakSet(), J_ = function() {
  var r;
  const { pointer: t } = l(this, Of).$state;
  if (t() !== "coarse" || !l(this, Ur).swipeGesture()) {
    L(this, _f, null);
    return;
  }
  L(this, _f, (r = l(this, Of).player.el) == null ? void 0 : r.querySelector(
    "media-provider,[data-media-provider]"
  )), l(this, _f) && new Cn(l(this, _f)).add("touchstart", m(this, ze, eN).bind(this), {
    passive: !0
  }).add("touchmove", m(this, ze, tN).bind(this), { passive: !1 });
}, _f = new WeakMap(), Xo = new WeakMap(), Ic = new WeakMap(), eN = function(t) {
  L(this, Xo, t.touches[0]);
}, tN = function(t) {
  if (sl(l(this, Xo)) || Ik(t)) return;
  const r = t.touches[0], f = r.clientX - l(this, Xo).clientX, v = r.clientY - l(this, Xo).clientY, g = this.$state.dragging();
  !g && Math.abs(v) > 5 || g || (t.preventDefault(), Math.abs(f) > 20 && (L(this, Xo, r), L(this, Ic, this.$state.value()), m(this, ze, p9).call(this, l(this, Ic), t)));
}, nN = function(t) {
  const { hidden: r } = this.$props;
  sn(t, "focus", m(this, ze, rN).bind(this)), !(r() || l(this, Ur).isDisabled()) && new Cn(t).add("keyup", m(this, ze, cN).bind(this)).add("keydown", m(this, ze, uN).bind(this)).add("pointerenter", m(this, ze, aN).bind(this)).add("pointermove", m(this, ze, sN).bind(this)).add("pointerleave", m(this, ze, oN).bind(this)).add("pointerdown", m(this, ze, lN).bind(this));
}, iN = function(t) {
  l(this, Ur).isDisabled() || !this.$state.dragging() || new Cn(document).add("pointerup", m(this, ze, dN).bind(this), { capture: !0 }).add("pointermove", l(this, Z9).bind(this)).add("touchmove", m(this, ze, fN).bind(this), {
    passive: !1
  });
}, rN = function() {
  m(this, ze, lf).call(this, this.$state.value());
}, h9 = function(t, r) {
  var P, A, U, F;
  const { value: f, min: v, max: g, dragging: T } = this.$state, x = Math.max(v(), Math.min(t, g()));
  f.set(x);
  const $ = this.createEvent("value-change", { detail: x, trigger: r });
  if (this.dispatch($), (A = (P = l(this, Ur)).onValueChange) == null || A.call(P, $), T()) {
    const Z = this.createEvent("drag-value-change", { detail: x, trigger: r });
    this.dispatch(Z), (F = (U = l(this, Ur)).onDragValueChange) == null || F.call(U, Z);
  }
}, lf = function(t, r) {
  const { pointerValue: f, dragging: v } = this.$state;
  f.set(t), this.dispatch("pointer-value-change", { detail: t, trigger: r }), v() && m(this, ze, h9).call(this, t, r);
}, h2 = function(t) {
  let r, f = this.el.getBoundingClientRect(), { min: v, max: g } = this.$state;
  if (this.$props.orientation() === "vertical") {
    const { bottom: T, height: x } = f;
    r = (T - t.clientY) / x;
  } else if (l(this, Xo) && ar(l(this, Ic))) {
    const { width: T } = l(this, _f).getBoundingClientRect(), x = (t.clientX - l(this, Xo).clientX) / T, $ = g() - v(), P = $ * Math.abs(x);
    r = (x < 0 ? l(this, Ic) - P : l(this, Ic) + P) / $;
  } else {
    const { left: T, width: x } = f;
    r = (t.clientX - T) / x;
  }
  return Math.max(
    v(),
    Math.min(
      g(),
      l(this, Ur).roundValue(
        dZ(v(), g(), r, l(this, Ur).getStep())
      )
    )
  );
}, aN = function(t) {
  this.$state.pointing.set(!0);
}, sN = function(t) {
  const { dragging: r } = this.$state;
  r() || m(this, ze, lf).call(this, m(this, ze, h2).call(this, t), t);
}, oN = function(t) {
  this.$state.pointing.set(!1);
}, lN = function(t) {
  if (t.button !== 0) return;
  const r = m(this, ze, h2).call(this, t);
  m(this, ze, p9).call(this, r, t), m(this, ze, lf).call(this, r, t);
}, p9 = function(t, r) {
  var g, T, x, $;
  const { dragging: f } = this.$state;
  if (f()) return;
  f.set(!0), l(this, Of).remote.pauseControls(r);
  const v = this.createEvent("drag-start", { detail: t, trigger: r });
  this.dispatch(v), (T = (g = l(this, Ur)).onDragStart) == null || T.call(g, v), ($ = (x = l(this, Wg)) == null ? void 0 : x.onDragStart) == null || $.call(x);
}, G5 = function(t, r) {
  var g, T, x, $;
  const { dragging: f } = this.$state;
  if (!f()) return;
  f.set(!1), l(this, Of).remote.resumeControls(r);
  const v = this.createEvent("drag-end", { detail: t, trigger: r });
  this.dispatch(v), (T = (g = l(this, Ur)).onDragEnd) == null || T.call(g, v), L(this, Xo, null), L(this, Ic, null), ($ = (x = l(this, Wg)) == null ? void 0 : x.onDragEnd) == null || $.call(x);
}, Kg = new WeakMap(), Bc = new WeakMap(), uN = function(t) {
  if (!Object.keys(o7).includes(t.key)) return;
  const { key: f } = t, v = m(this, ze, Q5).call(this, t);
  if (!sl(v)) {
    m(this, ze, lf).call(this, v, t), m(this, ze, h9).call(this, v, t);
    return;
  }
  const g = m(this, ze, Y5).call(this, t);
  l(this, Bc) || (L(this, Bc, f === l(this, Kg)), !this.$state.dragging() && l(this, Bc) && m(this, ze, p9).call(this, g, t)), m(this, ze, lf).call(this, g, t), L(this, Kg, f);
}, cN = function(t) {
  if (!Object.keys(o7).includes(t.key) || !sl(m(this, ze, Q5).call(this, t))) return;
  const f = l(this, Bc) ? this.$state.pointerValue() : m(this, ze, Y5).call(this, t);
  m(this, ze, h9).call(this, f, t), m(this, ze, G5).call(this, f, t), L(this, Kg, ""), L(this, Bc, !1);
}, Q5 = function(t) {
  let r = t.key, { min: f, max: v } = this.$state;
  return r === "Home" || r === "PageUp" ? f() : r === "End" || r === "PageDown" ? v() : !t.metaKey && /^[0-9]$/.test(r) ? (v() - f()) / 10 * Number(r) : null;
}, Y5 = function(t) {
  var De, Ne;
  const { key: r, shiftKey: f } = t;
  t.preventDefault(), t.stopPropagation();
  const { shiftKeyMultiplier: v } = this.$props, { min: g, max: T, value: x, pointerValue: $ } = this.$state, P = l(this, Ur).getStep(), A = l(this, Ur).getKeyStep(), U = f ? A * v() : A, F = Number(o7[r]), Z = U * F, ne = l(this, Bc) ? $() : ((Ne = (De = l(this, Ur)).getValue) == null ? void 0 : Ne.call(De)) ?? x(), ce = (ne + Z) / P;
  return Math.max(g(), Math.min(T(), Number((P * ce).toFixed(3))));
}, // -------------------------------------------------------------------------------------------
// Document (Pointer Events)
// -------------------------------------------------------------------------------------------
dN = function(t) {
  if (t.button !== 0) return;
  t.preventDefault(), t.stopImmediatePropagation();
  const r = m(this, ze, h2).call(this, t);
  m(this, ze, lf).call(this, r, t), m(this, ze, G5).call(this, r, t);
}, fN = function(t) {
  t.preventDefault();
}, Z9 = new WeakMap();
const L1 = ad(() => ({}));
var i0, ns, r0, a0, or, hN, pN, mN, vN, yN, gN, CN, W5, X9;
class Os extends Vs {
  constructor(t) {
    super();
    k(this, or);
    k(this, i0);
    k(this, ns);
    k(this, r0, nt(!0));
    k(this, a0, nt(!0));
    k(this, X9, nv((t, r) => {
      var f, v;
      (f = this.el) == null || f.style.setProperty("--slider-fill", t + "%"), (v = this.el) == null || v.style.setProperty("--slider-pointer", r + "%");
    }));
    L(this, ns, t);
  }
  onSetup() {
    L(this, i0, bn());
    const t = new dl();
    t.attach(this), this.$state.focused = t.focused.bind(t), fu(L1) || Ps(L1, {
      default: "value"
    }), Ps(Qk, {
      orientation: this.$props.orientation,
      disabled: l(this, ns).isDisabled,
      preview: nt(null)
    }), K(m(this, or, mN).bind(this)), K(m(this, or, vN).bind(this)), K(m(this, or, yN).bind(this)), m(this, or, CN).call(this), new fZ(l(this, ns), l(this, i0)).attach(this), new Z_({
      callback: m(this, or, hN).bind(this)
    }).attach(this);
  }
  onAttach(t) {
    hn(t, "role", "slider"), hn(t, "tabindex", "0"), hn(t, "autocomplete", "off"), Oe ? m(this, or, W5).call(this) : K(m(this, or, W5).bind(this));
  }
  onConnect(t) {
    bt(XM(t, l(this, r0).set)), K(m(this, or, pN).bind(this));
  }
}
i0 = new WeakMap(), ns = new WeakMap(), r0 = new WeakMap(), a0 = new WeakMap(), or = new WeakSet(), hN = function(t) {
  l(this, a0).set(t[0].isIntersecting);
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
pN = function() {
  const { hidden: t } = this.$props;
  this.$state.hidden.set(t() || !l(this, r0).call(this) || !l(this, a0).bind(this));
}, mN = function() {
  const { dragging: t, value: r, min: f, max: v } = this.$state;
  fe(t) || r.set(cZ(f(), v(), r(), l(this, ns).getStep()));
}, vN = function() {
  this.$state.step.set(l(this, ns).getStep());
}, yN = function() {
  if (!l(this, ns).isDisabled()) return;
  const { dragging: t, pointing: r } = this.$state;
  t.set(!1), r.set(!1);
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
gN = function() {
  return b2(l(this, ns).isDisabled());
}, // -------------------------------------------------------------------------------------------
// Attributes
// -------------------------------------------------------------------------------------------
CN = function() {
  const { orientation: t } = this.$props, { dragging: r, active: f, pointing: v } = this.$state;
  this.setAttributes({
    "data-dragging": r,
    "data-pointing": v,
    "data-active": f,
    "aria-disabled": m(this, or, gN).bind(this),
    "aria-valuemin": l(this, ns).aria.valueMin ?? this.$state.min,
    "aria-valuemax": l(this, ns).aria.valueMax ?? this.$state.max,
    "aria-valuenow": l(this, ns).aria.valueNow,
    "aria-valuetext": l(this, ns).aria.valueText,
    "aria-orientation": t
  });
}, W5 = function() {
  const { fillPercent: t, pointerPercent: r } = this.$state;
  l(this, X9).call(this, Hr(t(), 3), Hr(r(), 3));
}, X9 = new WeakMap(), I(Os, "props", {
  hidden: !1,
  disabled: !1,
  step: 1,
  keyStep: 1,
  orientation: "horizontal",
  shiftKeyMultiplier: 5
});
var Tu, SN, bN, wN, TN;
class Wm extends Et {
  constructor() {
    super();
    k(this, Tu);
    new Os({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: this.$props.disabled,
      aria: {
        valueNow: m(this, Tu, SN).bind(this),
        valueText: m(this, Tu, bN).bind(this)
      }
    });
  }
  onSetup() {
    K(m(this, Tu, wN).bind(this)), K(m(this, Tu, TN).bind(this));
  }
}
Tu = new WeakSet(), // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
SN = function() {
  const { value: t } = this.$state;
  return Math.round(t());
}, bN = function() {
  const { value: t, max: r } = this.$state;
  return Hr(t() / r() * 100, 2) + "%";
}, // -------------------------------------------------------------------------------------------
// Watch
// -------------------------------------------------------------------------------------------
wN = function() {
  const { value: t } = this.$props;
  this.$state.value.set(t());
}, TN = function() {
  const { min: t, max: r } = this.$props;
  this.$state.min.set(t()), this.$state.max.set(r());
}, I(Wm, "props", {
  ...Os.props,
  min: 0,
  max: 100,
  value: 0
}), I(Wm, "state", rv);
const wc = /* @__PURE__ */ new Map(), jb = /* @__PURE__ */ new Map();
var s0, Zg, o0, Yn, EN, kN, Z5, X5, J5, e8, xN, m9;
const cx = class cx {
  constructor(s, t, r) {
    k(this, Yn);
    k(this, s0);
    k(this, Zg);
    k(this, o0);
    I(this, "$images", nt([]));
    L(this, Zg, s), L(this, o0, t), L(this, s0, r), K(m(this, Yn, EN).bind(this));
  }
  static create(s, t) {
    const r = bn();
    return new cx(s, t, r);
  }
};
s0 = new WeakMap(), Zg = new WeakMap(), o0 = new WeakMap(), Yn = new WeakSet(), EN = function() {
  var r;
  const { canLoad: s } = l(this, s0).$state;
  if (!s()) return;
  const t = l(this, Zg).call(this);
  if (t) {
    if (qe(t) && wc.has(t)) {
      const f = wc.get(t);
      if (wc.delete(t), wc.set(t, f), wc.size > 99) {
        const v = wc.keys().next().value;
        wc.delete(v);
      }
      this.$images.set(wc.get(t));
    } else if (qe(t)) {
      const f = l(this, o0).call(this), v = t + "::" + f;
      if (!jb.has(v)) {
        const g = new Promise(async (T, x) => {
          try {
            const $ = await fetch(t, {
              credentials: g2(f)
            });
            if ($.headers.get("content-type") === "application/json") {
              const A = await $.json();
              if (vr(A))
                if (A[0] && "text" in A[0])
                  T(m(this, Yn, X5).call(this, A));
                else {
                  for (let U = 0; U < A.length; U++) {
                    const F = A[U];
                    bc(kk(F), !1), bc(
                      "url" in F && qe(F.url),
                      !1
                    ), bc(
                      "startTime" in F && ar(F.startTime),
                      !1
                    );
                  }
                  T(A);
                }
              else
                T(m(this, Yn, Z5).call(this, A));
              return;
            }
            import("./prod-DTLJXtPo.js").then((A) => A.d).then(async ({ parseResponse: A }) => {
              try {
                const { cues: U } = await A($);
                T(m(this, Yn, X5).call(this, U));
              } catch (U) {
                x(U);
              }
            });
          } catch ($) {
            x($);
          }
        }).then((T) => (wc.set(v, T), T)).catch((T) => {
          m(this, Yn, m9).call(this, t, T);
        }).finally(() => {
          qe(v) && jb.delete(v);
        });
        jb.set(v, g);
      }
      (r = jb.get(v)) == null || r.then((g) => {
        this.$images.set(g || []);
      });
    } else if (vr(t))
      try {
        this.$images.set(m(this, Yn, kN).call(this, t));
      } catch (f) {
        m(this, Yn, m9).call(this, t, f);
      }
    else
      try {
        this.$images.set(m(this, Yn, Z5).call(this, t));
      } catch (f) {
        m(this, Yn, m9).call(this, t, f);
      }
    return () => {
      this.$images.set([]);
    };
  }
}, kN = function(s) {
  const t = m(this, Yn, J5).call(this);
  return s.map((r, f) => (bc(
    r.url && qe(r.url)
  ), bc(
    "startTime" in r && ar(r.startTime)
  ), {
    ...r,
    url: qe(r.url) ? m(this, Yn, e8).call(this, r.url, t) : r.url
  }));
}, Z5 = function(s) {
  var g;
  bc(qe(s.url)), bc(vr(s.tiles) && ((g = s.tiles) == null ? void 0 : g.length));
  const t = new URL(s.url), r = [], f = "tile_width" in s ? s.tile_width : s.tileWidth, v = "tile_height" in s ? s.tile_height : s.tileHeight;
  for (const T of s.tiles)
    r.push({
      url: t,
      startTime: "start" in T ? T.start : T.startTime,
      width: f,
      height: v,
      coords: { x: T.x, y: T.y }
    });
  return r;
}, X5 = function(s) {
  for (let f = 0; f < s.length; f++) {
    const v = s[f];
    bc(
      "startTime" in v && ar(v.startTime)
    ), bc(
      "text" in v && qe(v.text)
    );
  }
  const t = [], r = m(this, Yn, J5).call(this);
  for (const f of s) {
    const [v, g] = f.text.split("#"), T = m(this, Yn, xN).call(this, g);
    t.push({
      url: m(this, Yn, e8).call(this, v, r),
      startTime: f.startTime,
      endTime: f.endTime,
      width: T == null ? void 0 : T.w,
      height: T == null ? void 0 : T.h,
      coords: T && ar(T.x) && ar(T.y) ? { x: T.x, y: T.y } : void 0
    });
  }
  return t;
}, J5 = function() {
  let s = fe(l(this, Zg));
  return !qe(s) || !/^https?:/.test(s) ? location.href : s;
}, e8 = function(s, t) {
  return /^https?:/.test(s) ? new URL(s) : new URL(s, t);
}, xN = function(s) {
  if (!s) return {};
  const [t, r] = s.split("="), f = r == null ? void 0 : r.split(","), v = {};
  if (!t || !f)
    return null;
  for (let g = 0; g < t.length; g++) {
    const T = +f[g];
    isNaN(T) || (v[t[g]] = T);
  }
  return v;
}, m9 = function(s, t) {
};
let K5 = cx;
var Xb, Xg, Jg, qt, LN, t8, $N, DN, MN, AN, n8, PN, ON, i8, uf, _N;
let RN = (Xb = class extends Et {
  constructor() {
    super(...arguments);
    k(this, qt);
    I(this, "media");
    k(this, Xg);
    k(this, Jg, []);
  }
  onSetup() {
    this.media = bn(), L(this, Xg, K5.create(this.$props.src, this.$state.crossOrigin)), m(this, qt, t8).call(this), this.setAttributes({
      "data-loading": m(this, qt, AN).bind(this),
      "data-error": m(this, qt, n8).bind(this),
      "data-hidden": this.$state.hidden,
      "aria-hidden": Fr(this.$state.hidden)
    });
  }
  onConnect(t) {
    K(m(this, qt, LN).bind(this)), K(m(this, qt, PN).bind(this)), K(m(this, qt, t8).bind(this)), K(m(this, qt, $N).bind(this)), K(m(this, qt, ON).bind(this)), K(m(this, qt, i8).bind(this));
  }
  getTime() {
    return this.$props.time();
  }
}, Xg = new WeakMap(), Jg = new WeakMap(), qt = new WeakSet(), LN = function() {
  const t = this.$state.img();
  t && new Cn(t).add("load", m(this, qt, DN).bind(this)).add("error", m(this, qt, MN).bind(this));
}, t8 = function() {
  const { crossOrigin: t } = this.$props, { crossOrigin: r } = this.$state, { crossOrigin: f } = this.media.$state, v = t() !== null ? t() : f();
  r.set(v === !0 ? "anonymous" : v);
}, $N = function() {
  const { src: t, loading: r, error: f } = this.$state;
  return t() && (r.set(!0), f.set(null)), () => {
    m(this, qt, _N).call(this), r.set(!1), f.set(null);
  };
}, DN = function() {
  const { loading: t, error: r } = this.$state;
  m(this, qt, i8).call(this), t.set(!1), r.set(null);
}, MN = function(t) {
  const { loading: r, error: f } = this.$state;
  r.set(!1), f.set(t);
}, AN = function() {
  const { loading: t, hidden: r } = this.$state;
  return !r() && t();
}, n8 = function() {
  const { error: t } = this.$state;
  return !sl(t());
}, PN = function() {
  const { hidden: t } = this.$state, { duration: r } = this.media.$state, f = l(this, Xg).$images();
  t.set(m(this, qt, n8).call(this) || !Number.isFinite(r()) || f.length === 0);
}, ON = function() {
  let t = l(this, Xg).$images();
  if (!t.length) return;
  let r = this.getTime(), { src: f, activeThumbnail: v } = this.$state, g = -1, T = null;
  for (let x = t.length - 1; x >= 0; x--) {
    const $ = t[x];
    if (r >= $.startTime && (!$.endTime || r < $.endTime)) {
      g = x;
      break;
    }
  }
  t[g] && (T = t[g]), v.set(T), f.set((T == null ? void 0 : T.url.href) || "");
}, i8 = function() {
  if (!this.scope || this.$state.hidden()) return;
  const t = this.el, r = this.$state.img(), f = this.$state.activeThumbnail();
  if (!r || !f || !t) return;
  let v = f.width ?? r.naturalWidth, g = (f == null ? void 0 : f.height) ?? r.naturalHeight, {
    maxWidth: T,
    maxHeight: x,
    minWidth: $,
    minHeight: P,
    width: A,
    height: U
  } = getComputedStyle(this.el);
  $ === "100%" && ($ = parseFloat(A) + ""), P === "100%" && (P = parseFloat(U) + "");
  let F = Math.max(parseInt($) / v, parseInt(P) / g), Z = Math.min(
    Math.max(parseInt($), parseInt(T)) / v,
    Math.max(parseInt(P), parseInt(x)) / g
  ), ne = !isNaN(Z) && Z < 1 ? Z : F > 1 ? F : 1;
  m(this, qt, uf).call(this, t, "--thumbnail-width", `${v * ne}px`), m(this, qt, uf).call(this, t, "--thumbnail-height", `${g * ne}px`), m(this, qt, uf).call(this, t, "--thumbnail-aspect-ratio", String(Hr(v / g, 5))), m(this, qt, uf).call(this, r, "width", `${r.naturalWidth * ne}px`), m(this, qt, uf).call(this, r, "height", `${r.naturalHeight * ne}px`), m(this, qt, uf).call(this, r, "transform", f.coords ? `translate(-${f.coords.x * ne}px, -${f.coords.y * ne}px)` : ""), m(this, qt, uf).call(this, r, "max-width", "none");
}, uf = function(t, r, f) {
  t.style.setProperty(r, f), l(this, Jg).push(() => t.style.removeProperty(r));
}, _N = function() {
  for (const t of l(this, Jg)) t();
  L(this, Jg, []);
}, I(Xb, "props", {
  src: null,
  time: 0,
  crossOrigin: null
}), I(Xb, "state", new sd({
  src: "",
  img: null,
  thumbnails: [],
  activeThumbnail: null,
  crossOrigin: null,
  loading: !1,
  error: null,
  hidden: !1
})), Xb);
var l0;
class hZ extends RN {
  constructor() {
    super(...arguments);
    k(this, l0);
  }
  onAttach(t) {
    L(this, l0, P1(Wm.state));
  }
  getTime() {
    const { duration: t, clipStartTime: r } = this.media.$state;
    return r() + l(this, l0).pointerRate() * t();
  }
}
l0 = new WeakMap();
var Nf, u0, Bn, NN, VN, r8, UN, a8, zN, HN, s8, FN, IN;
class U9 extends Et {
  constructor() {
    super(...arguments);
    k(this, Bn);
    k(this, Nf);
    k(this, u0);
  }
  get video() {
    return this.$state.video();
  }
  onSetup() {
    L(this, Nf, bn()), L(this, u0, P1(Wm.state)), m(this, Bn, r8).call(this), this.setAttributes({
      "data-loading": m(this, Bn, UN).bind(this),
      "data-hidden": this.$state.hidden,
      "data-error": m(this, Bn, a8).bind(this),
      "aria-hidden": Fr(this.$state.hidden)
    });
  }
  onAttach(t) {
    K(m(this, Bn, NN).bind(this)), K(m(this, Bn, VN).bind(this)), K(m(this, Bn, r8).bind(this)), K(m(this, Bn, zN).bind(this)), K(m(this, Bn, HN).bind(this)), K(m(this, Bn, IN).bind(this));
  }
}
Nf = new WeakMap(), u0 = new WeakMap(), Bn = new WeakSet(), NN = function() {
  const t = this.$state.video();
  t && (t.readyState >= 2 && m(this, Bn, s8).call(this), new Cn(t).add("canplay", m(this, Bn, s8).bind(this)).add("error", m(this, Bn, FN).bind(this)));
}, VN = function() {
  const { src: t } = this.$state, { canLoad: r } = l(this, Nf).$state;
  t.set(r() ? this.$props.src() : null);
}, r8 = function() {
  const { crossOrigin: t } = this.$props, { crossOrigin: r } = this.$state, { crossOrigin: f } = l(this, Nf).$state, v = t() !== null ? t() : f();
  r.set(v === !0 ? "anonymous" : v);
}, UN = function() {
  const { canPlay: t, hidden: r } = this.$state;
  return !t() && !r();
}, a8 = function() {
  const { error: t } = this.$state;
  return !sl(t);
}, zN = function() {
  const { src: t, hidden: r } = this.$state, { canLoad: f, duration: v } = l(this, Nf).$state;
  r.set(f() && (!t() || m(this, Bn, a8).call(this) || !Number.isFinite(v())));
}, HN = function() {
  const { src: t, canPlay: r, error: f } = this.$state;
  t(), r.set(!1), f.set(null);
}, s8 = function(t) {
  const { canPlay: r, error: f } = this.$state;
  r.set(!0), f.set(null), this.dispatch("can-play", { trigger: t });
}, FN = function(t) {
  const { canPlay: r, error: f } = this.$state;
  r.set(!1), f.set(t), this.dispatch("error", { trigger: t });
}, IN = function() {
  const { video: t, canPlay: r } = this.$state, { duration: f } = l(this, Nf).$state, { pointerRate: v } = l(this, u0), g = t();
  r() && g && Number.isFinite(f()) && Number.isFinite(v()) && (g.currentTime = v() * f());
}, I(U9, "props", {
  src: null,
  crossOrigin: null
}), I(U9, "state", new sd({
  video: null,
  src: null,
  crossOrigin: null,
  canPlay: !1,
  error: null,
  hidden: !1
}));
const pZ = U9.prototype;
on(pZ, "video");
var Vf, J9, c0;
class Yk extends Et {
  constructor() {
    super(...arguments);
    k(this, Vf);
    k(this, J9);
    k(this, c0);
  }
  onSetup() {
    L(this, c0, P1(Wm.state)), L(this, Vf, gi(L1)), L(this, J9, sh(this.getValueText.bind(this)));
  }
  /**
   * Returns the current value formatted as text based on prop settings.
   */
  getValueText() {
    var ne, ce;
    const {
      type: t,
      format: r,
      decimalPlaces: f,
      padHours: v,
      padMinutes: g,
      showHours: T,
      showMs: x
    } = this.$props, { value: $, pointerValue: P, min: A, max: U } = l(this, c0), F = (r == null ? void 0 : r()) ?? l(this, Vf).default, Z = t() === "current" ? $() : P();
    if (F === "percent") {
      const De = U() - A(), Ne = Z / De * 100;
      return (l(this, Vf).percent ?? Hr)(Ne, f()) + "%";
    } else return F === "time" ? (l(this, Vf).time ?? Gk)(Z, {
      padHrs: v(),
      padMins: g(),
      showHrs: T(),
      showMs: x()
    }) : (((ce = (ne = l(this, Vf)).value) == null ? void 0 : ce.call(ne, Z)) ?? Z.toFixed(2)) + "";
  }
}
Vf = new WeakMap(), J9 = new WeakMap(), c0 = new WeakMap(), I(Yk, "props", {
  type: "pointer",
  format: null,
  showHours: !1,
  showMs: !1,
  padHours: null,
  padMinutes: null,
  decimalPlaces: 2
});
const mZ = Yk.prototype;
Fi(mZ, "getValueText");
var e1, d0;
class BN extends Et {
  constructor() {
    super(...arguments);
    k(this, e1);
    k(this, d0, nv(() => {
      const { disabled: t, orientation: r } = l(this, e1);
      if (t()) return;
      const f = this.el, { offset: v, noClamp: g } = this.$props;
      f && vZ(f, {
        clamp: !g(),
        offset: v(),
        orientation: r()
      });
    }));
  }
  onSetup() {
    L(this, e1, gi(Qk));
    const { active: t } = P1(Wm.state);
    this.setAttributes({
      "data-visible": t
    });
  }
  onAttach(t) {
    Object.assign(t.style, {
      position: "absolute",
      top: 0,
      left: 0,
      width: "max-content"
    });
  }
  onConnect(t) {
    const { preview: r } = l(this, e1);
    r.set(t), bt(() => r.set(null)), K(l(this, d0).bind(this));
    const f = new ResizeObserver(l(this, d0).bind(this));
    f.observe(t), bt(() => f.disconnect());
  }
}
e1 = new WeakMap(), d0 = new WeakMap(), I(BN, "props", {
  offset: 0,
  noClamp: !1
});
function vZ(c, {
  clamp: s,
  offset: t,
  orientation: r
}) {
  const f = getComputedStyle(c), v = parseFloat(f.width), g = parseFloat(f.height), T = {
    top: null,
    right: null,
    bottom: null,
    left: null
  };
  if (T[r === "horizontal" ? "bottom" : "left"] = `calc(100% + var(--media-slider-preview-offset, ${t}px))`, r === "horizontal") {
    const x = v / 2;
    if (!s)
      T.left = `calc(var(--slider-pointer) - ${x}px)`;
    else {
      const $ = `max(0px, calc(var(--slider-pointer) - ${x}px))`, P = `calc(100% - ${v}px)`;
      T.left = `min(${$}, ${P})`;
    }
  } else {
    const x = g / 2;
    if (!s)
      T.bottom = `calc(var(--slider-pointer) - ${x}px)`;
    else {
      const $ = `max(${x}px, calc(var(--slider-pointer) - ${x}px))`, P = `calc(100% - ${g}px)`;
      T.bottom = `min(${$}, ${P})`;
    }
  }
  Object.assign(c.style, T);
}
var lo, yr, qN, jN, GN, QN, YN, f0, WN, KN, ZN;
class o8 extends Et {
  constructor() {
    super(...arguments);
    k(this, yr);
    k(this, lo);
    k(this, f0, mh(m(this, yr, WN).bind(this), 25));
  }
  onSetup() {
    L(this, lo, bn());
    const { audioGain: t } = l(this, lo).$state;
    Ps(L1, {
      default: "percent",
      value(r) {
        return (r * (t() ?? 1)).toFixed(2);
      },
      percent(r) {
        return Math.round(r * (t() ?? 1));
      }
    }), new Os({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: m(this, yr, QN).bind(this),
      aria: {
        valueMax: m(this, yr, GN).bind(this),
        valueNow: m(this, yr, qN).bind(this),
        valueText: m(this, yr, jN).bind(this)
      },
      onDragValueChange: m(this, yr, ZN).bind(this),
      onValueChange: m(this, yr, KN).bind(this)
    }).attach(this), K(m(this, yr, YN).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-volume-slider", ""), hn(t, "aria-label", "Volume");
    const { canSetVolume: r } = l(this, lo).$state;
    this.setAttributes({
      "data-supported": r,
      "aria-hidden": Fr(() => !r())
    });
  }
}
lo = new WeakMap(), yr = new WeakSet(), qN = function() {
  const { value: t } = this.$state, { audioGain: r } = l(this, lo).$state;
  return Math.round(t() * (r() ?? 1));
}, jN = function() {
  const { value: t, max: r } = this.$state, { audioGain: f } = l(this, lo).$state;
  return Hr(t() / r() * (f() ?? 1) * 100, 2) + "%";
}, GN = function() {
  const { audioGain: t } = l(this, lo).$state;
  return this.$state.max() * (t() ?? 1);
}, QN = function() {
  const { disabled: t } = this.$props, { canSetVolume: r } = l(this, lo).$state;
  return t() || !r();
}, YN = function() {
  const { muted: t, volume: r } = l(this, lo).$state, f = t() ? 0 : r() * 100;
  this.$state.value.set(f), this.dispatch("value-change", { detail: f });
}, f0 = new WeakMap(), WN = function(t) {
  if (!t.trigger) return;
  const r = Hr(t.detail / 100, 3);
  l(this, lo).remote.changeVolume(r, t);
}, KN = function(t) {
  l(this, f0).call(this, t);
}, ZN = function(t) {
  l(this, f0).call(this, t);
}, I(o8, "props", {
  ...Os.props,
  keyStep: 5,
  shiftKeyMultiplier: 2
}), I(o8, "state", rv);
var Uf, lr, XN, JN, eV, tV, nV, u8, iV, rV;
class l8 extends Et {
  constructor() {
    super(...arguments);
    k(this, lr);
    k(this, Uf);
  }
  onSetup() {
    L(this, Uf, bn()), Ps(L1, {
      default: "percent",
      percent: (t, r) => Hr(this.$state.value(), r) + "%"
    }), new Os({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: m(this, lr, nV).bind(this),
      aria: {
        valueNow: m(this, lr, XN).bind(this),
        valueText: m(this, lr, JN).bind(this)
      },
      onDragValueChange: m(this, lr, rV).bind(this),
      onValueChange: m(this, lr, iV).bind(this)
    }).attach(this), K(m(this, lr, eV).bind(this)), K(m(this, lr, tV).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-audio-gain-slider", ""), hn(t, "aria-label", "Audio Boost");
    const { canSetAudioGain: r } = l(this, Uf).$state;
    this.setAttributes({
      "data-supported": r,
      "aria-hidden": Fr(() => !r())
    });
  }
}
Uf = new WeakMap(), lr = new WeakSet(), XN = function() {
  const { value: t } = this.$state;
  return Math.round(t());
}, JN = function() {
  const { value: t } = this.$state;
  return t() + "%";
}, eV = function() {
  const { min: t, max: r } = this.$props;
  this.$state.min.set(t()), this.$state.max.set(r());
}, tV = function() {
  const { audioGain: t } = l(this, Uf).$state, r = ((t() ?? 1) - 1) * 100;
  this.$state.value.set(r), this.dispatch("value-change", { detail: r });
}, nV = function() {
  const { disabled: t } = this.$props, { canSetAudioGain: r } = l(this, Uf).$state;
  return t() || !r();
}, u8 = function(t) {
  if (!t.trigger) return;
  const r = Hr(1 + t.detail / 100, 2);
  l(this, Uf).remote.changeAudioGain(r, t);
}, iV = function(t) {
  m(this, lr, u8).call(this, t);
}, rV = function(t) {
  m(this, lr, u8).call(this, t);
}, I(l8, "props", {
  ...Os.props,
  step: 25,
  keyStep: 25,
  shiftKeyMultiplier: 2,
  min: 0,
  max: 300
}), I(l8, "state", rv);
var zf, zi, aV, sV, oV, lV, uV, cV, h0, dV, fV, hV;
class c8 extends Et {
  constructor() {
    super(...arguments);
    k(this, zi);
    k(this, zf);
    k(this, h0, mh(m(this, zi, dV).bind(this), 25));
  }
  onSetup() {
    L(this, zf, bn()), new Os({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: m(this, zi, uV),
      isDisabled: m(this, zi, cV).bind(this),
      aria: {
        valueNow: m(this, zi, aV).bind(this),
        valueText: m(this, zi, sV).bind(this)
      },
      onDragValueChange: m(this, zi, hV).bind(this),
      onValueChange: m(this, zi, fV).bind(this)
    }).attach(this), K(m(this, zi, oV).bind(this)), K(m(this, zi, lV).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-speed-slider", ""), hn(t, "aria-label", "Speed");
    const { canSetPlaybackRate: r } = l(this, zf).$state;
    this.setAttributes({
      "data-supported": r,
      "aria-hidden": Fr(() => !r())
    });
  }
}
zf = new WeakMap(), zi = new WeakSet(), aV = function() {
  const { value: t } = this.$state;
  return t();
}, sV = function() {
  const { value: t } = this.$state;
  return t() + "x";
}, oV = function() {
  const { min: t, max: r } = this.$props;
  this.$state.min.set(t()), this.$state.max.set(r());
}, lV = function() {
  const { playbackRate: t } = l(this, zf).$state, r = t();
  this.$state.value.set(r), this.dispatch("value-change", { detail: r });
}, uV = function(t) {
  return Hr(t, 2);
}, cV = function() {
  const { disabled: t } = this.$props, { canSetPlaybackRate: r } = l(this, zf).$state;
  return t() || !r();
}, h0 = new WeakMap(), dV = function(t) {
  if (!t.trigger) return;
  const r = t.detail;
  l(this, zf).remote.changePlaybackRate(r, t);
}, fV = function(t) {
  l(this, h0).call(this, t);
}, hV = function(t) {
  l(this, h0).call(this, t);
}, I(c8, "props", {
  ...Os.props,
  step: 0.25,
  keyStep: 0.25,
  shiftKeyMultiplier: 2,
  min: 0,
  max: 2
}), I(c8, "state", rv);
var Jo, t1, gr, pV, mV, vV, yV, gV, p0, CV, SV, bV;
class d8 extends Et {
  constructor() {
    super(...arguments);
    k(this, gr);
    k(this, Jo);
    k(this, t1, sh(() => {
      const { qualities: t } = l(this, Jo).$state;
      return cA(t());
    }));
    k(this, p0, mh(m(this, gr, CV).bind(this), 25));
  }
  onSetup() {
    L(this, Jo, bn()), new Os({
      getStep: this.$props.step,
      getKeyStep: this.$props.keyStep,
      roundValue: Math.round,
      isDisabled: m(this, gr, gV).bind(this),
      aria: {
        valueNow: m(this, gr, pV).bind(this),
        valueText: m(this, gr, mV).bind(this)
      },
      onDragValueChange: m(this, gr, bV).bind(this),
      onValueChange: m(this, gr, SV).bind(this)
    }).attach(this), K(m(this, gr, vV).bind(this)), K(m(this, gr, yV).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-quality-slider", ""), hn(t, "aria-label", "Video Quality");
    const { qualities: r, canSetQuality: f } = l(this, Jo).$state, v = sh(() => f() && r().length > 0);
    this.setAttributes({
      "data-supported": v,
      "aria-hidden": Fr(() => !v())
    });
  }
}
Jo = new WeakMap(), t1 = new WeakMap(), gr = new WeakSet(), pV = function() {
  const { value: t } = this.$state;
  return t();
}, mV = function() {
  const { quality: t } = l(this, Jo).$state;
  if (!t()) return "";
  const { height: r, bitrate: f } = t(), v = f && f > 0 ? `${(f / 1e6).toFixed(2)} Mbps` : null;
  return r ? `${r}p${v ? ` (${v})` : ""}` : "Auto";
}, vV = function() {
  const t = l(this, t1).call(this);
  this.$state.max.set(Math.max(0, t.length - 1));
}, yV = function() {
  let { quality: t } = l(this, Jo).$state, r = l(this, t1).call(this), f = Math.max(0, r.indexOf(t()));
  this.$state.value.set(f), this.dispatch("value-change", { detail: f });
}, gV = function() {
  const { disabled: t } = this.$props, { canSetQuality: r, qualities: f } = l(this, Jo).$state;
  return t() || f().length <= 1 || !r();
}, p0 = new WeakMap(), CV = function(t) {
  if (!t.trigger) return;
  const { qualities: r } = l(this, Jo), f = fe(l(this, t1))[t.detail];
  l(this, Jo).remote.changeQuality(r.indexOf(f), t);
}, SV = function(t) {
  l(this, p0).call(this, t);
}, bV = function(t) {
  l(this, p0).call(this, t);
}, I(d8, "props", {
  ...Os.props,
  step: 1,
  keyStep: 1,
  shiftKeyMultiplier: 1
}), I(d8, "state", rv);
var In, n1, m0, Je, wV, TV, EV, kV, xV, f8, RV, i1, LV, $V, h8, DV, p8, MV, AV, PV, OV, _V, NV, Bp, VV, UV, zV;
class z9 extends Et {
  constructor() {
    super();
    k(this, Je);
    k(this, In);
    k(this, n1);
    k(this, m0, nt(null));
    k(this, i1, !1);
    const { noSwipeGesture: t } = this.$props;
    new Os({
      swipeGesture: () => !t(),
      getValue: m(this, Je, p8).bind(this),
      getStep: m(this, Je, MV).bind(this),
      getKeyStep: m(this, Je, AV).bind(this),
      roundValue: m(this, Je, PV),
      isDisabled: m(this, Je, OV).bind(this),
      aria: {
        valueNow: m(this, Je, _V).bind(this),
        valueText: m(this, Je, NV).bind(this)
      },
      onDragStart: m(this, Je, LV).bind(this),
      onDragValueChange: m(this, Je, $V).bind(this),
      onDragEnd: m(this, Je, h8).bind(this),
      onValueChange: m(this, Je, DV).bind(this)
    });
  }
  onSetup() {
    L(this, In, bn()), Ps(L1, {
      default: "time",
      value: m(this, Je, UV).bind(this),
      time: m(this, Je, zV).bind(this)
    }), this.setAttributes({
      "data-chapters": m(this, Je, TV).bind(this)
    }), this.setStyles({
      "--slider-progress": m(this, Je, wV).bind(this)
    }), K(m(this, Je, kV).bind(this)), K(m(this, Je, EV).bind(this));
  }
  onAttach(t) {
    t.setAttribute("data-media-time-slider", ""), hn(t, "aria-label", "Seek");
  }
  onConnect(t) {
    K(m(this, Je, xV).bind(this)), zk(l(this, In).textTracks, "chapters", l(this, m0).set);
  }
}
In = new WeakMap(), n1 = new WeakMap(), m0 = new WeakMap(), Je = new WeakSet(), wV = function() {
  const { bufferedEnd: t, duration: r } = l(this, In).$state;
  return Hr(Math.min(t() / Math.max(r(), 1), 1) * 100, 3) + "%";
}, TV = function() {
  var r;
  const { duration: t } = l(this, In).$state;
  return ((r = l(this, m0).call(this)) == null ? void 0 : r.cues.length) && Number.isFinite(t()) && t() > 0;
}, EV = function() {
  L(this, n1, mh(
    m(this, Je, f8).bind(this),
    this.$props.seekingRequestThrottle()
  ));
}, kV = function() {
  if (this.$state.hidden()) return;
  const { value: t, dragging: r } = this.$state, f = m(this, Je, p8).call(this);
  fe(r) || (t.set(f), this.dispatch("value-change", { detail: f }));
}, xV = function() {
  const t = l(this, In).player.el, { preview: r } = gi(Qk);
  t && r() && lt(t, "data-preview", this.$state.active());
}, f8 = function(t, r) {
  l(this, In).remote.seeking(t, r);
}, RV = function(t, r, f) {
  l(this, n1).cancel();
  const { live: v } = l(this, In).$state;
  if (v() && r >= 99) {
    l(this, In).remote.seekToLiveEdge(f);
    return;
  }
  l(this, In).remote.seek(t, f);
}, i1 = new WeakMap(), LV = function(t) {
  const { pauseWhileDragging: r } = this.$props;
  if (r()) {
    const { paused: f } = l(this, In).$state;
    L(this, i1, !f()), l(this, In).remote.pause(t);
  }
}, $V = function(t) {
  l(this, n1).call(this, m(this, Je, Bp).call(this, t.detail), t);
}, h8 = function(t) {
  const { seeking: r } = l(this, In).$state;
  fe(r) || m(this, Je, f8).call(this, m(this, Je, Bp).call(this, t.detail), t);
  const f = t.detail;
  m(this, Je, RV).call(this, m(this, Je, Bp).call(this, f), f, t);
  const { pauseWhileDragging: v } = this.$props;
  v() && l(this, i1) && (l(this, In).remote.play(t), L(this, i1, !1));
}, DV = function(t) {
  const { dragging: r } = this.$state;
  r() || !t.trigger || m(this, Je, h8).call(this, t);
}, // -------------------------------------------------------------------------------------------
// Props
// -------------------------------------------------------------------------------------------
p8 = function() {
  const { currentTime: t } = l(this, In).$state;
  return m(this, Je, VV).call(this, t());
}, MV = function() {
  const t = this.$props.step() / l(this, In).$state.duration() * 100;
  return Number.isFinite(t) ? t : 1;
}, AV = function() {
  const t = this.$props.keyStep() / l(this, In).$state.duration() * 100;
  return Number.isFinite(t) ? t : 1;
}, PV = function(t) {
  return Hr(t, 3);
}, OV = function() {
  const { disabled: t } = this.$props, { canSeek: r } = l(this, In).$state;
  return t() || !r();
}, // -------------------------------------------------------------------------------------------
// ARIA
// -------------------------------------------------------------------------------------------
_V = function() {
  const { value: t } = this.$state;
  return Math.round(t());
}, NV = function() {
  const t = m(this, Je, Bp).call(this, this.$state.value()), { duration: r } = l(this, In).$state;
  return Number.isFinite(t) ? `${s5(t)} out of ${s5(r())}` : "live";
}, // -------------------------------------------------------------------------------------------
// Format
// -------------------------------------------------------------------------------------------
Bp = function(t) {
  const { duration: r } = l(this, In).$state;
  return Hr(t / 100 * r(), 5);
}, VV = function(t) {
  const { liveEdge: r, duration: f } = l(this, In).$state, v = Math.max(0, Math.min(1, r() ? 1 : Math.min(t, f()) / f()));
  return Number.isNaN(v) ? 0 : Number.isFinite(v) ? v * 100 : 100;
}, UV = function(t) {
  const r = m(this, Je, Bp).call(this, t), { live: f, duration: v } = l(this, In).$state;
  return Number.isFinite(r) ? (f() ? r - v() : r).toFixed(0) : "LIVE";
}, zV = function(t, r) {
  const f = m(this, Je, Bp).call(this, t), { live: v, duration: g } = l(this, In).$state, T = v() ? f - g() : f;
  return Number.isFinite(f) ? `${T < 0 ? "-" : ""}${Gk(Math.abs(T), r)}` : "LIVE";
}, I(z9, "props", {
  ...Os.props,
  step: 0.1,
  keyStep: 5,
  shiftKeyMultiplier: 2,
  pauseWhileDragging: !1,
  noSwipeGesture: !1,
  seekingRequestThrottle: 100
}), I(z9, "state", rv);
var is, Em, r1, tu, La, km, $a, qc, xm, Hf, et, m8, v8, HV, FV, IV, BV, qV, v9, y8, g8, jV, ew, tw, GV, y9, g9, QV, YV, WV, KV, v0, ZV, XV, JV;
class Wk extends Et {
  constructor() {
    super(...arguments);
    k(this, et);
    k(this, is);
    k(this, Em);
    k(this, r1);
    k(this, tu, null);
    k(this, La, []);
    k(this, km, nt(null));
    k(this, $a, nt([]));
    k(this, qc, nt(-1));
    k(this, xm, nt(-1));
    k(this, Hf, 0);
    k(this, ew, nv((t) => {
      var x;
      let r, f = l(this, $a).call(this), { seekableStart: v } = l(this, is).$state, g = v(), T = m(this, et, y9).call(this, f);
      for (let $ = l(this, Hf); $ < l(this, La).length; $++)
        if (r = m(this, et, g9).call(this, f[$], t, g, T), (x = l(this, La)[$]) == null || x.style.setProperty("--chapter-progress", r + "%"), r < 100) {
          L(this, Hf, $);
          break;
        }
    }));
    k(this, tw, sh(m(this, et, GV).bind(this)));
    k(this, v0, dw(
      () => {
        const t = fe(l(this, km));
        !this.scope || !t || !t.cues.length || (l(this, $a).set(m(this, et, QV).call(this, t.cues)), l(this, qc).set(0), L(this, Hf, 0));
      },
      150,
      !0
    ));
  }
  get cues() {
    return l(this, $a).call(this);
  }
  get activeCue() {
    return l(this, $a).call(this)[l(this, qc).call(this)] || null;
  }
  get activePointerCue() {
    return l(this, $a).call(this)[l(this, xm).call(this)] || null;
  }
  onSetup() {
    L(this, is, bn()), L(this, Em, P1(z9.state));
  }
  onAttach(t) {
    zk(l(this, is).textTracks, "chapters", m(this, et, m8).bind(this)), K(m(this, et, YV).bind(this));
  }
  onConnect() {
    bt(() => m(this, et, v8).bind(this));
  }
  onDestroy() {
    m(this, et, m8).call(this, null);
  }
  setRefs(t) {
    var r;
    if (L(this, La, t), (r = l(this, r1)) == null || r.dispose(), l(this, La).length === 1) {
      const f = l(this, La)[0];
      f.style.width = "100%", f.style.setProperty("--chapter-fill", "var(--slider-fill)"), f.style.setProperty("--chapter-progress", "var(--slider-progress)");
    } else l(this, La).length > 0 && la(() => m(this, et, HV).call(this), L(this, r1, Xc()));
  }
}
is = new WeakMap(), Em = new WeakMap(), r1 = new WeakMap(), tu = new WeakMap(), La = new WeakMap(), km = new WeakMap(), $a = new WeakMap(), qc = new WeakMap(), xm = new WeakMap(), Hf = new WeakMap(), et = new WeakSet(), m8 = function(t) {
  fe(l(this, km)) !== t && (m(this, et, v8).call(this), l(this, km).set(t));
}, v8 = function() {
  var t;
  L(this, La, []), l(this, $a).set([]), l(this, qc).set(-1), l(this, xm).set(-1), L(this, Hf, 0), (t = l(this, r1)) == null || t.dispose();
}, HV = function() {
  l(this, La).length && K(m(this, et, FV).bind(this));
}, FV = function() {
  const { hidden: t } = l(this, Em);
  t() || (K(m(this, et, IV).bind(this)), K(m(this, et, BV).bind(this)), K(m(this, et, qV).bind(this)), K(m(this, et, jV).bind(this)));
}, IV = function() {
  const t = l(this, $a).call(this);
  if (!t.length) return;
  let r, { seekableStart: f, seekableEnd: v } = l(this, is).$state, g = f(), T = v() || t[t.length - 1].endTime, x = T - g, $ = 100;
  for (let P = 0; P < t.length; P++)
    if (r = t[P], l(this, La)[P]) {
      const A = P === t.length - 1 ? $ : Hr((r.endTime - Math.max(g, r.startTime)) / x * 100, 3);
      l(this, La)[P].style.width = A + "%", $ -= A;
    }
}, BV = function() {
  let { liveEdge: t, seekableStart: r, seekableEnd: f } = l(this, is).$state, { fillPercent: v, value: g } = l(this, Em), T = l(this, $a).call(this), x = t(), $ = fe(l(this, qc)), P = T[$], A = x ? l(this, $a).length - 1 : m(this, et, g8).call(this, P && P.startTime / f() * 100 <= fe(g) ? $ : 0, v());
  x || !P ? m(this, et, v9).call(this, 0, T.length, 100) : A > $ ? m(this, et, v9).call(this, $, A, 100) : A < $ && m(this, et, v9).call(this, A + 1, $ + 1, 0);
  const U = x ? 100 : m(this, et, g9).call(this, T[A], v(), r(), m(this, et, y9).call(this, T));
  m(this, et, y8).call(this, l(this, La)[A], U), l(this, qc).set(A);
}, qV = function() {
  let { hidden: t, pointerPercent: r } = l(this, Em);
  if (t()) {
    l(this, xm).set(-1);
    return;
  }
  const f = m(this, et, g8).call(this, 0, r());
  l(this, xm).set(f);
}, v9 = function(t, r, f) {
  for (let v = t; v < r; v++) m(this, et, y8).call(this, l(this, La)[v], f);
}, y8 = function(t, r) {
  t && (t.style.setProperty("--chapter-fill", r + "%"), lt(t, "data-active", r > 0 && r < 100), lt(t, "data-ended", r === 100));
}, g8 = function(t, r) {
  let f = 0, v = l(this, $a).call(this);
  if (r === 0) return 0;
  if (r === 100) return v.length - 1;
  let { seekableStart: g } = l(this, is).$state, T = g(), x = m(this, et, y9).call(this, v);
  for (let $ = t; $ < v.length; $++)
    if (f = m(this, et, g9).call(this, v[$], r, T, x), f >= 0 && f < 100) return $;
  return 0;
}, jV = function() {
  l(this, ew).call(this, l(this, tw).call(this));
}, ew = new WeakMap(), tw = new WeakMap(), GV = function() {
  const { bufferedEnd: t, duration: r } = l(this, is).$state;
  return Hr(Math.min(t() / Math.max(r(), 1), 1), 3) * 100;
}, y9 = function(t) {
  var v;
  const { seekableEnd: r } = l(this, is).$state, f = r();
  return Number.isFinite(f) ? f : ((v = t[t.length - 1]) == null ? void 0 : v.endTime) || 0;
}, g9 = function(t, r, f, v) {
  if (!t || l(this, $a).call(this).length === 0) return 0;
  const T = v - f, x = Math.max(0, t.startTime - f), $ = Math.min(v, t.endTime) - f, P = x / T, A = P * 100, U = Math.min(1, P + ($ - x) / T) * 100;
  return Math.max(
    0,
    Hr(
      r >= U ? 100 : (r - A) / (U - A) * 100,
      3
    )
  );
}, QV = function(t) {
  let r = [], { seekableStart: f, seekableEnd: v, duration: g } = l(this, is).$state, T = f(), x = v();
  t = t.filter((A) => A.startTime <= x && A.endTime >= T);
  const $ = t[0];
  $ && $.startTime > T && r.push(new window.VTTCue(T, $.startTime, ""));
  for (let A = 0; A < t.length - 1; A++) {
    const U = t[A], F = t[A + 1];
    if (r.push(U), F) {
      const Z = F.startTime - U.endTime;
      Z > 0 && r.push(new window.VTTCue(U.endTime, U.endTime + Z, ""));
    }
  }
  const P = t[t.length - 1];
  if (P) {
    r.push(P);
    const A = g();
    A >= 0 && A - P.endTime > 1 && r.push(new window.VTTCue(P.endTime, g(), ""));
  }
  return r;
}, YV = function() {
  const { source: t } = l(this, is).$state;
  t(), m(this, et, WV).call(this);
}, WV = function() {
  if (!this.scope) return;
  const { disabled: t } = this.$props;
  if (t()) {
    l(this, $a).set([]), l(this, qc).set(0), L(this, Hf, 0);
    return;
  }
  const r = l(this, km).call(this);
  if (r) {
    const f = l(this, v0).bind(this);
    f(), new Cn(r).add("add-cue", f).add("remove-cue", f), K(m(this, et, KV).bind(this));
  }
  return L(this, tu, m(this, et, JV).call(this)), l(this, tu) && K(m(this, et, ZV).bind(this)), () => {
    l(this, tu) && (l(this, tu).textContent = "", L(this, tu, null));
  };
}, KV = function() {
  l(this, is).$state.duration(), l(this, v0).call(this);
}, v0 = new WeakMap(), ZV = function() {
  const t = this.activePointerCue || this.activeCue;
  l(this, tu) && (l(this, tu).textContent = (t == null ? void 0 : t.text) || "");
}, XV = function() {
  let t = this.el;
  for (; t && t.getAttribute("role") !== "slider"; )
    t = t.parentElement;
  return t;
}, JV = function() {
  const t = m(this, et, XV).call(this);
  return t ? t.querySelector('[data-part="chapter-title"]') : null;
}, I(Wk, "props", {
  disabled: !1
});
const gw = Wk.prototype;
on(gw, "cues");
on(gw, "activeCue");
on(gw, "activePointerCue");
Fi(gw, "setRefs");
const ol = ad();
function yZ(c, s) {
  const t = bM(c, s);
  for (const { el: r, top: f, left: v } of t)
    r.scroll({ top: f, left: v, behavior: s.behavior });
}
function gZ(c, s = {}) {
  yZ(c, {
    scrollMode: "if-needed",
    block: "center",
    inline: "center",
    ...s
  });
}
const CZ = /* @__PURE__ */ [
  "a[href]",
  "[tabindex]",
  "input",
  "select",
  "button"
].map((c) => `${c}:not([aria-hidden='true'])`).join(","), SZ = /* @__PURE__ */ new Set([
  "Escape",
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "PageUp",
  "End",
  "PageDown",
  "Enter",
  " "
]);
var Ff, el, rs, y0, On, qp, C8, eU, S8, tU, nU, C9, iU;
class bZ {
  constructor(s) {
    k(this, On);
    k(this, Ff, -1);
    k(this, el, null);
    k(this, rs, []);
    k(this, y0);
    L(this, y0, s);
  }
  get items() {
    return l(this, rs);
  }
  attachMenu(s) {
    sn(s, "focus", m(this, On, eU).bind(this)), L(this, el, s), bt(() => {
      L(this, el, null);
    });
  }
  listen() {
    l(this, el) && (this.update(), new Cn(l(this, el)).add("keyup", m(this, On, tU).bind(this)).add("keydown", m(this, On, nU).bind(this)), bt(() => {
      L(this, Ff, -1), L(this, rs, []);
    }));
  }
  update() {
    L(this, Ff, 0), L(this, rs, m(this, On, iU).call(this));
  }
  scroll(s = m(this, On, C8).call(this)) {
    const t = l(this, rs)[s];
    t && requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        gZ(t, {
          behavior: "smooth",
          boundary: (r) => !r.hasAttribute("data-root")
        });
      });
    });
  }
  focusActive(s = !0) {
    const t = m(this, On, C8).call(this);
    m(this, On, qp).call(this, t >= 0 ? t : 0, s);
  }
}
Ff = new WeakMap(), el = new WeakMap(), rs = new WeakMap(), y0 = new WeakMap(), On = new WeakSet(), qp = function(s, t = !0) {
  var r;
  L(this, Ff, s), l(this, rs)[s] ? (l(this, rs)[s].focus({ preventScroll: !0 }), t && this.scroll(s)) : (r = l(this, el)) == null || r.focus({ preventScroll: !0 });
}, C8 = function() {
  return l(this, rs).findIndex(
    (s) => document.activeElement === s || s.getAttribute("role") === "menuitemradio" && s.getAttribute("aria-checked") === "true"
  );
}, eU = function() {
  l(this, Ff) >= 0 || (this.update(), this.focusActive());
}, S8 = function(s) {
  const t = s.target;
  if (oM(s) && t instanceof Element) {
    const r = t.getAttribute("role");
    return !/a|input|select|button/.test(t.localName) && !r;
  }
  return SZ.has(s.key);
}, tU = function(s) {
  m(this, On, S8).call(this, s) && (s.stopPropagation(), s.preventDefault());
}, nU = function(s) {
  if (m(this, On, S8).call(this, s))
    switch (s.stopPropagation(), s.preventDefault(), s.key) {
      case "Escape":
        l(this, y0).closeMenu(s);
        break;
      case "Tab":
        m(this, On, qp).call(this, m(this, On, C9).call(this, s.shiftKey ? -1 : 1));
        break;
      case "ArrowUp":
        m(this, On, qp).call(this, m(this, On, C9).call(this, -1));
        break;
      case "ArrowDown":
        m(this, On, qp).call(this, m(this, On, C9).call(this, 1));
        break;
      case "Home":
      case "PageUp":
        m(this, On, qp).call(this, 0);
        break;
      case "End":
      case "PageDown":
        m(this, On, qp).call(this, l(this, rs).length - 1);
        break;
    }
}, C9 = function(s) {
  var r;
  let t = l(this, Ff);
  do
    t = (t + s + l(this, rs).length) % l(this, rs).length;
  while (((r = l(this, rs)[t]) == null ? void 0 : r.offsetParent) === null);
  return t;
}, iU = function() {
  if (!l(this, el)) return [];
  const s = l(this, el).querySelectorAll(CZ), t = [], r = (f) => f.getAttribute("role") === "menu";
  for (const f of s)
    P9(f) && f.offsetParent !== null && // does not have display: none
    JM(l(this, el), f, r) && t.push(f);
  return t;
};
var wZ = Object.defineProperty, TZ = Object.getOwnPropertyDescriptor, z0 = (c, s, t, r) => {
  for (var f = TZ(s, t), v = c.length - 1, g; v >= 0; v--)
    (g = c[v]) && (f = g(s, t, f) || f);
  return f && wZ(s, t, f), f;
};
let EZ = 0;
var tl, a1, s1, Da, g0, nu, mr, If, Bf, Rm, Lm, jc, $m, C0, Dm, ct, rU, aU, sU, oU, lU, b8, uU, o1, cU, w8, dU, p2, fU, hU, pU, mU, vU, yU, nw, gU, l1, iw, CU, rw, SU, u1, c1, bU;
class av extends Et {
  constructor() {
    super();
    k(this, ct);
    k(this, tl);
    k(this, a1);
    k(this, s1);
    k(this, Da, nt(!1));
    k(this, g0, nt(!1));
    k(this, nu, nt(null));
    k(this, mr, nt(null));
    k(this, If);
    k(this, Bf, /* @__PURE__ */ new Set());
    k(this, Rm, null);
    k(this, Lm);
    k(this, jc);
    k(this, $m, !1);
    k(this, C0, nt(!1));
    k(this, Dm, /* @__PURE__ */ new Set());
    k(this, o1, !1);
    k(this, nw, m(this, ct, gU).bind(this));
    k(this, l1, !1);
    k(this, iw, m(this, ct, CU).bind(this));
    k(this, rw, m(this, ct, SU).bind(this));
    k(this, u1, nv(() => {
      const t = fe(l(this, mr));
      if (!t || Oe) return;
      let r = 0, f = getComputedStyle(t), v = [...t.children];
      for (const g of ["paddingTop", "paddingBottom", "borderTopWidth", "borderBottomWidth"])
        r += parseFloat(f[g]) || 0;
      for (const g of v)
        if (P9(g) && g.style.display === "contents")
          v.push(...g.children);
        else if (g.nodeType === 3)
          r += parseFloat(getComputedStyle(g).fontSize);
        else if (P9(g)) {
          if (!ZM(g)) continue;
          const T = getComputedStyle(g);
          r += g.offsetHeight + (parseFloat(T.marginTop) || 0) + (parseFloat(T.marginBottom) || 0);
        }
      Aa(t, "--menu-height", r + "px");
    }));
    k(this, c1, !1);
    const { showDelay: t } = this.$props;
    L(this, Lm, new p_({
      trigger: l(this, nu),
      content: l(this, mr),
      showDelay: t,
      listen: (r, f, v) => {
        uh(r, (T) => {
          l(this, Da).call(this) ? v(T) : f(T);
        });
        const g = m(this, ct, mU).call(this);
        g && uh(g, (T) => {
          T.stopPropagation(), v(T);
        });
      },
      onChange: m(this, ct, cU).bind(this)
    }));
  }
  get triggerElement() {
    return l(this, nu).call(this);
  }
  get contentElement() {
    return l(this, mr).call(this);
  }
  get isSubmenu() {
    return !!l(this, If);
  }
  onSetup() {
    L(this, tl, bn());
    const t = ++EZ;
    L(this, a1, `media-menu-${t}`), L(this, s1, `media-menu-button-${t}`), L(this, jc, new bZ({
      closeMenu: this.close.bind(this)
    })), fu(ol) && L(this, If, gi(ol)), m(this, ct, rU).call(this), this.setAttributes({
      "data-open": l(this, Da),
      "data-root": !this.isSubmenu,
      "data-submenu": this.isSubmenu,
      "data-disabled": m(this, ct, p2).bind(this)
    }), Ps(ol, {
      button: l(this, nu),
      content: l(this, mr),
      expanded: l(this, Da),
      hint: nt(""),
      submenu: !!l(this, If),
      disable: m(this, ct, fU).bind(this),
      attachMenuButton: m(this, ct, sU).bind(this),
      attachMenuItems: m(this, ct, oU).bind(this),
      attachObserver: m(this, ct, lU).bind(this),
      disableMenuButton: m(this, ct, uU).bind(this),
      addSubmenu: m(this, ct, yU).bind(this),
      onTransitionEvent: (r) => {
        l(this, Dm).add(r), bt(() => {
          l(this, Dm).delete(r);
        });
      }
    });
  }
  onAttach(t) {
    t.style.setProperty("display", "contents");
  }
  onConnect(t) {
    var r;
    K(m(this, ct, aU).bind(this)), this.isSubmenu && ((r = l(this, If)) == null || r.addSubmenu(this));
  }
  onDestroy() {
    l(this, nu).set(null), l(this, mr).set(null), L(this, Rm, null), l(this, Dm).clear();
  }
  open(t) {
    fe(l(this, Da)) || (l(this, Lm).show(t), al());
  }
  close(t) {
    fe(l(this, Da)) && (l(this, Lm).hide(t), al());
  }
}
tl = new WeakMap(), a1 = new WeakMap(), s1 = new WeakMap(), Da = new WeakMap(), g0 = new WeakMap(), nu = new WeakMap(), mr = new WeakMap(), If = new WeakMap(), Bf = new WeakMap(), Rm = new WeakMap(), Lm = new WeakMap(), jc = new WeakMap(), $m = new WeakMap(), C0 = new WeakMap(), Dm = new WeakMap(), ct = new WeakSet(), rU = function() {
  let t = -1, r = fu(S2) ? gi(S2) : null;
  Ps(S2, {
    onDragStart: () => {
      var f;
      (f = r == null ? void 0 : r.onDragStart) == null || f.call(r), window.clearTimeout(t), t = -1, L(this, $m, !0);
    },
    onDragEnd: () => {
      var f;
      (f = r == null ? void 0 : r.onDragEnd) == null || f.call(r), t = window.setTimeout(() => {
        L(this, $m, !1), t = -1;
      }, 300);
    }
  });
}, aU = function() {
  const t = m(this, ct, dU).call(this);
  this.isSubmenu || l(this, u1).call(this), m(this, ct, b8).call(this, t), t && (K(() => {
    const { height: r } = l(this, tl).$state, f = l(this, mr).call(this);
    f && Aa(f, "--player-height", r() + "px");
  }), l(this, jc).listen(), this.listen("pointerup", m(this, ct, hU).bind(this)), sn(window, "pointerup", m(this, ct, pU).bind(this)));
}, sU = function(t) {
  const r = t.el, f = this.isSubmenu, v = Fr(m(this, ct, p2).bind(this));
  hn(r, "tabindex", f ? "-1" : "0"), hn(r, "role", f ? "menuitem" : "button"), lt(r, "id", l(this, s1)), lt(r, "aria-haspopup", "menu"), lt(r, "aria-expanded", "false"), lt(r, "data-root", !this.isSubmenu), lt(r, "data-submenu", this.isSubmenu);
  const g = () => {
    lt(r, "data-open", l(this, Da).call(this)), lt(r, "aria-disabled", v());
  };
  Oe ? g() : K(g), l(this, nu).set(r), bt(() => {
    l(this, nu).set(null);
  });
}, oU = function(t) {
  var g;
  const r = t.el;
  r.style.setProperty("display", "none"), lt(r, "id", l(this, a1)), hn(r, "role", "menu"), hn(r, "tabindex", "-1"), lt(r, "data-root", !this.isSubmenu), lt(r, "data-submenu", this.isSubmenu), l(this, mr).set(r), bt(() => l(this, mr).set(null));
  const f = () => lt(r, "data-open", l(this, Da).call(this));
  Oe ? f() : K(f), l(this, jc).attachMenu(r), m(this, ct, b8).call(this, !1);
  const v = m(this, ct, bU).bind(this);
  this.isSubmenu ? (g = l(this, If)) == null || g.onTransitionEvent(v) : (t.listen("transitionstart", v), t.listen("transitionend", v), t.listen("animationend", l(this, u1)), t.listen("vds-menu-resize", l(this, u1)));
}, lU = function(t) {
  L(this, Rm, t);
}, b8 = function(t) {
  const r = fe(l(this, mr));
  r && lt(r, "aria-hidden", b2(!t));
}, uU = function(t) {
  l(this, C0).set(t);
}, o1 = new WeakMap(), cU = function(t, r) {
  var g, T, x, $, P, A;
  if (L(this, o1, O0(r)), r == null || r.stopPropagation(), l(this, Da).call(this) === t) return;
  if (m(this, ct, p2).call(this)) {
    t && l(this, Lm).hide(r);
    return;
  }
  (g = this.el) == null || g.dispatchEvent(
    new Event("vds-menu-resize", {
      bubbles: !0,
      composed: !0
    })
  );
  const f = l(this, nu).call(this), v = l(this, mr).call(this);
  if (f && (lt(f, "aria-controls", t && l(this, a1)), lt(f, "aria-expanded", b2(t))), v && lt(v, "aria-labelledby", t && l(this, s1)), l(this, Da).set(t), m(this, ct, vU).call(this, r), al(), l(this, o1)) {
    t ? v == null || v.focus() : f == null || f.focus();
    for (const U of [this.el, v])
      U && U.setAttribute("data-keyboard", "");
  } else
    for (const U of [this.el, v])
      U && U.removeAttribute("data-keyboard");
  if (this.dispatch(t ? "open" : "close", { trigger: r }), t)
    !this.isSubmenu && l(this, tl).activeMenu !== this && ((T = l(this, tl).activeMenu) == null || T.close(r), l(this, tl).activeMenu = this), ($ = (x = l(this, Rm)) == null ? void 0 : x.onOpen) == null || $.call(x, r);
  else {
    if (this.isSubmenu)
      for (const U of l(this, Bf)) U.close(r);
    else
      l(this, tl).activeMenu = null;
    (A = (P = l(this, Rm)) == null ? void 0 : P.onClose) == null || A.call(P, r);
  }
  t && requestAnimationFrame(m(this, ct, w8).bind(this));
}, w8 = function() {
  l(this, c1) || l(this, l1) || (l(this, jc).update(), requestAnimationFrame(() => {
    l(this, o1) ? l(this, jc).focusActive() : l(this, jc).scroll();
  }));
}, dU = function() {
  return !m(this, ct, p2).call(this) && l(this, Da).call(this);
}, p2 = function() {
  return l(this, g0).call(this) || l(this, C0).call(this);
}, fU = function(t) {
  l(this, g0).set(t);
}, hU = function(t) {
  const r = l(this, mr).call(this);
  l(this, $m) || r && fD(r, t) || t.stopPropagation();
}, pU = function(t) {
  const r = l(this, mr).call(this);
  l(this, $m) || r && fD(r, t) || this.close(t);
}, mU = function() {
  var r;
  const t = (r = this.el) == null ? void 0 : r.querySelector('[data-part="close-target"]');
  return this.el && t && JM(this.el, t, (f) => f.getAttribute("role") === "menu") ? t : null;
}, vU = function(t) {
  this.isSubmenu || (l(this, Da).call(this) ? l(this, tl).remote.pauseControls(t) : l(this, tl).remote.resumeControls(t));
}, yU = function(t) {
  l(this, Bf).add(t), new Cn(t).add("open", l(this, iw)).add("close", l(this, rw)), bt(l(this, nw));
}, nw = new WeakMap(), gU = function(t) {
  l(this, Bf).delete(t);
}, l1 = new WeakMap(), iw = new WeakMap(), CU = function(t) {
  var f;
  L(this, l1, !0);
  const r = l(this, mr).call(this);
  this.isSubmenu && ((f = this.triggerElement) == null || f.setAttribute("aria-hidden", "true"));
  for (const v of l(this, Bf))
    if (v !== t.target)
      for (const g of [v.el, v.triggerElement])
        g == null || g.setAttribute("aria-hidden", "true");
  if (r) {
    const v = t.target.el;
    for (const g of r.children)
      g.contains(v) ? g.setAttribute("data-open", "") : g !== v && g.setAttribute("data-hidden", "");
  }
}, rw = new WeakMap(), SU = function(t) {
  var f;
  L(this, l1, !1);
  const r = l(this, mr).call(this);
  this.isSubmenu && ((f = this.triggerElement) == null || f.setAttribute("aria-hidden", "false"));
  for (const v of l(this, Bf))
    for (const g of [v.el, v.triggerElement])
      g == null || g.setAttribute("aria-hidden", "false");
  if (r)
    for (const v of r.children)
      v.removeAttribute("data-open"), v.removeAttribute("data-hidden");
}, u1 = new WeakMap(), c1 = new WeakMap(), bU = function(t) {
  const r = l(this, mr).call(this);
  r && t.propertyName === "height" && (L(this, c1, t.type === "transitionstart"), lt(r, "data-transition", l(this, c1) ? "height" : null), l(this, Da).call(this) && m(this, ct, w8).call(this));
  for (const f of l(this, Dm)) f(t);
}, I(av, "props", {
  showDelay: 0
});
z0([
  on
], av.prototype, "triggerElement");
z0([
  on
], av.prototype, "contentElement");
z0([
  on
], av.prototype, "isSubmenu");
z0([
  Fi
], av.prototype, "open");
z0([
  Fi
], av.prototype, "close");
var qf, S0, rd, wU, TU, T8;
class Cw extends Et {
  constructor() {
    super();
    k(this, rd);
    k(this, qf);
    k(this, S0, nt(null));
    new dl();
  }
  get expanded() {
    var t;
    return ((t = l(this, qf)) == null ? void 0 : t.expanded()) ?? !1;
  }
  onSetup() {
    L(this, qf, gi(ol));
  }
  onAttach(t) {
    l(this, qf).attachMenuButton(this), K(m(this, rd, wU).bind(this)), hn(t, "type", "button");
  }
  onConnect(t) {
    K(m(this, rd, TU).bind(this)), m(this, rd, T8).call(this);
    const r = new MutationObserver(m(this, rd, T8).bind(this));
    r.observe(t, { attributeFilter: ["data-part"], childList: !0, subtree: !0 }), bt(() => r.disconnect()), uh(t, (f) => {
      this.dispatch("select", { trigger: f });
    });
  }
}
qf = new WeakMap(), S0 = new WeakMap(), rd = new WeakSet(), wU = function() {
  l(this, qf).disableMenuButton(this.$props.disabled());
}, TU = function() {
  const t = l(this, S0).call(this);
  t && K(() => {
    const r = l(this, qf).hint();
    r && (t.textContent = r);
  });
}, T8 = function() {
  var r;
  const t = (r = this.el) == null ? void 0 : r.querySelector('[data-part="hint"]');
  l(this, S0).set(t ?? null);
}, I(Cw, "props", {
  disabled: !1
});
const kZ = Cw.prototype;
on(kZ, "expanded");
class xZ extends Cw {
}
const l7 = ad();
var Mm, ph, kU, xU, RU;
class EU extends Et {
  constructor() {
    super();
    k(this, ph);
    k(this, Mm);
    new dl();
    const { placement: t } = this.$props;
    this.setAttributes({
      "data-placement": t
    });
  }
  onAttach(t) {
    if (L(this, Mm, gi(ol)), l(this, Mm).attachMenuItems(this), fu(l7)) {
      const r = gi(l7);
      r && (Ps(l7, null), r.attach(t), bt(() => r.attach(null)));
    }
  }
  onConnect(t) {
    K(m(this, ph, kU).bind(this));
  }
}
Mm = new WeakMap(), ph = new WeakSet(), kU = function() {
  const { expanded: t } = l(this, Mm);
  if (!this.el || !t()) return;
  const r = this.$props.placement();
  if (!r) return;
  Object.assign(this.el.style, {
    position: "absolute",
    top: 0,
    left: 0,
    width: "max-content"
  });
  const { offset: f, alignOffset: v } = this.$props;
  bt(
    tA(this.el, m(this, ph, RU).call(this), r, {
      offsetVarName: "media-menu",
      xOffset: v(),
      yOffset: f()
    })
  ), bt(m(this, ph, xU).bind(this));
}, xU = function() {
  this.el && (this.el.removeAttribute("style"), this.el.style.display = "none");
}, RU = function() {
  return l(this, Mm).button();
}, I(EU, "props", {
  placement: null,
  offset: 0,
  alignOffset: 0
});
const E8 = ad();
var Gc, jf, mk, mo, LU, $U, aw, k8, x8;
class Kk extends Vs {
  constructor() {
    super(...arguments);
    k(this, mo);
    k(this, Gc, /* @__PURE__ */ new Set());
    k(this, jf, nt(""));
    k(this, mk, null);
    I(this, "onValueChange");
    k(this, aw, m(this, mo, k8).bind(this));
  }
  get values() {
    return Array.from(l(this, Gc)).map((t) => t.value());
  }
  get value() {
    return l(this, jf).call(this);
  }
  set value(t) {
    m(this, mo, k8).call(this, t);
  }
  onSetup() {
    Ps(E8, {
      add: m(this, mo, LU).bind(this),
      remove: m(this, mo, $U).bind(this)
    });
  }
  onAttach(t) {
    fu(ol) || hn(t, "role", "radiogroup"), this.setAttributes({ value: l(this, jf) });
  }
  onDestroy() {
    l(this, Gc).clear();
  }
}
Gc = new WeakMap(), jf = new WeakMap(), mk = new WeakMap(), mo = new WeakSet(), LU = function(t) {
  l(this, Gc).has(t) || (l(this, Gc).add(t), t.onCheck = l(this, aw), t.check(t.value() === l(this, jf).call(this)));
}, $U = function(t) {
  t.onCheck = null, l(this, Gc).delete(t);
}, aw = new WeakMap(), k8 = function(t, r) {
  var T;
  const f = fe(l(this, jf));
  if (!t || t === f) return;
  const v = m(this, mo, x8).call(this, f), g = m(this, mo, x8).call(this, t);
  v == null || v.check(!1, r), g == null || g.check(!0, r), l(this, jf).set(t), (T = this.onValueChange) == null || T.call(this, t, r);
}, x8 = function(t) {
  for (const r of l(this, Gc))
    if (t === fe(r.value)) return r;
  return null;
};
var Qc, Jm, R8, DU;
class Zk extends Et {
  constructor() {
    super();
    k(this, Jm);
    k(this, Qc);
    L(this, Qc, new Kk()), l(this, Qc).onValueChange = m(this, Jm, DU).bind(this);
  }
  /**
   * A list of radio values that belong this group.
   */
  get values() {
    return l(this, Qc).values;
  }
  /**
   * The radio value that is checked in this group.
   */
  get value() {
    return l(this, Qc).value;
  }
  set value(t) {
    l(this, Qc).value = t;
  }
  onSetup() {
    Oe ? m(this, Jm, R8).call(this) : K(m(this, Jm, R8).bind(this));
  }
}
Qc = new WeakMap(), Jm = new WeakSet(), R8 = function() {
  l(this, Qc).value = this.$props.value();
}, DU = function(t, r) {
  const f = this.createEvent("change", { detail: t, trigger: r });
  this.dispatch(f);
}, I(Zk, "props", {
  value: ""
});
const MU = Zk.prototype;
on(MU, "values");
on(MU, "value");
var iu, Am, Ir, AU, PU, OU, _U, NU, L8, VU;
class Xk extends Et {
  constructor() {
    super();
    k(this, Ir);
    k(this, iu, nt(!1));
    k(this, Am, {
      value: this.$props.value,
      check: m(this, Ir, NU).bind(this),
      onCheck: null
    });
    new dl();
  }
  /**
   * Whether this radio is currently checked.
   */
  get checked() {
    return l(this, iu).call(this);
  }
  onSetup() {
    this.setAttributes({
      value: this.$props.value,
      "data-checked": l(this, iu),
      "aria-checked": Fr(l(this, iu))
    });
  }
  onAttach(t) {
    const r = fu(ol);
    hn(t, "tabindex", r ? "-1" : "0"), hn(t, "role", r ? "menuitemradio" : "radio"), K(m(this, Ir, OU).bind(this));
  }
  onConnect(t) {
    m(this, Ir, PU).call(this), uh(t, m(this, Ir, _U).bind(this)), bt(m(this, Ir, AU).bind(this));
  }
}
iu = new WeakMap(), Am = new WeakMap(), Ir = new WeakSet(), AU = function() {
  la(() => {
    gi(E8).remove(l(this, Am));
  }, this.connectScope);
}, PU = function() {
  gi(E8).add(l(this, Am));
}, OU = function() {
  var f, v;
  const { value: t } = this.$props, r = t();
  fe(l(this, iu)) && ((v = (f = l(this, Am)).onCheck) == null || v.call(f, r));
}, _U = function(t) {
  var r, f;
  fe(l(this, iu)) || (m(this, Ir, L8).call(this, !0, t), m(this, Ir, VU).call(this, t), (f = (r = l(this, Am)).onCheck) == null || f.call(r, fe(this.$props.value), t));
}, NU = function(t, r) {
  fe(l(this, iu)) !== t && m(this, Ir, L8).call(this, t, r);
}, L8 = function(t, r) {
  l(this, iu).set(t), this.dispatch("change", { detail: t, trigger: r });
}, VU = function(t) {
  this.dispatch("select", { trigger: t });
}, I(Xk, "props", {
  value: ""
});
const RZ = Xk.prototype;
on(RZ, "checked");
var E7, Ls, d1, Pa, UU, ru, b0, zU, $8, HU, FU, IU;
let LZ = (E7 = class extends Et {
  constructor() {
    super(...arguments);
    k(this, Pa);
    k(this, Ls);
    k(this, d1, null);
    k(this, ru, 0);
    k(this, b0, -1);
  }
  onSetup() {
    L(this, Ls, bn());
    const { event: t, action: r } = this.$props;
    this.setAttributes({
      event: t,
      action: r
    });
  }
  onAttach(t) {
    t.setAttribute("data-media-gesture", ""), t.style.setProperty("pointer-events", "none");
  }
  onConnect(t) {
    var r;
    L(this, d1, (r = l(this, Ls).player.el) == null ? void 0 : r.querySelector(
      "[data-media-provider]"
    )), K(m(this, Pa, UU).bind(this));
  }
}, Ls = new WeakMap(), d1 = new WeakMap(), Pa = new WeakSet(), UU = function() {
  let t = this.$props.event(), r = this.$props.disabled();
  !l(this, d1) || !t || r || (/^dbl/.test(t) && (t = t.split(/^dbl/)[1]), (t === "pointerup" || t === "pointerdown") && l(this, Ls).$state.pointer() === "coarse" && (t = t === "pointerup" ? "touchend" : "touchstart"), sn(
    l(this, d1),
    t,
    m(this, Pa, zU).bind(this),
    { passive: !1 }
  ));
}, ru = new WeakMap(), b0 = new WeakMap(), zU = function(t) {
  if (this.$props.disabled() || R7(t) && (t.button !== 0 || l(this, Ls).activeMenu) || v2(t) && l(this, Ls).activeMenu || Ik(t) || !m(this, Pa, HU).call(this, t))
    return;
  t.MEDIA_GESTURE = !0, t.preventDefault();
  const r = fe(this.$props.event);
  if (!(r == null ? void 0 : r.startsWith("dbl")))
    l(this, ru) === 0 && setTimeout(() => {
      l(this, ru) === 1 && m(this, Pa, $8).call(this, t);
    }, 250);
  else if (l(this, ru) === 1) {
    queueMicrotask(() => m(this, Pa, $8).call(this, t)), clearTimeout(l(this, b0)), L(this, ru, 0);
    return;
  }
  l(this, ru) === 0 && L(this, b0, window.setTimeout(() => {
    L(this, ru, 0);
  }, 275)), Q$(this, ru)._++;
}, $8 = function(t) {
  this.el.setAttribute("data-triggered", ""), requestAnimationFrame(() => {
    m(this, Pa, FU).call(this) && m(this, Pa, IU).call(this, fe(this.$props.action), t), requestAnimationFrame(() => {
      this.el.removeAttribute("data-triggered");
    });
  });
}, /** Validate event occurred in gesture bounds. */
HU = function(t) {
  if (!this.el) return !1;
  if (R7(t) || sM(t) || v2(t)) {
    const r = v2(t) ? t.changedTouches[0] ?? t.touches[0] : void 0, f = (r == null ? void 0 : r.clientX) ?? t.clientX, v = (r == null ? void 0 : r.clientY) ?? t.clientY, g = this.el.getBoundingClientRect(), T = v >= g.top && v <= g.bottom && f >= g.left && f <= g.right;
    return t.type.includes("leave") ? !T : T;
  }
  return !0;
}, /** Validate gesture has the highest z-index in this triggered group. */
FU = function() {
  const t = l(this, Ls).player.el.querySelectorAll(
    "[data-media-gesture][data-triggered]"
  );
  return Array.from(t).sort(
    (r, f) => +getComputedStyle(f).zIndex - +getComputedStyle(r).zIndex
  )[0] === this.el;
}, IU = function(t, r) {
  if (!t) return;
  const f = new St("will-trigger", {
    detail: t,
    cancelable: !0,
    trigger: r
  });
  if (this.dispatchEvent(f), f.defaultPrevented) return;
  const [v, g] = t.replace(/:([a-z])/, "-$1").split(":");
  t.includes(":fullscreen") ? l(this, Ls).remote.toggleFullscreen("prefer-media", r) : t.includes("seek:") ? l(this, Ls).remote.seek(fe(l(this, Ls).$state.currentTime) + (+g || 0), r) : l(this, Ls).remote[$k(v)](r), this.dispatch("trigger", {
    detail: t,
    trigger: r
  });
}, I(E7, "props", {
  disabled: !1,
  event: void 0,
  action: void 0
}), E7);
var f1, Yc, Wc, w0, D8;
class $Z {
  constructor(s) {
    k(this, w0);
    I(this, "priority", 10);
    k(this, f1, null);
    k(this, Yc);
    k(this, Wc);
    L(this, Yc, s);
  }
  attach() {
  }
  canRender() {
    return !0;
  }
  detach() {
    var s;
    (s = l(this, Wc)) == null || s.abort(), L(this, Wc, void 0), l(this, Yc).reset(), L(this, f1, null);
  }
  changeTrack(s) {
    var t;
    !s || l(this, f1) === s || ((t = l(this, Wc)) == null || t.abort(), L(this, Wc, new Cn(s)), s.readyState < 2 ? (l(this, Yc).reset(), l(this, Wc).add("load", () => m(this, w0, D8).call(this, s), { once: !0 })) : m(this, w0, D8).call(this, s), l(this, Wc).add("add-cue", (r) => {
      l(this, Yc).addCue(r.detail);
    }).add("remove-cue", (r) => {
      l(this, Yc).removeCue(r.detail);
    }), L(this, f1, s));
  }
}
f1 = new WeakMap(), Yc = new WeakMap(), Wc = new WeakMap(), w0 = new WeakSet(), D8 = function(s) {
  l(this, Yc).changeTrack({
    cues: [...s.cues],
    regions: [...s.regions]
  });
};
var Ds, as, wt, S9, BU, qU, jU, M8, GU, QU, YU, WU, A8, KU, ZU, Kc, P8, b9, O8, _8;
let DZ = (Ds = class extends Et {
  constructor() {
    super(...arguments);
    k(this, wt);
    k(this, as);
    k(this, Kc, -1);
  }
  onSetup() {
    L(this, as, bn()), this.setAttributes({
      "aria-hidden": Fr(m(this, wt, S9).bind(this))
    });
  }
  onAttach(t) {
    t.style.setProperty("pointer-events", "none");
  }
  onConnect(t) {
    Ds.lib() || import("./prod-DTLJXtPo.js").then((r) => r.d).then((r) => Ds.lib.set(r)), K(m(this, wt, BU).bind(this));
  }
}, as = new WeakMap(), wt = new WeakSet(), S9 = function() {
  const { textTrack: t, remotePlaybackState: r, iOSControls: f } = l(this, as).$state, v = t();
  return f() || r() === "connected" || !v || !os(v);
}, BU = function() {
  if (!Ds.lib()) return;
  const { viewType: t } = l(this, as).$state;
  return t() === "audio" ? m(this, wt, qU).call(this) : m(this, wt, QU).call(this);
}, qU = function() {
  return K(m(this, wt, jU).bind(this)), m(this, wt, A8).call(this, null), () => {
    this.el.textContent = "";
  };
}, jU = function() {
  if (m(this, wt, S9).call(this)) return;
  m(this, wt, M8).call(this);
  const { textTrack: t } = l(this, as).$state;
  sn(t(), "cue-change", m(this, wt, M8).bind(this)), K(m(this, wt, GU).bind(this));
}, M8 = function() {
  this.el.textContent = "", l(this, Kc) >= 0 && m(this, wt, b9).call(this);
  const { realCurrentTime: t, textTrack: r } = l(this, as).$state, { renderVTTCueString: f } = Ds.lib(), v = fe(t), g = fe(r).activeCues;
  for (const T of g) {
    const x = m(this, wt, O8).call(this), $ = m(this, wt, _8).call(this);
    $.innerHTML = f(T, v), x.append($), this.el.append($);
  }
}, GU = function() {
  const { realCurrentTime: t } = l(this, as).$state, { updateTimedVTTCueNodes: r } = Ds.lib();
  r(this.el, t());
}, QU = function() {
  const { CaptionsRenderer: t } = Ds.lib(), r = new t(this.el), f = new $Z(r);
  return l(this, as).textRenderers.add(f), K(m(this, wt, YU).bind(this, r)), K(m(this, wt, WU).bind(this, r)), m(this, wt, A8).call(this, r), () => {
    this.el.textContent = "", l(this, as).textRenderers.remove(f), r.destroy();
  };
}, YU = function(t) {
  t.dir = this.$props.textDir();
}, WU = function(t) {
  var v;
  if (m(this, wt, S9).call(this)) return;
  const { realCurrentTime: r, textTrack: f } = l(this, as).$state;
  t.currentTime = r(), l(this, Kc) >= 0 && ((v = f()) != null && v.activeCues[0]) && m(this, wt, b9).call(this);
}, A8 = function(t) {
  const r = l(this, as).player;
  if (!r) return;
  const f = m(this, wt, KU).bind(this, t);
  sn(r, "vds-font-change", f);
}, KU = function(t) {
  var f;
  if (l(this, Kc) >= 0) {
    m(this, wt, P8).call(this);
    return;
  }
  const { textTrack: r } = l(this, as).$state;
  (f = r()) != null && f.activeCues[0] ? t == null || t.update(!0) : m(this, wt, ZU).call(this);
}, ZU = function() {
  var f, v;
  const t = m(this, wt, O8).call(this);
  lt(t, "data-example", "");
  const r = m(this, wt, _8).call(this);
  lt(r, "data-example", ""), r.textContent = this.$props.exampleText(), t == null || t.append(r), (f = this.el) == null || f.append(t), (v = this.el) == null || v.setAttribute("data-example", ""), m(this, wt, P8).call(this);
}, Kc = new WeakMap(), P8 = function() {
  window.clearTimeout(l(this, Kc)), L(this, Kc, window.setTimeout(m(this, wt, b9).bind(this), 2500));
}, b9 = function() {
  var t, r;
  (t = this.el) == null || t.removeAttribute("data-example"), (r = this.el) != null && r.querySelector("[data-example]") && (this.el.textContent = ""), L(this, Kc, -1);
}, O8 = function() {
  const t = document.createElement("div");
  return lt(t, "data-part", "cue-display"), t;
}, _8 = function() {
  const t = document.createElement("div");
  return lt(t, "data-part", "cue"), t;
}, I(Ds, "props", {
  textDir: "ltr",
  exampleText: "Captions look like this."
}), I(Ds, "lib", nt(null)), Ds);
var Jb, uo, Sn, N8, XU, V8, JU, ez, T0, U8, z8, H8, tz, F8, nz;
let MZ = (Jb = class extends Et {
  constructor() {
    super(...arguments);
    k(this, Sn);
    k(this, uo);
    k(this, T0, "");
  }
  onSetup() {
    L(this, uo, bn()), m(this, Sn, U8).call(this), m(this, Sn, z8).call(this), m(this, Sn, H8).call(this), m(this, Sn, V8).call(this);
  }
  onAttach(t) {
    t.style.setProperty("pointer-events", "none"), K(m(this, Sn, ez).bind(this)), K(m(this, Sn, U8).bind(this)), K(m(this, Sn, z8).bind(this)), K(m(this, Sn, H8).bind(this)), K(m(this, Sn, V8).bind(this));
    const { started: r } = l(this, uo).$state;
    this.setAttributes({
      "data-visible": () => !r() && !this.$state.hidden(),
      "data-loading": m(this, Sn, JU).bind(this),
      "data-error": m(this, Sn, N8).bind(this),
      "data-hidden": this.$state.hidden
    });
  }
  onConnect(t) {
    K(m(this, Sn, XU).bind(this)), K(m(this, Sn, tz).bind(this));
  }
}, uo = new WeakMap(), Sn = new WeakSet(), N8 = function() {
  const { error: t } = this.$state;
  return !sl(t());
}, XU = function() {
  const { canLoadPoster: t, poster: r } = l(this, uo).$state;
  !t() && r() && ld(r(), "preconnect");
}, V8 = function() {
  const { src: t } = this.$props, { poster: r, nativeControls: f } = l(this, uo).$state;
  this.el && lt(this.el, "display", f() ? "none" : null), this.$state.hidden.set(m(this, Sn, N8).call(this) || !(t() || r()) || f());
}, JU = function() {
  const { loading: t, hidden: r } = this.$state;
  return !r() && t();
}, ez = function() {
  const t = this.$state.img();
  t && (new Cn(t).add("load", m(this, Sn, F8).bind(this)).add("error", m(this, Sn, nz).bind(this)), t.complete && m(this, Sn, F8).call(this));
}, T0 = new WeakMap(), U8 = function() {
  const { poster: t } = l(this, uo).$props, { canLoadPoster: r, providedPoster: f, inferredPoster: v } = l(this, uo).$state, g = this.$props.src() || "", T = g || t() || v();
  l(this, T0) === f() && f.set(g), this.$state.src.set(r() && T.length ? T : null), L(this, T0, g);
}, z8 = function() {
  const { src: t } = this.$props, { alt: r } = this.$state, { poster: f } = l(this, uo).$state;
  r.set(t() || f() ? this.$props.alt() : null);
}, H8 = function() {
  const { crossOrigin: t } = this.$props, { crossOrigin: r } = this.$state, { crossOrigin: f, poster: v } = l(this, uo).$state, g = t() !== null ? t() : f();
  r.set(
    /ytimg\.com|vimeo/.test(v() || "") ? null : g === !0 ? "anonymous" : g
  );
}, tz = function() {
  const { loading: t, error: r } = this.$state, { canLoadPoster: f, poster: v } = l(this, uo).$state;
  t.set(f() && !!v()), r.set(null);
}, F8 = function() {
  const { loading: t, error: r } = this.$state;
  t.set(!1), r.set(null);
}, nz = function(t) {
  const { loading: r, error: f } = this.$state;
  r.set(!1), f.set(t);
}, I(Jb, "props", {
  src: null,
  alt: null,
  crossOrigin: null
}), I(Jb, "state", new sd({
  img: null,
  src: null,
  alt: null,
  crossOrigin: null,
  loading: !0,
  error: null,
  hidden: !1
})), Jb);
var e9, h1, Gf, E0, k0, Hi, iz, rz, az, I8, sz, oz, B8, lz;
let AZ = (e9 = class extends Et {
  constructor() {
    super(...arguments);
    k(this, Hi);
    k(this, h1);
    k(this, Gf, nt(null));
    k(this, E0, nt(!0));
    k(this, k0, nt(!0));
  }
  onSetup() {
    L(this, h1, bn()), m(this, Hi, I8).call(this);
    const { type: t } = this.$props;
    this.setAttributes({
      "data-type": t,
      "data-remainder": m(this, Hi, B8).bind(this)
    }), new Z_({
      callback: m(this, Hi, iz).bind(this)
    }).attach(this);
  }
  onAttach(t) {
    t.hasAttribute("role") || K(m(this, Hi, sz).bind(this)), K(m(this, Hi, I8).bind(this));
  }
  onConnect(t) {
    bt(XM(t, l(this, E0).set)), K(m(this, Hi, rz).bind(this)), K(m(this, Hi, az).bind(this));
  }
}, h1 = new WeakMap(), Gf = new WeakMap(), E0 = new WeakMap(), k0 = new WeakMap(), Hi = new WeakSet(), iz = function(t) {
  l(this, k0).set(t[0].isIntersecting);
}, rz = function() {
  const { hidden: t } = this.$props;
  this.$state.hidden.set(t() || !l(this, E0).call(this) || !l(this, k0).call(this));
}, az = function() {
  if (!this.$props.toggle()) {
    l(this, Gf).set(null);
    return;
  }
  this.el && uh(this.el, m(this, Hi, lz).bind(this));
}, I8 = function() {
  const { hidden: t, timeText: r } = this.$state, { duration: f } = l(this, h1).$state;
  if (t()) return;
  const { type: v, padHours: g, padMinutes: T, showHours: x } = this.$props, $ = m(this, Hi, oz).call(this, v()), P = f(), A = m(this, Hi, B8).call(this);
  if (!Number.isFinite($ + P)) {
    r.set("LIVE");
    return;
  }
  const U = A ? Math.max(0, P - $) : $, F = Gk(U, {
    padHrs: g(),
    padMins: T(),
    showHrs: x()
  });
  r.set((A ? "-" : "") + F);
}, sz = function() {
  if (!this.el) return;
  const { toggle: t } = this.$props;
  lt(this.el, "role", t() ? "timer" : null), lt(this.el, "tabindex", t() ? 0 : null);
}, oz = function(t) {
  const { bufferedEnd: r, duration: f, currentTime: v } = l(this, h1).$state;
  switch (t) {
    case "buffered":
      return r();
    case "duration":
      return f();
    default:
      return v();
  }
}, B8 = function() {
  return this.$props.remainder() && l(this, Gf).call(this) !== !1;
}, lz = function(t) {
  if (t.preventDefault(), l(this, Gf).call(this) === null) {
    l(this, Gf).set(!this.$props.remainder());
    return;
  }
  l(this, Gf).set((r) => !r);
}, I(e9, "props", {
  type: "current",
  showHours: !1,
  padHours: null,
  padMinutes: null,
  remainder: !1,
  toggle: !1,
  hidden: !1
}), I(e9, "state", new sd({
  timeText: "",
  hidden: !1
})), e9);
class Jk extends NO {
}
class PZ extends n_ {
}
class OZ extends KK {
}
class _Z extends d_ {
}
class NZ extends ZK {
}
class VZ extends D_ {
}
class UZ extends rZ {
}
class zZ extends aZ {
}
class HZ extends uZ {
}
class FZ extends sZ {
}
class IZ extends oZ {
}
class BZ extends iZ {
}
class qZ extends tZ {
}
class jZ extends nZ {
}
class GZ extends lZ {
}
class QZ extends v_ {
}
class YZ extends JK {
}
class WZ extends T_ {
}
class uz extends Wm {
}
class KZ extends z9 {
}
class ZZ extends o8 {
}
class XZ extends l8 {
}
class JZ extends c8 {
}
class eX extends d8 {
}
class tX extends hZ {
}
class nX extends Yk {
}
class iX extends U9 {
}
class rX extends BN {
}
class aX extends Wk {
}
class sX extends av {
}
class oX extends Cw {
}
class lX extends EU {
}
class uX extends xZ {
}
class cX extends Zk {
}
class dX extends Xk {
}
class fX extends DZ {
}
class hX extends LZ {
}
class pX extends MZ {
}
class cz extends RN {
}
class mX extends AZ {
}
const dz = _.forwardRef((c, s) => {
  const { children: t, ...r } = c, f = _.Children.toArray(t), v = f.find(yX);
  if (v) {
    const g = v.props.children, T = f.map((x) => x === v ? _.Children.count(g) > 1 ? _.Children.only(null) : _.isValidElement(g) ? g.props.children : null : x);
    return /* @__PURE__ */ _.createElement(q8, { ...r, ref: s }, _.isValidElement(g) ? _.cloneElement(g, void 0, T) : null);
  }
  return /* @__PURE__ */ _.createElement(q8, { ...r, ref: s }, t);
});
dz.displayName = "Slot";
const q8 = _.forwardRef((c, s) => {
  const { children: t, ...r } = c;
  return _.isValidElement(t) ? _.cloneElement(t, {
    ...gX(r, t.props),
    ref: s ? pn(s, t.ref) : t.ref
  }) : _.Children.count(t) > 1 ? _.Children.only(null) : null;
});
q8.displayName = "SlotClone";
const vX = ({ children: c }) => /* @__PURE__ */ _.createElement(_.Fragment, null, c);
function yX(c) {
  return _.isValidElement(c) && c.type === vX;
}
function gX(c, s) {
  const t = { ...s };
  for (const r in s) {
    const f = c[r], v = s[r];
    /^on[A-Z]/.test(r) ? f && v ? t[r] = (...T) => {
      v(...T), f(...T);
    } : f && (t[r] = f) : r === "style" ? t[r] = { ...f, ...v } : r === "className" && (t[r] = [f, v].filter(Boolean).join(" "));
  }
  return { ...c, ...t };
}
const CX = ["button", "div", "span", "img", "video", "audio"], st = CX.reduce((c, s) => {
  const t = _.forwardRef((r, f) => {
    const { asChild: v, ...g } = r, T = v ? dz : s;
    return /* @__PURE__ */ _.createElement(T, { ...g, ref: f });
  });
  return t.displayName = `Primitive.${s}`, { ...c, [s]: t };
}, {});
function SX(c) {
  return (c == null ? void 0 : c.$$PROVIDER_TYPE) === "REMOTION";
}
const xD = uz.state.record, bX = Object.keys(xD).reduce(
  (c, s) => ({
    ...c,
    [s]() {
      return xD[s];
    }
  }),
  {}
);
function u7(c, s) {
  const t = tv(rv);
  return cn((t || bX)[c]);
}
const RD = Jk.state.record, fz = Object.keys(RD).reduce(
  (c, s) => ({
    ...c,
    [s]() {
      return RD[s];
    }
  }),
  {}
);
function ex(c, s) {
  var r;
  const t = tv(N1);
  return cn((((r = s == null ? void 0 : s.current) == null ? void 0 : r.$state) || t || fz)[c]);
}
function yte(c) {
  const s = tv(N1);
  return SM(c != null && c.current ? c.current.$state : s || fz);
}
var Gb = { exports: {} }, es = {}, Qb = { exports: {} }, c7 = {};
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var LD;
function wX() {
  return LD || (LD = 1, function(c) {
    function s(se, Le) {
      var me = se.length;
      se.push(Le);
      e: for (; 0 < me; ) {
        var At = me - 1 >>> 1, Qt = se[At];
        if (0 < f(Qt, Le)) se[At] = Le, se[me] = Qt, me = At;
        else break e;
      }
    }
    function t(se) {
      return se.length === 0 ? null : se[0];
    }
    function r(se) {
      if (se.length === 0) return null;
      var Le = se[0], me = se.pop();
      if (me !== Le) {
        se[0] = me;
        e: for (var At = 0, Qt = se.length, ur = Qt >>> 1; At < ur; ) {
          var ri = 2 * (At + 1) - 1, Oa = se[ri], Ci = ri + 1, Si = se[Ci];
          if (0 > f(Oa, me)) Ci < Qt && 0 > f(Si, Oa) ? (se[At] = Si, se[Ci] = me, At = Ci) : (se[At] = Oa, se[ri] = me, At = ri);
          else if (Ci < Qt && 0 > f(Si, me)) se[At] = Si, se[Ci] = me, At = Ci;
          else break e;
        }
      }
      return Le;
    }
    function f(se, Le) {
      var me = se.sortIndex - Le.sortIndex;
      return me !== 0 ? me : se.id - Le.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var v = performance;
      c.unstable_now = function() {
        return v.now();
      };
    } else {
      var g = Date, T = g.now();
      c.unstable_now = function() {
        return g.now() - T;
      };
    }
    var x = [], $ = [], P = 1, A = null, U = 3, F = !1, Z = !1, ne = !1, ce = typeof setTimeout == "function" ? setTimeout : null, De = typeof clearTimeout == "function" ? clearTimeout : null, Ne = typeof setImmediate < "u" ? setImmediate : null;
    typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function Se(se) {
      for (var Le = t($); Le !== null; ) {
        if (Le.callback === null) r($);
        else if (Le.startTime <= se) r($), Le.sortIndex = Le.expirationTime, s(x, Le);
        else break;
        Le = t($);
      }
    }
    function je(se) {
      if (ne = !1, Se(se), !Z) if (t(x) !== null) Z = !0, Ye(Me);
      else {
        var Le = t($);
        Le !== null && rt(je, Le.startTime - se);
      }
    }
    function Me(se, Le) {
      Z = !1, ne && (ne = !1, De(he), he = -1), F = !0;
      var me = U;
      try {
        for (Se(Le), A = t(x); A !== null && (!(A.expirationTime > Le) || se && !Gt()); ) {
          var At = A.callback;
          if (typeof At == "function") {
            A.callback = null, U = A.priorityLevel;
            var Qt = At(A.expirationTime <= Le);
            Le = c.unstable_now(), typeof Qt == "function" ? A.callback = Qt : A === t(x) && r(x), Se(Le);
          } else r(x);
          A = t(x);
        }
        if (A !== null) var ur = !0;
        else {
          var ri = t($);
          ri !== null && rt(je, ri.startTime - Le), ur = !1;
        }
        return ur;
      } finally {
        A = null, U = me, F = !1;
      }
    }
    var Ct = !1, Ge = null, he = -1, Ze = 5, pt = -1;
    function Gt() {
      return !(c.unstable_now() - pt < Ze);
    }
    function Lt() {
      if (Ge !== null) {
        var se = c.unstable_now();
        pt = se;
        var Le = !0;
        try {
          Le = Ge(!0, se);
        } finally {
          Le ? Ve() : (Ct = !1, Ge = null);
        }
      } else Ct = !1;
    }
    var Ve;
    if (typeof Ne == "function") Ve = function() {
      Ne(Lt);
    };
    else if (typeof MessageChannel < "u") {
      var mt = new MessageChannel(), wn = mt.port2;
      mt.port1.onmessage = Lt, Ve = function() {
        wn.postMessage(null);
      };
    } else Ve = function() {
      ce(Lt, 0);
    };
    function Ye(se) {
      Ge = se, Ct || (Ct = !0, Ve());
    }
    function rt(se, Le) {
      he = ce(function() {
        se(c.unstable_now());
      }, Le);
    }
    c.unstable_IdlePriority = 5, c.unstable_ImmediatePriority = 1, c.unstable_LowPriority = 4, c.unstable_NormalPriority = 3, c.unstable_Profiling = null, c.unstable_UserBlockingPriority = 2, c.unstable_cancelCallback = function(se) {
      se.callback = null;
    }, c.unstable_continueExecution = function() {
      Z || F || (Z = !0, Ye(Me));
    }, c.unstable_forceFrameRate = function(se) {
      0 > se || 125 < se ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : Ze = 0 < se ? Math.floor(1e3 / se) : 5;
    }, c.unstable_getCurrentPriorityLevel = function() {
      return U;
    }, c.unstable_getFirstCallbackNode = function() {
      return t(x);
    }, c.unstable_next = function(se) {
      switch (U) {
        case 1:
        case 2:
        case 3:
          var Le = 3;
          break;
        default:
          Le = U;
      }
      var me = U;
      U = Le;
      try {
        return se();
      } finally {
        U = me;
      }
    }, c.unstable_pauseExecution = function() {
    }, c.unstable_requestPaint = function() {
    }, c.unstable_runWithPriority = function(se, Le) {
      switch (se) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          se = 3;
      }
      var me = U;
      U = se;
      try {
        return Le();
      } finally {
        U = me;
      }
    }, c.unstable_scheduleCallback = function(se, Le, me) {
      var At = c.unstable_now();
      switch (typeof me == "object" && me !== null ? (me = me.delay, me = typeof me == "number" && 0 < me ? At + me : At) : me = At, se) {
        case 1:
          var Qt = -1;
          break;
        case 2:
          Qt = 250;
          break;
        case 5:
          Qt = 1073741823;
          break;
        case 4:
          Qt = 1e4;
          break;
        default:
          Qt = 5e3;
      }
      return Qt = me + Qt, se = { id: P++, callback: Le, priorityLevel: se, startTime: me, expirationTime: Qt, sortIndex: -1 }, me > At ? (se.sortIndex = me, s($, se), t(x) === null && se === t($) && (ne ? (De(he), he = -1) : ne = !0, rt(je, me - At))) : (se.sortIndex = Qt, s(x, se), Z || F || (Z = !0, Ye(Me))), se;
    }, c.unstable_shouldYield = Gt, c.unstable_wrapCallback = function(se) {
      var Le = U;
      return function() {
        var me = U;
        U = Le;
        try {
          return se.apply(this, arguments);
        } finally {
          U = me;
        }
      };
    };
  }(c7)), c7;
}
var d7 = {};
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $D;
function TX() {
  return $D || ($D = 1, function(c) {
    process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var s = !1, t = 5;
      function r(ye, We) {
        var $t = ye.length;
        ye.push(We), g(ye, We, $t);
      }
      function f(ye) {
        return ye.length === 0 ? null : ye[0];
      }
      function v(ye) {
        if (ye.length === 0)
          return null;
        var We = ye[0], $t = ye.pop();
        return $t !== We && (ye[0] = $t, T(ye, $t, 0)), We;
      }
      function g(ye, We, $t) {
        for (var Tn = $t; Tn > 0; ) {
          var qn = Tn - 1 >>> 1, Br = ye[qn];
          if (x(Br, We) > 0)
            ye[qn] = We, ye[Tn] = Br, Tn = qn;
          else
            return;
        }
      }
      function T(ye, We, $t) {
        for (var Tn = $t, qn = ye.length, Br = qn >>> 1; Tn < Br; ) {
          var ai = (Tn + 1) * 2 - 1, qr = ye[ai], si = ai + 1, jn = ye[si];
          if (x(qr, We) < 0)
            si < qn && x(jn, qr) < 0 ? (ye[Tn] = jn, ye[si] = We, Tn = si) : (ye[Tn] = qr, ye[ai] = We, Tn = ai);
          else if (si < qn && x(jn, We) < 0)
            ye[Tn] = jn, ye[si] = We, Tn = si;
          else
            return;
        }
      }
      function x(ye, We) {
        var $t = ye.sortIndex - We.sortIndex;
        return $t !== 0 ? $t : ye.id - We.id;
      }
      var $ = 1, P = 2, A = 3, U = 4, F = 5;
      function Z(ye, We) {
      }
      var ne = typeof performance == "object" && typeof performance.now == "function";
      if (ne) {
        var ce = performance;
        c.unstable_now = function() {
          return ce.now();
        };
      } else {
        var De = Date, Ne = De.now();
        c.unstable_now = function() {
          return De.now() - Ne;
        };
      }
      var Se = 1073741823, je = -1, Me = 250, Ct = 5e3, Ge = 1e4, he = Se, Ze = [], pt = [], Gt = 1, Lt = null, Ve = A, mt = !1, wn = !1, Ye = !1, rt = typeof setTimeout == "function" ? setTimeout : null, se = typeof clearTimeout == "function" ? clearTimeout : null, Le = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function me(ye) {
        for (var We = f(pt); We !== null; ) {
          if (We.callback === null)
            v(pt);
          else if (We.startTime <= ye)
            v(pt), We.sortIndex = We.expirationTime, r(Ze, We);
          else
            return;
          We = f(pt);
        }
      }
      function At(ye) {
        if (Ye = !1, me(ye), !wn)
          if (f(Ze) !== null)
            wn = !0, ha(Qt);
          else {
            var We = f(pt);
            We !== null && Us(At, We.startTime - ye);
          }
      }
      function Qt(ye, We) {
        wn = !1, Ye && (Ye = !1, xu()), mt = !0;
        var $t = Ve;
        try {
          var Tn;
          if (!s) return ur(ye, We);
        } finally {
          Lt = null, Ve = $t, mt = !1;
        }
      }
      function ur(ye, We) {
        var $t = We;
        for (me($t), Lt = f(Ze); Lt !== null && !(Lt.expirationTime > $t && (!ye || gh())); ) {
          var Tn = Lt.callback;
          if (typeof Tn == "function") {
            Lt.callback = null, Ve = Lt.priorityLevel;
            var qn = Lt.expirationTime <= $t, Br = Tn(qn);
            $t = c.unstable_now(), typeof Br == "function" ? Lt.callback = Br : Lt === f(Ze) && v(Ze), me($t);
          } else
            v(Ze);
          Lt = f(Ze);
        }
        if (Lt !== null)
          return !0;
        var ai = f(pt);
        return ai !== null && Us(At, ai.startTime - $t), !1;
      }
      function ri(ye, We) {
        switch (ye) {
          case $:
          case P:
          case A:
          case U:
          case F:
            break;
          default:
            ye = A;
        }
        var $t = Ve;
        Ve = ye;
        try {
          return We();
        } finally {
          Ve = $t;
        }
      }
      function Oa(ye) {
        var We;
        switch (Ve) {
          case $:
          case P:
          case A:
            We = A;
            break;
          default:
            We = Ve;
            break;
        }
        var $t = Ve;
        Ve = We;
        try {
          return ye();
        } finally {
          Ve = $t;
        }
      }
      function Ci(ye) {
        var We = Ve;
        return function() {
          var $t = Ve;
          Ve = We;
          try {
            return ye.apply(this, arguments);
          } finally {
            Ve = $t;
          }
        };
      }
      function Si(ye, We, $t) {
        var Tn = c.unstable_now(), qn;
        if (typeof $t == "object" && $t !== null) {
          var Br = $t.delay;
          typeof Br == "number" && Br > 0 ? qn = Tn + Br : qn = Tn;
        } else
          qn = Tn;
        var ai;
        switch (ye) {
          case $:
            ai = je;
            break;
          case P:
            ai = Me;
            break;
          case F:
            ai = he;
            break;
          case U:
            ai = Ge;
            break;
          case A:
          default:
            ai = Ct;
            break;
        }
        var qr = qn + ai, si = {
          id: Gt++,
          callback: We,
          priorityLevel: ye,
          startTime: qn,
          expirationTime: qr,
          sortIndex: -1
        };
        return qn > Tn ? (si.sortIndex = qn, r(pt, si), f(Ze) === null && si === f(pt) && (Ye ? xu() : Ye = !0, Us(At, qn - Tn))) : (si.sortIndex = qr, r(Ze, si), !wn && !mt && (wn = !0, ha(Qt))), si;
      }
      function Ii() {
      }
      function bi() {
        !wn && !mt && (wn = !0, ha(Qt));
      }
      function Bi() {
        return f(Ze);
      }
      function Wn(ye) {
        ye.callback = null;
      }
      function Cr() {
        return Ve;
      }
      var Pi = !1, qi = null, Sr = -1, da = t, ud = -1;
      function gh() {
        var ye = c.unstable_now() - ud;
        return !(ye < da);
      }
      function Ch() {
      }
      function ku(ye) {
        if (ye < 0 || ye > 125) {
          console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
          return;
        }
        ye > 0 ? da = Math.floor(1e3 / ye) : da = t;
      }
      var fa = function() {
        if (qi !== null) {
          var ye = c.unstable_now();
          ud = ye;
          var We = !0, $t = !0;
          try {
            $t = qi(We, ye);
          } finally {
            $t ? _a() : (Pi = !1, qi = null);
          }
        } else
          Pi = !1;
      }, _a;
      if (typeof Le == "function")
        _a = function() {
          Le(fa);
        };
      else if (typeof MessageChannel < "u") {
        var ls = new MessageChannel(), cd = ls.port2;
        ls.port1.onmessage = fa, _a = function() {
          cd.postMessage(null);
        };
      } else
        _a = function() {
          rt(fa, 0);
        };
      function ha(ye) {
        qi = ye, Pi || (Pi = !0, _a());
      }
      function Us(ye, We) {
        Sr = rt(function() {
          ye(c.unstable_now());
        }, We);
      }
      function xu() {
        se(Sr), Sr = -1;
      }
      var Ru = Ch, Sh = null;
      c.unstable_IdlePriority = F, c.unstable_ImmediatePriority = $, c.unstable_LowPriority = U, c.unstable_NormalPriority = A, c.unstable_Profiling = Sh, c.unstable_UserBlockingPriority = P, c.unstable_cancelCallback = Wn, c.unstable_continueExecution = bi, c.unstable_forceFrameRate = ku, c.unstable_getCurrentPriorityLevel = Cr, c.unstable_getFirstCallbackNode = Bi, c.unstable_next = Oa, c.unstable_pauseExecution = Ii, c.unstable_requestPaint = Ru, c.unstable_runWithPriority = ri, c.unstable_scheduleCallback = Si, c.unstable_shouldYield = gh, c.unstable_wrapCallback = Ci, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }();
  }(d7)), d7;
}
var DD;
function hz() {
  return DD || (DD = 1, process.env.NODE_ENV === "production" ? Qb.exports = wX() : Qb.exports = TX()), Qb.exports;
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MD;
function EX() {
  if (MD) return es;
  MD = 1;
  var c = QD, s = hz();
  function t(i) {
    for (var a = "https://reactjs.org/docs/error-decoder.html?invariant=" + i, d = 1; d < arguments.length; d++) a += "&args[]=" + encodeURIComponent(arguments[d]);
    return "Minified React error #" + i + "; visit " + a + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = /* @__PURE__ */ new Set(), f = {};
  function v(i, a) {
    g(i, a), g(i + "Capture", a);
  }
  function g(i, a) {
    for (f[i] = a, i = 0; i < a.length; i++) r.add(a[i]);
  }
  var T = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), x = Object.prototype.hasOwnProperty, $ = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, P = {}, A = {};
  function U(i) {
    return x.call(A, i) ? !0 : x.call(P, i) ? !1 : $.test(i) ? A[i] = !0 : (P[i] = !0, !1);
  }
  function F(i, a, d, p) {
    if (d !== null && d.type === 0) return !1;
    switch (typeof a) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return p ? !1 : d !== null ? !d.acceptsBooleans : (i = i.toLowerCase().slice(0, 5), i !== "data-" && i !== "aria-");
      default:
        return !1;
    }
  }
  function Z(i, a, d, p) {
    if (a === null || typeof a > "u" || F(i, a, d, p)) return !0;
    if (p) return !1;
    if (d !== null) switch (d.type) {
      case 3:
        return !a;
      case 4:
        return a === !1;
      case 5:
        return isNaN(a);
      case 6:
        return isNaN(a) || 1 > a;
    }
    return !1;
  }
  function ne(i, a, d, p, C, b, R) {
    this.acceptsBooleans = a === 2 || a === 3 || a === 4, this.attributeName = p, this.attributeNamespace = C, this.mustUseProperty = d, this.propertyName = i, this.type = a, this.sanitizeURL = b, this.removeEmptyString = R;
  }
  var ce = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(i) {
    ce[i] = new ne(i, 0, !1, i, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(i) {
    var a = i[0];
    ce[a] = new ne(a, 1, !1, i[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(i) {
    ce[i] = new ne(i, 2, !1, i.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(i) {
    ce[i] = new ne(i, 2, !1, i, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(i) {
    ce[i] = new ne(i, 3, !1, i.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(i) {
    ce[i] = new ne(i, 3, !0, i, null, !1, !1);
  }), ["capture", "download"].forEach(function(i) {
    ce[i] = new ne(i, 4, !1, i, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(i) {
    ce[i] = new ne(i, 6, !1, i, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(i) {
    ce[i] = new ne(i, 5, !1, i.toLowerCase(), null, !1, !1);
  });
  var De = /[\-:]([a-z])/g;
  function Ne(i) {
    return i[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(i) {
    var a = i.replace(
      De,
      Ne
    );
    ce[a] = new ne(a, 1, !1, i, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(i) {
    var a = i.replace(De, Ne);
    ce[a] = new ne(a, 1, !1, i, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(i) {
    var a = i.replace(De, Ne);
    ce[a] = new ne(a, 1, !1, i, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(i) {
    ce[i] = new ne(i, 1, !1, i.toLowerCase(), null, !1, !1);
  }), ce.xlinkHref = new ne("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(i) {
    ce[i] = new ne(i, 1, !1, i.toLowerCase(), null, !0, !0);
  });
  function Se(i, a, d, p) {
    var C = ce.hasOwnProperty(a) ? ce[a] : null;
    (C !== null ? C.type !== 0 : p || !(2 < a.length) || a[0] !== "o" && a[0] !== "O" || a[1] !== "n" && a[1] !== "N") && (Z(a, d, C, p) && (d = null), p || C === null ? U(a) && (d === null ? i.removeAttribute(a) : i.setAttribute(a, "" + d)) : C.mustUseProperty ? i[C.propertyName] = d === null ? C.type === 3 ? !1 : "" : d : (a = C.attributeName, p = C.attributeNamespace, d === null ? i.removeAttribute(a) : (C = C.type, d = C === 3 || C === 4 && d === !0 ? "" : "" + d, p ? i.setAttributeNS(p, a, d) : i.setAttribute(a, d))));
  }
  var je = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, Me = Symbol.for("react.element"), Ct = Symbol.for("react.portal"), Ge = Symbol.for("react.fragment"), he = Symbol.for("react.strict_mode"), Ze = Symbol.for("react.profiler"), pt = Symbol.for("react.provider"), Gt = Symbol.for("react.context"), Lt = Symbol.for("react.forward_ref"), Ve = Symbol.for("react.suspense"), mt = Symbol.for("react.suspense_list"), wn = Symbol.for("react.memo"), Ye = Symbol.for("react.lazy"), rt = Symbol.for("react.offscreen"), se = Symbol.iterator;
  function Le(i) {
    return i === null || typeof i != "object" ? null : (i = se && i[se] || i["@@iterator"], typeof i == "function" ? i : null);
  }
  var me = Object.assign, At;
  function Qt(i) {
    if (At === void 0) try {
      throw Error();
    } catch (d) {
      var a = d.stack.trim().match(/\n( *(at )?)/);
      At = a && a[1] || "";
    }
    return `
` + At + i;
  }
  var ur = !1;
  function ri(i, a) {
    if (!i || ur) return "";
    ur = !0;
    var d = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (a) if (a = function() {
        throw Error();
      }, Object.defineProperty(a.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(a, []);
        } catch (Y) {
          var p = Y;
        }
        Reflect.construct(i, [], a);
      } else {
        try {
          a.call();
        } catch (Y) {
          p = Y;
        }
        i.call(a.prototype);
      }
      else {
        try {
          throw Error();
        } catch (Y) {
          p = Y;
        }
        i();
      }
    } catch (Y) {
      if (Y && p && typeof Y.stack == "string") {
        for (var C = Y.stack.split(`
`), b = p.stack.split(`
`), R = C.length - 1, O = b.length - 1; 1 <= R && 0 <= O && C[R] !== b[O]; ) O--;
        for (; 1 <= R && 0 <= O; R--, O--) if (C[R] !== b[O]) {
          if (R !== 1 || O !== 1)
            do
              if (R--, O--, 0 > O || C[R] !== b[O]) {
                var N = `
` + C[R].replace(" at new ", " at ");
                return i.displayName && N.includes("<anonymous>") && (N = N.replace("<anonymous>", i.displayName)), N;
              }
            while (1 <= R && 0 <= O);
          break;
        }
      }
    } finally {
      ur = !1, Error.prepareStackTrace = d;
    }
    return (i = i ? i.displayName || i.name : "") ? Qt(i) : "";
  }
  function Oa(i) {
    switch (i.tag) {
      case 5:
        return Qt(i.type);
      case 16:
        return Qt("Lazy");
      case 13:
        return Qt("Suspense");
      case 19:
        return Qt("SuspenseList");
      case 0:
      case 2:
      case 15:
        return i = ri(i.type, !1), i;
      case 11:
        return i = ri(i.type.render, !1), i;
      case 1:
        return i = ri(i.type, !0), i;
      default:
        return "";
    }
  }
  function Ci(i) {
    if (i == null) return null;
    if (typeof i == "function") return i.displayName || i.name || null;
    if (typeof i == "string") return i;
    switch (i) {
      case Ge:
        return "Fragment";
      case Ct:
        return "Portal";
      case Ze:
        return "Profiler";
      case he:
        return "StrictMode";
      case Ve:
        return "Suspense";
      case mt:
        return "SuspenseList";
    }
    if (typeof i == "object") switch (i.$$typeof) {
      case Gt:
        return (i.displayName || "Context") + ".Consumer";
      case pt:
        return (i._context.displayName || "Context") + ".Provider";
      case Lt:
        var a = i.render;
        return i = i.displayName, i || (i = a.displayName || a.name || "", i = i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef"), i;
      case wn:
        return a = i.displayName || null, a !== null ? a : Ci(i.type) || "Memo";
      case Ye:
        a = i._payload, i = i._init;
        try {
          return Ci(i(a));
        } catch {
        }
    }
    return null;
  }
  function Si(i) {
    var a = i.type;
    switch (i.tag) {
      case 24:
        return "Cache";
      case 9:
        return (a.displayName || "Context") + ".Consumer";
      case 10:
        return (a._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return i = a.render, i = i.displayName || i.name || "", a.displayName || (i !== "" ? "ForwardRef(" + i + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return a;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return Ci(a);
      case 8:
        return a === he ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof a == "function") return a.displayName || a.name || null;
        if (typeof a == "string") return a;
    }
    return null;
  }
  function Ii(i) {
    switch (typeof i) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return i;
      case "object":
        return i;
      default:
        return "";
    }
  }
  function bi(i) {
    var a = i.type;
    return (i = i.nodeName) && i.toLowerCase() === "input" && (a === "checkbox" || a === "radio");
  }
  function Bi(i) {
    var a = bi(i) ? "checked" : "value", d = Object.getOwnPropertyDescriptor(i.constructor.prototype, a), p = "" + i[a];
    if (!i.hasOwnProperty(a) && typeof d < "u" && typeof d.get == "function" && typeof d.set == "function") {
      var C = d.get, b = d.set;
      return Object.defineProperty(i, a, { configurable: !0, get: function() {
        return C.call(this);
      }, set: function(R) {
        p = "" + R, b.call(this, R);
      } }), Object.defineProperty(i, a, { enumerable: d.enumerable }), { getValue: function() {
        return p;
      }, setValue: function(R) {
        p = "" + R;
      }, stopTracking: function() {
        i._valueTracker = null, delete i[a];
      } };
    }
  }
  function Wn(i) {
    i._valueTracker || (i._valueTracker = Bi(i));
  }
  function Cr(i) {
    if (!i) return !1;
    var a = i._valueTracker;
    if (!a) return !0;
    var d = a.getValue(), p = "";
    return i && (p = bi(i) ? i.checked ? "true" : "false" : i.value), i = p, i !== d ? (a.setValue(i), !0) : !1;
  }
  function Pi(i) {
    if (i = i || (typeof document < "u" ? document : void 0), typeof i > "u") return null;
    try {
      return i.activeElement || i.body;
    } catch {
      return i.body;
    }
  }
  function qi(i, a) {
    var d = a.checked;
    return me({}, a, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: d ?? i._wrapperState.initialChecked });
  }
  function Sr(i, a) {
    var d = a.defaultValue == null ? "" : a.defaultValue, p = a.checked != null ? a.checked : a.defaultChecked;
    d = Ii(a.value != null ? a.value : d), i._wrapperState = { initialChecked: p, initialValue: d, controlled: a.type === "checkbox" || a.type === "radio" ? a.checked != null : a.value != null };
  }
  function da(i, a) {
    a = a.checked, a != null && Se(i, "checked", a, !1);
  }
  function ud(i, a) {
    da(i, a);
    var d = Ii(a.value), p = a.type;
    if (d != null) p === "number" ? (d === 0 && i.value === "" || i.value != d) && (i.value = "" + d) : i.value !== "" + d && (i.value = "" + d);
    else if (p === "submit" || p === "reset") {
      i.removeAttribute("value");
      return;
    }
    a.hasOwnProperty("value") ? Ch(i, a.type, d) : a.hasOwnProperty("defaultValue") && Ch(i, a.type, Ii(a.defaultValue)), a.checked == null && a.defaultChecked != null && (i.defaultChecked = !!a.defaultChecked);
  }
  function gh(i, a, d) {
    if (a.hasOwnProperty("value") || a.hasOwnProperty("defaultValue")) {
      var p = a.type;
      if (!(p !== "submit" && p !== "reset" || a.value !== void 0 && a.value !== null)) return;
      a = "" + i._wrapperState.initialValue, d || a === i.value || (i.value = a), i.defaultValue = a;
    }
    d = i.name, d !== "" && (i.name = ""), i.defaultChecked = !!i._wrapperState.initialChecked, d !== "" && (i.name = d);
  }
  function Ch(i, a, d) {
    (a !== "number" || Pi(i.ownerDocument) !== i) && (d == null ? i.defaultValue = "" + i._wrapperState.initialValue : i.defaultValue !== "" + d && (i.defaultValue = "" + d));
  }
  var ku = Array.isArray;
  function fa(i, a, d, p) {
    if (i = i.options, a) {
      a = {};
      for (var C = 0; C < d.length; C++) a["$" + d[C]] = !0;
      for (d = 0; d < i.length; d++) C = a.hasOwnProperty("$" + i[d].value), i[d].selected !== C && (i[d].selected = C), C && p && (i[d].defaultSelected = !0);
    } else {
      for (d = "" + Ii(d), a = null, C = 0; C < i.length; C++) {
        if (i[C].value === d) {
          i[C].selected = !0, p && (i[C].defaultSelected = !0);
          return;
        }
        a !== null || i[C].disabled || (a = i[C]);
      }
      a !== null && (a.selected = !0);
    }
  }
  function _a(i, a) {
    if (a.dangerouslySetInnerHTML != null) throw Error(t(91));
    return me({}, a, { value: void 0, defaultValue: void 0, children: "" + i._wrapperState.initialValue });
  }
  function ls(i, a) {
    var d = a.value;
    if (d == null) {
      if (d = a.children, a = a.defaultValue, d != null) {
        if (a != null) throw Error(t(92));
        if (ku(d)) {
          if (1 < d.length) throw Error(t(93));
          d = d[0];
        }
        a = d;
      }
      a == null && (a = ""), d = a;
    }
    i._wrapperState = { initialValue: Ii(d) };
  }
  function cd(i, a) {
    var d = Ii(a.value), p = Ii(a.defaultValue);
    d != null && (d = "" + d, d !== i.value && (i.value = d), a.defaultValue == null && i.defaultValue !== d && (i.defaultValue = d)), p != null && (i.defaultValue = "" + p);
  }
  function ha(i) {
    var a = i.textContent;
    a === i._wrapperState.initialValue && a !== "" && a !== null && (i.value = a);
  }
  function Us(i) {
    switch (i) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function xu(i, a) {
    return i == null || i === "http://www.w3.org/1999/xhtml" ? Us(a) : i === "http://www.w3.org/2000/svg" && a === "foreignObject" ? "http://www.w3.org/1999/xhtml" : i;
  }
  var Ru, Sh = function(i) {
    return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(a, d, p, C) {
      MSApp.execUnsafeLocalFunction(function() {
        return i(a, d, p, C);
      });
    } : i;
  }(function(i, a) {
    if (i.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in i) i.innerHTML = a;
    else {
      for (Ru = Ru || document.createElement("div"), Ru.innerHTML = "<svg>" + a.valueOf().toString() + "</svg>", a = Ru.firstChild; i.firstChild; ) i.removeChild(i.firstChild);
      for (; a.firstChild; ) i.appendChild(a.firstChild);
    }
  });
  function ye(i, a) {
    if (a) {
      var d = i.firstChild;
      if (d && d === i.lastChild && d.nodeType === 3) {
        d.nodeValue = a;
        return;
      }
    }
    i.textContent = a;
  }
  var We = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, $t = ["Webkit", "ms", "Moz", "O"];
  Object.keys(We).forEach(function(i) {
    $t.forEach(function(a) {
      a = a + i.charAt(0).toUpperCase() + i.substring(1), We[a] = We[i];
    });
  });
  function Tn(i, a, d) {
    return a == null || typeof a == "boolean" || a === "" ? "" : d || typeof a != "number" || a === 0 || We.hasOwnProperty(i) && We[i] ? ("" + a).trim() : a + "px";
  }
  function qn(i, a) {
    i = i.style;
    for (var d in a) if (a.hasOwnProperty(d)) {
      var p = d.indexOf("--") === 0, C = Tn(d, a[d], p);
      d === "float" && (d = "cssFloat"), p ? i.setProperty(d, C) : i[d] = C;
    }
  }
  var Br = me({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function ai(i, a) {
    if (a) {
      if (Br[i] && (a.children != null || a.dangerouslySetInnerHTML != null)) throw Error(t(137, i));
      if (a.dangerouslySetInnerHTML != null) {
        if (a.children != null) throw Error(t(60));
        if (typeof a.dangerouslySetInnerHTML != "object" || !("__html" in a.dangerouslySetInnerHTML)) throw Error(t(61));
      }
      if (a.style != null && typeof a.style != "object") throw Error(t(62));
    }
  }
  function qr(i, a) {
    if (i.indexOf("-") === -1) return typeof a.is == "string";
    switch (i) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var si = null;
  function jn(i) {
    return i = i.target || i.srcElement || window, i.correspondingUseElement && (i = i.correspondingUseElement), i.nodeType === 3 ? i.parentNode : i;
  }
  var wi = null, dd = null, fl = null;
  function sv(i) {
    if (i = Fe(i)) {
      if (typeof wi != "function") throw Error(t(280));
      var a = i.stateNode;
      a && (a = Kn(a), wi(i.stateNode, i.type, a));
    }
  }
  function H0(i) {
    dd ? fl ? fl.push(i) : fl = [i] : dd = i;
  }
  function F0() {
    if (dd) {
      var i = dd, a = fl;
      if (fl = dd = null, sv(i), a) for (i = 0; i < a.length; i++) sv(a[i]);
    }
  }
  function z1(i, a) {
    return i(a);
  }
  function H1() {
  }
  var F1 = !1;
  function I1(i, a, d) {
    if (F1) return i(a, d);
    F1 = !0;
    try {
      return z1(i, a, d);
    } finally {
      F1 = !1, (dd !== null || fl !== null) && (H1(), F0());
    }
  }
  function Lu(i, a) {
    var d = i.stateNode;
    if (d === null) return null;
    var p = Kn(d);
    if (p === null) return null;
    d = p[a];
    e: switch (a) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (p = !p.disabled) || (i = i.type, p = !(i === "button" || i === "input" || i === "select" || i === "textarea")), i = !p;
        break e;
      default:
        i = !1;
    }
    if (i) return null;
    if (d && typeof d != "function") throw Error(t(231, a, typeof d));
    return d;
  }
  var hl = !1;
  if (T) try {
    var us = {};
    Object.defineProperty(us, "passive", { get: function() {
      hl = !0;
    } }), window.addEventListener("test", us, us), window.removeEventListener("test", us, us);
  } catch {
    hl = !1;
  }
  function fd(i, a, d, p, C, b, R, O, N) {
    var Y = Array.prototype.slice.call(arguments, 3);
    try {
      a.apply(d, Y);
    } catch (ae) {
      this.onError(ae);
    }
  }
  var $u = !1, hd = null, pd = !1, bh = null, md = { onError: function(i) {
    $u = !0, hd = i;
  } };
  function ov(i, a, d, p, C, b, R, O, N) {
    $u = !1, hd = null, fd.apply(md, arguments);
  }
  function lv(i, a, d, p, C, b, R, O, N) {
    if (ov.apply(this, arguments), $u) {
      if ($u) {
        var Y = hd;
        $u = !1, hd = null;
      } else throw Error(t(198));
      pd || (pd = !0, bh = Y);
    }
  }
  function cs(i) {
    var a = i, d = i;
    if (i.alternate) for (; a.return; ) a = a.return;
    else {
      i = a;
      do
        a = i, a.flags & 4098 && (d = a.return), i = a.return;
      while (i);
    }
    return a.tag === 3 ? d : null;
  }
  function cr(i) {
    if (i.tag === 13) {
      var a = i.memoizedState;
      if (a === null && (i = i.alternate, i !== null && (a = i.memoizedState)), a !== null) return a.dehydrated;
    }
    return null;
  }
  function I0(i) {
    if (cs(i) !== i) throw Error(t(188));
  }
  function Tw(i) {
    var a = i.alternate;
    if (!a) {
      if (a = cs(i), a === null) throw Error(t(188));
      return a !== i ? null : i;
    }
    for (var d = i, p = a; ; ) {
      var C = d.return;
      if (C === null) break;
      var b = C.alternate;
      if (b === null) {
        if (p = C.return, p !== null) {
          d = p;
          continue;
        }
        break;
      }
      if (C.child === b.child) {
        for (b = C.child; b; ) {
          if (b === d) return I0(C), i;
          if (b === p) return I0(C), a;
          b = b.sibling;
        }
        throw Error(t(188));
      }
      if (d.return !== p.return) d = C, p = b;
      else {
        for (var R = !1, O = C.child; O; ) {
          if (O === d) {
            R = !0, d = C, p = b;
            break;
          }
          if (O === p) {
            R = !0, p = C, d = b;
            break;
          }
          O = O.sibling;
        }
        if (!R) {
          for (O = b.child; O; ) {
            if (O === d) {
              R = !0, d = b, p = C;
              break;
            }
            if (O === p) {
              R = !0, p = b, d = C;
              break;
            }
            O = O.sibling;
          }
          if (!R) throw Error(t(189));
        }
      }
      if (d.alternate !== p) throw Error(t(190));
    }
    if (d.tag !== 3) throw Error(t(188));
    return d.stateNode.current === d ? i : a;
  }
  function B1(i) {
    return i = Tw(i), i !== null ? B0(i) : null;
  }
  function B0(i) {
    if (i.tag === 5 || i.tag === 6) return i;
    for (i = i.child; i !== null; ) {
      var a = B0(i);
      if (a !== null) return a;
      i = i.sibling;
    }
    return null;
  }
  var q0 = s.unstable_scheduleCallback, j0 = s.unstable_cancelCallback, G0 = s.unstable_shouldYield, Ew = s.unstable_requestPaint, En = s.unstable_now, Pt = s.unstable_getCurrentPriorityLevel, Du = s.unstable_ImmediatePriority, q1 = s.unstable_UserBlockingPriority, wh = s.unstable_NormalPriority, Q0 = s.unstable_LowPriority, j1 = s.unstable_IdlePriority, Th = null, ds = null;
  function Y0(i) {
    if (ds && typeof ds.onCommitFiberRoot == "function") try {
      ds.onCommitFiberRoot(Th, i, void 0, (i.current.flags & 128) === 128);
    } catch {
    }
  }
  var Na = Math.clz32 ? Math.clz32 : G1, kw = Math.log, xw = Math.LN2;
  function G1(i) {
    return i >>>= 0, i === 0 ? 32 : 31 - (kw(i) / xw | 0) | 0;
  }
  var vd = 64, fs = 4194304;
  function Mu(i) {
    switch (i & -i) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return i & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return i;
    }
  }
  function Au(i, a) {
    var d = i.pendingLanes;
    if (d === 0) return 0;
    var p = 0, C = i.suspendedLanes, b = i.pingedLanes, R = d & 268435455;
    if (R !== 0) {
      var O = R & ~C;
      O !== 0 ? p = Mu(O) : (b &= R, b !== 0 && (p = Mu(b)));
    } else R = d & ~C, R !== 0 ? p = Mu(R) : b !== 0 && (p = Mu(b));
    if (p === 0) return 0;
    if (a !== 0 && a !== p && !(a & C) && (C = p & -p, b = a & -a, C >= b || C === 16 && (b & 4194240) !== 0)) return a;
    if (p & 4 && (p |= d & 16), a = i.entangledLanes, a !== 0) for (i = i.entanglements, a &= p; 0 < a; ) d = 31 - Na(a), C = 1 << d, p |= i[d], a &= ~C;
    return p;
  }
  function Rw(i, a) {
    switch (i) {
      case 1:
      case 2:
      case 4:
        return a + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Q1(i, a) {
    for (var d = i.suspendedLanes, p = i.pingedLanes, C = i.expirationTimes, b = i.pendingLanes; 0 < b; ) {
      var R = 31 - Na(b), O = 1 << R, N = C[R];
      N === -1 ? (!(O & d) || O & p) && (C[R] = Rw(O, a)) : N <= a && (i.expiredLanes |= O), b &= ~O;
    }
  }
  function Y1(i) {
    return i = i.pendingLanes & -1073741825, i !== 0 ? i : i & 1073741824 ? 1073741824 : 0;
  }
  function uv() {
    var i = vd;
    return vd <<= 1, !(vd & 4194240) && (vd = 64), i;
  }
  function W1(i) {
    for (var a = [], d = 0; 31 > d; d++) a.push(i);
    return a;
  }
  function Pu(i, a, d) {
    i.pendingLanes |= a, a !== 536870912 && (i.suspendedLanes = 0, i.pingedLanes = 0), i = i.eventTimes, a = 31 - Na(a), i[a] = d;
  }
  function Lw(i, a) {
    var d = i.pendingLanes & ~a;
    i.pendingLanes = a, i.suspendedLanes = 0, i.pingedLanes = 0, i.expiredLanes &= a, i.mutableReadLanes &= a, i.entangledLanes &= a, a = i.entanglements;
    var p = i.eventTimes;
    for (i = i.expirationTimes; 0 < d; ) {
      var C = 31 - Na(d), b = 1 << C;
      a[C] = 0, p[C] = -1, i[C] = -1, d &= ~b;
    }
  }
  function cv(i, a) {
    var d = i.entangledLanes |= a;
    for (i = i.entanglements; d; ) {
      var p = 31 - Na(d), C = 1 << p;
      C & a | i[p] & a && (i[p] |= a), d &= ~C;
    }
  }
  var dn = 0;
  function K1(i) {
    return i &= -i, 1 < i ? 4 < i ? i & 268435455 ? 16 : 536870912 : 4 : 1;
  }
  var fn, Z1, X1, vt, J1, br = !1, pl = [], Va = null, ml = null, Gn = null, Mn = /* @__PURE__ */ new Map(), Eh = /* @__PURE__ */ new Map(), ji = [], Ua = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function go(i, a) {
    switch (i) {
      case "focusin":
      case "focusout":
        Va = null;
        break;
      case "dragenter":
      case "dragleave":
        ml = null;
        break;
      case "mouseover":
      case "mouseout":
        Gn = null;
        break;
      case "pointerover":
      case "pointerout":
        Mn.delete(a.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        Eh.delete(a.pointerId);
    }
  }
  function kh(i, a, d, p, C, b) {
    return i === null || i.nativeEvent !== b ? (i = { blockedOn: a, domEventName: d, eventSystemFlags: p, nativeEvent: b, targetContainers: [C] }, a !== null && (a = Fe(a), a !== null && Z1(a)), i) : (i.eventSystemFlags |= p, a = i.targetContainers, C !== null && a.indexOf(C) === -1 && a.push(C), i);
  }
  function e3(i, a, d, p, C) {
    switch (a) {
      case "focusin":
        return Va = kh(Va, i, a, d, p, C), !0;
      case "dragenter":
        return ml = kh(ml, i, a, d, p, C), !0;
      case "mouseover":
        return Gn = kh(Gn, i, a, d, p, C), !0;
      case "pointerover":
        var b = C.pointerId;
        return Mn.set(b, kh(Mn.get(b) || null, i, a, d, p, C)), !0;
      case "gotpointercapture":
        return b = C.pointerId, Eh.set(b, kh(Eh.get(b) || null, i, a, d, p, C)), !0;
    }
    return !1;
  }
  function t3(i) {
    var a = Bu(i.target);
    if (a !== null) {
      var d = cs(a);
      if (d !== null) {
        if (a = d.tag, a === 13) {
          if (a = cr(d), a !== null) {
            i.blockedOn = a, J1(i.priority, function() {
              X1(d);
            });
            return;
          }
        } else if (a === 3 && d.stateNode.current.memoizedState.isDehydrated) {
          i.blockedOn = d.tag === 3 ? d.stateNode.containerInfo : null;
          return;
        }
      }
    }
    i.blockedOn = null;
  }
  function xh(i) {
    if (i.blockedOn !== null) return !1;
    for (var a = i.targetContainers; 0 < a.length; ) {
      var d = fv(i.domEventName, i.eventSystemFlags, a[0], i.nativeEvent);
      if (d === null) {
        d = i.nativeEvent;
        var p = new d.constructor(d.type, d);
        si = p, d.target.dispatchEvent(p), si = null;
      } else return a = Fe(d), a !== null && Z1(a), i.blockedOn = d, !1;
      a.shift();
    }
    return !0;
  }
  function W0(i, a, d) {
    xh(i) && d.delete(a);
  }
  function $w() {
    br = !1, Va !== null && xh(Va) && (Va = null), ml !== null && xh(ml) && (ml = null), Gn !== null && xh(Gn) && (Gn = null), Mn.forEach(W0), Eh.forEach(W0);
  }
  function Rh(i, a) {
    i.blockedOn === a && (i.blockedOn = null, br || (br = !0, s.unstable_scheduleCallback(s.unstable_NormalPriority, $w)));
  }
  function vl(i) {
    function a(C) {
      return Rh(C, i);
    }
    if (0 < pl.length) {
      Rh(pl[0], i);
      for (var d = 1; d < pl.length; d++) {
        var p = pl[d];
        p.blockedOn === i && (p.blockedOn = null);
      }
    }
    for (Va !== null && Rh(Va, i), ml !== null && Rh(ml, i), Gn !== null && Rh(Gn, i), Mn.forEach(a), Eh.forEach(a), d = 0; d < ji.length; d++) p = ji[d], p.blockedOn === i && (p.blockedOn = null);
    for (; 0 < ji.length && (d = ji[0], d.blockedOn === null); ) t3(d), d.blockedOn === null && ji.shift();
  }
  var Ou = je.ReactCurrentBatchConfig, _u = !0;
  function K0(i, a, d, p) {
    var C = dn, b = Ou.transition;
    Ou.transition = null;
    try {
      dn = 1, dv(i, a, d, p);
    } finally {
      dn = C, Ou.transition = b;
    }
  }
  function Z0(i, a, d, p) {
    var C = dn, b = Ou.transition;
    Ou.transition = null;
    try {
      dn = 4, dv(i, a, d, p);
    } finally {
      dn = C, Ou.transition = b;
    }
  }
  function dv(i, a, d, p) {
    if (_u) {
      var C = fv(i, a, d, p);
      if (C === null) Dv(i, a, p, Lh, d), go(i, p);
      else if (e3(C, i, a, d, p)) p.stopPropagation();
      else if (go(i, p), a & 4 && -1 < Ua.indexOf(i)) {
        for (; C !== null; ) {
          var b = Fe(C);
          if (b !== null && fn(b), b = fv(i, a, d, p), b === null && Dv(i, a, p, Lh, d), b === C) break;
          C = b;
        }
        C !== null && p.stopPropagation();
      } else Dv(i, a, p, null, d);
    }
  }
  var Lh = null;
  function fv(i, a, d, p) {
    if (Lh = null, i = jn(p), i = Bu(i), i !== null) if (a = cs(i), a === null) i = null;
    else if (d = a.tag, d === 13) {
      if (i = cr(a), i !== null) return i;
      i = null;
    } else if (d === 3) {
      if (a.stateNode.current.memoizedState.isDehydrated) return a.tag === 3 ? a.stateNode.containerInfo : null;
      i = null;
    } else a !== i && (i = null);
    return Lh = i, null;
  }
  function hv(i) {
    switch (i) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (Pt()) {
          case Du:
            return 1;
          case q1:
            return 4;
          case wh:
          case Q0:
            return 16;
          case j1:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Co = null, pv = null, yd = null;
  function n3() {
    if (yd) return yd;
    var i, a = pv, d = a.length, p, C = "value" in Co ? Co.value : Co.textContent, b = C.length;
    for (i = 0; i < d && a[i] === C[i]; i++) ;
    var R = d - i;
    for (p = 1; p <= R && a[d - p] === C[b - p]; p++) ;
    return yd = C.slice(i, 1 < p ? 1 - p : void 0);
  }
  function mv(i) {
    var a = i.keyCode;
    return "charCode" in i ? (i = i.charCode, i === 0 && a === 13 && (i = 13)) : i = a, i === 10 && (i = 13), 32 <= i || i === 13 ? i : 0;
  }
  function vv() {
    return !0;
  }
  function yv() {
    return !1;
  }
  function jr(i) {
    function a(d, p, C, b, R) {
      this._reactName = d, this._targetInst = C, this.type = p, this.nativeEvent = b, this.target = R, this.currentTarget = null;
      for (var O in i) i.hasOwnProperty(O) && (d = i[O], this[O] = d ? d(b) : b[O]);
      return this.isDefaultPrevented = (b.defaultPrevented != null ? b.defaultPrevented : b.returnValue === !1) ? vv : yv, this.isPropagationStopped = yv, this;
    }
    return me(a.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var d = this.nativeEvent;
      d && (d.preventDefault ? d.preventDefault() : typeof d.returnValue != "unknown" && (d.returnValue = !1), this.isDefaultPrevented = vv);
    }, stopPropagation: function() {
      var d = this.nativeEvent;
      d && (d.stopPropagation ? d.stopPropagation() : typeof d.cancelBubble != "unknown" && (d.cancelBubble = !0), this.isPropagationStopped = vv);
    }, persist: function() {
    }, isPersistent: vv }), a;
  }
  var Nu = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(i) {
    return i.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, gv = jr(Nu), gd = me({}, Nu, { view: 0, detail: 0 }), Dw = jr(gd), i3, Gi, Vu, $h = me({}, gd, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: l3, button: 0, buttons: 0, relatedTarget: function(i) {
    return i.relatedTarget === void 0 ? i.fromElement === i.srcElement ? i.toElement : i.fromElement : i.relatedTarget;
  }, movementX: function(i) {
    return "movementX" in i ? i.movementX : (i !== Vu && (Vu && i.type === "mousemove" ? (i3 = i.screenX - Vu.screenX, Gi = i.screenY - Vu.screenY) : Gi = i3 = 0, Vu = i), i3);
  }, movementY: function(i) {
    return "movementY" in i ? i.movementY : Gi;
  } }), r3 = jr($h), Mw = me({}, $h, { dataTransfer: 0 }), Cd = jr(Mw), a3 = me({}, gd, { relatedTarget: 0 }), Cv = jr(a3), Aw = me({}, Nu, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), Pw = jr(Aw), Ow = me({}, Nu, { clipboardData: function(i) {
    return "clipboardData" in i ? i.clipboardData : window.clipboardData;
  } }), X0 = jr(Ow), s3 = me({}, Nu, { data: 0 }), o3 = jr(s3), J0 = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, eC = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, _w = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function So(i) {
    var a = this.nativeEvent;
    return a.getModifierState ? a.getModifierState(i) : (i = _w[i]) ? !!a[i] : !1;
  }
  function l3() {
    return So;
  }
  var u3 = me({}, gd, { key: function(i) {
    if (i.key) {
      var a = J0[i.key] || i.key;
      if (a !== "Unidentified") return a;
    }
    return i.type === "keypress" ? (i = mv(i), i === 13 ? "Enter" : String.fromCharCode(i)) : i.type === "keydown" || i.type === "keyup" ? eC[i.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: l3, charCode: function(i) {
    return i.type === "keypress" ? mv(i) : 0;
  }, keyCode: function(i) {
    return i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  }, which: function(i) {
    return i.type === "keypress" ? mv(i) : i.type === "keydown" || i.type === "keyup" ? i.keyCode : 0;
  } }), c3 = jr(u3), d3 = me({}, $h, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), tC = jr(d3), Sv = me({}, gd, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: l3 }), nC = jr(Sv), Gr = me({}, Nu, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), bo = jr(Gr), oi = me({}, $h, {
    deltaX: function(i) {
      return "deltaX" in i ? i.deltaX : "wheelDeltaX" in i ? -i.wheelDeltaX : 0;
    },
    deltaY: function(i) {
      return "deltaY" in i ? i.deltaY : "wheelDeltaY" in i ? -i.wheelDeltaY : "wheelDelta" in i ? -i.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), wo = jr(oi), f3 = [9, 13, 27, 32], Sd = T && "CompositionEvent" in window, Dh = null;
  T && "documentMode" in document && (Dh = document.documentMode);
  var Mh = T && "TextEvent" in window && !Dh, iC = T && (!Sd || Dh && 8 < Dh && 11 >= Dh), rC = " ", bv = !1;
  function aC(i, a) {
    switch (i) {
      case "keyup":
        return f3.indexOf(a.keyCode) !== -1;
      case "keydown":
        return a.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function sC(i) {
    return i = i.detail, typeof i == "object" && "data" in i ? i.data : null;
  }
  var bd = !1;
  function oC(i, a) {
    switch (i) {
      case "compositionend":
        return sC(a);
      case "keypress":
        return a.which !== 32 ? null : (bv = !0, rC);
      case "textInput":
        return i = a.data, i === rC && bv ? null : i;
      default:
        return null;
    }
  }
  function Nw(i, a) {
    if (bd) return i === "compositionend" || !Sd && aC(i, a) ? (i = n3(), yd = pv = Co = null, bd = !1, i) : null;
    switch (i) {
      case "paste":
        return null;
      case "keypress":
        if (!(a.ctrlKey || a.altKey || a.metaKey) || a.ctrlKey && a.altKey) {
          if (a.char && 1 < a.char.length) return a.char;
          if (a.which) return String.fromCharCode(a.which);
        }
        return null;
      case "compositionend":
        return iC && a.locale !== "ko" ? null : a.data;
      default:
        return null;
    }
  }
  var Vw = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function lC(i) {
    var a = i && i.nodeName && i.nodeName.toLowerCase();
    return a === "input" ? !!Vw[i.type] : a === "textarea";
  }
  function h3(i, a, d, p) {
    H0(p), a = Vh(a, "onChange"), 0 < a.length && (d = new gv("onChange", "change", null, d, p), i.push({ event: d, listeners: a }));
  }
  var zs = null, Uu = null;
  function uC(i) {
    Fu(i, 0);
  }
  function Ah(i) {
    var a = ps(i);
    if (Cr(a)) return i;
  }
  function Uw(i, a) {
    if (i === "change") return a;
  }
  var cC = !1;
  if (T) {
    var p3;
    if (T) {
      var m3 = "oninput" in document;
      if (!m3) {
        var dC = document.createElement("div");
        dC.setAttribute("oninput", "return;"), m3 = typeof dC.oninput == "function";
      }
      p3 = m3;
    } else p3 = !1;
    cC = p3 && (!document.documentMode || 9 < document.documentMode);
  }
  function fC() {
    zs && (zs.detachEvent("onpropertychange", hC), Uu = zs = null);
  }
  function hC(i) {
    if (i.propertyName === "value" && Ah(Uu)) {
      var a = [];
      h3(a, Uu, i, jn(i)), I1(uC, a);
    }
  }
  function zw(i, a, d) {
    i === "focusin" ? (fC(), zs = a, Uu = d, zs.attachEvent("onpropertychange", hC)) : i === "focusout" && fC();
  }
  function pC(i) {
    if (i === "selectionchange" || i === "keyup" || i === "keydown") return Ah(Uu);
  }
  function Hw(i, a) {
    if (i === "click") return Ah(a);
  }
  function mC(i, a) {
    if (i === "input" || i === "change") return Ah(a);
  }
  function Fw(i, a) {
    return i === a && (i !== 0 || 1 / i === 1 / a) || i !== i && a !== a;
  }
  var hs = typeof Object.is == "function" ? Object.is : Fw;
  function Ph(i, a) {
    if (hs(i, a)) return !0;
    if (typeof i != "object" || i === null || typeof a != "object" || a === null) return !1;
    var d = Object.keys(i), p = Object.keys(a);
    if (d.length !== p.length) return !1;
    for (p = 0; p < d.length; p++) {
      var C = d[p];
      if (!x.call(a, C) || !hs(i[C], a[C])) return !1;
    }
    return !0;
  }
  function vC(i) {
    for (; i && i.firstChild; ) i = i.firstChild;
    return i;
  }
  function wv(i, a) {
    var d = vC(i);
    i = 0;
    for (var p; d; ) {
      if (d.nodeType === 3) {
        if (p = i + d.textContent.length, i <= a && p >= a) return { node: d, offset: a - i };
        i = p;
      }
      e: {
        for (; d; ) {
          if (d.nextSibling) {
            d = d.nextSibling;
            break e;
          }
          d = d.parentNode;
        }
        d = void 0;
      }
      d = vC(d);
    }
  }
  function yl(i, a) {
    return i && a ? i === a ? !0 : i && i.nodeType === 3 ? !1 : a && a.nodeType === 3 ? yl(i, a.parentNode) : "contains" in i ? i.contains(a) : i.compareDocumentPosition ? !!(i.compareDocumentPosition(a) & 16) : !1 : !1;
  }
  function Oh() {
    for (var i = window, a = Pi(); a instanceof i.HTMLIFrameElement; ) {
      try {
        var d = typeof a.contentWindow.location.href == "string";
      } catch {
        d = !1;
      }
      if (d) i = a.contentWindow;
      else break;
      a = Pi(i.document);
    }
    return a;
  }
  function Tv(i) {
    var a = i && i.nodeName && i.nodeName.toLowerCase();
    return a && (a === "input" && (i.type === "text" || i.type === "search" || i.type === "tel" || i.type === "url" || i.type === "password") || a === "textarea" || i.contentEditable === "true");
  }
  function wd(i) {
    var a = Oh(), d = i.focusedElem, p = i.selectionRange;
    if (a !== d && d && d.ownerDocument && yl(d.ownerDocument.documentElement, d)) {
      if (p !== null && Tv(d)) {
        if (a = p.start, i = p.end, i === void 0 && (i = a), "selectionStart" in d) d.selectionStart = a, d.selectionEnd = Math.min(i, d.value.length);
        else if (i = (a = d.ownerDocument || document) && a.defaultView || window, i.getSelection) {
          i = i.getSelection();
          var C = d.textContent.length, b = Math.min(p.start, C);
          p = p.end === void 0 ? b : Math.min(p.end, C), !i.extend && b > p && (C = p, p = b, b = C), C = wv(d, b);
          var R = wv(
            d,
            p
          );
          C && R && (i.rangeCount !== 1 || i.anchorNode !== C.node || i.anchorOffset !== C.offset || i.focusNode !== R.node || i.focusOffset !== R.offset) && (a = a.createRange(), a.setStart(C.node, C.offset), i.removeAllRanges(), b > p ? (i.addRange(a), i.extend(R.node, R.offset)) : (a.setEnd(R.node, R.offset), i.addRange(a)));
        }
      }
      for (a = [], i = d; i = i.parentNode; ) i.nodeType === 1 && a.push({ element: i, left: i.scrollLeft, top: i.scrollTop });
      for (typeof d.focus == "function" && d.focus(), d = 0; d < a.length; d++) i = a[d], i.element.scrollLeft = i.left, i.element.scrollTop = i.top;
    }
  }
  var Iw = T && "documentMode" in document && 11 >= document.documentMode, Td = null, v3 = null, _h = null, y3 = !1;
  function g3(i, a, d) {
    var p = d.window === d ? d.document : d.nodeType === 9 ? d : d.ownerDocument;
    y3 || Td == null || Td !== Pi(p) || (p = Td, "selectionStart" in p && Tv(p) ? p = { start: p.selectionStart, end: p.selectionEnd } : (p = (p.ownerDocument && p.ownerDocument.defaultView || window).getSelection(), p = { anchorNode: p.anchorNode, anchorOffset: p.anchorOffset, focusNode: p.focusNode, focusOffset: p.focusOffset }), _h && Ph(_h, p) || (_h = p, p = Vh(v3, "onSelect"), 0 < p.length && (a = new gv("onSelect", "select", null, a, d), i.push({ event: a, listeners: p }), a.target = Td)));
  }
  function Ev(i, a) {
    var d = {};
    return d[i.toLowerCase()] = a.toLowerCase(), d["Webkit" + i] = "webkit" + a, d["Moz" + i] = "moz" + a, d;
  }
  var zu = { animationend: Ev("Animation", "AnimationEnd"), animationiteration: Ev("Animation", "AnimationIteration"), animationstart: Ev("Animation", "AnimationStart"), transitionend: Ev("Transition", "TransitionEnd") }, Qi = {}, C3 = {};
  T && (C3 = document.createElement("div").style, "AnimationEvent" in window || (delete zu.animationend.animation, delete zu.animationiteration.animation, delete zu.animationstart.animation), "TransitionEvent" in window || delete zu.transitionend.transition);
  function kv(i) {
    if (Qi[i]) return Qi[i];
    if (!zu[i]) return i;
    var a = zu[i], d;
    for (d in a) if (a.hasOwnProperty(d) && d in C3) return Qi[i] = a[d];
    return i;
  }
  var yC = kv("animationend"), gC = kv("animationiteration"), CC = kv("animationstart"), SC = kv("transitionend"), S3 = /* @__PURE__ */ new Map(), xv = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function za(i, a) {
    S3.set(i, a), v(a, [i]);
  }
  for (var b3 = 0; b3 < xv.length; b3++) {
    var Hu = xv[b3], Bw = Hu.toLowerCase(), qw = Hu[0].toUpperCase() + Hu.slice(1);
    za(Bw, "on" + qw);
  }
  za(yC, "onAnimationEnd"), za(gC, "onAnimationIteration"), za(CC, "onAnimationStart"), za("dblclick", "onDoubleClick"), za("focusin", "onFocus"), za("focusout", "onBlur"), za(SC, "onTransitionEnd"), g("onMouseEnter", ["mouseout", "mouseover"]), g("onMouseLeave", ["mouseout", "mouseover"]), g("onPointerEnter", ["pointerout", "pointerover"]), g("onPointerLeave", ["pointerout", "pointerover"]), v("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), v("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), v("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), v("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), v("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var Nh = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), w3 = new Set("cancel close invalid load scroll toggle".split(" ").concat(Nh));
  function Rv(i, a, d) {
    var p = i.type || "unknown-event";
    i.currentTarget = d, lv(p, a, void 0, i), i.currentTarget = null;
  }
  function Fu(i, a) {
    a = (a & 4) !== 0;
    for (var d = 0; d < i.length; d++) {
      var p = i[d], C = p.event;
      p = p.listeners;
      e: {
        var b = void 0;
        if (a) for (var R = p.length - 1; 0 <= R; R--) {
          var O = p[R], N = O.instance, Y = O.currentTarget;
          if (O = O.listener, N !== b && C.isPropagationStopped()) break e;
          Rv(C, O, Y), b = N;
        }
        else for (R = 0; R < p.length; R++) {
          if (O = p[R], N = O.instance, Y = O.currentTarget, O = O.listener, N !== b && C.isPropagationStopped()) break e;
          Rv(C, O, Y), b = N;
        }
      }
    }
    if (pd) throw i = bh, pd = !1, bh = null, i;
  }
  function ln(i, a) {
    var d = a[Hh];
    d === void 0 && (d = a[Hh] = /* @__PURE__ */ new Set());
    var p = i + "__bubble";
    d.has(p) || (bC(a, i, 2, !1), d.add(p));
  }
  function Lv(i, a, d) {
    var p = 0;
    a && (p |= 4), bC(d, i, p, a);
  }
  var $v = "_reactListening" + Math.random().toString(36).slice(2);
  function Ed(i) {
    if (!i[$v]) {
      i[$v] = !0, r.forEach(function(d) {
        d !== "selectionchange" && (w3.has(d) || Lv(d, !1, i), Lv(d, !0, i));
      });
      var a = i.nodeType === 9 ? i : i.ownerDocument;
      a === null || a[$v] || (a[$v] = !0, Lv("selectionchange", !1, a));
    }
  }
  function bC(i, a, d, p) {
    switch (hv(a)) {
      case 1:
        var C = K0;
        break;
      case 4:
        C = Z0;
        break;
      default:
        C = dv;
    }
    d = C.bind(null, a, d, i), C = void 0, !hl || a !== "touchstart" && a !== "touchmove" && a !== "wheel" || (C = !0), p ? C !== void 0 ? i.addEventListener(a, d, { capture: !0, passive: C }) : i.addEventListener(a, d, !0) : C !== void 0 ? i.addEventListener(a, d, { passive: C }) : i.addEventListener(a, d, !1);
  }
  function Dv(i, a, d, p, C) {
    var b = p;
    if (!(a & 1) && !(a & 2) && p !== null) e: for (; ; ) {
      if (p === null) return;
      var R = p.tag;
      if (R === 3 || R === 4) {
        var O = p.stateNode.containerInfo;
        if (O === C || O.nodeType === 8 && O.parentNode === C) break;
        if (R === 4) for (R = p.return; R !== null; ) {
          var N = R.tag;
          if ((N === 3 || N === 4) && (N = R.stateNode.containerInfo, N === C || N.nodeType === 8 && N.parentNode === C)) return;
          R = R.return;
        }
        for (; O !== null; ) {
          if (R = Bu(O), R === null) return;
          if (N = R.tag, N === 5 || N === 6) {
            p = b = R;
            continue e;
          }
          O = O.parentNode;
        }
      }
      p = p.return;
    }
    I1(function() {
      var Y = b, ae = jn(d), oe = [];
      e: {
        var re = S3.get(i);
        if (re !== void 0) {
          var Te = gv, Ae = i;
          switch (i) {
            case "keypress":
              if (mv(d) === 0) break e;
            case "keydown":
            case "keyup":
              Te = c3;
              break;
            case "focusin":
              Ae = "focus", Te = Cv;
              break;
            case "focusout":
              Ae = "blur", Te = Cv;
              break;
            case "beforeblur":
            case "afterblur":
              Te = Cv;
              break;
            case "click":
              if (d.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              Te = r3;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              Te = Cd;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              Te = nC;
              break;
            case yC:
            case gC:
            case CC:
              Te = Pw;
              break;
            case SC:
              Te = bo;
              break;
            case "scroll":
              Te = Dw;
              break;
            case "wheel":
              Te = wo;
              break;
            case "copy":
            case "cut":
            case "paste":
              Te = X0;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              Te = tC;
          }
          var _e = (a & 4) !== 0, ti = !_e && i === "scroll", B = _e ? re !== null ? re + "Capture" : null : re;
          _e = [];
          for (var z = Y, G; z !== null; ) {
            G = z;
            var de = G.stateNode;
            if (G.tag === 5 && de !== null && (G = de, B !== null && (de = Lu(z, B), de != null && _e.push(kd(z, de, G)))), ti) break;
            z = z.return;
          }
          0 < _e.length && (re = new Te(re, Ae, null, d, ae), oe.push({ event: re, listeners: _e }));
        }
      }
      if (!(a & 7)) {
        e: {
          if (re = i === "mouseover" || i === "pointerover", Te = i === "mouseout" || i === "pointerout", re && d !== si && (Ae = d.relatedTarget || d.fromElement) && (Bu(Ae) || Ae[To])) break e;
          if ((Te || re) && (re = ae.window === ae ? ae : (re = ae.ownerDocument) ? re.defaultView || re.parentWindow : window, Te ? (Ae = d.relatedTarget || d.toElement, Te = Y, Ae = Ae ? Bu(Ae) : null, Ae !== null && (ti = cs(Ae), Ae !== ti || Ae.tag !== 5 && Ae.tag !== 6) && (Ae = null)) : (Te = null, Ae = Y), Te !== Ae)) {
            if (_e = r3, de = "onMouseLeave", B = "onMouseEnter", z = "mouse", (i === "pointerout" || i === "pointerover") && (_e = tC, de = "onPointerLeave", B = "onPointerEnter", z = "pointer"), ti = Te == null ? re : ps(Te), G = Ae == null ? re : ps(Ae), re = new _e(de, z + "leave", Te, d, ae), re.target = ti, re.relatedTarget = G, de = null, Bu(ae) === Y && (_e = new _e(B, z + "enter", Ae, d, ae), _e.target = G, _e.relatedTarget = ti, de = _e), ti = de, Te && Ae) t: {
              for (_e = Te, B = Ae, z = 0, G = _e; G; G = gl(G)) z++;
              for (G = 0, de = B; de; de = gl(de)) G++;
              for (; 0 < z - G; ) _e = gl(_e), z--;
              for (; 0 < G - z; ) B = gl(B), G--;
              for (; z--; ) {
                if (_e === B || B !== null && _e === B.alternate) break t;
                _e = gl(_e), B = gl(B);
              }
              _e = null;
            }
            else _e = null;
            Te !== null && wC(oe, re, Te, _e, !1), Ae !== null && ti !== null && wC(oe, ti, Ae, _e, !0);
          }
        }
        e: {
          if (re = Y ? ps(Y) : window, Te = re.nodeName && re.nodeName.toLowerCase(), Te === "select" || Te === "input" && re.type === "file") var be = Uw;
          else if (lC(re)) if (cC) be = mC;
          else {
            be = pC;
            var Be = zw;
          }
          else (Te = re.nodeName) && Te.toLowerCase() === "input" && (re.type === "checkbox" || re.type === "radio") && (be = Hw);
          if (be && (be = be(i, Y))) {
            h3(oe, be, d, ae);
            break e;
          }
          Be && Be(i, re, Y), i === "focusout" && (Be = re._wrapperState) && Be.controlled && re.type === "number" && Ch(re, "number", re.value);
        }
        switch (Be = Y ? ps(Y) : window, i) {
          case "focusin":
            (lC(Be) || Be.contentEditable === "true") && (Td = Be, v3 = Y, _h = null);
            break;
          case "focusout":
            _h = v3 = Td = null;
            break;
          case "mousedown":
            y3 = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            y3 = !1, g3(oe, d, ae);
            break;
          case "selectionchange":
            if (Iw) break;
          case "keydown":
          case "keyup":
            g3(oe, d, ae);
        }
        var Ke;
        if (Sd) e: {
          switch (i) {
            case "compositionstart":
              var ot = "onCompositionStart";
              break e;
            case "compositionend":
              ot = "onCompositionEnd";
              break e;
            case "compositionupdate":
              ot = "onCompositionUpdate";
              break e;
          }
          ot = void 0;
        }
        else bd ? aC(i, d) && (ot = "onCompositionEnd") : i === "keydown" && d.keyCode === 229 && (ot = "onCompositionStart");
        ot && (iC && d.locale !== "ko" && (bd || ot !== "onCompositionStart" ? ot === "onCompositionEnd" && bd && (Ke = n3()) : (Co = ae, pv = "value" in Co ? Co.value : Co.textContent, bd = !0)), Be = Vh(Y, ot), 0 < Be.length && (ot = new o3(ot, i, null, d, ae), oe.push({ event: ot, listeners: Be }), Ke ? ot.data = Ke : (Ke = sC(d), Ke !== null && (ot.data = Ke)))), (Ke = Mh ? oC(i, d) : Nw(i, d)) && (Y = Vh(Y, "onBeforeInput"), 0 < Y.length && (ae = new o3("onBeforeInput", "beforeinput", null, d, ae), oe.push({ event: ae, listeners: Y }), ae.data = Ke));
      }
      Fu(oe, a);
    });
  }
  function kd(i, a, d) {
    return { instance: i, listener: a, currentTarget: d };
  }
  function Vh(i, a) {
    for (var d = a + "Capture", p = []; i !== null; ) {
      var C = i, b = C.stateNode;
      C.tag === 5 && b !== null && (C = b, b = Lu(i, d), b != null && p.unshift(kd(i, b, C)), b = Lu(i, a), b != null && p.push(kd(i, b, C))), i = i.return;
    }
    return p;
  }
  function gl(i) {
    if (i === null) return null;
    do
      i = i.return;
    while (i && i.tag !== 5);
    return i || null;
  }
  function wC(i, a, d, p, C) {
    for (var b = a._reactName, R = []; d !== null && d !== p; ) {
      var O = d, N = O.alternate, Y = O.stateNode;
      if (N !== null && N === p) break;
      O.tag === 5 && Y !== null && (O = Y, C ? (N = Lu(d, b), N != null && R.unshift(kd(d, N, O))) : C || (N = Lu(d, b), N != null && R.push(kd(d, N, O)))), d = d.return;
    }
    R.length !== 0 && i.push({ event: a, listeners: R });
  }
  var TC = /\r\n?/g, jw = /\u0000|\uFFFD/g;
  function EC(i) {
    return (typeof i == "string" ? i : "" + i).replace(TC, `
`).replace(jw, "");
  }
  function Mv(i, a, d) {
    if (a = EC(a), EC(i) !== a && d) throw Error(t(425));
  }
  function Cl() {
  }
  var Uh = null, Iu = null;
  function Av(i, a) {
    return i === "textarea" || i === "noscript" || typeof a.children == "string" || typeof a.children == "number" || typeof a.dangerouslySetInnerHTML == "object" && a.dangerouslySetInnerHTML !== null && a.dangerouslySetInnerHTML.__html != null;
  }
  var Pv = typeof setTimeout == "function" ? setTimeout : void 0, T3 = typeof clearTimeout == "function" ? clearTimeout : void 0, kC = typeof Promise == "function" ? Promise : void 0, xd = typeof queueMicrotask == "function" ? queueMicrotask : typeof kC < "u" ? function(i) {
    return kC.resolve(null).then(i).catch(Ov);
  } : Pv;
  function Ov(i) {
    setTimeout(function() {
      throw i;
    });
  }
  function Rd(i, a) {
    var d = a, p = 0;
    do {
      var C = d.nextSibling;
      if (i.removeChild(d), C && C.nodeType === 8) if (d = C.data, d === "/$") {
        if (p === 0) {
          i.removeChild(C), vl(a);
          return;
        }
        p--;
      } else d !== "$" && d !== "$?" && d !== "$!" || p++;
      d = C;
    } while (d);
    vl(a);
  }
  function Hs(i) {
    for (; i != null; i = i.nextSibling) {
      var a = i.nodeType;
      if (a === 1 || a === 3) break;
      if (a === 8) {
        if (a = i.data, a === "$" || a === "$!" || a === "$?") break;
        if (a === "/$") return null;
      }
    }
    return i;
  }
  function xC(i) {
    i = i.previousSibling;
    for (var a = 0; i; ) {
      if (i.nodeType === 8) {
        var d = i.data;
        if (d === "$" || d === "$!" || d === "$?") {
          if (a === 0) return i;
          a--;
        } else d === "/$" && a++;
      }
      i = i.previousSibling;
    }
    return null;
  }
  var Sl = Math.random().toString(36).slice(2), Fs = "__reactFiber$" + Sl, zh = "__reactProps$" + Sl, To = "__reactContainer$" + Sl, Hh = "__reactEvents$" + Sl, Ld = "__reactListeners$" + Sl, Gw = "__reactHandles$" + Sl;
  function Bu(i) {
    var a = i[Fs];
    if (a) return a;
    for (var d = i.parentNode; d; ) {
      if (a = d[To] || d[Fs]) {
        if (d = a.alternate, a.child !== null || d !== null && d.child !== null) for (i = xC(i); i !== null; ) {
          if (d = i[Fs]) return d;
          i = xC(i);
        }
        return a;
      }
      i = d, d = i.parentNode;
    }
    return null;
  }
  function Fe(i) {
    return i = i[Fs] || i[To], !i || i.tag !== 5 && i.tag !== 6 && i.tag !== 13 && i.tag !== 3 ? null : i;
  }
  function ps(i) {
    if (i.tag === 5 || i.tag === 6) return i.stateNode;
    throw Error(t(33));
  }
  function Kn(i) {
    return i[zh] || null;
  }
  var _t = [], Ha = -1;
  function ms(i) {
    return { current: i };
  }
  function xn(i) {
    0 > Ha || (i.current = _t[Ha], _t[Ha] = null, Ha--);
  }
  function He(i, a) {
    Ha++, _t[Ha] = i.current, i.current = a;
  }
  var Qr = {}, Qn = ms(Qr), Ti = ms(!1), Yr = Qr;
  function Fa(i, a) {
    var d = i.type.contextTypes;
    if (!d) return Qr;
    var p = i.stateNode;
    if (p && p.__reactInternalMemoizedUnmaskedChildContext === a) return p.__reactInternalMemoizedMaskedChildContext;
    var C = {}, b;
    for (b in d) C[b] = a[b];
    return p && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = a, i.__reactInternalMemoizedMaskedChildContext = C), C;
  }
  function li(i) {
    return i = i.childContextTypes, i != null;
  }
  function $d() {
    xn(Ti), xn(Qn);
  }
  function RC(i, a, d) {
    if (Qn.current !== Qr) throw Error(t(168));
    He(Qn, a), He(Ti, d);
  }
  function Fh(i, a, d) {
    var p = i.stateNode;
    if (a = a.childContextTypes, typeof p.getChildContext != "function") return d;
    p = p.getChildContext();
    for (var C in p) if (!(C in a)) throw Error(t(108, Si(i) || "Unknown", C));
    return me({}, d, p);
  }
  function Wr(i) {
    return i = (i = i.stateNode) && i.__reactInternalMemoizedMergedChildContext || Qr, Yr = Qn.current, He(Qn, i), He(Ti, Ti.current), !0;
  }
  function _v(i, a, d) {
    var p = i.stateNode;
    if (!p) throw Error(t(169));
    d ? (i = Fh(i, a, Yr), p.__reactInternalMemoizedMergedChildContext = i, xn(Ti), xn(Qn), He(Qn, i)) : xn(Ti), He(Ti, d);
  }
  var Is = null, Dd = !1, Eo = !1;
  function Nv(i) {
    Is === null ? Is = [i] : Is.push(i);
  }
  function bl(i) {
    Dd = !0, Nv(i);
  }
  function Bs() {
    if (!Eo && Is !== null) {
      Eo = !0;
      var i = 0, a = dn;
      try {
        var d = Is;
        for (dn = 1; i < d.length; i++) {
          var p = d[i];
          do
            p = p(!0);
          while (p !== null);
        }
        Is = null, Dd = !1;
      } catch (C) {
        throw Is !== null && (Is = Is.slice(i + 1)), q0(Du, Bs), C;
      } finally {
        dn = a, Eo = !1;
      }
    }
    return null;
  }
  var wl = [], Tl = 0, El = null, ko = 0, ui = [], Ia = 0, pa = null, qs = 1, js = "";
  function qu(i, a) {
    wl[Tl++] = ko, wl[Tl++] = El, El = i, ko = a;
  }
  function LC(i, a, d) {
    ui[Ia++] = qs, ui[Ia++] = js, ui[Ia++] = pa, pa = i;
    var p = qs;
    i = js;
    var C = 32 - Na(p) - 1;
    p &= ~(1 << C), d += 1;
    var b = 32 - Na(a) + C;
    if (30 < b) {
      var R = C - C % 5;
      b = (p & (1 << R) - 1).toString(32), p >>= R, C -= R, qs = 1 << 32 - Na(a) + C | d << C | p, js = b + i;
    } else qs = 1 << b | d << C | p, js = i;
  }
  function Vv(i) {
    i.return !== null && (qu(i, 1), LC(i, 1, 0));
  }
  function Uv(i) {
    for (; i === El; ) El = wl[--Tl], wl[Tl] = null, ko = wl[--Tl], wl[Tl] = null;
    for (; i === pa; ) pa = ui[--Ia], ui[Ia] = null, js = ui[--Ia], ui[Ia] = null, qs = ui[--Ia], ui[Ia] = null;
  }
  var Kr = null, Zr = null, Nn = !1, Ba = null;
  function E3(i, a) {
    var d = Ya(5, null, null, 0);
    d.elementType = "DELETED", d.stateNode = a, d.return = i, a = i.deletions, a === null ? (i.deletions = [d], i.flags |= 16) : a.push(d);
  }
  function $C(i, a) {
    switch (i.tag) {
      case 5:
        var d = i.type;
        return a = a.nodeType !== 1 || d.toLowerCase() !== a.nodeName.toLowerCase() ? null : a, a !== null ? (i.stateNode = a, Kr = i, Zr = Hs(a.firstChild), !0) : !1;
      case 6:
        return a = i.pendingProps === "" || a.nodeType !== 3 ? null : a, a !== null ? (i.stateNode = a, Kr = i, Zr = null, !0) : !1;
      case 13:
        return a = a.nodeType !== 8 ? null : a, a !== null ? (d = pa !== null ? { id: qs, overflow: js } : null, i.memoizedState = { dehydrated: a, treeContext: d, retryLane: 1073741824 }, d = Ya(18, null, null, 0), d.stateNode = a, d.return = i, i.child = d, Kr = i, Zr = null, !0) : !1;
      default:
        return !1;
    }
  }
  function k3(i) {
    return (i.mode & 1) !== 0 && (i.flags & 128) === 0;
  }
  function x3(i) {
    if (Nn) {
      var a = Zr;
      if (a) {
        var d = a;
        if (!$C(i, a)) {
          if (k3(i)) throw Error(t(418));
          a = Hs(d.nextSibling);
          var p = Kr;
          a && $C(i, a) ? E3(p, d) : (i.flags = i.flags & -4097 | 2, Nn = !1, Kr = i);
        }
      } else {
        if (k3(i)) throw Error(t(418));
        i.flags = i.flags & -4097 | 2, Nn = !1, Kr = i;
      }
    }
  }
  function Ei(i) {
    for (i = i.return; i !== null && i.tag !== 5 && i.tag !== 3 && i.tag !== 13; ) i = i.return;
    Kr = i;
  }
  function zv(i) {
    if (i !== Kr) return !1;
    if (!Nn) return Ei(i), Nn = !0, !1;
    var a;
    if ((a = i.tag !== 3) && !(a = i.tag !== 5) && (a = i.type, a = a !== "head" && a !== "body" && !Av(i.type, i.memoizedProps)), a && (a = Zr)) {
      if (k3(i)) throw Ih(), Error(t(418));
      for (; a; ) E3(i, a), a = Hs(a.nextSibling);
    }
    if (Ei(i), i.tag === 13) {
      if (i = i.memoizedState, i = i !== null ? i.dehydrated : null, !i) throw Error(t(317));
      e: {
        for (i = i.nextSibling, a = 0; i; ) {
          if (i.nodeType === 8) {
            var d = i.data;
            if (d === "/$") {
              if (a === 0) {
                Zr = Hs(i.nextSibling);
                break e;
              }
              a--;
            } else d !== "$" && d !== "$!" && d !== "$?" || a++;
          }
          i = i.nextSibling;
        }
        Zr = null;
      }
    } else Zr = Kr ? Hs(i.stateNode.nextSibling) : null;
    return !0;
  }
  function Ih() {
    for (var i = Zr; i; ) i = Hs(i.nextSibling);
  }
  function kl() {
    Zr = Kr = null, Nn = !1;
  }
  function xo(i) {
    Ba === null ? Ba = [i] : Ba.push(i);
  }
  var Qw = je.ReactCurrentBatchConfig;
  function ju(i, a, d) {
    if (i = d.ref, i !== null && typeof i != "function" && typeof i != "object") {
      if (d._owner) {
        if (d = d._owner, d) {
          if (d.tag !== 1) throw Error(t(309));
          var p = d.stateNode;
        }
        if (!p) throw Error(t(147, i));
        var C = p, b = "" + i;
        return a !== null && a.ref !== null && typeof a.ref == "function" && a.ref._stringRef === b ? a.ref : (a = function(R) {
          var O = C.refs;
          R === null ? delete O[b] : O[b] = R;
        }, a._stringRef = b, a);
      }
      if (typeof i != "string") throw Error(t(284));
      if (!d._owner) throw Error(t(290, i));
    }
    return i;
  }
  function Hv(i, a) {
    throw i = Object.prototype.toString.call(a), Error(t(31, i === "[object Object]" ? "object with keys {" + Object.keys(a).join(", ") + "}" : i));
  }
  function DC(i) {
    var a = i._init;
    return a(i._payload);
  }
  function Gu(i) {
    function a(B, z) {
      if (i) {
        var G = B.deletions;
        G === null ? (B.deletions = [z], B.flags |= 16) : G.push(z);
      }
    }
    function d(B, z) {
      if (!i) return null;
      for (; z !== null; ) a(B, z), z = z.sibling;
      return null;
    }
    function p(B, z) {
      for (B = /* @__PURE__ */ new Map(); z !== null; ) z.key !== null ? B.set(z.key, z) : B.set(z.index, z), z = z.sibling;
      return B;
    }
    function C(B, z) {
      return B = Pl(B, z), B.index = 0, B.sibling = null, B;
    }
    function b(B, z, G) {
      return B.index = G, i ? (G = B.alternate, G !== null ? (G = G.index, G < z ? (B.flags |= 2, z) : G) : (B.flags |= 2, z)) : (B.flags |= 1048576, z);
    }
    function R(B) {
      return i && B.alternate === null && (B.flags |= 2), B;
    }
    function O(B, z, G, de) {
      return z === null || z.tag !== 6 ? (z = i6(G, B.mode, de), z.return = B, z) : (z = C(z, G), z.return = B, z);
    }
    function N(B, z, G, de) {
      var be = G.type;
      return be === Ge ? ae(B, z, G.props.children, de, G.key) : z !== null && (z.elementType === be || typeof be == "object" && be !== null && be.$$typeof === Ye && DC(be) === z.type) ? (de = C(z, G.props), de.ref = ju(B, z, G), de.return = B, de) : (de = gp(G.type, G.key, G.props, null, B.mode, de), de.ref = ju(B, z, G), de.return = B, de);
    }
    function Y(B, z, G, de) {
      return z === null || z.tag !== 4 || z.stateNode.containerInfo !== G.containerInfo || z.stateNode.implementation !== G.implementation ? (z = Cy(G, B.mode, de), z.return = B, z) : (z = C(z, G.children || []), z.return = B, z);
    }
    function ae(B, z, G, de, be) {
      return z === null || z.tag !== 7 ? (z = Ao(G, B.mode, de, be), z.return = B, z) : (z = C(z, G), z.return = B, z);
    }
    function oe(B, z, G) {
      if (typeof z == "string" && z !== "" || typeof z == "number") return z = i6("" + z, B.mode, G), z.return = B, z;
      if (typeof z == "object" && z !== null) {
        switch (z.$$typeof) {
          case Me:
            return G = gp(z.type, z.key, z.props, null, B.mode, G), G.ref = ju(B, null, z), G.return = B, G;
          case Ct:
            return z = Cy(z, B.mode, G), z.return = B, z;
          case Ye:
            var de = z._init;
            return oe(B, de(z._payload), G);
        }
        if (ku(z) || Le(z)) return z = Ao(z, B.mode, G, null), z.return = B, z;
        Hv(B, z);
      }
      return null;
    }
    function re(B, z, G, de) {
      var be = z !== null ? z.key : null;
      if (typeof G == "string" && G !== "" || typeof G == "number") return be !== null ? null : O(B, z, "" + G, de);
      if (typeof G == "object" && G !== null) {
        switch (G.$$typeof) {
          case Me:
            return G.key === be ? N(B, z, G, de) : null;
          case Ct:
            return G.key === be ? Y(B, z, G, de) : null;
          case Ye:
            return be = G._init, re(
              B,
              z,
              be(G._payload),
              de
            );
        }
        if (ku(G) || Le(G)) return be !== null ? null : ae(B, z, G, de, null);
        Hv(B, G);
      }
      return null;
    }
    function Te(B, z, G, de, be) {
      if (typeof de == "string" && de !== "" || typeof de == "number") return B = B.get(G) || null, O(z, B, "" + de, be);
      if (typeof de == "object" && de !== null) {
        switch (de.$$typeof) {
          case Me:
            return B = B.get(de.key === null ? G : de.key) || null, N(z, B, de, be);
          case Ct:
            return B = B.get(de.key === null ? G : de.key) || null, Y(z, B, de, be);
          case Ye:
            var Be = de._init;
            return Te(B, z, G, Be(de._payload), be);
        }
        if (ku(de) || Le(de)) return B = B.get(G) || null, ae(z, B, de, be, null);
        Hv(z, de);
      }
      return null;
    }
    function Ae(B, z, G, de) {
      for (var be = null, Be = null, Ke = z, ot = z = 0, xi = null; Ke !== null && ot < G.length; ot++) {
        Ke.index > ot ? (xi = Ke, Ke = null) : xi = Ke.sibling;
        var Kt = re(B, Ke, G[ot], de);
        if (Kt === null) {
          Ke === null && (Ke = xi);
          break;
        }
        i && Ke && Kt.alternate === null && a(B, Ke), z = b(Kt, z, ot), Be === null ? be = Kt : Be.sibling = Kt, Be = Kt, Ke = xi;
      }
      if (ot === G.length) return d(B, Ke), Nn && qu(B, ot), be;
      if (Ke === null) {
        for (; ot < G.length; ot++) Ke = oe(B, G[ot], de), Ke !== null && (z = b(Ke, z, ot), Be === null ? be = Ke : Be.sibling = Ke, Be = Ke);
        return Nn && qu(B, ot), be;
      }
      for (Ke = p(B, Ke); ot < G.length; ot++) xi = Te(Ke, B, ot, G[ot], de), xi !== null && (i && xi.alternate !== null && Ke.delete(xi.key === null ? ot : xi.key), z = b(xi, z, ot), Be === null ? be = xi : Be.sibling = xi, Be = xi);
      return i && Ke.forEach(function(Nl) {
        return a(B, Nl);
      }), Nn && qu(B, ot), be;
    }
    function _e(B, z, G, de) {
      var be = Le(G);
      if (typeof be != "function") throw Error(t(150));
      if (G = be.call(G), G == null) throw Error(t(151));
      for (var Be = be = null, Ke = z, ot = z = 0, xi = null, Kt = G.next(); Ke !== null && !Kt.done; ot++, Kt = G.next()) {
        Ke.index > ot ? (xi = Ke, Ke = null) : xi = Ke.sibling;
        var Nl = re(B, Ke, Kt.value, de);
        if (Nl === null) {
          Ke === null && (Ke = xi);
          break;
        }
        i && Ke && Nl.alternate === null && a(B, Ke), z = b(Nl, z, ot), Be === null ? be = Nl : Be.sibling = Nl, Be = Nl, Ke = xi;
      }
      if (Kt.done) return d(
        B,
        Ke
      ), Nn && qu(B, ot), be;
      if (Ke === null) {
        for (; !Kt.done; ot++, Kt = G.next()) Kt = oe(B, Kt.value, de), Kt !== null && (z = b(Kt, z, ot), Be === null ? be = Kt : Be.sibling = Kt, Be = Kt);
        return Nn && qu(B, ot), be;
      }
      for (Ke = p(B, Ke); !Kt.done; ot++, Kt = G.next()) Kt = Te(Ke, B, ot, Kt.value, de), Kt !== null && (i && Kt.alternate !== null && Ke.delete(Kt.key === null ? ot : Kt.key), z = b(Kt, z, ot), Be === null ? be = Kt : Be.sibling = Kt, Be = Kt);
      return i && Ke.forEach(function(oT) {
        return a(B, oT);
      }), Nn && qu(B, ot), be;
    }
    function ti(B, z, G, de) {
      if (typeof G == "object" && G !== null && G.type === Ge && G.key === null && (G = G.props.children), typeof G == "object" && G !== null) {
        switch (G.$$typeof) {
          case Me:
            e: {
              for (var be = G.key, Be = z; Be !== null; ) {
                if (Be.key === be) {
                  if (be = G.type, be === Ge) {
                    if (Be.tag === 7) {
                      d(B, Be.sibling), z = C(Be, G.props.children), z.return = B, B = z;
                      break e;
                    }
                  } else if (Be.elementType === be || typeof be == "object" && be !== null && be.$$typeof === Ye && DC(be) === Be.type) {
                    d(B, Be.sibling), z = C(Be, G.props), z.ref = ju(B, Be, G), z.return = B, B = z;
                    break e;
                  }
                  d(B, Be);
                  break;
                } else a(B, Be);
                Be = Be.sibling;
              }
              G.type === Ge ? (z = Ao(G.props.children, B.mode, de, G.key), z.return = B, B = z) : (de = gp(G.type, G.key, G.props, null, B.mode, de), de.ref = ju(B, z, G), de.return = B, B = de);
            }
            return R(B);
          case Ct:
            e: {
              for (Be = G.key; z !== null; ) {
                if (z.key === Be) if (z.tag === 4 && z.stateNode.containerInfo === G.containerInfo && z.stateNode.implementation === G.implementation) {
                  d(B, z.sibling), z = C(z, G.children || []), z.return = B, B = z;
                  break e;
                } else {
                  d(B, z);
                  break;
                }
                else a(B, z);
                z = z.sibling;
              }
              z = Cy(G, B.mode, de), z.return = B, B = z;
            }
            return R(B);
          case Ye:
            return Be = G._init, ti(B, z, Be(G._payload), de);
        }
        if (ku(G)) return Ae(B, z, G, de);
        if (Le(G)) return _e(B, z, G, de);
        Hv(B, G);
      }
      return typeof G == "string" && G !== "" || typeof G == "number" ? (G = "" + G, z !== null && z.tag === 6 ? (d(B, z.sibling), z = C(z, G), z.return = B, B = z) : (d(B, z), z = i6(G, B.mode, de), z.return = B, B = z), R(B)) : d(B, z);
    }
    return ti;
  }
  var Zn = Gu(!0), ge = Gu(!1), ma = ms(null), Xr = null, Md = null, R3 = null;
  function L3() {
    R3 = Md = Xr = null;
  }
  function $3(i) {
    var a = ma.current;
    xn(ma), i._currentValue = a;
  }
  function D3(i, a, d) {
    for (; i !== null; ) {
      var p = i.alternate;
      if ((i.childLanes & a) !== a ? (i.childLanes |= a, p !== null && (p.childLanes |= a)) : p !== null && (p.childLanes & a) !== a && (p.childLanes |= a), i === d) break;
      i = i.return;
    }
  }
  function Un(i, a) {
    Xr = i, R3 = Md = null, i = i.dependencies, i !== null && i.firstContext !== null && (i.lanes & a && (di = !0), i.firstContext = null);
  }
  function qa(i) {
    var a = i._currentValue;
    if (R3 !== i) if (i = { context: i, memoizedValue: a, next: null }, Md === null) {
      if (Xr === null) throw Error(t(308));
      Md = i, Xr.dependencies = { lanes: 0, firstContext: i };
    } else Md = Md.next = i;
    return a;
  }
  var Qu = null;
  function M3(i) {
    Qu === null ? Qu = [i] : Qu.push(i);
  }
  function A3(i, a, d, p) {
    var C = a.interleaved;
    return C === null ? (d.next = d, M3(a)) : (d.next = C.next, C.next = d), a.interleaved = d, va(i, p);
  }
  function va(i, a) {
    i.lanes |= a;
    var d = i.alternate;
    for (d !== null && (d.lanes |= a), d = i, i = i.return; i !== null; ) i.childLanes |= a, d = i.alternate, d !== null && (d.childLanes |= a), d = i, i = i.return;
    return d.tag === 3 ? d.stateNode : null;
  }
  var ya = !1;
  function P3(i) {
    i.updateQueue = { baseState: i.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function MC(i, a) {
    i = i.updateQueue, a.updateQueue === i && (a.updateQueue = { baseState: i.baseState, firstBaseUpdate: i.firstBaseUpdate, lastBaseUpdate: i.lastBaseUpdate, shared: i.shared, effects: i.effects });
  }
  function Ro(i, a) {
    return { eventTime: i, lane: a, tag: 0, payload: null, callback: null, next: null };
  }
  function xl(i, a, d) {
    var p = i.updateQueue;
    if (p === null) return null;
    if (p = p.shared, Nt & 2) {
      var C = p.pending;
      return C === null ? a.next = a : (a.next = C.next, C.next = a), p.pending = a, va(i, d);
    }
    return C = p.interleaved, C === null ? (a.next = a, M3(p)) : (a.next = C.next, C.next = a), p.interleaved = a, va(i, d);
  }
  function Fv(i, a, d) {
    if (a = a.updateQueue, a !== null && (a = a.shared, (d & 4194240) !== 0)) {
      var p = a.lanes;
      p &= i.pendingLanes, d |= p, a.lanes = d, cv(i, d);
    }
  }
  function AC(i, a) {
    var d = i.updateQueue, p = i.alternate;
    if (p !== null && (p = p.updateQueue, d === p)) {
      var C = null, b = null;
      if (d = d.firstBaseUpdate, d !== null) {
        do {
          var R = { eventTime: d.eventTime, lane: d.lane, tag: d.tag, payload: d.payload, callback: d.callback, next: null };
          b === null ? C = b = R : b = b.next = R, d = d.next;
        } while (d !== null);
        b === null ? C = b = a : b = b.next = a;
      } else C = b = a;
      d = { baseState: p.baseState, firstBaseUpdate: C, lastBaseUpdate: b, shared: p.shared, effects: p.effects }, i.updateQueue = d;
      return;
    }
    i = d.lastBaseUpdate, i === null ? d.firstBaseUpdate = a : i.next = a, d.lastBaseUpdate = a;
  }
  function Bh(i, a, d, p) {
    var C = i.updateQueue;
    ya = !1;
    var b = C.firstBaseUpdate, R = C.lastBaseUpdate, O = C.shared.pending;
    if (O !== null) {
      C.shared.pending = null;
      var N = O, Y = N.next;
      N.next = null, R === null ? b = Y : R.next = Y, R = N;
      var ae = i.alternate;
      ae !== null && (ae = ae.updateQueue, O = ae.lastBaseUpdate, O !== R && (O === null ? ae.firstBaseUpdate = Y : O.next = Y, ae.lastBaseUpdate = N));
    }
    if (b !== null) {
      var oe = C.baseState;
      R = 0, ae = Y = N = null, O = b;
      do {
        var re = O.lane, Te = O.eventTime;
        if ((p & re) === re) {
          ae !== null && (ae = ae.next = {
            eventTime: Te,
            lane: 0,
            tag: O.tag,
            payload: O.payload,
            callback: O.callback,
            next: null
          });
          e: {
            var Ae = i, _e = O;
            switch (re = a, Te = d, _e.tag) {
              case 1:
                if (Ae = _e.payload, typeof Ae == "function") {
                  oe = Ae.call(Te, oe, re);
                  break e;
                }
                oe = Ae;
                break e;
              case 3:
                Ae.flags = Ae.flags & -65537 | 128;
              case 0:
                if (Ae = _e.payload, re = typeof Ae == "function" ? Ae.call(Te, oe, re) : Ae, re == null) break e;
                oe = me({}, oe, re);
                break e;
              case 2:
                ya = !0;
            }
          }
          O.callback !== null && O.lane !== 0 && (i.flags |= 64, re = C.effects, re === null ? C.effects = [O] : re.push(O));
        } else Te = { eventTime: Te, lane: re, tag: O.tag, payload: O.payload, callback: O.callback, next: null }, ae === null ? (Y = ae = Te, N = oe) : ae = ae.next = Te, R |= re;
        if (O = O.next, O === null) {
          if (O = C.shared.pending, O === null) break;
          re = O, O = re.next, re.next = null, C.lastBaseUpdate = re, C.shared.pending = null;
        }
      } while (!0);
      if (ae === null && (N = oe), C.baseState = N, C.firstBaseUpdate = Y, C.lastBaseUpdate = ae, a = C.shared.interleaved, a !== null) {
        C = a;
        do
          R |= C.lane, C = C.next;
        while (C !== a);
      } else b === null && (C.shared.lanes = 0);
      Ks |= R, i.lanes = R, i.memoizedState = oe;
    }
  }
  function O3(i, a, d) {
    if (i = a.effects, a.effects = null, i !== null) for (a = 0; a < i.length; a++) {
      var p = i[a], C = p.callback;
      if (C !== null) {
        if (p.callback = null, p = d, typeof C != "function") throw Error(t(191, C));
        C.call(p);
      }
    }
  }
  var qh = {}, Gs = ms(qh), jh = ms(qh), Gh = ms(qh);
  function Yu(i) {
    if (i === qh) throw Error(t(174));
    return i;
  }
  function _3(i, a) {
    switch (He(Gh, a), He(jh, i), He(Gs, qh), i = a.nodeType, i) {
      case 9:
      case 11:
        a = (a = a.documentElement) ? a.namespaceURI : xu(null, "");
        break;
      default:
        i = i === 8 ? a.parentNode : a, a = i.namespaceURI || null, i = i.tagName, a = xu(a, i);
    }
    xn(Gs), He(Gs, a);
  }
  function Wu() {
    xn(Gs), xn(jh), xn(Gh);
  }
  function PC(i) {
    Yu(Gh.current);
    var a = Yu(Gs.current), d = xu(a, i.type);
    a !== d && (He(jh, i), He(Gs, d));
  }
  function Iv(i) {
    jh.current === i && (xn(Gs), xn(jh));
  }
  var zn = ms(0);
  function Bv(i) {
    for (var a = i; a !== null; ) {
      if (a.tag === 13) {
        var d = a.memoizedState;
        if (d !== null && (d = d.dehydrated, d === null || d.data === "$?" || d.data === "$!")) return a;
      } else if (a.tag === 19 && a.memoizedProps.revealOrder !== void 0) {
        if (a.flags & 128) return a;
      } else if (a.child !== null) {
        a.child.return = a, a = a.child;
        continue;
      }
      if (a === i) break;
      for (; a.sibling === null; ) {
        if (a.return === null || a.return === i) return null;
        a = a.return;
      }
      a.sibling.return = a.return, a = a.sibling;
    }
    return null;
  }
  var Qh = [];
  function Ie() {
    for (var i = 0; i < Qh.length; i++) Qh[i]._workInProgressVersionPrimary = null;
    Qh.length = 0;
  }
  var Tt = je.ReactCurrentDispatcher, Yt = je.ReactCurrentBatchConfig, mn = 0, Wt = null, ci = null, Oi = null, qv = !1, Yh = !1, Ku = 0, ie = 0;
  function Ft() {
    throw Error(t(321));
  }
  function tt(i, a) {
    if (a === null) return !1;
    for (var d = 0; d < a.length && d < i.length; d++) if (!hs(i[d], a[d])) return !1;
    return !0;
  }
  function Rl(i, a, d, p, C, b) {
    if (mn = b, Wt = a, a.memoizedState = null, a.updateQueue = null, a.lanes = 0, Tt.current = i === null || i.memoizedState === null ? ay : ep, i = d(p, C), Yh) {
      b = 0;
      do {
        if (Yh = !1, Ku = 0, 25 <= b) throw Error(t(301));
        b += 1, Oi = ci = null, a.updateQueue = null, Tt.current = sy, i = d(p, C);
      } while (Yh);
    }
    if (Tt.current = tc, a = ci !== null && ci.next !== null, mn = 0, Oi = ci = Wt = null, qv = !1, a) throw Error(t(300));
    return i;
  }
  function vs() {
    var i = Ku !== 0;
    return Ku = 0, i;
  }
  function dr() {
    var i = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return Oi === null ? Wt.memoizedState = Oi = i : Oi = Oi.next = i, Oi;
  }
  function Xn() {
    if (ci === null) {
      var i = Wt.alternate;
      i = i !== null ? i.memoizedState : null;
    } else i = ci.next;
    var a = Oi === null ? Wt.memoizedState : Oi.next;
    if (a !== null) Oi = a, ci = i;
    else {
      if (i === null) throw Error(t(310));
      ci = i, i = { memoizedState: ci.memoizedState, baseState: ci.baseState, baseQueue: ci.baseQueue, queue: ci.queue, next: null }, Oi === null ? Wt.memoizedState = Oi = i : Oi = Oi.next = i;
    }
    return Oi;
  }
  function Lo(i, a) {
    return typeof a == "function" ? a(i) : a;
  }
  function Ll(i) {
    var a = Xn(), d = a.queue;
    if (d === null) throw Error(t(311));
    d.lastRenderedReducer = i;
    var p = ci, C = p.baseQueue, b = d.pending;
    if (b !== null) {
      if (C !== null) {
        var R = C.next;
        C.next = b.next, b.next = R;
      }
      p.baseQueue = C = b, d.pending = null;
    }
    if (C !== null) {
      b = C.next, p = p.baseState;
      var O = R = null, N = null, Y = b;
      do {
        var ae = Y.lane;
        if ((mn & ae) === ae) N !== null && (N = N.next = { lane: 0, action: Y.action, hasEagerState: Y.hasEagerState, eagerState: Y.eagerState, next: null }), p = Y.hasEagerState ? Y.eagerState : i(p, Y.action);
        else {
          var oe = {
            lane: ae,
            action: Y.action,
            hasEagerState: Y.hasEagerState,
            eagerState: Y.eagerState,
            next: null
          };
          N === null ? (O = N = oe, R = p) : N = N.next = oe, Wt.lanes |= ae, Ks |= ae;
        }
        Y = Y.next;
      } while (Y !== null && Y !== b);
      N === null ? R = p : N.next = O, hs(p, a.memoizedState) || (di = !0), a.memoizedState = p, a.baseState = R, a.baseQueue = N, d.lastRenderedState = p;
    }
    if (i = d.interleaved, i !== null) {
      C = i;
      do
        b = C.lane, Wt.lanes |= b, Ks |= b, C = C.next;
      while (C !== i);
    } else C === null && (d.lanes = 0);
    return [a.memoizedState, d.dispatch];
  }
  function Zu(i) {
    var a = Xn(), d = a.queue;
    if (d === null) throw Error(t(311));
    d.lastRenderedReducer = i;
    var p = d.dispatch, C = d.pending, b = a.memoizedState;
    if (C !== null) {
      d.pending = null;
      var R = C = C.next;
      do
        b = i(b, R.action), R = R.next;
      while (R !== C);
      hs(b, a.memoizedState) || (di = !0), a.memoizedState = b, a.baseQueue === null && (a.baseState = b), d.lastRenderedState = b;
    }
    return [b, p];
  }
  function jv() {
  }
  function Gv(i, a) {
    var d = Wt, p = Xn(), C = a(), b = !hs(p.memoizedState, C);
    if (b && (p.memoizedState = C, di = !0), p = p.queue, Wh(Wv.bind(null, d, p, i), [i]), p.getSnapshot !== a || b || Oi !== null && Oi.memoizedState.tag & 1) {
      if (d.flags |= 2048, Xu(9, Yv.bind(null, d, p, C, a), void 0, null), ki === null) throw Error(t(349));
      mn & 30 || Qv(d, a, C);
    }
    return C;
  }
  function Qv(i, a, d) {
    i.flags |= 16384, i = { getSnapshot: a, value: d }, a = Wt.updateQueue, a === null ? (a = { lastEffect: null, stores: null }, Wt.updateQueue = a, a.stores = [i]) : (d = a.stores, d === null ? a.stores = [i] : d.push(i));
  }
  function Yv(i, a, d, p) {
    a.value = d, a.getSnapshot = p, Kv(a) && Zv(i);
  }
  function Wv(i, a, d) {
    return d(function() {
      Kv(a) && Zv(i);
    });
  }
  function Kv(i) {
    var a = i.getSnapshot;
    i = i.value;
    try {
      var d = a();
      return !hs(i, d);
    } catch {
      return !0;
    }
  }
  function Zv(i) {
    var a = va(i, 1);
    a !== null && kr(a, i, 1, -1);
  }
  function Xv(i) {
    var a = dr();
    return typeof i == "function" && (i = i()), a.memoizedState = a.baseState = i, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Lo, lastRenderedState: i }, a.queue = i, i = i.dispatch = ec.bind(null, Wt, i), [a.memoizedState, i];
  }
  function Xu(i, a, d, p) {
    return i = { tag: i, create: a, destroy: d, deps: p, next: null }, a = Wt.updateQueue, a === null ? (a = { lastEffect: null, stores: null }, Wt.updateQueue = a, a.lastEffect = i.next = i) : (d = a.lastEffect, d === null ? a.lastEffect = i.next = i : (p = d.next, d.next = i, i.next = p, a.lastEffect = i)), i;
  }
  function Jv() {
    return Xn().memoizedState;
  }
  function Ad(i, a, d, p) {
    var C = dr();
    Wt.flags |= i, C.memoizedState = Xu(1 | a, d, void 0, p === void 0 ? null : p);
  }
  function Pd(i, a, d, p) {
    var C = Xn();
    p = p === void 0 ? null : p;
    var b = void 0;
    if (ci !== null) {
      var R = ci.memoizedState;
      if (b = R.destroy, p !== null && tt(p, R.deps)) {
        C.memoizedState = Xu(a, d, b, p);
        return;
      }
    }
    Wt.flags |= i, C.memoizedState = Xu(1 | a, d, b, p);
  }
  function ey(i, a) {
    return Ad(8390656, 8, i, a);
  }
  function Wh(i, a) {
    return Pd(2048, 8, i, a);
  }
  function ty(i, a) {
    return Pd(4, 2, i, a);
  }
  function Kh(i, a) {
    return Pd(4, 4, i, a);
  }
  function Ju(i, a) {
    if (typeof a == "function") return i = i(), a(i), function() {
      a(null);
    };
    if (a != null) return i = i(), a.current = i, function() {
      a.current = null;
    };
  }
  function ny(i, a, d) {
    return d = d != null ? d.concat([i]) : null, Pd(4, 4, Ju.bind(null, a, i), d);
  }
  function Zh() {
  }
  function iy(i, a) {
    var d = Xn();
    a = a === void 0 ? null : a;
    var p = d.memoizedState;
    return p !== null && a !== null && tt(a, p[1]) ? p[0] : (d.memoizedState = [i, a], i);
  }
  function ry(i, a) {
    var d = Xn();
    a = a === void 0 ? null : a;
    var p = d.memoizedState;
    return p !== null && a !== null && tt(a, p[1]) ? p[0] : (i = i(), d.memoizedState = [i, a], i);
  }
  function N3(i, a, d) {
    return mn & 21 ? (hs(d, a) || (d = uv(), Wt.lanes |= d, Ks |= d, i.baseState = !0), a) : (i.baseState && (i.baseState = !1, di = !0), i.memoizedState = d);
  }
  function Xh(i, a) {
    var d = dn;
    dn = d !== 0 && 4 > d ? d : 4, i(!0);
    var p = Yt.transition;
    Yt.transition = {};
    try {
      i(!1), a();
    } finally {
      dn = d, Yt.transition = p;
    }
  }
  function V3() {
    return Xn().memoizedState;
  }
  function Jh(i, a, d) {
    var p = Zs(i);
    if (d = { lane: p, action: d, hasEagerState: !1, eagerState: null, next: null }, ga(i)) OC(a, d);
    else if (d = A3(i, a, d, p), d !== null) {
      var C = pi();
      kr(d, i, p, C), kn(d, a, p);
    }
  }
  function ec(i, a, d) {
    var p = Zs(i), C = { lane: p, action: d, hasEagerState: !1, eagerState: null, next: null };
    if (ga(i)) OC(a, C);
    else {
      var b = i.alternate;
      if (i.lanes === 0 && (b === null || b.lanes === 0) && (b = a.lastRenderedReducer, b !== null)) try {
        var R = a.lastRenderedState, O = b(R, d);
        if (C.hasEagerState = !0, C.eagerState = O, hs(O, R)) {
          var N = a.interleaved;
          N === null ? (C.next = C, M3(a)) : (C.next = N.next, N.next = C), a.interleaved = C;
          return;
        }
      } catch {
      } finally {
      }
      d = A3(i, a, C, p), d !== null && (C = pi(), kr(d, i, p, C), kn(d, a, p));
    }
  }
  function ga(i) {
    var a = i.alternate;
    return i === Wt || a !== null && a === Wt;
  }
  function OC(i, a) {
    Yh = qv = !0;
    var d = i.pending;
    d === null ? a.next = a : (a.next = d.next, d.next = a), i.pending = a;
  }
  function kn(i, a, d) {
    if (d & 4194240) {
      var p = a.lanes;
      p &= i.pendingLanes, d |= p, a.lanes = d, cv(i, d);
    }
  }
  var tc = { readContext: qa, useCallback: Ft, useContext: Ft, useEffect: Ft, useImperativeHandle: Ft, useInsertionEffect: Ft, useLayoutEffect: Ft, useMemo: Ft, useReducer: Ft, useRef: Ft, useState: Ft, useDebugValue: Ft, useDeferredValue: Ft, useTransition: Ft, useMutableSource: Ft, useSyncExternalStore: Ft, useId: Ft, unstable_isNewReconciler: !1 }, ay = { readContext: qa, useCallback: function(i, a) {
    return dr().memoizedState = [i, a === void 0 ? null : a], i;
  }, useContext: qa, useEffect: ey, useImperativeHandle: function(i, a, d) {
    return d = d != null ? d.concat([i]) : null, Ad(
      4194308,
      4,
      Ju.bind(null, a, i),
      d
    );
  }, useLayoutEffect: function(i, a) {
    return Ad(4194308, 4, i, a);
  }, useInsertionEffect: function(i, a) {
    return Ad(4, 2, i, a);
  }, useMemo: function(i, a) {
    var d = dr();
    return a = a === void 0 ? null : a, i = i(), d.memoizedState = [i, a], i;
  }, useReducer: function(i, a, d) {
    var p = dr();
    return a = d !== void 0 ? d(a) : a, p.memoizedState = p.baseState = a, i = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: i, lastRenderedState: a }, p.queue = i, i = i.dispatch = Jh.bind(null, Wt, i), [p.memoizedState, i];
  }, useRef: function(i) {
    var a = dr();
    return i = { current: i }, a.memoizedState = i;
  }, useState: Xv, useDebugValue: Zh, useDeferredValue: function(i) {
    return dr().memoizedState = i;
  }, useTransition: function() {
    var i = Xv(!1), a = i[0];
    return i = Xh.bind(null, i[1]), dr().memoizedState = i, [a, i];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(i, a, d) {
    var p = Wt, C = dr();
    if (Nn) {
      if (d === void 0) throw Error(t(407));
      d = d();
    } else {
      if (d = a(), ki === null) throw Error(t(349));
      mn & 30 || Qv(p, a, d);
    }
    C.memoizedState = d;
    var b = { value: d, getSnapshot: a };
    return C.queue = b, ey(Wv.bind(
      null,
      p,
      b,
      i
    ), [i]), p.flags |= 2048, Xu(9, Yv.bind(null, p, b, d, a), void 0, null), d;
  }, useId: function() {
    var i = dr(), a = ki.identifierPrefix;
    if (Nn) {
      var d = js, p = qs;
      d = (p & ~(1 << 32 - Na(p) - 1)).toString(32) + d, a = ":" + a + "R" + d, d = Ku++, 0 < d && (a += "H" + d.toString(32)), a += ":";
    } else d = ie++, a = ":" + a + "r" + d.toString(32) + ":";
    return i.memoizedState = a;
  }, unstable_isNewReconciler: !1 }, ep = {
    readContext: qa,
    useCallback: iy,
    useContext: qa,
    useEffect: Wh,
    useImperativeHandle: ny,
    useInsertionEffect: ty,
    useLayoutEffect: Kh,
    useMemo: ry,
    useReducer: Ll,
    useRef: Jv,
    useState: function() {
      return Ll(Lo);
    },
    useDebugValue: Zh,
    useDeferredValue: function(i) {
      var a = Xn();
      return N3(a, ci.memoizedState, i);
    },
    useTransition: function() {
      var i = Ll(Lo)[0], a = Xn().memoizedState;
      return [i, a];
    },
    useMutableSource: jv,
    useSyncExternalStore: Gv,
    useId: V3,
    unstable_isNewReconciler: !1
  }, sy = { readContext: qa, useCallback: iy, useContext: qa, useEffect: Wh, useImperativeHandle: ny, useInsertionEffect: ty, useLayoutEffect: Kh, useMemo: ry, useReducer: Zu, useRef: Jv, useState: function() {
    return Zu(Lo);
  }, useDebugValue: Zh, useDeferredValue: function(i) {
    var a = Xn();
    return ci === null ? a.memoizedState = i : N3(a, ci.memoizedState, i);
  }, useTransition: function() {
    var i = Zu(Lo)[0], a = Xn().memoizedState;
    return [i, a];
  }, useMutableSource: jv, useSyncExternalStore: Gv, useId: V3, unstable_isNewReconciler: !1 };
  function ys(i, a) {
    if (i && i.defaultProps) {
      a = me({}, a), i = i.defaultProps;
      for (var d in i) a[d] === void 0 && (a[d] = i[d]);
      return a;
    }
    return a;
  }
  function U3(i, a, d, p) {
    a = i.memoizedState, d = d(p, a), d = d == null ? a : me({}, a, d), i.memoizedState = d, i.lanes === 0 && (i.updateQueue.baseState = d);
  }
  var oy = { isMounted: function(i) {
    return (i = i._reactInternals) ? cs(i) === i : !1;
  }, enqueueSetState: function(i, a, d) {
    i = i._reactInternals;
    var p = pi(), C = Zs(i), b = Ro(p, C);
    b.payload = a, d != null && (b.callback = d), a = xl(i, b, C), a !== null && (kr(a, i, C, p), Fv(a, i, C));
  }, enqueueReplaceState: function(i, a, d) {
    i = i._reactInternals;
    var p = pi(), C = Zs(i), b = Ro(p, C);
    b.tag = 1, b.payload = a, d != null && (b.callback = d), a = xl(i, b, C), a !== null && (kr(a, i, C, p), Fv(a, i, C));
  }, enqueueForceUpdate: function(i, a) {
    i = i._reactInternals;
    var d = pi(), p = Zs(i), C = Ro(d, p);
    C.tag = 2, a != null && (C.callback = a), a = xl(i, C, p), a !== null && (kr(a, i, p, d), Fv(a, i, p));
  } };
  function _C(i, a, d, p, C, b, R) {
    return i = i.stateNode, typeof i.shouldComponentUpdate == "function" ? i.shouldComponentUpdate(p, b, R) : a.prototype && a.prototype.isPureReactComponent ? !Ph(d, p) || !Ph(C, b) : !0;
  }
  function ly(i, a, d) {
    var p = !1, C = Qr, b = a.contextType;
    return typeof b == "object" && b !== null ? b = qa(b) : (C = li(a) ? Yr : Qn.current, p = a.contextTypes, b = (p = p != null) ? Fa(i, C) : Qr), a = new a(d, b), i.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = oy, i.stateNode = a, a._reactInternals = i, p && (i = i.stateNode, i.__reactInternalMemoizedUnmaskedChildContext = C, i.__reactInternalMemoizedMaskedChildContext = b), a;
  }
  function NC(i, a, d, p) {
    i = a.state, typeof a.componentWillReceiveProps == "function" && a.componentWillReceiveProps(d, p), typeof a.UNSAFE_componentWillReceiveProps == "function" && a.UNSAFE_componentWillReceiveProps(d, p), a.state !== i && oy.enqueueReplaceState(a, a.state, null);
  }
  function tp(i, a, d, p) {
    var C = i.stateNode;
    C.props = d, C.state = i.memoizedState, C.refs = {}, P3(i);
    var b = a.contextType;
    typeof b == "object" && b !== null ? C.context = qa(b) : (b = li(a) ? Yr : Qn.current, C.context = Fa(i, b)), C.state = i.memoizedState, b = a.getDerivedStateFromProps, typeof b == "function" && (U3(i, a, b, d), C.state = i.memoizedState), typeof a.getDerivedStateFromProps == "function" || typeof C.getSnapshotBeforeUpdate == "function" || typeof C.UNSAFE_componentWillMount != "function" && typeof C.componentWillMount != "function" || (a = C.state, typeof C.componentWillMount == "function" && C.componentWillMount(), typeof C.UNSAFE_componentWillMount == "function" && C.UNSAFE_componentWillMount(), a !== C.state && oy.enqueueReplaceState(C, C.state, null), Bh(i, d, C, p), C.state = i.memoizedState), typeof C.componentDidMount == "function" && (i.flags |= 4194308);
  }
  function nc(i, a) {
    try {
      var d = "", p = a;
      do
        d += Oa(p), p = p.return;
      while (p);
      var C = d;
    } catch (b) {
      C = `
Error generating stack: ` + b.message + `
` + b.stack;
    }
    return { value: i, source: a, stack: C, digest: null };
  }
  function z3(i, a, d) {
    return { value: i, source: null, stack: d ?? null, digest: a ?? null };
  }
  function H3(i, a) {
    try {
      console.error(a.value);
    } catch (d) {
      setTimeout(function() {
        throw d;
      });
    }
  }
  var uy = typeof WeakMap == "function" ? WeakMap : Map;
  function VC(i, a, d) {
    d = Ro(-1, d), d.tag = 3, d.payload = { element: null };
    var p = a.value;
    return d.callback = function() {
      zd || (zd = !0, ac = p), H3(i, a);
    }, d;
  }
  function F3(i, a, d) {
    d = Ro(-1, d), d.tag = 3;
    var p = i.type.getDerivedStateFromError;
    if (typeof p == "function") {
      var C = a.value;
      d.payload = function() {
        return p(C);
      }, d.callback = function() {
        H3(i, a);
      };
    }
    var b = i.stateNode;
    return b !== null && typeof b.componentDidCatch == "function" && (d.callback = function() {
      H3(i, a), typeof p != "function" && (Ml === null ? Ml = /* @__PURE__ */ new Set([this]) : Ml.add(this));
      var R = a.stack;
      this.componentDidCatch(a.value, { componentStack: R !== null ? R : "" });
    }), d;
  }
  function I3(i, a, d) {
    var p = i.pingCache;
    if (p === null) {
      p = i.pingCache = new uy();
      var C = /* @__PURE__ */ new Set();
      p.set(a, C);
    } else C = p.get(a), C === void 0 && (C = /* @__PURE__ */ new Set(), p.set(a, C));
    C.has(d) || (C.add(d), i = eT.bind(null, i, a, d), a.then(i, i));
  }
  function UC(i) {
    do {
      var a;
      if ((a = i.tag === 13) && (a = i.memoizedState, a = a !== null ? a.dehydrated !== null : !0), a) return i;
      i = i.return;
    } while (i !== null);
    return null;
  }
  function $l(i, a, d, p, C) {
    return i.mode & 1 ? (i.flags |= 65536, i.lanes = C, i) : (i === a ? i.flags |= 65536 : (i.flags |= 128, d.flags |= 131072, d.flags &= -52805, d.tag === 1 && (d.alternate === null ? d.tag = 17 : (a = Ro(-1, 1), a.tag = 2, xl(d, a, 1))), d.lanes |= 1), i);
  }
  var np = je.ReactCurrentOwner, di = !1;
  function Yi(i, a, d, p) {
    a.child = i === null ? ge(a, null, d, p) : Zn(a, i.child, d, p);
  }
  function Jr(i, a, d, p, C) {
    d = d.render;
    var b = a.ref;
    return Un(a, C), p = Rl(i, a, d, p, b, C), d = vs(), i !== null && !di ? (a.updateQueue = i.updateQueue, a.flags &= -2053, i.lanes &= ~C, Ga(i, a, C)) : (Nn && d && Vv(a), a.flags |= 1, Yi(i, a, p, C), a.child);
  }
  function ic(i, a, d, p, C) {
    if (i === null) {
      var b = d.type;
      return typeof b == "function" && !n6(b) && b.defaultProps === void 0 && d.compare === null && d.defaultProps === void 0 ? (a.tag = 15, a.type = b, yt(i, a, b, p, C)) : (i = gp(d.type, null, p, a, a.mode, C), i.ref = a.ref, i.return = a, a.child = i);
    }
    if (b = i.child, !(i.lanes & C)) {
      var R = b.memoizedProps;
      if (d = d.compare, d = d !== null ? d : Ph, d(R, p) && i.ref === a.ref) return Ga(i, a, C);
    }
    return a.flags |= 1, i = Pl(b, p), i.ref = a.ref, i.return = a, a.child = i;
  }
  function yt(i, a, d, p, C) {
    if (i !== null) {
      var b = i.memoizedProps;
      if (Ph(b, p) && i.ref === a.ref) if (di = !1, a.pendingProps = p = b, (i.lanes & C) !== 0) i.flags & 131072 && (di = !0);
      else return a.lanes = i.lanes, Ga(i, a, C);
    }
    return zC(i, a, d, p, C);
  }
  function ip(i, a, d) {
    var p = a.pendingProps, C = p.children, b = i !== null ? i.memoizedState : null;
    if (p.mode === "hidden") if (!(a.mode & 1)) a.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, He(Nd, Ca), Ca |= d;
    else {
      if (!(d & 1073741824)) return i = b !== null ? b.baseLanes | d : d, a.lanes = a.childLanes = 1073741824, a.memoizedState = { baseLanes: i, cachePool: null, transitions: null }, a.updateQueue = null, He(Nd, Ca), Ca |= i, null;
      a.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, p = b !== null ? b.baseLanes : d, He(Nd, Ca), Ca |= p;
    }
    else b !== null ? (p = b.baseLanes | d, a.memoizedState = null) : p = d, He(Nd, Ca), Ca |= p;
    return Yi(i, a, C, d), a.child;
  }
  function B3(i, a) {
    var d = a.ref;
    (i === null && d !== null || i !== null && i.ref !== d) && (a.flags |= 512, a.flags |= 2097152);
  }
  function zC(i, a, d, p, C) {
    var b = li(d) ? Yr : Qn.current;
    return b = Fa(a, b), Un(a, C), d = Rl(i, a, d, p, b, C), p = vs(), i !== null && !di ? (a.updateQueue = i.updateQueue, a.flags &= -2053, i.lanes &= ~C, Ga(i, a, C)) : (Nn && p && Vv(a), a.flags |= 1, Yi(i, a, d, C), a.child);
  }
  function HC(i, a, d, p, C) {
    if (li(d)) {
      var b = !0;
      Wr(a);
    } else b = !1;
    if (Un(a, C), a.stateNode === null) ja(i, a), ly(a, d, p), tp(a, d, p, C), p = !0;
    else if (i === null) {
      var R = a.stateNode, O = a.memoizedProps;
      R.props = O;
      var N = R.context, Y = d.contextType;
      typeof Y == "object" && Y !== null ? Y = qa(Y) : (Y = li(d) ? Yr : Qn.current, Y = Fa(a, Y));
      var ae = d.getDerivedStateFromProps, oe = typeof ae == "function" || typeof R.getSnapshotBeforeUpdate == "function";
      oe || typeof R.UNSAFE_componentWillReceiveProps != "function" && typeof R.componentWillReceiveProps != "function" || (O !== p || N !== Y) && NC(a, R, p, Y), ya = !1;
      var re = a.memoizedState;
      R.state = re, Bh(a, p, R, C), N = a.memoizedState, O !== p || re !== N || Ti.current || ya ? (typeof ae == "function" && (U3(a, d, ae, p), N = a.memoizedState), (O = ya || _C(a, d, O, p, re, N, Y)) ? (oe || typeof R.UNSAFE_componentWillMount != "function" && typeof R.componentWillMount != "function" || (typeof R.componentWillMount == "function" && R.componentWillMount(), typeof R.UNSAFE_componentWillMount == "function" && R.UNSAFE_componentWillMount()), typeof R.componentDidMount == "function" && (a.flags |= 4194308)) : (typeof R.componentDidMount == "function" && (a.flags |= 4194308), a.memoizedProps = p, a.memoizedState = N), R.props = p, R.state = N, R.context = Y, p = O) : (typeof R.componentDidMount == "function" && (a.flags |= 4194308), p = !1);
    } else {
      R = a.stateNode, MC(i, a), O = a.memoizedProps, Y = a.type === a.elementType ? O : ys(a.type, O), R.props = Y, oe = a.pendingProps, re = R.context, N = d.contextType, typeof N == "object" && N !== null ? N = qa(N) : (N = li(d) ? Yr : Qn.current, N = Fa(a, N));
      var Te = d.getDerivedStateFromProps;
      (ae = typeof Te == "function" || typeof R.getSnapshotBeforeUpdate == "function") || typeof R.UNSAFE_componentWillReceiveProps != "function" && typeof R.componentWillReceiveProps != "function" || (O !== oe || re !== N) && NC(a, R, p, N), ya = !1, re = a.memoizedState, R.state = re, Bh(a, p, R, C);
      var Ae = a.memoizedState;
      O !== oe || re !== Ae || Ti.current || ya ? (typeof Te == "function" && (U3(a, d, Te, p), Ae = a.memoizedState), (Y = ya || _C(a, d, Y, p, re, Ae, N) || !1) ? (ae || typeof R.UNSAFE_componentWillUpdate != "function" && typeof R.componentWillUpdate != "function" || (typeof R.componentWillUpdate == "function" && R.componentWillUpdate(p, Ae, N), typeof R.UNSAFE_componentWillUpdate == "function" && R.UNSAFE_componentWillUpdate(p, Ae, N)), typeof R.componentDidUpdate == "function" && (a.flags |= 4), typeof R.getSnapshotBeforeUpdate == "function" && (a.flags |= 1024)) : (typeof R.componentDidUpdate != "function" || O === i.memoizedProps && re === i.memoizedState || (a.flags |= 4), typeof R.getSnapshotBeforeUpdate != "function" || O === i.memoizedProps && re === i.memoizedState || (a.flags |= 1024), a.memoizedProps = p, a.memoizedState = Ae), R.props = p, R.state = Ae, R.context = N, p = Y) : (typeof R.componentDidUpdate != "function" || O === i.memoizedProps && re === i.memoizedState || (a.flags |= 4), typeof R.getSnapshotBeforeUpdate != "function" || O === i.memoizedProps && re === i.memoizedState || (a.flags |= 1024), p = !1);
    }
    return rp(i, a, d, p, b, C);
  }
  function rp(i, a, d, p, C, b) {
    B3(i, a);
    var R = (a.flags & 128) !== 0;
    if (!p && !R) return C && _v(a, d, !1), Ga(i, a, b);
    p = a.stateNode, np.current = a;
    var O = R && typeof d.getDerivedStateFromError != "function" ? null : p.render();
    return a.flags |= 1, i !== null && R ? (a.child = Zn(a, i.child, null, b), a.child = Zn(a, null, O, b)) : Yi(i, a, O, b), a.memoizedState = p.state, C && _v(a, d, !0), a.child;
  }
  function Od(i) {
    var a = i.stateNode;
    a.pendingContext ? RC(i, a.pendingContext, a.pendingContext !== a.context) : a.context && RC(i, a.context, !1), _3(i, a.containerInfo);
  }
  function FC(i, a, d, p, C) {
    return kl(), xo(C), a.flags |= 256, Yi(i, a, d, p), a.child;
  }
  var cy = { dehydrated: null, treeContext: null, retryLane: 0 };
  function q3(i) {
    return { baseLanes: i, cachePool: null, transitions: null };
  }
  function dy(i, a, d) {
    var p = a.pendingProps, C = zn.current, b = !1, R = (a.flags & 128) !== 0, O;
    if ((O = R) || (O = i !== null && i.memoizedState === null ? !1 : (C & 2) !== 0), O ? (b = !0, a.flags &= -129) : (i === null || i.memoizedState !== null) && (C |= 1), He(zn, C & 1), i === null)
      return x3(a), i = a.memoizedState, i !== null && (i = i.dehydrated, i !== null) ? (a.mode & 1 ? i.data === "$!" ? a.lanes = 8 : a.lanes = 1073741824 : a.lanes = 1, null) : (R = p.children, i = p.fallback, b ? (p = a.mode, b = a.child, R = { mode: "hidden", children: R }, !(p & 1) && b !== null ? (b.childLanes = 0, b.pendingProps = R) : b = Ol(R, p, 0, null), i = Ao(i, p, d, null), b.return = a, i.return = a, b.sibling = i, a.child = b, a.child.memoizedState = q3(d), a.memoizedState = cy, i) : j3(a, R));
    if (C = i.memoizedState, C !== null && (O = C.dehydrated, O !== null)) return IC(i, a, R, p, O, C, d);
    if (b) {
      b = p.fallback, R = a.mode, C = i.child, O = C.sibling;
      var N = { mode: "hidden", children: p.children };
      return !(R & 1) && a.child !== C ? (p = a.child, p.childLanes = 0, p.pendingProps = N, a.deletions = null) : (p = Pl(C, N), p.subtreeFlags = C.subtreeFlags & 14680064), O !== null ? b = Pl(O, b) : (b = Ao(b, R, d, null), b.flags |= 2), b.return = a, p.return = a, p.sibling = b, a.child = p, p = b, b = a.child, R = i.child.memoizedState, R = R === null ? q3(d) : { baseLanes: R.baseLanes | d, cachePool: null, transitions: R.transitions }, b.memoizedState = R, b.childLanes = i.childLanes & ~d, a.memoizedState = cy, p;
    }
    return b = i.child, i = b.sibling, p = Pl(b, { mode: "visible", children: p.children }), !(a.mode & 1) && (p.lanes = d), p.return = a, p.sibling = null, i !== null && (d = a.deletions, d === null ? (a.deletions = [i], a.flags |= 16) : d.push(i)), a.child = p, a.memoizedState = null, p;
  }
  function j3(i, a) {
    return a = Ol({ mode: "visible", children: a }, i.mode, 0, null), a.return = i, i.child = a;
  }
  function ap(i, a, d, p) {
    return p !== null && xo(p), Zn(a, i.child, null, d), i = j3(a, a.pendingProps.children), i.flags |= 2, a.memoizedState = null, i;
  }
  function IC(i, a, d, p, C, b, R) {
    if (d)
      return a.flags & 256 ? (a.flags &= -257, p = z3(Error(t(422))), ap(i, a, R, p)) : a.memoizedState !== null ? (a.child = i.child, a.flags |= 128, null) : (b = p.fallback, C = a.mode, p = Ol({ mode: "visible", children: p.children }, C, 0, null), b = Ao(b, C, R, null), b.flags |= 2, p.return = a, b.return = a, p.sibling = b, a.child = p, a.mode & 1 && Zn(a, i.child, null, R), a.child.memoizedState = q3(R), a.memoizedState = cy, b);
    if (!(a.mode & 1)) return ap(i, a, R, null);
    if (C.data === "$!") {
      if (p = C.nextSibling && C.nextSibling.dataset, p) var O = p.dgst;
      return p = O, b = Error(t(419)), p = z3(b, p, void 0), ap(i, a, R, p);
    }
    if (O = (R & i.childLanes) !== 0, di || O) {
      if (p = ki, p !== null) {
        switch (R & -R) {
          case 4:
            C = 2;
            break;
          case 16:
            C = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            C = 32;
            break;
          case 536870912:
            C = 268435456;
            break;
          default:
            C = 0;
        }
        C = C & (p.suspendedLanes | R) ? 0 : C, C !== 0 && C !== b.retryLane && (b.retryLane = C, va(i, C), kr(p, i, C, -1));
      }
      return t6(), p = z3(Error(t(421))), ap(i, a, R, p);
    }
    return C.data === "$?" ? (a.flags |= 128, a.child = i.child, a = tT.bind(null, i), C._reactRetry = a, null) : (i = b.treeContext, Zr = Hs(C.nextSibling), Kr = a, Nn = !0, Ba = null, i !== null && (ui[Ia++] = qs, ui[Ia++] = js, ui[Ia++] = pa, qs = i.id, js = i.overflow, pa = a), a = j3(a, p.children), a.flags |= 4096, a);
  }
  function G3(i, a, d) {
    i.lanes |= a;
    var p = i.alternate;
    p !== null && (p.lanes |= a), D3(i.return, a, d);
  }
  function wr(i, a, d, p, C) {
    var b = i.memoizedState;
    b === null ? i.memoizedState = { isBackwards: a, rendering: null, renderingStartTime: 0, last: p, tail: d, tailMode: C } : (b.isBackwards = a, b.rendering = null, b.renderingStartTime = 0, b.last = p, b.tail = d, b.tailMode = C);
  }
  function Qs(i, a, d) {
    var p = a.pendingProps, C = p.revealOrder, b = p.tail;
    if (Yi(i, a, p.children, d), p = zn.current, p & 2) p = p & 1 | 2, a.flags |= 128;
    else {
      if (i !== null && i.flags & 128) e: for (i = a.child; i !== null; ) {
        if (i.tag === 13) i.memoizedState !== null && G3(i, d, a);
        else if (i.tag === 19) G3(i, d, a);
        else if (i.child !== null) {
          i.child.return = i, i = i.child;
          continue;
        }
        if (i === a) break e;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === a) break e;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
      p &= 1;
    }
    if (He(zn, p), !(a.mode & 1)) a.memoizedState = null;
    else switch (C) {
      case "forwards":
        for (d = a.child, C = null; d !== null; ) i = d.alternate, i !== null && Bv(i) === null && (C = d), d = d.sibling;
        d = C, d === null ? (C = a.child, a.child = null) : (C = d.sibling, d.sibling = null), wr(a, !1, C, d, b);
        break;
      case "backwards":
        for (d = null, C = a.child, a.child = null; C !== null; ) {
          if (i = C.alternate, i !== null && Bv(i) === null) {
            a.child = C;
            break;
          }
          i = C.sibling, C.sibling = d, d = C, C = i;
        }
        wr(a, !0, d, null, b);
        break;
      case "together":
        wr(a, !1, null, null, void 0);
        break;
      default:
        a.memoizedState = null;
    }
    return a.child;
  }
  function ja(i, a) {
    !(a.mode & 1) && i !== null && (i.alternate = null, a.alternate = null, a.flags |= 2);
  }
  function Ga(i, a, d) {
    if (i !== null && (a.dependencies = i.dependencies), Ks |= a.lanes, !(d & a.childLanes)) return null;
    if (i !== null && a.child !== i.child) throw Error(t(153));
    if (a.child !== null) {
      for (i = a.child, d = Pl(i, i.pendingProps), a.child = d, d.return = a; i.sibling !== null; ) i = i.sibling, d = d.sibling = Pl(i, i.pendingProps), d.return = a;
      d.sibling = null;
    }
    return a.child;
  }
  function sp(i, a, d) {
    switch (a.tag) {
      case 3:
        Od(a), kl();
        break;
      case 5:
        PC(a);
        break;
      case 1:
        li(a.type) && Wr(a);
        break;
      case 4:
        _3(a, a.stateNode.containerInfo);
        break;
      case 10:
        var p = a.type._context, C = a.memoizedProps.value;
        He(ma, p._currentValue), p._currentValue = C;
        break;
      case 13:
        if (p = a.memoizedState, p !== null)
          return p.dehydrated !== null ? (He(zn, zn.current & 1), a.flags |= 128, null) : d & a.child.childLanes ? dy(i, a, d) : (He(zn, zn.current & 1), i = Ga(i, a, d), i !== null ? i.sibling : null);
        He(zn, zn.current & 1);
        break;
      case 19:
        if (p = (d & a.childLanes) !== 0, i.flags & 128) {
          if (p) return Qs(i, a, d);
          a.flags |= 128;
        }
        if (C = a.memoizedState, C !== null && (C.rendering = null, C.tail = null, C.lastEffect = null), He(zn, zn.current), p) break;
        return null;
      case 22:
      case 23:
        return a.lanes = 0, ip(i, a, d);
    }
    return Ga(i, a, d);
  }
  var Qa, fi, BC, qC;
  Qa = function(i, a) {
    for (var d = a.child; d !== null; ) {
      if (d.tag === 5 || d.tag === 6) i.appendChild(d.stateNode);
      else if (d.tag !== 4 && d.child !== null) {
        d.child.return = d, d = d.child;
        continue;
      }
      if (d === a) break;
      for (; d.sibling === null; ) {
        if (d.return === null || d.return === a) return;
        d = d.return;
      }
      d.sibling.return = d.return, d = d.sibling;
    }
  }, fi = function() {
  }, BC = function(i, a, d, p) {
    var C = i.memoizedProps;
    if (C !== p) {
      i = a.stateNode, Yu(Gs.current);
      var b = null;
      switch (d) {
        case "input":
          C = qi(i, C), p = qi(i, p), b = [];
          break;
        case "select":
          C = me({}, C, { value: void 0 }), p = me({}, p, { value: void 0 }), b = [];
          break;
        case "textarea":
          C = _a(i, C), p = _a(i, p), b = [];
          break;
        default:
          typeof C.onClick != "function" && typeof p.onClick == "function" && (i.onclick = Cl);
      }
      ai(d, p);
      var R;
      d = null;
      for (Y in C) if (!p.hasOwnProperty(Y) && C.hasOwnProperty(Y) && C[Y] != null) if (Y === "style") {
        var O = C[Y];
        for (R in O) O.hasOwnProperty(R) && (d || (d = {}), d[R] = "");
      } else Y !== "dangerouslySetInnerHTML" && Y !== "children" && Y !== "suppressContentEditableWarning" && Y !== "suppressHydrationWarning" && Y !== "autoFocus" && (f.hasOwnProperty(Y) ? b || (b = []) : (b = b || []).push(Y, null));
      for (Y in p) {
        var N = p[Y];
        if (O = C != null ? C[Y] : void 0, p.hasOwnProperty(Y) && N !== O && (N != null || O != null)) if (Y === "style") if (O) {
          for (R in O) !O.hasOwnProperty(R) || N && N.hasOwnProperty(R) || (d || (d = {}), d[R] = "");
          for (R in N) N.hasOwnProperty(R) && O[R] !== N[R] && (d || (d = {}), d[R] = N[R]);
        } else d || (b || (b = []), b.push(
          Y,
          d
        )), d = N;
        else Y === "dangerouslySetInnerHTML" ? (N = N ? N.__html : void 0, O = O ? O.__html : void 0, N != null && O !== N && (b = b || []).push(Y, N)) : Y === "children" ? typeof N != "string" && typeof N != "number" || (b = b || []).push(Y, "" + N) : Y !== "suppressContentEditableWarning" && Y !== "suppressHydrationWarning" && (f.hasOwnProperty(Y) ? (N != null && Y === "onScroll" && ln("scroll", i), b || O === N || (b = [])) : (b = b || []).push(Y, N));
      }
      d && (b = b || []).push("style", d);
      var Y = b;
      (a.updateQueue = Y) && (a.flags |= 4);
    }
  }, qC = function(i, a, d, p) {
    d !== p && (a.flags |= 4);
  };
  function op(i, a) {
    if (!Nn) switch (i.tailMode) {
      case "hidden":
        a = i.tail;
        for (var d = null; a !== null; ) a.alternate !== null && (d = a), a = a.sibling;
        d === null ? i.tail = null : d.sibling = null;
        break;
      case "collapsed":
        d = i.tail;
        for (var p = null; d !== null; ) d.alternate !== null && (p = d), d = d.sibling;
        p === null ? a || i.tail === null ? i.tail = null : i.tail.sibling = null : p.sibling = null;
    }
  }
  function _i(i) {
    var a = i.alternate !== null && i.alternate.child === i.child, d = 0, p = 0;
    if (a) for (var C = i.child; C !== null; ) d |= C.lanes | C.childLanes, p |= C.subtreeFlags & 14680064, p |= C.flags & 14680064, C.return = i, C = C.sibling;
    else for (C = i.child; C !== null; ) d |= C.lanes | C.childLanes, p |= C.subtreeFlags, p |= C.flags, C.return = i, C = C.sibling;
    return i.subtreeFlags |= p, i.childLanes = d, a;
  }
  function jC(i, a, d) {
    var p = a.pendingProps;
    switch (Uv(a), a.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return _i(a), null;
      case 1:
        return li(a.type) && $d(), _i(a), null;
      case 3:
        return p = a.stateNode, Wu(), xn(Ti), xn(Qn), Ie(), p.pendingContext && (p.context = p.pendingContext, p.pendingContext = null), (i === null || i.child === null) && (zv(a) ? a.flags |= 4 : i === null || i.memoizedState.isDehydrated && !(a.flags & 256) || (a.flags |= 1024, Ba !== null && (sc(Ba), Ba = null))), fi(i, a), _i(a), null;
      case 5:
        Iv(a);
        var C = Yu(Gh.current);
        if (d = a.type, i !== null && a.stateNode != null) BC(i, a, d, p, C), i.ref !== a.ref && (a.flags |= 512, a.flags |= 2097152);
        else {
          if (!p) {
            if (a.stateNode === null) throw Error(t(166));
            return _i(a), null;
          }
          if (i = Yu(Gs.current), zv(a)) {
            p = a.stateNode, d = a.type;
            var b = a.memoizedProps;
            switch (p[Fs] = a, p[zh] = b, i = (a.mode & 1) !== 0, d) {
              case "dialog":
                ln("cancel", p), ln("close", p);
                break;
              case "iframe":
              case "object":
              case "embed":
                ln("load", p);
                break;
              case "video":
              case "audio":
                for (C = 0; C < Nh.length; C++) ln(Nh[C], p);
                break;
              case "source":
                ln("error", p);
                break;
              case "img":
              case "image":
              case "link":
                ln(
                  "error",
                  p
                ), ln("load", p);
                break;
              case "details":
                ln("toggle", p);
                break;
              case "input":
                Sr(p, b), ln("invalid", p);
                break;
              case "select":
                p._wrapperState = { wasMultiple: !!b.multiple }, ln("invalid", p);
                break;
              case "textarea":
                ls(p, b), ln("invalid", p);
            }
            ai(d, b), C = null;
            for (var R in b) if (b.hasOwnProperty(R)) {
              var O = b[R];
              R === "children" ? typeof O == "string" ? p.textContent !== O && (b.suppressHydrationWarning !== !0 && Mv(p.textContent, O, i), C = ["children", O]) : typeof O == "number" && p.textContent !== "" + O && (b.suppressHydrationWarning !== !0 && Mv(
                p.textContent,
                O,
                i
              ), C = ["children", "" + O]) : f.hasOwnProperty(R) && O != null && R === "onScroll" && ln("scroll", p);
            }
            switch (d) {
              case "input":
                Wn(p), gh(p, b, !0);
                break;
              case "textarea":
                Wn(p), ha(p);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof b.onClick == "function" && (p.onclick = Cl);
            }
            p = C, a.updateQueue = p, p !== null && (a.flags |= 4);
          } else {
            R = C.nodeType === 9 ? C : C.ownerDocument, i === "http://www.w3.org/1999/xhtml" && (i = Us(d)), i === "http://www.w3.org/1999/xhtml" ? d === "script" ? (i = R.createElement("div"), i.innerHTML = "<script><\/script>", i = i.removeChild(i.firstChild)) : typeof p.is == "string" ? i = R.createElement(d, { is: p.is }) : (i = R.createElement(d), d === "select" && (R = i, p.multiple ? R.multiple = !0 : p.size && (R.size = p.size))) : i = R.createElementNS(i, d), i[Fs] = a, i[zh] = p, Qa(i, a, !1, !1), a.stateNode = i;
            e: {
              switch (R = qr(d, p), d) {
                case "dialog":
                  ln("cancel", i), ln("close", i), C = p;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  ln("load", i), C = p;
                  break;
                case "video":
                case "audio":
                  for (C = 0; C < Nh.length; C++) ln(Nh[C], i);
                  C = p;
                  break;
                case "source":
                  ln("error", i), C = p;
                  break;
                case "img":
                case "image":
                case "link":
                  ln(
                    "error",
                    i
                  ), ln("load", i), C = p;
                  break;
                case "details":
                  ln("toggle", i), C = p;
                  break;
                case "input":
                  Sr(i, p), C = qi(i, p), ln("invalid", i);
                  break;
                case "option":
                  C = p;
                  break;
                case "select":
                  i._wrapperState = { wasMultiple: !!p.multiple }, C = me({}, p, { value: void 0 }), ln("invalid", i);
                  break;
                case "textarea":
                  ls(i, p), C = _a(i, p), ln("invalid", i);
                  break;
                default:
                  C = p;
              }
              ai(d, C), O = C;
              for (b in O) if (O.hasOwnProperty(b)) {
                var N = O[b];
                b === "style" ? qn(i, N) : b === "dangerouslySetInnerHTML" ? (N = N ? N.__html : void 0, N != null && Sh(i, N)) : b === "children" ? typeof N == "string" ? (d !== "textarea" || N !== "") && ye(i, N) : typeof N == "number" && ye(i, "" + N) : b !== "suppressContentEditableWarning" && b !== "suppressHydrationWarning" && b !== "autoFocus" && (f.hasOwnProperty(b) ? N != null && b === "onScroll" && ln("scroll", i) : N != null && Se(i, b, N, R));
              }
              switch (d) {
                case "input":
                  Wn(i), gh(i, p, !1);
                  break;
                case "textarea":
                  Wn(i), ha(i);
                  break;
                case "option":
                  p.value != null && i.setAttribute("value", "" + Ii(p.value));
                  break;
                case "select":
                  i.multiple = !!p.multiple, b = p.value, b != null ? fa(i, !!p.multiple, b, !1) : p.defaultValue != null && fa(
                    i,
                    !!p.multiple,
                    p.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof C.onClick == "function" && (i.onclick = Cl);
              }
              switch (d) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  p = !!p.autoFocus;
                  break e;
                case "img":
                  p = !0;
                  break e;
                default:
                  p = !1;
              }
            }
            p && (a.flags |= 4);
          }
          a.ref !== null && (a.flags |= 512, a.flags |= 2097152);
        }
        return _i(a), null;
      case 6:
        if (i && a.stateNode != null) qC(i, a, i.memoizedProps, p);
        else {
          if (typeof p != "string" && a.stateNode === null) throw Error(t(166));
          if (d = Yu(Gh.current), Yu(Gs.current), zv(a)) {
            if (p = a.stateNode, d = a.memoizedProps, p[Fs] = a, (b = p.nodeValue !== d) && (i = Kr, i !== null)) switch (i.tag) {
              case 3:
                Mv(p.nodeValue, d, (i.mode & 1) !== 0);
                break;
              case 5:
                i.memoizedProps.suppressHydrationWarning !== !0 && Mv(p.nodeValue, d, (i.mode & 1) !== 0);
            }
            b && (a.flags |= 4);
          } else p = (d.nodeType === 9 ? d : d.ownerDocument).createTextNode(p), p[Fs] = a, a.stateNode = p;
        }
        return _i(a), null;
      case 13:
        if (xn(zn), p = a.memoizedState, i === null || i.memoizedState !== null && i.memoizedState.dehydrated !== null) {
          if (Nn && Zr !== null && a.mode & 1 && !(a.flags & 128)) Ih(), kl(), a.flags |= 98560, b = !1;
          else if (b = zv(a), p !== null && p.dehydrated !== null) {
            if (i === null) {
              if (!b) throw Error(t(318));
              if (b = a.memoizedState, b = b !== null ? b.dehydrated : null, !b) throw Error(t(317));
              b[Fs] = a;
            } else kl(), !(a.flags & 128) && (a.memoizedState = null), a.flags |= 4;
            _i(a), b = !1;
          } else Ba !== null && (sc(Ba), Ba = null), b = !0;
          if (!b) return a.flags & 65536 ? a : null;
        }
        return a.flags & 128 ? (a.lanes = d, a) : (p = p !== null, p !== (i !== null && i.memoizedState !== null) && p && (a.child.flags |= 8192, a.mode & 1 && (i === null || zn.current & 1 ? ei === 0 && (ei = 3) : t6())), a.updateQueue !== null && (a.flags |= 4), _i(a), null);
      case 4:
        return Wu(), fi(i, a), i === null && Ed(a.stateNode.containerInfo), _i(a), null;
      case 10:
        return $3(a.type._context), _i(a), null;
      case 17:
        return li(a.type) && $d(), _i(a), null;
      case 19:
        if (xn(zn), b = a.memoizedState, b === null) return _i(a), null;
        if (p = (a.flags & 128) !== 0, R = b.rendering, R === null) if (p) op(b, !1);
        else {
          if (ei !== 0 || i !== null && i.flags & 128) for (i = a.child; i !== null; ) {
            if (R = Bv(i), R !== null) {
              for (a.flags |= 128, op(b, !1), p = R.updateQueue, p !== null && (a.updateQueue = p, a.flags |= 4), a.subtreeFlags = 0, p = d, d = a.child; d !== null; ) b = d, i = p, b.flags &= 14680066, R = b.alternate, R === null ? (b.childLanes = 0, b.lanes = i, b.child = null, b.subtreeFlags = 0, b.memoizedProps = null, b.memoizedState = null, b.updateQueue = null, b.dependencies = null, b.stateNode = null) : (b.childLanes = R.childLanes, b.lanes = R.lanes, b.child = R.child, b.subtreeFlags = 0, b.deletions = null, b.memoizedProps = R.memoizedProps, b.memoizedState = R.memoizedState, b.updateQueue = R.updateQueue, b.type = R.type, i = R.dependencies, b.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }), d = d.sibling;
              return He(zn, zn.current & 1 | 2), a.child;
            }
            i = i.sibling;
          }
          b.tail !== null && En() > Ud && (a.flags |= 128, p = !0, op(b, !1), a.lanes = 4194304);
        }
        else {
          if (!p) if (i = Bv(R), i !== null) {
            if (a.flags |= 128, p = !0, d = i.updateQueue, d !== null && (a.updateQueue = d, a.flags |= 4), op(b, !0), b.tail === null && b.tailMode === "hidden" && !R.alternate && !Nn) return _i(a), null;
          } else 2 * En() - b.renderingStartTime > Ud && d !== 1073741824 && (a.flags |= 128, p = !0, op(b, !1), a.lanes = 4194304);
          b.isBackwards ? (R.sibling = a.child, a.child = R) : (d = b.last, d !== null ? d.sibling = R : a.child = R, b.last = R);
        }
        return b.tail !== null ? (a = b.tail, b.rendering = a, b.tail = a.sibling, b.renderingStartTime = En(), a.sibling = null, d = zn.current, He(zn, p ? d & 1 | 2 : d & 1), a) : (_i(a), null);
      case 22:
      case 23:
        return e6(), p = a.memoizedState !== null, i !== null && i.memoizedState !== null !== p && (a.flags |= 8192), p && a.mode & 1 ? Ca & 1073741824 && (_i(a), a.subtreeFlags & 6 && (a.flags |= 8192)) : _i(a), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(t(156, a.tag));
  }
  function fy(i, a) {
    switch (Uv(a), a.tag) {
      case 1:
        return li(a.type) && $d(), i = a.flags, i & 65536 ? (a.flags = i & -65537 | 128, a) : null;
      case 3:
        return Wu(), xn(Ti), xn(Qn), Ie(), i = a.flags, i & 65536 && !(i & 128) ? (a.flags = i & -65537 | 128, a) : null;
      case 5:
        return Iv(a), null;
      case 13:
        if (xn(zn), i = a.memoizedState, i !== null && i.dehydrated !== null) {
          if (a.alternate === null) throw Error(t(340));
          kl();
        }
        return i = a.flags, i & 65536 ? (a.flags = i & -65537 | 128, a) : null;
      case 19:
        return xn(zn), null;
      case 4:
        return Wu(), null;
      case 10:
        return $3(a.type._context), null;
      case 22:
      case 23:
        return e6(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var lp = !1, fr = !1, Yw = typeof WeakSet == "function" ? WeakSet : Set, Re = null;
  function _d(i, a) {
    var d = i.ref;
    if (d !== null) if (typeof d == "function") try {
      d(null);
    } catch (p) {
      Vn(i, a, p);
    }
    else d.current = null;
  }
  function hy(i, a, d) {
    try {
      d();
    } catch (p) {
      Vn(i, a, p);
    }
  }
  var GC = !1;
  function QC(i, a) {
    if (Uh = _u, i = Oh(), Tv(i)) {
      if ("selectionStart" in i) var d = { start: i.selectionStart, end: i.selectionEnd };
      else e: {
        d = (d = i.ownerDocument) && d.defaultView || window;
        var p = d.getSelection && d.getSelection();
        if (p && p.rangeCount !== 0) {
          d = p.anchorNode;
          var C = p.anchorOffset, b = p.focusNode;
          p = p.focusOffset;
          try {
            d.nodeType, b.nodeType;
          } catch {
            d = null;
            break e;
          }
          var R = 0, O = -1, N = -1, Y = 0, ae = 0, oe = i, re = null;
          t: for (; ; ) {
            for (var Te; oe !== d || C !== 0 && oe.nodeType !== 3 || (O = R + C), oe !== b || p !== 0 && oe.nodeType !== 3 || (N = R + p), oe.nodeType === 3 && (R += oe.nodeValue.length), (Te = oe.firstChild) !== null; )
              re = oe, oe = Te;
            for (; ; ) {
              if (oe === i) break t;
              if (re === d && ++Y === C && (O = R), re === b && ++ae === p && (N = R), (Te = oe.nextSibling) !== null) break;
              oe = re, re = oe.parentNode;
            }
            oe = Te;
          }
          d = O === -1 || N === -1 ? null : { start: O, end: N };
        } else d = null;
      }
      d = d || { start: 0, end: 0 };
    } else d = null;
    for (Iu = { focusedElem: i, selectionRange: d }, _u = !1, Re = a; Re !== null; ) if (a = Re, i = a.child, (a.subtreeFlags & 1028) !== 0 && i !== null) i.return = a, Re = i;
    else for (; Re !== null; ) {
      a = Re;
      try {
        var Ae = a.alternate;
        if (a.flags & 1024) switch (a.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (Ae !== null) {
              var _e = Ae.memoizedProps, ti = Ae.memoizedState, B = a.stateNode, z = B.getSnapshotBeforeUpdate(a.elementType === a.type ? _e : ys(a.type, _e), ti);
              B.__reactInternalSnapshotBeforeUpdate = z;
            }
            break;
          case 3:
            var G = a.stateNode.containerInfo;
            G.nodeType === 1 ? G.textContent = "" : G.nodeType === 9 && G.documentElement && G.removeChild(G.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(t(163));
        }
      } catch (de) {
        Vn(a, a.return, de);
      }
      if (i = a.sibling, i !== null) {
        i.return = a.return, Re = i;
        break;
      }
      Re = a.return;
    }
    return Ae = GC, GC = !1, Ae;
  }
  function up(i, a, d) {
    var p = a.updateQueue;
    if (p = p !== null ? p.lastEffect : null, p !== null) {
      var C = p = p.next;
      do {
        if ((C.tag & i) === i) {
          var b = C.destroy;
          C.destroy = void 0, b !== void 0 && hy(a, d, b);
        }
        C = C.next;
      } while (C !== p);
    }
  }
  function cp(i, a) {
    if (a = a.updateQueue, a = a !== null ? a.lastEffect : null, a !== null) {
      var d = a = a.next;
      do {
        if ((d.tag & i) === i) {
          var p = d.create;
          d.destroy = p();
        }
        d = d.next;
      } while (d !== a);
    }
  }
  function Q3(i) {
    var a = i.ref;
    if (a !== null) {
      var d = i.stateNode;
      switch (i.tag) {
        case 5:
          i = d;
          break;
        default:
          i = d;
      }
      typeof a == "function" ? a(i) : a.current = i;
    }
  }
  function py(i) {
    var a = i.alternate;
    a !== null && (i.alternate = null, py(a)), i.child = null, i.deletions = null, i.sibling = null, i.tag === 5 && (a = i.stateNode, a !== null && (delete a[Fs], delete a[zh], delete a[Hh], delete a[Ld], delete a[Gw])), i.stateNode = null, i.return = null, i.dependencies = null, i.memoizedProps = null, i.memoizedState = null, i.pendingProps = null, i.stateNode = null, i.updateQueue = null;
  }
  function dp(i) {
    return i.tag === 5 || i.tag === 3 || i.tag === 4;
  }
  function $o(i) {
    e: for (; ; ) {
      for (; i.sibling === null; ) {
        if (i.return === null || dp(i.return)) return null;
        i = i.return;
      }
      for (i.sibling.return = i.return, i = i.sibling; i.tag !== 5 && i.tag !== 6 && i.tag !== 18; ) {
        if (i.flags & 2 || i.child === null || i.tag === 4) continue e;
        i.child.return = i, i = i.child;
      }
      if (!(i.flags & 2)) return i.stateNode;
    }
  }
  function Ys(i, a, d) {
    var p = i.tag;
    if (p === 5 || p === 6) i = i.stateNode, a ? d.nodeType === 8 ? d.parentNode.insertBefore(i, a) : d.insertBefore(i, a) : (d.nodeType === 8 ? (a = d.parentNode, a.insertBefore(i, d)) : (a = d, a.appendChild(i)), d = d._reactRootContainer, d != null || a.onclick !== null || (a.onclick = Cl));
    else if (p !== 4 && (i = i.child, i !== null)) for (Ys(i, a, d), i = i.sibling; i !== null; ) Ys(i, a, d), i = i.sibling;
  }
  function Ws(i, a, d) {
    var p = i.tag;
    if (p === 5 || p === 6) i = i.stateNode, a ? d.insertBefore(i, a) : d.appendChild(i);
    else if (p !== 4 && (i = i.child, i !== null)) for (Ws(i, a, d), i = i.sibling; i !== null; ) Ws(i, a, d), i = i.sibling;
  }
  var Jn = null, Tr = !1;
  function Er(i, a, d) {
    for (d = d.child; d !== null; ) YC(i, a, d), d = d.sibling;
  }
  function YC(i, a, d) {
    if (ds && typeof ds.onCommitFiberUnmount == "function") try {
      ds.onCommitFiberUnmount(Th, d);
    } catch {
    }
    switch (d.tag) {
      case 5:
        fr || _d(d, a);
      case 6:
        var p = Jn, C = Tr;
        Jn = null, Er(i, a, d), Jn = p, Tr = C, Jn !== null && (Tr ? (i = Jn, d = d.stateNode, i.nodeType === 8 ? i.parentNode.removeChild(d) : i.removeChild(d)) : Jn.removeChild(d.stateNode));
        break;
      case 18:
        Jn !== null && (Tr ? (i = Jn, d = d.stateNode, i.nodeType === 8 ? Rd(i.parentNode, d) : i.nodeType === 1 && Rd(i, d), vl(i)) : Rd(Jn, d.stateNode));
        break;
      case 4:
        p = Jn, C = Tr, Jn = d.stateNode.containerInfo, Tr = !0, Er(i, a, d), Jn = p, Tr = C;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!fr && (p = d.updateQueue, p !== null && (p = p.lastEffect, p !== null))) {
          C = p = p.next;
          do {
            var b = C, R = b.destroy;
            b = b.tag, R !== void 0 && (b & 2 || b & 4) && hy(d, a, R), C = C.next;
          } while (C !== p);
        }
        Er(i, a, d);
        break;
      case 1:
        if (!fr && (_d(d, a), p = d.stateNode, typeof p.componentWillUnmount == "function")) try {
          p.props = d.memoizedProps, p.state = d.memoizedState, p.componentWillUnmount();
        } catch (O) {
          Vn(d, a, O);
        }
        Er(i, a, d);
        break;
      case 21:
        Er(i, a, d);
        break;
      case 22:
        d.mode & 1 ? (fr = (p = fr) || d.memoizedState !== null, Er(i, a, d), fr = p) : Er(i, a, d);
        break;
      default:
        Er(i, a, d);
    }
  }
  function WC(i) {
    var a = i.updateQueue;
    if (a !== null) {
      i.updateQueue = null;
      var d = i.stateNode;
      d === null && (d = i.stateNode = new Yw()), a.forEach(function(p) {
        var C = rS.bind(null, i, p);
        d.has(p) || (d.add(p), p.then(C, C));
      });
    }
  }
  function gs(i, a) {
    var d = a.deletions;
    if (d !== null) for (var p = 0; p < d.length; p++) {
      var C = d[p];
      try {
        var b = i, R = a, O = R;
        e: for (; O !== null; ) {
          switch (O.tag) {
            case 5:
              Jn = O.stateNode, Tr = !1;
              break e;
            case 3:
              Jn = O.stateNode.containerInfo, Tr = !0;
              break e;
            case 4:
              Jn = O.stateNode.containerInfo, Tr = !0;
              break e;
          }
          O = O.return;
        }
        if (Jn === null) throw Error(t(160));
        YC(b, R, C), Jn = null, Tr = !1;
        var N = C.alternate;
        N !== null && (N.return = null), C.return = null;
      } catch (Y) {
        Vn(C, a, Y);
      }
    }
    if (a.subtreeFlags & 12854) for (a = a.child; a !== null; ) Y3(a, i), a = a.sibling;
  }
  function Y3(i, a) {
    var d = i.alternate, p = i.flags;
    switch (i.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (gs(a, i), ea(i), p & 4) {
          try {
            up(3, i, i.return), cp(3, i);
          } catch (_e) {
            Vn(i, i.return, _e);
          }
          try {
            up(5, i, i.return);
          } catch (_e) {
            Vn(i, i.return, _e);
          }
        }
        break;
      case 1:
        gs(a, i), ea(i), p & 512 && d !== null && _d(d, d.return);
        break;
      case 5:
        if (gs(a, i), ea(i), p & 512 && d !== null && _d(d, d.return), i.flags & 32) {
          var C = i.stateNode;
          try {
            ye(C, "");
          } catch (_e) {
            Vn(i, i.return, _e);
          }
        }
        if (p & 4 && (C = i.stateNode, C != null)) {
          var b = i.memoizedProps, R = d !== null ? d.memoizedProps : b, O = i.type, N = i.updateQueue;
          if (i.updateQueue = null, N !== null) try {
            O === "input" && b.type === "radio" && b.name != null && da(C, b), qr(O, R);
            var Y = qr(O, b);
            for (R = 0; R < N.length; R += 2) {
              var ae = N[R], oe = N[R + 1];
              ae === "style" ? qn(C, oe) : ae === "dangerouslySetInnerHTML" ? Sh(C, oe) : ae === "children" ? ye(C, oe) : Se(C, ae, oe, Y);
            }
            switch (O) {
              case "input":
                ud(C, b);
                break;
              case "textarea":
                cd(C, b);
                break;
              case "select":
                var re = C._wrapperState.wasMultiple;
                C._wrapperState.wasMultiple = !!b.multiple;
                var Te = b.value;
                Te != null ? fa(C, !!b.multiple, Te, !1) : re !== !!b.multiple && (b.defaultValue != null ? fa(
                  C,
                  !!b.multiple,
                  b.defaultValue,
                  !0
                ) : fa(C, !!b.multiple, b.multiple ? [] : "", !1));
            }
            C[zh] = b;
          } catch (_e) {
            Vn(i, i.return, _e);
          }
        }
        break;
      case 6:
        if (gs(a, i), ea(i), p & 4) {
          if (i.stateNode === null) throw Error(t(162));
          C = i.stateNode, b = i.memoizedProps;
          try {
            C.nodeValue = b;
          } catch (_e) {
            Vn(i, i.return, _e);
          }
        }
        break;
      case 3:
        if (gs(a, i), ea(i), p & 4 && d !== null && d.memoizedState.isDehydrated) try {
          vl(a.containerInfo);
        } catch (_e) {
          Vn(i, i.return, _e);
        }
        break;
      case 4:
        gs(a, i), ea(i);
        break;
      case 13:
        gs(a, i), ea(i), C = i.child, C.flags & 8192 && (b = C.memoizedState !== null, C.stateNode.isHidden = b, !b || C.alternate !== null && C.alternate.memoizedState !== null || (Z3 = En())), p & 4 && WC(i);
        break;
      case 22:
        if (ae = d !== null && d.memoizedState !== null, i.mode & 1 ? (fr = (Y = fr) || ae, gs(a, i), fr = Y) : gs(a, i), ea(i), p & 8192) {
          if (Y = i.memoizedState !== null, (i.stateNode.isHidden = Y) && !ae && i.mode & 1) for (Re = i, ae = i.child; ae !== null; ) {
            for (oe = Re = ae; Re !== null; ) {
              switch (re = Re, Te = re.child, re.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  up(4, re, re.return);
                  break;
                case 1:
                  _d(re, re.return);
                  var Ae = re.stateNode;
                  if (typeof Ae.componentWillUnmount == "function") {
                    p = re, d = re.return;
                    try {
                      a = p, Ae.props = a.memoizedProps, Ae.state = a.memoizedState, Ae.componentWillUnmount();
                    } catch (_e) {
                      Vn(p, d, _e);
                    }
                  }
                  break;
                case 5:
                  _d(re, re.return);
                  break;
                case 22:
                  if (re.memoizedState !== null) {
                    fp(oe);
                    continue;
                  }
              }
              Te !== null ? (Te.return = re, Re = Te) : fp(oe);
            }
            ae = ae.sibling;
          }
          e: for (ae = null, oe = i; ; ) {
            if (oe.tag === 5) {
              if (ae === null) {
                ae = oe;
                try {
                  C = oe.stateNode, Y ? (b = C.style, typeof b.setProperty == "function" ? b.setProperty("display", "none", "important") : b.display = "none") : (O = oe.stateNode, N = oe.memoizedProps.style, R = N != null && N.hasOwnProperty("display") ? N.display : null, O.style.display = Tn("display", R));
                } catch (_e) {
                  Vn(i, i.return, _e);
                }
              }
            } else if (oe.tag === 6) {
              if (ae === null) try {
                oe.stateNode.nodeValue = Y ? "" : oe.memoizedProps;
              } catch (_e) {
                Vn(i, i.return, _e);
              }
            } else if ((oe.tag !== 22 && oe.tag !== 23 || oe.memoizedState === null || oe === i) && oe.child !== null) {
              oe.child.return = oe, oe = oe.child;
              continue;
            }
            if (oe === i) break e;
            for (; oe.sibling === null; ) {
              if (oe.return === null || oe.return === i) break e;
              ae === oe && (ae = null), oe = oe.return;
            }
            ae === oe && (ae = null), oe.sibling.return = oe.return, oe = oe.sibling;
          }
        }
        break;
      case 19:
        gs(a, i), ea(i), p & 4 && WC(i);
        break;
      case 21:
        break;
      default:
        gs(
          a,
          i
        ), ea(i);
    }
  }
  function ea(i) {
    var a = i.flags;
    if (a & 2) {
      try {
        e: {
          for (var d = i.return; d !== null; ) {
            if (dp(d)) {
              var p = d;
              break e;
            }
            d = d.return;
          }
          throw Error(t(160));
        }
        switch (p.tag) {
          case 5:
            var C = p.stateNode;
            p.flags & 32 && (ye(C, ""), p.flags &= -33);
            var b = $o(i);
            Ws(i, b, C);
            break;
          case 3:
          case 4:
            var R = p.stateNode.containerInfo, O = $o(i);
            Ys(i, O, R);
            break;
          default:
            throw Error(t(161));
        }
      } catch (N) {
        Vn(i, i.return, N);
      }
      i.flags &= -3;
    }
    a & 4096 && (i.flags &= -4097);
  }
  function Ww(i, a, d) {
    Re = i, W3(i);
  }
  function W3(i, a, d) {
    for (var p = (i.mode & 1) !== 0; Re !== null; ) {
      var C = Re, b = C.child;
      if (C.tag === 22 && p) {
        var R = C.memoizedState !== null || lp;
        if (!R) {
          var O = C.alternate, N = O !== null && O.memoizedState !== null || fr;
          O = lp;
          var Y = fr;
          if (lp = R, (fr = N) && !Y) for (Re = C; Re !== null; ) R = Re, N = R.child, R.tag === 22 && R.memoizedState !== null ? K3(C) : N !== null ? (N.return = R, Re = N) : K3(C);
          for (; b !== null; ) Re = b, W3(b), b = b.sibling;
          Re = C, lp = O, fr = Y;
        }
        KC(i);
      } else C.subtreeFlags & 8772 && b !== null ? (b.return = C, Re = b) : KC(i);
    }
  }
  function KC(i) {
    for (; Re !== null; ) {
      var a = Re;
      if (a.flags & 8772) {
        var d = a.alternate;
        try {
          if (a.flags & 8772) switch (a.tag) {
            case 0:
            case 11:
            case 15:
              fr || cp(5, a);
              break;
            case 1:
              var p = a.stateNode;
              if (a.flags & 4 && !fr) if (d === null) p.componentDidMount();
              else {
                var C = a.elementType === a.type ? d.memoizedProps : ys(a.type, d.memoizedProps);
                p.componentDidUpdate(C, d.memoizedState, p.__reactInternalSnapshotBeforeUpdate);
              }
              var b = a.updateQueue;
              b !== null && O3(a, b, p);
              break;
            case 3:
              var R = a.updateQueue;
              if (R !== null) {
                if (d = null, a.child !== null) switch (a.child.tag) {
                  case 5:
                    d = a.child.stateNode;
                    break;
                  case 1:
                    d = a.child.stateNode;
                }
                O3(a, R, d);
              }
              break;
            case 5:
              var O = a.stateNode;
              if (d === null && a.flags & 4) {
                d = O;
                var N = a.memoizedProps;
                switch (a.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    N.autoFocus && d.focus();
                    break;
                  case "img":
                    N.src && (d.src = N.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (a.memoizedState === null) {
                var Y = a.alternate;
                if (Y !== null) {
                  var ae = Y.memoizedState;
                  if (ae !== null) {
                    var oe = ae.dehydrated;
                    oe !== null && vl(oe);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(t(163));
          }
          fr || a.flags & 512 && Q3(a);
        } catch (re) {
          Vn(a, a.return, re);
        }
      }
      if (a === i) {
        Re = null;
        break;
      }
      if (d = a.sibling, d !== null) {
        d.return = a.return, Re = d;
        break;
      }
      Re = a.return;
    }
  }
  function fp(i) {
    for (; Re !== null; ) {
      var a = Re;
      if (a === i) {
        Re = null;
        break;
      }
      var d = a.sibling;
      if (d !== null) {
        d.return = a.return, Re = d;
        break;
      }
      Re = a.return;
    }
  }
  function K3(i) {
    for (; Re !== null; ) {
      var a = Re;
      try {
        switch (a.tag) {
          case 0:
          case 11:
          case 15:
            var d = a.return;
            try {
              cp(4, a);
            } catch (N) {
              Vn(a, d, N);
            }
            break;
          case 1:
            var p = a.stateNode;
            if (typeof p.componentDidMount == "function") {
              var C = a.return;
              try {
                p.componentDidMount();
              } catch (N) {
                Vn(a, C, N);
              }
            }
            var b = a.return;
            try {
              Q3(a);
            } catch (N) {
              Vn(a, b, N);
            }
            break;
          case 5:
            var R = a.return;
            try {
              Q3(a);
            } catch (N) {
              Vn(a, R, N);
            }
        }
      } catch (N) {
        Vn(a, a.return, N);
      }
      if (a === i) {
        Re = null;
        break;
      }
      var O = a.sibling;
      if (O !== null) {
        O.return = a.return, Re = O;
        break;
      }
      Re = a.return;
    }
  }
  var Kw = Math.ceil, Dl = je.ReactCurrentDispatcher, rc = je.ReactCurrentOwner, Wi = je.ReactCurrentBatchConfig, Nt = 0, ki = null, hi = null, Ki = 0, Ca = 0, Nd = ms(0), ei = 0, hp = null, Ks = 0, Vd = 0, my = 0, pp = null, ta = null, Z3 = 0, Ud = 1 / 0, Sa = null, zd = !1, ac = null, Ml = null, vy = !1, Do = null, mp = 0, Al = 0, Hd = null, vp = -1, hr = 0;
  function pi() {
    return Nt & 6 ? En() : vp !== -1 ? vp : vp = En();
  }
  function Zs(i) {
    return i.mode & 1 ? Nt & 2 && Ki !== 0 ? Ki & -Ki : Qw.transition !== null ? (hr === 0 && (hr = uv()), hr) : (i = dn, i !== 0 || (i = window.event, i = i === void 0 ? 16 : hv(i.type)), i) : 1;
  }
  function kr(i, a, d, p) {
    if (50 < Al) throw Al = 0, Hd = null, Error(t(185));
    Pu(i, d, p), (!(Nt & 2) || i !== ki) && (i === ki && (!(Nt & 2) && (Vd |= d), ei === 4 && Cs(i, Ki)), na(i, p), d === 1 && Nt === 0 && !(a.mode & 1) && (Ud = En() + 500, Dd && Bs()));
  }
  function na(i, a) {
    var d = i.callbackNode;
    Q1(i, a);
    var p = Au(i, i === ki ? Ki : 0);
    if (p === 0) d !== null && j0(d), i.callbackNode = null, i.callbackPriority = 0;
    else if (a = p & -p, i.callbackPriority !== a) {
      if (d != null && j0(d), a === 1) i.tag === 0 ? bl(X3.bind(null, i)) : Nv(X3.bind(null, i)), xd(function() {
        !(Nt & 6) && Bs();
      }), d = null;
      else {
        switch (K1(p)) {
          case 1:
            d = Du;
            break;
          case 4:
            d = q1;
            break;
          case 16:
            d = wh;
            break;
          case 536870912:
            d = j1;
            break;
          default:
            d = wh;
        }
        d = sS(d, yy.bind(null, i));
      }
      i.callbackPriority = a, i.callbackNode = d;
    }
  }
  function yy(i, a) {
    if (vp = -1, hr = 0, Nt & 6) throw Error(t(327));
    var d = i.callbackNode;
    if (Fd() && i.callbackNode !== d) return null;
    var p = Au(i, i === ki ? Ki : 0);
    if (p === 0) return null;
    if (p & 30 || p & i.expiredLanes || a) a = gy(i, p);
    else {
      a = p;
      var C = Nt;
      Nt |= 2;
      var b = XC();
      (ki !== i || Ki !== a) && (Sa = null, Ud = En() + 500, Mo(i, a));
      do
        try {
          JC();
          break;
        } catch (O) {
          ZC(i, O);
        }
      while (!0);
      L3(), Dl.current = b, Nt = C, hi !== null ? a = 0 : (ki = null, Ki = 0, a = ei);
    }
    if (a !== 0) {
      if (a === 2 && (C = Y1(i), C !== 0 && (p = C, a = yp(i, C))), a === 1) throw d = hp, Mo(i, 0), Cs(i, p), na(i, En()), d;
      if (a === 6) Cs(i, p);
      else {
        if (C = i.current.alternate, !(p & 30) && !Zw(C) && (a = gy(i, p), a === 2 && (b = Y1(i), b !== 0 && (p = b, a = yp(i, b))), a === 1)) throw d = hp, Mo(i, 0), Cs(i, p), na(i, En()), d;
        switch (i.finishedWork = C, i.finishedLanes = p, a) {
          case 0:
          case 1:
            throw Error(t(345));
          case 2:
            lc(i, ta, Sa);
            break;
          case 3:
            if (Cs(i, p), (p & 130023424) === p && (a = Z3 + 500 - En(), 10 < a)) {
              if (Au(i, 0) !== 0) break;
              if (C = i.suspendedLanes, (C & p) !== p) {
                pi(), i.pingedLanes |= i.suspendedLanes & C;
                break;
              }
              i.timeoutHandle = Pv(lc.bind(null, i, ta, Sa), a);
              break;
            }
            lc(i, ta, Sa);
            break;
          case 4:
            if (Cs(i, p), (p & 4194240) === p) break;
            for (a = i.eventTimes, C = -1; 0 < p; ) {
              var R = 31 - Na(p);
              b = 1 << R, R = a[R], R > C && (C = R), p &= ~b;
            }
            if (p = C, p = En() - p, p = (120 > p ? 120 : 480 > p ? 480 : 1080 > p ? 1080 : 1920 > p ? 1920 : 3e3 > p ? 3e3 : 4320 > p ? 4320 : 1960 * Kw(p / 1960)) - p, 10 < p) {
              i.timeoutHandle = Pv(lc.bind(null, i, ta, Sa), p);
              break;
            }
            lc(i, ta, Sa);
            break;
          case 5:
            lc(i, ta, Sa);
            break;
          default:
            throw Error(t(329));
        }
      }
    }
    return na(i, En()), i.callbackNode === d ? yy.bind(null, i) : null;
  }
  function yp(i, a) {
    var d = pp;
    return i.current.memoizedState.isDehydrated && (Mo(i, a).flags |= 256), i = gy(i, a), i !== 2 && (a = ta, ta = d, a !== null && sc(a)), i;
  }
  function sc(i) {
    ta === null ? ta = i : ta.push.apply(ta, i);
  }
  function Zw(i) {
    for (var a = i; ; ) {
      if (a.flags & 16384) {
        var d = a.updateQueue;
        if (d !== null && (d = d.stores, d !== null)) for (var p = 0; p < d.length; p++) {
          var C = d[p], b = C.getSnapshot;
          C = C.value;
          try {
            if (!hs(b(), C)) return !1;
          } catch {
            return !1;
          }
        }
      }
      if (d = a.child, a.subtreeFlags & 16384 && d !== null) d.return = a, a = d;
      else {
        if (a === i) break;
        for (; a.sibling === null; ) {
          if (a.return === null || a.return === i) return !0;
          a = a.return;
        }
        a.sibling.return = a.return, a = a.sibling;
      }
    }
    return !0;
  }
  function Cs(i, a) {
    for (a &= ~my, a &= ~Vd, i.suspendedLanes |= a, i.pingedLanes &= ~a, i = i.expirationTimes; 0 < a; ) {
      var d = 31 - Na(a), p = 1 << d;
      i[d] = -1, a &= ~p;
    }
  }
  function X3(i) {
    if (Nt & 6) throw Error(t(327));
    Fd();
    var a = Au(i, 0);
    if (!(a & 1)) return na(i, En()), null;
    var d = gy(i, a);
    if (i.tag !== 0 && d === 2) {
      var p = Y1(i);
      p !== 0 && (a = p, d = yp(i, p));
    }
    if (d === 1) throw d = hp, Mo(i, 0), Cs(i, a), na(i, En()), d;
    if (d === 6) throw Error(t(345));
    return i.finishedWork = i.current.alternate, i.finishedLanes = a, lc(i, ta, Sa), na(i, En()), null;
  }
  function J3(i, a) {
    var d = Nt;
    Nt |= 1;
    try {
      return i(a);
    } finally {
      Nt = d, Nt === 0 && (Ud = En() + 500, Dd && Bs());
    }
  }
  function oc(i) {
    Do !== null && Do.tag === 0 && !(Nt & 6) && Fd();
    var a = Nt;
    Nt |= 1;
    var d = Wi.transition, p = dn;
    try {
      if (Wi.transition = null, dn = 1, i) return i();
    } finally {
      dn = p, Wi.transition = d, Nt = a, !(Nt & 6) && Bs();
    }
  }
  function e6() {
    Ca = Nd.current, xn(Nd);
  }
  function Mo(i, a) {
    i.finishedWork = null, i.finishedLanes = 0;
    var d = i.timeoutHandle;
    if (d !== -1 && (i.timeoutHandle = -1, T3(d)), hi !== null) for (d = hi.return; d !== null; ) {
      var p = d;
      switch (Uv(p), p.tag) {
        case 1:
          p = p.type.childContextTypes, p != null && $d();
          break;
        case 3:
          Wu(), xn(Ti), xn(Qn), Ie();
          break;
        case 5:
          Iv(p);
          break;
        case 4:
          Wu();
          break;
        case 13:
          xn(zn);
          break;
        case 19:
          xn(zn);
          break;
        case 10:
          $3(p.type._context);
          break;
        case 22:
        case 23:
          e6();
      }
      d = d.return;
    }
    if (ki = i, hi = i = Pl(i.current, null), Ki = Ca = a, ei = 0, hp = null, my = Vd = Ks = 0, ta = pp = null, Qu !== null) {
      for (a = 0; a < Qu.length; a++) if (d = Qu[a], p = d.interleaved, p !== null) {
        d.interleaved = null;
        var C = p.next, b = d.pending;
        if (b !== null) {
          var R = b.next;
          b.next = C, p.next = R;
        }
        d.pending = p;
      }
      Qu = null;
    }
    return i;
  }
  function ZC(i, a) {
    do {
      var d = hi;
      try {
        if (L3(), Tt.current = tc, qv) {
          for (var p = Wt.memoizedState; p !== null; ) {
            var C = p.queue;
            C !== null && (C.pending = null), p = p.next;
          }
          qv = !1;
        }
        if (mn = 0, Oi = ci = Wt = null, Yh = !1, Ku = 0, rc.current = null, d === null || d.return === null) {
          ei = 1, hp = a, hi = null;
          break;
        }
        e: {
          var b = i, R = d.return, O = d, N = a;
          if (a = Ki, O.flags |= 32768, N !== null && typeof N == "object" && typeof N.then == "function") {
            var Y = N, ae = O, oe = ae.tag;
            if (!(ae.mode & 1) && (oe === 0 || oe === 11 || oe === 15)) {
              var re = ae.alternate;
              re ? (ae.updateQueue = re.updateQueue, ae.memoizedState = re.memoizedState, ae.lanes = re.lanes) : (ae.updateQueue = null, ae.memoizedState = null);
            }
            var Te = UC(R);
            if (Te !== null) {
              Te.flags &= -257, $l(Te, R, O, b, a), Te.mode & 1 && I3(b, Y, a), a = Te, N = Y;
              var Ae = a.updateQueue;
              if (Ae === null) {
                var _e = /* @__PURE__ */ new Set();
                _e.add(N), a.updateQueue = _e;
              } else Ae.add(N);
              break e;
            } else {
              if (!(a & 1)) {
                I3(b, Y, a), t6();
                break e;
              }
              N = Error(t(426));
            }
          } else if (Nn && O.mode & 1) {
            var ti = UC(R);
            if (ti !== null) {
              !(ti.flags & 65536) && (ti.flags |= 256), $l(ti, R, O, b, a), xo(nc(N, O));
              break e;
            }
          }
          b = N = nc(N, O), ei !== 4 && (ei = 2), pp === null ? pp = [b] : pp.push(b), b = R;
          do {
            switch (b.tag) {
              case 3:
                b.flags |= 65536, a &= -a, b.lanes |= a;
                var B = VC(b, N, a);
                AC(b, B);
                break e;
              case 1:
                O = N;
                var z = b.type, G = b.stateNode;
                if (!(b.flags & 128) && (typeof z.getDerivedStateFromError == "function" || G !== null && typeof G.componentDidCatch == "function" && (Ml === null || !Ml.has(G)))) {
                  b.flags |= 65536, a &= -a, b.lanes |= a;
                  var de = F3(b, O, a);
                  AC(b, de);
                  break e;
                }
            }
            b = b.return;
          } while (b !== null);
        }
        tS(d);
      } catch (be) {
        a = be, hi === d && d !== null && (hi = d = d.return);
        continue;
      }
      break;
    } while (!0);
  }
  function XC() {
    var i = Dl.current;
    return Dl.current = tc, i === null ? tc : i;
  }
  function t6() {
    (ei === 0 || ei === 3 || ei === 2) && (ei = 4), ki === null || !(Ks & 268435455) && !(Vd & 268435455) || Cs(ki, Ki);
  }
  function gy(i, a) {
    var d = Nt;
    Nt |= 2;
    var p = XC();
    (ki !== i || Ki !== a) && (Sa = null, Mo(i, a));
    do
      try {
        Xw();
        break;
      } catch (C) {
        ZC(i, C);
      }
    while (!0);
    if (L3(), Nt = d, Dl.current = p, hi !== null) throw Error(t(261));
    return ki = null, Ki = 0, ei;
  }
  function Xw() {
    for (; hi !== null; ) eS(hi);
  }
  function JC() {
    for (; hi !== null && !G0(); ) eS(hi);
  }
  function eS(i) {
    var a = aS(i.alternate, i, Ca);
    i.memoizedProps = i.pendingProps, a === null ? tS(i) : hi = a, rc.current = null;
  }
  function tS(i) {
    var a = i;
    do {
      var d = a.alternate;
      if (i = a.return, a.flags & 32768) {
        if (d = fy(d, a), d !== null) {
          d.flags &= 32767, hi = d;
          return;
        }
        if (i !== null) i.flags |= 32768, i.subtreeFlags = 0, i.deletions = null;
        else {
          ei = 6, hi = null;
          return;
        }
      } else if (d = jC(d, a, Ca), d !== null) {
        hi = d;
        return;
      }
      if (a = a.sibling, a !== null) {
        hi = a;
        return;
      }
      hi = a = i;
    } while (a !== null);
    ei === 0 && (ei = 5);
  }
  function lc(i, a, d) {
    var p = dn, C = Wi.transition;
    try {
      Wi.transition = null, dn = 1, Jw(i, a, d, p);
    } finally {
      Wi.transition = C, dn = p;
    }
    return null;
  }
  function Jw(i, a, d, p) {
    do
      Fd();
    while (Do !== null);
    if (Nt & 6) throw Error(t(327));
    d = i.finishedWork;
    var C = i.finishedLanes;
    if (d === null) return null;
    if (i.finishedWork = null, i.finishedLanes = 0, d === i.current) throw Error(t(177));
    i.callbackNode = null, i.callbackPriority = 0;
    var b = d.lanes | d.childLanes;
    if (Lw(i, b), i === ki && (hi = ki = null, Ki = 0), !(d.subtreeFlags & 2064) && !(d.flags & 2064) || vy || (vy = !0, sS(wh, function() {
      return Fd(), null;
    })), b = (d.flags & 15990) !== 0, d.subtreeFlags & 15990 || b) {
      b = Wi.transition, Wi.transition = null;
      var R = dn;
      dn = 1;
      var O = Nt;
      Nt |= 4, rc.current = null, QC(i, d), Y3(d, i), wd(Iu), _u = !!Uh, Iu = Uh = null, i.current = d, Ww(d), Ew(), Nt = O, dn = R, Wi.transition = b;
    } else i.current = d;
    if (vy && (vy = !1, Do = i, mp = C), b = i.pendingLanes, b === 0 && (Ml = null), Y0(d.stateNode), na(i, En()), a !== null) for (p = i.onRecoverableError, d = 0; d < a.length; d++) C = a[d], p(C.value, { componentStack: C.stack, digest: C.digest });
    if (zd) throw zd = !1, i = ac, ac = null, i;
    return mp & 1 && i.tag !== 0 && Fd(), b = i.pendingLanes, b & 1 ? i === Hd ? Al++ : (Al = 0, Hd = i) : Al = 0, Bs(), null;
  }
  function Fd() {
    if (Do !== null) {
      var i = K1(mp), a = Wi.transition, d = dn;
      try {
        if (Wi.transition = null, dn = 16 > i ? 16 : i, Do === null) var p = !1;
        else {
          if (i = Do, Do = null, mp = 0, Nt & 6) throw Error(t(331));
          var C = Nt;
          for (Nt |= 4, Re = i.current; Re !== null; ) {
            var b = Re, R = b.child;
            if (Re.flags & 16) {
              var O = b.deletions;
              if (O !== null) {
                for (var N = 0; N < O.length; N++) {
                  var Y = O[N];
                  for (Re = Y; Re !== null; ) {
                    var ae = Re;
                    switch (ae.tag) {
                      case 0:
                      case 11:
                      case 15:
                        up(8, ae, b);
                    }
                    var oe = ae.child;
                    if (oe !== null) oe.return = ae, Re = oe;
                    else for (; Re !== null; ) {
                      ae = Re;
                      var re = ae.sibling, Te = ae.return;
                      if (py(ae), ae === Y) {
                        Re = null;
                        break;
                      }
                      if (re !== null) {
                        re.return = Te, Re = re;
                        break;
                      }
                      Re = Te;
                    }
                  }
                }
                var Ae = b.alternate;
                if (Ae !== null) {
                  var _e = Ae.child;
                  if (_e !== null) {
                    Ae.child = null;
                    do {
                      var ti = _e.sibling;
                      _e.sibling = null, _e = ti;
                    } while (_e !== null);
                  }
                }
                Re = b;
              }
            }
            if (b.subtreeFlags & 2064 && R !== null) R.return = b, Re = R;
            else e: for (; Re !== null; ) {
              if (b = Re, b.flags & 2048) switch (b.tag) {
                case 0:
                case 11:
                case 15:
                  up(9, b, b.return);
              }
              var B = b.sibling;
              if (B !== null) {
                B.return = b.return, Re = B;
                break e;
              }
              Re = b.return;
            }
          }
          var z = i.current;
          for (Re = z; Re !== null; ) {
            R = Re;
            var G = R.child;
            if (R.subtreeFlags & 2064 && G !== null) G.return = R, Re = G;
            else e: for (R = z; Re !== null; ) {
              if (O = Re, O.flags & 2048) try {
                switch (O.tag) {
                  case 0:
                  case 11:
                  case 15:
                    cp(9, O);
                }
              } catch (be) {
                Vn(O, O.return, be);
              }
              if (O === R) {
                Re = null;
                break e;
              }
              var de = O.sibling;
              if (de !== null) {
                de.return = O.return, Re = de;
                break e;
              }
              Re = O.return;
            }
          }
          if (Nt = C, Bs(), ds && typeof ds.onPostCommitFiberRoot == "function") try {
            ds.onPostCommitFiberRoot(Th, i);
          } catch {
          }
          p = !0;
        }
        return p;
      } finally {
        dn = d, Wi.transition = a;
      }
    }
    return !1;
  }
  function nS(i, a, d) {
    a = nc(d, a), a = VC(i, a, 1), i = xl(i, a, 1), a = pi(), i !== null && (Pu(i, 1, a), na(i, a));
  }
  function Vn(i, a, d) {
    if (i.tag === 3) nS(i, i, d);
    else for (; a !== null; ) {
      if (a.tag === 3) {
        nS(a, i, d);
        break;
      } else if (a.tag === 1) {
        var p = a.stateNode;
        if (typeof a.type.getDerivedStateFromError == "function" || typeof p.componentDidCatch == "function" && (Ml === null || !Ml.has(p))) {
          i = nc(d, i), i = F3(a, i, 1), a = xl(a, i, 1), i = pi(), a !== null && (Pu(a, 1, i), na(a, i));
          break;
        }
      }
      a = a.return;
    }
  }
  function eT(i, a, d) {
    var p = i.pingCache;
    p !== null && p.delete(a), a = pi(), i.pingedLanes |= i.suspendedLanes & d, ki === i && (Ki & d) === d && (ei === 4 || ei === 3 && (Ki & 130023424) === Ki && 500 > En() - Z3 ? Mo(i, 0) : my |= d), na(i, a);
  }
  function iS(i, a) {
    a === 0 && (i.mode & 1 ? (a = fs, fs <<= 1, !(fs & 130023424) && (fs = 4194304)) : a = 1);
    var d = pi();
    i = va(i, a), i !== null && (Pu(i, a, d), na(i, d));
  }
  function tT(i) {
    var a = i.memoizedState, d = 0;
    a !== null && (d = a.retryLane), iS(i, d);
  }
  function rS(i, a) {
    var d = 0;
    switch (i.tag) {
      case 13:
        var p = i.stateNode, C = i.memoizedState;
        C !== null && (d = C.retryLane);
        break;
      case 19:
        p = i.stateNode;
        break;
      default:
        throw Error(t(314));
    }
    p !== null && p.delete(a), iS(i, d);
  }
  var aS;
  aS = function(i, a, d) {
    if (i !== null) if (i.memoizedProps !== a.pendingProps || Ti.current) di = !0;
    else {
      if (!(i.lanes & d) && !(a.flags & 128)) return di = !1, sp(i, a, d);
      di = !!(i.flags & 131072);
    }
    else di = !1, Nn && a.flags & 1048576 && LC(a, ko, a.index);
    switch (a.lanes = 0, a.tag) {
      case 2:
        var p = a.type;
        ja(i, a), i = a.pendingProps;
        var C = Fa(a, Qn.current);
        Un(a, d), C = Rl(null, a, p, i, C, d);
        var b = vs();
        return a.flags |= 1, typeof C == "object" && C !== null && typeof C.render == "function" && C.$$typeof === void 0 ? (a.tag = 1, a.memoizedState = null, a.updateQueue = null, li(p) ? (b = !0, Wr(a)) : b = !1, a.memoizedState = C.state !== null && C.state !== void 0 ? C.state : null, P3(a), C.updater = oy, a.stateNode = C, C._reactInternals = a, tp(a, p, i, d), a = rp(null, a, p, !0, b, d)) : (a.tag = 0, Nn && b && Vv(a), Yi(null, a, C, d), a = a.child), a;
      case 16:
        p = a.elementType;
        e: {
          switch (ja(i, a), i = a.pendingProps, C = p._init, p = C(p._payload), a.type = p, C = a.tag = iT(p), i = ys(p, i), C) {
            case 0:
              a = zC(null, a, p, i, d);
              break e;
            case 1:
              a = HC(null, a, p, i, d);
              break e;
            case 11:
              a = Jr(null, a, p, i, d);
              break e;
            case 14:
              a = ic(null, a, p, ys(p.type, i), d);
              break e;
          }
          throw Error(t(
            306,
            p,
            ""
          ));
        }
        return a;
      case 0:
        return p = a.type, C = a.pendingProps, C = a.elementType === p ? C : ys(p, C), zC(i, a, p, C, d);
      case 1:
        return p = a.type, C = a.pendingProps, C = a.elementType === p ? C : ys(p, C), HC(i, a, p, C, d);
      case 3:
        e: {
          if (Od(a), i === null) throw Error(t(387));
          p = a.pendingProps, b = a.memoizedState, C = b.element, MC(i, a), Bh(a, p, null, d);
          var R = a.memoizedState;
          if (p = R.element, b.isDehydrated) if (b = { element: p, isDehydrated: !1, cache: R.cache, pendingSuspenseBoundaries: R.pendingSuspenseBoundaries, transitions: R.transitions }, a.updateQueue.baseState = b, a.memoizedState = b, a.flags & 256) {
            C = nc(Error(t(423)), a), a = FC(i, a, p, d, C);
            break e;
          } else if (p !== C) {
            C = nc(Error(t(424)), a), a = FC(i, a, p, d, C);
            break e;
          } else for (Zr = Hs(a.stateNode.containerInfo.firstChild), Kr = a, Nn = !0, Ba = null, d = ge(a, null, p, d), a.child = d; d; ) d.flags = d.flags & -3 | 4096, d = d.sibling;
          else {
            if (kl(), p === C) {
              a = Ga(i, a, d);
              break e;
            }
            Yi(i, a, p, d);
          }
          a = a.child;
        }
        return a;
      case 5:
        return PC(a), i === null && x3(a), p = a.type, C = a.pendingProps, b = i !== null ? i.memoizedProps : null, R = C.children, Av(p, C) ? R = null : b !== null && Av(p, b) && (a.flags |= 32), B3(i, a), Yi(i, a, R, d), a.child;
      case 6:
        return i === null && x3(a), null;
      case 13:
        return dy(i, a, d);
      case 4:
        return _3(a, a.stateNode.containerInfo), p = a.pendingProps, i === null ? a.child = Zn(a, null, p, d) : Yi(i, a, p, d), a.child;
      case 11:
        return p = a.type, C = a.pendingProps, C = a.elementType === p ? C : ys(p, C), Jr(i, a, p, C, d);
      case 7:
        return Yi(i, a, a.pendingProps, d), a.child;
      case 8:
        return Yi(i, a, a.pendingProps.children, d), a.child;
      case 12:
        return Yi(i, a, a.pendingProps.children, d), a.child;
      case 10:
        e: {
          if (p = a.type._context, C = a.pendingProps, b = a.memoizedProps, R = C.value, He(ma, p._currentValue), p._currentValue = R, b !== null) if (hs(b.value, R)) {
            if (b.children === C.children && !Ti.current) {
              a = Ga(i, a, d);
              break e;
            }
          } else for (b = a.child, b !== null && (b.return = a); b !== null; ) {
            var O = b.dependencies;
            if (O !== null) {
              R = b.child;
              for (var N = O.firstContext; N !== null; ) {
                if (N.context === p) {
                  if (b.tag === 1) {
                    N = Ro(-1, d & -d), N.tag = 2;
                    var Y = b.updateQueue;
                    if (Y !== null) {
                      Y = Y.shared;
                      var ae = Y.pending;
                      ae === null ? N.next = N : (N.next = ae.next, ae.next = N), Y.pending = N;
                    }
                  }
                  b.lanes |= d, N = b.alternate, N !== null && (N.lanes |= d), D3(
                    b.return,
                    d,
                    a
                  ), O.lanes |= d;
                  break;
                }
                N = N.next;
              }
            } else if (b.tag === 10) R = b.type === a.type ? null : b.child;
            else if (b.tag === 18) {
              if (R = b.return, R === null) throw Error(t(341));
              R.lanes |= d, O = R.alternate, O !== null && (O.lanes |= d), D3(R, d, a), R = b.sibling;
            } else R = b.child;
            if (R !== null) R.return = b;
            else for (R = b; R !== null; ) {
              if (R === a) {
                R = null;
                break;
              }
              if (b = R.sibling, b !== null) {
                b.return = R.return, R = b;
                break;
              }
              R = R.return;
            }
            b = R;
          }
          Yi(i, a, C.children, d), a = a.child;
        }
        return a;
      case 9:
        return C = a.type, p = a.pendingProps.children, Un(a, d), C = qa(C), p = p(C), a.flags |= 1, Yi(i, a, p, d), a.child;
      case 14:
        return p = a.type, C = ys(p, a.pendingProps), C = ys(p.type, C), ic(i, a, p, C, d);
      case 15:
        return yt(i, a, a.type, a.pendingProps, d);
      case 17:
        return p = a.type, C = a.pendingProps, C = a.elementType === p ? C : ys(p, C), ja(i, a), a.tag = 1, li(p) ? (i = !0, Wr(a)) : i = !1, Un(a, d), ly(a, p, C), tp(a, p, C, d), rp(null, a, p, !0, i, d);
      case 19:
        return Qs(i, a, d);
      case 22:
        return ip(i, a, d);
    }
    throw Error(t(156, a.tag));
  };
  function sS(i, a) {
    return q0(i, a);
  }
  function nT(i, a, d, p) {
    this.tag = i, this.key = d, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = a, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = p, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function Ya(i, a, d, p) {
    return new nT(i, a, d, p);
  }
  function n6(i) {
    return i = i.prototype, !(!i || !i.isReactComponent);
  }
  function iT(i) {
    if (typeof i == "function") return n6(i) ? 1 : 0;
    if (i != null) {
      if (i = i.$$typeof, i === Lt) return 11;
      if (i === wn) return 14;
    }
    return 2;
  }
  function Pl(i, a) {
    var d = i.alternate;
    return d === null ? (d = Ya(i.tag, a, i.key, i.mode), d.elementType = i.elementType, d.type = i.type, d.stateNode = i.stateNode, d.alternate = i, i.alternate = d) : (d.pendingProps = a, d.type = i.type, d.flags = 0, d.subtreeFlags = 0, d.deletions = null), d.flags = i.flags & 14680064, d.childLanes = i.childLanes, d.lanes = i.lanes, d.child = i.child, d.memoizedProps = i.memoizedProps, d.memoizedState = i.memoizedState, d.updateQueue = i.updateQueue, a = i.dependencies, d.dependencies = a === null ? null : { lanes: a.lanes, firstContext: a.firstContext }, d.sibling = i.sibling, d.index = i.index, d.ref = i.ref, d;
  }
  function gp(i, a, d, p, C, b) {
    var R = 2;
    if (p = i, typeof i == "function") n6(i) && (R = 1);
    else if (typeof i == "string") R = 5;
    else e: switch (i) {
      case Ge:
        return Ao(d.children, C, b, a);
      case he:
        R = 8, C |= 8;
        break;
      case Ze:
        return i = Ya(12, d, a, C | 2), i.elementType = Ze, i.lanes = b, i;
      case Ve:
        return i = Ya(13, d, a, C), i.elementType = Ve, i.lanes = b, i;
      case mt:
        return i = Ya(19, d, a, C), i.elementType = mt, i.lanes = b, i;
      case rt:
        return Ol(d, C, b, a);
      default:
        if (typeof i == "object" && i !== null) switch (i.$$typeof) {
          case pt:
            R = 10;
            break e;
          case Gt:
            R = 9;
            break e;
          case Lt:
            R = 11;
            break e;
          case wn:
            R = 14;
            break e;
          case Ye:
            R = 16, p = null;
            break e;
        }
        throw Error(t(130, i == null ? i : typeof i, ""));
    }
    return a = Ya(R, d, a, C), a.elementType = i, a.type = p, a.lanes = b, a;
  }
  function Ao(i, a, d, p) {
    return i = Ya(7, i, p, a), i.lanes = d, i;
  }
  function Ol(i, a, d, p) {
    return i = Ya(22, i, p, a), i.elementType = rt, i.lanes = d, i.stateNode = { isHidden: !1 }, i;
  }
  function i6(i, a, d) {
    return i = Ya(6, i, null, a), i.lanes = d, i;
  }
  function Cy(i, a, d) {
    return a = Ya(4, i.children !== null ? i.children : [], i.key, a), a.lanes = d, a.stateNode = { containerInfo: i.containerInfo, pendingChildren: null, implementation: i.implementation }, a;
  }
  function oS(i, a, d, p, C) {
    this.tag = a, this.containerInfo = i, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = W1(0), this.expirationTimes = W1(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = W1(0), this.identifierPrefix = p, this.onRecoverableError = C, this.mutableSourceEagerHydrationData = null;
  }
  function Sy(i, a, d, p, C, b, R, O, N) {
    return i = new oS(i, a, d, O, N), a === 1 ? (a = 1, b === !0 && (a |= 8)) : a = 0, b = Ya(3, null, null, a), i.current = b, b.stateNode = i, b.memoizedState = { element: p, isDehydrated: d, cache: null, transitions: null, pendingSuspenseBoundaries: null }, P3(b), i;
  }
  function rT(i, a, d) {
    var p = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: Ct, key: p == null ? null : "" + p, children: i, containerInfo: a, implementation: d };
  }
  function r6(i) {
    if (!i) return Qr;
    i = i._reactInternals;
    e: {
      if (cs(i) !== i || i.tag !== 1) throw Error(t(170));
      var a = i;
      do {
        switch (a.tag) {
          case 3:
            a = a.stateNode.context;
            break e;
          case 1:
            if (li(a.type)) {
              a = a.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        a = a.return;
      } while (a !== null);
      throw Error(t(171));
    }
    if (i.tag === 1) {
      var d = i.type;
      if (li(d)) return Fh(i, d, a);
    }
    return a;
  }
  function lS(i, a, d, p, C, b, R, O, N) {
    return i = Sy(d, p, !0, i, C, b, R, O, N), i.context = r6(null), d = i.current, p = pi(), C = Zs(d), b = Ro(p, C), b.callback = a ?? null, xl(d, b, C), i.current.lanes = C, Pu(i, C, p), na(i, p), i;
  }
  function by(i, a, d, p) {
    var C = a.current, b = pi(), R = Zs(C);
    return d = r6(d), a.context === null ? a.context = d : a.pendingContext = d, a = Ro(b, R), a.payload = { element: i }, p = p === void 0 ? null : p, p !== null && (a.callback = p), i = xl(C, a, R), i !== null && (kr(i, C, R, b), Fv(i, C, R)), R;
  }
  function wy(i) {
    if (i = i.current, !i.child) return null;
    switch (i.child.tag) {
      case 5:
        return i.child.stateNode;
      default:
        return i.child.stateNode;
    }
  }
  function a6(i, a) {
    if (i = i.memoizedState, i !== null && i.dehydrated !== null) {
      var d = i.retryLane;
      i.retryLane = d !== 0 && d < a ? d : a;
    }
  }
  function Ty(i, a) {
    a6(i, a), (i = i.alternate) && a6(i, a);
  }
  var s6 = typeof reportError == "function" ? reportError : function(i) {
    console.error(i);
  };
  function _l(i) {
    this._internalRoot = i;
  }
  Ey.prototype.render = _l.prototype.render = function(i) {
    var a = this._internalRoot;
    if (a === null) throw Error(t(409));
    by(i, a, null, null);
  }, Ey.prototype.unmount = _l.prototype.unmount = function() {
    var i = this._internalRoot;
    if (i !== null) {
      this._internalRoot = null;
      var a = i.containerInfo;
      oc(function() {
        by(null, i, null, null);
      }), a[To] = null;
    }
  };
  function Ey(i) {
    this._internalRoot = i;
  }
  Ey.prototype.unstable_scheduleHydration = function(i) {
    if (i) {
      var a = vt();
      i = { blockedOn: null, target: i, priority: a };
      for (var d = 0; d < ji.length && a !== 0 && a < ji[d].priority; d++) ;
      ji.splice(d, 0, i), d === 0 && t3(i);
    }
  };
  function o6(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11);
  }
  function ky(i) {
    return !(!i || i.nodeType !== 1 && i.nodeType !== 9 && i.nodeType !== 11 && (i.nodeType !== 8 || i.nodeValue !== " react-mount-point-unstable "));
  }
  function uS() {
  }
  function aT(i, a, d, p, C) {
    if (C) {
      if (typeof p == "function") {
        var b = p;
        p = function() {
          var Y = wy(R);
          b.call(Y);
        };
      }
      var R = lS(a, p, i, 0, null, !1, !1, "", uS);
      return i._reactRootContainer = R, i[To] = R.current, Ed(i.nodeType === 8 ? i.parentNode : i), oc(), R;
    }
    for (; C = i.lastChild; ) i.removeChild(C);
    if (typeof p == "function") {
      var O = p;
      p = function() {
        var Y = wy(N);
        O.call(Y);
      };
    }
    var N = Sy(i, 0, !1, null, null, !1, !1, "", uS);
    return i._reactRootContainer = N, i[To] = N.current, Ed(i.nodeType === 8 ? i.parentNode : i), oc(function() {
      by(a, N, d, p);
    }), N;
  }
  function xy(i, a, d, p, C) {
    var b = d._reactRootContainer;
    if (b) {
      var R = b;
      if (typeof C == "function") {
        var O = C;
        C = function() {
          var N = wy(R);
          O.call(N);
        };
      }
      by(a, R, i, C);
    } else R = aT(d, a, i, C, p);
    return wy(R);
  }
  fn = function(i) {
    switch (i.tag) {
      case 3:
        var a = i.stateNode;
        if (a.current.memoizedState.isDehydrated) {
          var d = Mu(a.pendingLanes);
          d !== 0 && (cv(a, d | 1), na(a, En()), !(Nt & 6) && (Ud = En() + 500, Bs()));
        }
        break;
      case 13:
        oc(function() {
          var p = va(i, 1);
          if (p !== null) {
            var C = pi();
            kr(p, i, 1, C);
          }
        }), Ty(i, 1);
    }
  }, Z1 = function(i) {
    if (i.tag === 13) {
      var a = va(i, 134217728);
      if (a !== null) {
        var d = pi();
        kr(a, i, 134217728, d);
      }
      Ty(i, 134217728);
    }
  }, X1 = function(i) {
    if (i.tag === 13) {
      var a = Zs(i), d = va(i, a);
      if (d !== null) {
        var p = pi();
        kr(d, i, a, p);
      }
      Ty(i, a);
    }
  }, vt = function() {
    return dn;
  }, J1 = function(i, a) {
    var d = dn;
    try {
      return dn = i, a();
    } finally {
      dn = d;
    }
  }, wi = function(i, a, d) {
    switch (a) {
      case "input":
        if (ud(i, d), a = d.name, d.type === "radio" && a != null) {
          for (d = i; d.parentNode; ) d = d.parentNode;
          for (d = d.querySelectorAll("input[name=" + JSON.stringify("" + a) + '][type="radio"]'), a = 0; a < d.length; a++) {
            var p = d[a];
            if (p !== i && p.form === i.form) {
              var C = Kn(p);
              if (!C) throw Error(t(90));
              Cr(p), ud(p, C);
            }
          }
        }
        break;
      case "textarea":
        cd(i, d);
        break;
      case "select":
        a = d.value, a != null && fa(i, !!d.multiple, a, !1);
    }
  }, z1 = J3, H1 = oc;
  var cS = { usingClientEntryPoint: !1, Events: [Fe, ps, Kn, H0, F0, J3] }, Cp = { findFiberByHostInstance: Bu, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, sT = { bundleType: Cp.bundleType, version: Cp.version, rendererPackageName: Cp.rendererPackageName, rendererConfig: Cp.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: je.ReactCurrentDispatcher, findHostInstanceByFiber: function(i) {
    return i = B1(i), i === null ? null : i.stateNode;
  }, findFiberByHostInstance: Cp.findFiberByHostInstance, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Sp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Sp.isDisabled && Sp.supportsFiber) try {
      Th = Sp.inject(sT), ds = Sp;
    } catch {
    }
  }
  return es.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = cS, es.createPortal = function(i, a) {
    var d = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!o6(a)) throw Error(t(200));
    return rT(i, a, null, d);
  }, es.createRoot = function(i, a) {
    if (!o6(i)) throw Error(t(299));
    var d = !1, p = "", C = s6;
    return a != null && (a.unstable_strictMode === !0 && (d = !0), a.identifierPrefix !== void 0 && (p = a.identifierPrefix), a.onRecoverableError !== void 0 && (C = a.onRecoverableError)), a = Sy(i, 1, !1, null, null, d, !1, p, C), i[To] = a.current, Ed(i.nodeType === 8 ? i.parentNode : i), new _l(a);
  }, es.findDOMNode = function(i) {
    if (i == null) return null;
    if (i.nodeType === 1) return i;
    var a = i._reactInternals;
    if (a === void 0)
      throw typeof i.render == "function" ? Error(t(188)) : (i = Object.keys(i).join(","), Error(t(268, i)));
    return i = B1(a), i = i === null ? null : i.stateNode, i;
  }, es.flushSync = function(i) {
    return oc(i);
  }, es.hydrate = function(i, a, d) {
    if (!ky(a)) throw Error(t(200));
    return xy(null, i, a, !0, d);
  }, es.hydrateRoot = function(i, a, d) {
    if (!o6(i)) throw Error(t(405));
    var p = d != null && d.hydratedSources || null, C = !1, b = "", R = s6;
    if (d != null && (d.unstable_strictMode === !0 && (C = !0), d.identifierPrefix !== void 0 && (b = d.identifierPrefix), d.onRecoverableError !== void 0 && (R = d.onRecoverableError)), a = lS(a, null, i, 1, d ?? null, C, !1, b, R), i[To] = a.current, Ed(i), p) for (i = 0; i < p.length; i++) d = p[i], C = d._getVersion, C = C(d._source), a.mutableSourceEagerHydrationData == null ? a.mutableSourceEagerHydrationData = [d, C] : a.mutableSourceEagerHydrationData.push(
      d,
      C
    );
    return new Ey(a);
  }, es.render = function(i, a, d) {
    if (!ky(a)) throw Error(t(200));
    return xy(null, i, a, !1, d);
  }, es.unmountComponentAtNode = function(i) {
    if (!ky(i)) throw Error(t(40));
    return i._reactRootContainer ? (oc(function() {
      xy(null, null, i, !1, function() {
        i._reactRootContainer = null, i[To] = null;
      });
    }), !0) : !1;
  }, es.unstable_batchedUpdates = J3, es.unstable_renderSubtreeIntoContainer = function(i, a, d, p) {
    if (!ky(d)) throw Error(t(200));
    if (i == null || i._reactInternals === void 0) throw Error(t(38));
    return xy(i, a, d, !1, p);
  }, es.version = "18.3.1-next-f1338f8080-20240426", es;
}
var ts = {};
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AD;
function kX() {
  return AD || (AD = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var c = QD, s = hz(), t = c.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, r = !1;
    function f(e) {
      r = e;
    }
    function v(e) {
      if (!r) {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), u = 1; u < n; u++)
          o[u - 1] = arguments[u];
        T("warn", e, o);
      }
    }
    function g(e) {
      if (!r) {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), u = 1; u < n; u++)
          o[u - 1] = arguments[u];
        T("error", e, o);
      }
    }
    function T(e, n, o) {
      {
        var u = t.ReactDebugCurrentFrame, h = u.getStackAddendum();
        h !== "" && (n += "%s", o = o.concat([h]));
        var y = o.map(function(S) {
          return String(S);
        });
        y.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, y);
      }
    }
    var x = 0, $ = 1, P = 2, A = 3, U = 4, F = 5, Z = 6, ne = 7, ce = 8, De = 9, Ne = 10, Se = 11, je = 12, Me = 13, Ct = 14, Ge = 15, he = 16, Ze = 17, pt = 18, Gt = 19, Lt = 21, Ve = 22, mt = 23, wn = 24, Ye = 25, rt = !0, se = !1, Le = !1, me = !1, At = !1, Qt = !0, ur = !0, ri = !0, Oa = !0, Ci = /* @__PURE__ */ new Set(), Si = {}, Ii = {};
    function bi(e, n) {
      Bi(e, n), Bi(e + "Capture", n);
    }
    function Bi(e, n) {
      Si[e] && g("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", e), Si[e] = n;
      {
        var o = e.toLowerCase();
        Ii[o] = e, e === "onDoubleClick" && (Ii.ondblclick = e);
      }
      for (var u = 0; u < n.length; u++)
        Ci.add(n[u]);
    }
    var Wn = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", Cr = Object.prototype.hasOwnProperty;
    function Pi(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, o = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return o;
      }
    }
    function qi(e) {
      try {
        return Sr(e), !1;
      } catch {
        return !0;
      }
    }
    function Sr(e) {
      return "" + e;
    }
    function da(e, n) {
      if (qi(e))
        return g("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", n, Pi(e)), Sr(e);
    }
    function ud(e) {
      if (qi(e))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pi(e)), Sr(e);
    }
    function gh(e, n) {
      if (qi(e))
        return g("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", n, Pi(e)), Sr(e);
    }
    function Ch(e, n) {
      if (qi(e))
        return g("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", n, Pi(e)), Sr(e);
    }
    function ku(e) {
      if (qi(e))
        return g("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", Pi(e)), Sr(e);
    }
    function fa(e) {
      if (qi(e))
        return g("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", Pi(e)), Sr(e);
    }
    var _a = 0, ls = 1, cd = 2, ha = 3, Us = 4, xu = 5, Ru = 6, Sh = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ye = Sh + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", We = new RegExp("^[" + Sh + "][" + ye + "]*$"), $t = {}, Tn = {};
    function qn(e) {
      return Cr.call(Tn, e) ? !0 : Cr.call($t, e) ? !1 : We.test(e) ? (Tn[e] = !0, !0) : ($t[e] = !0, g("Invalid attribute name: `%s`", e), !1);
    }
    function Br(e, n, o) {
      return n !== null ? n.type === _a : o ? !1 : e.length > 2 && (e[0] === "o" || e[0] === "O") && (e[1] === "n" || e[1] === "N");
    }
    function ai(e, n, o, u) {
      if (o !== null && o.type === _a)
        return !1;
      switch (typeof n) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (u)
            return !1;
          if (o !== null)
            return !o.acceptsBooleans;
          var h = e.toLowerCase().slice(0, 5);
          return h !== "data-" && h !== "aria-";
        }
        default:
          return !1;
      }
    }
    function qr(e, n, o, u) {
      if (n === null || typeof n > "u" || ai(e, n, o, u))
        return !0;
      if (u)
        return !1;
      if (o !== null)
        switch (o.type) {
          case ha:
            return !n;
          case Us:
            return n === !1;
          case xu:
            return isNaN(n);
          case Ru:
            return isNaN(n) || n < 1;
        }
      return !1;
    }
    function si(e) {
      return wi.hasOwnProperty(e) ? wi[e] : null;
    }
    function jn(e, n, o, u, h, y, S) {
      this.acceptsBooleans = n === cd || n === ha || n === Us, this.attributeName = u, this.attributeNamespace = h, this.mustUseProperty = o, this.propertyName = e, this.type = n, this.sanitizeURL = y, this.removeEmptyString = S;
    }
    var wi = {}, dd = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    dd.forEach(function(e) {
      wi[e] = new jn(
        e,
        _a,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
      var n = e[0], o = e[1];
      wi[n] = new jn(
        n,
        ls,
        !1,
        // mustUseProperty
        o,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
      wi[e] = new jn(
        e,
        cd,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
      wi[e] = new jn(
        e,
        cd,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(e) {
      wi[e] = new jn(
        e,
        ha,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      wi[e] = new jn(
        e,
        ha,
        !0,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      wi[e] = new jn(
        e,
        Us,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      wi[e] = new jn(
        e,
        Ru,
        !1,
        // mustUseProperty
        e,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(e) {
      wi[e] = new jn(
        e,
        xu,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var fl = /[\-\:]([a-z])/g, sv = function(e) {
      return e[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var n = e.replace(fl, sv);
      wi[n] = new jn(
        n,
        ls,
        !1,
        // mustUseProperty
        e,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var n = e.replace(fl, sv);
      wi[n] = new jn(
        n,
        ls,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(e) {
      var n = e.replace(fl, sv);
      wi[n] = new jn(
        n,
        ls,
        !1,
        // mustUseProperty
        e,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(e) {
      wi[e] = new jn(
        e,
        ls,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var H0 = "xlinkHref";
    wi[H0] = new jn(
      "xlinkHref",
      ls,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(e) {
      wi[e] = new jn(
        e,
        ls,
        !1,
        // mustUseProperty
        e.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var F0 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, z1 = !1;
    function H1(e) {
      !z1 && F0.test(e) && (z1 = !0, g("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(e)));
    }
    function F1(e, n, o, u) {
      if (u.mustUseProperty) {
        var h = u.propertyName;
        return e[h];
      } else {
        da(o, n), u.sanitizeURL && H1("" + o);
        var y = u.attributeName, S = null;
        if (u.type === Us) {
          if (e.hasAttribute(y)) {
            var w = e.getAttribute(y);
            return w === "" ? !0 : qr(n, o, u, !1) ? w : w === "" + o ? o : w;
          }
        } else if (e.hasAttribute(y)) {
          if (qr(n, o, u, !1))
            return e.getAttribute(y);
          if (u.type === ha)
            return o;
          S = e.getAttribute(y);
        }
        return qr(n, o, u, !1) ? S === null ? o : S : S === "" + o ? o : S;
      }
    }
    function I1(e, n, o, u) {
      {
        if (!qn(n))
          return;
        if (!e.hasAttribute(n))
          return o === void 0 ? void 0 : null;
        var h = e.getAttribute(n);
        return da(o, n), h === "" + o ? o : h;
      }
    }
    function Lu(e, n, o, u) {
      var h = si(n);
      if (!Br(n, h, u)) {
        if (qr(n, o, h, u) && (o = null), u || h === null) {
          if (qn(n)) {
            var y = n;
            o === null ? e.removeAttribute(y) : (da(o, n), e.setAttribute(y, "" + o));
          }
          return;
        }
        var S = h.mustUseProperty;
        if (S) {
          var w = h.propertyName;
          if (o === null) {
            var E = h.type;
            e[w] = E === ha ? !1 : "";
          } else
            e[w] = o;
          return;
        }
        var D = h.attributeName, M = h.attributeNamespace;
        if (o === null)
          e.removeAttribute(D);
        else {
          var H = h.type, V;
          H === ha || H === Us && o === !0 ? V = "" : (da(o, D), V = "" + o, h.sanitizeURL && H1(V.toString())), M ? e.setAttributeNS(M, D, V) : e.setAttribute(D, V);
        }
      }
    }
    var hl = Symbol.for("react.element"), us = Symbol.for("react.portal"), fd = Symbol.for("react.fragment"), $u = Symbol.for("react.strict_mode"), hd = Symbol.for("react.profiler"), pd = Symbol.for("react.provider"), bh = Symbol.for("react.context"), md = Symbol.for("react.forward_ref"), ov = Symbol.for("react.suspense"), lv = Symbol.for("react.suspense_list"), cs = Symbol.for("react.memo"), cr = Symbol.for("react.lazy"), I0 = Symbol.for("react.scope"), Tw = Symbol.for("react.debug_trace_mode"), B1 = Symbol.for("react.offscreen"), B0 = Symbol.for("react.legacy_hidden"), q0 = Symbol.for("react.cache"), j0 = Symbol.for("react.tracing_marker"), G0 = Symbol.iterator, Ew = "@@iterator";
    function En(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = G0 && e[G0] || e[Ew];
      return typeof n == "function" ? n : null;
    }
    var Pt = Object.assign, Du = 0, q1, wh, Q0, j1, Th, ds, Y0;
    function Na() {
    }
    Na.__reactDisabledLog = !0;
    function kw() {
      {
        if (Du === 0) {
          q1 = console.log, wh = console.info, Q0 = console.warn, j1 = console.error, Th = console.group, ds = console.groupCollapsed, Y0 = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Na,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        Du++;
      }
    }
    function xw() {
      {
        if (Du--, Du === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Pt({}, e, {
              value: q1
            }),
            info: Pt({}, e, {
              value: wh
            }),
            warn: Pt({}, e, {
              value: Q0
            }),
            error: Pt({}, e, {
              value: j1
            }),
            group: Pt({}, e, {
              value: Th
            }),
            groupCollapsed: Pt({}, e, {
              value: ds
            }),
            groupEnd: Pt({}, e, {
              value: Y0
            })
          });
        }
        Du < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var G1 = t.ReactCurrentDispatcher, vd;
    function fs(e, n, o) {
      {
        if (vd === void 0)
          try {
            throw Error();
          } catch (h) {
            var u = h.stack.trim().match(/\n( *(at )?)/);
            vd = u && u[1] || "";
          }
        return `
` + vd + e;
      }
    }
    var Mu = !1, Au;
    {
      var Rw = typeof WeakMap == "function" ? WeakMap : Map;
      Au = new Rw();
    }
    function Q1(e, n) {
      if (!e || Mu)
        return "";
      {
        var o = Au.get(e);
        if (o !== void 0)
          return o;
      }
      var u;
      Mu = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var y;
      y = G1.current, G1.current = null, kw();
      try {
        if (n) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (W) {
              u = W;
            }
            Reflect.construct(e, [], S);
          } else {
            try {
              S.call();
            } catch (W) {
              u = W;
            }
            e.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (W) {
            u = W;
          }
          e();
        }
      } catch (W) {
        if (W && u && typeof W.stack == "string") {
          for (var w = W.stack.split(`
`), E = u.stack.split(`
`), D = w.length - 1, M = E.length - 1; D >= 1 && M >= 0 && w[D] !== E[M]; )
            M--;
          for (; D >= 1 && M >= 0; D--, M--)
            if (w[D] !== E[M]) {
              if (D !== 1 || M !== 1)
                do
                  if (D--, M--, M < 0 || w[D] !== E[M]) {
                    var H = `
` + w[D].replace(" at new ", " at ");
                    return e.displayName && H.includes("<anonymous>") && (H = H.replace("<anonymous>", e.displayName)), typeof e == "function" && Au.set(e, H), H;
                  }
                while (D >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Mu = !1, G1.current = y, xw(), Error.prepareStackTrace = h;
      }
      var V = e ? e.displayName || e.name : "", Q = V ? fs(V) : "";
      return typeof e == "function" && Au.set(e, Q), Q;
    }
    function Y1(e, n, o) {
      return Q1(e, !0);
    }
    function uv(e, n, o) {
      return Q1(e, !1);
    }
    function W1(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function Pu(e, n, o) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Q1(e, W1(e));
      if (typeof e == "string")
        return fs(e);
      switch (e) {
        case ov:
          return fs("Suspense");
        case lv:
          return fs("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case md:
            return uv(e.render);
          case cs:
            return Pu(e.type, n, o);
          case cr: {
            var u = e, h = u._payload, y = u._init;
            try {
              return Pu(y(h), n, o);
            } catch {
            }
          }
        }
      return "";
    }
    function Lw(e) {
      switch (e._debugOwner && e._debugOwner.type, e._debugSource, e.tag) {
        case F:
          return fs(e.type);
        case he:
          return fs("Lazy");
        case Me:
          return fs("Suspense");
        case Gt:
          return fs("SuspenseList");
        case x:
        case P:
        case Ge:
          return uv(e.type);
        case Se:
          return uv(e.type.render);
        case $:
          return Y1(e.type);
        default:
          return "";
      }
    }
    function cv(e) {
      try {
        var n = "", o = e;
        do
          n += Lw(o), o = o.return;
        while (o);
        return n;
      } catch (u) {
        return `
Error generating stack: ` + u.message + `
` + u.stack;
      }
    }
    function dn(e, n, o) {
      var u = e.displayName;
      if (u)
        return u;
      var h = n.displayName || n.name || "";
      return h !== "" ? o + "(" + h + ")" : o;
    }
    function K1(e) {
      return e.displayName || "Context";
    }
    function fn(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case fd:
          return "Fragment";
        case us:
          return "Portal";
        case hd:
          return "Profiler";
        case $u:
          return "StrictMode";
        case ov:
          return "Suspense";
        case lv:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case bh:
            var n = e;
            return K1(n) + ".Consumer";
          case pd:
            var o = e;
            return K1(o._context) + ".Provider";
          case md:
            return dn(e, e.render, "ForwardRef");
          case cs:
            var u = e.displayName || null;
            return u !== null ? u : fn(e.type) || "Memo";
          case cr: {
            var h = e, y = h._payload, S = h._init;
            try {
              return fn(S(y));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    function Z1(e, n, o) {
      var u = n.displayName || n.name || "";
      return e.displayName || (u !== "" ? o + "(" + u + ")" : o);
    }
    function X1(e) {
      return e.displayName || "Context";
    }
    function vt(e) {
      var n = e.tag, o = e.type;
      switch (n) {
        case wn:
          return "Cache";
        case De:
          var u = o;
          return X1(u) + ".Consumer";
        case Ne:
          var h = o;
          return X1(h._context) + ".Provider";
        case pt:
          return "DehydratedFragment";
        case Se:
          return Z1(o, o.render, "ForwardRef");
        case ne:
          return "Fragment";
        case F:
          return o;
        case U:
          return "Portal";
        case A:
          return "Root";
        case Z:
          return "Text";
        case he:
          return fn(o);
        case ce:
          return o === $u ? "StrictMode" : "Mode";
        case Ve:
          return "Offscreen";
        case je:
          return "Profiler";
        case Lt:
          return "Scope";
        case Me:
          return "Suspense";
        case Gt:
          return "SuspenseList";
        case Ye:
          return "TracingMarker";
        // The display name for this tags come from the user-provided type:
        case $:
        case x:
        case Ze:
        case P:
        case Ct:
        case Ge:
          if (typeof o == "function")
            return o.displayName || o.name || null;
          if (typeof o == "string")
            return o;
          break;
      }
      return null;
    }
    var J1 = t.ReactDebugCurrentFrame, br = null, pl = !1;
    function Va() {
      {
        if (br === null)
          return null;
        var e = br._debugOwner;
        if (e !== null && typeof e < "u")
          return vt(e);
      }
      return null;
    }
    function ml() {
      return br === null ? "" : cv(br);
    }
    function Gn() {
      J1.getCurrentStack = null, br = null, pl = !1;
    }
    function Mn(e) {
      J1.getCurrentStack = e === null ? null : ml, br = e, pl = !1;
    }
    function Eh() {
      return br;
    }
    function ji(e) {
      pl = e;
    }
    function Ua(e) {
      return "" + e;
    }
    function go(e) {
      switch (typeof e) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return e;
        case "object":
          return fa(e), e;
        default:
          return "";
      }
    }
    var kh = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function e3(e, n) {
      kh[n.type] || n.onChange || n.onInput || n.readOnly || n.disabled || n.value == null || g("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), n.onChange || n.readOnly || n.disabled || n.checked == null || g("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function t3(e) {
      var n = e.type, o = e.nodeName;
      return o && o.toLowerCase() === "input" && (n === "checkbox" || n === "radio");
    }
    function xh(e) {
      return e._valueTracker;
    }
    function W0(e) {
      e._valueTracker = null;
    }
    function $w(e) {
      var n = "";
      return e && (t3(e) ? n = e.checked ? "true" : "false" : n = e.value), n;
    }
    function Rh(e) {
      var n = t3(e) ? "checked" : "value", o = Object.getOwnPropertyDescriptor(e.constructor.prototype, n);
      fa(e[n]);
      var u = "" + e[n];
      if (!(e.hasOwnProperty(n) || typeof o > "u" || typeof o.get != "function" || typeof o.set != "function")) {
        var h = o.get, y = o.set;
        Object.defineProperty(e, n, {
          configurable: !0,
          get: function() {
            return h.call(this);
          },
          set: function(w) {
            fa(w), u = "" + w, y.call(this, w);
          }
        }), Object.defineProperty(e, n, {
          enumerable: o.enumerable
        });
        var S = {
          getValue: function() {
            return u;
          },
          setValue: function(w) {
            fa(w), u = "" + w;
          },
          stopTracking: function() {
            W0(e), delete e[n];
          }
        };
        return S;
      }
    }
    function vl(e) {
      xh(e) || (e._valueTracker = Rh(e));
    }
    function Ou(e) {
      if (!e)
        return !1;
      var n = xh(e);
      if (!n)
        return !0;
      var o = n.getValue(), u = $w(e);
      return u !== o ? (n.setValue(u), !0) : !1;
    }
    function _u(e) {
      if (e = e || (typeof document < "u" ? document : void 0), typeof e > "u")
        return null;
      try {
        return e.activeElement || e.body;
      } catch {
        return e.body;
      }
    }
    var K0 = !1, Z0 = !1, dv = !1, Lh = !1;
    function fv(e) {
      var n = e.type === "checkbox" || e.type === "radio";
      return n ? e.checked != null : e.value != null;
    }
    function hv(e, n) {
      var o = e, u = n.checked, h = Pt({}, n, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: u ?? o._wrapperState.initialChecked
      });
      return h;
    }
    function Co(e, n) {
      e3("input", n), n.checked !== void 0 && n.defaultChecked !== void 0 && !Z0 && (g("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Va() || "A component", n.type), Z0 = !0), n.value !== void 0 && n.defaultValue !== void 0 && !K0 && (g("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", Va() || "A component", n.type), K0 = !0);
      var o = e, u = n.defaultValue == null ? "" : n.defaultValue;
      o._wrapperState = {
        initialChecked: n.checked != null ? n.checked : n.defaultChecked,
        initialValue: go(n.value != null ? n.value : u),
        controlled: fv(n)
      };
    }
    function pv(e, n) {
      var o = e, u = n.checked;
      u != null && Lu(o, "checked", u, !1);
    }
    function yd(e, n) {
      var o = e;
      {
        var u = fv(n);
        !o._wrapperState.controlled && u && !Lh && (g("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), Lh = !0), o._wrapperState.controlled && !u && !dv && (g("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), dv = !0);
      }
      pv(e, n);
      var h = go(n.value), y = n.type;
      if (h != null)
        y === "number" ? (h === 0 && o.value === "" || // We explicitly want to coerce to number here if possible.
        // eslint-disable-next-line
        o.value != h) && (o.value = Ua(h)) : o.value !== Ua(h) && (o.value = Ua(h));
      else if (y === "submit" || y === "reset") {
        o.removeAttribute("value");
        return;
      }
      n.hasOwnProperty("value") ? yv(o, n.type, h) : n.hasOwnProperty("defaultValue") && yv(o, n.type, go(n.defaultValue)), n.checked == null && n.defaultChecked != null && (o.defaultChecked = !!n.defaultChecked);
    }
    function n3(e, n, o) {
      var u = e;
      if (n.hasOwnProperty("value") || n.hasOwnProperty("defaultValue")) {
        var h = n.type, y = h === "submit" || h === "reset";
        if (y && (n.value === void 0 || n.value === null))
          return;
        var S = Ua(u._wrapperState.initialValue);
        o || S !== u.value && (u.value = S), u.defaultValue = S;
      }
      var w = u.name;
      w !== "" && (u.name = ""), u.defaultChecked = !u.defaultChecked, u.defaultChecked = !!u._wrapperState.initialChecked, w !== "" && (u.name = w);
    }
    function mv(e, n) {
      var o = e;
      yd(o, n), vv(o, n);
    }
    function vv(e, n) {
      var o = n.name;
      if (n.type === "radio" && o != null) {
        for (var u = e; u.parentNode; )
          u = u.parentNode;
        da(o, "name");
        for (var h = u.querySelectorAll("input[name=" + JSON.stringify("" + o) + '][type="radio"]'), y = 0; y < h.length; y++) {
          var S = h[y];
          if (!(S === e || S.form !== e.form)) {
            var w = RS(S);
            if (!w)
              throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
            Ou(S), yd(S, w);
          }
        }
      }
    }
    function yv(e, n, o) {
      // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
      (n !== "number" || _u(e.ownerDocument) !== e) && (o == null ? e.defaultValue = Ua(e._wrapperState.initialValue) : e.defaultValue !== Ua(o) && (e.defaultValue = Ua(o)));
    }
    var jr = !1, Nu = !1, gv = !1;
    function gd(e, n) {
      n.value == null && (typeof n.children == "object" && n.children !== null ? c.Children.forEach(n.children, function(o) {
        o != null && (typeof o == "string" || typeof o == "number" || Nu || (Nu = !0, g("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
      }) : n.dangerouslySetInnerHTML != null && (gv || (gv = !0, g("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), n.selected != null && !jr && (g("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), jr = !0);
    }
    function Dw(e, n) {
      n.value != null && e.setAttribute("value", Ua(go(n.value)));
    }
    var i3 = Array.isArray;
    function Gi(e) {
      return i3(e);
    }
    var Vu;
    Vu = !1;
    function $h() {
      var e = Va();
      return e ? `

Check the render method of \`` + e + "`." : "";
    }
    var r3 = ["value", "defaultValue"];
    function Mw(e) {
      {
        e3("select", e);
        for (var n = 0; n < r3.length; n++) {
          var o = r3[n];
          if (e[o] != null) {
            var u = Gi(e[o]);
            e.multiple && !u ? g("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", o, $h()) : !e.multiple && u && g("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", o, $h());
          }
        }
      }
    }
    function Cd(e, n, o, u) {
      var h = e.options;
      if (n) {
        for (var y = o, S = {}, w = 0; w < y.length; w++)
          S["$" + y[w]] = !0;
        for (var E = 0; E < h.length; E++) {
          var D = S.hasOwnProperty("$" + h[E].value);
          h[E].selected !== D && (h[E].selected = D), D && u && (h[E].defaultSelected = !0);
        }
      } else {
        for (var M = Ua(go(o)), H = null, V = 0; V < h.length; V++) {
          if (h[V].value === M) {
            h[V].selected = !0, u && (h[V].defaultSelected = !0);
            return;
          }
          H === null && !h[V].disabled && (H = h[V]);
        }
        H !== null && (H.selected = !0);
      }
    }
    function a3(e, n) {
      return Pt({}, n, {
        value: void 0
      });
    }
    function Cv(e, n) {
      var o = e;
      Mw(n), o._wrapperState = {
        wasMultiple: !!n.multiple
      }, n.value !== void 0 && n.defaultValue !== void 0 && !Vu && (g("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Vu = !0);
    }
    function Aw(e, n) {
      var o = e;
      o.multiple = !!n.multiple;
      var u = n.value;
      u != null ? Cd(o, !!n.multiple, u, !1) : n.defaultValue != null && Cd(o, !!n.multiple, n.defaultValue, !0);
    }
    function Pw(e, n) {
      var o = e, u = o._wrapperState.wasMultiple;
      o._wrapperState.wasMultiple = !!n.multiple;
      var h = n.value;
      h != null ? Cd(o, !!n.multiple, h, !1) : u !== !!n.multiple && (n.defaultValue != null ? Cd(o, !!n.multiple, n.defaultValue, !0) : Cd(o, !!n.multiple, n.multiple ? [] : "", !1));
    }
    function Ow(e, n) {
      var o = e, u = n.value;
      u != null && Cd(o, !!n.multiple, u, !1);
    }
    var X0 = !1;
    function s3(e, n) {
      var o = e;
      if (n.dangerouslySetInnerHTML != null)
        throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
      var u = Pt({}, n, {
        value: void 0,
        defaultValue: void 0,
        children: Ua(o._wrapperState.initialValue)
      });
      return u;
    }
    function o3(e, n) {
      var o = e;
      e3("textarea", n), n.value !== void 0 && n.defaultValue !== void 0 && !X0 && (g("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", Va() || "A component"), X0 = !0);
      var u = n.value;
      if (u == null) {
        var h = n.children, y = n.defaultValue;
        if (h != null) {
          g("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
          {
            if (y != null)
              throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
            if (Gi(h)) {
              if (h.length > 1)
                throw new Error("<textarea> can only have at most one child.");
              h = h[0];
            }
            y = h;
          }
        }
        y == null && (y = ""), u = y;
      }
      o._wrapperState = {
        initialValue: go(u)
      };
    }
    function J0(e, n) {
      var o = e, u = go(n.value), h = go(n.defaultValue);
      if (u != null) {
        var y = Ua(u);
        y !== o.value && (o.value = y), n.defaultValue == null && o.defaultValue !== y && (o.defaultValue = y);
      }
      h != null && (o.defaultValue = Ua(h));
    }
    function eC(e, n) {
      var o = e, u = o.textContent;
      u === o._wrapperState.initialValue && u !== "" && u !== null && (o.value = u);
    }
    function _w(e, n) {
      J0(e, n);
    }
    var So = "http://www.w3.org/1999/xhtml", l3 = "http://www.w3.org/1998/Math/MathML", u3 = "http://www.w3.org/2000/svg";
    function c3(e) {
      switch (e) {
        case "svg":
          return u3;
        case "math":
          return l3;
        default:
          return So;
      }
    }
    function d3(e, n) {
      return e == null || e === So ? c3(n) : e === u3 && n === "foreignObject" ? So : e;
    }
    var tC = function(e) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(n, o, u, h) {
        MSApp.execUnsafeLocalFunction(function() {
          return e(n, o, u, h);
        });
      } : e;
    }, Sv, nC = tC(function(e, n) {
      if (e.namespaceURI === u3 && !("innerHTML" in e)) {
        Sv = Sv || document.createElement("div"), Sv.innerHTML = "<svg>" + n.valueOf().toString() + "</svg>";
        for (var o = Sv.firstChild; e.firstChild; )
          e.removeChild(e.firstChild);
        for (; o.firstChild; )
          e.appendChild(o.firstChild);
        return;
      }
      e.innerHTML = n;
    }), Gr = 1, bo = 3, oi = 8, wo = 9, f3 = 11, Sd = function(e, n) {
      if (n) {
        var o = e.firstChild;
        if (o && o === e.lastChild && o.nodeType === bo) {
          o.nodeValue = n;
          return;
        }
      }
      e.textContent = n;
    }, Dh = {
      animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
      background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
      borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
      borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
      borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
      borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
      borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
      borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
      borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
      borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
      fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
      gap: ["columnGap", "rowGap"],
      grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
      wordWrap: ["overflowWrap"]
    }, Mh = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function iC(e, n) {
      return e + n.charAt(0).toUpperCase() + n.substring(1);
    }
    var rC = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Mh).forEach(function(e) {
      rC.forEach(function(n) {
        Mh[iC(n, e)] = Mh[e];
      });
    });
    function bv(e, n, o) {
      var u = n == null || typeof n == "boolean" || n === "";
      return u ? "" : !o && typeof n == "number" && n !== 0 && !(Mh.hasOwnProperty(e) && Mh[e]) ? n + "px" : (Ch(n, e), ("" + n).trim());
    }
    var aC = /([A-Z])/g, sC = /^ms-/;
    function bd(e) {
      return e.replace(aC, "-$1").toLowerCase().replace(sC, "-ms-");
    }
    var oC = function() {
    };
    {
      var Nw = /^(?:webkit|moz|o)[A-Z]/, Vw = /^-ms-/, lC = /-(.)/g, h3 = /;\s*$/, zs = {}, Uu = {}, uC = !1, Ah = !1, Uw = function(e) {
        return e.replace(lC, function(n, o) {
          return o.toUpperCase();
        });
      }, cC = function(e) {
        zs.hasOwnProperty(e) && zs[e] || (zs[e] = !0, g(
          "Unsupported style property %s. Did you mean %s?",
          e,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          Uw(e.replace(Vw, "ms-"))
        ));
      }, p3 = function(e) {
        zs.hasOwnProperty(e) && zs[e] || (zs[e] = !0, g("Unsupported vendor-prefixed style property %s. Did you mean %s?", e, e.charAt(0).toUpperCase() + e.slice(1)));
      }, m3 = function(e, n) {
        Uu.hasOwnProperty(n) && Uu[n] || (Uu[n] = !0, g(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, e, n.replace(h3, "")));
      }, dC = function(e, n) {
        uC || (uC = !0, g("`NaN` is an invalid value for the `%s` css style property.", e));
      }, fC = function(e, n) {
        Ah || (Ah = !0, g("`Infinity` is an invalid value for the `%s` css style property.", e));
      };
      oC = function(e, n) {
        e.indexOf("-") > -1 ? cC(e) : Nw.test(e) ? p3(e) : h3.test(n) && m3(e, n), typeof n == "number" && (isNaN(n) ? dC(e, n) : isFinite(n) || fC(e, n));
      };
    }
    var hC = oC;
    function zw(e) {
      {
        var n = "", o = "";
        for (var u in e)
          if (e.hasOwnProperty(u)) {
            var h = e[u];
            if (h != null) {
              var y = u.indexOf("--") === 0;
              n += o + (y ? u : bd(u)) + ":", n += bv(u, h, y), o = ";";
            }
          }
        return n || null;
      }
    }
    function pC(e, n) {
      var o = e.style;
      for (var u in n)
        if (n.hasOwnProperty(u)) {
          var h = u.indexOf("--") === 0;
          h || hC(u, n[u]);
          var y = bv(u, n[u], h);
          u === "float" && (u = "cssFloat"), h ? o.setProperty(u, y) : o[u] = y;
        }
    }
    function Hw(e) {
      return e == null || typeof e == "boolean" || e === "";
    }
    function mC(e) {
      var n = {};
      for (var o in e)
        for (var u = Dh[o] || [o], h = 0; h < u.length; h++)
          n[u[h]] = o;
      return n;
    }
    function Fw(e, n) {
      {
        if (!n)
          return;
        var o = mC(e), u = mC(n), h = {};
        for (var y in o) {
          var S = o[y], w = u[y];
          if (w && S !== w) {
            var E = S + "," + w;
            if (h[E])
              continue;
            h[E] = !0, g("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", Hw(e[S]) ? "Removing" : "Updating", S, w);
          }
        }
      }
    }
    var hs = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Ph = Pt({
      menuitem: !0
    }, hs), vC = "__html";
    function wv(e, n) {
      if (n) {
        if (Ph[e] && (n.children != null || n.dangerouslySetInnerHTML != null))
          throw new Error(e + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (n.dangerouslySetInnerHTML != null) {
          if (n.children != null)
            throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (typeof n.dangerouslySetInnerHTML != "object" || !(vC in n.dangerouslySetInnerHTML))
            throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!n.suppressContentEditableWarning && n.contentEditable && n.children != null && g("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), n.style != null && typeof n.style != "object")
          throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    function yl(e, n) {
      if (e.indexOf("-") === -1)
        return typeof n.is == "string";
      switch (e) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Oh = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, Tv = {
      "aria-current": 0,
      // state
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, wd = {}, Iw = new RegExp("^(aria)-[" + ye + "]*$"), Td = new RegExp("^(aria)[A-Z][" + ye + "]*$");
    function v3(e, n) {
      {
        if (Cr.call(wd, n) && wd[n])
          return !0;
        if (Td.test(n)) {
          var o = "aria-" + n.slice(4).toLowerCase(), u = Tv.hasOwnProperty(o) ? o : null;
          if (u == null)
            return g("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", n), wd[n] = !0, !0;
          if (n !== u)
            return g("Invalid ARIA attribute `%s`. Did you mean `%s`?", n, u), wd[n] = !0, !0;
        }
        if (Iw.test(n)) {
          var h = n.toLowerCase(), y = Tv.hasOwnProperty(h) ? h : null;
          if (y == null)
            return wd[n] = !0, !1;
          if (n !== y)
            return g("Unknown ARIA attribute `%s`. Did you mean `%s`?", n, y), wd[n] = !0, !0;
        }
      }
      return !0;
    }
    function _h(e, n) {
      {
        var o = [];
        for (var u in n) {
          var h = v3(e, u);
          h || o.push(u);
        }
        var y = o.map(function(S) {
          return "`" + S + "`";
        }).join(", ");
        o.length === 1 ? g("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", y, e) : o.length > 1 && g("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", y, e);
      }
    }
    function y3(e, n) {
      yl(e, n) || _h(e, n);
    }
    var g3 = !1;
    function Ev(e, n) {
      {
        if (e !== "input" && e !== "textarea" && e !== "select")
          return;
        n != null && n.value === null && !g3 && (g3 = !0, e === "select" && n.multiple ? g("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", e) : g("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", e));
      }
    }
    var zu = function() {
    };
    {
      var Qi = {}, C3 = /^on./, kv = /^on[^A-Z]/, yC = new RegExp("^(aria)-[" + ye + "]*$"), gC = new RegExp("^(aria)[A-Z][" + ye + "]*$");
      zu = function(e, n, o, u) {
        if (Cr.call(Qi, n) && Qi[n])
          return !0;
        var h = n.toLowerCase();
        if (h === "onfocusin" || h === "onfocusout")
          return g("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), Qi[n] = !0, !0;
        if (u != null) {
          var y = u.registrationNameDependencies, S = u.possibleRegistrationNames;
          if (y.hasOwnProperty(n))
            return !0;
          var w = S.hasOwnProperty(h) ? S[h] : null;
          if (w != null)
            return g("Invalid event handler property `%s`. Did you mean `%s`?", n, w), Qi[n] = !0, !0;
          if (C3.test(n))
            return g("Unknown event handler property `%s`. It will be ignored.", n), Qi[n] = !0, !0;
        } else if (C3.test(n))
          return kv.test(n) && g("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", n), Qi[n] = !0, !0;
        if (yC.test(n) || gC.test(n))
          return !0;
        if (h === "innerhtml")
          return g("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), Qi[n] = !0, !0;
        if (h === "aria")
          return g("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), Qi[n] = !0, !0;
        if (h === "is" && o !== null && o !== void 0 && typeof o != "string")
          return g("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof o), Qi[n] = !0, !0;
        if (typeof o == "number" && isNaN(o))
          return g("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", n), Qi[n] = !0, !0;
        var E = si(n), D = E !== null && E.type === _a;
        if (Oh.hasOwnProperty(h)) {
          var M = Oh[h];
          if (M !== n)
            return g("Invalid DOM property `%s`. Did you mean `%s`?", n, M), Qi[n] = !0, !0;
        } else if (!D && n !== h)
          return g("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", n, h), Qi[n] = !0, !0;
        return typeof o == "boolean" && ai(n, o, E, !1) ? (o ? g('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', o, n, n, o, n) : g('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', o, n, n, o, n, n, n), Qi[n] = !0, !0) : D ? !0 : ai(n, o, E, !1) ? (Qi[n] = !0, !1) : ((o === "false" || o === "true") && E !== null && E.type === ha && (g("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", o, n, o === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', n, o), Qi[n] = !0), !0);
      };
    }
    var CC = function(e, n, o) {
      {
        var u = [];
        for (var h in n) {
          var y = zu(e, h, n[h], o);
          y || u.push(h);
        }
        var S = u.map(function(w) {
          return "`" + w + "`";
        }).join(", ");
        u.length === 1 ? g("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", S, e) : u.length > 1 && g("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", S, e);
      }
    };
    function SC(e, n, o) {
      yl(e, n) || CC(e, n, o);
    }
    var S3 = 1, xv = 2, za = 4, b3 = S3 | xv | za, Hu = null;
    function Bw(e) {
      Hu !== null && g("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), Hu = e;
    }
    function qw() {
      Hu === null && g("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), Hu = null;
    }
    function Nh(e) {
      return e === Hu;
    }
    function w3(e) {
      var n = e.target || e.srcElement || window;
      return n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === bo ? n.parentNode : n;
    }
    var Rv = null, Fu = null, ln = null;
    function Lv(e) {
      var n = qd(e);
      if (n) {
        if (typeof Rv != "function")
          throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var o = n.stateNode;
        if (o) {
          var u = RS(o);
          Rv(n.stateNode, n.type, u);
        }
      }
    }
    function $v(e) {
      Rv = e;
    }
    function Ed(e) {
      Fu ? ln ? ln.push(e) : ln = [e] : Fu = e;
    }
    function bC() {
      return Fu !== null || ln !== null;
    }
    function Dv() {
      if (Fu) {
        var e = Fu, n = ln;
        if (Fu = null, ln = null, Lv(e), n)
          for (var o = 0; o < n.length; o++)
            Lv(n[o]);
      }
    }
    var kd = function(e, n) {
      return e(n);
    }, Vh = function() {
    }, gl = !1;
    function wC() {
      var e = bC();
      e && (Vh(), Dv());
    }
    function TC(e, n, o) {
      if (gl)
        return e(n, o);
      gl = !0;
      try {
        return kd(e, n, o);
      } finally {
        gl = !1, wC();
      }
    }
    function jw(e, n, o) {
      kd = e, Vh = o;
    }
    function EC(e) {
      return e === "button" || e === "input" || e === "select" || e === "textarea";
    }
    function Mv(e, n, o) {
      switch (e) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(o.disabled && EC(n));
        default:
          return !1;
      }
    }
    function Cl(e, n) {
      var o = e.stateNode;
      if (o === null)
        return null;
      var u = RS(o);
      if (u === null)
        return null;
      var h = u[n];
      if (Mv(n, e.type, u))
        return null;
      if (h && typeof h != "function")
        throw new Error("Expected `" + n + "` listener to be a function, instead got a value of `" + typeof h + "` type.");
      return h;
    }
    var Uh = !1;
    if (Wn)
      try {
        var Iu = {};
        Object.defineProperty(Iu, "passive", {
          get: function() {
            Uh = !0;
          }
        }), window.addEventListener("test", Iu, Iu), window.removeEventListener("test", Iu, Iu);
      } catch {
        Uh = !1;
      }
    function Av(e, n, o, u, h, y, S, w, E) {
      var D = Array.prototype.slice.call(arguments, 3);
      try {
        n.apply(o, D);
      } catch (M) {
        this.onError(M);
      }
    }
    var Pv = Av;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var T3 = document.createElement("react");
      Pv = function(n, o, u, h, y, S, w, E, D) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var M = document.createEvent("Event"), H = !1, V = !0, Q = window.event, W = Object.getOwnPropertyDescriptor(window, "event");
        function X() {
          T3.removeEventListener(J, Qe, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = Q);
        }
        var Ce = Array.prototype.slice.call(arguments, 3);
        function Qe() {
          H = !0, X(), o.apply(u, Ce), V = !1;
        }
        var Ue, Ut = !1, Dt = !1;
        function q(j) {
          if (Ue = j.error, Ut = !0, Ue === null && j.colno === 0 && j.lineno === 0 && (Dt = !0), j.defaultPrevented && Ue != null && typeof Ue == "object")
            try {
              Ue._suppressLogging = !0;
            } catch {
            }
        }
        var J = "react-" + (n || "invokeguardedcallback");
        if (window.addEventListener("error", q), T3.addEventListener(J, Qe, !1), M.initEvent(J, !1, !1), T3.dispatchEvent(M), W && Object.defineProperty(window, "event", W), H && V && (Ut ? Dt && (Ue = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Ue = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Ue)), window.removeEventListener("error", q), !H)
          return X(), Av.apply(this, arguments);
      };
    }
    var kC = Pv, xd = !1, Ov = null, Rd = !1, Hs = null, xC = {
      onError: function(e) {
        xd = !0, Ov = e;
      }
    };
    function Sl(e, n, o, u, h, y, S, w, E) {
      xd = !1, Ov = null, kC.apply(xC, arguments);
    }
    function Fs(e, n, o, u, h, y, S, w, E) {
      if (Sl.apply(this, arguments), xd) {
        var D = Hh();
        Rd || (Rd = !0, Hs = D);
      }
    }
    function zh() {
      if (Rd) {
        var e = Hs;
        throw Rd = !1, Hs = null, e;
      }
    }
    function To() {
      return xd;
    }
    function Hh() {
      if (xd) {
        var e = Ov;
        return xd = !1, Ov = null, e;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    function Ld(e) {
      return e._reactInternals;
    }
    function Gw(e) {
      return e._reactInternals !== void 0;
    }
    function Bu(e, n) {
      e._reactInternals = n;
    }
    var Fe = (
      /*                      */
      0
    ), ps = (
      /*                */
      1
    ), Kn = (
      /*                    */
      2
    ), _t = (
      /*                       */
      4
    ), Ha = (
      /*                */
      16
    ), ms = (
      /*                 */
      32
    ), xn = (
      /*                     */
      64
    ), He = (
      /*                   */
      128
    ), Qr = (
      /*            */
      256
    ), Qn = (
      /*                          */
      512
    ), Ti = (
      /*                     */
      1024
    ), Yr = (
      /*                      */
      2048
    ), Fa = (
      /*                    */
      4096
    ), li = (
      /*                   */
      8192
    ), $d = (
      /*             */
      16384
    ), RC = (
      /*               */
      32767
    ), Fh = (
      /*                   */
      32768
    ), Wr = (
      /*                */
      65536
    ), _v = (
      /* */
      131072
    ), Is = (
      /*                       */
      1048576
    ), Dd = (
      /*                    */
      2097152
    ), Eo = (
      /*                 */
      4194304
    ), Nv = (
      /*                */
      8388608
    ), bl = (
      /*               */
      16777216
    ), Bs = (
      /*              */
      33554432
    ), wl = (
      // TODO: Remove Update flag from before mutation phase by re-landing Visibility
      // flag logic (see #20043)
      _t | Ti | 0
    ), Tl = Kn | _t | Ha | ms | Qn | Fa | li, El = _t | xn | Qn | li, ko = Yr | Ha, ui = Eo | Nv | Dd, Ia = t.ReactCurrentOwner;
    function pa(e) {
      var n = e, o = e;
      if (e.alternate)
        for (; n.return; )
          n = n.return;
      else {
        var u = n;
        do
          n = u, (n.flags & (Kn | Fa)) !== Fe && (o = n.return), u = n.return;
        while (u);
      }
      return n.tag === A ? o : null;
    }
    function qs(e) {
      if (e.tag === Me) {
        var n = e.memoizedState;
        if (n === null) {
          var o = e.alternate;
          o !== null && (n = o.memoizedState);
        }
        if (n !== null)
          return n.dehydrated;
      }
      return null;
    }
    function js(e) {
      return e.tag === A ? e.stateNode.containerInfo : null;
    }
    function qu(e) {
      return pa(e) === e;
    }
    function LC(e) {
      {
        var n = Ia.current;
        if (n !== null && n.tag === $) {
          var o = n, u = o.stateNode;
          u._warnedAboutRefsInRender || g("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", vt(o) || "A component"), u._warnedAboutRefsInRender = !0;
        }
      }
      var h = Ld(e);
      return h ? pa(h) === h : !1;
    }
    function Vv(e) {
      if (pa(e) !== e)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function Uv(e) {
      var n = e.alternate;
      if (!n) {
        var o = pa(e);
        if (o === null)
          throw new Error("Unable to find node on an unmounted component.");
        return o !== e ? null : e;
      }
      for (var u = e, h = n; ; ) {
        var y = u.return;
        if (y === null)
          break;
        var S = y.alternate;
        if (S === null) {
          var w = y.return;
          if (w !== null) {
            u = h = w;
            continue;
          }
          break;
        }
        if (y.child === S.child) {
          for (var E = y.child; E; ) {
            if (E === u)
              return Vv(y), e;
            if (E === h)
              return Vv(y), n;
            E = E.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (u.return !== h.return)
          u = y, h = S;
        else {
          for (var D = !1, M = y.child; M; ) {
            if (M === u) {
              D = !0, u = y, h = S;
              break;
            }
            if (M === h) {
              D = !0, h = y, u = S;
              break;
            }
            M = M.sibling;
          }
          if (!D) {
            for (M = S.child; M; ) {
              if (M === u) {
                D = !0, u = S, h = y;
                break;
              }
              if (M === h) {
                D = !0, h = S, u = y;
                break;
              }
              M = M.sibling;
            }
            if (!D)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (u.alternate !== h)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (u.tag !== A)
        throw new Error("Unable to find node on an unmounted component.");
      return u.stateNode.current === u ? e : n;
    }
    function Kr(e) {
      var n = Uv(e);
      return n !== null ? Zr(n) : null;
    }
    function Zr(e) {
      if (e.tag === F || e.tag === Z)
        return e;
      for (var n = e.child; n !== null; ) {
        var o = Zr(n);
        if (o !== null)
          return o;
        n = n.sibling;
      }
      return null;
    }
    function Nn(e) {
      var n = Uv(e);
      return n !== null ? Ba(n) : null;
    }
    function Ba(e) {
      if (e.tag === F || e.tag === Z)
        return e;
      for (var n = e.child; n !== null; ) {
        if (n.tag !== U) {
          var o = Ba(n);
          if (o !== null)
            return o;
        }
        n = n.sibling;
      }
      return null;
    }
    var E3 = s.unstable_scheduleCallback, $C = s.unstable_cancelCallback, k3 = s.unstable_shouldYield, x3 = s.unstable_requestPaint, Ei = s.unstable_now, zv = s.unstable_getCurrentPriorityLevel, Ih = s.unstable_ImmediatePriority, kl = s.unstable_UserBlockingPriority, xo = s.unstable_NormalPriority, Qw = s.unstable_LowPriority, ju = s.unstable_IdlePriority, Hv = s.unstable_yieldValue, DC = s.unstable_setDisableYieldValue, Gu = null, Zn = null, ge = null, ma = !1, Xr = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
    function Md(e) {
      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
        return !1;
      var n = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (n.isDisabled)
        return !0;
      if (!n.supportsFiber)
        return g("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
      try {
        ur && (e = Pt({}, e, {
          getLaneLabelMap: Qu,
          injectProfilingHooks: qa
        })), Gu = n.inject(e), Zn = n;
      } catch (o) {
        g("React instrumentation encountered an error: %s.", o);
      }
      return !!n.checkDCE;
    }
    function R3(e, n) {
      if (Zn && typeof Zn.onScheduleFiberRoot == "function")
        try {
          Zn.onScheduleFiberRoot(Gu, e, n);
        } catch (o) {
          ma || (ma = !0, g("React instrumentation encountered an error: %s", o));
        }
    }
    function L3(e, n) {
      if (Zn && typeof Zn.onCommitFiberRoot == "function")
        try {
          var o = (e.current.flags & He) === He;
          if (ri) {
            var u;
            switch (n) {
              case wr:
                u = Ih;
                break;
              case Qs:
                u = kl;
                break;
              case ja:
                u = xo;
                break;
              case Ga:
                u = ju;
                break;
              default:
                u = xo;
                break;
            }
            Zn.onCommitFiberRoot(Gu, e, u, o);
          }
        } catch (h) {
          ma || (ma = !0, g("React instrumentation encountered an error: %s", h));
        }
    }
    function $3(e) {
      if (Zn && typeof Zn.onPostCommitFiberRoot == "function")
        try {
          Zn.onPostCommitFiberRoot(Gu, e);
        } catch (n) {
          ma || (ma = !0, g("React instrumentation encountered an error: %s", n));
        }
    }
    function D3(e) {
      if (Zn && typeof Zn.onCommitFiberUnmount == "function")
        try {
          Zn.onCommitFiberUnmount(Gu, e);
        } catch (n) {
          ma || (ma = !0, g("React instrumentation encountered an error: %s", n));
        }
    }
    function Un(e) {
      if (typeof Hv == "function" && (DC(e), f(e)), Zn && typeof Zn.setStrictMode == "function")
        try {
          Zn.setStrictMode(Gu, e);
        } catch (n) {
          ma || (ma = !0, g("React instrumentation encountered an error: %s", n));
        }
    }
    function qa(e) {
      ge = e;
    }
    function Qu() {
      {
        for (var e = /* @__PURE__ */ new Map(), n = 1, o = 0; o < Ku; o++) {
          var u = OC(n);
          e.set(n, u), n *= 2;
        }
        return e;
      }
    }
    function M3(e) {
      ge !== null && typeof ge.markCommitStarted == "function" && ge.markCommitStarted(e);
    }
    function A3() {
      ge !== null && typeof ge.markCommitStopped == "function" && ge.markCommitStopped();
    }
    function va(e) {
      ge !== null && typeof ge.markComponentRenderStarted == "function" && ge.markComponentRenderStarted(e);
    }
    function ya() {
      ge !== null && typeof ge.markComponentRenderStopped == "function" && ge.markComponentRenderStopped();
    }
    function P3(e) {
      ge !== null && typeof ge.markComponentPassiveEffectMountStarted == "function" && ge.markComponentPassiveEffectMountStarted(e);
    }
    function MC() {
      ge !== null && typeof ge.markComponentPassiveEffectMountStopped == "function" && ge.markComponentPassiveEffectMountStopped();
    }
    function Ro(e) {
      ge !== null && typeof ge.markComponentPassiveEffectUnmountStarted == "function" && ge.markComponentPassiveEffectUnmountStarted(e);
    }
    function xl() {
      ge !== null && typeof ge.markComponentPassiveEffectUnmountStopped == "function" && ge.markComponentPassiveEffectUnmountStopped();
    }
    function Fv(e) {
      ge !== null && typeof ge.markComponentLayoutEffectMountStarted == "function" && ge.markComponentLayoutEffectMountStarted(e);
    }
    function AC() {
      ge !== null && typeof ge.markComponentLayoutEffectMountStopped == "function" && ge.markComponentLayoutEffectMountStopped();
    }
    function Bh(e) {
      ge !== null && typeof ge.markComponentLayoutEffectUnmountStarted == "function" && ge.markComponentLayoutEffectUnmountStarted(e);
    }
    function O3() {
      ge !== null && typeof ge.markComponentLayoutEffectUnmountStopped == "function" && ge.markComponentLayoutEffectUnmountStopped();
    }
    function qh(e, n, o) {
      ge !== null && typeof ge.markComponentErrored == "function" && ge.markComponentErrored(e, n, o);
    }
    function Gs(e, n, o) {
      ge !== null && typeof ge.markComponentSuspended == "function" && ge.markComponentSuspended(e, n, o);
    }
    function jh(e) {
      ge !== null && typeof ge.markLayoutEffectsStarted == "function" && ge.markLayoutEffectsStarted(e);
    }
    function Gh() {
      ge !== null && typeof ge.markLayoutEffectsStopped == "function" && ge.markLayoutEffectsStopped();
    }
    function Yu(e) {
      ge !== null && typeof ge.markPassiveEffectsStarted == "function" && ge.markPassiveEffectsStarted(e);
    }
    function _3() {
      ge !== null && typeof ge.markPassiveEffectsStopped == "function" && ge.markPassiveEffectsStopped();
    }
    function Wu(e) {
      ge !== null && typeof ge.markRenderStarted == "function" && ge.markRenderStarted(e);
    }
    function PC() {
      ge !== null && typeof ge.markRenderYielded == "function" && ge.markRenderYielded();
    }
    function Iv() {
      ge !== null && typeof ge.markRenderStopped == "function" && ge.markRenderStopped();
    }
    function zn(e) {
      ge !== null && typeof ge.markRenderScheduled == "function" && ge.markRenderScheduled(e);
    }
    function Bv(e, n) {
      ge !== null && typeof ge.markForceUpdateScheduled == "function" && ge.markForceUpdateScheduled(e, n);
    }
    function Qh(e, n) {
      ge !== null && typeof ge.markStateUpdateScheduled == "function" && ge.markStateUpdateScheduled(e, n);
    }
    var Ie = (
      /*                         */
      0
    ), Tt = (
      /*                 */
      1
    ), Yt = (
      /*                    */
      2
    ), mn = (
      /*               */
      8
    ), Wt = (
      /*              */
      16
    ), ci = Math.clz32 ? Math.clz32 : Yh, Oi = Math.log, qv = Math.LN2;
    function Yh(e) {
      var n = e >>> 0;
      return n === 0 ? 32 : 31 - (Oi(n) / qv | 0) | 0;
    }
    var Ku = 31, ie = (
      /*                        */
      0
    ), Ft = (
      /*                          */
      0
    ), tt = (
      /*                        */
      1
    ), Rl = (
      /*    */
      2
    ), vs = (
      /*             */
      4
    ), dr = (
      /*            */
      8
    ), Xn = (
      /*                     */
      16
    ), Lo = (
      /*                */
      32
    ), Ll = (
      /*                       */
      4194240
    ), Zu = (
      /*                        */
      64
    ), jv = (
      /*                        */
      128
    ), Gv = (
      /*                        */
      256
    ), Qv = (
      /*                        */
      512
    ), Yv = (
      /*                        */
      1024
    ), Wv = (
      /*                        */
      2048
    ), Kv = (
      /*                        */
      4096
    ), Zv = (
      /*                        */
      8192
    ), Xv = (
      /*                        */
      16384
    ), Xu = (
      /*                       */
      32768
    ), Jv = (
      /*                       */
      65536
    ), Ad = (
      /*                       */
      131072
    ), Pd = (
      /*                       */
      262144
    ), ey = (
      /*                       */
      524288
    ), Wh = (
      /*                       */
      1048576
    ), ty = (
      /*                       */
      2097152
    ), Kh = (
      /*                            */
      130023424
    ), Ju = (
      /*                             */
      4194304
    ), ny = (
      /*                             */
      8388608
    ), Zh = (
      /*                             */
      16777216
    ), iy = (
      /*                             */
      33554432
    ), ry = (
      /*                             */
      67108864
    ), N3 = Ju, Xh = (
      /*          */
      134217728
    ), V3 = (
      /*                          */
      268435455
    ), Jh = (
      /*               */
      268435456
    ), ec = (
      /*                        */
      536870912
    ), ga = (
      /*                   */
      1073741824
    );
    function OC(e) {
      {
        if (e & tt)
          return "Sync";
        if (e & Rl)
          return "InputContinuousHydration";
        if (e & vs)
          return "InputContinuous";
        if (e & dr)
          return "DefaultHydration";
        if (e & Xn)
          return "Default";
        if (e & Lo)
          return "TransitionHydration";
        if (e & Ll)
          return "Transition";
        if (e & Kh)
          return "Retry";
        if (e & Xh)
          return "SelectiveHydration";
        if (e & Jh)
          return "IdleHydration";
        if (e & ec)
          return "Idle";
        if (e & ga)
          return "Offscreen";
      }
    }
    var kn = -1, tc = Zu, ay = Ju;
    function ep(e) {
      switch ($l(e)) {
        case tt:
          return tt;
        case Rl:
          return Rl;
        case vs:
          return vs;
        case dr:
          return dr;
        case Xn:
          return Xn;
        case Lo:
          return Lo;
        case Zu:
        case jv:
        case Gv:
        case Qv:
        case Yv:
        case Wv:
        case Kv:
        case Zv:
        case Xv:
        case Xu:
        case Jv:
        case Ad:
        case Pd:
        case ey:
        case Wh:
        case ty:
          return e & Ll;
        case Ju:
        case ny:
        case Zh:
        case iy:
        case ry:
          return e & Kh;
        case Xh:
          return Xh;
        case Jh:
          return Jh;
        case ec:
          return ec;
        case ga:
          return ga;
        default:
          return g("Should have found matching lanes. This is a bug in React."), e;
      }
    }
    function sy(e, n) {
      var o = e.pendingLanes;
      if (o === ie)
        return ie;
      var u = ie, h = e.suspendedLanes, y = e.pingedLanes, S = o & V3;
      if (S !== ie) {
        var w = S & ~h;
        if (w !== ie)
          u = ep(w);
        else {
          var E = S & y;
          E !== ie && (u = ep(E));
        }
      } else {
        var D = o & ~h;
        D !== ie ? u = ep(D) : y !== ie && (u = ep(y));
      }
      if (u === ie)
        return ie;
      if (n !== ie && n !== u && // If we already suspended with a delay, then interrupting is fine. Don't
      // bother waiting until the root is complete.
      (n & h) === ie) {
        var M = $l(u), H = $l(n);
        if (
          // Tests whether the next lane is equal or lower priority than the wip
          // one. This works because the bits decrease in priority as you go left.
          M >= H || // Default priority updates should not interrupt transition updates. The
          // only difference between default updates and transition updates is that
          // default updates do not support refresh transitions.
          M === Xn && (H & Ll) !== ie
        )
          return n;
      }
      (u & vs) !== ie && (u |= o & Xn);
      var V = e.entangledLanes;
      if (V !== ie)
        for (var Q = e.entanglements, W = u & V; W > 0; ) {
          var X = di(W), Ce = 1 << X;
          u |= Q[X], W &= ~Ce;
        }
      return u;
    }
    function ys(e, n) {
      for (var o = e.eventTimes, u = kn; n > 0; ) {
        var h = di(n), y = 1 << h, S = o[h];
        S > u && (u = S), n &= ~y;
      }
      return u;
    }
    function U3(e, n) {
      switch (e) {
        case tt:
        case Rl:
        case vs:
          return n + 250;
        case dr:
        case Xn:
        case Lo:
        case Zu:
        case jv:
        case Gv:
        case Qv:
        case Yv:
        case Wv:
        case Kv:
        case Zv:
        case Xv:
        case Xu:
        case Jv:
        case Ad:
        case Pd:
        case ey:
        case Wh:
        case ty:
          return n + 5e3;
        case Ju:
        case ny:
        case Zh:
        case iy:
        case ry:
          return kn;
        case Xh:
        case Jh:
        case ec:
        case ga:
          return kn;
        default:
          return g("Should have found matching lanes. This is a bug in React."), kn;
      }
    }
    function oy(e, n) {
      for (var o = e.pendingLanes, u = e.suspendedLanes, h = e.pingedLanes, y = e.expirationTimes, S = o; S > 0; ) {
        var w = di(S), E = 1 << w, D = y[w];
        D === kn ? ((E & u) === ie || (E & h) !== ie) && (y[w] = U3(E, n)) : D <= n && (e.expiredLanes |= E), S &= ~E;
      }
    }
    function _C(e) {
      return ep(e.pendingLanes);
    }
    function ly(e) {
      var n = e.pendingLanes & -1073741825;
      return n !== ie ? n : n & ga ? ga : ie;
    }
    function NC(e) {
      return (e & tt) !== ie;
    }
    function tp(e) {
      return (e & V3) !== ie;
    }
    function nc(e) {
      return (e & Kh) === e;
    }
    function z3(e) {
      var n = tt | vs | Xn;
      return (e & n) === ie;
    }
    function H3(e) {
      return (e & Ll) === e;
    }
    function uy(e, n) {
      var o = Rl | vs | dr | Xn;
      return (n & o) !== ie;
    }
    function VC(e, n) {
      return (n & e.expiredLanes) !== ie;
    }
    function F3(e) {
      return (e & Ll) !== ie;
    }
    function I3() {
      var e = tc;
      return tc <<= 1, (tc & Ll) === ie && (tc = Zu), e;
    }
    function UC() {
      var e = ay;
      return ay <<= 1, (ay & Kh) === ie && (ay = Ju), e;
    }
    function $l(e) {
      return e & -e;
    }
    function np(e) {
      return $l(e);
    }
    function di(e) {
      return 31 - ci(e);
    }
    function Yi(e) {
      return di(e);
    }
    function Jr(e, n) {
      return (e & n) !== ie;
    }
    function ic(e, n) {
      return (e & n) === n;
    }
    function yt(e, n) {
      return e | n;
    }
    function ip(e, n) {
      return e & ~n;
    }
    function B3(e, n) {
      return e & n;
    }
    function zC(e) {
      return e;
    }
    function HC(e, n) {
      return e !== Ft && e < n ? e : n;
    }
    function rp(e) {
      for (var n = [], o = 0; o < Ku; o++)
        n.push(e);
      return n;
    }
    function Od(e, n, o) {
      e.pendingLanes |= n, n !== ec && (e.suspendedLanes = ie, e.pingedLanes = ie);
      var u = e.eventTimes, h = Yi(n);
      u[h] = o;
    }
    function FC(e, n) {
      e.suspendedLanes |= n, e.pingedLanes &= ~n;
      for (var o = e.expirationTimes, u = n; u > 0; ) {
        var h = di(u), y = 1 << h;
        o[h] = kn, u &= ~y;
      }
    }
    function cy(e, n, o) {
      e.pingedLanes |= e.suspendedLanes & n;
    }
    function q3(e, n) {
      var o = e.pendingLanes & ~n;
      e.pendingLanes = n, e.suspendedLanes = ie, e.pingedLanes = ie, e.expiredLanes &= n, e.mutableReadLanes &= n, e.entangledLanes &= n;
      for (var u = e.entanglements, h = e.eventTimes, y = e.expirationTimes, S = o; S > 0; ) {
        var w = di(S), E = 1 << w;
        u[w] = ie, h[w] = kn, y[w] = kn, S &= ~E;
      }
    }
    function dy(e, n) {
      for (var o = e.entangledLanes |= n, u = e.entanglements, h = o; h; ) {
        var y = di(h), S = 1 << y;
        // Is this one of the newly entangled lanes?
        S & n | // Is this lane transitively entangled with the newly entangled lanes?
        u[y] & n && (u[y] |= n), h &= ~S;
      }
    }
    function j3(e, n) {
      var o = $l(n), u;
      switch (o) {
        case vs:
          u = Rl;
          break;
        case Xn:
          u = dr;
          break;
        case Zu:
        case jv:
        case Gv:
        case Qv:
        case Yv:
        case Wv:
        case Kv:
        case Zv:
        case Xv:
        case Xu:
        case Jv:
        case Ad:
        case Pd:
        case ey:
        case Wh:
        case ty:
        case Ju:
        case ny:
        case Zh:
        case iy:
        case ry:
          u = Lo;
          break;
        case ec:
          u = Jh;
          break;
        default:
          u = Ft;
          break;
      }
      return (u & (e.suspendedLanes | n)) !== Ft ? Ft : u;
    }
    function ap(e, n, o) {
      if (Xr)
        for (var u = e.pendingUpdatersLaneMap; o > 0; ) {
          var h = Yi(o), y = 1 << h, S = u[h];
          S.add(n), o &= ~y;
        }
    }
    function IC(e, n) {
      if (Xr)
        for (var o = e.pendingUpdatersLaneMap, u = e.memoizedUpdaters; n > 0; ) {
          var h = Yi(n), y = 1 << h, S = o[h];
          S.size > 0 && (S.forEach(function(w) {
            var E = w.alternate;
            (E === null || !u.has(E)) && u.add(w);
          }), S.clear()), n &= ~y;
        }
    }
    function G3(e, n) {
      return null;
    }
    var wr = tt, Qs = vs, ja = Xn, Ga = ec, sp = Ft;
    function Qa() {
      return sp;
    }
    function fi(e) {
      sp = e;
    }
    function BC(e, n) {
      var o = sp;
      try {
        return sp = e, n();
      } finally {
        sp = o;
      }
    }
    function qC(e, n) {
      return e !== 0 && e < n ? e : n;
    }
    function op(e, n) {
      return e > n ? e : n;
    }
    function _i(e, n) {
      return e !== 0 && e < n;
    }
    function jC(e) {
      var n = $l(e);
      return _i(wr, n) ? _i(Qs, n) ? tp(n) ? ja : Ga : Qs : wr;
    }
    function fy(e) {
      var n = e.current.memoizedState;
      return n.isDehydrated;
    }
    var lp;
    function fr(e) {
      lp = e;
    }
    function Yw(e) {
      lp(e);
    }
    var Re;
    function _d(e) {
      Re = e;
    }
    var hy;
    function GC(e) {
      hy = e;
    }
    var QC;
    function up(e) {
      QC = e;
    }
    var cp;
    function Q3(e) {
      cp = e;
    }
    var py = !1, dp = [], $o = null, Ys = null, Ws = null, Jn = /* @__PURE__ */ new Map(), Tr = /* @__PURE__ */ new Map(), Er = [], YC = [
      "mousedown",
      "mouseup",
      "touchcancel",
      "touchend",
      "touchstart",
      "auxclick",
      "dblclick",
      "pointercancel",
      "pointerdown",
      "pointerup",
      "dragend",
      "dragstart",
      "drop",
      "compositionend",
      "compositionstart",
      "keydown",
      "keypress",
      "keyup",
      "input",
      "textInput",
      // Intentionally camelCase
      "copy",
      "cut",
      "paste",
      "click",
      "change",
      "contextmenu",
      "reset",
      "submit"
    ];
    function WC(e) {
      return YC.indexOf(e) > -1;
    }
    function gs(e, n, o, u, h) {
      return {
        blockedOn: e,
        domEventName: n,
        eventSystemFlags: o,
        nativeEvent: h,
        targetContainers: [u]
      };
    }
    function Y3(e, n) {
      switch (e) {
        case "focusin":
        case "focusout":
          $o = null;
          break;
        case "dragenter":
        case "dragleave":
          Ys = null;
          break;
        case "mouseover":
        case "mouseout":
          Ws = null;
          break;
        case "pointerover":
        case "pointerout": {
          var o = n.pointerId;
          Jn.delete(o);
          break;
        }
        case "gotpointercapture":
        case "lostpointercapture": {
          var u = n.pointerId;
          Tr.delete(u);
          break;
        }
      }
    }
    function ea(e, n, o, u, h, y) {
      if (e === null || e.nativeEvent !== y) {
        var S = gs(n, o, u, h, y);
        if (n !== null) {
          var w = qd(n);
          w !== null && Re(w);
        }
        return S;
      }
      e.eventSystemFlags |= u;
      var E = e.targetContainers;
      return h !== null && E.indexOf(h) === -1 && E.push(h), e;
    }
    function Ww(e, n, o, u, h) {
      switch (n) {
        case "focusin": {
          var y = h;
          return $o = ea($o, e, n, o, u, y), !0;
        }
        case "dragenter": {
          var S = h;
          return Ys = ea(Ys, e, n, o, u, S), !0;
        }
        case "mouseover": {
          var w = h;
          return Ws = ea(Ws, e, n, o, u, w), !0;
        }
        case "pointerover": {
          var E = h, D = E.pointerId;
          return Jn.set(D, ea(Jn.get(D) || null, e, n, o, u, E)), !0;
        }
        case "gotpointercapture": {
          var M = h, H = M.pointerId;
          return Tr.set(H, ea(Tr.get(H) || null, e, n, o, u, M)), !0;
        }
      }
      return !1;
    }
    function W3(e) {
      var n = Tp(e.target);
      if (n !== null) {
        var o = pa(n);
        if (o !== null) {
          var u = o.tag;
          if (u === Me) {
            var h = qs(o);
            if (h !== null) {
              e.blockedOn = h, cp(e.priority, function() {
                hy(o);
              });
              return;
            }
          } else if (u === A) {
            var y = o.stateNode;
            if (fy(y)) {
              e.blockedOn = js(o);
              return;
            }
          }
        }
      }
      e.blockedOn = null;
    }
    function KC(e) {
      for (var n = QC(), o = {
        blockedOn: null,
        target: e,
        priority: n
      }, u = 0; u < Er.length && _i(n, Er[u].priority); u++)
        ;
      Er.splice(u, 0, o), u === 0 && W3(o);
    }
    function fp(e) {
      if (e.blockedOn !== null)
        return !1;
      for (var n = e.targetContainers; n.length > 0; ) {
        var o = n[0], u = Vd(e.domEventName, e.eventSystemFlags, o, e.nativeEvent);
        if (u === null) {
          var h = e.nativeEvent, y = new h.constructor(h.type, h);
          Bw(y), h.target.dispatchEvent(y), qw();
        } else {
          var S = qd(u);
          return S !== null && Re(S), e.blockedOn = u, !1;
        }
        n.shift();
      }
      return !0;
    }
    function K3(e, n, o) {
      fp(e) && o.delete(n);
    }
    function Kw() {
      py = !1, $o !== null && fp($o) && ($o = null), Ys !== null && fp(Ys) && (Ys = null), Ws !== null && fp(Ws) && (Ws = null), Jn.forEach(K3), Tr.forEach(K3);
    }
    function Dl(e, n) {
      e.blockedOn === n && (e.blockedOn = null, py || (py = !0, s.unstable_scheduleCallback(s.unstable_NormalPriority, Kw)));
    }
    function rc(e) {
      if (dp.length > 0) {
        Dl(dp[0], e);
        for (var n = 1; n < dp.length; n++) {
          var o = dp[n];
          o.blockedOn === e && (o.blockedOn = null);
        }
      }
      $o !== null && Dl($o, e), Ys !== null && Dl(Ys, e), Ws !== null && Dl(Ws, e);
      var u = function(w) {
        return Dl(w, e);
      };
      Jn.forEach(u), Tr.forEach(u);
      for (var h = 0; h < Er.length; h++) {
        var y = Er[h];
        y.blockedOn === e && (y.blockedOn = null);
      }
      for (; Er.length > 0; ) {
        var S = Er[0];
        if (S.blockedOn !== null)
          break;
        W3(S), S.blockedOn === null && Er.shift();
      }
    }
    var Wi = t.ReactCurrentBatchConfig, Nt = !0;
    function ki(e) {
      Nt = !!e;
    }
    function hi() {
      return Nt;
    }
    function Ki(e, n, o) {
      var u = my(n), h;
      switch (u) {
        case wr:
          h = Ca;
          break;
        case Qs:
          h = Nd;
          break;
        case ja:
        default:
          h = ei;
          break;
      }
      return h.bind(null, n, o, e);
    }
    function Ca(e, n, o, u) {
      var h = Qa(), y = Wi.transition;
      Wi.transition = null;
      try {
        fi(wr), ei(e, n, o, u);
      } finally {
        fi(h), Wi.transition = y;
      }
    }
    function Nd(e, n, o, u) {
      var h = Qa(), y = Wi.transition;
      Wi.transition = null;
      try {
        fi(Qs), ei(e, n, o, u);
      } finally {
        fi(h), Wi.transition = y;
      }
    }
    function ei(e, n, o, u) {
      Nt && hp(e, n, o, u);
    }
    function hp(e, n, o, u) {
      var h = Vd(e, n, o, u);
      if (h === null) {
        pT(e, n, u, Ks, o), Y3(e, u);
        return;
      }
      if (Ww(h, e, n, o, u)) {
        u.stopPropagation();
        return;
      }
      if (Y3(e, u), n & za && WC(e)) {
        for (; h !== null; ) {
          var y = qd(h);
          y !== null && Yw(y);
          var S = Vd(e, n, o, u);
          if (S === null && pT(e, n, u, Ks, o), S === h)
            break;
          h = S;
        }
        h !== null && u.stopPropagation();
        return;
      }
      pT(e, n, u, null, o);
    }
    var Ks = null;
    function Vd(e, n, o, u) {
      Ks = null;
      var h = w3(u), y = Tp(h);
      if (y !== null) {
        var S = pa(y);
        if (S === null)
          y = null;
        else {
          var w = S.tag;
          if (w === Me) {
            var E = qs(S);
            if (E !== null)
              return E;
            y = null;
          } else if (w === A) {
            var D = S.stateNode;
            if (fy(D))
              return js(S);
            y = null;
          } else S !== y && (y = null);
        }
      }
      return Ks = y, null;
    }
    function my(e) {
      switch (e) {
        // Used by SimpleEventPlugin:
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        // Used by polyfills:
        // eslint-disable-next-line no-fallthrough
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        // Only enableCreateEventHandleAPI:
        // eslint-disable-next-line no-fallthrough
        case "beforeblur":
        case "afterblur":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return wr;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        // Not used by React but could be by user code:
        // eslint-disable-next-line no-fallthrough
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return Qs;
        case "message": {
          var n = zv();
          switch (n) {
            case Ih:
              return wr;
            case kl:
              return Qs;
            case xo:
            case Qw:
              return ja;
            case ju:
              return Ga;
            default:
              return ja;
          }
        }
        default:
          return ja;
      }
    }
    function pp(e, n, o) {
      return e.addEventListener(n, o, !1), o;
    }
    function ta(e, n, o) {
      return e.addEventListener(n, o, !0), o;
    }
    function Z3(e, n, o, u) {
      return e.addEventListener(n, o, {
        capture: !0,
        passive: u
      }), o;
    }
    function Ud(e, n, o, u) {
      return e.addEventListener(n, o, {
        passive: u
      }), o;
    }
    var Sa = null, zd = null, ac = null;
    function Ml(e) {
      return Sa = e, zd = mp(), !0;
    }
    function vy() {
      Sa = null, zd = null, ac = null;
    }
    function Do() {
      if (ac)
        return ac;
      var e, n = zd, o = n.length, u, h = mp(), y = h.length;
      for (e = 0; e < o && n[e] === h[e]; e++)
        ;
      var S = o - e;
      for (u = 1; u <= S && n[o - u] === h[y - u]; u++)
        ;
      var w = u > 1 ? 1 - u : void 0;
      return ac = h.slice(e, w), ac;
    }
    function mp() {
      return "value" in Sa ? Sa.value : Sa.textContent;
    }
    function Al(e) {
      var n, o = e.keyCode;
      return "charCode" in e ? (n = e.charCode, n === 0 && o === 13 && (n = 13)) : n = o, n === 10 && (n = 13), n >= 32 || n === 13 ? n : 0;
    }
    function Hd() {
      return !0;
    }
    function vp() {
      return !1;
    }
    function hr(e) {
      function n(o, u, h, y, S) {
        this._reactName = o, this._targetInst = h, this.type = u, this.nativeEvent = y, this.target = S, this.currentTarget = null;
        for (var w in e)
          if (e.hasOwnProperty(w)) {
            var E = e[w];
            E ? this[w] = E(y) : this[w] = y[w];
          }
        var D = y.defaultPrevented != null ? y.defaultPrevented : y.returnValue === !1;
        return D ? this.isDefaultPrevented = Hd : this.isDefaultPrevented = vp, this.isPropagationStopped = vp, this;
      }
      return Pt(n.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var o = this.nativeEvent;
          o && (o.preventDefault ? o.preventDefault() : typeof o.returnValue != "unknown" && (o.returnValue = !1), this.isDefaultPrevented = Hd);
        },
        stopPropagation: function() {
          var o = this.nativeEvent;
          o && (o.stopPropagation ? o.stopPropagation() : typeof o.cancelBubble != "unknown" && (o.cancelBubble = !0), this.isPropagationStopped = Hd);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: Hd
      }), n;
    }
    var pi = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(e) {
        return e.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, Zs = hr(pi), kr = Pt({}, pi, {
      view: 0,
      detail: 0
    }), na = hr(kr), yy, yp, sc;
    function Zw(e) {
      e !== sc && (sc && e.type === "mousemove" ? (yy = e.screenX - sc.screenX, yp = e.screenY - sc.screenY) : (yy = 0, yp = 0), sc = e);
    }
    var Cs = Pt({}, kr, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Vn,
      button: 0,
      buttons: 0,
      relatedTarget: function(e) {
        return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
      },
      movementX: function(e) {
        return "movementX" in e ? e.movementX : (Zw(e), yy);
      },
      movementY: function(e) {
        return "movementY" in e ? e.movementY : yp;
      }
    }), X3 = hr(Cs), J3 = Pt({}, Cs, {
      dataTransfer: 0
    }), oc = hr(J3), e6 = Pt({}, kr, {
      relatedTarget: 0
    }), Mo = hr(e6), ZC = Pt({}, pi, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), XC = hr(ZC), t6 = Pt({}, pi, {
      clipboardData: function(e) {
        return "clipboardData" in e ? e.clipboardData : window.clipboardData;
      }
    }), gy = hr(t6), Xw = Pt({}, pi, {
      data: 0
    }), JC = hr(Xw), eS = JC, tS = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, lc = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function Jw(e) {
      if (e.key) {
        var n = tS[e.key] || e.key;
        if (n !== "Unidentified")
          return n;
      }
      if (e.type === "keypress") {
        var o = Al(e);
        return o === 13 ? "Enter" : String.fromCharCode(o);
      }
      return e.type === "keydown" || e.type === "keyup" ? lc[e.keyCode] || "Unidentified" : "";
    }
    var Fd = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function nS(e) {
      var n = this, o = n.nativeEvent;
      if (o.getModifierState)
        return o.getModifierState(e);
      var u = Fd[e];
      return u ? !!o[u] : !1;
    }
    function Vn(e) {
      return nS;
    }
    var eT = Pt({}, kr, {
      key: Jw,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Vn,
      // Legacy Interface
      charCode: function(e) {
        return e.type === "keypress" ? Al(e) : 0;
      },
      keyCode: function(e) {
        return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      },
      which: function(e) {
        return e.type === "keypress" ? Al(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
      }
    }), iS = hr(eT), tT = Pt({}, Cs, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), rS = hr(tT), aS = Pt({}, kr, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Vn
    }), sS = hr(aS), nT = Pt({}, pi, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), Ya = hr(nT), n6 = Pt({}, Cs, {
      deltaX: function(e) {
        return "deltaX" in e ? e.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in e ? -e.wheelDeltaX : 0
        );
      },
      deltaY: function(e) {
        return "deltaY" in e ? e.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in e ? -e.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in e ? -e.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    }), iT = hr(n6), Pl = [9, 13, 27, 32], gp = 229, Ao = Wn && "CompositionEvent" in window, Ol = null;
    Wn && "documentMode" in document && (Ol = document.documentMode);
    var i6 = Wn && "TextEvent" in window && !Ol, Cy = Wn && (!Ao || Ol && Ol > 8 && Ol <= 11), oS = 32, Sy = String.fromCharCode(oS);
    function rT() {
      bi("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), bi("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), bi("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), bi("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
    }
    var r6 = !1;
    function lS(e) {
      return (e.ctrlKey || e.altKey || e.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
      !(e.ctrlKey && e.altKey);
    }
    function by(e) {
      switch (e) {
        case "compositionstart":
          return "onCompositionStart";
        case "compositionend":
          return "onCompositionEnd";
        case "compositionupdate":
          return "onCompositionUpdate";
      }
    }
    function wy(e, n) {
      return e === "keydown" && n.keyCode === gp;
    }
    function a6(e, n) {
      switch (e) {
        case "keyup":
          return Pl.indexOf(n.keyCode) !== -1;
        case "keydown":
          return n.keyCode !== gp;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function Ty(e) {
      var n = e.detail;
      return typeof n == "object" && "data" in n ? n.data : null;
    }
    function s6(e) {
      return e.locale === "ko";
    }
    var _l = !1;
    function Ey(e, n, o, u, h) {
      var y, S;
      if (Ao ? y = by(n) : _l ? a6(n, u) && (y = "onCompositionEnd") : wy(n, u) && (y = "onCompositionStart"), !y)
        return null;
      Cy && !s6(u) && (!_l && y === "onCompositionStart" ? _l = Ml(h) : y === "onCompositionEnd" && _l && (S = Do()));
      var w = pS(o, y);
      if (w.length > 0) {
        var E = new JC(y, n, null, u, h);
        if (e.push({
          event: E,
          listeners: w
        }), S)
          E.data = S;
        else {
          var D = Ty(u);
          D !== null && (E.data = D);
        }
      }
    }
    function o6(e, n) {
      switch (e) {
        case "compositionend":
          return Ty(n);
        case "keypress":
          var o = n.which;
          return o !== oS ? null : (r6 = !0, Sy);
        case "textInput":
          var u = n.data;
          return u === Sy && r6 ? null : u;
        default:
          return null;
      }
    }
    function ky(e, n) {
      if (_l) {
        if (e === "compositionend" || !Ao && a6(e, n)) {
          var o = Do();
          return vy(), _l = !1, o;
        }
        return null;
      }
      switch (e) {
        case "paste":
          return null;
        case "keypress":
          if (!lS(n)) {
            if (n.char && n.char.length > 1)
              return n.char;
            if (n.which)
              return String.fromCharCode(n.which);
          }
          return null;
        case "compositionend":
          return Cy && !s6(n) ? null : n.data;
        default:
          return null;
      }
    }
    function uS(e, n, o, u, h) {
      var y;
      if (i6 ? y = o6(n, u) : y = ky(n, u), !y)
        return null;
      var S = pS(o, "onBeforeInput");
      if (S.length > 0) {
        var w = new eS("onBeforeInput", "beforeinput", null, u, h);
        e.push({
          event: w,
          listeners: S
        }), w.data = y;
      }
    }
    function aT(e, n, o, u, h, y, S) {
      Ey(e, n, o, u, h), uS(e, n, o, u, h);
    }
    var xy = {
      color: !0,
      date: !0,
      datetime: !0,
      "datetime-local": !0,
      email: !0,
      month: !0,
      number: !0,
      password: !0,
      range: !0,
      search: !0,
      tel: !0,
      text: !0,
      time: !0,
      url: !0,
      week: !0
    };
    function cS(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n === "input" ? !!xy[e.type] : n === "textarea";
    }
    /**
     * Checks if an event is supported in the current execution environment.
     *
     * NOTE: This will not work correctly for non-generic events such as `change`,
     * `reset`, `load`, `error`, and `select`.
     *
     * Borrows from Modernizr.
     *
     * @param {string} eventNameSuffix Event name, e.g. "click".
     * @return {boolean} True if the event is supported.
     * @internal
     * @license Modernizr 3.0.0pre (Custom Build) | MIT
     */
    function Cp(e) {
      if (!Wn)
        return !1;
      var n = "on" + e, o = n in document;
      if (!o) {
        var u = document.createElement("div");
        u.setAttribute(n, "return;"), o = typeof u[n] == "function";
      }
      return o;
    }
    function sT() {
      bi("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
    }
    function Sp(e, n, o, u) {
      Ed(u);
      var h = pS(n, "onChange");
      if (h.length > 0) {
        var y = new Zs("onChange", "change", null, o, u);
        e.push({
          event: y,
          listeners: h
        });
      }
    }
    var i = null, a = null;
    function d(e) {
      var n = e.nodeName && e.nodeName.toLowerCase();
      return n === "select" || n === "input" && e.type === "file";
    }
    function p(e) {
      var n = [];
      Sp(n, a, e, w3(e)), TC(C, n);
    }
    function C(e) {
      Tx(e, 0);
    }
    function b(e) {
      var n = Ay(e);
      if (Ou(n))
        return e;
    }
    function R(e, n) {
      if (e === "change")
        return n;
    }
    var O = !1;
    Wn && (O = Cp("input") && (!document.documentMode || document.documentMode > 9));
    function N(e, n) {
      i = e, a = n, i.attachEvent("onpropertychange", ae);
    }
    function Y() {
      i && (i.detachEvent("onpropertychange", ae), i = null, a = null);
    }
    function ae(e) {
      e.propertyName === "value" && b(a) && p(e);
    }
    function oe(e, n, o) {
      e === "focusin" ? (Y(), N(n, o)) : e === "focusout" && Y();
    }
    function re(e, n) {
      if (e === "selectionchange" || e === "keyup" || e === "keydown")
        return b(a);
    }
    function Te(e) {
      var n = e.nodeName;
      return n && n.toLowerCase() === "input" && (e.type === "checkbox" || e.type === "radio");
    }
    function Ae(e, n) {
      if (e === "click")
        return b(n);
    }
    function _e(e, n) {
      if (e === "input" || e === "change")
        return b(n);
    }
    function ti(e) {
      var n = e._wrapperState;
      !n || !n.controlled || e.type !== "number" || yv(e, "number", e.value);
    }
    function B(e, n, o, u, h, y, S) {
      var w = o ? Ay(o) : window, E, D;
      if (d(w) ? E = R : cS(w) ? O ? E = _e : (E = re, D = oe) : Te(w) && (E = Ae), E) {
        var M = E(n, o);
        if (M) {
          Sp(e, M, u, h);
          return;
        }
      }
      D && D(n, w, o), n === "focusout" && ti(w);
    }
    function z() {
      Bi("onMouseEnter", ["mouseout", "mouseover"]), Bi("onMouseLeave", ["mouseout", "mouseover"]), Bi("onPointerEnter", ["pointerout", "pointerover"]), Bi("onPointerLeave", ["pointerout", "pointerover"]);
    }
    function G(e, n, o, u, h, y, S) {
      var w = n === "mouseover" || n === "pointerover", E = n === "mouseout" || n === "pointerout";
      if (w && !Nh(u)) {
        var D = u.relatedTarget || u.fromElement;
        if (D && (Tp(D) || b6(D)))
          return;
      }
      if (!(!E && !w)) {
        var M;
        if (h.window === h)
          M = h;
        else {
          var H = h.ownerDocument;
          H ? M = H.defaultView || H.parentWindow : M = window;
        }
        var V, Q;
        if (E) {
          var W = u.relatedTarget || u.toElement;
          if (V = o, Q = W ? Tp(W) : null, Q !== null) {
            var X = pa(Q);
            (Q !== X || Q.tag !== F && Q.tag !== Z) && (Q = null);
          }
        } else
          V = null, Q = o;
        if (V !== Q) {
          var Ce = X3, Qe = "onMouseLeave", Ue = "onMouseEnter", Ut = "mouse";
          (n === "pointerout" || n === "pointerover") && (Ce = rS, Qe = "onPointerLeave", Ue = "onPointerEnter", Ut = "pointer");
          var Dt = V == null ? M : Ay(V), q = Q == null ? M : Ay(Q), J = new Ce(Qe, Ut + "leave", V, u, h);
          J.target = Dt, J.relatedTarget = q;
          var j = null, le = Tp(h);
          if (le === o) {
            var xe = new Ce(Ue, Ut + "enter", Q, u, h);
            xe.target = q, xe.relatedTarget = Dt, j = xe;
          }
          EF(e, J, j, V, Q);
        }
      }
    }
    function de(e, n) {
      return e === n && (e !== 0 || 1 / e === 1 / n) || e !== e && n !== n;
    }
    var be = typeof Object.is == "function" ? Object.is : de;
    function Be(e, n) {
      if (be(e, n))
        return !0;
      if (typeof e != "object" || e === null || typeof n != "object" || n === null)
        return !1;
      var o = Object.keys(e), u = Object.keys(n);
      if (o.length !== u.length)
        return !1;
      for (var h = 0; h < o.length; h++) {
        var y = o[h];
        if (!Cr.call(n, y) || !be(e[y], n[y]))
          return !1;
      }
      return !0;
    }
    function Ke(e) {
      for (; e && e.firstChild; )
        e = e.firstChild;
      return e;
    }
    function ot(e) {
      for (; e; ) {
        if (e.nextSibling)
          return e.nextSibling;
        e = e.parentNode;
      }
    }
    function xi(e, n) {
      for (var o = Ke(e), u = 0, h = 0; o; ) {
        if (o.nodeType === bo) {
          if (h = u + o.textContent.length, u <= n && h >= n)
            return {
              node: o,
              offset: n - u
            };
          u = h;
        }
        o = Ke(ot(o));
      }
    }
    function Kt(e) {
      var n = e.ownerDocument, o = n && n.defaultView || window, u = o.getSelection && o.getSelection();
      if (!u || u.rangeCount === 0)
        return null;
      var h = u.anchorNode, y = u.anchorOffset, S = u.focusNode, w = u.focusOffset;
      try {
        h.nodeType, S.nodeType;
      } catch {
        return null;
      }
      return Nl(e, h, y, S, w);
    }
    function Nl(e, n, o, u, h) {
      var y = 0, S = -1, w = -1, E = 0, D = 0, M = e, H = null;
      e: for (; ; ) {
        for (var V = null; M === n && (o === 0 || M.nodeType === bo) && (S = y + o), M === u && (h === 0 || M.nodeType === bo) && (w = y + h), M.nodeType === bo && (y += M.nodeValue.length), (V = M.firstChild) !== null; )
          H = M, M = V;
        for (; ; ) {
          if (M === e)
            break e;
          if (H === n && ++E === o && (S = y), H === u && ++D === h && (w = y), (V = M.nextSibling) !== null)
            break;
          M = H, H = M.parentNode;
        }
        M = V;
      }
      return S === -1 || w === -1 ? null : {
        start: S,
        end: w
      };
    }
    function oT(e, n) {
      var o = e.ownerDocument || document, u = o && o.defaultView || window;
      if (u.getSelection) {
        var h = u.getSelection(), y = e.textContent.length, S = Math.min(n.start, y), w = n.end === void 0 ? S : Math.min(n.end, y);
        if (!h.extend && S > w) {
          var E = w;
          w = S, S = E;
        }
        var D = xi(e, S), M = xi(e, w);
        if (D && M) {
          if (h.rangeCount === 1 && h.anchorNode === D.node && h.anchorOffset === D.offset && h.focusNode === M.node && h.focusOffset === M.offset)
            return;
          var H = o.createRange();
          H.setStart(D.node, D.offset), h.removeAllRanges(), S > w ? (h.addRange(H), h.extend(M.node, M.offset)) : (H.setEnd(M.node, M.offset), h.addRange(H));
        }
      }
    }
    function dx(e) {
      return e && e.nodeType === bo;
    }
    function fx(e, n) {
      return !e || !n ? !1 : e === n ? !0 : dx(e) ? !1 : dx(n) ? fx(e, n.parentNode) : "contains" in e ? e.contains(n) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(n) & 16) : !1;
    }
    function sF(e) {
      return e && e.ownerDocument && fx(e.ownerDocument.documentElement, e);
    }
    function oF(e) {
      try {
        return typeof e.contentWindow.location.href == "string";
      } catch {
        return !1;
      }
    }
    function hx() {
      for (var e = window, n = _u(); n instanceof e.HTMLIFrameElement; ) {
        if (oF(n))
          e = n.contentWindow;
        else
          return n;
        n = _u(e.document);
      }
      return n;
    }
    function lT(e) {
      var n = e && e.nodeName && e.nodeName.toLowerCase();
      return n && (n === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || n === "textarea" || e.contentEditable === "true");
    }
    function lF() {
      var e = hx();
      return {
        focusedElem: e,
        selectionRange: lT(e) ? cF(e) : null
      };
    }
    function uF(e) {
      var n = hx(), o = e.focusedElem, u = e.selectionRange;
      if (n !== o && sF(o)) {
        u !== null && lT(o) && dF(o, u);
        for (var h = [], y = o; y = y.parentNode; )
          y.nodeType === Gr && h.push({
            element: y,
            left: y.scrollLeft,
            top: y.scrollTop
          });
        typeof o.focus == "function" && o.focus();
        for (var S = 0; S < h.length; S++) {
          var w = h[S];
          w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
      }
    }
    function cF(e) {
      var n;
      return "selectionStart" in e ? n = {
        start: e.selectionStart,
        end: e.selectionEnd
      } : n = Kt(e), n || {
        start: 0,
        end: 0
      };
    }
    function dF(e, n) {
      var o = n.start, u = n.end;
      u === void 0 && (u = o), "selectionStart" in e ? (e.selectionStart = o, e.selectionEnd = Math.min(u, e.value.length)) : oT(e, n);
    }
    var fF = Wn && "documentMode" in document && document.documentMode <= 11;
    function hF() {
      bi("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
    }
    var Ry = null, uT = null, l6 = null, cT = !1;
    function pF(e) {
      if ("selectionStart" in e && lT(e))
        return {
          start: e.selectionStart,
          end: e.selectionEnd
        };
      var n = e.ownerDocument && e.ownerDocument.defaultView || window, o = n.getSelection();
      return {
        anchorNode: o.anchorNode,
        anchorOffset: o.anchorOffset,
        focusNode: o.focusNode,
        focusOffset: o.focusOffset
      };
    }
    function mF(e) {
      return e.window === e ? e.document : e.nodeType === wo ? e : e.ownerDocument;
    }
    function px(e, n, o) {
      var u = mF(o);
      if (!(cT || Ry == null || Ry !== _u(u))) {
        var h = pF(Ry);
        if (!l6 || !Be(l6, h)) {
          l6 = h;
          var y = pS(uT, "onSelect");
          if (y.length > 0) {
            var S = new Zs("onSelect", "select", null, n, o);
            e.push({
              event: S,
              listeners: y
            }), S.target = Ry;
          }
        }
      }
    }
    function vF(e, n, o, u, h, y, S) {
      var w = o ? Ay(o) : window;
      switch (n) {
        // Track the input node that has focus.
        case "focusin":
          (cS(w) || w.contentEditable === "true") && (Ry = w, uT = o, l6 = null);
          break;
        case "focusout":
          Ry = null, uT = null, l6 = null;
          break;
        // Don't fire the event while the user is dragging. This matches the
        // semantics of the native select event.
        case "mousedown":
          cT = !0;
          break;
        case "contextmenu":
        case "mouseup":
        case "dragend":
          cT = !1, px(e, u, h);
          break;
        // Chrome and IE fire non-standard event when selection is changed (and
        // sometimes when it hasn't). IE's event fires out of order with respect
        // to key and input events on deletion, so we discard it.
        //
        // Firefox doesn't support selectionchange, so check selection status
        // after each key entry. The selection changes after keydown and before
        // keyup, but we check on keydown as well in the case of holding down a
        // key, when multiple keydown events are fired but only one keyup is.
        // This is also our approach for IE handling, for the reason above.
        case "selectionchange":
          if (fF)
            break;
        // falls through
        case "keydown":
        case "keyup":
          px(e, u, h);
      }
    }
    function dS(e, n) {
      var o = {};
      return o[e.toLowerCase()] = n.toLowerCase(), o["Webkit" + e] = "webkit" + n, o["Moz" + e] = "moz" + n, o;
    }
    var Ly = {
      animationend: dS("Animation", "AnimationEnd"),
      animationiteration: dS("Animation", "AnimationIteration"),
      animationstart: dS("Animation", "AnimationStart"),
      transitionend: dS("Transition", "TransitionEnd")
    }, dT = {}, mx = {};
    Wn && (mx = document.createElement("div").style, "AnimationEvent" in window || (delete Ly.animationend.animation, delete Ly.animationiteration.animation, delete Ly.animationstart.animation), "TransitionEvent" in window || delete Ly.transitionend.transition);
    function fS(e) {
      if (dT[e])
        return dT[e];
      if (!Ly[e])
        return e;
      var n = Ly[e];
      for (var o in n)
        if (n.hasOwnProperty(o) && o in mx)
          return dT[e] = n[o];
      return e;
    }
    var vx = fS("animationend"), yx = fS("animationiteration"), gx = fS("animationstart"), Cx = fS("transitionend"), Sx = /* @__PURE__ */ new Map(), bx = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
    function Id(e, n) {
      Sx.set(e, n), bi(n, [e]);
    }
    function yF() {
      for (var e = 0; e < bx.length; e++) {
        var n = bx[e], o = n.toLowerCase(), u = n[0].toUpperCase() + n.slice(1);
        Id(o, "on" + u);
      }
      Id(vx, "onAnimationEnd"), Id(yx, "onAnimationIteration"), Id(gx, "onAnimationStart"), Id("dblclick", "onDoubleClick"), Id("focusin", "onFocus"), Id("focusout", "onBlur"), Id(Cx, "onTransitionEnd");
    }
    function gF(e, n, o, u, h, y, S) {
      var w = Sx.get(n);
      if (w !== void 0) {
        var E = Zs, D = n;
        switch (n) {
          case "keypress":
            if (Al(u) === 0)
              return;
          /* falls through */
          case "keydown":
          case "keyup":
            E = iS;
            break;
          case "focusin":
            D = "focus", E = Mo;
            break;
          case "focusout":
            D = "blur", E = Mo;
            break;
          case "beforeblur":
          case "afterblur":
            E = Mo;
            break;
          case "click":
            if (u.button === 2)
              return;
          /* falls through */
          case "auxclick":
          case "dblclick":
          case "mousedown":
          case "mousemove":
          case "mouseup":
          // TODO: Disabled elements should not respond to mouse events
          /* falls through */
          case "mouseout":
          case "mouseover":
          case "contextmenu":
            E = X3;
            break;
          case "drag":
          case "dragend":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "dragstart":
          case "drop":
            E = oc;
            break;
          case "touchcancel":
          case "touchend":
          case "touchmove":
          case "touchstart":
            E = sS;
            break;
          case vx:
          case yx:
          case gx:
            E = XC;
            break;
          case Cx:
            E = Ya;
            break;
          case "scroll":
            E = na;
            break;
          case "wheel":
            E = iT;
            break;
          case "copy":
          case "cut":
          case "paste":
            E = gy;
            break;
          case "gotpointercapture":
          case "lostpointercapture":
          case "pointercancel":
          case "pointerdown":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "pointerup":
            E = rS;
            break;
        }
        var M = (y & za) !== 0;
        {
          var H = !M && // TODO: ideally, we'd eventually add all events from
          // nonDelegatedEvents list in DOMPluginEventSystem.
          // Then we can remove this special list.
          // This is a breaking change that can wait until React 18.
          n === "scroll", V = wF(o, w, u.type, M, H);
          if (V.length > 0) {
            var Q = new E(w, D, null, u, h);
            e.push({
              event: Q,
              listeners: V
            });
          }
        }
      }
    }
    yF(), z(), sT(), hF(), rT();
    function CF(e, n, o, u, h, y, S) {
      gF(e, n, o, u, h, y);
      var w = (y & b3) === 0;
      w && (G(e, n, o, u, h), B(e, n, o, u, h), vF(e, n, o, u, h), aT(e, n, o, u, h));
    }
    var u6 = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], fT = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(u6));
    function wx(e, n, o) {
      var u = e.type || "unknown-event";
      e.currentTarget = o, Fs(u, n, void 0, e), e.currentTarget = null;
    }
    function SF(e, n, o) {
      var u;
      if (o)
        for (var h = n.length - 1; h >= 0; h--) {
          var y = n[h], S = y.instance, w = y.currentTarget, E = y.listener;
          if (S !== u && e.isPropagationStopped())
            return;
          wx(e, E, w), u = S;
        }
      else
        for (var D = 0; D < n.length; D++) {
          var M = n[D], H = M.instance, V = M.currentTarget, Q = M.listener;
          if (H !== u && e.isPropagationStopped())
            return;
          wx(e, Q, V), u = H;
        }
    }
    function Tx(e, n) {
      for (var o = (n & za) !== 0, u = 0; u < e.length; u++) {
        var h = e[u], y = h.event, S = h.listeners;
        SF(y, S, o);
      }
      zh();
    }
    function bF(e, n, o, u, h) {
      var y = w3(o), S = [];
      CF(S, e, u, o, y, n), Tx(S, n);
    }
    function Hn(e, n) {
      fT.has(e) || g('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', e);
      var o = !1, u = ZI(n), h = kF(e);
      u.has(h) || (Ex(n, e, xv, o), u.add(h));
    }
    function hT(e, n, o) {
      fT.has(e) && !n && g('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', e);
      var u = 0;
      n && (u |= za), Ex(o, e, u, n);
    }
    var hS = "_reactListening" + Math.random().toString(36).slice(2);
    function c6(e) {
      if (!e[hS]) {
        e[hS] = !0, Ci.forEach(function(o) {
          o !== "selectionchange" && (fT.has(o) || hT(o, !1, e), hT(o, !0, e));
        });
        var n = e.nodeType === wo ? e : e.ownerDocument;
        n !== null && (n[hS] || (n[hS] = !0, hT("selectionchange", !1, n)));
      }
    }
    function Ex(e, n, o, u, h) {
      var y = Ki(e, n, o), S = void 0;
      Uh && (n === "touchstart" || n === "touchmove" || n === "wheel") && (S = !0), e = e, u ? S !== void 0 ? Z3(e, n, y, S) : ta(e, n, y) : S !== void 0 ? Ud(e, n, y, S) : pp(e, n, y);
    }
    function kx(e, n) {
      return e === n || e.nodeType === oi && e.parentNode === n;
    }
    function pT(e, n, o, u, h) {
      var y = u;
      if (!(n & S3) && !(n & xv)) {
        var S = h;
        if (u !== null) {
          var w = u;
          e: for (; ; ) {
            if (w === null)
              return;
            var E = w.tag;
            if (E === A || E === U) {
              var D = w.stateNode.containerInfo;
              if (kx(D, S))
                break;
              if (E === U)
                for (var M = w.return; M !== null; ) {
                  var H = M.tag;
                  if (H === A || H === U) {
                    var V = M.stateNode.containerInfo;
                    if (kx(V, S))
                      return;
                  }
                  M = M.return;
                }
              for (; D !== null; ) {
                var Q = Tp(D);
                if (Q === null)
                  return;
                var W = Q.tag;
                if (W === F || W === Z) {
                  w = y = Q;
                  continue e;
                }
                D = D.parentNode;
              }
            }
            w = w.return;
          }
        }
      }
      TC(function() {
        return bF(e, n, o, y);
      });
    }
    function d6(e, n, o) {
      return {
        instance: e,
        listener: n,
        currentTarget: o
      };
    }
    function wF(e, n, o, u, h, y) {
      for (var S = n !== null ? n + "Capture" : null, w = u ? S : n, E = [], D = e, M = null; D !== null; ) {
        var H = D, V = H.stateNode, Q = H.tag;
        if (Q === F && V !== null && (M = V, w !== null)) {
          var W = Cl(D, w);
          W != null && E.push(d6(D, W, M));
        }
        if (h)
          break;
        D = D.return;
      }
      return E;
    }
    function pS(e, n) {
      for (var o = n + "Capture", u = [], h = e; h !== null; ) {
        var y = h, S = y.stateNode, w = y.tag;
        if (w === F && S !== null) {
          var E = S, D = Cl(h, o);
          D != null && u.unshift(d6(h, D, E));
          var M = Cl(h, n);
          M != null && u.push(d6(h, M, E));
        }
        h = h.return;
      }
      return u;
    }
    function $y(e) {
      if (e === null)
        return null;
      do
        e = e.return;
      while (e && e.tag !== F);
      return e || null;
    }
    function TF(e, n) {
      for (var o = e, u = n, h = 0, y = o; y; y = $y(y))
        h++;
      for (var S = 0, w = u; w; w = $y(w))
        S++;
      for (; h - S > 0; )
        o = $y(o), h--;
      for (; S - h > 0; )
        u = $y(u), S--;
      for (var E = h; E--; ) {
        if (o === u || u !== null && o === u.alternate)
          return o;
        o = $y(o), u = $y(u);
      }
      return null;
    }
    function xx(e, n, o, u, h) {
      for (var y = n._reactName, S = [], w = o; w !== null && w !== u; ) {
        var E = w, D = E.alternate, M = E.stateNode, H = E.tag;
        if (D !== null && D === u)
          break;
        if (H === F && M !== null) {
          var V = M;
          if (h) {
            var Q = Cl(w, y);
            Q != null && S.unshift(d6(w, Q, V));
          } else if (!h) {
            var W = Cl(w, y);
            W != null && S.push(d6(w, W, V));
          }
        }
        w = w.return;
      }
      S.length !== 0 && e.push({
        event: n,
        listeners: S
      });
    }
    function EF(e, n, o, u, h) {
      var y = u && h ? TF(u, h) : null;
      u !== null && xx(e, n, u, y, !1), h !== null && o !== null && xx(e, o, h, y, !0);
    }
    function kF(e, n) {
      return e + "__bubble";
    }
    var Wa = !1, f6 = "dangerouslySetInnerHTML", mS = "suppressContentEditableWarning", Bd = "suppressHydrationWarning", Rx = "autoFocus", bp = "children", wp = "style", vS = "__html", mT, yS, h6, Lx, gS, $x, Dx;
    mT = {
      // There are working polyfills for <dialog>. Let people use it.
      dialog: !0,
      // Electron ships a custom <webview> tag to display external web content in
      // an isolated frame and process.
      // This tag is not present in non Electron environments such as JSDom which
      // is often used for testing purposes.
      // @see https://electronjs.org/docs/api/webview-tag
      webview: !0
    }, yS = function(e, n) {
      y3(e, n), Ev(e, n), SC(e, n, {
        registrationNameDependencies: Si,
        possibleRegistrationNames: Ii
      });
    }, $x = Wn && !document.documentMode, h6 = function(e, n, o) {
      if (!Wa) {
        var u = CS(o), h = CS(n);
        h !== u && (Wa = !0, g("Prop `%s` did not match. Server: %s Client: %s", e, JSON.stringify(h), JSON.stringify(u)));
      }
    }, Lx = function(e) {
      if (!Wa) {
        Wa = !0;
        var n = [];
        e.forEach(function(o) {
          n.push(o);
        }), g("Extra attributes from the server: %s", n);
      }
    }, gS = function(e, n) {
      n === !1 ? g("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", e, e, e) : g("Expected `%s` listener to be a function, instead got a value of `%s` type.", e, typeof n);
    }, Dx = function(e, n) {
      var o = e.namespaceURI === So ? e.ownerDocument.createElement(e.tagName) : e.ownerDocument.createElementNS(e.namespaceURI, e.tagName);
      return o.innerHTML = n, o.innerHTML;
    };
    var xF = /\r\n?/g, RF = /\u0000|\uFFFD/g;
    function CS(e) {
      ku(e);
      var n = typeof e == "string" ? e : "" + e;
      return n.replace(xF, `
`).replace(RF, "");
    }
    function SS(e, n, o, u) {
      var h = CS(n), y = CS(e);
      if (y !== h && (u && (Wa || (Wa = !0, g('Text content did not match. Server: "%s" Client: "%s"', y, h))), o && rt))
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function Mx(e) {
      return e.nodeType === wo ? e : e.ownerDocument;
    }
    function LF() {
    }
    function bS(e) {
      e.onclick = LF;
    }
    function $F(e, n, o, u, h) {
      for (var y in u)
        if (u.hasOwnProperty(y)) {
          var S = u[y];
          if (y === wp)
            S && Object.freeze(S), pC(n, S);
          else if (y === f6) {
            var w = S ? S[vS] : void 0;
            w != null && nC(n, w);
          } else if (y === bp)
            if (typeof S == "string") {
              var E = e !== "textarea" || S !== "";
              E && Sd(n, S);
            } else typeof S == "number" && Sd(n, "" + S);
          else y === mS || y === Bd || y === Rx || (Si.hasOwnProperty(y) ? S != null && (typeof S != "function" && gS(y, S), y === "onScroll" && Hn("scroll", n)) : S != null && Lu(n, y, S, h));
        }
    }
    function DF(e, n, o, u) {
      for (var h = 0; h < n.length; h += 2) {
        var y = n[h], S = n[h + 1];
        y === wp ? pC(e, S) : y === f6 ? nC(e, S) : y === bp ? Sd(e, S) : Lu(e, y, S, u);
      }
    }
    function MF(e, n, o, u) {
      var h, y = Mx(o), S, w = u;
      if (w === So && (w = c3(e)), w === So) {
        if (h = yl(e, n), !h && e !== e.toLowerCase() && g("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", e), e === "script") {
          var E = y.createElement("div");
          E.innerHTML = "<script><\/script>";
          var D = E.firstChild;
          S = E.removeChild(D);
        } else if (typeof n.is == "string")
          S = y.createElement(e, {
            is: n.is
          });
        else if (S = y.createElement(e), e === "select") {
          var M = S;
          n.multiple ? M.multiple = !0 : n.size && (M.size = n.size);
        }
      } else
        S = y.createElementNS(w, e);
      return w === So && !h && Object.prototype.toString.call(S) === "[object HTMLUnknownElement]" && !Cr.call(mT, e) && (mT[e] = !0, g("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", e)), S;
    }
    function AF(e, n) {
      return Mx(n).createTextNode(e);
    }
    function PF(e, n, o, u) {
      var h = yl(n, o);
      yS(n, o);
      var y;
      switch (n) {
        case "dialog":
          Hn("cancel", e), Hn("close", e), y = o;
          break;
        case "iframe":
        case "object":
        case "embed":
          Hn("load", e), y = o;
          break;
        case "video":
        case "audio":
          for (var S = 0; S < u6.length; S++)
            Hn(u6[S], e);
          y = o;
          break;
        case "source":
          Hn("error", e), y = o;
          break;
        case "img":
        case "image":
        case "link":
          Hn("error", e), Hn("load", e), y = o;
          break;
        case "details":
          Hn("toggle", e), y = o;
          break;
        case "input":
          Co(e, o), y = hv(e, o), Hn("invalid", e);
          break;
        case "option":
          gd(e, o), y = o;
          break;
        case "select":
          Cv(e, o), y = a3(e, o), Hn("invalid", e);
          break;
        case "textarea":
          o3(e, o), y = s3(e, o), Hn("invalid", e);
          break;
        default:
          y = o;
      }
      switch (wv(n, y), $F(n, e, u, y, h), n) {
        case "input":
          vl(e), n3(e, o, !1);
          break;
        case "textarea":
          vl(e), eC(e);
          break;
        case "option":
          Dw(e, o);
          break;
        case "select":
          Aw(e, o);
          break;
        default:
          typeof y.onClick == "function" && bS(e);
          break;
      }
    }
    function OF(e, n, o, u, h) {
      yS(n, u);
      var y = null, S, w;
      switch (n) {
        case "input":
          S = hv(e, o), w = hv(e, u), y = [];
          break;
        case "select":
          S = a3(e, o), w = a3(e, u), y = [];
          break;
        case "textarea":
          S = s3(e, o), w = s3(e, u), y = [];
          break;
        default:
          S = o, w = u, typeof S.onClick != "function" && typeof w.onClick == "function" && bS(e);
          break;
      }
      wv(n, w);
      var E, D, M = null;
      for (E in S)
        if (!(w.hasOwnProperty(E) || !S.hasOwnProperty(E) || S[E] == null))
          if (E === wp) {
            var H = S[E];
            for (D in H)
              H.hasOwnProperty(D) && (M || (M = {}), M[D] = "");
          } else E === f6 || E === bp || E === mS || E === Bd || E === Rx || (Si.hasOwnProperty(E) ? y || (y = []) : (y = y || []).push(E, null));
      for (E in w) {
        var V = w[E], Q = S != null ? S[E] : void 0;
        if (!(!w.hasOwnProperty(E) || V === Q || V == null && Q == null))
          if (E === wp)
            if (V && Object.freeze(V), Q) {
              for (D in Q)
                Q.hasOwnProperty(D) && (!V || !V.hasOwnProperty(D)) && (M || (M = {}), M[D] = "");
              for (D in V)
                V.hasOwnProperty(D) && Q[D] !== V[D] && (M || (M = {}), M[D] = V[D]);
            } else
              M || (y || (y = []), y.push(E, M)), M = V;
          else if (E === f6) {
            var W = V ? V[vS] : void 0, X = Q ? Q[vS] : void 0;
            W != null && X !== W && (y = y || []).push(E, W);
          } else E === bp ? (typeof V == "string" || typeof V == "number") && (y = y || []).push(E, "" + V) : E === mS || E === Bd || (Si.hasOwnProperty(E) ? (V != null && (typeof V != "function" && gS(E, V), E === "onScroll" && Hn("scroll", e)), !y && Q !== V && (y = [])) : (y = y || []).push(E, V));
      }
      return M && (Fw(M, w[wp]), (y = y || []).push(wp, M)), y;
    }
    function _F(e, n, o, u, h) {
      o === "input" && h.type === "radio" && h.name != null && pv(e, h);
      var y = yl(o, u), S = yl(o, h);
      switch (DF(e, n, y, S), o) {
        case "input":
          yd(e, h);
          break;
        case "textarea":
          J0(e, h);
          break;
        case "select":
          Pw(e, h);
          break;
      }
    }
    function NF(e) {
      {
        var n = e.toLowerCase();
        return Oh.hasOwnProperty(n) && Oh[n] || null;
      }
    }
    function VF(e, n, o, u, h, y, S) {
      var w, E;
      switch (w = yl(n, o), yS(n, o), n) {
        case "dialog":
          Hn("cancel", e), Hn("close", e);
          break;
        case "iframe":
        case "object":
        case "embed":
          Hn("load", e);
          break;
        case "video":
        case "audio":
          for (var D = 0; D < u6.length; D++)
            Hn(u6[D], e);
          break;
        case "source":
          Hn("error", e);
          break;
        case "img":
        case "image":
        case "link":
          Hn("error", e), Hn("load", e);
          break;
        case "details":
          Hn("toggle", e);
          break;
        case "input":
          Co(e, o), Hn("invalid", e);
          break;
        case "option":
          gd(e, o);
          break;
        case "select":
          Cv(e, o), Hn("invalid", e);
          break;
        case "textarea":
          o3(e, o), Hn("invalid", e);
          break;
      }
      wv(n, o);
      {
        E = /* @__PURE__ */ new Set();
        for (var M = e.attributes, H = 0; H < M.length; H++) {
          var V = M[H].name.toLowerCase();
          switch (V) {
            // Controlled attributes are not validated
            // TODO: Only ignore them on controlled tags.
            case "value":
              break;
            case "checked":
              break;
            case "selected":
              break;
            default:
              E.add(M[H].name);
          }
        }
      }
      var Q = null;
      for (var W in o)
        if (o.hasOwnProperty(W)) {
          var X = o[W];
          if (W === bp)
            typeof X == "string" ? e.textContent !== X && (o[Bd] !== !0 && SS(e.textContent, X, y, S), Q = [bp, X]) : typeof X == "number" && e.textContent !== "" + X && (o[Bd] !== !0 && SS(e.textContent, X, y, S), Q = [bp, "" + X]);
          else if (Si.hasOwnProperty(W))
            X != null && (typeof X != "function" && gS(W, X), W === "onScroll" && Hn("scroll", e));
          else if (S && // Convince Flow we've calculated it (it's DEV-only in this method.)
          typeof w == "boolean") {
            var Ce = void 0, Qe = si(W);
            if (o[Bd] !== !0) {
              if (!(W === mS || W === Bd || // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              W === "value" || W === "checked" || W === "selected")) {
                if (W === f6) {
                  var Ue = e.innerHTML, Ut = X ? X[vS] : void 0;
                  if (Ut != null) {
                    var Dt = Dx(e, Ut);
                    Dt !== Ue && h6(W, Ue, Dt);
                  }
                } else if (W === wp) {
                  if (E.delete(W), $x) {
                    var q = zw(X);
                    Ce = e.getAttribute("style"), q !== Ce && h6(W, Ce, q);
                  }
                } else if (w)
                  E.delete(W.toLowerCase()), Ce = I1(e, W, X), X !== Ce && h6(W, Ce, X);
                else if (!Br(W, Qe, w) && !qr(W, X, Qe, w)) {
                  var J = !1;
                  if (Qe !== null)
                    E.delete(Qe.attributeName), Ce = F1(e, W, X, Qe);
                  else {
                    var j = u;
                    if (j === So && (j = c3(n)), j === So)
                      E.delete(W.toLowerCase());
                    else {
                      var le = NF(W);
                      le !== null && le !== W && (J = !0, E.delete(le)), E.delete(W);
                    }
                    Ce = I1(e, W, X);
                  }
                  var xe = At;
                  !xe && X !== Ce && !J && h6(W, Ce, X);
                }
              }
            }
          }
        }
      switch (S && // $FlowFixMe - Should be inferred as not undefined.
      E.size > 0 && o[Bd] !== !0 && Lx(E), n) {
        case "input":
          vl(e), n3(e, o, !0);
          break;
        case "textarea":
          vl(e), eC(e);
          break;
        case "select":
        case "option":
          break;
        default:
          typeof o.onClick == "function" && bS(e);
          break;
      }
      return Q;
    }
    function UF(e, n, o) {
      var u = e.nodeValue !== n;
      return u;
    }
    function vT(e, n) {
      {
        if (Wa)
          return;
        Wa = !0, g("Did not expect server HTML to contain a <%s> in <%s>.", n.nodeName.toLowerCase(), e.nodeName.toLowerCase());
      }
    }
    function yT(e, n) {
      {
        if (Wa)
          return;
        Wa = !0, g('Did not expect server HTML to contain the text node "%s" in <%s>.', n.nodeValue, e.nodeName.toLowerCase());
      }
    }
    function gT(e, n, o) {
      {
        if (Wa)
          return;
        Wa = !0, g("Expected server HTML to contain a matching <%s> in <%s>.", n, e.nodeName.toLowerCase());
      }
    }
    function CT(e, n) {
      {
        if (n === "" || Wa)
          return;
        Wa = !0, g('Expected server HTML to contain a matching text node for "%s" in <%s>.', n, e.nodeName.toLowerCase());
      }
    }
    function zF(e, n, o) {
      switch (n) {
        case "input":
          mv(e, o);
          return;
        case "textarea":
          _w(e, o);
          return;
        case "select":
          Ow(e, o);
          return;
      }
    }
    var p6 = function() {
    }, m6 = function() {
    };
    {
      var HF = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], Ax = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
      ], FF = Ax.concat(["button"]), IF = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], Px = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
      };
      m6 = function(e, n) {
        var o = Pt({}, e || Px), u = {
          tag: n
        };
        return Ax.indexOf(n) !== -1 && (o.aTagInScope = null, o.buttonTagInScope = null, o.nobrTagInScope = null), FF.indexOf(n) !== -1 && (o.pTagInButtonScope = null), HF.indexOf(n) !== -1 && n !== "address" && n !== "div" && n !== "p" && (o.listItemTagAutoclosing = null, o.dlItemTagAutoclosing = null), o.current = u, n === "form" && (o.formTag = u), n === "a" && (o.aTagInScope = u), n === "button" && (o.buttonTagInScope = u), n === "nobr" && (o.nobrTagInScope = u), n === "p" && (o.pTagInButtonScope = u), n === "li" && (o.listItemTagAutoclosing = u), (n === "dd" || n === "dt") && (o.dlItemTagAutoclosing = u), o;
      };
      var BF = function(e, n) {
        switch (n) {
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
          case "select":
            return e === "option" || e === "optgroup" || e === "#text";
          case "optgroup":
            return e === "option" || e === "#text";
          // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
          // but
          case "option":
            return e === "#text";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
          // No special behavior since these rules fall back to "in body" mode for
          // all except special table nodes which cause bad parsing behavior anyway.
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
          case "tr":
            return e === "th" || e === "td" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
          case "tbody":
          case "thead":
          case "tfoot":
            return e === "tr" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
          case "colgroup":
            return e === "col" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
          case "table":
            return e === "caption" || e === "colgroup" || e === "tbody" || e === "tfoot" || e === "thead" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
          case "head":
            return e === "base" || e === "basefont" || e === "bgsound" || e === "link" || e === "meta" || e === "title" || e === "noscript" || e === "noframes" || e === "style" || e === "script" || e === "template";
          // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
          case "html":
            return e === "head" || e === "body" || e === "frameset";
          case "frameset":
            return e === "frame";
          case "#document":
            return e === "html";
        }
        switch (e) {
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return n !== "h1" && n !== "h2" && n !== "h3" && n !== "h4" && n !== "h5" && n !== "h6";
          case "rp":
          case "rt":
            return IF.indexOf(n) === -1;
          case "body":
          case "caption":
          case "col":
          case "colgroup":
          case "frameset":
          case "frame":
          case "head":
          case "html":
          case "tbody":
          case "td":
          case "tfoot":
          case "th":
          case "thead":
          case "tr":
            return n == null;
        }
        return !0;
      }, qF = function(e, n) {
        switch (e) {
          case "address":
          case "article":
          case "aside":
          case "blockquote":
          case "center":
          case "details":
          case "dialog":
          case "dir":
          case "div":
          case "dl":
          case "fieldset":
          case "figcaption":
          case "figure":
          case "footer":
          case "header":
          case "hgroup":
          case "main":
          case "menu":
          case "nav":
          case "ol":
          case "p":
          case "section":
          case "summary":
          case "ul":
          case "pre":
          case "listing":
          case "table":
          case "hr":
          case "xmp":
          case "h1":
          case "h2":
          case "h3":
          case "h4":
          case "h5":
          case "h6":
            return n.pTagInButtonScope;
          case "form":
            return n.formTag || n.pTagInButtonScope;
          case "li":
            return n.listItemTagAutoclosing;
          case "dd":
          case "dt":
            return n.dlItemTagAutoclosing;
          case "button":
            return n.buttonTagInScope;
          case "a":
            return n.aTagInScope;
          case "nobr":
            return n.nobrTagInScope;
        }
        return null;
      }, Ox = {};
      p6 = function(e, n, o) {
        o = o || Px;
        var u = o.current, h = u && u.tag;
        n != null && (e != null && g("validateDOMNesting: when childText is passed, childTag should be null"), e = "#text");
        var y = BF(e, h) ? null : u, S = y ? null : qF(e, o), w = y || S;
        if (w) {
          var E = w.tag, D = !!y + "|" + e + "|" + E;
          if (!Ox[D]) {
            Ox[D] = !0;
            var M = e, H = "";
            if (e === "#text" ? /\S/.test(n) ? M = "Text nodes" : (M = "Whitespace text nodes", H = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : M = "<" + e + ">", y) {
              var V = "";
              E === "table" && e === "tr" && (V += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), g("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", M, E, H, V);
            } else
              g("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", M, E);
          }
        }
      };
    }
    var wS = "suppressHydrationWarning", TS = "$", ES = "/$", v6 = "$?", y6 = "$!", jF = "style", ST = null, bT = null;
    function GF(e) {
      var n, o, u = e.nodeType;
      switch (u) {
        case wo:
        case f3: {
          n = u === wo ? "#document" : "#fragment";
          var h = e.documentElement;
          o = h ? h.namespaceURI : d3(null, "");
          break;
        }
        default: {
          var y = u === oi ? e.parentNode : e, S = y.namespaceURI || null;
          n = y.tagName, o = d3(S, n);
          break;
        }
      }
      {
        var w = n.toLowerCase(), E = m6(null, w);
        return {
          namespace: o,
          ancestorInfo: E
        };
      }
    }
    function QF(e, n, o) {
      {
        var u = e, h = d3(u.namespace, n), y = m6(u.ancestorInfo, n);
        return {
          namespace: h,
          ancestorInfo: y
        };
      }
    }
    function Bee(e) {
      return e;
    }
    function YF(e) {
      ST = hi(), bT = lF();
      var n = null;
      return ki(!1), n;
    }
    function WF(e) {
      uF(bT), ki(ST), ST = null, bT = null;
    }
    function KF(e, n, o, u, h) {
      var y;
      {
        var S = u;
        if (p6(e, null, S.ancestorInfo), typeof n.children == "string" || typeof n.children == "number") {
          var w = "" + n.children, E = m6(S.ancestorInfo, e);
          p6(null, w, E);
        }
        y = S.namespace;
      }
      var D = MF(e, n, o, y);
      return S6(h, D), $T(D, n), D;
    }
    function ZF(e, n) {
      e.appendChild(n);
    }
    function XF(e, n, o, u, h) {
      switch (PF(e, n, o, u), n) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          return !!o.autoFocus;
        case "img":
          return !0;
        default:
          return !1;
      }
    }
    function JF(e, n, o, u, h, y) {
      {
        var S = y;
        if (typeof u.children != typeof o.children && (typeof u.children == "string" || typeof u.children == "number")) {
          var w = "" + u.children, E = m6(S.ancestorInfo, n);
          p6(null, w, E);
        }
      }
      return OF(e, n, o, u);
    }
    function wT(e, n) {
      return e === "textarea" || e === "noscript" || typeof n.children == "string" || typeof n.children == "number" || typeof n.dangerouslySetInnerHTML == "object" && n.dangerouslySetInnerHTML !== null && n.dangerouslySetInnerHTML.__html != null;
    }
    function eI(e, n, o, u) {
      {
        var h = o;
        p6(null, e, h.ancestorInfo);
      }
      var y = AF(e, n);
      return S6(u, y), y;
    }
    function tI() {
      var e = window.event;
      return e === void 0 ? ja : my(e.type);
    }
    var TT = typeof setTimeout == "function" ? setTimeout : void 0, nI = typeof clearTimeout == "function" ? clearTimeout : void 0, ET = -1, _x = typeof Promise == "function" ? Promise : void 0, iI = typeof queueMicrotask == "function" ? queueMicrotask : typeof _x < "u" ? function(e) {
      return _x.resolve(null).then(e).catch(rI);
    } : TT;
    function rI(e) {
      setTimeout(function() {
        throw e;
      });
    }
    function aI(e, n, o, u) {
      switch (n) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          o.autoFocus && e.focus();
          return;
        case "img": {
          o.src && (e.src = o.src);
          return;
        }
      }
    }
    function sI(e, n, o, u, h, y) {
      _F(e, n, o, u, h), $T(e, h);
    }
    function Nx(e) {
      Sd(e, "");
    }
    function oI(e, n, o) {
      e.nodeValue = o;
    }
    function lI(e, n) {
      e.appendChild(n);
    }
    function uI(e, n) {
      var o;
      e.nodeType === oi ? (o = e.parentNode, o.insertBefore(n, e)) : (o = e, o.appendChild(n));
      var u = e._reactRootContainer;
      u == null && o.onclick === null && bS(o);
    }
    function cI(e, n, o) {
      e.insertBefore(n, o);
    }
    function dI(e, n, o) {
      e.nodeType === oi ? e.parentNode.insertBefore(n, o) : e.insertBefore(n, o);
    }
    function fI(e, n) {
      e.removeChild(n);
    }
    function hI(e, n) {
      e.nodeType === oi ? e.parentNode.removeChild(n) : e.removeChild(n);
    }
    function kT(e, n) {
      var o = n, u = 0;
      do {
        var h = o.nextSibling;
        if (e.removeChild(o), h && h.nodeType === oi) {
          var y = h.data;
          if (y === ES)
            if (u === 0) {
              e.removeChild(h), rc(n);
              return;
            } else
              u--;
          else (y === TS || y === v6 || y === y6) && u++;
        }
        o = h;
      } while (o);
      rc(n);
    }
    function pI(e, n) {
      e.nodeType === oi ? kT(e.parentNode, n) : e.nodeType === Gr && kT(e, n), rc(e);
    }
    function mI(e) {
      e = e;
      var n = e.style;
      typeof n.setProperty == "function" ? n.setProperty("display", "none", "important") : n.display = "none";
    }
    function vI(e) {
      e.nodeValue = "";
    }
    function yI(e, n) {
      e = e;
      var o = n[jF], u = o != null && o.hasOwnProperty("display") ? o.display : null;
      e.style.display = bv("display", u);
    }
    function gI(e, n) {
      e.nodeValue = n;
    }
    function CI(e) {
      e.nodeType === Gr ? e.textContent = "" : e.nodeType === wo && e.documentElement && e.removeChild(e.documentElement);
    }
    function SI(e, n, o) {
      return e.nodeType !== Gr || n.toLowerCase() !== e.nodeName.toLowerCase() ? null : e;
    }
    function bI(e, n) {
      return n === "" || e.nodeType !== bo ? null : e;
    }
    function wI(e) {
      return e.nodeType !== oi ? null : e;
    }
    function Vx(e) {
      return e.data === v6;
    }
    function xT(e) {
      return e.data === y6;
    }
    function TI(e) {
      var n = e.nextSibling && e.nextSibling.dataset, o, u, h;
      return n && (o = n.dgst, u = n.msg, h = n.stck), {
        message: u,
        digest: o,
        stack: h
      };
    }
    function EI(e, n) {
      e._reactRetry = n;
    }
    function kS(e) {
      for (; e != null; e = e.nextSibling) {
        var n = e.nodeType;
        if (n === Gr || n === bo)
          break;
        if (n === oi) {
          var o = e.data;
          if (o === TS || o === y6 || o === v6)
            break;
          if (o === ES)
            return null;
        }
      }
      return e;
    }
    function g6(e) {
      return kS(e.nextSibling);
    }
    function kI(e) {
      return kS(e.firstChild);
    }
    function xI(e) {
      return kS(e.firstChild);
    }
    function RI(e) {
      return kS(e.nextSibling);
    }
    function LI(e, n, o, u, h, y, S) {
      S6(y, e), $T(e, o);
      var w;
      {
        var E = h;
        w = E.namespace;
      }
      var D = (y.mode & Tt) !== Ie;
      return VF(e, n, o, w, u, D, S);
    }
    function $I(e, n, o, u) {
      return S6(o, e), o.mode & Tt, UF(e, n);
    }
    function DI(e, n) {
      S6(n, e);
    }
    function MI(e) {
      for (var n = e.nextSibling, o = 0; n; ) {
        if (n.nodeType === oi) {
          var u = n.data;
          if (u === ES) {
            if (o === 0)
              return g6(n);
            o--;
          } else (u === TS || u === y6 || u === v6) && o++;
        }
        n = n.nextSibling;
      }
      return null;
    }
    function Ux(e) {
      for (var n = e.previousSibling, o = 0; n; ) {
        if (n.nodeType === oi) {
          var u = n.data;
          if (u === TS || u === y6 || u === v6) {
            if (o === 0)
              return n;
            o--;
          } else u === ES && o++;
        }
        n = n.previousSibling;
      }
      return null;
    }
    function AI(e) {
      rc(e);
    }
    function PI(e) {
      rc(e);
    }
    function OI(e) {
      return e !== "head" && e !== "body";
    }
    function _I(e, n, o, u) {
      var h = !0;
      SS(n.nodeValue, o, u, h);
    }
    function NI(e, n, o, u, h, y) {
      if (n[wS] !== !0) {
        var S = !0;
        SS(u.nodeValue, h, y, S);
      }
    }
    function VI(e, n) {
      n.nodeType === Gr ? vT(e, n) : n.nodeType === oi || yT(e, n);
    }
    function UI(e, n) {
      {
        var o = e.parentNode;
        o !== null && (n.nodeType === Gr ? vT(o, n) : n.nodeType === oi || yT(o, n));
      }
    }
    function zI(e, n, o, u, h) {
      (h || n[wS] !== !0) && (u.nodeType === Gr ? vT(o, u) : u.nodeType === oi || yT(o, u));
    }
    function HI(e, n, o) {
      gT(e, n);
    }
    function FI(e, n) {
      CT(e, n);
    }
    function II(e, n, o) {
      {
        var u = e.parentNode;
        u !== null && gT(u, n);
      }
    }
    function BI(e, n) {
      {
        var o = e.parentNode;
        o !== null && CT(o, n);
      }
    }
    function qI(e, n, o, u, h, y) {
      (y || n[wS] !== !0) && gT(o, u);
    }
    function jI(e, n, o, u, h) {
      (h || n[wS] !== !0) && CT(o, u);
    }
    function GI(e) {
      g("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", e.nodeName.toLowerCase());
    }
    function QI(e) {
      c6(e);
    }
    var Dy = Math.random().toString(36).slice(2), My = "__reactFiber$" + Dy, RT = "__reactProps$" + Dy, C6 = "__reactContainer$" + Dy, LT = "__reactEvents$" + Dy, YI = "__reactListeners$" + Dy, WI = "__reactHandles$" + Dy;
    function KI(e) {
      delete e[My], delete e[RT], delete e[LT], delete e[YI], delete e[WI];
    }
    function S6(e, n) {
      n[My] = e;
    }
    function xS(e, n) {
      n[C6] = e;
    }
    function zx(e) {
      e[C6] = null;
    }
    function b6(e) {
      return !!e[C6];
    }
    function Tp(e) {
      var n = e[My];
      if (n)
        return n;
      for (var o = e.parentNode; o; ) {
        if (n = o[C6] || o[My], n) {
          var u = n.alternate;
          if (n.child !== null || u !== null && u.child !== null)
            for (var h = Ux(e); h !== null; ) {
              var y = h[My];
              if (y)
                return y;
              h = Ux(h);
            }
          return n;
        }
        e = o, o = e.parentNode;
      }
      return null;
    }
    function qd(e) {
      var n = e[My] || e[C6];
      return n && (n.tag === F || n.tag === Z || n.tag === Me || n.tag === A) ? n : null;
    }
    function Ay(e) {
      if (e.tag === F || e.tag === Z)
        return e.stateNode;
      throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function RS(e) {
      return e[RT] || null;
    }
    function $T(e, n) {
      e[RT] = n;
    }
    function ZI(e) {
      var n = e[LT];
      return n === void 0 && (n = e[LT] = /* @__PURE__ */ new Set()), n;
    }
    var Hx = {}, Fx = t.ReactDebugCurrentFrame;
    function LS(e) {
      if (e) {
        var n = e._owner, o = Pu(e.type, e._source, n ? n.type : null);
        Fx.setExtraStackFrame(o);
      } else
        Fx.setExtraStackFrame(null);
    }
    function Po(e, n, o, u, h) {
      {
        var y = Function.call.bind(Cr);
        for (var S in e)
          if (y(e, S)) {
            var w = void 0;
            try {
              if (typeof e[S] != "function") {
                var E = Error((u || "React class") + ": " + o + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw E.name = "Invariant Violation", E;
              }
              w = e[S](n, S, u, o, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (D) {
              w = D;
            }
            w && !(w instanceof Error) && (LS(h), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", u || "React class", o, S, typeof w), LS(null)), w instanceof Error && !(w.message in Hx) && (Hx[w.message] = !0, LS(h), g("Failed %s type: %s", o, w.message), LS(null));
          }
      }
    }
    var DT = [], $S;
    $S = [];
    var uc = -1;
    function jd(e) {
      return {
        current: e
      };
    }
    function ia(e, n) {
      if (uc < 0) {
        g("Unexpected pop.");
        return;
      }
      n !== $S[uc] && g("Unexpected Fiber popped."), e.current = DT[uc], DT[uc] = null, $S[uc] = null, uc--;
    }
    function ra(e, n, o) {
      uc++, DT[uc] = e.current, $S[uc] = o, e.current = n;
    }
    var MT;
    MT = {};
    var Ss = {};
    Object.freeze(Ss);
    var cc = jd(Ss), Vl = jd(!1), AT = Ss;
    function Py(e, n, o) {
      return o && Ul(n) ? AT : cc.current;
    }
    function Ix(e, n, o) {
      {
        var u = e.stateNode;
        u.__reactInternalMemoizedUnmaskedChildContext = n, u.__reactInternalMemoizedMaskedChildContext = o;
      }
    }
    function Oy(e, n) {
      {
        var o = e.type, u = o.contextTypes;
        if (!u)
          return Ss;
        var h = e.stateNode;
        if (h && h.__reactInternalMemoizedUnmaskedChildContext === n)
          return h.__reactInternalMemoizedMaskedChildContext;
        var y = {};
        for (var S in u)
          y[S] = n[S];
        {
          var w = vt(e) || "Unknown";
          Po(u, y, "context", w);
        }
        return h && Ix(e, n, y), y;
      }
    }
    function DS() {
      return Vl.current;
    }
    function Ul(e) {
      {
        var n = e.childContextTypes;
        return n != null;
      }
    }
    function MS(e) {
      ia(Vl, e), ia(cc, e);
    }
    function PT(e) {
      ia(Vl, e), ia(cc, e);
    }
    function Bx(e, n, o) {
      {
        if (cc.current !== Ss)
          throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        ra(cc, n, e), ra(Vl, o, e);
      }
    }
    function qx(e, n, o) {
      {
        var u = e.stateNode, h = n.childContextTypes;
        if (typeof u.getChildContext != "function") {
          {
            var y = vt(e) || "Unknown";
            MT[y] || (MT[y] = !0, g("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", y, y));
          }
          return o;
        }
        var S = u.getChildContext();
        for (var w in S)
          if (!(w in h))
            throw new Error((vt(e) || "Unknown") + '.getChildContext(): key "' + w + '" is not defined in childContextTypes.');
        {
          var E = vt(e) || "Unknown";
          Po(h, S, "child context", E);
        }
        return Pt({}, o, S);
      }
    }
    function AS(e) {
      {
        var n = e.stateNode, o = n && n.__reactInternalMemoizedMergedChildContext || Ss;
        return AT = cc.current, ra(cc, o, e), ra(Vl, Vl.current, e), !0;
      }
    }
    function jx(e, n, o) {
      {
        var u = e.stateNode;
        if (!u)
          throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (o) {
          var h = qx(e, n, AT);
          u.__reactInternalMemoizedMergedChildContext = h, ia(Vl, e), ia(cc, e), ra(cc, h, e), ra(Vl, o, e);
        } else
          ia(Vl, e), ra(Vl, o, e);
      }
    }
    function XI(e) {
      {
        if (!qu(e) || e.tag !== $)
          throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var n = e;
        do {
          switch (n.tag) {
            case A:
              return n.stateNode.context;
            case $: {
              var o = n.type;
              if (Ul(o))
                return n.stateNode.__reactInternalMemoizedMergedChildContext;
              break;
            }
          }
          n = n.return;
        } while (n !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    var Gd = 0, PS = 1, dc = null, OT = !1, _T = !1;
    function Gx(e) {
      dc === null ? dc = [e] : dc.push(e);
    }
    function JI(e) {
      OT = !0, Gx(e);
    }
    function Qx() {
      OT && Qd();
    }
    function Qd() {
      if (!_T && dc !== null) {
        _T = !0;
        var e = 0, n = Qa();
        try {
          var o = !0, u = dc;
          for (fi(wr); e < u.length; e++) {
            var h = u[e];
            do
              h = h(o);
            while (h !== null);
          }
          dc = null, OT = !1;
        } catch (y) {
          throw dc !== null && (dc = dc.slice(e + 1)), E3(Ih, Qd), y;
        } finally {
          fi(n), _T = !1;
        }
      }
      return null;
    }
    var _y = [], Ny = 0, OS = null, _S = 0, Xs = [], Js = 0, Ep = null, fc = 1, hc = "";
    function eB(e) {
      return xp(), (e.flags & Is) !== Fe;
    }
    function tB(e) {
      return xp(), _S;
    }
    function nB() {
      var e = hc, n = fc, o = n & ~iB(n);
      return o.toString(32) + e;
    }
    function kp(e, n) {
      xp(), _y[Ny++] = _S, _y[Ny++] = OS, OS = e, _S = n;
    }
    function Yx(e, n, o) {
      xp(), Xs[Js++] = fc, Xs[Js++] = hc, Xs[Js++] = Ep, Ep = e;
      var u = fc, h = hc, y = NS(u) - 1, S = u & ~(1 << y), w = o + 1, E = NS(n) + y;
      if (E > 30) {
        var D = y - y % 5, M = (1 << D) - 1, H = (S & M).toString(32), V = S >> D, Q = y - D, W = NS(n) + Q, X = w << Q, Ce = X | V, Qe = H + h;
        fc = 1 << W | Ce, hc = Qe;
      } else {
        var Ue = w << y, Ut = Ue | S, Dt = h;
        fc = 1 << E | Ut, hc = Dt;
      }
    }
    function NT(e) {
      xp();
      var n = e.return;
      if (n !== null) {
        var o = 1, u = 0;
        kp(e, o), Yx(e, o, u);
      }
    }
    function NS(e) {
      return 32 - ci(e);
    }
    function iB(e) {
      return 1 << NS(e) - 1;
    }
    function VT(e) {
      for (; e === OS; )
        OS = _y[--Ny], _y[Ny] = null, _S = _y[--Ny], _y[Ny] = null;
      for (; e === Ep; )
        Ep = Xs[--Js], Xs[Js] = null, hc = Xs[--Js], Xs[Js] = null, fc = Xs[--Js], Xs[Js] = null;
    }
    function rB() {
      return xp(), Ep !== null ? {
        id: fc,
        overflow: hc
      } : null;
    }
    function aB(e, n) {
      xp(), Xs[Js++] = fc, Xs[Js++] = hc, Xs[Js++] = Ep, fc = n.id, hc = n.overflow, Ep = e;
    }
    function xp() {
      Rr() || g("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    var xr = null, eo = null, Oo = !1, Rp = !1, Yd = null;
    function sB() {
      Oo && g("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function Wx() {
      Rp = !0;
    }
    function oB() {
      return Rp;
    }
    function lB(e) {
      var n = e.stateNode.containerInfo;
      return eo = xI(n), xr = e, Oo = !0, Yd = null, Rp = !1, !0;
    }
    function uB(e, n, o) {
      return eo = RI(n), xr = e, Oo = !0, Yd = null, Rp = !1, o !== null && aB(e, o), !0;
    }
    function Kx(e, n) {
      switch (e.tag) {
        case A: {
          VI(e.stateNode.containerInfo, n);
          break;
        }
        case F: {
          var o = (e.mode & Tt) !== Ie;
          zI(
            e.type,
            e.memoizedProps,
            e.stateNode,
            n,
            // TODO: Delete this argument when we remove the legacy root API.
            o
          );
          break;
        }
        case Me: {
          var u = e.memoizedState;
          u.dehydrated !== null && UI(u.dehydrated, n);
          break;
        }
      }
    }
    function Zx(e, n) {
      Kx(e, n);
      var o = hG();
      o.stateNode = n, o.return = e;
      var u = e.deletions;
      u === null ? (e.deletions = [o], e.flags |= Ha) : u.push(o);
    }
    function UT(e, n) {
      {
        if (Rp)
          return;
        switch (e.tag) {
          case A: {
            var o = e.stateNode.containerInfo;
            switch (n.tag) {
              case F:
                var u = n.type;
                n.pendingProps, HI(o, u);
                break;
              case Z:
                var h = n.pendingProps;
                FI(o, h);
                break;
            }
            break;
          }
          case F: {
            var y = e.type, S = e.memoizedProps, w = e.stateNode;
            switch (n.tag) {
              case F: {
                var E = n.type, D = n.pendingProps, M = (e.mode & Tt) !== Ie;
                qI(
                  y,
                  S,
                  w,
                  E,
                  D,
                  // TODO: Delete this argument when we remove the legacy root API.
                  M
                );
                break;
              }
              case Z: {
                var H = n.pendingProps, V = (e.mode & Tt) !== Ie;
                jI(
                  y,
                  S,
                  w,
                  H,
                  // TODO: Delete this argument when we remove the legacy root API.
                  V
                );
                break;
              }
            }
            break;
          }
          case Me: {
            var Q = e.memoizedState, W = Q.dehydrated;
            if (W !== null) switch (n.tag) {
              case F:
                var X = n.type;
                n.pendingProps, II(W, X);
                break;
              case Z:
                var Ce = n.pendingProps;
                BI(W, Ce);
                break;
            }
            break;
          }
          default:
            return;
        }
      }
    }
    function Xx(e, n) {
      n.flags = n.flags & -4097 | Kn, UT(e, n);
    }
    function Jx(e, n) {
      switch (e.tag) {
        case F: {
          var o = e.type;
          e.pendingProps;
          var u = SI(n, o);
          return u !== null ? (e.stateNode = u, xr = e, eo = kI(u), !0) : !1;
        }
        case Z: {
          var h = e.pendingProps, y = bI(n, h);
          return y !== null ? (e.stateNode = y, xr = e, eo = null, !0) : !1;
        }
        case Me: {
          var S = wI(n);
          if (S !== null) {
            var w = {
              dehydrated: S,
              treeContext: rB(),
              retryLane: ga
            };
            e.memoizedState = w;
            var E = pG(S);
            return E.return = e, e.child = E, xr = e, eo = null, !0;
          }
          return !1;
        }
        default:
          return !1;
      }
    }
    function zT(e) {
      return (e.mode & Tt) !== Ie && (e.flags & He) === Fe;
    }
    function HT(e) {
      throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function FT(e) {
      if (Oo) {
        var n = eo;
        if (!n) {
          zT(e) && (UT(xr, e), HT()), Xx(xr, e), Oo = !1, xr = e;
          return;
        }
        var o = n;
        if (!Jx(e, n)) {
          zT(e) && (UT(xr, e), HT()), n = g6(o);
          var u = xr;
          if (!n || !Jx(e, n)) {
            Xx(xr, e), Oo = !1, xr = e;
            return;
          }
          Zx(u, o);
        }
      }
    }
    function cB(e, n, o) {
      var u = e.stateNode, h = !Rp, y = LI(u, e.type, e.memoizedProps, n, o, e, h);
      return e.updateQueue = y, y !== null;
    }
    function dB(e) {
      var n = e.stateNode, o = e.memoizedProps, u = $I(n, o, e);
      if (u) {
        var h = xr;
        if (h !== null)
          switch (h.tag) {
            case A: {
              var y = h.stateNode.containerInfo, S = (h.mode & Tt) !== Ie;
              _I(
                y,
                n,
                o,
                // TODO: Delete this argument when we remove the legacy root API.
                S
              );
              break;
            }
            case F: {
              var w = h.type, E = h.memoizedProps, D = h.stateNode, M = (h.mode & Tt) !== Ie;
              NI(
                w,
                E,
                D,
                n,
                o,
                // TODO: Delete this argument when we remove the legacy root API.
                M
              );
              break;
            }
          }
      }
      return u;
    }
    function fB(e) {
      var n = e.memoizedState, o = n !== null ? n.dehydrated : null;
      if (!o)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      DI(o, e);
    }
    function hB(e) {
      var n = e.memoizedState, o = n !== null ? n.dehydrated : null;
      if (!o)
        throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
      return MI(o);
    }
    function eR(e) {
      for (var n = e.return; n !== null && n.tag !== F && n.tag !== A && n.tag !== Me; )
        n = n.return;
      xr = n;
    }
    function VS(e) {
      if (e !== xr)
        return !1;
      if (!Oo)
        return eR(e), Oo = !0, !1;
      if (e.tag !== A && (e.tag !== F || OI(e.type) && !wT(e.type, e.memoizedProps))) {
        var n = eo;
        if (n)
          if (zT(e))
            tR(e), HT();
          else
            for (; n; )
              Zx(e, n), n = g6(n);
      }
      return eR(e), e.tag === Me ? eo = hB(e) : eo = xr ? g6(e.stateNode) : null, !0;
    }
    function pB() {
      return Oo && eo !== null;
    }
    function tR(e) {
      for (var n = eo; n; )
        Kx(e, n), n = g6(n);
    }
    function Vy() {
      xr = null, eo = null, Oo = !1, Rp = !1;
    }
    function nR() {
      Yd !== null && (WL(Yd), Yd = null);
    }
    function Rr() {
      return Oo;
    }
    function IT(e) {
      Yd === null ? Yd = [e] : Yd.push(e);
    }
    var mB = t.ReactCurrentBatchConfig, vB = null;
    function yB() {
      return mB.transition;
    }
    var _o = {
      recordUnsafeLifecycleWarnings: function(e, n) {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function(e, n) {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    };
    {
      var gB = function(e) {
        for (var n = null, o = e; o !== null; )
          o.mode & mn && (n = o), o = o.return;
        return n;
      }, Lp = function(e) {
        var n = [];
        return e.forEach(function(o) {
          n.push(o);
        }), n.sort().join(", ");
      }, w6 = [], T6 = [], E6 = [], k6 = [], x6 = [], R6 = [], $p = /* @__PURE__ */ new Set();
      _o.recordUnsafeLifecycleWarnings = function(e, n) {
        $p.has(e.type) || (typeof n.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        n.componentWillMount.__suppressDeprecationWarning !== !0 && w6.push(e), e.mode & mn && typeof n.UNSAFE_componentWillMount == "function" && T6.push(e), typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && E6.push(e), e.mode & mn && typeof n.UNSAFE_componentWillReceiveProps == "function" && k6.push(e), typeof n.componentWillUpdate == "function" && n.componentWillUpdate.__suppressDeprecationWarning !== !0 && x6.push(e), e.mode & mn && typeof n.UNSAFE_componentWillUpdate == "function" && R6.push(e));
      }, _o.flushPendingUnsafeLifecycleWarnings = function() {
        var e = /* @__PURE__ */ new Set();
        w6.length > 0 && (w6.forEach(function(V) {
          e.add(vt(V) || "Component"), $p.add(V.type);
        }), w6 = []);
        var n = /* @__PURE__ */ new Set();
        T6.length > 0 && (T6.forEach(function(V) {
          n.add(vt(V) || "Component"), $p.add(V.type);
        }), T6 = []);
        var o = /* @__PURE__ */ new Set();
        E6.length > 0 && (E6.forEach(function(V) {
          o.add(vt(V) || "Component"), $p.add(V.type);
        }), E6 = []);
        var u = /* @__PURE__ */ new Set();
        k6.length > 0 && (k6.forEach(function(V) {
          u.add(vt(V) || "Component"), $p.add(V.type);
        }), k6 = []);
        var h = /* @__PURE__ */ new Set();
        x6.length > 0 && (x6.forEach(function(V) {
          h.add(vt(V) || "Component"), $p.add(V.type);
        }), x6 = []);
        var y = /* @__PURE__ */ new Set();
        if (R6.length > 0 && (R6.forEach(function(V) {
          y.add(vt(V) || "Component"), $p.add(V.type);
        }), R6 = []), n.size > 0) {
          var S = Lp(n);
          g(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, S);
        }
        if (u.size > 0) {
          var w = Lp(u);
          g(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, w);
        }
        if (y.size > 0) {
          var E = Lp(y);
          g(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, E);
        }
        if (e.size > 0) {
          var D = Lp(e);
          v(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, D);
        }
        if (o.size > 0) {
          var M = Lp(o);
          v(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, M);
        }
        if (h.size > 0) {
          var H = Lp(h);
          v(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, H);
        }
      };
      var US = /* @__PURE__ */ new Map(), iR = /* @__PURE__ */ new Set();
      _o.recordLegacyContextWarning = function(e, n) {
        var o = gB(e);
        if (o === null) {
          g("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        if (!iR.has(e.type)) {
          var u = US.get(o);
          (e.type.contextTypes != null || e.type.childContextTypes != null || n !== null && typeof n.getChildContext == "function") && (u === void 0 && (u = [], US.set(o, u)), u.push(e));
        }
      }, _o.flushLegacyContextWarning = function() {
        US.forEach(function(e, n) {
          if (e.length !== 0) {
            var o = e[0], u = /* @__PURE__ */ new Set();
            e.forEach(function(y) {
              u.add(vt(y) || "Component"), iR.add(y.type);
            });
            var h = Lp(u);
            try {
              Mn(o), g(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, h);
            } finally {
              Gn();
            }
          }
        });
      }, _o.discardPendingWarnings = function() {
        w6 = [], T6 = [], E6 = [], k6 = [], x6 = [], R6 = [], US = /* @__PURE__ */ new Map();
      };
    }
    var BT, qT, jT, GT, QT, rR = function(e, n) {
    };
    BT = !1, qT = !1, jT = {}, GT = {}, QT = {}, rR = function(e, n) {
      if (!(e === null || typeof e != "object") && !(!e._store || e._store.validated || e.key != null)) {
        if (typeof e._store != "object")
          throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        e._store.validated = !0;
        var o = vt(n) || "Component";
        GT[o] || (GT[o] = !0, g('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
      }
    };
    function CB(e) {
      return e.prototype && e.prototype.isReactComponent;
    }
    function L6(e, n, o) {
      var u = o.ref;
      if (u !== null && typeof u != "function" && typeof u != "object") {
        if ((e.mode & mn || Qt) && // We warn in ReactElement.js if owner and self are equal for string refs
        // because these cannot be automatically converted to an arrow function
        // using a codemod. Therefore, we don't have to warn about string refs again.
        !(o._owner && o._self && o._owner.stateNode !== o._self) && // Will already throw with "Function components cannot have string refs"
        !(o._owner && o._owner.tag !== $) && // Will already warn with "Function components cannot be given refs"
        !(typeof o.type == "function" && !CB(o.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
        o._owner) {
          var h = vt(e) || "Component";
          jT[h] || (g('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', h, u), jT[h] = !0);
        }
        if (o._owner) {
          var y = o._owner, S;
          if (y) {
            var w = y;
            if (w.tag !== $)
              throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
            S = w.stateNode;
          }
          if (!S)
            throw new Error("Missing owner for string ref " + u + ". This error is likely caused by a bug in React. Please file an issue.");
          var E = S;
          gh(u, "ref");
          var D = "" + u;
          if (n !== null && n.ref !== null && typeof n.ref == "function" && n.ref._stringRef === D)
            return n.ref;
          var M = function(H) {
            var V = E.refs;
            H === null ? delete V[D] : V[D] = H;
          };
          return M._stringRef = D, M;
        } else {
          if (typeof u != "string")
            throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
          if (!o._owner)
            throw new Error("Element ref was specified as a string (" + u + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
        }
      }
      return u;
    }
    function zS(e, n) {
      var o = Object.prototype.toString.call(n);
      throw new Error("Objects are not valid as a React child (found: " + (o === "[object Object]" ? "object with keys {" + Object.keys(n).join(", ") + "}" : o) + "). If you meant to render a collection of children, use an array instead.");
    }
    function HS(e) {
      {
        var n = vt(e) || "Component";
        if (QT[n])
          return;
        QT[n] = !0, g("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
      }
    }
    function aR(e) {
      var n = e._payload, o = e._init;
      return o(n);
    }
    function sR(e) {
      function n(q, J) {
        if (e) {
          var j = q.deletions;
          j === null ? (q.deletions = [J], q.flags |= Ha) : j.push(J);
        }
      }
      function o(q, J) {
        if (!e)
          return null;
        for (var j = J; j !== null; )
          n(q, j), j = j.sibling;
        return null;
      }
      function u(q, J) {
        for (var j = /* @__PURE__ */ new Map(), le = J; le !== null; )
          le.key !== null ? j.set(le.key, le) : j.set(le.index, le), le = le.sibling;
        return j;
      }
      function h(q, J) {
        var j = Up(q, J);
        return j.index = 0, j.sibling = null, j;
      }
      function y(q, J, j) {
        if (q.index = j, !e)
          return q.flags |= Is, J;
        var le = q.alternate;
        if (le !== null) {
          var xe = le.index;
          return xe < J ? (q.flags |= Kn, J) : xe;
        } else
          return q.flags |= Kn, J;
      }
      function S(q) {
        return e && q.alternate === null && (q.flags |= Kn), q;
      }
      function w(q, J, j, le) {
        if (J === null || J.tag !== Z) {
          var xe = I4(j, q.mode, le);
          return xe.return = q, xe;
        } else {
          var we = h(J, j);
          return we.return = q, we;
        }
      }
      function E(q, J, j, le) {
        var xe = j.type;
        if (xe === fd)
          return M(q, J, j.props.children, le, j.key);
        if (J !== null && (J.elementType === xe || // Keep this check inline so it only runs on the false path:
        d$(J, j) || // Lazy types should reconcile their resolved type.
        // We need to do this after the Hot Reloading check above,
        // because hot reloading has different semantics than prod because
        // it doesn't resuspend. So we can't let the call below suspend.
        typeof xe == "object" && xe !== null && xe.$$typeof === cr && aR(xe) === J.type)) {
          var we = h(J, j.props);
          return we.ref = L6(q, J, j), we.return = q, we._debugSource = j._source, we._debugOwner = j._owner, we;
        }
        var at = F4(j, q.mode, le);
        return at.ref = L6(q, J, j), at.return = q, at;
      }
      function D(q, J, j, le) {
        if (J === null || J.tag !== U || J.stateNode.containerInfo !== j.containerInfo || J.stateNode.implementation !== j.implementation) {
          var xe = B4(j, q.mode, le);
          return xe.return = q, xe;
        } else {
          var we = h(J, j.children || []);
          return we.return = q, we;
        }
      }
      function M(q, J, j, le, xe) {
        if (J === null || J.tag !== ne) {
          var we = sf(j, q.mode, le, xe);
          return we.return = q, we;
        } else {
          var at = h(J, j);
          return at.return = q, at;
        }
      }
      function H(q, J, j) {
        if (typeof J == "string" && J !== "" || typeof J == "number") {
          var le = I4("" + J, q.mode, j);
          return le.return = q, le;
        }
        if (typeof J == "object" && J !== null) {
          switch (J.$$typeof) {
            case hl: {
              var xe = F4(J, q.mode, j);
              return xe.ref = L6(q, null, J), xe.return = q, xe;
            }
            case us: {
              var we = B4(J, q.mode, j);
              return we.return = q, we;
            }
            case cr: {
              var at = J._payload, ft = J._init;
              return H(q, ft(at), j);
            }
          }
          if (Gi(J) || En(J)) {
            var yn = sf(J, q.mode, j, null);
            return yn.return = q, yn;
          }
          zS(q, J);
        }
        return typeof J == "function" && HS(q), null;
      }
      function V(q, J, j, le) {
        var xe = J !== null ? J.key : null;
        if (typeof j == "string" && j !== "" || typeof j == "number")
          return xe !== null ? null : w(q, J, "" + j, le);
        if (typeof j == "object" && j !== null) {
          switch (j.$$typeof) {
            case hl:
              return j.key === xe ? E(q, J, j, le) : null;
            case us:
              return j.key === xe ? D(q, J, j, le) : null;
            case cr: {
              var we = j._payload, at = j._init;
              return V(q, J, at(we), le);
            }
          }
          if (Gi(j) || En(j))
            return xe !== null ? null : M(q, J, j, le, null);
          zS(q, j);
        }
        return typeof j == "function" && HS(q), null;
      }
      function Q(q, J, j, le, xe) {
        if (typeof le == "string" && le !== "" || typeof le == "number") {
          var we = q.get(j) || null;
          return w(J, we, "" + le, xe);
        }
        if (typeof le == "object" && le !== null) {
          switch (le.$$typeof) {
            case hl: {
              var at = q.get(le.key === null ? j : le.key) || null;
              return E(J, at, le, xe);
            }
            case us: {
              var ft = q.get(le.key === null ? j : le.key) || null;
              return D(J, ft, le, xe);
            }
            case cr:
              var yn = le._payload, Zt = le._init;
              return Q(q, J, j, Zt(yn), xe);
          }
          if (Gi(le) || En(le)) {
            var Ri = q.get(j) || null;
            return M(J, Ri, le, xe, null);
          }
          zS(J, le);
        }
        return typeof le == "function" && HS(J), null;
      }
      function W(q, J, j) {
        {
          if (typeof q != "object" || q === null)
            return J;
          switch (q.$$typeof) {
            case hl:
            case us:
              rR(q, j);
              var le = q.key;
              if (typeof le != "string")
                break;
              if (J === null) {
                J = /* @__PURE__ */ new Set(), J.add(le);
                break;
              }
              if (!J.has(le)) {
                J.add(le);
                break;
              }
              g("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", le);
              break;
            case cr:
              var xe = q._payload, we = q._init;
              W(we(xe), J, j);
              break;
          }
        }
        return J;
      }
      function X(q, J, j, le) {
        for (var xe = null, we = 0; we < j.length; we++) {
          var at = j[we];
          xe = W(at, xe, q);
        }
        for (var ft = null, yn = null, Zt = J, Ri = 0, Xt = 0, mi = null; Zt !== null && Xt < j.length; Xt++) {
          Zt.index > Xt ? (mi = Zt, Zt = null) : mi = Zt.sibling;
          var sa = V(q, Zt, j[Xt], le);
          if (sa === null) {
            Zt === null && (Zt = mi);
            break;
          }
          e && Zt && sa.alternate === null && n(q, Zt), Ri = y(sa, Ri, Xt), yn === null ? ft = sa : yn.sibling = sa, yn = sa, Zt = mi;
        }
        if (Xt === j.length) {
          if (o(q, Zt), Rr()) {
            var Or = Xt;
            kp(q, Or);
          }
          return ft;
        }
        if (Zt === null) {
          for (; Xt < j.length; Xt++) {
            var ws = H(q, j[Xt], le);
            ws !== null && (Ri = y(ws, Ri, Xt), yn === null ? ft = ws : yn.sibling = ws, yn = ws);
          }
          if (Rr()) {
            var Ea = Xt;
            kp(q, Ea);
          }
          return ft;
        }
        for (var ka = u(q, Zt); Xt < j.length; Xt++) {
          var oa = Q(ka, q, Xt, j[Xt], le);
          oa !== null && (e && oa.alternate !== null && ka.delete(oa.key === null ? Xt : oa.key), Ri = y(oa, Ri, Xt), yn === null ? ft = oa : yn.sibling = oa, yn = oa);
        }
        if (e && ka.forEach(function(ng) {
          return n(q, ng);
        }), Rr()) {
          var Sc = Xt;
          kp(q, Sc);
        }
        return ft;
      }
      function Ce(q, J, j, le) {
        var xe = En(j);
        if (typeof xe != "function")
          throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
        {
          typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
          j[Symbol.toStringTag] === "Generator" && (qT || g("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), qT = !0), j.entries === xe && (BT || g("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), BT = !0);
          var we = xe.call(j);
          if (we)
            for (var at = null, ft = we.next(); !ft.done; ft = we.next()) {
              var yn = ft.value;
              at = W(yn, at, q);
            }
        }
        var Zt = xe.call(j);
        if (Zt == null)
          throw new Error("An iterable object provided no iterator.");
        for (var Ri = null, Xt = null, mi = J, sa = 0, Or = 0, ws = null, Ea = Zt.next(); mi !== null && !Ea.done; Or++, Ea = Zt.next()) {
          mi.index > Or ? (ws = mi, mi = null) : ws = mi.sibling;
          var ka = V(q, mi, Ea.value, le);
          if (ka === null) {
            mi === null && (mi = ws);
            break;
          }
          e && mi && ka.alternate === null && n(q, mi), sa = y(ka, sa, Or), Xt === null ? Ri = ka : Xt.sibling = ka, Xt = ka, mi = ws;
        }
        if (Ea.done) {
          if (o(q, mi), Rr()) {
            var oa = Or;
            kp(q, oa);
          }
          return Ri;
        }
        if (mi === null) {
          for (; !Ea.done; Or++, Ea = Zt.next()) {
            var Sc = H(q, Ea.value, le);
            Sc !== null && (sa = y(Sc, sa, Or), Xt === null ? Ri = Sc : Xt.sibling = Sc, Xt = Sc);
          }
          if (Rr()) {
            var ng = Or;
            kp(q, ng);
          }
          return Ri;
        }
        for (var s2 = u(q, mi); !Ea.done; Or++, Ea = Zt.next()) {
          var Gl = Q(s2, q, Or, Ea.value, le);
          Gl !== null && (e && Gl.alternate !== null && s2.delete(Gl.key === null ? Or : Gl.key), sa = y(Gl, sa, Or), Xt === null ? Ri = Gl : Xt.sibling = Gl, Xt = Gl);
        }
        if (e && s2.forEach(function(jG) {
          return n(q, jG);
        }), Rr()) {
          var qG = Or;
          kp(q, qG);
        }
        return Ri;
      }
      function Qe(q, J, j, le) {
        if (J !== null && J.tag === Z) {
          o(q, J.sibling);
          var xe = h(J, j);
          return xe.return = q, xe;
        }
        o(q, J);
        var we = I4(j, q.mode, le);
        return we.return = q, we;
      }
      function Ue(q, J, j, le) {
        for (var xe = j.key, we = J; we !== null; ) {
          if (we.key === xe) {
            var at = j.type;
            if (at === fd) {
              if (we.tag === ne) {
                o(q, we.sibling);
                var ft = h(we, j.props.children);
                return ft.return = q, ft._debugSource = j._source, ft._debugOwner = j._owner, ft;
              }
            } else if (we.elementType === at || // Keep this check inline so it only runs on the false path:
            d$(we, j) || // Lazy types should reconcile their resolved type.
            // We need to do this after the Hot Reloading check above,
            // because hot reloading has different semantics than prod because
            // it doesn't resuspend. So we can't let the call below suspend.
            typeof at == "object" && at !== null && at.$$typeof === cr && aR(at) === we.type) {
              o(q, we.sibling);
              var yn = h(we, j.props);
              return yn.ref = L6(q, we, j), yn.return = q, yn._debugSource = j._source, yn._debugOwner = j._owner, yn;
            }
            o(q, we);
            break;
          } else
            n(q, we);
          we = we.sibling;
        }
        if (j.type === fd) {
          var Zt = sf(j.props.children, q.mode, le, j.key);
          return Zt.return = q, Zt;
        } else {
          var Ri = F4(j, q.mode, le);
          return Ri.ref = L6(q, J, j), Ri.return = q, Ri;
        }
      }
      function Ut(q, J, j, le) {
        for (var xe = j.key, we = J; we !== null; ) {
          if (we.key === xe)
            if (we.tag === U && we.stateNode.containerInfo === j.containerInfo && we.stateNode.implementation === j.implementation) {
              o(q, we.sibling);
              var at = h(we, j.children || []);
              return at.return = q, at;
            } else {
              o(q, we);
              break;
            }
          else
            n(q, we);
          we = we.sibling;
        }
        var ft = B4(j, q.mode, le);
        return ft.return = q, ft;
      }
      function Dt(q, J, j, le) {
        var xe = typeof j == "object" && j !== null && j.type === fd && j.key === null;
        if (xe && (j = j.props.children), typeof j == "object" && j !== null) {
          switch (j.$$typeof) {
            case hl:
              return S(Ue(q, J, j, le));
            case us:
              return S(Ut(q, J, j, le));
            case cr:
              var we = j._payload, at = j._init;
              return Dt(q, J, at(we), le);
          }
          if (Gi(j))
            return X(q, J, j, le);
          if (En(j))
            return Ce(q, J, j, le);
          zS(q, j);
        }
        return typeof j == "string" && j !== "" || typeof j == "number" ? S(Qe(q, J, "" + j, le)) : (typeof j == "function" && HS(q), o(q, J));
      }
      return Dt;
    }
    var Uy = sR(!0), oR = sR(!1);
    function SB(e, n) {
      if (e !== null && n.child !== e.child)
        throw new Error("Resuming work not yet implemented.");
      if (n.child !== null) {
        var o = n.child, u = Up(o, o.pendingProps);
        for (n.child = u, u.return = n; o.sibling !== null; )
          o = o.sibling, u = u.sibling = Up(o, o.pendingProps), u.return = n;
        u.sibling = null;
      }
    }
    function bB(e, n) {
      for (var o = e.child; o !== null; )
        lG(o, n), o = o.sibling;
    }
    var YT = jd(null), WT;
    WT = {};
    var FS = null, zy = null, KT = null, IS = !1;
    function BS() {
      FS = null, zy = null, KT = null, IS = !1;
    }
    function lR() {
      IS = !0;
    }
    function uR() {
      IS = !1;
    }
    function cR(e, n, o) {
      ra(YT, n._currentValue, e), n._currentValue = o, n._currentRenderer !== void 0 && n._currentRenderer !== null && n._currentRenderer !== WT && g("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), n._currentRenderer = WT;
    }
    function ZT(e, n) {
      var o = YT.current;
      ia(YT, n), e._currentValue = o;
    }
    function XT(e, n, o) {
      for (var u = e; u !== null; ) {
        var h = u.alternate;
        if (ic(u.childLanes, n) ? h !== null && !ic(h.childLanes, n) && (h.childLanes = yt(h.childLanes, n)) : (u.childLanes = yt(u.childLanes, n), h !== null && (h.childLanes = yt(h.childLanes, n))), u === o)
          break;
        u = u.return;
      }
      u !== o && g("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function wB(e, n, o) {
      TB(e, n, o);
    }
    function TB(e, n, o) {
      var u = e.child;
      for (u !== null && (u.return = e); u !== null; ) {
        var h = void 0, y = u.dependencies;
        if (y !== null) {
          h = u.child;
          for (var S = y.firstContext; S !== null; ) {
            if (S.context === n) {
              if (u.tag === $) {
                var w = np(o), E = pc(kn, w);
                E.tag = jS;
                var D = u.updateQueue;
                if (D !== null) {
                  var M = D.shared, H = M.pending;
                  H === null ? E.next = E : (E.next = H.next, H.next = E), M.pending = E;
                }
              }
              u.lanes = yt(u.lanes, o);
              var V = u.alternate;
              V !== null && (V.lanes = yt(V.lanes, o)), XT(u.return, o, e), y.lanes = yt(y.lanes, o);
              break;
            }
            S = S.next;
          }
        } else if (u.tag === Ne)
          h = u.type === e.type ? null : u.child;
        else if (u.tag === pt) {
          var Q = u.return;
          if (Q === null)
            throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
          Q.lanes = yt(Q.lanes, o);
          var W = Q.alternate;
          W !== null && (W.lanes = yt(W.lanes, o)), XT(Q, o, e), h = u.sibling;
        } else
          h = u.child;
        if (h !== null)
          h.return = u;
        else
          for (h = u; h !== null; ) {
            if (h === e) {
              h = null;
              break;
            }
            var X = h.sibling;
            if (X !== null) {
              X.return = h.return, h = X;
              break;
            }
            h = h.return;
          }
        u = h;
      }
    }
    function Hy(e, n) {
      FS = e, zy = null, KT = null;
      var o = e.dependencies;
      if (o !== null) {
        var u = o.firstContext;
        u !== null && (Jr(o.lanes, n) && B6(), o.firstContext = null);
      }
    }
    function Ni(e) {
      IS && g("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      var n = e._currentValue;
      if (KT !== e) {
        var o = {
          context: e,
          memoizedValue: n,
          next: null
        };
        if (zy === null) {
          if (FS === null)
            throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
          zy = o, FS.dependencies = {
            lanes: ie,
            firstContext: o
          };
        } else
          zy = zy.next = o;
      }
      return n;
    }
    var Dp = null;
    function JT(e) {
      Dp === null ? Dp = [e] : Dp.push(e);
    }
    function EB() {
      if (Dp !== null) {
        for (var e = 0; e < Dp.length; e++) {
          var n = Dp[e], o = n.interleaved;
          if (o !== null) {
            n.interleaved = null;
            var u = o.next, h = n.pending;
            if (h !== null) {
              var y = h.next;
              h.next = u, o.next = y;
            }
            n.pending = o;
          }
        }
        Dp = null;
      }
    }
    function dR(e, n, o, u) {
      var h = n.interleaved;
      return h === null ? (o.next = o, JT(n)) : (o.next = h.next, h.next = o), n.interleaved = o, qS(e, u);
    }
    function kB(e, n, o, u) {
      var h = n.interleaved;
      h === null ? (o.next = o, JT(n)) : (o.next = h.next, h.next = o), n.interleaved = o;
    }
    function xB(e, n, o, u) {
      var h = n.interleaved;
      return h === null ? (o.next = o, JT(n)) : (o.next = h.next, h.next = o), n.interleaved = o, qS(e, u);
    }
    function Ka(e, n) {
      return qS(e, n);
    }
    var RB = qS;
    function qS(e, n) {
      e.lanes = yt(e.lanes, n);
      var o = e.alternate;
      o !== null && (o.lanes = yt(o.lanes, n)), o === null && (e.flags & (Kn | Fa)) !== Fe && o$(e);
      for (var u = e, h = e.return; h !== null; )
        h.childLanes = yt(h.childLanes, n), o = h.alternate, o !== null ? o.childLanes = yt(o.childLanes, n) : (h.flags & (Kn | Fa)) !== Fe && o$(e), u = h, h = h.return;
      if (u.tag === A) {
        var y = u.stateNode;
        return y;
      } else
        return null;
    }
    var fR = 0, hR = 1, jS = 2, eE = 3, GS = !1, tE, QS;
    tE = !1, QS = null;
    function nE(e) {
      var n = {
        baseState: e.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
          pending: null,
          interleaved: null,
          lanes: ie
        },
        effects: null
      };
      e.updateQueue = n;
    }
    function pR(e, n) {
      var o = n.updateQueue, u = e.updateQueue;
      if (o === u) {
        var h = {
          baseState: u.baseState,
          firstBaseUpdate: u.firstBaseUpdate,
          lastBaseUpdate: u.lastBaseUpdate,
          shared: u.shared,
          effects: u.effects
        };
        n.updateQueue = h;
      }
    }
    function pc(e, n) {
      var o = {
        eventTime: e,
        lane: n,
        tag: fR,
        payload: null,
        callback: null,
        next: null
      };
      return o;
    }
    function Wd(e, n, o) {
      var u = e.updateQueue;
      if (u === null)
        return null;
      var h = u.shared;
      if (QS === h && !tE && (g("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), tE = !0), kj()) {
        var y = h.pending;
        return y === null ? n.next = n : (n.next = y.next, y.next = n), h.pending = n, RB(e, o);
      } else
        return xB(e, h, n, o);
    }
    function YS(e, n, o) {
      var u = n.updateQueue;
      if (u !== null) {
        var h = u.shared;
        if (F3(o)) {
          var y = h.lanes;
          y = B3(y, e.pendingLanes);
          var S = yt(y, o);
          h.lanes = S, dy(e, S);
        }
      }
    }
    function iE(e, n) {
      var o = e.updateQueue, u = e.alternate;
      if (u !== null) {
        var h = u.updateQueue;
        if (o === h) {
          var y = null, S = null, w = o.firstBaseUpdate;
          if (w !== null) {
            var E = w;
            do {
              var D = {
                eventTime: E.eventTime,
                lane: E.lane,
                tag: E.tag,
                payload: E.payload,
                callback: E.callback,
                next: null
              };
              S === null ? y = S = D : (S.next = D, S = D), E = E.next;
            } while (E !== null);
            S === null ? y = S = n : (S.next = n, S = n);
          } else
            y = S = n;
          o = {
            baseState: h.baseState,
            firstBaseUpdate: y,
            lastBaseUpdate: S,
            shared: h.shared,
            effects: h.effects
          }, e.updateQueue = o;
          return;
        }
      }
      var M = o.lastBaseUpdate;
      M === null ? o.firstBaseUpdate = n : M.next = n, o.lastBaseUpdate = n;
    }
    function LB(e, n, o, u, h, y) {
      switch (o.tag) {
        case hR: {
          var S = o.payload;
          if (typeof S == "function") {
            lR();
            var w = S.call(y, u, h);
            {
              if (e.mode & mn) {
                Un(!0);
                try {
                  S.call(y, u, h);
                } finally {
                  Un(!1);
                }
              }
              uR();
            }
            return w;
          }
          return S;
        }
        case eE:
          e.flags = e.flags & -65537 | He;
        // Intentional fallthrough
        case fR: {
          var E = o.payload, D;
          if (typeof E == "function") {
            lR(), D = E.call(y, u, h);
            {
              if (e.mode & mn) {
                Un(!0);
                try {
                  E.call(y, u, h);
                } finally {
                  Un(!1);
                }
              }
              uR();
            }
          } else
            D = E;
          return D == null ? u : Pt({}, u, D);
        }
        case jS:
          return GS = !0, u;
      }
      return u;
    }
    function WS(e, n, o, u) {
      var h = e.updateQueue;
      GS = !1, QS = h.shared;
      var y = h.firstBaseUpdate, S = h.lastBaseUpdate, w = h.shared.pending;
      if (w !== null) {
        h.shared.pending = null;
        var E = w, D = E.next;
        E.next = null, S === null ? y = D : S.next = D, S = E;
        var M = e.alternate;
        if (M !== null) {
          var H = M.updateQueue, V = H.lastBaseUpdate;
          V !== S && (V === null ? H.firstBaseUpdate = D : V.next = D, H.lastBaseUpdate = E);
        }
      }
      if (y !== null) {
        var Q = h.baseState, W = ie, X = null, Ce = null, Qe = null, Ue = y;
        do {
          var Ut = Ue.lane, Dt = Ue.eventTime;
          if (ic(u, Ut)) {
            if (Qe !== null) {
              var J = {
                eventTime: Dt,
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ft,
                tag: Ue.tag,
                payload: Ue.payload,
                callback: Ue.callback,
                next: null
              };
              Qe = Qe.next = J;
            }
            Q = LB(e, h, Ue, Q, n, o);
            var j = Ue.callback;
            if (j !== null && // If the update was already committed, we should not queue its
            // callback again.
            Ue.lane !== Ft) {
              e.flags |= xn;
              var le = h.effects;
              le === null ? h.effects = [Ue] : le.push(Ue);
            }
          } else {
            var q = {
              eventTime: Dt,
              lane: Ut,
              tag: Ue.tag,
              payload: Ue.payload,
              callback: Ue.callback,
              next: null
            };
            Qe === null ? (Ce = Qe = q, X = Q) : Qe = Qe.next = q, W = yt(W, Ut);
          }
          if (Ue = Ue.next, Ue === null) {
            if (w = h.shared.pending, w === null)
              break;
            var xe = w, we = xe.next;
            xe.next = null, Ue = we, h.lastBaseUpdate = xe, h.shared.pending = null;
          }
        } while (!0);
        Qe === null && (X = Q), h.baseState = X, h.firstBaseUpdate = Ce, h.lastBaseUpdate = Qe;
        var at = h.shared.interleaved;
        if (at !== null) {
          var ft = at;
          do
            W = yt(W, ft.lane), ft = ft.next;
          while (ft !== at);
        } else y === null && (h.shared.lanes = ie);
        t2(W), e.lanes = W, e.memoizedState = Q;
      }
      QS = null;
    }
    function $B(e, n) {
      if (typeof e != "function")
        throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + e));
      e.call(n);
    }
    function mR() {
      GS = !1;
    }
    function KS() {
      return GS;
    }
    function vR(e, n, o) {
      var u = n.effects;
      if (n.effects = null, u !== null)
        for (var h = 0; h < u.length; h++) {
          var y = u[h], S = y.callback;
          S !== null && (y.callback = null, $B(S, o));
        }
    }
    var $6 = {}, Kd = jd($6), D6 = jd($6), ZS = jd($6);
    function XS(e) {
      if (e === $6)
        throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
      return e;
    }
    function yR() {
      var e = XS(ZS.current);
      return e;
    }
    function rE(e, n) {
      ra(ZS, n, e), ra(D6, e, e), ra(Kd, $6, e);
      var o = GF(n);
      ia(Kd, e), ra(Kd, o, e);
    }
    function Fy(e) {
      ia(Kd, e), ia(D6, e), ia(ZS, e);
    }
    function aE() {
      var e = XS(Kd.current);
      return e;
    }
    function gR(e) {
      XS(ZS.current);
      var n = XS(Kd.current), o = QF(n, e.type);
      n !== o && (ra(D6, e, e), ra(Kd, o, e));
    }
    function sE(e) {
      D6.current === e && (ia(Kd, e), ia(D6, e));
    }
    var DB = 0, CR = 1, SR = 1, M6 = 2, No = jd(DB);
    function oE(e, n) {
      return (e & n) !== 0;
    }
    function Iy(e) {
      return e & CR;
    }
    function lE(e, n) {
      return e & CR | n;
    }
    function MB(e, n) {
      return e | n;
    }
    function Zd(e, n) {
      ra(No, n, e);
    }
    function By(e) {
      ia(No, e);
    }
    function AB(e, n) {
      var o = e.memoizedState;
      return o !== null ? o.dehydrated !== null : (e.memoizedProps, !0);
    }
    function JS(e) {
      for (var n = e; n !== null; ) {
        if (n.tag === Me) {
          var o = n.memoizedState;
          if (o !== null) {
            var u = o.dehydrated;
            if (u === null || Vx(u) || xT(u))
              return n;
          }
        } else if (n.tag === Gt && // revealOrder undefined can't be trusted because it don't
        // keep track of whether it suspended or not.
        n.memoizedProps.revealOrder !== void 0) {
          var h = (n.flags & He) !== Fe;
          if (h)
            return n;
        } else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === e)
          return null;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === e)
            return null;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      return null;
    }
    var Za = (
      /*   */
      0
    ), Zi = (
      /* */
      1
    ), zl = (
      /*  */
      2
    ), Xi = (
      /*    */
      4
    ), Lr = (
      /*   */
      8
    ), uE = [];
    function cE() {
      for (var e = 0; e < uE.length; e++) {
        var n = uE[e];
        n._workInProgressVersionPrimary = null;
      }
      uE.length = 0;
    }
    function PB(e, n) {
      var o = n._getVersion, u = o(n._source);
      e.mutableSourceEagerHydrationData == null ? e.mutableSourceEagerHydrationData = [n, u] : e.mutableSourceEagerHydrationData.push(n, u);
    }
    var Ee = t.ReactCurrentDispatcher, A6 = t.ReactCurrentBatchConfig, dE, qy;
    dE = /* @__PURE__ */ new Set();
    var Mp = ie, vn = null, Ji = null, er = null, eb = !1, P6 = !1, O6 = 0, OB = 0, _B = 25, te = null, to = null, Xd = -1, fE = !1;
    function un() {
      {
        var e = te;
        to === null ? to = [e] : to.push(e);
      }
    }
    function ve() {
      {
        var e = te;
        to !== null && (Xd++, to[Xd] !== e && NB(e));
      }
    }
    function jy(e) {
      e != null && !Gi(e) && g("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", te, typeof e);
    }
    function NB(e) {
      {
        var n = vt(vn);
        if (!dE.has(n) && (dE.add(n), to !== null)) {
          for (var o = "", u = 30, h = 0; h <= Xd; h++) {
            for (var y = to[h], S = h === Xd ? e : y, w = h + 1 + ". " + y; w.length < u; )
              w += " ";
            w += S + `
`, o += w;
          }
          g(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, n, o);
        }
      }
    }
    function aa() {
      throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
    }
    function hE(e, n) {
      if (fE)
        return !1;
      if (n === null)
        return g("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", te), !1;
      e.length !== n.length && g(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, te, "[" + n.join(", ") + "]", "[" + e.join(", ") + "]");
      for (var o = 0; o < n.length && o < e.length; o++)
        if (!be(e[o], n[o]))
          return !1;
      return !0;
    }
    function Gy(e, n, o, u, h, y) {
      Mp = y, vn = n, to = e !== null ? e._debugHookTypes : null, Xd = -1, fE = e !== null && e.type !== n.type, n.memoizedState = null, n.updateQueue = null, n.lanes = ie, e !== null && e.memoizedState !== null ? Ee.current = IR : to !== null ? Ee.current = FR : Ee.current = HR;
      var S = o(u, h);
      if (P6) {
        var w = 0;
        do {
          if (P6 = !1, O6 = 0, w >= _B)
            throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
          w += 1, fE = !1, Ji = null, er = null, n.updateQueue = null, Xd = -1, Ee.current = BR, S = o(u, h);
        } while (P6);
      }
      Ee.current = hb, n._debugHookTypes = to;
      var E = Ji !== null && Ji.next !== null;
      if (Mp = ie, vn = null, Ji = null, er = null, te = null, to = null, Xd = -1, e !== null && (e.flags & ui) !== (n.flags & ui) && // Disable this warning in legacy mode, because legacy Suspense is weird
      // and creates false positives. To make this work in legacy mode, we'd
      // need to mark fibers that commit in an incomplete state, somehow. For
      // now I'll disable the warning that most of the bugs that would trigger
      // it are either exclusive to concurrent mode or exist in both.
      (e.mode & Tt) !== Ie && g("Internal React error: Expected static flag was missing. Please notify the React team."), eb = !1, E)
        throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
      return S;
    }
    function Qy() {
      var e = O6 !== 0;
      return O6 = 0, e;
    }
    function bR(e, n, o) {
      n.updateQueue = e.updateQueue, (n.mode & Wt) !== Ie ? n.flags &= -50333701 : n.flags &= -2053, e.lanes = ip(e.lanes, o);
    }
    function wR() {
      if (Ee.current = hb, eb) {
        for (var e = vn.memoizedState; e !== null; ) {
          var n = e.queue;
          n !== null && (n.pending = null), e = e.next;
        }
        eb = !1;
      }
      Mp = ie, vn = null, Ji = null, er = null, to = null, Xd = -1, te = null, _R = !1, P6 = !1, O6 = 0;
    }
    function Hl() {
      var e = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      return er === null ? vn.memoizedState = er = e : er = er.next = e, er;
    }
    function no() {
      var e;
      if (Ji === null) {
        var n = vn.alternate;
        n !== null ? e = n.memoizedState : e = null;
      } else
        e = Ji.next;
      var o;
      if (er === null ? o = vn.memoizedState : o = er.next, o !== null)
        er = o, o = er.next, Ji = e;
      else {
        if (e === null)
          throw new Error("Rendered more hooks than during the previous render.");
        Ji = e;
        var u = {
          memoizedState: Ji.memoizedState,
          baseState: Ji.baseState,
          baseQueue: Ji.baseQueue,
          queue: Ji.queue,
          next: null
        };
        er === null ? vn.memoizedState = er = u : er = er.next = u;
      }
      return er;
    }
    function TR() {
      return {
        lastEffect: null,
        stores: null
      };
    }
    function pE(e, n) {
      return typeof n == "function" ? n(e) : n;
    }
    function mE(e, n, o) {
      var u = Hl(), h;
      o !== void 0 ? h = o(n) : h = n, u.memoizedState = u.baseState = h;
      var y = {
        pending: null,
        interleaved: null,
        lanes: ie,
        dispatch: null,
        lastRenderedReducer: e,
        lastRenderedState: h
      };
      u.queue = y;
      var S = y.dispatch = HB.bind(null, vn, y);
      return [u.memoizedState, S];
    }
    function vE(e, n, o) {
      var u = no(), h = u.queue;
      if (h === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      h.lastRenderedReducer = e;
      var y = Ji, S = y.baseQueue, w = h.pending;
      if (w !== null) {
        if (S !== null) {
          var E = S.next, D = w.next;
          S.next = D, w.next = E;
        }
        y.baseQueue !== S && g("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), y.baseQueue = S = w, h.pending = null;
      }
      if (S !== null) {
        var M = S.next, H = y.baseState, V = null, Q = null, W = null, X = M;
        do {
          var Ce = X.lane;
          if (ic(Mp, Ce)) {
            if (W !== null) {
              var Ue = {
                // This update is going to be committed so we never want uncommit
                // it. Using NoLane works because 0 is a subset of all bitmasks, so
                // this will never be skipped by the check above.
                lane: Ft,
                action: X.action,
                hasEagerState: X.hasEagerState,
                eagerState: X.eagerState,
                next: null
              };
              W = W.next = Ue;
            }
            if (X.hasEagerState)
              H = X.eagerState;
            else {
              var Ut = X.action;
              H = e(H, Ut);
            }
          } else {
            var Qe = {
              lane: Ce,
              action: X.action,
              hasEagerState: X.hasEagerState,
              eagerState: X.eagerState,
              next: null
            };
            W === null ? (Q = W = Qe, V = H) : W = W.next = Qe, vn.lanes = yt(vn.lanes, Ce), t2(Ce);
          }
          X = X.next;
        } while (X !== null && X !== M);
        W === null ? V = H : W.next = Q, be(H, u.memoizedState) || B6(), u.memoizedState = H, u.baseState = V, u.baseQueue = W, h.lastRenderedState = H;
      }
      var Dt = h.interleaved;
      if (Dt !== null) {
        var q = Dt;
        do {
          var J = q.lane;
          vn.lanes = yt(vn.lanes, J), t2(J), q = q.next;
        } while (q !== Dt);
      } else S === null && (h.lanes = ie);
      var j = h.dispatch;
      return [u.memoizedState, j];
    }
    function yE(e, n, o) {
      var u = no(), h = u.queue;
      if (h === null)
        throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
      h.lastRenderedReducer = e;
      var y = h.dispatch, S = h.pending, w = u.memoizedState;
      if (S !== null) {
        h.pending = null;
        var E = S.next, D = E;
        do {
          var M = D.action;
          w = e(w, M), D = D.next;
        } while (D !== E);
        be(w, u.memoizedState) || B6(), u.memoizedState = w, u.baseQueue === null && (u.baseState = w), h.lastRenderedState = w;
      }
      return [w, y];
    }
    function qee(e, n, o) {
    }
    function jee(e, n, o) {
    }
    function gE(e, n, o) {
      var u = vn, h = Hl(), y, S = Rr();
      if (S) {
        if (o === void 0)
          throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
        y = o(), qy || y !== o() && (g("The result of getServerSnapshot should be cached to avoid an infinite loop"), qy = !0);
      } else {
        if (y = n(), !qy) {
          var w = n();
          be(y, w) || (g("The result of getSnapshot should be cached to avoid an infinite loop"), qy = !0);
        }
        var E = Ab();
        if (E === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        uy(E, Mp) || ER(u, n, y);
      }
      h.memoizedState = y;
      var D = {
        value: y,
        getSnapshot: n
      };
      return h.queue = D, ab(xR.bind(null, u, D, e), [e]), u.flags |= Yr, _6(Zi | Lr, kR.bind(null, u, D, y, n), void 0, null), y;
    }
    function tb(e, n, o) {
      var u = vn, h = no(), y = n();
      if (!qy) {
        var S = n();
        be(y, S) || (g("The result of getSnapshot should be cached to avoid an infinite loop"), qy = !0);
      }
      var w = h.memoizedState, E = !be(w, y);
      E && (h.memoizedState = y, B6());
      var D = h.queue;
      if (V6(xR.bind(null, u, D, e), [e]), D.getSnapshot !== n || E || // Check if the susbcribe function changed. We can save some memory by
      // checking whether we scheduled a subscription effect above.
      er !== null && er.memoizedState.tag & Zi) {
        u.flags |= Yr, _6(Zi | Lr, kR.bind(null, u, D, y, n), void 0, null);
        var M = Ab();
        if (M === null)
          throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
        uy(M, Mp) || ER(u, n, y);
      }
      return y;
    }
    function ER(e, n, o) {
      e.flags |= $d;
      var u = {
        getSnapshot: n,
        value: o
      }, h = vn.updateQueue;
      if (h === null)
        h = TR(), vn.updateQueue = h, h.stores = [u];
      else {
        var y = h.stores;
        y === null ? h.stores = [u] : y.push(u);
      }
    }
    function kR(e, n, o, u) {
      n.value = o, n.getSnapshot = u, RR(n) && LR(e);
    }
    function xR(e, n, o) {
      var u = function() {
        RR(n) && LR(e);
      };
      return o(u);
    }
    function RR(e) {
      var n = e.getSnapshot, o = e.value;
      try {
        var u = n();
        return !be(o, u);
      } catch {
        return !0;
      }
    }
    function LR(e) {
      var n = Ka(e, tt);
      n !== null && rr(n, e, tt, kn);
    }
    function nb(e) {
      var n = Hl();
      typeof e == "function" && (e = e()), n.memoizedState = n.baseState = e;
      var o = {
        pending: null,
        interleaved: null,
        lanes: ie,
        dispatch: null,
        lastRenderedReducer: pE,
        lastRenderedState: e
      };
      n.queue = o;
      var u = o.dispatch = FB.bind(null, vn, o);
      return [n.memoizedState, u];
    }
    function CE(e) {
      return vE(pE);
    }
    function SE(e) {
      return yE(pE);
    }
    function _6(e, n, o, u) {
      var h = {
        tag: e,
        create: n,
        destroy: o,
        deps: u,
        // Circular
        next: null
      }, y = vn.updateQueue;
      if (y === null)
        y = TR(), vn.updateQueue = y, y.lastEffect = h.next = h;
      else {
        var S = y.lastEffect;
        if (S === null)
          y.lastEffect = h.next = h;
        else {
          var w = S.next;
          S.next = h, h.next = w, y.lastEffect = h;
        }
      }
      return h;
    }
    function bE(e) {
      var n = Hl();
      {
        var o = {
          current: e
        };
        return n.memoizedState = o, o;
      }
    }
    function ib(e) {
      var n = no();
      return n.memoizedState;
    }
    function N6(e, n, o, u) {
      var h = Hl(), y = u === void 0 ? null : u;
      vn.flags |= e, h.memoizedState = _6(Zi | n, o, void 0, y);
    }
    function rb(e, n, o, u) {
      var h = no(), y = u === void 0 ? null : u, S = void 0;
      if (Ji !== null) {
        var w = Ji.memoizedState;
        if (S = w.destroy, y !== null) {
          var E = w.deps;
          if (hE(y, E)) {
            h.memoizedState = _6(n, o, S, y);
            return;
          }
        }
      }
      vn.flags |= e, h.memoizedState = _6(Zi | n, o, S, y);
    }
    function ab(e, n) {
      return (vn.mode & Wt) !== Ie ? N6(Bs | Yr | Nv, Lr, e, n) : N6(Yr | Nv, Lr, e, n);
    }
    function V6(e, n) {
      return rb(Yr, Lr, e, n);
    }
    function wE(e, n) {
      return N6(_t, zl, e, n);
    }
    function sb(e, n) {
      return rb(_t, zl, e, n);
    }
    function TE(e, n) {
      var o = _t;
      return o |= Eo, (vn.mode & Wt) !== Ie && (o |= bl), N6(o, Xi, e, n);
    }
    function ob(e, n) {
      return rb(_t, Xi, e, n);
    }
    function $R(e, n) {
      if (typeof n == "function") {
        var o = n, u = e();
        return o(u), function() {
          o(null);
        };
      } else if (n != null) {
        var h = n;
        h.hasOwnProperty("current") || g("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(h).join(", ") + "}");
        var y = e();
        return h.current = y, function() {
          h.current = null;
        };
      }
    }
    function EE(e, n, o) {
      typeof n != "function" && g("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", n !== null ? typeof n : "null");
      var u = o != null ? o.concat([e]) : null, h = _t;
      return h |= Eo, (vn.mode & Wt) !== Ie && (h |= bl), N6(h, Xi, $R.bind(null, n, e), u);
    }
    function lb(e, n, o) {
      typeof n != "function" && g("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", n !== null ? typeof n : "null");
      var u = o != null ? o.concat([e]) : null;
      return rb(_t, Xi, $R.bind(null, n, e), u);
    }
    function VB(e, n) {
    }
    var ub = VB;
    function kE(e, n) {
      var o = Hl(), u = n === void 0 ? null : n;
      return o.memoizedState = [e, u], e;
    }
    function cb(e, n) {
      var o = no(), u = n === void 0 ? null : n, h = o.memoizedState;
      if (h !== null && u !== null) {
        var y = h[1];
        if (hE(u, y))
          return h[0];
      }
      return o.memoizedState = [e, u], e;
    }
    function xE(e, n) {
      var o = Hl(), u = n === void 0 ? null : n, h = e();
      return o.memoizedState = [h, u], h;
    }
    function db(e, n) {
      var o = no(), u = n === void 0 ? null : n, h = o.memoizedState;
      if (h !== null && u !== null) {
        var y = h[1];
        if (hE(u, y))
          return h[0];
      }
      var S = e();
      return o.memoizedState = [S, u], S;
    }
    function RE(e) {
      var n = Hl();
      return n.memoizedState = e, e;
    }
    function DR(e) {
      var n = no(), o = Ji, u = o.memoizedState;
      return AR(n, u, e);
    }
    function MR(e) {
      var n = no();
      if (Ji === null)
        return n.memoizedState = e, e;
      var o = Ji.memoizedState;
      return AR(n, o, e);
    }
    function AR(e, n, o) {
      var u = !z3(Mp);
      if (u) {
        if (!be(o, n)) {
          var h = I3();
          vn.lanes = yt(vn.lanes, h), t2(h), e.baseState = !0;
        }
        return n;
      } else
        return e.baseState && (e.baseState = !1, B6()), e.memoizedState = o, o;
    }
    function UB(e, n, o) {
      var u = Qa();
      fi(qC(u, Qs)), e(!0);
      var h = A6.transition;
      A6.transition = {};
      var y = A6.transition;
      A6.transition._updatedFibers = /* @__PURE__ */ new Set();
      try {
        e(!1), n();
      } finally {
        if (fi(u), A6.transition = h, h === null && y._updatedFibers) {
          var S = y._updatedFibers.size;
          S > 10 && v("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), y._updatedFibers.clear();
        }
      }
    }
    function LE() {
      var e = nb(!1), n = e[0], o = e[1], u = UB.bind(null, o), h = Hl();
      return h.memoizedState = u, [n, u];
    }
    function PR() {
      var e = CE(), n = e[0], o = no(), u = o.memoizedState;
      return [n, u];
    }
    function OR() {
      var e = SE(), n = e[0], o = no(), u = o.memoizedState;
      return [n, u];
    }
    var _R = !1;
    function zB() {
      return _R;
    }
    function $E() {
      var e = Hl(), n = Ab(), o = n.identifierPrefix, u;
      if (Rr()) {
        var h = nB();
        u = ":" + o + "R" + h;
        var y = O6++;
        y > 0 && (u += "H" + y.toString(32)), u += ":";
      } else {
        var S = OB++;
        u = ":" + o + "r" + S.toString(32) + ":";
      }
      return e.memoizedState = u, u;
    }
    function fb() {
      var e = no(), n = e.memoizedState;
      return n;
    }
    function HB(e, n, o) {
      typeof arguments[3] == "function" && g("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var u = rf(e), h = {
        lane: u,
        action: o,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (NR(e))
        VR(n, h);
      else {
        var y = dR(e, n, h, u);
        if (y !== null) {
          var S = Ta();
          rr(y, e, u, S), UR(y, n, u);
        }
      }
      zR(e, u);
    }
    function FB(e, n, o) {
      typeof arguments[3] == "function" && g("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
      var u = rf(e), h = {
        lane: u,
        action: o,
        hasEagerState: !1,
        eagerState: null,
        next: null
      };
      if (NR(e))
        VR(n, h);
      else {
        var y = e.alternate;
        if (e.lanes === ie && (y === null || y.lanes === ie)) {
          var S = n.lastRenderedReducer;
          if (S !== null) {
            var w;
            w = Ee.current, Ee.current = Vo;
            try {
              var E = n.lastRenderedState, D = S(E, o);
              if (h.hasEagerState = !0, h.eagerState = D, be(D, E)) {
                kB(e, n, h, u);
                return;
              }
            } catch {
            } finally {
              Ee.current = w;
            }
          }
        }
        var M = dR(e, n, h, u);
        if (M !== null) {
          var H = Ta();
          rr(M, e, u, H), UR(M, n, u);
        }
      }
      zR(e, u);
    }
    function NR(e) {
      var n = e.alternate;
      return e === vn || n !== null && n === vn;
    }
    function VR(e, n) {
      P6 = eb = !0;
      var o = e.pending;
      o === null ? n.next = n : (n.next = o.next, o.next = n), e.pending = n;
    }
    function UR(e, n, o) {
      if (F3(o)) {
        var u = n.lanes;
        u = B3(u, e.pendingLanes);
        var h = yt(u, o);
        n.lanes = h, dy(e, h);
      }
    }
    function zR(e, n, o) {
      Qh(e, n);
    }
    var hb = {
      readContext: Ni,
      useCallback: aa,
      useContext: aa,
      useEffect: aa,
      useImperativeHandle: aa,
      useInsertionEffect: aa,
      useLayoutEffect: aa,
      useMemo: aa,
      useReducer: aa,
      useRef: aa,
      useState: aa,
      useDebugValue: aa,
      useDeferredValue: aa,
      useTransition: aa,
      useMutableSource: aa,
      useSyncExternalStore: aa,
      useId: aa,
      unstable_isNewReconciler: se
    }, HR = null, FR = null, IR = null, BR = null, Fl = null, Vo = null, pb = null;
    {
      var DE = function() {
        g("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
      }, dt = function() {
        g("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
      };
      HR = {
        readContext: function(e) {
          return Ni(e);
        },
        useCallback: function(e, n) {
          return te = "useCallback", un(), jy(n), kE(e, n);
        },
        useContext: function(e) {
          return te = "useContext", un(), Ni(e);
        },
        useEffect: function(e, n) {
          return te = "useEffect", un(), jy(n), ab(e, n);
        },
        useImperativeHandle: function(e, n, o) {
          return te = "useImperativeHandle", un(), jy(o), EE(e, n, o);
        },
        useInsertionEffect: function(e, n) {
          return te = "useInsertionEffect", un(), jy(n), wE(e, n);
        },
        useLayoutEffect: function(e, n) {
          return te = "useLayoutEffect", un(), jy(n), TE(e, n);
        },
        useMemo: function(e, n) {
          te = "useMemo", un(), jy(n);
          var o = Ee.current;
          Ee.current = Fl;
          try {
            return xE(e, n);
          } finally {
            Ee.current = o;
          }
        },
        useReducer: function(e, n, o) {
          te = "useReducer", un();
          var u = Ee.current;
          Ee.current = Fl;
          try {
            return mE(e, n, o);
          } finally {
            Ee.current = u;
          }
        },
        useRef: function(e) {
          return te = "useRef", un(), bE(e);
        },
        useState: function(e) {
          te = "useState", un();
          var n = Ee.current;
          Ee.current = Fl;
          try {
            return nb(e);
          } finally {
            Ee.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return te = "useDebugValue", un(), void 0;
        },
        useDeferredValue: function(e) {
          return te = "useDeferredValue", un(), RE(e);
        },
        useTransition: function() {
          return te = "useTransition", un(), LE();
        },
        useMutableSource: function(e, n, o) {
          return te = "useMutableSource", un(), void 0;
        },
        useSyncExternalStore: function(e, n, o) {
          return te = "useSyncExternalStore", un(), gE(e, n, o);
        },
        useId: function() {
          return te = "useId", un(), $E();
        },
        unstable_isNewReconciler: se
      }, FR = {
        readContext: function(e) {
          return Ni(e);
        },
        useCallback: function(e, n) {
          return te = "useCallback", ve(), kE(e, n);
        },
        useContext: function(e) {
          return te = "useContext", ve(), Ni(e);
        },
        useEffect: function(e, n) {
          return te = "useEffect", ve(), ab(e, n);
        },
        useImperativeHandle: function(e, n, o) {
          return te = "useImperativeHandle", ve(), EE(e, n, o);
        },
        useInsertionEffect: function(e, n) {
          return te = "useInsertionEffect", ve(), wE(e, n);
        },
        useLayoutEffect: function(e, n) {
          return te = "useLayoutEffect", ve(), TE(e, n);
        },
        useMemo: function(e, n) {
          te = "useMemo", ve();
          var o = Ee.current;
          Ee.current = Fl;
          try {
            return xE(e, n);
          } finally {
            Ee.current = o;
          }
        },
        useReducer: function(e, n, o) {
          te = "useReducer", ve();
          var u = Ee.current;
          Ee.current = Fl;
          try {
            return mE(e, n, o);
          } finally {
            Ee.current = u;
          }
        },
        useRef: function(e) {
          return te = "useRef", ve(), bE(e);
        },
        useState: function(e) {
          te = "useState", ve();
          var n = Ee.current;
          Ee.current = Fl;
          try {
            return nb(e);
          } finally {
            Ee.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return te = "useDebugValue", ve(), void 0;
        },
        useDeferredValue: function(e) {
          return te = "useDeferredValue", ve(), RE(e);
        },
        useTransition: function() {
          return te = "useTransition", ve(), LE();
        },
        useMutableSource: function(e, n, o) {
          return te = "useMutableSource", ve(), void 0;
        },
        useSyncExternalStore: function(e, n, o) {
          return te = "useSyncExternalStore", ve(), gE(e, n, o);
        },
        useId: function() {
          return te = "useId", ve(), $E();
        },
        unstable_isNewReconciler: se
      }, IR = {
        readContext: function(e) {
          return Ni(e);
        },
        useCallback: function(e, n) {
          return te = "useCallback", ve(), cb(e, n);
        },
        useContext: function(e) {
          return te = "useContext", ve(), Ni(e);
        },
        useEffect: function(e, n) {
          return te = "useEffect", ve(), V6(e, n);
        },
        useImperativeHandle: function(e, n, o) {
          return te = "useImperativeHandle", ve(), lb(e, n, o);
        },
        useInsertionEffect: function(e, n) {
          return te = "useInsertionEffect", ve(), sb(e, n);
        },
        useLayoutEffect: function(e, n) {
          return te = "useLayoutEffect", ve(), ob(e, n);
        },
        useMemo: function(e, n) {
          te = "useMemo", ve();
          var o = Ee.current;
          Ee.current = Vo;
          try {
            return db(e, n);
          } finally {
            Ee.current = o;
          }
        },
        useReducer: function(e, n, o) {
          te = "useReducer", ve();
          var u = Ee.current;
          Ee.current = Vo;
          try {
            return vE(e, n, o);
          } finally {
            Ee.current = u;
          }
        },
        useRef: function(e) {
          return te = "useRef", ve(), ib();
        },
        useState: function(e) {
          te = "useState", ve();
          var n = Ee.current;
          Ee.current = Vo;
          try {
            return CE(e);
          } finally {
            Ee.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return te = "useDebugValue", ve(), ub();
        },
        useDeferredValue: function(e) {
          return te = "useDeferredValue", ve(), DR(e);
        },
        useTransition: function() {
          return te = "useTransition", ve(), PR();
        },
        useMutableSource: function(e, n, o) {
          return te = "useMutableSource", ve(), void 0;
        },
        useSyncExternalStore: function(e, n, o) {
          return te = "useSyncExternalStore", ve(), tb(e, n);
        },
        useId: function() {
          return te = "useId", ve(), fb();
        },
        unstable_isNewReconciler: se
      }, BR = {
        readContext: function(e) {
          return Ni(e);
        },
        useCallback: function(e, n) {
          return te = "useCallback", ve(), cb(e, n);
        },
        useContext: function(e) {
          return te = "useContext", ve(), Ni(e);
        },
        useEffect: function(e, n) {
          return te = "useEffect", ve(), V6(e, n);
        },
        useImperativeHandle: function(e, n, o) {
          return te = "useImperativeHandle", ve(), lb(e, n, o);
        },
        useInsertionEffect: function(e, n) {
          return te = "useInsertionEffect", ve(), sb(e, n);
        },
        useLayoutEffect: function(e, n) {
          return te = "useLayoutEffect", ve(), ob(e, n);
        },
        useMemo: function(e, n) {
          te = "useMemo", ve();
          var o = Ee.current;
          Ee.current = pb;
          try {
            return db(e, n);
          } finally {
            Ee.current = o;
          }
        },
        useReducer: function(e, n, o) {
          te = "useReducer", ve();
          var u = Ee.current;
          Ee.current = pb;
          try {
            return yE(e, n, o);
          } finally {
            Ee.current = u;
          }
        },
        useRef: function(e) {
          return te = "useRef", ve(), ib();
        },
        useState: function(e) {
          te = "useState", ve();
          var n = Ee.current;
          Ee.current = pb;
          try {
            return SE(e);
          } finally {
            Ee.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return te = "useDebugValue", ve(), ub();
        },
        useDeferredValue: function(e) {
          return te = "useDeferredValue", ve(), MR(e);
        },
        useTransition: function() {
          return te = "useTransition", ve(), OR();
        },
        useMutableSource: function(e, n, o) {
          return te = "useMutableSource", ve(), void 0;
        },
        useSyncExternalStore: function(e, n, o) {
          return te = "useSyncExternalStore", ve(), tb(e, n);
        },
        useId: function() {
          return te = "useId", ve(), fb();
        },
        unstable_isNewReconciler: se
      }, Fl = {
        readContext: function(e) {
          return DE(), Ni(e);
        },
        useCallback: function(e, n) {
          return te = "useCallback", dt(), un(), kE(e, n);
        },
        useContext: function(e) {
          return te = "useContext", dt(), un(), Ni(e);
        },
        useEffect: function(e, n) {
          return te = "useEffect", dt(), un(), ab(e, n);
        },
        useImperativeHandle: function(e, n, o) {
          return te = "useImperativeHandle", dt(), un(), EE(e, n, o);
        },
        useInsertionEffect: function(e, n) {
          return te = "useInsertionEffect", dt(), un(), wE(e, n);
        },
        useLayoutEffect: function(e, n) {
          return te = "useLayoutEffect", dt(), un(), TE(e, n);
        },
        useMemo: function(e, n) {
          te = "useMemo", dt(), un();
          var o = Ee.current;
          Ee.current = Fl;
          try {
            return xE(e, n);
          } finally {
            Ee.current = o;
          }
        },
        useReducer: function(e, n, o) {
          te = "useReducer", dt(), un();
          var u = Ee.current;
          Ee.current = Fl;
          try {
            return mE(e, n, o);
          } finally {
            Ee.current = u;
          }
        },
        useRef: function(e) {
          return te = "useRef", dt(), un(), bE(e);
        },
        useState: function(e) {
          te = "useState", dt(), un();
          var n = Ee.current;
          Ee.current = Fl;
          try {
            return nb(e);
          } finally {
            Ee.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return te = "useDebugValue", dt(), un(), void 0;
        },
        useDeferredValue: function(e) {
          return te = "useDeferredValue", dt(), un(), RE(e);
        },
        useTransition: function() {
          return te = "useTransition", dt(), un(), LE();
        },
        useMutableSource: function(e, n, o) {
          return te = "useMutableSource", dt(), un(), void 0;
        },
        useSyncExternalStore: function(e, n, o) {
          return te = "useSyncExternalStore", dt(), un(), gE(e, n, o);
        },
        useId: function() {
          return te = "useId", dt(), un(), $E();
        },
        unstable_isNewReconciler: se
      }, Vo = {
        readContext: function(e) {
          return DE(), Ni(e);
        },
        useCallback: function(e, n) {
          return te = "useCallback", dt(), ve(), cb(e, n);
        },
        useContext: function(e) {
          return te = "useContext", dt(), ve(), Ni(e);
        },
        useEffect: function(e, n) {
          return te = "useEffect", dt(), ve(), V6(e, n);
        },
        useImperativeHandle: function(e, n, o) {
          return te = "useImperativeHandle", dt(), ve(), lb(e, n, o);
        },
        useInsertionEffect: function(e, n) {
          return te = "useInsertionEffect", dt(), ve(), sb(e, n);
        },
        useLayoutEffect: function(e, n) {
          return te = "useLayoutEffect", dt(), ve(), ob(e, n);
        },
        useMemo: function(e, n) {
          te = "useMemo", dt(), ve();
          var o = Ee.current;
          Ee.current = Vo;
          try {
            return db(e, n);
          } finally {
            Ee.current = o;
          }
        },
        useReducer: function(e, n, o) {
          te = "useReducer", dt(), ve();
          var u = Ee.current;
          Ee.current = Vo;
          try {
            return vE(e, n, o);
          } finally {
            Ee.current = u;
          }
        },
        useRef: function(e) {
          return te = "useRef", dt(), ve(), ib();
        },
        useState: function(e) {
          te = "useState", dt(), ve();
          var n = Ee.current;
          Ee.current = Vo;
          try {
            return CE(e);
          } finally {
            Ee.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return te = "useDebugValue", dt(), ve(), ub();
        },
        useDeferredValue: function(e) {
          return te = "useDeferredValue", dt(), ve(), DR(e);
        },
        useTransition: function() {
          return te = "useTransition", dt(), ve(), PR();
        },
        useMutableSource: function(e, n, o) {
          return te = "useMutableSource", dt(), ve(), void 0;
        },
        useSyncExternalStore: function(e, n, o) {
          return te = "useSyncExternalStore", dt(), ve(), tb(e, n);
        },
        useId: function() {
          return te = "useId", dt(), ve(), fb();
        },
        unstable_isNewReconciler: se
      }, pb = {
        readContext: function(e) {
          return DE(), Ni(e);
        },
        useCallback: function(e, n) {
          return te = "useCallback", dt(), ve(), cb(e, n);
        },
        useContext: function(e) {
          return te = "useContext", dt(), ve(), Ni(e);
        },
        useEffect: function(e, n) {
          return te = "useEffect", dt(), ve(), V6(e, n);
        },
        useImperativeHandle: function(e, n, o) {
          return te = "useImperativeHandle", dt(), ve(), lb(e, n, o);
        },
        useInsertionEffect: function(e, n) {
          return te = "useInsertionEffect", dt(), ve(), sb(e, n);
        },
        useLayoutEffect: function(e, n) {
          return te = "useLayoutEffect", dt(), ve(), ob(e, n);
        },
        useMemo: function(e, n) {
          te = "useMemo", dt(), ve();
          var o = Ee.current;
          Ee.current = Vo;
          try {
            return db(e, n);
          } finally {
            Ee.current = o;
          }
        },
        useReducer: function(e, n, o) {
          te = "useReducer", dt(), ve();
          var u = Ee.current;
          Ee.current = Vo;
          try {
            return yE(e, n, o);
          } finally {
            Ee.current = u;
          }
        },
        useRef: function(e) {
          return te = "useRef", dt(), ve(), ib();
        },
        useState: function(e) {
          te = "useState", dt(), ve();
          var n = Ee.current;
          Ee.current = Vo;
          try {
            return SE(e);
          } finally {
            Ee.current = n;
          }
        },
        useDebugValue: function(e, n) {
          return te = "useDebugValue", dt(), ve(), ub();
        },
        useDeferredValue: function(e) {
          return te = "useDeferredValue", dt(), ve(), MR(e);
        },
        useTransition: function() {
          return te = "useTransition", dt(), ve(), OR();
        },
        useMutableSource: function(e, n, o) {
          return te = "useMutableSource", dt(), ve(), void 0;
        },
        useSyncExternalStore: function(e, n, o) {
          return te = "useSyncExternalStore", dt(), ve(), tb(e, n);
        },
        useId: function() {
          return te = "useId", dt(), ve(), fb();
        },
        unstable_isNewReconciler: se
      };
    }
    var Jd = s.unstable_now, qR = 0, mb = -1, U6 = -1, vb = -1, ME = !1, yb = !1;
    function jR() {
      return ME;
    }
    function IB() {
      yb = !0;
    }
    function BB() {
      ME = !1, yb = !1;
    }
    function qB() {
      ME = yb, yb = !1;
    }
    function GR() {
      return qR;
    }
    function QR() {
      qR = Jd();
    }
    function AE(e) {
      U6 = Jd(), e.actualStartTime < 0 && (e.actualStartTime = Jd());
    }
    function YR(e) {
      U6 = -1;
    }
    function gb(e, n) {
      if (U6 >= 0) {
        var o = Jd() - U6;
        e.actualDuration += o, n && (e.selfBaseDuration = o), U6 = -1;
      }
    }
    function Il(e) {
      if (mb >= 0) {
        var n = Jd() - mb;
        mb = -1;
        for (var o = e.return; o !== null; ) {
          switch (o.tag) {
            case A:
              var u = o.stateNode;
              u.effectDuration += n;
              return;
            case je:
              var h = o.stateNode;
              h.effectDuration += n;
              return;
          }
          o = o.return;
        }
      }
    }
    function PE(e) {
      if (vb >= 0) {
        var n = Jd() - vb;
        vb = -1;
        for (var o = e.return; o !== null; ) {
          switch (o.tag) {
            case A:
              var u = o.stateNode;
              u !== null && (u.passiveEffectDuration += n);
              return;
            case je:
              var h = o.stateNode;
              h !== null && (h.passiveEffectDuration += n);
              return;
          }
          o = o.return;
        }
      }
    }
    function Bl() {
      mb = Jd();
    }
    function OE() {
      vb = Jd();
    }
    function _E(e) {
      for (var n = e.child; n; )
        e.actualDuration += n.actualDuration, n = n.sibling;
    }
    function Uo(e, n) {
      if (e && e.defaultProps) {
        var o = Pt({}, n), u = e.defaultProps;
        for (var h in u)
          o[h] === void 0 && (o[h] = u[h]);
        return o;
      }
      return n;
    }
    var NE = {}, VE, UE, zE, HE, FE, WR, Cb, IE, BE, qE, z6;
    {
      VE = /* @__PURE__ */ new Set(), UE = /* @__PURE__ */ new Set(), zE = /* @__PURE__ */ new Set(), HE = /* @__PURE__ */ new Set(), IE = /* @__PURE__ */ new Set(), FE = /* @__PURE__ */ new Set(), BE = /* @__PURE__ */ new Set(), qE = /* @__PURE__ */ new Set(), z6 = /* @__PURE__ */ new Set();
      var KR = /* @__PURE__ */ new Set();
      Cb = function(e, n) {
        if (!(e === null || typeof e == "function")) {
          var o = n + "_" + e;
          KR.has(o) || (KR.add(o), g("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", n, e));
        }
      }, WR = function(e, n) {
        if (n === void 0) {
          var o = fn(e) || "Component";
          FE.has(o) || (FE.add(o), g("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", o));
        }
      }, Object.defineProperty(NE, "_processChildContext", {
        enumerable: !1,
        value: function() {
          throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
      }), Object.freeze(NE);
    }
    function jE(e, n, o, u) {
      var h = e.memoizedState, y = o(u, h);
      {
        if (e.mode & mn) {
          Un(!0);
          try {
            y = o(u, h);
          } finally {
            Un(!1);
          }
        }
        WR(n, y);
      }
      var S = y == null ? h : Pt({}, h, y);
      if (e.memoizedState = S, e.lanes === ie) {
        var w = e.updateQueue;
        w.baseState = S;
      }
    }
    var GE = {
      isMounted: LC,
      enqueueSetState: function(e, n, o) {
        var u = Ld(e), h = Ta(), y = rf(u), S = pc(h, y);
        S.payload = n, o != null && (Cb(o, "setState"), S.callback = o);
        var w = Wd(u, S, y);
        w !== null && (rr(w, u, y, h), YS(w, u, y)), Qh(u, y);
      },
      enqueueReplaceState: function(e, n, o) {
        var u = Ld(e), h = Ta(), y = rf(u), S = pc(h, y);
        S.tag = hR, S.payload = n, o != null && (Cb(o, "replaceState"), S.callback = o);
        var w = Wd(u, S, y);
        w !== null && (rr(w, u, y, h), YS(w, u, y)), Qh(u, y);
      },
      enqueueForceUpdate: function(e, n) {
        var o = Ld(e), u = Ta(), h = rf(o), y = pc(u, h);
        y.tag = jS, n != null && (Cb(n, "forceUpdate"), y.callback = n);
        var S = Wd(o, y, h);
        S !== null && (rr(S, o, h, u), YS(S, o, h)), Bv(o, h);
      }
    };
    function ZR(e, n, o, u, h, y, S) {
      var w = e.stateNode;
      if (typeof w.shouldComponentUpdate == "function") {
        var E = w.shouldComponentUpdate(u, y, S);
        {
          if (e.mode & mn) {
            Un(!0);
            try {
              E = w.shouldComponentUpdate(u, y, S);
            } finally {
              Un(!1);
            }
          }
          E === void 0 && g("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", fn(n) || "Component");
        }
        return E;
      }
      return n.prototype && n.prototype.isPureReactComponent ? !Be(o, u) || !Be(h, y) : !0;
    }
    function jB(e, n, o) {
      var u = e.stateNode;
      {
        var h = fn(n) || "Component", y = u.render;
        y || (n.prototype && typeof n.prototype.render == "function" ? g("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", h) : g("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", h)), u.getInitialState && !u.getInitialState.isReactClassApproved && !u.state && g("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", h), u.getDefaultProps && !u.getDefaultProps.isReactClassApproved && g("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", h), u.propTypes && g("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", h), u.contextType && g("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", h), n.childContextTypes && !z6.has(n) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & mn) === Ie && (z6.add(n), g(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, h)), n.contextTypes && !z6.has(n) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (e.mode & mn) === Ie && (z6.add(n), g(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, h)), u.contextTypes && g("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", h), n.contextType && n.contextTypes && !BE.has(n) && (BE.add(n), g("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", h)), typeof u.componentShouldUpdate == "function" && g("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", h), n.prototype && n.prototype.isPureReactComponent && typeof u.shouldComponentUpdate < "u" && g("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", fn(n) || "A pure component"), typeof u.componentDidUnmount == "function" && g("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", h), typeof u.componentDidReceiveProps == "function" && g("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", h), typeof u.componentWillRecieveProps == "function" && g("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", h), typeof u.UNSAFE_componentWillRecieveProps == "function" && g("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", h);
        var S = u.props !== o;
        u.props !== void 0 && S && g("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", h, h), u.defaultProps && g("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", h, h), typeof u.getSnapshotBeforeUpdate == "function" && typeof u.componentDidUpdate != "function" && !zE.has(n) && (zE.add(n), g("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", fn(n))), typeof u.getDerivedStateFromProps == "function" && g("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", h), typeof u.getDerivedStateFromError == "function" && g("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", h), typeof n.getSnapshotBeforeUpdate == "function" && g("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", h);
        var w = u.state;
        w && (typeof w != "object" || Gi(w)) && g("%s.state: must be set to an object or null", h), typeof u.getChildContext == "function" && typeof n.childContextTypes != "object" && g("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", h);
      }
    }
    function XR(e, n) {
      n.updater = GE, e.stateNode = n, Bu(n, e), n._reactInternalInstance = NE;
    }
    function JR(e, n, o) {
      var u = !1, h = Ss, y = Ss, S = n.contextType;
      if ("contextType" in n) {
        var w = (
          // Allow null for conditional declaration
          S === null || S !== void 0 && S.$$typeof === bh && S._context === void 0
        );
        if (!w && !qE.has(n)) {
          qE.add(n);
          var E = "";
          S === void 0 ? E = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof S != "object" ? E = " However, it is set to a " + typeof S + "." : S.$$typeof === pd ? E = " Did you accidentally pass the Context.Provider instead?" : S._context !== void 0 ? E = " Did you accidentally pass the Context.Consumer instead?" : E = " However, it is set to an object with keys {" + Object.keys(S).join(", ") + "}.", g("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", fn(n) || "Component", E);
        }
      }
      if (typeof S == "object" && S !== null)
        y = Ni(S);
      else {
        h = Py(e, n, !0);
        var D = n.contextTypes;
        u = D != null, y = u ? Oy(e, h) : Ss;
      }
      var M = new n(o, y);
      if (e.mode & mn) {
        Un(!0);
        try {
          M = new n(o, y);
        } finally {
          Un(!1);
        }
      }
      var H = e.memoizedState = M.state !== null && M.state !== void 0 ? M.state : null;
      XR(e, M);
      {
        if (typeof n.getDerivedStateFromProps == "function" && H === null) {
          var V = fn(n) || "Component";
          UE.has(V) || (UE.add(V), g("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", V, M.state === null ? "null" : "undefined", V));
        }
        if (typeof n.getDerivedStateFromProps == "function" || typeof M.getSnapshotBeforeUpdate == "function") {
          var Q = null, W = null, X = null;
          if (typeof M.componentWillMount == "function" && M.componentWillMount.__suppressDeprecationWarning !== !0 ? Q = "componentWillMount" : typeof M.UNSAFE_componentWillMount == "function" && (Q = "UNSAFE_componentWillMount"), typeof M.componentWillReceiveProps == "function" && M.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? W = "componentWillReceiveProps" : typeof M.UNSAFE_componentWillReceiveProps == "function" && (W = "UNSAFE_componentWillReceiveProps"), typeof M.componentWillUpdate == "function" && M.componentWillUpdate.__suppressDeprecationWarning !== !0 ? X = "componentWillUpdate" : typeof M.UNSAFE_componentWillUpdate == "function" && (X = "UNSAFE_componentWillUpdate"), Q !== null || W !== null || X !== null) {
            var Ce = fn(n) || "Component", Qe = typeof n.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            HE.has(Ce) || (HE.add(Ce), g(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, Ce, Qe, Q !== null ? `
  ` + Q : "", W !== null ? `
  ` + W : "", X !== null ? `
  ` + X : ""));
          }
        }
      }
      return u && Ix(e, h, y), M;
    }
    function GB(e, n) {
      var o = n.state;
      typeof n.componentWillMount == "function" && n.componentWillMount(), typeof n.UNSAFE_componentWillMount == "function" && n.UNSAFE_componentWillMount(), o !== n.state && (g("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", vt(e) || "Component"), GE.enqueueReplaceState(n, n.state, null));
    }
    function eL(e, n, o, u) {
      var h = n.state;
      if (typeof n.componentWillReceiveProps == "function" && n.componentWillReceiveProps(o, u), typeof n.UNSAFE_componentWillReceiveProps == "function" && n.UNSAFE_componentWillReceiveProps(o, u), n.state !== h) {
        {
          var y = vt(e) || "Component";
          VE.has(y) || (VE.add(y), g("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", y));
        }
        GE.enqueueReplaceState(n, n.state, null);
      }
    }
    function QE(e, n, o, u) {
      jB(e, n, o);
      var h = e.stateNode;
      h.props = o, h.state = e.memoizedState, h.refs = {}, nE(e);
      var y = n.contextType;
      if (typeof y == "object" && y !== null)
        h.context = Ni(y);
      else {
        var S = Py(e, n, !0);
        h.context = Oy(e, S);
      }
      {
        if (h.state === o) {
          var w = fn(n) || "Component";
          IE.has(w) || (IE.add(w), g("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", w));
        }
        e.mode & mn && _o.recordLegacyContextWarning(e, h), _o.recordUnsafeLifecycleWarnings(e, h);
      }
      h.state = e.memoizedState;
      var E = n.getDerivedStateFromProps;
      if (typeof E == "function" && (jE(e, n, E, o), h.state = e.memoizedState), typeof n.getDerivedStateFromProps != "function" && typeof h.getSnapshotBeforeUpdate != "function" && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (GB(e, h), WS(e, o, h, u), h.state = e.memoizedState), typeof h.componentDidMount == "function") {
        var D = _t;
        D |= Eo, (e.mode & Wt) !== Ie && (D |= bl), e.flags |= D;
      }
    }
    function QB(e, n, o, u) {
      var h = e.stateNode, y = e.memoizedProps;
      h.props = y;
      var S = h.context, w = n.contextType, E = Ss;
      if (typeof w == "object" && w !== null)
        E = Ni(w);
      else {
        var D = Py(e, n, !0);
        E = Oy(e, D);
      }
      var M = n.getDerivedStateFromProps, H = typeof M == "function" || typeof h.getSnapshotBeforeUpdate == "function";
      !H && (typeof h.UNSAFE_componentWillReceiveProps == "function" || typeof h.componentWillReceiveProps == "function") && (y !== o || S !== E) && eL(e, h, o, E), mR();
      var V = e.memoizedState, Q = h.state = V;
      if (WS(e, o, h, u), Q = e.memoizedState, y === o && V === Q && !DS() && !KS()) {
        if (typeof h.componentDidMount == "function") {
          var W = _t;
          W |= Eo, (e.mode & Wt) !== Ie && (W |= bl), e.flags |= W;
        }
        return !1;
      }
      typeof M == "function" && (jE(e, n, M, o), Q = e.memoizedState);
      var X = KS() || ZR(e, n, y, o, V, Q, E);
      if (X) {
        if (!H && (typeof h.UNSAFE_componentWillMount == "function" || typeof h.componentWillMount == "function") && (typeof h.componentWillMount == "function" && h.componentWillMount(), typeof h.UNSAFE_componentWillMount == "function" && h.UNSAFE_componentWillMount()), typeof h.componentDidMount == "function") {
          var Ce = _t;
          Ce |= Eo, (e.mode & Wt) !== Ie && (Ce |= bl), e.flags |= Ce;
        }
      } else {
        if (typeof h.componentDidMount == "function") {
          var Qe = _t;
          Qe |= Eo, (e.mode & Wt) !== Ie && (Qe |= bl), e.flags |= Qe;
        }
        e.memoizedProps = o, e.memoizedState = Q;
      }
      return h.props = o, h.state = Q, h.context = E, X;
    }
    function YB(e, n, o, u, h) {
      var y = n.stateNode;
      pR(e, n);
      var S = n.memoizedProps, w = n.type === n.elementType ? S : Uo(n.type, S);
      y.props = w;
      var E = n.pendingProps, D = y.context, M = o.contextType, H = Ss;
      if (typeof M == "object" && M !== null)
        H = Ni(M);
      else {
        var V = Py(n, o, !0);
        H = Oy(n, V);
      }
      var Q = o.getDerivedStateFromProps, W = typeof Q == "function" || typeof y.getSnapshotBeforeUpdate == "function";
      !W && (typeof y.UNSAFE_componentWillReceiveProps == "function" || typeof y.componentWillReceiveProps == "function") && (S !== E || D !== H) && eL(n, y, u, H), mR();
      var X = n.memoizedState, Ce = y.state = X;
      if (WS(n, u, y, h), Ce = n.memoizedState, S === E && X === Ce && !DS() && !KS())
        return typeof y.componentDidUpdate == "function" && (S !== e.memoizedProps || X !== e.memoizedState) && (n.flags |= _t), typeof y.getSnapshotBeforeUpdate == "function" && (S !== e.memoizedProps || X !== e.memoizedState) && (n.flags |= Ti), !1;
      typeof Q == "function" && (jE(n, o, Q, u), Ce = n.memoizedState);
      var Qe = KS() || ZR(n, o, w, u, X, Ce, H) || // TODO: In some cases, we'll end up checking if context has changed twice,
      // both before and after `shouldComponentUpdate` has been called. Not ideal,
      // but I'm loath to refactor this function. This only happens for memoized
      // components so it's not that common.
      Le;
      return Qe ? (!W && (typeof y.UNSAFE_componentWillUpdate == "function" || typeof y.componentWillUpdate == "function") && (typeof y.componentWillUpdate == "function" && y.componentWillUpdate(u, Ce, H), typeof y.UNSAFE_componentWillUpdate == "function" && y.UNSAFE_componentWillUpdate(u, Ce, H)), typeof y.componentDidUpdate == "function" && (n.flags |= _t), typeof y.getSnapshotBeforeUpdate == "function" && (n.flags |= Ti)) : (typeof y.componentDidUpdate == "function" && (S !== e.memoizedProps || X !== e.memoizedState) && (n.flags |= _t), typeof y.getSnapshotBeforeUpdate == "function" && (S !== e.memoizedProps || X !== e.memoizedState) && (n.flags |= Ti), n.memoizedProps = u, n.memoizedState = Ce), y.props = u, y.state = Ce, y.context = H, Qe;
    }
    function Ap(e, n) {
      return {
        value: e,
        source: n,
        stack: cv(n),
        digest: null
      };
    }
    function YE(e, n, o) {
      return {
        value: e,
        source: null,
        stack: o ?? null,
        digest: n ?? null
      };
    }
    function WB(e, n) {
      return !0;
    }
    function WE(e, n) {
      try {
        var o = WB(e, n);
        if (o === !1)
          return;
        var u = n.value, h = n.source, y = n.stack, S = y !== null ? y : "";
        if (u != null && u._suppressLogging) {
          if (e.tag === $)
            return;
          console.error(u);
        }
        var w = h ? vt(h) : null, E = w ? "The above error occurred in the <" + w + "> component:" : "The above error occurred in one of your React components:", D;
        if (e.tag === A)
          D = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
        else {
          var M = vt(e) || "Anonymous";
          D = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + M + ".");
        }
        var H = E + `
` + S + `

` + ("" + D);
        console.error(H);
      } catch (V) {
        setTimeout(function() {
          throw V;
        });
      }
    }
    var KB = typeof WeakMap == "function" ? WeakMap : Map;
    function tL(e, n, o) {
      var u = pc(kn, o);
      u.tag = eE, u.payload = {
        element: null
      };
      var h = n.value;
      return u.callback = function() {
        Ij(h), WE(e, n);
      }, u;
    }
    function KE(e, n, o) {
      var u = pc(kn, o);
      u.tag = eE;
      var h = e.type.getDerivedStateFromError;
      if (typeof h == "function") {
        var y = n.value;
        u.payload = function() {
          return h(y);
        }, u.callback = function() {
          f$(e), WE(e, n);
        };
      }
      var S = e.stateNode;
      return S !== null && typeof S.componentDidCatch == "function" && (u.callback = function() {
        f$(e), WE(e, n), typeof h != "function" && Hj(this);
        var E = n.value, D = n.stack;
        this.componentDidCatch(E, {
          componentStack: D !== null ? D : ""
        }), typeof h != "function" && (Jr(e.lanes, tt) || g("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", vt(e) || "Unknown"));
      }), u;
    }
    function nL(e, n, o) {
      var u = e.pingCache, h;
      if (u === null ? (u = e.pingCache = new KB(), h = /* @__PURE__ */ new Set(), u.set(n, h)) : (h = u.get(n), h === void 0 && (h = /* @__PURE__ */ new Set(), u.set(n, h))), !h.has(o)) {
        h.add(o);
        var y = Bj.bind(null, e, n, o);
        Xr && n2(e, o), n.then(y, y);
      }
    }
    function ZB(e, n, o, u) {
      var h = e.updateQueue;
      if (h === null) {
        var y = /* @__PURE__ */ new Set();
        y.add(o), e.updateQueue = y;
      } else
        h.add(o);
    }
    function XB(e, n) {
      var o = e.tag;
      if ((e.mode & Tt) === Ie && (o === x || o === Se || o === Ge)) {
        var u = e.alternate;
        u ? (e.updateQueue = u.updateQueue, e.memoizedState = u.memoizedState, e.lanes = u.lanes) : (e.updateQueue = null, e.memoizedState = null);
      }
    }
    function iL(e) {
      var n = e;
      do {
        if (n.tag === Me && AB(n))
          return n;
        n = n.return;
      } while (n !== null);
      return null;
    }
    function rL(e, n, o, u, h) {
      if ((e.mode & Tt) === Ie) {
        if (e === n)
          e.flags |= Wr;
        else {
          if (e.flags |= He, o.flags |= _v, o.flags &= -52805, o.tag === $) {
            var y = o.alternate;
            if (y === null)
              o.tag = Ze;
            else {
              var S = pc(kn, tt);
              S.tag = jS, Wd(o, S, tt);
            }
          }
          o.lanes = yt(o.lanes, tt);
        }
        return e;
      }
      return e.flags |= Wr, e.lanes = h, e;
    }
    function JB(e, n, o, u, h) {
      if (o.flags |= Fh, Xr && n2(e, h), u !== null && typeof u == "object" && typeof u.then == "function") {
        var y = u;
        XB(o), Rr() && o.mode & Tt && Wx();
        var S = iL(n);
        if (S !== null) {
          S.flags &= -257, rL(S, n, o, e, h), S.mode & Tt && nL(e, y, h), ZB(S, e, y);
          return;
        } else {
          if (!NC(h)) {
            nL(e, y, h), $4();
            return;
          }
          var w = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
          u = w;
        }
      } else if (Rr() && o.mode & Tt) {
        Wx();
        var E = iL(n);
        if (E !== null) {
          (E.flags & Wr) === Fe && (E.flags |= Qr), rL(E, n, o, e, h), IT(Ap(u, o));
          return;
        }
      }
      u = Ap(u, o), Aj(u);
      var D = n;
      do {
        switch (D.tag) {
          case A: {
            var M = u;
            D.flags |= Wr;
            var H = np(h);
            D.lanes = yt(D.lanes, H);
            var V = tL(D, M, H);
            iE(D, V);
            return;
          }
          case $:
            var Q = u, W = D.type, X = D.stateNode;
            if ((D.flags & He) === Fe && (typeof W.getDerivedStateFromError == "function" || X !== null && typeof X.componentDidCatch == "function" && !i$(X))) {
              D.flags |= Wr;
              var Ce = np(h);
              D.lanes = yt(D.lanes, Ce);
              var Qe = KE(D, Q, Ce);
              iE(D, Qe);
              return;
            }
            break;
        }
        D = D.return;
      } while (D !== null);
    }
    function eq() {
      return null;
    }
    var H6 = t.ReactCurrentOwner, zo = !1, ZE, F6, XE, JE, e4, Pp, t4, Sb, I6;
    ZE = {}, F6 = {}, XE = {}, JE = {}, e4 = {}, Pp = !1, t4 = {}, Sb = {}, I6 = {};
    function ba(e, n, o, u) {
      e === null ? n.child = oR(n, null, o, u) : n.child = Uy(n, e.child, o, u);
    }
    function tq(e, n, o, u) {
      n.child = Uy(n, e.child, null, u), n.child = Uy(n, null, o, u);
    }
    function aL(e, n, o, u, h) {
      if (n.type !== n.elementType) {
        var y = o.propTypes;
        y && Po(
          y,
          u,
          // Resolved props
          "prop",
          fn(o)
        );
      }
      var S = o.render, w = n.ref, E, D;
      Hy(n, h), va(n);
      {
        if (H6.current = n, ji(!0), E = Gy(e, n, S, u, w, h), D = Qy(), n.mode & mn) {
          Un(!0);
          try {
            E = Gy(e, n, S, u, w, h), D = Qy();
          } finally {
            Un(!1);
          }
        }
        ji(!1);
      }
      return ya(), e !== null && !zo ? (bR(e, n, h), mc(e, n, h)) : (Rr() && D && NT(n), n.flags |= ps, ba(e, n, E, h), n.child);
    }
    function sL(e, n, o, u, h) {
      if (e === null) {
        var y = o.type;
        if (sG(y) && o.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
        o.defaultProps === void 0) {
          var S = y;
          return S = tg(y), n.tag = Ge, n.type = S, r4(n, y), oL(e, n, S, u, h);
        }
        {
          var w = y.propTypes;
          if (w && Po(
            w,
            u,
            // Resolved props
            "prop",
            fn(y)
          ), o.defaultProps !== void 0) {
            var E = fn(y) || "Unknown";
            I6[E] || (g("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", E), I6[E] = !0);
          }
        }
        var D = H4(o.type, null, u, n, n.mode, h);
        return D.ref = n.ref, D.return = n, n.child = D, D;
      }
      {
        var M = o.type, H = M.propTypes;
        H && Po(
          H,
          u,
          // Resolved props
          "prop",
          fn(M)
        );
      }
      var V = e.child, Q = c4(e, h);
      if (!Q) {
        var W = V.memoizedProps, X = o.compare;
        if (X = X !== null ? X : Be, X(W, u) && e.ref === n.ref)
          return mc(e, n, h);
      }
      n.flags |= ps;
      var Ce = Up(V, u);
      return Ce.ref = n.ref, Ce.return = n, n.child = Ce, Ce;
    }
    function oL(e, n, o, u, h) {
      if (n.type !== n.elementType) {
        var y = n.elementType;
        if (y.$$typeof === cr) {
          var S = y, w = S._payload, E = S._init;
          try {
            y = E(w);
          } catch {
            y = null;
          }
          var D = y && y.propTypes;
          D && Po(
            D,
            u,
            // Resolved (SimpleMemoComponent has no defaultProps)
            "prop",
            fn(y)
          );
        }
      }
      if (e !== null) {
        var M = e.memoizedProps;
        if (Be(M, u) && e.ref === n.ref && // Prevent bailout if the implementation changed due to hot reload.
        n.type === e.type)
          if (zo = !1, n.pendingProps = u = M, c4(e, h))
            (e.flags & _v) !== Fe && (zo = !0);
          else return n.lanes = e.lanes, mc(e, n, h);
      }
      return n4(e, n, o, u, h);
    }
    function lL(e, n, o) {
      var u = n.pendingProps, h = u.children, y = e !== null ? e.memoizedState : null;
      if (u.mode === "hidden" || me)
        if ((n.mode & Tt) === Ie) {
          var S = {
            baseLanes: ie,
            cachePool: null,
            transitions: null
          };
          n.memoizedState = S, Pb(n, o);
        } else if (Jr(o, ga)) {
          var H = {
            baseLanes: ie,
            cachePool: null,
            transitions: null
          };
          n.memoizedState = H;
          var V = y !== null ? y.baseLanes : o;
          Pb(n, V);
        } else {
          var w = null, E;
          if (y !== null) {
            var D = y.baseLanes;
            E = yt(D, o);
          } else
            E = o;
          n.lanes = n.childLanes = ga;
          var M = {
            baseLanes: E,
            cachePool: w,
            transitions: null
          };
          return n.memoizedState = M, n.updateQueue = null, Pb(n, E), null;
        }
      else {
        var Q;
        y !== null ? (Q = yt(y.baseLanes, o), n.memoizedState = null) : Q = o, Pb(n, Q);
      }
      return ba(e, n, h, o), n.child;
    }
    function nq(e, n, o) {
      var u = n.pendingProps;
      return ba(e, n, u, o), n.child;
    }
    function iq(e, n, o) {
      var u = n.pendingProps.children;
      return ba(e, n, u, o), n.child;
    }
    function rq(e, n, o) {
      {
        n.flags |= _t;
        {
          var u = n.stateNode;
          u.effectDuration = 0, u.passiveEffectDuration = 0;
        }
      }
      var h = n.pendingProps, y = h.children;
      return ba(e, n, y, o), n.child;
    }
    function uL(e, n) {
      var o = n.ref;
      (e === null && o !== null || e !== null && e.ref !== o) && (n.flags |= Qn, n.flags |= Dd);
    }
    function n4(e, n, o, u, h) {
      if (n.type !== n.elementType) {
        var y = o.propTypes;
        y && Po(
          y,
          u,
          // Resolved props
          "prop",
          fn(o)
        );
      }
      var S;
      {
        var w = Py(n, o, !0);
        S = Oy(n, w);
      }
      var E, D;
      Hy(n, h), va(n);
      {
        if (H6.current = n, ji(!0), E = Gy(e, n, o, u, S, h), D = Qy(), n.mode & mn) {
          Un(!0);
          try {
            E = Gy(e, n, o, u, S, h), D = Qy();
          } finally {
            Un(!1);
          }
        }
        ji(!1);
      }
      return ya(), e !== null && !zo ? (bR(e, n, h), mc(e, n, h)) : (Rr() && D && NT(n), n.flags |= ps, ba(e, n, E, h), n.child);
    }
    function cL(e, n, o, u, h) {
      {
        switch (bG(n)) {
          case !1: {
            var y = n.stateNode, S = n.type, w = new S(n.memoizedProps, y.context), E = w.state;
            y.updater.enqueueSetState(y, E, null);
            break;
          }
          case !0: {
            n.flags |= He, n.flags |= Wr;
            var D = new Error("Simulated error coming from DevTools"), M = np(h);
            n.lanes = yt(n.lanes, M);
            var H = KE(n, Ap(D, n), M);
            iE(n, H);
            break;
          }
        }
        if (n.type !== n.elementType) {
          var V = o.propTypes;
          V && Po(
            V,
            u,
            // Resolved props
            "prop",
            fn(o)
          );
        }
      }
      var Q;
      Ul(o) ? (Q = !0, AS(n)) : Q = !1, Hy(n, h);
      var W = n.stateNode, X;
      W === null ? (wb(e, n), JR(n, o, u), QE(n, o, u, h), X = !0) : e === null ? X = QB(n, o, u, h) : X = YB(e, n, o, u, h);
      var Ce = i4(e, n, o, X, Q, h);
      {
        var Qe = n.stateNode;
        X && Qe.props !== u && (Pp || g("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", vt(n) || "a component"), Pp = !0);
      }
      return Ce;
    }
    function i4(e, n, o, u, h, y) {
      uL(e, n);
      var S = (n.flags & He) !== Fe;
      if (!u && !S)
        return h && jx(n, o, !1), mc(e, n, y);
      var w = n.stateNode;
      H6.current = n;
      var E;
      if (S && typeof o.getDerivedStateFromError != "function")
        E = null, YR();
      else {
        va(n);
        {
          if (ji(!0), E = w.render(), n.mode & mn) {
            Un(!0);
            try {
              w.render();
            } finally {
              Un(!1);
            }
          }
          ji(!1);
        }
        ya();
      }
      return n.flags |= ps, e !== null && S ? tq(e, n, E, y) : ba(e, n, E, y), n.memoizedState = w.state, h && jx(n, o, !0), n.child;
    }
    function dL(e) {
      var n = e.stateNode;
      n.pendingContext ? Bx(e, n.pendingContext, n.pendingContext !== n.context) : n.context && Bx(e, n.context, !1), rE(e, n.containerInfo);
    }
    function aq(e, n, o) {
      if (dL(n), e === null)
        throw new Error("Should have a current fiber. This is a bug in React.");
      var u = n.pendingProps, h = n.memoizedState, y = h.element;
      pR(e, n), WS(n, u, null, o);
      var S = n.memoizedState;
      n.stateNode;
      var w = S.element;
      if (h.isDehydrated) {
        var E = {
          element: w,
          isDehydrated: !1,
          cache: S.cache,
          pendingSuspenseBoundaries: S.pendingSuspenseBoundaries,
          transitions: S.transitions
        }, D = n.updateQueue;
        if (D.baseState = E, n.memoizedState = E, n.flags & Qr) {
          var M = Ap(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), n);
          return fL(e, n, w, o, M);
        } else if (w !== y) {
          var H = Ap(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), n);
          return fL(e, n, w, o, H);
        } else {
          lB(n);
          var V = oR(n, null, w, o);
          n.child = V;
          for (var Q = V; Q; )
            Q.flags = Q.flags & -3 | Fa, Q = Q.sibling;
        }
      } else {
        if (Vy(), w === y)
          return mc(e, n, o);
        ba(e, n, w, o);
      }
      return n.child;
    }
    function fL(e, n, o, u, h) {
      return Vy(), IT(h), n.flags |= Qr, ba(e, n, o, u), n.child;
    }
    function sq(e, n, o) {
      gR(n), e === null && FT(n);
      var u = n.type, h = n.pendingProps, y = e !== null ? e.memoizedProps : null, S = h.children, w = wT(u, h);
      return w ? S = null : y !== null && wT(u, y) && (n.flags |= ms), uL(e, n), ba(e, n, S, o), n.child;
    }
    function oq(e, n) {
      return e === null && FT(n), null;
    }
    function lq(e, n, o, u) {
      wb(e, n);
      var h = n.pendingProps, y = o, S = y._payload, w = y._init, E = w(S);
      n.type = E;
      var D = n.tag = oG(E), M = Uo(E, h), H;
      switch (D) {
        case x:
          return r4(n, E), n.type = E = tg(E), H = n4(null, n, E, M, u), H;
        case $:
          return n.type = E = O4(E), H = cL(null, n, E, M, u), H;
        case Se:
          return n.type = E = _4(E), H = aL(null, n, E, M, u), H;
        case Ct: {
          if (n.type !== n.elementType) {
            var V = E.propTypes;
            V && Po(
              V,
              M,
              // Resolved for outer only
              "prop",
              fn(E)
            );
          }
          return H = sL(
            null,
            n,
            E,
            Uo(E.type, M),
            // The inner type can have defaults too
            u
          ), H;
        }
      }
      var Q = "";
      throw E !== null && typeof E == "object" && E.$$typeof === cr && (Q = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + E + ". " + ("Lazy element type must resolve to a class or function." + Q));
    }
    function uq(e, n, o, u, h) {
      wb(e, n), n.tag = $;
      var y;
      return Ul(o) ? (y = !0, AS(n)) : y = !1, Hy(n, h), JR(n, o, u), QE(n, o, u, h), i4(null, n, o, !0, y, h);
    }
    function cq(e, n, o, u) {
      wb(e, n);
      var h = n.pendingProps, y;
      {
        var S = Py(n, o, !1);
        y = Oy(n, S);
      }
      Hy(n, u);
      var w, E;
      va(n);
      {
        if (o.prototype && typeof o.prototype.render == "function") {
          var D = fn(o) || "Unknown";
          ZE[D] || (g("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", D, D), ZE[D] = !0);
        }
        n.mode & mn && _o.recordLegacyContextWarning(n, null), ji(!0), H6.current = n, w = Gy(null, n, o, h, y, u), E = Qy(), ji(!1);
      }
      if (ya(), n.flags |= ps, typeof w == "object" && w !== null && typeof w.render == "function" && w.$$typeof === void 0) {
        var M = fn(o) || "Unknown";
        F6[M] || (g("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", M, M, M), F6[M] = !0);
      }
      if (
        // Run these checks in production only if the flag is off.
        // Eventually we'll delete this branch altogether.
        typeof w == "object" && w !== null && typeof w.render == "function" && w.$$typeof === void 0
      ) {
        {
          var H = fn(o) || "Unknown";
          F6[H] || (g("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", H, H, H), F6[H] = !0);
        }
        n.tag = $, n.memoizedState = null, n.updateQueue = null;
        var V = !1;
        return Ul(o) ? (V = !0, AS(n)) : V = !1, n.memoizedState = w.state !== null && w.state !== void 0 ? w.state : null, nE(n), XR(n, w), QE(n, o, h, u), i4(null, n, o, !0, V, u);
      } else {
        if (n.tag = x, n.mode & mn) {
          Un(!0);
          try {
            w = Gy(null, n, o, h, y, u), E = Qy();
          } finally {
            Un(!1);
          }
        }
        return Rr() && E && NT(n), ba(null, n, w, u), r4(n, o), n.child;
      }
    }
    function r4(e, n) {
      {
        if (n && n.childContextTypes && g("%s(...): childContextTypes cannot be defined on a function component.", n.displayName || n.name || "Component"), e.ref !== null) {
          var o = "", u = Va();
          u && (o += `

Check the render method of \`` + u + "`.");
          var h = u || "", y = e._debugSource;
          y && (h = y.fileName + ":" + y.lineNumber), e4[h] || (e4[h] = !0, g("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", o));
        }
        if (n.defaultProps !== void 0) {
          var S = fn(n) || "Unknown";
          I6[S] || (g("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", S), I6[S] = !0);
        }
        if (typeof n.getDerivedStateFromProps == "function") {
          var w = fn(n) || "Unknown";
          JE[w] || (g("%s: Function components do not support getDerivedStateFromProps.", w), JE[w] = !0);
        }
        if (typeof n.contextType == "object" && n.contextType !== null) {
          var E = fn(n) || "Unknown";
          XE[E] || (g("%s: Function components do not support contextType.", E), XE[E] = !0);
        }
      }
    }
    var a4 = {
      dehydrated: null,
      treeContext: null,
      retryLane: Ft
    };
    function s4(e) {
      return {
        baseLanes: e,
        cachePool: eq(),
        transitions: null
      };
    }
    function dq(e, n) {
      var o = null;
      return {
        baseLanes: yt(e.baseLanes, n),
        cachePool: o,
        transitions: e.transitions
      };
    }
    function fq(e, n, o, u) {
      if (n !== null) {
        var h = n.memoizedState;
        if (h === null)
          return !1;
      }
      return oE(e, M6);
    }
    function hq(e, n) {
      return ip(e.childLanes, n);
    }
    function hL(e, n, o) {
      var u = n.pendingProps;
      wG(n) && (n.flags |= He);
      var h = No.current, y = !1, S = (n.flags & He) !== Fe;
      if (S || fq(h, e) ? (y = !0, n.flags &= -129) : (e === null || e.memoizedState !== null) && (h = MB(h, SR)), h = Iy(h), Zd(n, h), e === null) {
        FT(n);
        var w = n.memoizedState;
        if (w !== null) {
          var E = w.dehydrated;
          if (E !== null)
            return gq(n, E);
        }
        var D = u.children, M = u.fallback;
        if (y) {
          var H = pq(n, D, M, o), V = n.child;
          return V.memoizedState = s4(o), n.memoizedState = a4, H;
        } else
          return o4(n, D);
      } else {
        var Q = e.memoizedState;
        if (Q !== null) {
          var W = Q.dehydrated;
          if (W !== null)
            return Cq(e, n, S, u, W, Q, o);
        }
        if (y) {
          var X = u.fallback, Ce = u.children, Qe = vq(e, n, Ce, X, o), Ue = n.child, Ut = e.child.memoizedState;
          return Ue.memoizedState = Ut === null ? s4(o) : dq(Ut, o), Ue.childLanes = hq(e, o), n.memoizedState = a4, Qe;
        } else {
          var Dt = u.children, q = mq(e, n, Dt, o);
          return n.memoizedState = null, q;
        }
      }
    }
    function o4(e, n, o) {
      var u = e.mode, h = {
        mode: "visible",
        children: n
      }, y = l4(h, u);
      return y.return = e, e.child = y, y;
    }
    function pq(e, n, o, u) {
      var h = e.mode, y = e.child, S = {
        mode: "hidden",
        children: n
      }, w, E;
      return (h & Tt) === Ie && y !== null ? (w = y, w.childLanes = ie, w.pendingProps = S, e.mode & Yt && (w.actualDuration = 0, w.actualStartTime = -1, w.selfBaseDuration = 0, w.treeBaseDuration = 0), E = sf(o, h, u, null)) : (w = l4(S, h), E = sf(o, h, u, null)), w.return = e, E.return = e, w.sibling = E, e.child = w, E;
    }
    function l4(e, n, o) {
      return p$(e, n, ie, null);
    }
    function pL(e, n) {
      return Up(e, n);
    }
    function mq(e, n, o, u) {
      var h = e.child, y = h.sibling, S = pL(h, {
        mode: "visible",
        children: o
      });
      if ((n.mode & Tt) === Ie && (S.lanes = u), S.return = n, S.sibling = null, y !== null) {
        var w = n.deletions;
        w === null ? (n.deletions = [y], n.flags |= Ha) : w.push(y);
      }
      return n.child = S, S;
    }
    function vq(e, n, o, u, h) {
      var y = n.mode, S = e.child, w = S.sibling, E = {
        mode: "hidden",
        children: o
      }, D;
      if (
        // In legacy mode, we commit the primary tree as if it successfully
        // completed, even though it's in an inconsistent state.
        (y & Tt) === Ie && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        n.child !== S
      ) {
        var M = n.child;
        D = M, D.childLanes = ie, D.pendingProps = E, n.mode & Yt && (D.actualDuration = 0, D.actualStartTime = -1, D.selfBaseDuration = S.selfBaseDuration, D.treeBaseDuration = S.treeBaseDuration), n.deletions = null;
      } else
        D = pL(S, E), D.subtreeFlags = S.subtreeFlags & ui;
      var H;
      return w !== null ? H = Up(w, u) : (H = sf(u, y, h, null), H.flags |= Kn), H.return = n, D.return = n, D.sibling = H, n.child = D, H;
    }
    function bb(e, n, o, u) {
      u !== null && IT(u), Uy(n, e.child, null, o);
      var h = n.pendingProps, y = h.children, S = o4(n, y);
      return S.flags |= Kn, n.memoizedState = null, S;
    }
    function yq(e, n, o, u, h) {
      var y = n.mode, S = {
        mode: "visible",
        children: o
      }, w = l4(S, y), E = sf(u, y, h, null);
      return E.flags |= Kn, w.return = n, E.return = n, w.sibling = E, n.child = w, (n.mode & Tt) !== Ie && Uy(n, e.child, null, h), E;
    }
    function gq(e, n, o) {
      return (e.mode & Tt) === Ie ? (g("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), e.lanes = tt) : xT(n) ? e.lanes = dr : e.lanes = ga, null;
    }
    function Cq(e, n, o, u, h, y, S) {
      if (o)
        if (n.flags & Qr) {
          n.flags &= -257;
          var q = YE(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
          return bb(e, n, S, q);
        } else {
          if (n.memoizedState !== null)
            return n.child = e.child, n.flags |= He, null;
          var J = u.children, j = u.fallback, le = yq(e, n, J, j, S), xe = n.child;
          return xe.memoizedState = s4(S), n.memoizedState = a4, le;
        }
      else {
        if (sB(), (n.mode & Tt) === Ie)
          return bb(
            e,
            n,
            S,
            // TODO: When we delete legacy mode, we should make this error argument
            // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null
          );
        if (xT(h)) {
          var w, E, D;
          {
            var M = TI(h);
            w = M.digest, E = M.message, D = M.stack;
          }
          var H;
          E ? H = new Error(E) : H = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
          var V = YE(H, w, D);
          return bb(e, n, S, V);
        }
        var Q = Jr(S, e.childLanes);
        if (zo || Q) {
          var W = Ab();
          if (W !== null) {
            var X = j3(W, S);
            if (X !== Ft && X !== y.retryLane) {
              y.retryLane = X;
              var Ce = kn;
              Ka(e, X), rr(W, e, X, Ce);
            }
          }
          $4();
          var Qe = YE(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
          return bb(e, n, S, Qe);
        } else if (Vx(h)) {
          n.flags |= He, n.child = e.child;
          var Ue = qj.bind(null, e);
          return EI(h, Ue), null;
        } else {
          uB(n, h, y.treeContext);
          var Ut = u.children, Dt = o4(n, Ut);
          return Dt.flags |= Fa, Dt;
        }
      }
    }
    function mL(e, n, o) {
      e.lanes = yt(e.lanes, n);
      var u = e.alternate;
      u !== null && (u.lanes = yt(u.lanes, n)), XT(e.return, n, o);
    }
    function Sq(e, n, o) {
      for (var u = n; u !== null; ) {
        if (u.tag === Me) {
          var h = u.memoizedState;
          h !== null && mL(u, o, e);
        } else if (u.tag === Gt)
          mL(u, o, e);
        else if (u.child !== null) {
          u.child.return = u, u = u.child;
          continue;
        }
        if (u === e)
          return;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === e)
            return;
          u = u.return;
        }
        u.sibling.return = u.return, u = u.sibling;
      }
    }
    function bq(e) {
      for (var n = e, o = null; n !== null; ) {
        var u = n.alternate;
        u !== null && JS(u) === null && (o = n), n = n.sibling;
      }
      return o;
    }
    function wq(e) {
      if (e !== void 0 && e !== "forwards" && e !== "backwards" && e !== "together" && !t4[e])
        if (t4[e] = !0, typeof e == "string")
          switch (e.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards": {
              g('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', e, e.toLowerCase());
              break;
            }
            case "forward":
            case "backward": {
              g('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', e, e.toLowerCase());
              break;
            }
            default:
              g('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
              break;
          }
        else
          g('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', e);
    }
    function Tq(e, n) {
      e !== void 0 && !Sb[e] && (e !== "collapsed" && e !== "hidden" ? (Sb[e] = !0, g('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', e)) : n !== "forwards" && n !== "backwards" && (Sb[e] = !0, g('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', e)));
    }
    function vL(e, n) {
      {
        var o = Gi(e), u = !o && typeof En(e) == "function";
        if (o || u) {
          var h = o ? "array" : "iterable";
          return g("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", h, n, h), !1;
        }
      }
      return !0;
    }
    function Eq(e, n) {
      if ((n === "forwards" || n === "backwards") && e !== void 0 && e !== null && e !== !1)
        if (Gi(e)) {
          for (var o = 0; o < e.length; o++)
            if (!vL(e[o], o))
              return;
        } else {
          var u = En(e);
          if (typeof u == "function") {
            var h = u.call(e);
            if (h)
              for (var y = h.next(), S = 0; !y.done; y = h.next()) {
                if (!vL(y.value, S))
                  return;
                S++;
              }
          } else
            g('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', n);
        }
    }
    function u4(e, n, o, u, h) {
      var y = e.memoizedState;
      y === null ? e.memoizedState = {
        isBackwards: n,
        rendering: null,
        renderingStartTime: 0,
        last: u,
        tail: o,
        tailMode: h
      } : (y.isBackwards = n, y.rendering = null, y.renderingStartTime = 0, y.last = u, y.tail = o, y.tailMode = h);
    }
    function yL(e, n, o) {
      var u = n.pendingProps, h = u.revealOrder, y = u.tail, S = u.children;
      wq(h), Tq(y, h), Eq(S, h), ba(e, n, S, o);
      var w = No.current, E = oE(w, M6);
      if (E)
        w = lE(w, M6), n.flags |= He;
      else {
        var D = e !== null && (e.flags & He) !== Fe;
        D && Sq(n, n.child, o), w = Iy(w);
      }
      if (Zd(n, w), (n.mode & Tt) === Ie)
        n.memoizedState = null;
      else
        switch (h) {
          case "forwards": {
            var M = bq(n.child), H;
            M === null ? (H = n.child, n.child = null) : (H = M.sibling, M.sibling = null), u4(
              n,
              !1,
              // isBackwards
              H,
              M,
              y
            );
            break;
          }
          case "backwards": {
            var V = null, Q = n.child;
            for (n.child = null; Q !== null; ) {
              var W = Q.alternate;
              if (W !== null && JS(W) === null) {
                n.child = Q;
                break;
              }
              var X = Q.sibling;
              Q.sibling = V, V = Q, Q = X;
            }
            u4(
              n,
              !0,
              // isBackwards
              V,
              null,
              // last
              y
            );
            break;
          }
          case "together": {
            u4(
              n,
              !1,
              // isBackwards
              null,
              // tail
              null,
              // last
              void 0
            );
            break;
          }
          default:
            n.memoizedState = null;
        }
      return n.child;
    }
    function kq(e, n, o) {
      rE(n, n.stateNode.containerInfo);
      var u = n.pendingProps;
      return e === null ? n.child = Uy(n, null, u, o) : ba(e, n, u, o), n.child;
    }
    var gL = !1;
    function xq(e, n, o) {
      var u = n.type, h = u._context, y = n.pendingProps, S = n.memoizedProps, w = y.value;
      {
        "value" in y || gL || (gL = !0, g("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
        var E = n.type.propTypes;
        E && Po(E, y, "prop", "Context.Provider");
      }
      if (cR(n, h, w), S !== null) {
        var D = S.value;
        if (be(D, w)) {
          if (S.children === y.children && !DS())
            return mc(e, n, o);
        } else
          wB(n, h, o);
      }
      var M = y.children;
      return ba(e, n, M, o), n.child;
    }
    var CL = !1;
    function Rq(e, n, o) {
      var u = n.type;
      u._context === void 0 ? u !== u.Consumer && (CL || (CL = !0, g("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : u = u._context;
      var h = n.pendingProps, y = h.children;
      typeof y != "function" && g("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), Hy(n, o);
      var S = Ni(u);
      va(n);
      var w;
      return H6.current = n, ji(!0), w = y(S), ji(!1), ya(), n.flags |= ps, ba(e, n, w, o), n.child;
    }
    function B6() {
      zo = !0;
    }
    function wb(e, n) {
      (n.mode & Tt) === Ie && e !== null && (e.alternate = null, n.alternate = null, n.flags |= Kn);
    }
    function mc(e, n, o) {
      return e !== null && (n.dependencies = e.dependencies), YR(), t2(n.lanes), Jr(o, n.childLanes) ? (SB(e, n), n.child) : null;
    }
    function Lq(e, n, o) {
      {
        var u = n.return;
        if (u === null)
          throw new Error("Cannot swap the root fiber.");
        if (e.alternate = null, n.alternate = null, o.index = n.index, o.sibling = n.sibling, o.return = n.return, o.ref = n.ref, n === u.child)
          u.child = o;
        else {
          var h = u.child;
          if (h === null)
            throw new Error("Expected parent to have a child.");
          for (; h.sibling !== n; )
            if (h = h.sibling, h === null)
              throw new Error("Expected to find the previous sibling.");
          h.sibling = o;
        }
        var y = u.deletions;
        return y === null ? (u.deletions = [e], u.flags |= Ha) : y.push(e), o.flags |= Kn, o;
      }
    }
    function c4(e, n) {
      var o = e.lanes;
      return !!Jr(o, n);
    }
    function $q(e, n, o) {
      switch (n.tag) {
        case A:
          dL(n), n.stateNode, Vy();
          break;
        case F:
          gR(n);
          break;
        case $: {
          var u = n.type;
          Ul(u) && AS(n);
          break;
        }
        case U:
          rE(n, n.stateNode.containerInfo);
          break;
        case Ne: {
          var h = n.memoizedProps.value, y = n.type._context;
          cR(n, y, h);
          break;
        }
        case je:
          {
            var S = Jr(o, n.childLanes);
            S && (n.flags |= _t);
            {
              var w = n.stateNode;
              w.effectDuration = 0, w.passiveEffectDuration = 0;
            }
          }
          break;
        case Me: {
          var E = n.memoizedState;
          if (E !== null) {
            if (E.dehydrated !== null)
              return Zd(n, Iy(No.current)), n.flags |= He, null;
            var D = n.child, M = D.childLanes;
            if (Jr(o, M))
              return hL(e, n, o);
            Zd(n, Iy(No.current));
            var H = mc(e, n, o);
            return H !== null ? H.sibling : null;
          } else
            Zd(n, Iy(No.current));
          break;
        }
        case Gt: {
          var V = (e.flags & He) !== Fe, Q = Jr(o, n.childLanes);
          if (V) {
            if (Q)
              return yL(e, n, o);
            n.flags |= He;
          }
          var W = n.memoizedState;
          if (W !== null && (W.rendering = null, W.tail = null, W.lastEffect = null), Zd(n, No.current), Q)
            break;
          return null;
        }
        case Ve:
        case mt:
          return n.lanes = ie, lL(e, n, o);
      }
      return mc(e, n, o);
    }
    function SL(e, n, o) {
      if (n._debugNeedsRemount && e !== null)
        return Lq(e, n, H4(n.type, n.key, n.pendingProps, n._debugOwner || null, n.mode, n.lanes));
      if (e !== null) {
        var u = e.memoizedProps, h = n.pendingProps;
        if (u !== h || DS() || // Force a re-render if the implementation changed due to hot reload:
        n.type !== e.type)
          zo = !0;
        else {
          var y = c4(e, o);
          if (!y && // If this is the second pass of an error or suspense boundary, there
          // may not be work scheduled on `current`, so we check for this flag.
          (n.flags & He) === Fe)
            return zo = !1, $q(e, n, o);
          (e.flags & _v) !== Fe ? zo = !0 : zo = !1;
        }
      } else if (zo = !1, Rr() && eB(n)) {
        var S = n.index, w = tB();
        Yx(n, w, S);
      }
      switch (n.lanes = ie, n.tag) {
        case P:
          return cq(e, n, n.type, o);
        case he: {
          var E = n.elementType;
          return lq(e, n, E, o);
        }
        case x: {
          var D = n.type, M = n.pendingProps, H = n.elementType === D ? M : Uo(D, M);
          return n4(e, n, D, H, o);
        }
        case $: {
          var V = n.type, Q = n.pendingProps, W = n.elementType === V ? Q : Uo(V, Q);
          return cL(e, n, V, W, o);
        }
        case A:
          return aq(e, n, o);
        case F:
          return sq(e, n, o);
        case Z:
          return oq(e, n);
        case Me:
          return hL(e, n, o);
        case U:
          return kq(e, n, o);
        case Se: {
          var X = n.type, Ce = n.pendingProps, Qe = n.elementType === X ? Ce : Uo(X, Ce);
          return aL(e, n, X, Qe, o);
        }
        case ne:
          return nq(e, n, o);
        case ce:
          return iq(e, n, o);
        case je:
          return rq(e, n, o);
        case Ne:
          return xq(e, n, o);
        case De:
          return Rq(e, n, o);
        case Ct: {
          var Ue = n.type, Ut = n.pendingProps, Dt = Uo(Ue, Ut);
          if (n.type !== n.elementType) {
            var q = Ue.propTypes;
            q && Po(
              q,
              Dt,
              // Resolved for outer only
              "prop",
              fn(Ue)
            );
          }
          return Dt = Uo(Ue.type, Dt), sL(e, n, Ue, Dt, o);
        }
        case Ge:
          return oL(e, n, n.type, n.pendingProps, o);
        case Ze: {
          var J = n.type, j = n.pendingProps, le = n.elementType === J ? j : Uo(J, j);
          return uq(e, n, J, le, o);
        }
        case Gt:
          return yL(e, n, o);
        case Lt:
          break;
        case Ve:
          return lL(e, n, o);
      }
      throw new Error("Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Yy(e) {
      e.flags |= _t;
    }
    function bL(e) {
      e.flags |= Qn, e.flags |= Dd;
    }
    var wL, d4, TL, EL;
    wL = function(e, n, o, u) {
      for (var h = n.child; h !== null; ) {
        if (h.tag === F || h.tag === Z)
          ZF(e, h.stateNode);
        else if (h.tag !== U) {
          if (h.child !== null) {
            h.child.return = h, h = h.child;
            continue;
          }
        }
        if (h === n)
          return;
        for (; h.sibling === null; ) {
          if (h.return === null || h.return === n)
            return;
          h = h.return;
        }
        h.sibling.return = h.return, h = h.sibling;
      }
    }, d4 = function(e, n) {
    }, TL = function(e, n, o, u, h) {
      var y = e.memoizedProps;
      if (y !== u) {
        var S = n.stateNode, w = aE(), E = JF(S, o, y, u, h, w);
        n.updateQueue = E, E && Yy(n);
      }
    }, EL = function(e, n, o, u) {
      o !== u && Yy(n);
    };
    function q6(e, n) {
      if (!Rr())
        switch (e.tailMode) {
          case "hidden": {
            for (var o = e.tail, u = null; o !== null; )
              o.alternate !== null && (u = o), o = o.sibling;
            u === null ? e.tail = null : u.sibling = null;
            break;
          }
          case "collapsed": {
            for (var h = e.tail, y = null; h !== null; )
              h.alternate !== null && (y = h), h = h.sibling;
            y === null ? !n && e.tail !== null ? e.tail.sibling = null : e.tail = null : y.sibling = null;
            break;
          }
        }
    }
    function $r(e) {
      var n = e.alternate !== null && e.alternate.child === e.child, o = ie, u = Fe;
      if (n) {
        if ((e.mode & Yt) !== Ie) {
          for (var E = e.selfBaseDuration, D = e.child; D !== null; )
            o = yt(o, yt(D.lanes, D.childLanes)), u |= D.subtreeFlags & ui, u |= D.flags & ui, E += D.treeBaseDuration, D = D.sibling;
          e.treeBaseDuration = E;
        } else
          for (var M = e.child; M !== null; )
            o = yt(o, yt(M.lanes, M.childLanes)), u |= M.subtreeFlags & ui, u |= M.flags & ui, M.return = e, M = M.sibling;
        e.subtreeFlags |= u;
      } else {
        if ((e.mode & Yt) !== Ie) {
          for (var h = e.actualDuration, y = e.selfBaseDuration, S = e.child; S !== null; )
            o = yt(o, yt(S.lanes, S.childLanes)), u |= S.subtreeFlags, u |= S.flags, h += S.actualDuration, y += S.treeBaseDuration, S = S.sibling;
          e.actualDuration = h, e.treeBaseDuration = y;
        } else
          for (var w = e.child; w !== null; )
            o = yt(o, yt(w.lanes, w.childLanes)), u |= w.subtreeFlags, u |= w.flags, w.return = e, w = w.sibling;
        e.subtreeFlags |= u;
      }
      return e.childLanes = o, n;
    }
    function Dq(e, n, o) {
      if (pB() && (n.mode & Tt) !== Ie && (n.flags & He) === Fe)
        return tR(n), Vy(), n.flags |= Qr | Fh | Wr, !1;
      var u = VS(n);
      if (o !== null && o.dehydrated !== null)
        if (e === null) {
          if (!u)
            throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
          if (fB(n), $r(n), (n.mode & Yt) !== Ie) {
            var h = o !== null;
            if (h) {
              var y = n.child;
              y !== null && (n.treeBaseDuration -= y.treeBaseDuration);
            }
          }
          return !1;
        } else {
          if (Vy(), (n.flags & He) === Fe && (n.memoizedState = null), n.flags |= _t, $r(n), (n.mode & Yt) !== Ie) {
            var S = o !== null;
            if (S) {
              var w = n.child;
              w !== null && (n.treeBaseDuration -= w.treeBaseDuration);
            }
          }
          return !1;
        }
      else
        return nR(), !0;
    }
    function kL(e, n, o) {
      var u = n.pendingProps;
      switch (VT(n), n.tag) {
        case P:
        case he:
        case Ge:
        case x:
        case Se:
        case ne:
        case ce:
        case je:
        case De:
        case Ct:
          return $r(n), null;
        case $: {
          var h = n.type;
          return Ul(h) && MS(n), $r(n), null;
        }
        case A: {
          var y = n.stateNode;
          if (Fy(n), PT(n), cE(), y.pendingContext && (y.context = y.pendingContext, y.pendingContext = null), e === null || e.child === null) {
            var S = VS(n);
            if (S)
              Yy(n);
            else if (e !== null) {
              var w = e.memoizedState;
              // Check if this is a client root
              (!w.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
              (n.flags & Qr) !== Fe) && (n.flags |= Ti, nR());
            }
          }
          return d4(e, n), $r(n), null;
        }
        case F: {
          sE(n);
          var E = yR(), D = n.type;
          if (e !== null && n.stateNode != null)
            TL(e, n, D, u, E), e.ref !== n.ref && bL(n);
          else {
            if (!u) {
              if (n.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              return $r(n), null;
            }
            var M = aE(), H = VS(n);
            if (H)
              cB(n, E, M) && Yy(n);
            else {
              var V = KF(D, u, E, M, n);
              wL(V, n, !1, !1), n.stateNode = V, XF(V, D, u, E) && Yy(n);
            }
            n.ref !== null && bL(n);
          }
          return $r(n), null;
        }
        case Z: {
          var Q = u;
          if (e && n.stateNode != null) {
            var W = e.memoizedProps;
            EL(e, n, W, Q);
          } else {
            if (typeof Q != "string" && n.stateNode === null)
              throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
            var X = yR(), Ce = aE(), Qe = VS(n);
            Qe ? dB(n) && Yy(n) : n.stateNode = eI(Q, X, Ce, n);
          }
          return $r(n), null;
        }
        case Me: {
          By(n);
          var Ue = n.memoizedState;
          if (e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
            var Ut = Dq(e, n, Ue);
            if (!Ut)
              return n.flags & Wr ? n : null;
          }
          if ((n.flags & He) !== Fe)
            return n.lanes = o, (n.mode & Yt) !== Ie && _E(n), n;
          var Dt = Ue !== null, q = e !== null && e.memoizedState !== null;
          if (Dt !== q && Dt) {
            var J = n.child;
            if (J.flags |= li, (n.mode & Tt) !== Ie) {
              var j = e === null && (n.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
              j || oE(No.current, SR) ? Mj() : $4();
            }
          }
          var le = n.updateQueue;
          if (le !== null && (n.flags |= _t), $r(n), (n.mode & Yt) !== Ie && Dt) {
            var xe = n.child;
            xe !== null && (n.treeBaseDuration -= xe.treeBaseDuration);
          }
          return null;
        }
        case U:
          return Fy(n), d4(e, n), e === null && QI(n.stateNode.containerInfo), $r(n), null;
        case Ne:
          var we = n.type._context;
          return ZT(we, n), $r(n), null;
        case Ze: {
          var at = n.type;
          return Ul(at) && MS(n), $r(n), null;
        }
        case Gt: {
          By(n);
          var ft = n.memoizedState;
          if (ft === null)
            return $r(n), null;
          var yn = (n.flags & He) !== Fe, Zt = ft.rendering;
          if (Zt === null)
            if (yn)
              q6(ft, !1);
            else {
              var Ri = Pj() && (e === null || (e.flags & He) === Fe);
              if (!Ri)
                for (var Xt = n.child; Xt !== null; ) {
                  var mi = JS(Xt);
                  if (mi !== null) {
                    yn = !0, n.flags |= He, q6(ft, !1);
                    var sa = mi.updateQueue;
                    return sa !== null && (n.updateQueue = sa, n.flags |= _t), n.subtreeFlags = Fe, bB(n, o), Zd(n, lE(No.current, M6)), n.child;
                  }
                  Xt = Xt.sibling;
                }
              ft.tail !== null && Ei() > GL() && (n.flags |= He, yn = !0, q6(ft, !1), n.lanes = N3);
            }
          else {
            if (!yn) {
              var Or = JS(Zt);
              if (Or !== null) {
                n.flags |= He, yn = !0;
                var ws = Or.updateQueue;
                if (ws !== null && (n.updateQueue = ws, n.flags |= _t), q6(ft, !0), ft.tail === null && ft.tailMode === "hidden" && !Zt.alternate && !Rr())
                  return $r(n), null;
              } else // The time it took to render last row is greater than the remaining
              // time we have to render. So rendering one more row would likely
              // exceed it.
              Ei() * 2 - ft.renderingStartTime > GL() && o !== ga && (n.flags |= He, yn = !0, q6(ft, !1), n.lanes = N3);
            }
            if (ft.isBackwards)
              Zt.sibling = n.child, n.child = Zt;
            else {
              var Ea = ft.last;
              Ea !== null ? Ea.sibling = Zt : n.child = Zt, ft.last = Zt;
            }
          }
          if (ft.tail !== null) {
            var ka = ft.tail;
            ft.rendering = ka, ft.tail = ka.sibling, ft.renderingStartTime = Ei(), ka.sibling = null;
            var oa = No.current;
            return yn ? oa = lE(oa, M6) : oa = Iy(oa), Zd(n, oa), ka;
          }
          return $r(n), null;
        }
        case Lt:
          break;
        case Ve:
        case mt: {
          L4(n);
          var Sc = n.memoizedState, ng = Sc !== null;
          if (e !== null) {
            var s2 = e.memoizedState, Gl = s2 !== null;
            Gl !== ng && (n.flags |= li);
          }
          return !ng || (n.mode & Tt) === Ie ? $r(n) : Jr(jl, ga) && ($r(n), n.subtreeFlags & (Kn | _t) && (n.flags |= li)), null;
        }
        case wn:
          return null;
        case Ye:
          return null;
      }
      throw new Error("Unknown unit of work tag (" + n.tag + "). This error is likely caused by a bug in React. Please file an issue.");
    }
    function Mq(e, n, o) {
      switch (VT(n), n.tag) {
        case $: {
          var u = n.type;
          Ul(u) && MS(n);
          var h = n.flags;
          return h & Wr ? (n.flags = h & -65537 | He, (n.mode & Yt) !== Ie && _E(n), n) : null;
        }
        case A: {
          n.stateNode, Fy(n), PT(n), cE();
          var y = n.flags;
          return (y & Wr) !== Fe && (y & He) === Fe ? (n.flags = y & -65537 | He, n) : null;
        }
        case F:
          return sE(n), null;
        case Me: {
          By(n);
          var S = n.memoizedState;
          if (S !== null && S.dehydrated !== null) {
            if (n.alternate === null)
              throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
            Vy();
          }
          var w = n.flags;
          return w & Wr ? (n.flags = w & -65537 | He, (n.mode & Yt) !== Ie && _E(n), n) : null;
        }
        case Gt:
          return By(n), null;
        case U:
          return Fy(n), null;
        case Ne:
          var E = n.type._context;
          return ZT(E, n), null;
        case Ve:
        case mt:
          return L4(n), null;
        case wn:
          return null;
        default:
          return null;
      }
    }
    function xL(e, n, o) {
      switch (VT(n), n.tag) {
        case $: {
          var u = n.type.childContextTypes;
          u != null && MS(n);
          break;
        }
        case A: {
          n.stateNode, Fy(n), PT(n), cE();
          break;
        }
        case F: {
          sE(n);
          break;
        }
        case U:
          Fy(n);
          break;
        case Me:
          By(n);
          break;
        case Gt:
          By(n);
          break;
        case Ne:
          var h = n.type._context;
          ZT(h, n);
          break;
        case Ve:
        case mt:
          L4(n);
          break;
      }
    }
    var RL = null;
    RL = /* @__PURE__ */ new Set();
    var Tb = !1, Dr = !1, Aq = typeof WeakSet == "function" ? WeakSet : Set, Pe = null, Wy = null, Ky = null;
    function Pq(e) {
      Sl(null, function() {
        throw e;
      }), Hh();
    }
    var Oq = function(e, n) {
      if (n.props = e.memoizedProps, n.state = e.memoizedState, e.mode & Yt)
        try {
          Bl(), n.componentWillUnmount();
        } finally {
          Il(e);
        }
      else
        n.componentWillUnmount();
    };
    function LL(e, n) {
      try {
        ef(Xi, e);
      } catch (o) {
        An(e, n, o);
      }
    }
    function f4(e, n, o) {
      try {
        Oq(e, o);
      } catch (u) {
        An(e, n, u);
      }
    }
    function _q(e, n, o) {
      try {
        o.componentDidMount();
      } catch (u) {
        An(e, n, u);
      }
    }
    function $L(e, n) {
      try {
        ML(e);
      } catch (o) {
        An(e, n, o);
      }
    }
    function Zy(e, n) {
      var o = e.ref;
      if (o !== null)
        if (typeof o == "function") {
          var u;
          try {
            if (ri && Oa && e.mode & Yt)
              try {
                Bl(), u = o(null);
              } finally {
                Il(e);
              }
            else
              u = o(null);
          } catch (h) {
            An(e, n, h);
          }
          typeof u == "function" && g("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", vt(e));
        } else
          o.current = null;
    }
    function Eb(e, n, o) {
      try {
        o();
      } catch (u) {
        An(e, n, u);
      }
    }
    var DL = !1;
    function Nq(e, n) {
      YF(e.containerInfo), Pe = n, Vq();
      var o = DL;
      return DL = !1, o;
    }
    function Vq() {
      for (; Pe !== null; ) {
        var e = Pe, n = e.child;
        (e.subtreeFlags & wl) !== Fe && n !== null ? (n.return = e, Pe = n) : Uq();
      }
    }
    function Uq() {
      for (; Pe !== null; ) {
        var e = Pe;
        Mn(e);
        try {
          zq(e);
        } catch (o) {
          An(e, e.return, o);
        }
        Gn();
        var n = e.sibling;
        if (n !== null) {
          n.return = e.return, Pe = n;
          return;
        }
        Pe = e.return;
      }
    }
    function zq(e) {
      var n = e.alternate, o = e.flags;
      if ((o & Ti) !== Fe) {
        switch (Mn(e), e.tag) {
          case x:
          case Se:
          case Ge:
            break;
          case $: {
            if (n !== null) {
              var u = n.memoizedProps, h = n.memoizedState, y = e.stateNode;
              e.type === e.elementType && !Pp && (y.props !== e.memoizedProps && g("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", vt(e) || "instance"), y.state !== e.memoizedState && g("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", vt(e) || "instance"));
              var S = y.getSnapshotBeforeUpdate(e.elementType === e.type ? u : Uo(e.type, u), h);
              {
                var w = RL;
                S === void 0 && !w.has(e.type) && (w.add(e.type), g("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", vt(e)));
              }
              y.__reactInternalSnapshotBeforeUpdate = S;
            }
            break;
          }
          case A: {
            {
              var E = e.stateNode;
              CI(E.containerInfo);
            }
            break;
          }
          case F:
          case Z:
          case U:
          case Ze:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        Gn();
      }
    }
    function Ho(e, n, o) {
      var u = n.updateQueue, h = u !== null ? u.lastEffect : null;
      if (h !== null) {
        var y = h.next, S = y;
        do {
          if ((S.tag & e) === e) {
            var w = S.destroy;
            S.destroy = void 0, w !== void 0 && ((e & Lr) !== Za ? Ro(n) : (e & Xi) !== Za && Bh(n), (e & zl) !== Za && i2(!0), Eb(n, o, w), (e & zl) !== Za && i2(!1), (e & Lr) !== Za ? xl() : (e & Xi) !== Za && O3());
          }
          S = S.next;
        } while (S !== y);
      }
    }
    function ef(e, n) {
      var o = n.updateQueue, u = o !== null ? o.lastEffect : null;
      if (u !== null) {
        var h = u.next, y = h;
        do {
          if ((y.tag & e) === e) {
            (e & Lr) !== Za ? P3(n) : (e & Xi) !== Za && Fv(n);
            var S = y.create;
            (e & zl) !== Za && i2(!0), y.destroy = S(), (e & zl) !== Za && i2(!1), (e & Lr) !== Za ? MC() : (e & Xi) !== Za && AC();
            {
              var w = y.destroy;
              if (w !== void 0 && typeof w != "function") {
                var E = void 0;
                (y.tag & Xi) !== Fe ? E = "useLayoutEffect" : (y.tag & zl) !== Fe ? E = "useInsertionEffect" : E = "useEffect";
                var D = void 0;
                w === null ? D = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof w.then == "function" ? D = `

It looks like you wrote ` + E + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + E + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : D = " You returned: " + w, g("%s must not return anything besides a function, which is used for clean-up.%s", E, D);
              }
            }
          }
          y = y.next;
        } while (y !== h);
      }
    }
    function Hq(e, n) {
      if ((n.flags & _t) !== Fe)
        switch (n.tag) {
          case je: {
            var o = n.stateNode.passiveEffectDuration, u = n.memoizedProps, h = u.id, y = u.onPostCommit, S = GR(), w = n.alternate === null ? "mount" : "update";
            jR() && (w = "nested-update"), typeof y == "function" && y(h, w, o, S);
            var E = n.return;
            e: for (; E !== null; ) {
              switch (E.tag) {
                case A:
                  var D = E.stateNode;
                  D.passiveEffectDuration += o;
                  break e;
                case je:
                  var M = E.stateNode;
                  M.passiveEffectDuration += o;
                  break e;
              }
              E = E.return;
            }
            break;
          }
        }
    }
    function Fq(e, n, o, u) {
      if ((o.flags & El) !== Fe)
        switch (o.tag) {
          case x:
          case Se:
          case Ge: {
            if (!Dr)
              if (o.mode & Yt)
                try {
                  Bl(), ef(Xi | Zi, o);
                } finally {
                  Il(o);
                }
              else
                ef(Xi | Zi, o);
            break;
          }
          case $: {
            var h = o.stateNode;
            if (o.flags & _t && !Dr)
              if (n === null)
                if (o.type === o.elementType && !Pp && (h.props !== o.memoizedProps && g("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", vt(o) || "instance"), h.state !== o.memoizedState && g("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", vt(o) || "instance")), o.mode & Yt)
                  try {
                    Bl(), h.componentDidMount();
                  } finally {
                    Il(o);
                  }
                else
                  h.componentDidMount();
              else {
                var y = o.elementType === o.type ? n.memoizedProps : Uo(o.type, n.memoizedProps), S = n.memoizedState;
                if (o.type === o.elementType && !Pp && (h.props !== o.memoizedProps && g("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", vt(o) || "instance"), h.state !== o.memoizedState && g("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", vt(o) || "instance")), o.mode & Yt)
                  try {
                    Bl(), h.componentDidUpdate(y, S, h.__reactInternalSnapshotBeforeUpdate);
                  } finally {
                    Il(o);
                  }
                else
                  h.componentDidUpdate(y, S, h.__reactInternalSnapshotBeforeUpdate);
              }
            var w = o.updateQueue;
            w !== null && (o.type === o.elementType && !Pp && (h.props !== o.memoizedProps && g("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", vt(o) || "instance"), h.state !== o.memoizedState && g("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", vt(o) || "instance")), vR(o, w, h));
            break;
          }
          case A: {
            var E = o.updateQueue;
            if (E !== null) {
              var D = null;
              if (o.child !== null)
                switch (o.child.tag) {
                  case F:
                    D = o.child.stateNode;
                    break;
                  case $:
                    D = o.child.stateNode;
                    break;
                }
              vR(o, E, D);
            }
            break;
          }
          case F: {
            var M = o.stateNode;
            if (n === null && o.flags & _t) {
              var H = o.type, V = o.memoizedProps;
              aI(M, H, V);
            }
            break;
          }
          case Z:
            break;
          case U:
            break;
          case je: {
            {
              var Q = o.memoizedProps, W = Q.onCommit, X = Q.onRender, Ce = o.stateNode.effectDuration, Qe = GR(), Ue = n === null ? "mount" : "update";
              jR() && (Ue = "nested-update"), typeof X == "function" && X(o.memoizedProps.id, Ue, o.actualDuration, o.treeBaseDuration, o.actualStartTime, Qe);
              {
                typeof W == "function" && W(o.memoizedProps.id, Ue, Ce, Qe), Uj(o);
                var Ut = o.return;
                e: for (; Ut !== null; ) {
                  switch (Ut.tag) {
                    case A:
                      var Dt = Ut.stateNode;
                      Dt.effectDuration += Ce;
                      break e;
                    case je:
                      var q = Ut.stateNode;
                      q.effectDuration += Ce;
                      break e;
                  }
                  Ut = Ut.return;
                }
              }
            }
            break;
          }
          case Me: {
            Wq(e, o);
            break;
          }
          case Gt:
          case Ze:
          case Lt:
          case Ve:
          case mt:
          case Ye:
            break;
          default:
            throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
      Dr || o.flags & Qn && ML(o);
    }
    function Iq(e) {
      switch (e.tag) {
        case x:
        case Se:
        case Ge: {
          if (e.mode & Yt)
            try {
              Bl(), LL(e, e.return);
            } finally {
              Il(e);
            }
          else
            LL(e, e.return);
          break;
        }
        case $: {
          var n = e.stateNode;
          typeof n.componentDidMount == "function" && _q(e, e.return, n), $L(e, e.return);
          break;
        }
        case F: {
          $L(e, e.return);
          break;
        }
      }
    }
    function Bq(e, n) {
      for (var o = null, u = e; ; ) {
        if (u.tag === F) {
          if (o === null) {
            o = u;
            try {
              var h = u.stateNode;
              n ? mI(h) : yI(u.stateNode, u.memoizedProps);
            } catch (S) {
              An(e, e.return, S);
            }
          }
        } else if (u.tag === Z) {
          if (o === null)
            try {
              var y = u.stateNode;
              n ? vI(y) : gI(y, u.memoizedProps);
            } catch (S) {
              An(e, e.return, S);
            }
        } else if (!((u.tag === Ve || u.tag === mt) && u.memoizedState !== null && u !== e)) {
          if (u.child !== null) {
            u.child.return = u, u = u.child;
            continue;
          }
        }
        if (u === e)
          return;
        for (; u.sibling === null; ) {
          if (u.return === null || u.return === e)
            return;
          o === u && (o = null), u = u.return;
        }
        o === u && (o = null), u.sibling.return = u.return, u = u.sibling;
      }
    }
    function ML(e) {
      var n = e.ref;
      if (n !== null) {
        var o = e.stateNode, u;
        switch (e.tag) {
          case F:
            u = o;
            break;
          default:
            u = o;
        }
        if (typeof n == "function") {
          var h;
          if (e.mode & Yt)
            try {
              Bl(), h = n(u);
            } finally {
              Il(e);
            }
          else
            h = n(u);
          typeof h == "function" && g("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", vt(e));
        } else
          n.hasOwnProperty("current") || g("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", vt(e)), n.current = u;
      }
    }
    function qq(e) {
      var n = e.alternate;
      n !== null && (n.return = null), e.return = null;
    }
    function AL(e) {
      var n = e.alternate;
      n !== null && (e.alternate = null, AL(n));
      {
        if (e.child = null, e.deletions = null, e.sibling = null, e.tag === F) {
          var o = e.stateNode;
          o !== null && KI(o);
        }
        e.stateNode = null, e._debugOwner = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
      }
    }
    function jq(e) {
      for (var n = e.return; n !== null; ) {
        if (PL(n))
          return n;
        n = n.return;
      }
      throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function PL(e) {
      return e.tag === F || e.tag === A || e.tag === U;
    }
    function OL(e) {
      var n = e;
      e: for (; ; ) {
        for (; n.sibling === null; ) {
          if (n.return === null || PL(n.return))
            return null;
          n = n.return;
        }
        for (n.sibling.return = n.return, n = n.sibling; n.tag !== F && n.tag !== Z && n.tag !== pt; ) {
          if (n.flags & Kn || n.child === null || n.tag === U)
            continue e;
          n.child.return = n, n = n.child;
        }
        if (!(n.flags & Kn))
          return n.stateNode;
      }
    }
    function Gq(e) {
      var n = jq(e);
      switch (n.tag) {
        case F: {
          var o = n.stateNode;
          n.flags & ms && (Nx(o), n.flags &= -33);
          var u = OL(e);
          p4(e, u, o);
          break;
        }
        case A:
        case U: {
          var h = n.stateNode.containerInfo, y = OL(e);
          h4(e, y, h);
          break;
        }
        // eslint-disable-next-line-no-fallthrough
        default:
          throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
      }
    }
    function h4(e, n, o) {
      var u = e.tag, h = u === F || u === Z;
      if (h) {
        var y = e.stateNode;
        n ? dI(o, y, n) : uI(o, y);
      } else if (u !== U) {
        var S = e.child;
        if (S !== null) {
          h4(S, n, o);
          for (var w = S.sibling; w !== null; )
            h4(w, n, o), w = w.sibling;
        }
      }
    }
    function p4(e, n, o) {
      var u = e.tag, h = u === F || u === Z;
      if (h) {
        var y = e.stateNode;
        n ? cI(o, y, n) : lI(o, y);
      } else if (u !== U) {
        var S = e.child;
        if (S !== null) {
          p4(S, n, o);
          for (var w = S.sibling; w !== null; )
            p4(w, n, o), w = w.sibling;
        }
      }
    }
    var Mr = null, Fo = !1;
    function Qq(e, n, o) {
      {
        var u = n;
        e: for (; u !== null; ) {
          switch (u.tag) {
            case F: {
              Mr = u.stateNode, Fo = !1;
              break e;
            }
            case A: {
              Mr = u.stateNode.containerInfo, Fo = !0;
              break e;
            }
            case U: {
              Mr = u.stateNode.containerInfo, Fo = !0;
              break e;
            }
          }
          u = u.return;
        }
        if (Mr === null)
          throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        _L(e, n, o), Mr = null, Fo = !1;
      }
      qq(o);
    }
    function tf(e, n, o) {
      for (var u = o.child; u !== null; )
        _L(e, n, u), u = u.sibling;
    }
    function _L(e, n, o) {
      switch (D3(o), o.tag) {
        case F:
          Dr || Zy(o, n);
        // eslint-disable-next-line-no-fallthrough
        case Z: {
          {
            var u = Mr, h = Fo;
            Mr = null, tf(e, n, o), Mr = u, Fo = h, Mr !== null && (Fo ? hI(Mr, o.stateNode) : fI(Mr, o.stateNode));
          }
          return;
        }
        case pt: {
          Mr !== null && (Fo ? pI(Mr, o.stateNode) : kT(Mr, o.stateNode));
          return;
        }
        case U: {
          {
            var y = Mr, S = Fo;
            Mr = o.stateNode.containerInfo, Fo = !0, tf(e, n, o), Mr = y, Fo = S;
          }
          return;
        }
        case x:
        case Se:
        case Ct:
        case Ge: {
          if (!Dr) {
            var w = o.updateQueue;
            if (w !== null) {
              var E = w.lastEffect;
              if (E !== null) {
                var D = E.next, M = D;
                do {
                  var H = M, V = H.destroy, Q = H.tag;
                  V !== void 0 && ((Q & zl) !== Za ? Eb(o, n, V) : (Q & Xi) !== Za && (Bh(o), o.mode & Yt ? (Bl(), Eb(o, n, V), Il(o)) : Eb(o, n, V), O3())), M = M.next;
                } while (M !== D);
              }
            }
          }
          tf(e, n, o);
          return;
        }
        case $: {
          if (!Dr) {
            Zy(o, n);
            var W = o.stateNode;
            typeof W.componentWillUnmount == "function" && f4(o, n, W);
          }
          tf(e, n, o);
          return;
        }
        case Lt: {
          tf(e, n, o);
          return;
        }
        case Ve: {
          if (
            // TODO: Remove this dead flag
            o.mode & Tt
          ) {
            var X = Dr;
            Dr = X || o.memoizedState !== null, tf(e, n, o), Dr = X;
          } else
            tf(e, n, o);
          break;
        }
        default: {
          tf(e, n, o);
          return;
        }
      }
    }
    function Yq(e) {
      e.memoizedState;
    }
    function Wq(e, n) {
      var o = n.memoizedState;
      if (o === null) {
        var u = n.alternate;
        if (u !== null) {
          var h = u.memoizedState;
          if (h !== null) {
            var y = h.dehydrated;
            y !== null && PI(y);
          }
        }
      }
    }
    function NL(e) {
      var n = e.updateQueue;
      if (n !== null) {
        e.updateQueue = null;
        var o = e.stateNode;
        o === null && (o = e.stateNode = new Aq()), n.forEach(function(u) {
          var h = jj.bind(null, e, u);
          if (!o.has(u)) {
            if (o.add(u), Xr)
              if (Wy !== null && Ky !== null)
                n2(Ky, Wy);
              else
                throw Error("Expected finished root and lanes to be set. This is a bug in React.");
            u.then(h, h);
          }
        });
      }
    }
    function Kq(e, n, o) {
      Wy = o, Ky = e, Mn(n), VL(n, e), Mn(n), Wy = null, Ky = null;
    }
    function Io(e, n, o) {
      var u = n.deletions;
      if (u !== null)
        for (var h = 0; h < u.length; h++) {
          var y = u[h];
          try {
            Qq(e, n, y);
          } catch (E) {
            An(y, n, E);
          }
        }
      var S = Eh();
      if (n.subtreeFlags & Tl)
        for (var w = n.child; w !== null; )
          Mn(w), VL(w, e), w = w.sibling;
      Mn(S);
    }
    function VL(e, n, o) {
      var u = e.alternate, h = e.flags;
      switch (e.tag) {
        case x:
        case Se:
        case Ct:
        case Ge: {
          if (Io(n, e), ql(e), h & _t) {
            try {
              Ho(zl | Zi, e, e.return), ef(zl | Zi, e);
            } catch (at) {
              An(e, e.return, at);
            }
            if (e.mode & Yt) {
              try {
                Bl(), Ho(Xi | Zi, e, e.return);
              } catch (at) {
                An(e, e.return, at);
              }
              Il(e);
            } else
              try {
                Ho(Xi | Zi, e, e.return);
              } catch (at) {
                An(e, e.return, at);
              }
          }
          return;
        }
        case $: {
          Io(n, e), ql(e), h & Qn && u !== null && Zy(u, u.return);
          return;
        }
        case F: {
          Io(n, e), ql(e), h & Qn && u !== null && Zy(u, u.return);
          {
            if (e.flags & ms) {
              var y = e.stateNode;
              try {
                Nx(y);
              } catch (at) {
                An(e, e.return, at);
              }
            }
            if (h & _t) {
              var S = e.stateNode;
              if (S != null) {
                var w = e.memoizedProps, E = u !== null ? u.memoizedProps : w, D = e.type, M = e.updateQueue;
                if (e.updateQueue = null, M !== null)
                  try {
                    sI(S, M, D, E, w, e);
                  } catch (at) {
                    An(e, e.return, at);
                  }
              }
            }
          }
          return;
        }
        case Z: {
          if (Io(n, e), ql(e), h & _t) {
            if (e.stateNode === null)
              throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
            var H = e.stateNode, V = e.memoizedProps, Q = u !== null ? u.memoizedProps : V;
            try {
              oI(H, Q, V);
            } catch (at) {
              An(e, e.return, at);
            }
          }
          return;
        }
        case A: {
          if (Io(n, e), ql(e), h & _t && u !== null) {
            var W = u.memoizedState;
            if (W.isDehydrated)
              try {
                AI(n.containerInfo);
              } catch (at) {
                An(e, e.return, at);
              }
          }
          return;
        }
        case U: {
          Io(n, e), ql(e);
          return;
        }
        case Me: {
          Io(n, e), ql(e);
          var X = e.child;
          if (X.flags & li) {
            var Ce = X.stateNode, Qe = X.memoizedState, Ue = Qe !== null;
            if (Ce.isHidden = Ue, Ue) {
              var Ut = X.alternate !== null && X.alternate.memoizedState !== null;
              Ut || Dj();
            }
          }
          if (h & _t) {
            try {
              Yq(e);
            } catch (at) {
              An(e, e.return, at);
            }
            NL(e);
          }
          return;
        }
        case Ve: {
          var Dt = u !== null && u.memoizedState !== null;
          if (
            // TODO: Remove this dead flag
            e.mode & Tt
          ) {
            var q = Dr;
            Dr = q || Dt, Io(n, e), Dr = q;
          } else
            Io(n, e);
          if (ql(e), h & li) {
            var J = e.stateNode, j = e.memoizedState, le = j !== null, xe = e;
            if (J.isHidden = le, le && !Dt && (xe.mode & Tt) !== Ie) {
              Pe = xe;
              for (var we = xe.child; we !== null; )
                Pe = we, Xq(we), we = we.sibling;
            }
            Bq(xe, le);
          }
          return;
        }
        case Gt: {
          Io(n, e), ql(e), h & _t && NL(e);
          return;
        }
        case Lt:
          return;
        default: {
          Io(n, e), ql(e);
          return;
        }
      }
    }
    function ql(e) {
      var n = e.flags;
      if (n & Kn) {
        try {
          Gq(e);
        } catch (o) {
          An(e, e.return, o);
        }
        e.flags &= -3;
      }
      n & Fa && (e.flags &= -4097);
    }
    function Zq(e, n, o) {
      Wy = o, Ky = n, Pe = e, UL(e, n, o), Wy = null, Ky = null;
    }
    function UL(e, n, o) {
      for (var u = (e.mode & Tt) !== Ie; Pe !== null; ) {
        var h = Pe, y = h.child;
        if (h.tag === Ve && u) {
          var S = h.memoizedState !== null, w = S || Tb;
          if (w) {
            m4(e, n, o);
            continue;
          } else {
            var E = h.alternate, D = E !== null && E.memoizedState !== null, M = D || Dr, H = Tb, V = Dr;
            Tb = w, Dr = M, Dr && !V && (Pe = h, Jq(h));
            for (var Q = y; Q !== null; )
              Pe = Q, UL(
                Q,
                // New root; bubble back up to here and stop.
                n,
                o
              ), Q = Q.sibling;
            Pe = h, Tb = H, Dr = V, m4(e, n, o);
            continue;
          }
        }
        (h.subtreeFlags & El) !== Fe && y !== null ? (y.return = h, Pe = y) : m4(e, n, o);
      }
    }
    function m4(e, n, o) {
      for (; Pe !== null; ) {
        var u = Pe;
        if ((u.flags & El) !== Fe) {
          var h = u.alternate;
          Mn(u);
          try {
            Fq(n, h, u, o);
          } catch (S) {
            An(u, u.return, S);
          }
          Gn();
        }
        if (u === e) {
          Pe = null;
          return;
        }
        var y = u.sibling;
        if (y !== null) {
          y.return = u.return, Pe = y;
          return;
        }
        Pe = u.return;
      }
    }
    function Xq(e) {
      for (; Pe !== null; ) {
        var n = Pe, o = n.child;
        switch (n.tag) {
          case x:
          case Se:
          case Ct:
          case Ge: {
            if (n.mode & Yt)
              try {
                Bl(), Ho(Xi, n, n.return);
              } finally {
                Il(n);
              }
            else
              Ho(Xi, n, n.return);
            break;
          }
          case $: {
            Zy(n, n.return);
            var u = n.stateNode;
            typeof u.componentWillUnmount == "function" && f4(n, n.return, u);
            break;
          }
          case F: {
            Zy(n, n.return);
            break;
          }
          case Ve: {
            var h = n.memoizedState !== null;
            if (h) {
              zL(e);
              continue;
            }
            break;
          }
        }
        o !== null ? (o.return = n, Pe = o) : zL(e);
      }
    }
    function zL(e) {
      for (; Pe !== null; ) {
        var n = Pe;
        if (n === e) {
          Pe = null;
          return;
        }
        var o = n.sibling;
        if (o !== null) {
          o.return = n.return, Pe = o;
          return;
        }
        Pe = n.return;
      }
    }
    function Jq(e) {
      for (; Pe !== null; ) {
        var n = Pe, o = n.child;
        if (n.tag === Ve) {
          var u = n.memoizedState !== null;
          if (u) {
            HL(e);
            continue;
          }
        }
        o !== null ? (o.return = n, Pe = o) : HL(e);
      }
    }
    function HL(e) {
      for (; Pe !== null; ) {
        var n = Pe;
        Mn(n);
        try {
          Iq(n);
        } catch (u) {
          An(n, n.return, u);
        }
        if (Gn(), n === e) {
          Pe = null;
          return;
        }
        var o = n.sibling;
        if (o !== null) {
          o.return = n.return, Pe = o;
          return;
        }
        Pe = n.return;
      }
    }
    function ej(e, n, o, u) {
      Pe = n, tj(n, e, o, u);
    }
    function tj(e, n, o, u) {
      for (; Pe !== null; ) {
        var h = Pe, y = h.child;
        (h.subtreeFlags & ko) !== Fe && y !== null ? (y.return = h, Pe = y) : nj(e, n, o, u);
      }
    }
    function nj(e, n, o, u) {
      for (; Pe !== null; ) {
        var h = Pe;
        if ((h.flags & Yr) !== Fe) {
          Mn(h);
          try {
            ij(n, h, o, u);
          } catch (S) {
            An(h, h.return, S);
          }
          Gn();
        }
        if (h === e) {
          Pe = null;
          return;
        }
        var y = h.sibling;
        if (y !== null) {
          y.return = h.return, Pe = y;
          return;
        }
        Pe = h.return;
      }
    }
    function ij(e, n, o, u) {
      switch (n.tag) {
        case x:
        case Se:
        case Ge: {
          if (n.mode & Yt) {
            OE();
            try {
              ef(Lr | Zi, n);
            } finally {
              PE(n);
            }
          } else
            ef(Lr | Zi, n);
          break;
        }
      }
    }
    function rj(e) {
      Pe = e, aj();
    }
    function aj() {
      for (; Pe !== null; ) {
        var e = Pe, n = e.child;
        if ((Pe.flags & Ha) !== Fe) {
          var o = e.deletions;
          if (o !== null) {
            for (var u = 0; u < o.length; u++) {
              var h = o[u];
              Pe = h, lj(h, e);
            }
            {
              var y = e.alternate;
              if (y !== null) {
                var S = y.child;
                if (S !== null) {
                  y.child = null;
                  do {
                    var w = S.sibling;
                    S.sibling = null, S = w;
                  } while (S !== null);
                }
              }
            }
            Pe = e;
          }
        }
        (e.subtreeFlags & ko) !== Fe && n !== null ? (n.return = e, Pe = n) : sj();
      }
    }
    function sj() {
      for (; Pe !== null; ) {
        var e = Pe;
        (e.flags & Yr) !== Fe && (Mn(e), oj(e), Gn());
        var n = e.sibling;
        if (n !== null) {
          n.return = e.return, Pe = n;
          return;
        }
        Pe = e.return;
      }
    }
    function oj(e) {
      switch (e.tag) {
        case x:
        case Se:
        case Ge: {
          e.mode & Yt ? (OE(), Ho(Lr | Zi, e, e.return), PE(e)) : Ho(Lr | Zi, e, e.return);
          break;
        }
      }
    }
    function lj(e, n) {
      for (; Pe !== null; ) {
        var o = Pe;
        Mn(o), cj(o, n), Gn();
        var u = o.child;
        u !== null ? (u.return = o, Pe = u) : uj(e);
      }
    }
    function uj(e) {
      for (; Pe !== null; ) {
        var n = Pe, o = n.sibling, u = n.return;
        if (AL(n), n === e) {
          Pe = null;
          return;
        }
        if (o !== null) {
          o.return = u, Pe = o;
          return;
        }
        Pe = u;
      }
    }
    function cj(e, n) {
      switch (e.tag) {
        case x:
        case Se:
        case Ge: {
          e.mode & Yt ? (OE(), Ho(Lr, e, n), PE(e)) : Ho(Lr, e, n);
          break;
        }
      }
    }
    function dj(e) {
      switch (e.tag) {
        case x:
        case Se:
        case Ge: {
          try {
            ef(Xi | Zi, e);
          } catch (o) {
            An(e, e.return, o);
          }
          break;
        }
        case $: {
          var n = e.stateNode;
          try {
            n.componentDidMount();
          } catch (o) {
            An(e, e.return, o);
          }
          break;
        }
      }
    }
    function fj(e) {
      switch (e.tag) {
        case x:
        case Se:
        case Ge: {
          try {
            ef(Lr | Zi, e);
          } catch (n) {
            An(e, e.return, n);
          }
          break;
        }
      }
    }
    function hj(e) {
      switch (e.tag) {
        case x:
        case Se:
        case Ge: {
          try {
            Ho(Xi | Zi, e, e.return);
          } catch (o) {
            An(e, e.return, o);
          }
          break;
        }
        case $: {
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && f4(e, e.return, n);
          break;
        }
      }
    }
    function pj(e) {
      switch (e.tag) {
        case x:
        case Se:
        case Ge:
          try {
            Ho(Lr | Zi, e, e.return);
          } catch (n) {
            An(e, e.return, n);
          }
      }
    }
    if (typeof Symbol == "function" && Symbol.for) {
      var j6 = Symbol.for;
      j6("selector.component"), j6("selector.has_pseudo_class"), j6("selector.role"), j6("selector.test_id"), j6("selector.text");
    }
    var mj = [];
    function vj() {
      mj.forEach(function(e) {
        return e();
      });
    }
    var yj = t.ReactCurrentActQueue;
    function gj(e) {
      {
        var n = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        ), o = typeof jest < "u";
        return o && n !== !1;
      }
    }
    function FL() {
      {
        var e = (
          // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
          typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
        );
        return !e && yj.current !== null && g("The current testing environment is not configured to support act(...)"), e;
      }
    }
    var Cj = Math.ceil, v4 = t.ReactCurrentDispatcher, y4 = t.ReactCurrentOwner, Ar = t.ReactCurrentBatchConfig, Bo = t.ReactCurrentActQueue, tr = (
      /*             */
      0
    ), IL = (
      /*               */
      1
    ), Pr = (
      /*                */
      2
    ), io = (
      /*                */
      4
    ), vc = 0, G6 = 1, Op = 2, kb = 3, Q6 = 4, BL = 5, g4 = 6, Vt = tr, wa = null, ni = null, nr = ie, jl = ie, C4 = jd(ie), ir = vc, Y6 = null, xb = ie, W6 = ie, Rb = ie, K6 = null, Xa = null, S4 = 0, qL = 500, jL = 1 / 0, Sj = 500, yc = null;
    function Z6() {
      jL = Ei() + Sj;
    }
    function GL() {
      return jL;
    }
    var Lb = !1, b4 = null, Xy = null, _p = !1, nf = null, X6 = ie, w4 = [], T4 = null, bj = 50, J6 = 0, E4 = null, k4 = !1, $b = !1, wj = 50, Jy = 0, Db = null, e2 = kn, Mb = ie, QL = !1;
    function Ab() {
      return wa;
    }
    function Ta() {
      return (Vt & (Pr | io)) !== tr ? Ei() : (e2 !== kn || (e2 = Ei()), e2);
    }
    function rf(e) {
      var n = e.mode;
      if ((n & Tt) === Ie)
        return tt;
      if ((Vt & Pr) !== tr && nr !== ie)
        return np(nr);
      var o = yB() !== vB;
      if (o) {
        if (Ar.transition !== null) {
          var u = Ar.transition;
          u._updatedFibers || (u._updatedFibers = /* @__PURE__ */ new Set()), u._updatedFibers.add(e);
        }
        return Mb === Ft && (Mb = I3()), Mb;
      }
      var h = Qa();
      if (h !== Ft)
        return h;
      var y = tI();
      return y;
    }
    function Tj(e) {
      var n = e.mode;
      return (n & Tt) === Ie ? tt : UC();
    }
    function rr(e, n, o, u) {
      Qj(), QL && g("useInsertionEffect must not schedule updates."), k4 && ($b = !0), Od(e, o, u), (Vt & Pr) !== ie && e === wa ? Kj(n) : (Xr && ap(e, n, o), Zj(n), e === wa && ((Vt & Pr) === tr && (W6 = yt(W6, o)), ir === Q6 && af(e, nr)), Ja(e, u), o === tt && Vt === tr && (n.mode & Tt) === Ie && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
      !Bo.isBatchingLegacy && (Z6(), Qx()));
    }
    function Ej(e, n, o) {
      var u = e.current;
      u.lanes = n, Od(e, n, o), Ja(e, o);
    }
    function kj(e) {
      return (
        // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
        // decided not to enable it.
        (Vt & Pr) !== tr
      );
    }
    function Ja(e, n) {
      var o = e.callbackNode;
      oy(e, n);
      var u = sy(e, e === wa ? nr : ie);
      if (u === ie) {
        o !== null && u$(o), e.callbackNode = null, e.callbackPriority = Ft;
        return;
      }
      var h = $l(u), y = e.callbackPriority;
      if (y === h && // Special case related to `act`. If the currently scheduled task is a
      // Scheduler task, rather than an `act` task, cancel it and re-scheduled
      // on the `act` queue.
      !(Bo.current !== null && o !== A4)) {
        o == null && y !== tt && g("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
        return;
      }
      o != null && u$(o);
      var S;
      if (h === tt)
        e.tag === Gd ? (Bo.isBatchingLegacy !== null && (Bo.didScheduleLegacyUpdate = !0), JI(KL.bind(null, e))) : Gx(KL.bind(null, e)), Bo.current !== null ? Bo.current.push(Qd) : iI(function() {
          (Vt & (Pr | io)) === tr && Qd();
        }), S = null;
      else {
        var w;
        switch (jC(u)) {
          case wr:
            w = Ih;
            break;
          case Qs:
            w = kl;
            break;
          case ja:
            w = xo;
            break;
          case Ga:
            w = ju;
            break;
          default:
            w = xo;
            break;
        }
        S = P4(w, YL.bind(null, e));
      }
      e.callbackPriority = h, e.callbackNode = S;
    }
    function YL(e, n) {
      if (BB(), e2 = kn, Mb = ie, (Vt & (Pr | io)) !== tr)
        throw new Error("Should not already be working.");
      var o = e.callbackNode, u = Cc();
      if (u && e.callbackNode !== o)
        return null;
      var h = sy(e, e === wa ? nr : ie);
      if (h === ie)
        return null;
      var y = !uy(e, h) && !VC(e, h) && !n, S = y ? _j(e, h) : Ob(e, h);
      if (S !== vc) {
        if (S === Op) {
          var w = ly(e);
          w !== ie && (h = w, S = x4(e, w));
        }
        if (S === G6) {
          var E = Y6;
          throw Np(e, ie), af(e, h), Ja(e, Ei()), E;
        }
        if (S === g4)
          af(e, h);
        else {
          var D = !uy(e, h), M = e.current.alternate;
          if (D && !Rj(M)) {
            if (S = Ob(e, h), S === Op) {
              var H = ly(e);
              H !== ie && (h = H, S = x4(e, H));
            }
            if (S === G6) {
              var V = Y6;
              throw Np(e, ie), af(e, h), Ja(e, Ei()), V;
            }
          }
          e.finishedWork = M, e.finishedLanes = h, xj(e, S, h);
        }
      }
      return Ja(e, Ei()), e.callbackNode === o ? YL.bind(null, e) : null;
    }
    function x4(e, n) {
      var o = K6;
      if (fy(e)) {
        var u = Np(e, n);
        u.flags |= Qr, GI(e.containerInfo);
      }
      var h = Ob(e, n);
      if (h !== Op) {
        var y = Xa;
        Xa = o, y !== null && WL(y);
      }
      return h;
    }
    function WL(e) {
      Xa === null ? Xa = e : Xa.push.apply(Xa, e);
    }
    function xj(e, n, o) {
      switch (n) {
        case vc:
        case G6:
          throw new Error("Root did not complete. This is a bug in React.");
        // Flow knows about invariant, so it complains if I add a break
        // statement, but eslint doesn't know about invariant, so it complains
        // if I do. eslint-disable-next-line no-fallthrough
        case Op: {
          Vp(e, Xa, yc);
          break;
        }
        case kb: {
          if (af(e, o), nc(o) && // do not delay if we're inside an act() scope
          !c$()) {
            var u = S4 + qL - Ei();
            if (u > 10) {
              var h = sy(e, ie);
              if (h !== ie)
                break;
              var y = e.suspendedLanes;
              if (!ic(y, o)) {
                Ta(), cy(e, y);
                break;
              }
              e.timeoutHandle = TT(Vp.bind(null, e, Xa, yc), u);
              break;
            }
          }
          Vp(e, Xa, yc);
          break;
        }
        case Q6: {
          if (af(e, o), H3(o))
            break;
          if (!c$()) {
            var S = ys(e, o), w = S, E = Ei() - w, D = Gj(E) - E;
            if (D > 10) {
              e.timeoutHandle = TT(Vp.bind(null, e, Xa, yc), D);
              break;
            }
          }
          Vp(e, Xa, yc);
          break;
        }
        case BL: {
          Vp(e, Xa, yc);
          break;
        }
        default:
          throw new Error("Unknown root exit status.");
      }
    }
    function Rj(e) {
      for (var n = e; ; ) {
        if (n.flags & $d) {
          var o = n.updateQueue;
          if (o !== null) {
            var u = o.stores;
            if (u !== null)
              for (var h = 0; h < u.length; h++) {
                var y = u[h], S = y.getSnapshot, w = y.value;
                try {
                  if (!be(S(), w))
                    return !1;
                } catch {
                  return !1;
                }
              }
          }
        }
        var E = n.child;
        if (n.subtreeFlags & $d && E !== null) {
          E.return = n, n = E;
          continue;
        }
        if (n === e)
          return !0;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === e)
            return !0;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      return !0;
    }
    function af(e, n) {
      n = ip(n, Rb), n = ip(n, W6), FC(e, n);
    }
    function KL(e) {
      if (qB(), (Vt & (Pr | io)) !== tr)
        throw new Error("Should not already be working.");
      Cc();
      var n = sy(e, ie);
      if (!Jr(n, tt))
        return Ja(e, Ei()), null;
      var o = Ob(e, n);
      if (e.tag !== Gd && o === Op) {
        var u = ly(e);
        u !== ie && (n = u, o = x4(e, u));
      }
      if (o === G6) {
        var h = Y6;
        throw Np(e, ie), af(e, n), Ja(e, Ei()), h;
      }
      if (o === g4)
        throw new Error("Root did not complete. This is a bug in React.");
      var y = e.current.alternate;
      return e.finishedWork = y, e.finishedLanes = n, Vp(e, Xa, yc), Ja(e, Ei()), null;
    }
    function Lj(e, n) {
      n !== ie && (dy(e, yt(n, tt)), Ja(e, Ei()), (Vt & (Pr | io)) === tr && (Z6(), Qd()));
    }
    function R4(e, n) {
      var o = Vt;
      Vt |= IL;
      try {
        return e(n);
      } finally {
        Vt = o, Vt === tr && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !Bo.isBatchingLegacy && (Z6(), Qx());
      }
    }
    function $j(e, n, o, u, h) {
      var y = Qa(), S = Ar.transition;
      try {
        return Ar.transition = null, fi(wr), e(n, o, u, h);
      } finally {
        fi(y), Ar.transition = S, Vt === tr && Z6();
      }
    }
    function gc(e) {
      nf !== null && nf.tag === Gd && (Vt & (Pr | io)) === tr && Cc();
      var n = Vt;
      Vt |= IL;
      var o = Ar.transition, u = Qa();
      try {
        return Ar.transition = null, fi(wr), e ? e() : void 0;
      } finally {
        fi(u), Ar.transition = o, Vt = n, (Vt & (Pr | io)) === tr && Qd();
      }
    }
    function ZL() {
      return (Vt & (Pr | io)) !== tr;
    }
    function Pb(e, n) {
      ra(C4, jl, e), jl = yt(jl, n);
    }
    function L4(e) {
      jl = C4.current, ia(C4, e);
    }
    function Np(e, n) {
      e.finishedWork = null, e.finishedLanes = ie;
      var o = e.timeoutHandle;
      if (o !== ET && (e.timeoutHandle = ET, nI(o)), ni !== null)
        for (var u = ni.return; u !== null; ) {
          var h = u.alternate;
          xL(h, u), u = u.return;
        }
      wa = e;
      var y = Up(e.current, null);
      return ni = y, nr = jl = n, ir = vc, Y6 = null, xb = ie, W6 = ie, Rb = ie, K6 = null, Xa = null, EB(), _o.discardPendingWarnings(), y;
    }
    function XL(e, n) {
      do {
        var o = ni;
        try {
          if (BS(), wR(), Gn(), y4.current = null, o === null || o.return === null) {
            ir = G6, Y6 = n, ni = null;
            return;
          }
          if (ri && o.mode & Yt && gb(o, !0), ur)
            if (ya(), n !== null && typeof n == "object" && typeof n.then == "function") {
              var u = n;
              Gs(o, u, nr);
            } else
              qh(o, n, nr);
          JB(e, o.return, o, n, nr), n$(o);
        } catch (h) {
          n = h, ni === o && o !== null ? (o = o.return, ni = o) : o = ni;
          continue;
        }
        return;
      } while (!0);
    }
    function JL() {
      var e = v4.current;
      return v4.current = hb, e === null ? hb : e;
    }
    function e$(e) {
      v4.current = e;
    }
    function Dj() {
      S4 = Ei();
    }
    function t2(e) {
      xb = yt(e, xb);
    }
    function Mj() {
      ir === vc && (ir = kb);
    }
    function $4() {
      (ir === vc || ir === kb || ir === Op) && (ir = Q6), wa !== null && (tp(xb) || tp(W6)) && af(wa, nr);
    }
    function Aj(e) {
      ir !== Q6 && (ir = Op), K6 === null ? K6 = [e] : K6.push(e);
    }
    function Pj() {
      return ir === vc;
    }
    function Ob(e, n) {
      var o = Vt;
      Vt |= Pr;
      var u = JL();
      if (wa !== e || nr !== n) {
        if (Xr) {
          var h = e.memoizedUpdaters;
          h.size > 0 && (n2(e, nr), h.clear()), IC(e, n);
        }
        yc = G3(), Np(e, n);
      }
      Wu(n);
      do
        try {
          Oj();
          break;
        } catch (y) {
          XL(e, y);
        }
      while (!0);
      if (BS(), Vt = o, e$(u), ni !== null)
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
      return Iv(), wa = null, nr = ie, ir;
    }
    function Oj() {
      for (; ni !== null; )
        t$(ni);
    }
    function _j(e, n) {
      var o = Vt;
      Vt |= Pr;
      var u = JL();
      if (wa !== e || nr !== n) {
        if (Xr) {
          var h = e.memoizedUpdaters;
          h.size > 0 && (n2(e, nr), h.clear()), IC(e, n);
        }
        yc = G3(), Z6(), Np(e, n);
      }
      Wu(n);
      do
        try {
          Nj();
          break;
        } catch (y) {
          XL(e, y);
        }
      while (!0);
      return BS(), e$(u), Vt = o, ni !== null ? (PC(), vc) : (Iv(), wa = null, nr = ie, ir);
    }
    function Nj() {
      for (; ni !== null && !k3(); )
        t$(ni);
    }
    function t$(e) {
      var n = e.alternate;
      Mn(e);
      var o;
      (e.mode & Yt) !== Ie ? (AE(e), o = D4(n, e, jl), gb(e, !0)) : o = D4(n, e, jl), Gn(), e.memoizedProps = e.pendingProps, o === null ? n$(e) : ni = o, y4.current = null;
    }
    function n$(e) {
      var n = e;
      do {
        var o = n.alternate, u = n.return;
        if ((n.flags & Fh) === Fe) {
          Mn(n);
          var h = void 0;
          if ((n.mode & Yt) === Ie ? h = kL(o, n, jl) : (AE(n), h = kL(o, n, jl), gb(n, !1)), Gn(), h !== null) {
            ni = h;
            return;
          }
        } else {
          var y = Mq(o, n);
          if (y !== null) {
            y.flags &= RC, ni = y;
            return;
          }
          if ((n.mode & Yt) !== Ie) {
            gb(n, !1);
            for (var S = n.actualDuration, w = n.child; w !== null; )
              S += w.actualDuration, w = w.sibling;
            n.actualDuration = S;
          }
          if (u !== null)
            u.flags |= Fh, u.subtreeFlags = Fe, u.deletions = null;
          else {
            ir = g4, ni = null;
            return;
          }
        }
        var E = n.sibling;
        if (E !== null) {
          ni = E;
          return;
        }
        n = u, ni = n;
      } while (n !== null);
      ir === vc && (ir = BL);
    }
    function Vp(e, n, o) {
      var u = Qa(), h = Ar.transition;
      try {
        Ar.transition = null, fi(wr), Vj(e, n, o, u);
      } finally {
        Ar.transition = h, fi(u);
      }
      return null;
    }
    function Vj(e, n, o, u) {
      do
        Cc();
      while (nf !== null);
      if (Yj(), (Vt & (Pr | io)) !== tr)
        throw new Error("Should not already be working.");
      var h = e.finishedWork, y = e.finishedLanes;
      if (M3(y), h === null)
        return A3(), null;
      if (y === ie && g("root.finishedLanes should not be empty during a commit. This is a bug in React."), e.finishedWork = null, e.finishedLanes = ie, h === e.current)
        throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
      e.callbackNode = null, e.callbackPriority = Ft;
      var S = yt(h.lanes, h.childLanes);
      q3(e, S), e === wa && (wa = null, ni = null, nr = ie), ((h.subtreeFlags & ko) !== Fe || (h.flags & ko) !== Fe) && (_p || (_p = !0, T4 = o, P4(xo, function() {
        return Cc(), null;
      })));
      var w = (h.subtreeFlags & (wl | Tl | El | ko)) !== Fe, E = (h.flags & (wl | Tl | El | ko)) !== Fe;
      if (w || E) {
        var D = Ar.transition;
        Ar.transition = null;
        var M = Qa();
        fi(wr);
        var H = Vt;
        Vt |= io, y4.current = null, Nq(e, h), QR(), Kq(e, h, y), WF(e.containerInfo), e.current = h, jh(y), Zq(h, e, y), Gh(), x3(), Vt = H, fi(M), Ar.transition = D;
      } else
        e.current = h, QR();
      var V = _p;
      if (_p ? (_p = !1, nf = e, X6 = y) : (Jy = 0, Db = null), S = e.pendingLanes, S === ie && (Xy = null), V || s$(e.current, !1), L3(h.stateNode, u), Xr && e.memoizedUpdaters.clear(), vj(), Ja(e, Ei()), n !== null)
        for (var Q = e.onRecoverableError, W = 0; W < n.length; W++) {
          var X = n[W], Ce = X.stack, Qe = X.digest;
          Q(X.value, {
            componentStack: Ce,
            digest: Qe
          });
        }
      if (Lb) {
        Lb = !1;
        var Ue = b4;
        throw b4 = null, Ue;
      }
      return Jr(X6, tt) && e.tag !== Gd && Cc(), S = e.pendingLanes, Jr(S, tt) ? (IB(), e === E4 ? J6++ : (J6 = 0, E4 = e)) : J6 = 0, Qd(), A3(), null;
    }
    function Cc() {
      if (nf !== null) {
        var e = jC(X6), n = op(ja, e), o = Ar.transition, u = Qa();
        try {
          return Ar.transition = null, fi(n), zj();
        } finally {
          fi(u), Ar.transition = o;
        }
      }
      return !1;
    }
    function Uj(e) {
      w4.push(e), _p || (_p = !0, P4(xo, function() {
        return Cc(), null;
      }));
    }
    function zj() {
      if (nf === null)
        return !1;
      var e = T4;
      T4 = null;
      var n = nf, o = X6;
      if (nf = null, X6 = ie, (Vt & (Pr | io)) !== tr)
        throw new Error("Cannot flush passive effects while already rendering.");
      k4 = !0, $b = !1, Yu(o);
      var u = Vt;
      Vt |= io, rj(n.current), ej(n, n.current, o, e);
      {
        var h = w4;
        w4 = [];
        for (var y = 0; y < h.length; y++) {
          var S = h[y];
          Hq(n, S);
        }
      }
      _3(), s$(n.current, !0), Vt = u, Qd(), $b ? n === Db ? Jy++ : (Jy = 0, Db = n) : Jy = 0, k4 = !1, $b = !1, $3(n);
      {
        var w = n.current.stateNode;
        w.effectDuration = 0, w.passiveEffectDuration = 0;
      }
      return !0;
    }
    function i$(e) {
      return Xy !== null && Xy.has(e);
    }
    function Hj(e) {
      Xy === null ? Xy = /* @__PURE__ */ new Set([e]) : Xy.add(e);
    }
    function Fj(e) {
      Lb || (Lb = !0, b4 = e);
    }
    var Ij = Fj;
    function r$(e, n, o) {
      var u = Ap(o, n), h = tL(e, u, tt), y = Wd(e, h, tt), S = Ta();
      y !== null && (Od(y, tt, S), Ja(y, S));
    }
    function An(e, n, o) {
      if (Pq(o), i2(!1), e.tag === A) {
        r$(e, e, o);
        return;
      }
      var u = null;
      for (u = n; u !== null; ) {
        if (u.tag === A) {
          r$(u, e, o);
          return;
        } else if (u.tag === $) {
          var h = u.type, y = u.stateNode;
          if (typeof h.getDerivedStateFromError == "function" || typeof y.componentDidCatch == "function" && !i$(y)) {
            var S = Ap(o, e), w = KE(u, S, tt), E = Wd(u, w, tt), D = Ta();
            E !== null && (Od(E, tt, D), Ja(E, D));
            return;
          }
        }
        u = u.return;
      }
      g(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, o);
    }
    function Bj(e, n, o) {
      var u = e.pingCache;
      u !== null && u.delete(n);
      var h = Ta();
      cy(e, o), Xj(e), wa === e && ic(nr, o) && (ir === Q6 || ir === kb && nc(nr) && Ei() - S4 < qL ? Np(e, ie) : Rb = yt(Rb, o)), Ja(e, h);
    }
    function a$(e, n) {
      n === Ft && (n = Tj(e));
      var o = Ta(), u = Ka(e, n);
      u !== null && (Od(u, n, o), Ja(u, o));
    }
    function qj(e) {
      var n = e.memoizedState, o = Ft;
      n !== null && (o = n.retryLane), a$(e, o);
    }
    function jj(e, n) {
      var o = Ft, u;
      switch (e.tag) {
        case Me:
          u = e.stateNode;
          var h = e.memoizedState;
          h !== null && (o = h.retryLane);
          break;
        case Gt:
          u = e.stateNode;
          break;
        default:
          throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
      }
      u !== null && u.delete(n), a$(e, o);
    }
    function Gj(e) {
      return e < 120 ? 120 : e < 480 ? 480 : e < 1080 ? 1080 : e < 1920 ? 1920 : e < 3e3 ? 3e3 : e < 4320 ? 4320 : Cj(e / 1960) * 1960;
    }
    function Qj() {
      if (J6 > bj)
        throw J6 = 0, E4 = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
      Jy > wj && (Jy = 0, Db = null, g("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
    }
    function Yj() {
      _o.flushLegacyContextWarning(), _o.flushPendingUnsafeLifecycleWarnings();
    }
    function s$(e, n) {
      Mn(e), _b(e, bl, hj), n && _b(e, Bs, pj), _b(e, bl, dj), n && _b(e, Bs, fj), Gn();
    }
    function _b(e, n, o) {
      for (var u = e, h = null; u !== null; ) {
        var y = u.subtreeFlags & n;
        u !== h && u.child !== null && y !== Fe ? u = u.child : ((u.flags & n) !== Fe && o(u), u.sibling !== null ? u = u.sibling : u = h = u.return);
      }
    }
    var Nb = null;
    function o$(e) {
      {
        if ((Vt & Pr) !== tr || !(e.mode & Tt))
          return;
        var n = e.tag;
        if (n !== P && n !== A && n !== $ && n !== x && n !== Se && n !== Ct && n !== Ge)
          return;
        var o = vt(e) || "ReactComponent";
        if (Nb !== null) {
          if (Nb.has(o))
            return;
          Nb.add(o);
        } else
          Nb = /* @__PURE__ */ new Set([o]);
        var u = br;
        try {
          Mn(e), g("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally {
          u ? Mn(e) : Gn();
        }
      }
    }
    var D4;
    {
      var Wj = null;
      D4 = function(e, n, o) {
        var u = m$(Wj, n);
        try {
          return SL(e, n, o);
        } catch (y) {
          if (oB() || y !== null && typeof y == "object" && typeof y.then == "function")
            throw y;
          if (BS(), wR(), xL(e, n), m$(n, u), n.mode & Yt && AE(n), Sl(null, SL, null, e, n, o), To()) {
            var h = Hh();
            typeof h == "object" && h !== null && h._suppressLogging && typeof y == "object" && y !== null && !y._suppressLogging && (y._suppressLogging = !0);
          }
          throw y;
        }
      };
    }
    var l$ = !1, M4;
    M4 = /* @__PURE__ */ new Set();
    function Kj(e) {
      if (pl && !zB())
        switch (e.tag) {
          case x:
          case Se:
          case Ge: {
            var n = ni && vt(ni) || "Unknown", o = n;
            if (!M4.has(o)) {
              M4.add(o);
              var u = vt(e) || "Unknown";
              g("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", u, n, n);
            }
            break;
          }
          case $: {
            l$ || (g("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), l$ = !0);
            break;
          }
        }
    }
    function n2(e, n) {
      if (Xr) {
        var o = e.memoizedUpdaters;
        o.forEach(function(u) {
          ap(e, u, n);
        });
      }
    }
    var A4 = {};
    function P4(e, n) {
      {
        var o = Bo.current;
        return o !== null ? (o.push(n), A4) : E3(e, n);
      }
    }
    function u$(e) {
      if (e !== A4)
        return $C(e);
    }
    function c$() {
      return Bo.current !== null;
    }
    function Zj(e) {
      {
        if (e.mode & Tt) {
          if (!FL())
            return;
        } else if (!gj() || Vt !== tr || e.tag !== x && e.tag !== Se && e.tag !== Ge)
          return;
        if (Bo.current === null) {
          var n = br;
          try {
            Mn(e), g(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, vt(e));
          } finally {
            n ? Mn(e) : Gn();
          }
        }
      }
    }
    function Xj(e) {
      e.tag !== Gd && FL() && Bo.current === null && g(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
    }
    function i2(e) {
      QL = e;
    }
    var ro = null, eg = null, Jj = function(e) {
      ro = e;
    };
    function tg(e) {
      {
        if (ro === null)
          return e;
        var n = ro(e);
        return n === void 0 ? e : n.current;
      }
    }
    function O4(e) {
      return tg(e);
    }
    function _4(e) {
      {
        if (ro === null)
          return e;
        var n = ro(e);
        if (n === void 0) {
          if (e != null && typeof e.render == "function") {
            var o = tg(e.render);
            if (e.render !== o) {
              var u = {
                $$typeof: md,
                render: o
              };
              return e.displayName !== void 0 && (u.displayName = e.displayName), u;
            }
          }
          return e;
        }
        return n.current;
      }
    }
    function d$(e, n) {
      {
        if (ro === null)
          return !1;
        var o = e.elementType, u = n.type, h = !1, y = typeof u == "object" && u !== null ? u.$$typeof : null;
        switch (e.tag) {
          case $: {
            typeof u == "function" && (h = !0);
            break;
          }
          case x: {
            (typeof u == "function" || y === cr) && (h = !0);
            break;
          }
          case Se: {
            (y === md || y === cr) && (h = !0);
            break;
          }
          case Ct:
          case Ge: {
            (y === cs || y === cr) && (h = !0);
            break;
          }
          default:
            return !1;
        }
        if (h) {
          var S = ro(o);
          if (S !== void 0 && S === ro(u))
            return !0;
        }
        return !1;
      }
    }
    function f$(e) {
      {
        if (ro === null || typeof WeakSet != "function")
          return;
        eg === null && (eg = /* @__PURE__ */ new WeakSet()), eg.add(e);
      }
    }
    var eG = function(e, n) {
      {
        if (ro === null)
          return;
        var o = n.staleFamilies, u = n.updatedFamilies;
        Cc(), gc(function() {
          N4(e.current, u, o);
        });
      }
    }, tG = function(e, n) {
      {
        if (e.context !== Ss)
          return;
        Cc(), gc(function() {
          r2(n, e, null, null);
        });
      }
    };
    function N4(e, n, o) {
      {
        var u = e.alternate, h = e.child, y = e.sibling, S = e.tag, w = e.type, E = null;
        switch (S) {
          case x:
          case Ge:
          case $:
            E = w;
            break;
          case Se:
            E = w.render;
            break;
        }
        if (ro === null)
          throw new Error("Expected resolveFamily to be set during hot reload.");
        var D = !1, M = !1;
        if (E !== null) {
          var H = ro(E);
          H !== void 0 && (o.has(H) ? M = !0 : n.has(H) && (S === $ ? M = !0 : D = !0));
        }
        if (eg !== null && (eg.has(e) || u !== null && eg.has(u)) && (M = !0), M && (e._debugNeedsRemount = !0), M || D) {
          var V = Ka(e, tt);
          V !== null && rr(V, e, tt, kn);
        }
        h !== null && !M && N4(h, n, o), y !== null && N4(y, n, o);
      }
    }
    var nG = function(e, n) {
      {
        var o = /* @__PURE__ */ new Set(), u = new Set(n.map(function(h) {
          return h.current;
        }));
        return V4(e.current, u, o), o;
      }
    };
    function V4(e, n, o) {
      {
        var u = e.child, h = e.sibling, y = e.tag, S = e.type, w = null;
        switch (y) {
          case x:
          case Ge:
          case $:
            w = S;
            break;
          case Se:
            w = S.render;
            break;
        }
        var E = !1;
        w !== null && n.has(w) && (E = !0), E ? iG(e, o) : u !== null && V4(u, n, o), h !== null && V4(h, n, o);
      }
    }
    function iG(e, n) {
      {
        var o = rG(e, n);
        if (o)
          return;
        for (var u = e; ; ) {
          switch (u.tag) {
            case F:
              n.add(u.stateNode);
              return;
            case U:
              n.add(u.stateNode.containerInfo);
              return;
            case A:
              n.add(u.stateNode.containerInfo);
              return;
          }
          if (u.return === null)
            throw new Error("Expected to reach root first.");
          u = u.return;
        }
      }
    }
    function rG(e, n) {
      for (var o = e, u = !1; ; ) {
        if (o.tag === F)
          u = !0, n.add(o.stateNode);
        else if (o.child !== null) {
          o.child.return = o, o = o.child;
          continue;
        }
        if (o === e)
          return u;
        for (; o.sibling === null; ) {
          if (o.return === null || o.return === e)
            return u;
          o = o.return;
        }
        o.sibling.return = o.return, o = o.sibling;
      }
      return !1;
    }
    var U4;
    {
      U4 = !1;
      try {
        var h$ = Object.preventExtensions({});
      } catch {
        U4 = !0;
      }
    }
    function aG(e, n, o, u) {
      this.tag = e, this.key = o, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = n, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = u, this.flags = Fe, this.subtreeFlags = Fe, this.deletions = null, this.lanes = ie, this.childLanes = ie, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !U4 && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
    }
    var bs = function(e, n, o, u) {
      return new aG(e, n, o, u);
    };
    function z4(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function sG(e) {
      return typeof e == "function" && !z4(e) && e.defaultProps === void 0;
    }
    function oG(e) {
      if (typeof e == "function")
        return z4(e) ? $ : x;
      if (e != null) {
        var n = e.$$typeof;
        if (n === md)
          return Se;
        if (n === cs)
          return Ct;
      }
      return P;
    }
    function Up(e, n) {
      var o = e.alternate;
      o === null ? (o = bs(e.tag, n, e.key, e.mode), o.elementType = e.elementType, o.type = e.type, o.stateNode = e.stateNode, o._debugSource = e._debugSource, o._debugOwner = e._debugOwner, o._debugHookTypes = e._debugHookTypes, o.alternate = e, e.alternate = o) : (o.pendingProps = n, o.type = e.type, o.flags = Fe, o.subtreeFlags = Fe, o.deletions = null, o.actualDuration = 0, o.actualStartTime = -1), o.flags = e.flags & ui, o.childLanes = e.childLanes, o.lanes = e.lanes, o.child = e.child, o.memoizedProps = e.memoizedProps, o.memoizedState = e.memoizedState, o.updateQueue = e.updateQueue;
      var u = e.dependencies;
      switch (o.dependencies = u === null ? null : {
        lanes: u.lanes,
        firstContext: u.firstContext
      }, o.sibling = e.sibling, o.index = e.index, o.ref = e.ref, o.selfBaseDuration = e.selfBaseDuration, o.treeBaseDuration = e.treeBaseDuration, o._debugNeedsRemount = e._debugNeedsRemount, o.tag) {
        case P:
        case x:
        case Ge:
          o.type = tg(e.type);
          break;
        case $:
          o.type = O4(e.type);
          break;
        case Se:
          o.type = _4(e.type);
          break;
      }
      return o;
    }
    function lG(e, n) {
      e.flags &= ui | Kn;
      var o = e.alternate;
      if (o === null)
        e.childLanes = ie, e.lanes = n, e.child = null, e.subtreeFlags = Fe, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null, e.selfBaseDuration = 0, e.treeBaseDuration = 0;
      else {
        e.childLanes = o.childLanes, e.lanes = o.lanes, e.child = o.child, e.subtreeFlags = Fe, e.deletions = null, e.memoizedProps = o.memoizedProps, e.memoizedState = o.memoizedState, e.updateQueue = o.updateQueue, e.type = o.type;
        var u = o.dependencies;
        e.dependencies = u === null ? null : {
          lanes: u.lanes,
          firstContext: u.firstContext
        }, e.selfBaseDuration = o.selfBaseDuration, e.treeBaseDuration = o.treeBaseDuration;
      }
      return e;
    }
    function uG(e, n, o) {
      var u;
      return e === PS ? (u = Tt, n === !0 && (u |= mn, u |= Wt)) : u = Ie, Xr && (u |= Yt), bs(A, null, null, u);
    }
    function H4(e, n, o, u, h, y) {
      var S = P, w = e;
      if (typeof e == "function")
        z4(e) ? (S = $, w = O4(w)) : w = tg(w);
      else if (typeof e == "string")
        S = F;
      else
        e: switch (e) {
          case fd:
            return sf(o.children, h, y, n);
          case $u:
            S = ce, h |= mn, (h & Tt) !== Ie && (h |= Wt);
            break;
          case hd:
            return cG(o, h, y, n);
          case ov:
            return dG(o, h, y, n);
          case lv:
            return fG(o, h, y, n);
          case B1:
            return p$(o, h, y, n);
          case B0:
          // eslint-disable-next-line no-fallthrough
          case I0:
          // eslint-disable-next-line no-fallthrough
          case q0:
          // eslint-disable-next-line no-fallthrough
          case j0:
          // eslint-disable-next-line no-fallthrough
          case Tw:
          // eslint-disable-next-line no-fallthrough
          default: {
            if (typeof e == "object" && e !== null)
              switch (e.$$typeof) {
                case pd:
                  S = Ne;
                  break e;
                case bh:
                  S = De;
                  break e;
                case md:
                  S = Se, w = _4(w);
                  break e;
                case cs:
                  S = Ct;
                  break e;
                case cr:
                  S = he, w = null;
                  break e;
              }
            var E = "";
            {
              (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (E += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
              var D = u ? vt(u) : null;
              D && (E += `

Check the render method of \`` + D + "`.");
            }
            throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (e == null ? e : typeof e) + "." + E));
          }
        }
      var M = bs(S, o, n, h);
      return M.elementType = e, M.type = w, M.lanes = y, M._debugOwner = u, M;
    }
    function F4(e, n, o) {
      var u = null;
      u = e._owner;
      var h = e.type, y = e.key, S = e.props, w = H4(h, y, S, u, n, o);
      return w._debugSource = e._source, w._debugOwner = e._owner, w;
    }
    function sf(e, n, o, u) {
      var h = bs(ne, e, u, n);
      return h.lanes = o, h;
    }
    function cG(e, n, o, u) {
      typeof e.id != "string" && g('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof e.id);
      var h = bs(je, e, u, n | Yt);
      return h.elementType = hd, h.lanes = o, h.stateNode = {
        effectDuration: 0,
        passiveEffectDuration: 0
      }, h;
    }
    function dG(e, n, o, u) {
      var h = bs(Me, e, u, n);
      return h.elementType = ov, h.lanes = o, h;
    }
    function fG(e, n, o, u) {
      var h = bs(Gt, e, u, n);
      return h.elementType = lv, h.lanes = o, h;
    }
    function p$(e, n, o, u) {
      var h = bs(Ve, e, u, n);
      h.elementType = B1, h.lanes = o;
      var y = {
        isHidden: !1
      };
      return h.stateNode = y, h;
    }
    function I4(e, n, o) {
      var u = bs(Z, e, null, n);
      return u.lanes = o, u;
    }
    function hG() {
      var e = bs(F, null, null, Ie);
      return e.elementType = "DELETED", e;
    }
    function pG(e) {
      var n = bs(pt, null, null, Ie);
      return n.stateNode = e, n;
    }
    function B4(e, n, o) {
      var u = e.children !== null ? e.children : [], h = bs(U, u, e.key, n);
      return h.lanes = o, h.stateNode = {
        containerInfo: e.containerInfo,
        pendingChildren: null,
        // Used by persistent updates
        implementation: e.implementation
      }, h;
    }
    function m$(e, n) {
      return e === null && (e = bs(P, null, null, Ie)), e.tag = n.tag, e.key = n.key, e.elementType = n.elementType, e.type = n.type, e.stateNode = n.stateNode, e.return = n.return, e.child = n.child, e.sibling = n.sibling, e.index = n.index, e.ref = n.ref, e.pendingProps = n.pendingProps, e.memoizedProps = n.memoizedProps, e.updateQueue = n.updateQueue, e.memoizedState = n.memoizedState, e.dependencies = n.dependencies, e.mode = n.mode, e.flags = n.flags, e.subtreeFlags = n.subtreeFlags, e.deletions = n.deletions, e.lanes = n.lanes, e.childLanes = n.childLanes, e.alternate = n.alternate, e.actualDuration = n.actualDuration, e.actualStartTime = n.actualStartTime, e.selfBaseDuration = n.selfBaseDuration, e.treeBaseDuration = n.treeBaseDuration, e._debugSource = n._debugSource, e._debugOwner = n._debugOwner, e._debugNeedsRemount = n._debugNeedsRemount, e._debugHookTypes = n._debugHookTypes, e;
    }
    function mG(e, n, o, u, h) {
      this.tag = n, this.containerInfo = e, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = ET, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Ft, this.eventTimes = rp(ie), this.expirationTimes = rp(kn), this.pendingLanes = ie, this.suspendedLanes = ie, this.pingedLanes = ie, this.expiredLanes = ie, this.mutableReadLanes = ie, this.finishedLanes = ie, this.entangledLanes = ie, this.entanglements = rp(ie), this.identifierPrefix = u, this.onRecoverableError = h, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
      {
        this.memoizedUpdaters = /* @__PURE__ */ new Set();
        for (var y = this.pendingUpdatersLaneMap = [], S = 0; S < Ku; S++)
          y.push(/* @__PURE__ */ new Set());
      }
      switch (n) {
        case PS:
          this._debugRootType = o ? "hydrateRoot()" : "createRoot()";
          break;
        case Gd:
          this._debugRootType = o ? "hydrate()" : "render()";
          break;
      }
    }
    function v$(e, n, o, u, h, y, S, w, E, D) {
      var M = new mG(e, n, o, w, E), H = uG(n, y);
      M.current = H, H.stateNode = M;
      {
        var V = {
          element: u,
          isDehydrated: o,
          cache: null,
          // not enabled yet
          transitions: null,
          pendingSuspenseBoundaries: null
        };
        H.memoizedState = V;
      }
      return nE(H), M;
    }
    var q4 = "18.3.1";
    function vG(e, n, o) {
      var u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
      return ud(u), {
        // This tag allow us to uniquely identify this as a React Portal
        $$typeof: us,
        key: u == null ? null : "" + u,
        children: e,
        containerInfo: n,
        implementation: o
      };
    }
    var j4, G4;
    j4 = !1, G4 = {};
    function y$(e) {
      if (!e)
        return Ss;
      var n = Ld(e), o = XI(n);
      if (n.tag === $) {
        var u = n.type;
        if (Ul(u))
          return qx(n, u, o);
      }
      return o;
    }
    function yG(e, n) {
      {
        var o = Ld(e);
        if (o === void 0) {
          if (typeof e.render == "function")
            throw new Error("Unable to find node on an unmounted component.");
          var u = Object.keys(e).join(",");
          throw new Error("Argument appears to not be a ReactComponent. Keys: " + u);
        }
        var h = Kr(o);
        if (h === null)
          return null;
        if (h.mode & mn) {
          var y = vt(o) || "Component";
          if (!G4[y]) {
            G4[y] = !0;
            var S = br;
            try {
              Mn(h), o.mode & mn ? g("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", n, n, y) : g("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", n, n, y);
            } finally {
              S ? Mn(S) : Gn();
            }
          }
        }
        return h.stateNode;
      }
    }
    function g$(e, n, o, u, h, y, S, w) {
      var E = !1, D = null;
      return v$(e, n, E, D, o, u, h, y, S);
    }
    function C$(e, n, o, u, h, y, S, w, E, D) {
      var M = !0, H = v$(o, u, M, e, h, y, S, w, E);
      H.context = y$(null);
      var V = H.current, Q = Ta(), W = rf(V), X = pc(Q, W);
      return X.callback = n ?? null, Wd(V, X, W), Ej(H, W, Q), H;
    }
    function r2(e, n, o, u) {
      R3(n, e);
      var h = n.current, y = Ta(), S = rf(h);
      zn(S);
      var w = y$(o);
      n.context === null ? n.context = w : n.pendingContext = w, pl && br !== null && !j4 && (j4 = !0, g(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, vt(br) || "Unknown"));
      var E = pc(y, S);
      E.payload = {
        element: e
      }, u = u === void 0 ? null : u, u !== null && (typeof u != "function" && g("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", u), E.callback = u);
      var D = Wd(h, E, S);
      return D !== null && (rr(D, h, S, y), YS(D, h, S)), S;
    }
    function Vb(e) {
      var n = e.current;
      if (!n.child)
        return null;
      switch (n.child.tag) {
        case F:
          return n.child.stateNode;
        default:
          return n.child.stateNode;
      }
    }
    function gG(e) {
      switch (e.tag) {
        case A: {
          var n = e.stateNode;
          if (fy(n)) {
            var o = _C(n);
            Lj(n, o);
          }
          break;
        }
        case Me: {
          gc(function() {
            var h = Ka(e, tt);
            if (h !== null) {
              var y = Ta();
              rr(h, e, tt, y);
            }
          });
          var u = tt;
          Q4(e, u);
          break;
        }
      }
    }
    function S$(e, n) {
      var o = e.memoizedState;
      o !== null && o.dehydrated !== null && (o.retryLane = HC(o.retryLane, n));
    }
    function Q4(e, n) {
      S$(e, n);
      var o = e.alternate;
      o && S$(o, n);
    }
    function CG(e) {
      if (e.tag === Me) {
        var n = Xh, o = Ka(e, n);
        if (o !== null) {
          var u = Ta();
          rr(o, e, n, u);
        }
        Q4(e, n);
      }
    }
    function SG(e) {
      if (e.tag === Me) {
        var n = rf(e), o = Ka(e, n);
        if (o !== null) {
          var u = Ta();
          rr(o, e, n, u);
        }
        Q4(e, n);
      }
    }
    function b$(e) {
      var n = Nn(e);
      return n === null ? null : n.stateNode;
    }
    var w$ = function(e) {
      return null;
    };
    function bG(e) {
      return w$(e);
    }
    var T$ = function(e) {
      return !1;
    };
    function wG(e) {
      return T$(e);
    }
    var E$ = null, k$ = null, x$ = null, R$ = null, L$ = null, $$ = null, D$ = null, M$ = null, A$ = null;
    {
      var P$ = function(e, n, o) {
        var u = n[o], h = Gi(e) ? e.slice() : Pt({}, e);
        return o + 1 === n.length ? (Gi(h) ? h.splice(u, 1) : delete h[u], h) : (h[u] = P$(e[u], n, o + 1), h);
      }, O$ = function(e, n) {
        return P$(e, n, 0);
      }, _$ = function(e, n, o, u) {
        var h = n[u], y = Gi(e) ? e.slice() : Pt({}, e);
        if (u + 1 === n.length) {
          var S = o[u];
          y[S] = y[h], Gi(y) ? y.splice(h, 1) : delete y[h];
        } else
          y[h] = _$(
            // $FlowFixMe number or string is fine here
            e[h],
            n,
            o,
            u + 1
          );
        return y;
      }, N$ = function(e, n, o) {
        if (n.length !== o.length) {
          v("copyWithRename() expects paths of the same length");
          return;
        } else
          for (var u = 0; u < o.length - 1; u++)
            if (n[u] !== o[u]) {
              v("copyWithRename() expects paths to be the same except for the deepest key");
              return;
            }
        return _$(e, n, o, 0);
      }, V$ = function(e, n, o, u) {
        if (o >= n.length)
          return u;
        var h = n[o], y = Gi(e) ? e.slice() : Pt({}, e);
        return y[h] = V$(e[h], n, o + 1, u), y;
      }, U$ = function(e, n, o) {
        return V$(e, n, 0, o);
      }, Y4 = function(e, n) {
        for (var o = e.memoizedState; o !== null && n > 0; )
          o = o.next, n--;
        return o;
      };
      E$ = function(e, n, o, u) {
        var h = Y4(e, n);
        if (h !== null) {
          var y = U$(h.memoizedState, o, u);
          h.memoizedState = y, h.baseState = y, e.memoizedProps = Pt({}, e.memoizedProps);
          var S = Ka(e, tt);
          S !== null && rr(S, e, tt, kn);
        }
      }, k$ = function(e, n, o) {
        var u = Y4(e, n);
        if (u !== null) {
          var h = O$(u.memoizedState, o);
          u.memoizedState = h, u.baseState = h, e.memoizedProps = Pt({}, e.memoizedProps);
          var y = Ka(e, tt);
          y !== null && rr(y, e, tt, kn);
        }
      }, x$ = function(e, n, o, u) {
        var h = Y4(e, n);
        if (h !== null) {
          var y = N$(h.memoizedState, o, u);
          h.memoizedState = y, h.baseState = y, e.memoizedProps = Pt({}, e.memoizedProps);
          var S = Ka(e, tt);
          S !== null && rr(S, e, tt, kn);
        }
      }, R$ = function(e, n, o) {
        e.pendingProps = U$(e.memoizedProps, n, o), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var u = Ka(e, tt);
        u !== null && rr(u, e, tt, kn);
      }, L$ = function(e, n) {
        e.pendingProps = O$(e.memoizedProps, n), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var o = Ka(e, tt);
        o !== null && rr(o, e, tt, kn);
      }, $$ = function(e, n, o) {
        e.pendingProps = N$(e.memoizedProps, n, o), e.alternate && (e.alternate.pendingProps = e.pendingProps);
        var u = Ka(e, tt);
        u !== null && rr(u, e, tt, kn);
      }, D$ = function(e) {
        var n = Ka(e, tt);
        n !== null && rr(n, e, tt, kn);
      }, M$ = function(e) {
        w$ = e;
      }, A$ = function(e) {
        T$ = e;
      };
    }
    function TG(e) {
      var n = Kr(e);
      return n === null ? null : n.stateNode;
    }
    function EG(e) {
      return null;
    }
    function kG() {
      return br;
    }
    function xG(e) {
      var n = e.findFiberByHostInstance, o = t.ReactCurrentDispatcher;
      return Md({
        bundleType: e.bundleType,
        version: e.version,
        rendererPackageName: e.rendererPackageName,
        rendererConfig: e.rendererConfig,
        overrideHookState: E$,
        overrideHookStateDeletePath: k$,
        overrideHookStateRenamePath: x$,
        overrideProps: R$,
        overridePropsDeletePath: L$,
        overridePropsRenamePath: $$,
        setErrorHandler: M$,
        setSuspenseHandler: A$,
        scheduleUpdate: D$,
        currentDispatcherRef: o,
        findHostInstanceByFiber: TG,
        findFiberByHostInstance: n || EG,
        // React Refresh
        findHostInstancesForRefresh: nG,
        scheduleRefresh: eG,
        scheduleRoot: tG,
        setRefreshHandler: Jj,
        // Enables DevTools to append owner stacks to error messages in DEV mode.
        getCurrentFiber: kG,
        // Enables DevTools to detect reconciler version rather than renderer version
        // which may not match for third party renderers.
        reconcilerVersion: q4
      });
    }
    var z$ = typeof reportError == "function" ? (
      // In modern browsers, reportError will dispatch an error event,
      // emulating an uncaught JavaScript error.
      reportError
    ) : function(e) {
      console.error(e);
    };
    function W4(e) {
      this._internalRoot = e;
    }
    Ub.prototype.render = W4.prototype.render = function(e) {
      var n = this._internalRoot;
      if (n === null)
        throw new Error("Cannot update an unmounted root.");
      {
        typeof arguments[1] == "function" ? g("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : zb(arguments[1]) ? g("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && g("You passed a second argument to root.render(...) but it only accepts one argument.");
        var o = n.containerInfo;
        if (o.nodeType !== oi) {
          var u = b$(n.current);
          u && u.parentNode !== o && g("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
        }
      }
      r2(e, n, null, null);
    }, Ub.prototype.unmount = W4.prototype.unmount = function() {
      typeof arguments[0] == "function" && g("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
      var e = this._internalRoot;
      if (e !== null) {
        this._internalRoot = null;
        var n = e.containerInfo;
        ZL() && g("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), gc(function() {
          r2(null, e, null, null);
        }), zx(n);
      }
    };
    function RG(e, n) {
      if (!zb(e))
        throw new Error("createRoot(...): Target container is not a DOM element.");
      H$(e);
      var o = !1, u = !1, h = "", y = z$;
      n != null && (n.hydrate ? v("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof n == "object" && n !== null && n.$$typeof === hl && g(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), n.unstable_strictMode === !0 && (o = !0), n.identifierPrefix !== void 0 && (h = n.identifierPrefix), n.onRecoverableError !== void 0 && (y = n.onRecoverableError), n.transitionCallbacks !== void 0 && n.transitionCallbacks);
      var S = g$(e, PS, null, o, u, h, y);
      xS(S.current, e);
      var w = e.nodeType === oi ? e.parentNode : e;
      return c6(w), new W4(S);
    }
    function Ub(e) {
      this._internalRoot = e;
    }
    function LG(e) {
      e && KC(e);
    }
    Ub.prototype.unstable_scheduleHydration = LG;
    function $G(e, n, o) {
      if (!zb(e))
        throw new Error("hydrateRoot(...): Target container is not a DOM element.");
      H$(e), n === void 0 && g("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
      var u = o ?? null, h = o != null && o.hydratedSources || null, y = !1, S = !1, w = "", E = z$;
      o != null && (o.unstable_strictMode === !0 && (y = !0), o.identifierPrefix !== void 0 && (w = o.identifierPrefix), o.onRecoverableError !== void 0 && (E = o.onRecoverableError));
      var D = C$(n, null, e, PS, u, y, S, w, E);
      if (xS(D.current, e), c6(e), h)
        for (var M = 0; M < h.length; M++) {
          var H = h[M];
          PB(D, H);
        }
      return new Ub(D);
    }
    function zb(e) {
      return !!(e && (e.nodeType === Gr || e.nodeType === wo || e.nodeType === f3));
    }
    function a2(e) {
      return !!(e && (e.nodeType === Gr || e.nodeType === wo || e.nodeType === f3 || e.nodeType === oi && e.nodeValue === " react-mount-point-unstable "));
    }
    function H$(e) {
      e.nodeType === Gr && e.tagName && e.tagName.toUpperCase() === "BODY" && g("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), b6(e) && (e._reactRootContainer ? g("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : g("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
    }
    var DG = t.ReactCurrentOwner, F$;
    F$ = function(e) {
      if (e._reactRootContainer && e.nodeType !== oi) {
        var n = b$(e._reactRootContainer.current);
        n && n.parentNode !== e && g("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
      }
      var o = !!e._reactRootContainer, u = K4(e), h = !!(u && qd(u));
      h && !o && g("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), e.nodeType === Gr && e.tagName && e.tagName.toUpperCase() === "BODY" && g("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function K4(e) {
      return e ? e.nodeType === wo ? e.documentElement : e.firstChild : null;
    }
    function I$() {
    }
    function MG(e, n, o, u, h) {
      if (h) {
        if (typeof u == "function") {
          var y = u;
          u = function() {
            var V = Vb(S);
            y.call(V);
          };
        }
        var S = C$(
          n,
          u,
          e,
          Gd,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          I$
        );
        e._reactRootContainer = S, xS(S.current, e);
        var w = e.nodeType === oi ? e.parentNode : e;
        return c6(w), gc(), S;
      } else {
        for (var E; E = e.lastChild; )
          e.removeChild(E);
        if (typeof u == "function") {
          var D = u;
          u = function() {
            var V = Vb(M);
            D.call(V);
          };
        }
        var M = g$(
          e,
          Gd,
          null,
          // hydrationCallbacks
          !1,
          // isStrictMode
          !1,
          // concurrentUpdatesByDefaultOverride,
          "",
          // identifierPrefix
          I$
        );
        e._reactRootContainer = M, xS(M.current, e);
        var H = e.nodeType === oi ? e.parentNode : e;
        return c6(H), gc(function() {
          r2(n, M, o, u);
        }), M;
      }
    }
    function AG(e, n) {
      e !== null && typeof e != "function" && g("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", n, e);
    }
    function Hb(e, n, o, u, h) {
      F$(o), AG(h === void 0 ? null : h, "render");
      var y = o._reactRootContainer, S;
      if (!y)
        S = MG(o, n, e, h, u);
      else {
        if (S = y, typeof h == "function") {
          var w = h;
          h = function() {
            var E = Vb(S);
            w.call(E);
          };
        }
        r2(n, S, e, h);
      }
      return Vb(S);
    }
    var B$ = !1;
    function PG(e) {
      {
        B$ || (B$ = !0, g("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
        var n = DG.current;
        if (n !== null && n.stateNode !== null) {
          var o = n.stateNode._warnedAboutRefsInRender;
          o || g("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", fn(n.type) || "A component"), n.stateNode._warnedAboutRefsInRender = !0;
        }
      }
      return e == null ? null : e.nodeType === Gr ? e : yG(e, "findDOMNode");
    }
    function OG(e, n, o) {
      if (g("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !a2(n))
        throw new Error("Target container is not a DOM element.");
      {
        var u = b6(n) && n._reactRootContainer === void 0;
        u && g("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
      }
      return Hb(null, e, n, !0, o);
    }
    function _G(e, n, o) {
      if (g("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !a2(n))
        throw new Error("Target container is not a DOM element.");
      {
        var u = b6(n) && n._reactRootContainer === void 0;
        u && g("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
      }
      return Hb(null, e, n, !1, o);
    }
    function NG(e, n, o, u) {
      if (g("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !a2(o))
        throw new Error("Target container is not a DOM element.");
      if (e == null || !Gw(e))
        throw new Error("parentComponent must be a valid React Component");
      return Hb(e, n, o, !1, u);
    }
    var q$ = !1;
    function VG(e) {
      if (q$ || (q$ = !0, g("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !a2(e))
        throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
      {
        var n = b6(e) && e._reactRootContainer === void 0;
        n && g("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
      }
      if (e._reactRootContainer) {
        {
          var o = K4(e), u = o && !qd(o);
          u && g("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
        }
        return gc(function() {
          Hb(null, null, e, !1, function() {
            e._reactRootContainer = null, zx(e);
          });
        }), !0;
      } else {
        {
          var h = K4(e), y = !!(h && qd(h)), S = e.nodeType === Gr && a2(e.parentNode) && !!e.parentNode._reactRootContainer;
          y && g("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", S ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
        }
        return !1;
      }
    }
    fr(gG), _d(CG), GC(SG), up(Qa), Q3(BC), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && g("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), $v(zF), jw(R4, $j, gc);
    function UG(e, n) {
      var o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      if (!zb(n))
        throw new Error("Target container is not a DOM element.");
      return vG(e, n, null, o);
    }
    function zG(e, n, o, u) {
      return NG(e, n, o, u);
    }
    var Z4 = {
      usingClientEntryPoint: !1,
      // Keep in sync with ReactTestUtils.js.
      // This is an array for better minification.
      Events: [qd, Ay, RS, Ed, Dv, R4]
    };
    function HG(e, n) {
      return Z4.usingClientEntryPoint || g('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), RG(e, n);
    }
    function FG(e, n, o) {
      return Z4.usingClientEntryPoint || g('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), $G(e, n, o);
    }
    function IG(e) {
      return ZL() && g("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), gc(e);
    }
    var BG = xG({
      findFiberByHostInstance: Tp,
      bundleType: 1,
      version: q4,
      rendererPackageName: "react-dom"
    });
    if (!BG && Wn && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
      var j$ = window.location.protocol;
      /^(https?|file):$/.test(j$) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (j$ === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
    }
    ts.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Z4, ts.createPortal = UG, ts.createRoot = HG, ts.findDOMNode = PG, ts.flushSync = IG, ts.hydrate = OG, ts.hydrateRoot = FG, ts.render = _G, ts.unmountComponentAtNode = VG, ts.unstable_batchedUpdates = R4, ts.unstable_renderSubtreeIntoContainer = zG, ts.version = q4, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ts;
}
var PD;
function xX() {
  if (PD) return Gb.exports;
  PD = 1;
  function c() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
      if (process.env.NODE_ENV !== "production")
        throw new Error("^_^");
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(c);
      } catch (s) {
        console.error(s);
      }
    }
  }
  return process.env.NODE_ENV === "production" ? (c(), Gb.exports = EX()) : Gb.exports = kX(), Gb.exports;
}
var RX = xX();
function yh() {
  return Mk(Hk);
}
const LX = xt(qZ, {
  domEventsRegex: /^onMedia/
}), $X = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(LX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
$X.displayName = "AirPlayButton";
const DX = xt(BZ, {
  domEventsRegex: /^onMedia/
}), MX = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(DX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
MX.displayName = "PlayButton";
const AX = xt(UZ, {
  domEventsRegex: /^onMedia/
}), PX = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(AX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
PX.displayName = "CaptionButton";
const OX = xt(zZ, {
  domEventsRegex: /^onMedia/
}), _X = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(OX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
_X.displayName = "FullscreenButton";
const NX = xt(FZ, {
  domEventsRegex: /^onMedia/
}), VX = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(NX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
VX.displayName = "MuteButton";
const UX = xt(IZ, {
  domEventsRegex: /^onMedia/
}), zX = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(UX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
zX.displayName = "PIPButton";
const HX = xt(GZ, {
  domEventsRegex: /^onMedia/
}), FX = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(HX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
FX.displayName = "SeekButton";
const IX = xt(HZ, {
  domEventsRegex: /^onMedia/
}), BX = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(IX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
BX.displayName = "LiveButton";
const V1 = [
  "onDragStart",
  "onDragEnd",
  "onDragValueChange",
  "onValueChange",
  "onPointerValueChange"
], qX = xt(nX), jX = xt(uz, {
  events: V1
}), GX = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(jX, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c)));
GX.displayName = "Slider";
const tx = _.forwardRef((c, s) => /* @__PURE__ */ _.createElement(st.div, { ...c, ref: s }));
tx.displayName = "SliderThumb";
const nx = _.forwardRef((c, s) => /* @__PURE__ */ _.createElement(st.div, { ...c, ref: s }));
nx.displayName = "SliderTrack";
const ix = _.forwardRef((c, s) => /* @__PURE__ */ _.createElement(st.div, { ...c, ref: s }));
ix.displayName = "SliderTrackFill";
const QX = xt(rX), rx = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(QX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.div,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
rx.displayName = "SliderPreview";
const ax = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(qX, { ...s }, (r, f) => {
  const v = cn(() => f.getValueText(), f);
  return /* @__PURE__ */ _.createElement(st.div, { ...r, ref: t }, v, c);
}));
ax.displayName = "SliderValue";
const sx = _.forwardRef(({ children: c, ...s }, t) => {
  const r = u7("min"), f = u7("max"), v = u7("step"), g = (f - r) / v;
  return /* @__PURE__ */ _.createElement(st.div, { ...s, ref: t }, Array.from({ length: Math.floor(g) + 1 }).map((T, x) => c(x)));
});
sx.displayName = "SliderSteps";
const YX = xt(ZZ, {
  events: V1,
  domEventsRegex: /^onMedia/
}), pz = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(YX, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c))
);
pz.displayName = "VolumeSlider";
var gte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Preview: rx,
  Root: pz,
  Steps: sx,
  Thumb: tx,
  Track: nx,
  TrackFill: ix,
  Value: ax
});
function WX(c = 0, s = 0, t = "") {
  return Oe ? {
    startTime: c,
    endTime: s,
    text: t,
    addEventListener: Ms,
    removeEventListener: Ms,
    dispatchEvent: Ms
  } : new window.VTTCue(c, s, t);
}
const KX = xt(cz), ZX = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(KX, { ...s }, (r) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    ...r,
    ref: pn(r.ref, t)
  },
  c
)));
ZX.displayName = "Thumbnail";
const mz = _.forwardRef(({ children: c, ...s }, t) => {
  const { src: r, img: f, crossOrigin: v } = tv(cz.state), g = cn(r), T = cn(v);
  return /* @__PURE__ */ _.createElement(
    st.img,
    {
      crossOrigin: T,
      ...s,
      src: g || void 0,
      ref: pn(f.set, t)
    },
    c
  );
});
mz.displayName = "ThumbnailImg";
const Sw = _.createContext({
  $chapters: nt(null)
});
Sw.displayName = "TimeSliderContext";
const XX = xt(KZ, {
  events: V1,
  domEventsRegex: /^onMedia/
}), vz = _.forwardRef(
  ({ children: c, ...s }, t) => {
    const r = _.useMemo(() => nt(null), []);
    return /* @__PURE__ */ _.createElement(Sw.Provider, { value: { $chapters: r } }, /* @__PURE__ */ _.createElement(XX, { ...s, ref: t }, (f) => /* @__PURE__ */ _.createElement(st.div, { ...f }, c)));
  }
);
vz.displayName = "TimeSlider";
const JX = xt(aX), yz = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(JX, { ...s }, (r, f) => /* @__PURE__ */ _.createElement(
    st.div,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    /* @__PURE__ */ _.createElement(gz, { instance: f }, c)
  ))
);
yz.displayName = "SliderChapters";
function gz({ instance: c, children: s }) {
  const t = cn(() => c.cues, c), r = _.useRef([]), f = _.useRef(null), { $chapters: v } = _.useContext(Sw);
  return f.current || (f.current = WX()), _.useEffect(() => (v.set(c), () => void v.set(null)), [c]), _.useEffect(() => {
    c.setRefs(r.current);
  }, [t]), s(t.length ? t : [f.current], (g) => {
    if (!g) {
      r.current.length = 0;
      return;
    }
    r.current.push(g);
  });
}
gz.displayName = "SliderChapterTracks";
const Cz = _.forwardRef(
  ({ children: c, ...s }, t) => {
    const { $chapters: r } = _.useContext(Sw), [f, v] = _.useState();
    return _.useEffect(() => K(() => {
      const g = r(), T = (g == null ? void 0 : g.activePointerCue) || (g == null ? void 0 : g.activeCue);
      v((T == null ? void 0 : T.text) || "");
    }), []), /* @__PURE__ */ _.createElement(st.div, { ...s, ref: t }, f, c);
  }
);
Cz.displayName = "SliderChapterTitle";
const Sz = _.forwardRef((c, s) => /* @__PURE__ */ _.createElement(st.div, { ...c, ref: s }));
Sz.displayName = "SliderProgress";
const eJ = xt(tX), bz = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(eJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r, ref: pn(r.ref, t) }, c))
);
bz.displayName = "SliderThumbnail";
const tJ = {
  Root: bz,
  Img: mz
}, nJ = xt(iX, {
  events: ["onCanPlay", "onError"]
}), wz = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(nJ, { ...s }, (r, f) => /* @__PURE__ */ _.createElement(
    Tz,
    {
      ...r,
      instance: f,
      ref: pn(r.ref, t)
    },
    c
  ))
);
wz.displayName = "SliderVideo";
const Tz = _.forwardRef(
  ({ instance: c, children: s, ...t }, r) => {
    const { canLoad: f } = tv(N1), { src: v, video: g, crossOrigin: T } = c.$state, x = cn(v), $ = cn(f), P = cn(T);
    return /* @__PURE__ */ _.createElement(
      st.video,
      {
        style: { maxWidth: "unset" },
        ...t,
        src: x || void 0,
        muted: !0,
        playsInline: !0,
        preload: $ ? "auto" : "none",
        crossOrigin: P || void 0,
        ref: pn(g.set, r)
      },
      s
    );
  }
);
Tz.displayName = "SliderVideoProvider";
var Cte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ChapterTitle: Cz,
  Chapters: yz,
  Preview: rx,
  Progress: Sz,
  Root: vz,
  Steps: sx,
  Thumb: tx,
  Thumbnail: tJ,
  Track: nx,
  TrackFill: ix,
  Value: ax,
  Video: wz
});
const iJ = xt(cX, {
  events: ["onChange"]
}), rJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(iJ, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c))
);
rJ.displayName = "RadioGroup";
const aJ = xt(dX, {
  events: ["onChange", "onSelect"]
}), sJ = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(aJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    ...r,
    ref: pn(r.ref, t)
  },
  c
)));
sJ.displayName = "RadioItem";
const oJ = xt(sX, {
  events: ["onOpen", "onClose"],
  domEventsRegex: /^onMedia/
}), lJ = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(oJ, { ...s, ref: t }, (r, f) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    ...r,
    style: { display: f.isSubmenu ? void 0 : "contents", ...r.style }
  },
  c
)));
lJ.displayName = "Menu";
const uJ = xt(oX, {
  events: ["onSelect"]
}), cJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(uJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
cJ.displayName = "MenuButton";
const dJ = _.forwardRef(
  ({ container: c = null, disabled: s = !1, children: t, ...r }, f) => {
    let v = ex("fullscreen"), g = s === "fullscreen" ? !v : !s;
    const T = _.useMemo(() => Oe ? null : (qe(c) ? document.querySelector(c) : c) ?? document.body, [c]);
    return !T || !g ? t : RX.createPortal(
      /* @__PURE__ */ _.createElement(
        st.div,
        {
          ...r,
          style: { display: "contents", ...r.style },
          ref: f
        },
        t
      ),
      T
    );
  }
);
dJ.displayName = "MenuPortal";
const fJ = xt(lX), hJ = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(fJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    ...r,
    ref: pn(r.ref, t)
  },
  c
)));
hJ.displayName = "MenuItems";
const pJ = xt(uX), mJ = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(pJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    ...r,
    ref: pn(r.ref, t)
  },
  c
)));
mJ.displayName = "MenuItem";
const vJ = xt(hX, {
  events: ["onWillTrigger", "onTrigger"]
}), yJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(vJ, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c))
);
yJ.displayName = "Gesture";
const gJ = xt(mX), CJ = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(gJ, { ...s }, (r, f) => /* @__PURE__ */ _.createElement(
  Ez,
  {
    ...r,
    instance: f,
    ref: pn(r.ref, t)
  },
  c
)));
CJ.displayName = "Time";
const Ez = _.forwardRef(
  ({ instance: c, children: s, ...t }, r) => {
    const { timeText: f } = c.$state, v = cn(f);
    return /* @__PURE__ */ _.createElement(st.div, { ...t, ref: r }, v, s);
  }
);
Ez.displayName = "TimeText";
function Ste() {
  const c = yh();
  return (c == null ? void 0 : c.player) || null;
}
function bte({ off: c = !0 } = {}) {
  const s = yh(), { textTracks: t, textTrack: r } = s.$state, f = cn(t);
  return cn(r), _.useMemo(() => {
    const v = f.filter(os), g = v.map((T) => ({
      track: T,
      label: T.label,
      value: OD(T),
      get selected() {
        return r() === T;
      },
      select(x) {
        const $ = t().indexOf(T);
        $ >= 0 && s.remote.changeTextTrackMode($, "showing", x);
      }
    }));
    return c && g.unshift({
      track: null,
      label: qe(c) ? c : "Off",
      value: "off",
      get selected() {
        return !r();
      },
      select(T) {
        s.remote.toggleCaptions(T);
      }
    }), Object.defineProperty(g, "disabled", {
      get() {
        return !v.length;
      }
    }), Object.defineProperty(g, "selectedTrack", {
      get() {
        return r();
      }
    }), Object.defineProperty(g, "selectedValue", {
      get() {
        const T = r();
        return T ? OD(T) : "off";
      }
    }), g;
  }, [f]);
}
function OD(c) {
  return c.id + ":" + c.kind + "-" + c.label.toLowerCase();
}
const SJ = xt(OZ, {
  events: ["onChange"]
}), bJ = _.forwardRef(
  ({ style: c, children: s, ...t }, r) => /* @__PURE__ */ _.createElement(SJ, { ...t }, (f) => /* @__PURE__ */ _.createElement(
    st.div,
    {
      ...f,
      style: { display: "contents", ...c },
      ref: pn(f.ref, r)
    },
    s
  ))
);
bJ.displayName = "MediaAnnouncer";
const wJ = xt(_Z), TJ = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(wJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    ...r,
    ref: pn(r.ref, t)
  },
  c
)));
TJ.displayName = "Controls";
const EJ = xt(NZ), kJ = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(EJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    ...r,
    ref: pn(r.ref, t)
  },
  c
)));
kJ.displayName = "ControlsGroup";
const xJ = xt(QZ);
function RJ({ children: c, ...s }) {
  return /* @__PURE__ */ _.createElement(xJ, { ...s }, c);
}
RJ.displayName = "Tooltip";
const LJ = xt(YZ), $J = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(LJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
$J.displayName = "TooltipTrigger";
const DJ = xt(WZ), MJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(DJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.div,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
MJ.displayName = "TooltipContent";
const AJ = xt(jZ, {
  domEventsRegex: /^onMedia/
}), PJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(AJ, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
PJ.displayName = "GoogleCastButton";
const OJ = xt(eX, {
  events: V1,
  domEventsRegex: /^onMedia/
}), _J = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(OJ, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c))
);
_J.displayName = "QualitySlider";
const NJ = xt(XZ, {
  events: V1,
  domEventsRegex: /^onMedia/
}), VJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(NJ, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c))
);
VJ.displayName = "AudioGainSlider";
const UJ = xt(JZ, {
  events: V1,
  domEventsRegex: /^onMedia/
}), zJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(UJ, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c))
);
zJ.displayName = "SpeedSlider";
const HJ = _.forwardRef(({ children: c, ...s }, t) => {
  const r = ex("title");
  return /* @__PURE__ */ _.createElement(st.span, { ...s, ref: t }, r, c);
});
HJ.displayName = "Title";
function FJ(c) {
  const [s, t] = _.useState([]);
  return _.useEffect(() => {
    if (!c) {
      t([]);
      return;
    }
    function r() {
      c && t(c.activeCues);
    }
    return r(), sn(c, "cue-change", r);
  }, [c]), s;
}
function IJ(c) {
  const s = yh(), [t, r] = _.useState(null);
  return _.useEffect(() => zk(s.textTracks, c, r), [c]), t;
}
function BJ() {
  var t;
  const c = IJ("chapters");
  return ((t = FJ(c)[0]) == null ? void 0 : t.text) || "";
}
const qJ = _.forwardRef(
  ({ defaultText: c = "", children: s, ...t }, r) => {
    const f = BJ();
    return /* @__PURE__ */ _.createElement(st.span, { ...t, ref: r }, f || c, s);
  }
);
qJ.displayName = "ChapterTitle";
const jJ = xt(fX), GJ = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(jJ, { ...s, ref: t }, (r) => /* @__PURE__ */ _.createElement(st.div, { ...r }, c))
);
GJ.displayName = "Captions";
const QJ = _.forwardRef(
  ({ size: c = 96, children: s, ...t }, r) => /* @__PURE__ */ _.createElement(
    "svg",
    {
      width: c,
      height: c,
      fill: "none",
      viewBox: "0 0 120 120",
      "aria-hidden": "true",
      "data-part": "root",
      ...t,
      ref: r
    },
    s
  )
), YJ = _.forwardRef(
  ({ width: c = 8, children: s, ...t }, r) => /* @__PURE__ */ _.createElement(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      strokeWidth: c,
      "data-part": "track",
      ...t,
      ref: r
    },
    s
  )
), WJ = _.forwardRef(
  ({ width: c = 8, fillPercent: s = 50, children: t, ...r }, f) => /* @__PURE__ */ _.createElement(
    "circle",
    {
      cx: "60",
      cy: "60",
      r: "54",
      stroke: "currentColor",
      pathLength: "100",
      strokeWidth: c,
      strokeDasharray: 100,
      strokeDashoffset: 100 - s,
      "data-part": "track-fill",
      ...r,
      ref: f
    },
    t
  )
);
var wte = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Root: QJ,
  Track: YJ,
  TrackFill: WJ
});
const kz = /* @__PURE__ */ _.forwardRef((c, s) => {
  const { width: t, height: r, size: f = null, paths: v, ...g } = c;
  return _.createElement("svg", {
    viewBox: "0 0 32 32",
    ...g,
    width: t ?? f,
    height: r ?? f,
    fill: "none",
    "aria-hidden": "true",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    ref: s,
    dangerouslySetInnerHTML: { __html: v }
  });
});
kz.displayName = "VidstackIcon";
const xz = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2];
var Qf, p1, Pm, vo, Lz, $z, Dz, Mz, Az;
class Rz extends Et {
  constructor() {
    super();
    k(this, vo);
    k(this, Qf);
    k(this, p1);
    k(this, Pm);
    L(this, Pm, new Kk()), l(this, Pm).onValueChange = m(this, vo, Az).bind(this);
  }
  get value() {
    return l(this, Pm).value;
  }
  get disabled() {
    const { rates: t } = this.$props, { canSetPlaybackRate: r } = l(this, Qf).$state;
    return !r() || t().length === 0;
  }
  onSetup() {
    L(this, Qf, bn()), fu(ol) && L(this, p1, gi(ol));
  }
  onConnect(t) {
    K(m(this, vo, Lz).bind(this)), K(m(this, vo, $z).bind(this)), K(m(this, vo, Dz).bind(this));
  }
  getOptions() {
    const { rates: t, normalLabel: r } = this.$props;
    return t().map((f) => ({
      label: f === 1 ? r : f + "×",
      value: f.toString()
    }));
  }
}
Qf = new WeakMap(), p1 = new WeakMap(), Pm = new WeakMap(), vo = new WeakSet(), Lz = function() {
  l(this, Pm).value = m(this, vo, Mz).call(this);
}, $z = function() {
  var v;
  const { normalLabel: t } = this.$props, { playbackRate: r } = l(this, Qf).$state, f = r();
  (v = l(this, p1)) == null || v.hint.set(f === 1 ? t() : f + "×");
}, Dz = function() {
  var t;
  (t = l(this, p1)) == null || t.disable(this.disabled);
}, Mz = function() {
  const { playbackRate: t } = l(this, Qf).$state;
  return t().toString();
}, Az = function(t, r) {
  if (this.disabled) return;
  const f = +t;
  l(this, Qf).remote.changePlaybackRate(f, r), this.dispatch("change", { detail: f, trigger: r });
}, I(Rz, "props", {
  normalLabel: "Normal",
  rates: xz
});
const ox = Rz.prototype;
on(ox, "value");
on(ox, "disabled");
Fi(ox, "getOptions");
function Tte(c) {
  const s = yh(), t = _.useRef(null);
  return t.current || (t.current = new YM()), _.useEffect(() => {
    const r = c, f = r instanceof Jk, v = f ? r : s == null ? void 0 : s.player;
    t.current.setPlayer(v ?? null), t.current.setTarget(null);
  }, [s, c]), t.current;
}
function Ete({
  auto: c = !0,
  sort: s = "descending"
} = {}) {
  const t = yh(), { qualities: r, quality: f, autoQuality: v, canSetQuality: g } = t.$state, T = cn(r);
  return cn(f), cn(v), cn(g), _.useMemo(() => {
    const x = cA(T, s === "descending"), $ = x.map((P) => ({
      quality: P,
      label: P.height + "p",
      value: _D(P),
      bitrateText: P.bitrate && P.bitrate > 0 ? `${(P.bitrate / 1e6).toFixed(2)} Mbps` : null,
      get selected() {
        return P === f();
      },
      get autoSelected() {
        return v();
      },
      select(A) {
        const U = r().indexOf(P);
        U >= 0 && t.remote.changeQuality(U, A);
      }
    }));
    return c && $.unshift({
      quality: null,
      label: qe(c) ? c : "Auto",
      value: "auto",
      bitrateText: null,
      get selected() {
        return v();
      },
      get autoSelected() {
        return v();
      },
      select(P) {
        t.remote.requestAutoQuality(P);
      }
    }), Object.defineProperty($, "disabled", {
      get() {
        return !g() || T.length <= 1;
      }
    }), Object.defineProperty($, "selectedQuality", {
      get() {
        return f();
      }
    }), Object.defineProperty($, "selectedValue", {
      get() {
        const P = f();
        return !v() && P ? _D(P) : "auto";
      }
    }), $;
  }, [T, s]);
}
function _D(c) {
  return c.height + "_" + c.bitrate;
}
function kte({
  rates: c = xz,
  normalLabel: s = "Normal"
} = {}) {
  const t = yh(), { playbackRate: r, canSetPlaybackRate: f } = t.$state;
  return cn(r), cn(f), _.useMemo(() => {
    const v = c.map((g) => {
      const T = typeof g == "number" ? g === 1 && s ? s : g + "x" : g.label, x = typeof g == "number" ? g : g.rate;
      return {
        label: T,
        value: x.toString(),
        rate: x,
        get selected() {
          return r() === x;
        },
        select($) {
          t.remote.changePlaybackRate(x, $);
        }
      };
    });
    return Object.defineProperty(v, "disabled", {
      get() {
        return !f() || !v.length;
      }
    }), Object.defineProperty(v, "selectedValue", {
      get() {
        return r().toString();
      }
    }), v;
  }, [c]);
}
const KJ = [1, 1.25, 1.5, 1.75, 2, 2.5, 3, 4];
var Yf, m1, Om, yo, Oz, _z, Nz, Vz, Uz;
class Pz extends Et {
  constructor() {
    super();
    k(this, yo);
    k(this, Yf);
    k(this, m1);
    k(this, Om);
    L(this, Om, new Kk()), l(this, Om).onValueChange = m(this, yo, Uz).bind(this);
  }
  get value() {
    return l(this, Om).value;
  }
  get disabled() {
    const { gains: t } = this.$props, { canSetAudioGain: r } = l(this, Yf).$state;
    return !r() || t().length === 0;
  }
  onSetup() {
    L(this, Yf, bn()), fu(ol) && L(this, m1, gi(ol));
  }
  onConnect(t) {
    K(m(this, yo, Oz).bind(this)), K(m(this, yo, _z).bind(this)), K(m(this, yo, Nz).bind(this));
  }
  getOptions() {
    const { gains: t, normalLabel: r } = this.$props;
    return t().map((f) => ({
      label: f === 1 || f === null ? r : String(f * 100) + "%",
      value: f.toString()
    }));
  }
}
Yf = new WeakMap(), m1 = new WeakMap(), Om = new WeakMap(), yo = new WeakSet(), Oz = function() {
  l(this, Om).value = m(this, yo, Vz).call(this);
}, _z = function() {
  var v;
  const { normalLabel: t } = this.$props, { audioGain: r } = l(this, Yf).$state, f = r();
  (v = l(this, m1)) == null || v.hint.set(f === 1 || f == null ? t() : String(f * 100) + "%");
}, Nz = function() {
  var t;
  (t = l(this, m1)) == null || t.disable(this.disabled);
}, Vz = function() {
  var r;
  const { audioGain: t } = l(this, Yf).$state;
  return ((r = t()) == null ? void 0 : r.toString()) ?? "1";
}, Uz = function(t, r) {
  if (this.disabled) return;
  const f = +t;
  l(this, Yf).remote.changeAudioGain(f, r), this.dispatch("change", { detail: f, trigger: r });
}, I(Pz, "props", {
  normalLabel: "Disabled",
  gains: KJ
});
const lx = Pz.prototype;
on(lx, "value");
on(lx, "disabled");
Fi(lx, "getOptions");
const ZJ = [
  "onAbort",
  "onAudioTrackChange",
  "onAudioTracksChange",
  "onAutoPlay",
  "onAutoPlayChange",
  "onAutoPlayFail",
  "onCanLoad",
  "onCanPlay",
  "onCanPlayThrough",
  "onControlsChange",
  "onDestroy",
  "onDurationChange",
  "onEmptied",
  "onEnd",
  "onEnded",
  "onError",
  "onFindMediaPlayer",
  "onFullscreenChange",
  "onFullscreenError",
  "onLiveChange",
  "onLiveEdgeChange",
  "onLoadedData",
  "onLoadedMetadata",
  "onLoadStart",
  "onLoopChange",
  "onOrientationChange",
  "onPause",
  "onPictureInPictureChange",
  "onPictureInPictureError",
  "onPlay",
  "onPlayFail",
  "onPlaying",
  "onPlaysInlineChange",
  "onPosterChange",
  "onProgress",
  "onProviderChange",
  "onProviderLoaderChange",
  "onProviderSetup",
  "onQualitiesChange",
  "onQualityChange",
  "onRateChange",
  "onReplay",
  "onSeeked",
  "onSeeking",
  "onSourceChange",
  "onSourceChange",
  "onStalled",
  "onStarted",
  "onStreamTypeChange",
  "onSuspend",
  "onTextTrackChange",
  "onTextTracksChange",
  "onTimeUpdate",
  "onTitleChange",
  "onVdsLog",
  "onVideoPresentationChange",
  "onVolumeChange",
  "onWaiting"
], XJ = xt(Jk, {
  events: ZJ,
  eventsRegex: /^onHls/,
  domEventsRegex: /^onMedia/
}), JJ = _.forwardRef(
  ({ aspectRatio: c, children: s, ...t }, r) => /* @__PURE__ */ _.createElement(
    XJ,
    {
      ...t,
      src: t.src,
      ref: r,
      style: {
        aspectRatio: c,
        ...t.style
      }
    },
    (f) => /* @__PURE__ */ _.createElement(st.div, { ...f }, s)
  )
);
JJ.displayName = "MediaPlayer";
const eee = xt(PZ), tee = _.forwardRef(
  ({ loaders: c = [], children: s, iframeProps: t, mediaProps: r, ...f }, v) => {
    const g = _.useMemo(() => c.map((T) => new T()), c);
    return /* @__PURE__ */ _.createElement(eee, { ...f, loaders: g, ref: v }, (T, x) => /* @__PURE__ */ _.createElement("div", { ...T }, /* @__PURE__ */ _.createElement(zz, { provider: x, mediaProps: r, iframeProps: t }), s));
  }
);
tee.displayName = "MediaProvider";
function zz({ provider: c, mediaProps: s, iframeProps: t }) {
  const { sources: r, crossOrigin: f, poster: v, remotePlaybackInfo: g, nativeControls: T, viewType: x } = tv(N1), { loader: $ } = c.$state, { $provider: P, $providerSetup: A } = yh(), U = cn(r), F = cn(T), Z = cn(f), ne = cn(v), ce = cn($), De = cn(P), Ne = cn(A), Se = cn(g), je = ce == null ? void 0 : ce.mediaType(), Me = cn(x), Ct = Me === "audio", Ge = (ce == null ? void 0 : ce.name) === "youtube", he = (ce == null ? void 0 : ce.name) === "vimeo", Ze = Ge || he, pt = (ce == null ? void 0 : ce.name) === "remotion", Gt = (ce == null ? void 0 : ce.name) === "google-cast", [Lt, Ve] = _.useState(""), [mt, wn] = _.useState(!1);
  return _.useEffect(() => {
    !Gt || Lt || Promise.resolve().then(() => hY).then(function(Ye) {
      return Ye.chromecast;
    }).then((Ye) => {
      Ve(Ye.default);
    });
  }, [Gt]), _.useEffect(() => {
    wn(!0);
  }, []), Gt ? /* @__PURE__ */ _.createElement(
    "div",
    {
      className: "vds-google-cast",
      ref: (Ye) => {
        c.load(Ye);
      }
    },
    /* @__PURE__ */ _.createElement(kz, { paths: Lt }),
    Se != null && Se.deviceName ? /* @__PURE__ */ _.createElement("span", { className: "vds-google-cast-info" }, "Google Cast on", " ", /* @__PURE__ */ _.createElement("span", { className: "vds-google-cast-device-name" }, Se.deviceName)) : null
  ) : pt ? /* @__PURE__ */ _.createElement("div", { "data-remotion-canvas": !0 }, /* @__PURE__ */ _.createElement(
    "div",
    {
      "data-remotion-container": !0,
      ref: (Ye) => {
        c.load(Ye);
      }
    },
    SX(De) && Ne ? _.createElement(De.render) : null
  )) : Ze ? _.createElement(
    _.Fragment,
    null,
    _.createElement("iframe", {
      ...t,
      className: (t != null && t.className ? `${t.className} ` : "") + Ge ? "vds-youtube" : "vds-vimeo",
      suppressHydrationWarning: !0,
      tabIndex: F ? void 0 : -1,
      "aria-hidden": "true",
      "data-no-controls": F ? void 0 : "",
      ref(Ye) {
        c.load(Ye);
      }
    }),
    !F && !Ct ? _.createElement("div", { className: "vds-blocker" }) : null
  ) : je ? _.createElement(je === "audio" ? "audio" : "video", {
    ...s,
    controls: F ? !0 : null,
    crossOrigin: typeof Z == "boolean" ? "" : Z,
    poster: je === "video" && F && ne ? ne : null,
    suppressHydrationWarning: !0,
    children: mt ? null : U.map(
      ({ src: Ye, type: rt }) => qe(Ye) ? /* @__PURE__ */ _.createElement("source", { src: Ye, type: rt !== "?" ? rt : void 0, key: Ye }) : null
    ),
    ref(Ye) {
      c.load(Ye);
    }
  }) : null;
}
zz.displayName = "MediaOutlet";
function nee(c) {
  const s = yh(), t = _.useMemo(() => new Jc(c), Object.values(c));
  return _.useEffect(() => (s.textTracks.add(t), () => void s.textTracks.remove(t)), [t]), t;
}
function iee({ lang: c, ...s }) {
  return nee({ language: c, ...s }), null;
}
iee.displayName = "Track";
const ree = xt(VZ), aee = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(ree, { ...s }, (r) => /* @__PURE__ */ _.createElement(
    st.button,
    {
      ...r,
      ref: pn(r.ref, t)
    },
    c
  ))
);
aee.displayName = "ToggleButton";
const see = xt(pX), oee = _.forwardRef(
  ({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(
    see,
    {
      src: s.asChild && _.isValidElement(c) ? c.props.src : void 0,
      ...s
    },
    (r, f) => /* @__PURE__ */ _.createElement(
      Hz,
      {
        ...r,
        instance: f,
        ref: pn(r.ref, t)
      },
      c
    )
  )
);
oee.displayName = "Poster";
const Hz = _.forwardRef(
  ({ instance: c, children: s, ...t }, r) => {
    const { src: f, img: v, alt: g, crossOrigin: T, hidden: x } = c.$state, $ = cn(f), P = cn(g), A = cn(T), U = cn(x);
    return /* @__PURE__ */ _.createElement(
      st.img,
      {
        ...t,
        src: $ || void 0,
        alt: P || void 0,
        crossOrigin: A || void 0,
        ref: pn(v.set, r),
        style: { display: U ? "none" : void 0 }
      },
      s
    );
  }
);
Hz.displayName = "PosterImg";
const lee = _.forwardRef(({ children: c, ...s }, t) => /* @__PURE__ */ _.createElement(
  st.div,
  {
    translate: "yes",
    "aria-live": "off",
    "aria-atomic": "true",
    ...s,
    ref: t
  },
  c
));
lee.displayName = "Caption";
const uee = _.forwardRef((c, s) => {
  const t = ex("textTrack"), [r, f] = _.useState();
  return _.useEffect(() => {
    if (!t) return;
    function v() {
      f(t == null ? void 0 : t.activeCues[0]);
    }
    return t.addEventListener("cue-change", v), () => {
      t.removeEventListener("cue-change", v), f(void 0);
    };
  }, [t]), /* @__PURE__ */ _.createElement(
    st.span,
    {
      ...c,
      "data-part": "cue",
      dangerouslySetInnerHTML: {
        __html: (r == null ? void 0 : r.text) || ""
      },
      ref: s
    }
  );
});
uee.displayName = "CaptionText";
class cee extends uP {
  constructor(t, r) {
    super(t, r);
    I(this, "$$PROVIDER_TYPE", "AUDIO");
    I(this, "airPlay");
    la(() => {
      this.airPlay = new hP(this.media, r);
    }, this.scope);
  }
  get type() {
    return "audio";
  }
  setup() {
    super.setup(), this.type === "audio" && this.ctx.notify("provider-setup", this);
  }
  /**
   * The native HTML `<audio>` element.
   *
   * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLAudioElement}
   */
  get audio() {
    return this.media;
  }
}
const dee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AudioProvider: cee
}, Symbol.toStringTag, { value: "Module" })), fee = (c) => _0(c);
var _m, $n, It, v1, y1, Ht, jp, Fz, Iz, Bz, qz, jz, Gz, Qz, Yz, Wz, Kz, Zz, Xz, Jz, eH;
class hee {
  constructor(s, t) {
    k(this, Ht);
    k(this, _m);
    k(this, $n);
    k(this, It, null);
    k(this, v1, null);
    I(this, "config", {});
    k(this, y1, /* @__PURE__ */ new Set());
    L(this, _m, s), L(this, $n, t);
  }
  get instance() {
    return l(this, It);
  }
  setup(s) {
    const { streamType: t } = l(this, $n).$state, r = fe(t).includes("live"), f = fe(t).includes("ll-");
    L(this, It, new s({
      lowLatencyMode: f,
      backBufferLength: f ? 4 : r ? 8 : void 0,
      renderTextTracksNatively: !1,
      ...this.config
    }));
    const v = m(this, Ht, Bz).bind(this);
    for (const g of Object.values(s.Events)) l(this, It).on(g, v);
    l(this, It).on(s.Events.ERROR, m(this, Ht, Kz).bind(this));
    for (const g of l(this, y1)) g(l(this, It));
    l(this, $n).player.dispatch("hls-instance", {
      detail: l(this, It)
    }), l(this, It).attachMedia(l(this, _m)), l(this, It).on(s.Events.AUDIO_TRACK_SWITCHED, m(this, Ht, Gz).bind(this)), l(this, It).on(s.Events.LEVEL_SWITCHED, m(this, Ht, Qz).bind(this)), l(this, It).on(s.Events.LEVEL_LOADED, m(this, Ht, Wz).bind(this)), l(this, It).on(s.Events.LEVEL_UPDATED, m(this, Ht, Yz).bind(this)), l(this, It).on(s.Events.NON_NATIVE_TEXT_TRACKS_FOUND, m(this, Ht, qz).bind(this)), l(this, It).on(s.Events.CUES_PARSED, m(this, Ht, jz).bind(this)), l(this, $n).qualities[zr.enableAuto] = m(this, Ht, Xz).bind(this), sn(l(this, $n).qualities, "change", m(this, Ht, Jz).bind(this)), sn(l(this, $n).audioTracks, "change", m(this, Ht, eH).bind(this)), L(this, v1, K(m(this, Ht, Fz).bind(this)));
  }
  onInstance(s) {
    return l(this, y1).add(s), () => l(this, y1).delete(s);
  }
  loadSource(s) {
    var t;
    qe(s.src) && ((t = l(this, It)) == null || t.loadSource(s.src));
  }
  destroy() {
    var s, t;
    (s = l(this, It)) == null || s.destroy(), L(this, It, null), (t = l(this, v1)) == null || t.call(this), L(this, v1, null);
  }
}
_m = new WeakMap(), $n = new WeakMap(), It = new WeakMap(), v1 = new WeakMap(), y1 = new WeakMap(), Ht = new WeakSet(), jp = function(s, t) {
  return new St(fee(s), { detail: t });
}, Fz = function() {
  if (!l(this, $n).$state.live()) return;
  const s = new U0(m(this, Ht, Iz).bind(this));
  return s.start(), s.stop.bind(s);
}, Iz = function() {
  var s;
  l(this, $n).$state.liveSyncPosition.set(((s = l(this, It)) == null ? void 0 : s.liveSyncPosition) ?? 1 / 0);
}, Bz = function(s, t) {
  var r;
  (r = l(this, $n).player) == null || r.dispatch(m(this, Ht, jp).call(this, s, t));
}, qz = function(s, t) {
  const r = m(this, Ht, jp).call(this, s, t);
  let f = -1;
  for (let v = 0; v < t.tracks.length; v++) {
    const g = t.tracks[v], T = g.subtitleTrack ?? g.closedCaptions, x = new Jc({
      id: `hls-${g.kind}-${v}`,
      src: T == null ? void 0 : T.url,
      label: g.label,
      language: T == null ? void 0 : T.lang,
      kind: g.kind,
      default: g.default
    });
    x[ht.readyState] = 2, x[ht.onModeChange] = () => {
      x.mode === "showing" ? (l(this, It).subtitleTrack = v, f = v) : f === v && (l(this, It).subtitleTrack = -1, f = -1);
    }, l(this, $n).textTracks.add(x, r);
  }
}, jz = function(s, t) {
  var g;
  const r = (g = l(this, It)) == null ? void 0 : g.subtitleTrack, f = l(this, $n).textTracks.getById(`hls-${t.type}-${r}`);
  if (!f) return;
  const v = m(this, Ht, jp).call(this, s, t);
  for (const T of t.cues)
    T.positionAlign = "auto", f.addCue(T, v);
}, Gz = function(s, t) {
  const r = l(this, $n).audioTracks[t.id];
  if (r) {
    const f = m(this, Ht, jp).call(this, s, t);
    l(this, $n).audioTracks[ut.select](r, !0, f);
  }
}, Qz = function(s, t) {
  const r = l(this, $n).qualities[t.level];
  if (r) {
    const f = m(this, Ht, jp).call(this, s, t);
    l(this, $n).qualities[ut.select](r, !0, f);
  }
}, Yz = function(s, t) {
  t.details.totalduration > 0 && l(this, $n).$state.inferredLiveDVRWindow.set(t.details.totalduration);
}, Wz = function(s, t) {
  var $;
  if (l(this, $n).$state.canPlay()) return;
  const { type: r, live: f, totalduration: v, targetduration: g } = t.details, T = m(this, Ht, jp).call(this, s, t);
  l(this, $n).notify(
    "stream-type-change",
    f ? r === "EVENT" && Number.isFinite(v) && g >= 10 ? "live:dvr" : "live" : "on-demand",
    T
  ), l(this, $n).notify("duration-change", v, T);
  const x = l(this, It).media;
  l(this, It).currentLevel === -1 && l(this, $n).qualities[zr.setAuto](!0, T);
  for (const P of l(this, It).audioTracks) {
    const A = {
      id: P.id.toString(),
      label: P.name,
      language: P.lang || "",
      kind: "main"
    };
    l(this, $n).audioTracks[ut.add](A, T);
  }
  for (const P of l(this, It).levels) {
    const A = {
      id: (($ = P.id) == null ? void 0 : $.toString()) ?? P.height + "p",
      width: P.width,
      height: P.height,
      codec: P.codecSet,
      bitrate: P.bitrate
    };
    l(this, $n).qualities[ut.add](A, T);
  }
  x.dispatchEvent(new St("canplay", { trigger: T }));
}, Kz = function(s, t) {
  var r;
  if (t.fatal)
    switch (t.type) {
      case "mediaError":
        (r = l(this, It)) == null || r.recoverMediaError();
        break;
      default:
        m(this, Ht, Zz).call(this, t.error);
        break;
    }
}, Zz = function(s) {
  l(this, $n).notify("error", {
    message: s.message,
    code: 1,
    error: s
  });
}, Xz = function() {
  l(this, It) && (l(this, It).currentLevel = -1);
}, Jz = function() {
  const { qualities: s } = l(this, $n);
  !l(this, It) || s.auto || (l(this, It)[s.switch + "Level"] = s.selectedIndex, vw && (l(this, _m).currentTime = l(this, _m).currentTime));
}, eH = function() {
  const { audioTracks: s } = l(this, $n);
  l(this, It) && l(this, It).audioTrack !== s.selectedIndex && (l(this, It).audioTrack = s.selectedIndex);
};
var Nm, au, x0, Eu, tH, nH, iH, rH;
class pee {
  constructor(s, t, r) {
    k(this, Eu);
    k(this, Nm);
    k(this, au);
    k(this, x0);
    L(this, Nm, s), L(this, au, t), L(this, x0, r), m(this, Eu, tH).call(this);
  }
}
Nm = new WeakMap(), au = new WeakMap(), x0 = new WeakMap(), Eu = new WeakSet(), tH = async function() {
  const s = {
    onLoadStart: m(this, Eu, nH).bind(this),
    onLoaded: m(this, Eu, iH).bind(this),
    onLoadError: m(this, Eu, rH).bind(this)
  };
  let t = await vee(l(this, Nm), s);
  if (Di(t) && !qe(l(this, Nm)) && (t = await mee(l(this, Nm), s)), !t) return null;
  if (!t.isSupported()) {
    const r = "[vidstack] `hls.js` is not supported in this environment";
    return l(this, au).player.dispatch(new St("hls-unsupported")), l(this, au).notify("error", { message: r, code: 4 }), null;
  }
  return t;
}, nH = function() {
  l(this, au).player.dispatch(new St("hls-lib-load-start"));
}, iH = function(s) {
  l(this, au).player.dispatch(
    new St("hls-lib-loaded", {
      detail: s
    })
  ), l(this, x0).call(this, s);
}, rH = function(s) {
  const t = C2(s);
  l(this, au).player.dispatch(
    new St("hls-lib-load-error", {
      detail: t
    })
  ), l(this, au).notify("error", {
    message: t.message,
    code: 4,
    error: t
  });
};
async function mee(c, s = {}) {
  var t, r, f, v, g;
  if (!Di(c)) {
    if ((t = s.onLoadStart) == null || t.call(s), c.prototype && c.prototype !== Function)
      return (r = s.onLoaded) == null || r.call(s, c), c;
    try {
      const T = (f = await c()) == null ? void 0 : f.default;
      if (T && T.isSupported)
        (v = s.onLoaded) == null || v.call(s, T);
      else
        throw Error(
          ""
        );
      return T;
    } catch (T) {
      (g = s.onLoadError) == null || g.call(s, T);
    }
  }
}
async function vee(c, s = {}) {
  var t, r, f;
  if (qe(c)) {
    (t = s.onLoadStart) == null || t.call(s);
    try {
      if (await Uk(c), !Ma(window.Hls))
        throw Error(
          ""
        );
      const v = window.Hls;
      return (r = s.onLoaded) == null || r.call(s, v), v;
    } catch (v) {
      (f = s.onLoadError) == null || f.call(s, v);
    }
  }
}
const yee = "https://cdn.jsdelivr.net";
var R0, nl, Wf;
class aH extends jk {
  constructor() {
    super(...arguments);
    I(this, "$$PROVIDER_TYPE", "HLS");
    k(this, R0, null);
    k(this, nl, new hee(this.video, this.ctx));
    k(this, Wf, `${yee}/npm/hls.js@^1.5.0/dist/hls.min.js`);
  }
  /**
   * The `hls.js` constructor.
   */
  get ctor() {
    return l(this, R0);
  }
  /**
   * The current `hls.js` instance.
   */
  get instance() {
    return l(this, nl).instance;
  }
  get type() {
    return "hls";
  }
  get canLiveSync() {
    return !0;
  }
  /**
   * The `hls.js` configuration object.
   *
   * @see {@link https://github.com/video-dev/hls.js/blob/master/docs/API.md#fine-tuning}
   */
  get config() {
    return l(this, nl).config;
  }
  set config(t) {
    l(this, nl).config = t;
  }
  /**
   * The `hls.js` constructor (supports dynamic imports) or a URL of where it can be found.
   *
   * @defaultValue `https://cdn.jsdelivr.net/npm/hls.js@^1.0.0/dist/hls.min.js`
   */
  get library() {
    return l(this, Wf);
  }
  set library(t) {
    L(this, Wf, t);
  }
  preconnect() {
    qe(l(this, Wf)) && ld(l(this, Wf));
  }
  setup() {
    super.setup(), new pee(l(this, Wf), this.ctx, (t) => {
      L(this, R0, t), l(this, nl).setup(t), this.ctx.notify("provider-setup", this);
      const r = fe(this.ctx.$state.source);
      r && this.loadSource(r);
    });
  }
  async loadSource(t, r) {
    if (!qe(t.src)) {
      this.removeSource();
      return;
    }
    this.media.preload = r || "", this.appendSource(t, "application/x-mpegurl"), l(this, nl).loadSource(t), this.currentSrc = t;
  }
  /**
   * The given callback is invoked when a new `hls.js` instance is created and right before it's
   * attached to media.
   */
  onInstance(t) {
    const r = l(this, nl).instance;
    return r && t(r), l(this, nl).onInstance(t);
  }
  destroy() {
    l(this, nl).destroy();
  }
}
R0 = new WeakMap(), nl = new WeakMap(), Wf = new WeakMap(), /**
 * Whether `hls.js` is supported in this environment.
 */
I(aH, "supported", yw());
const gee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  HLSProvider: aH
}, Symbol.toStringTag, { value: "Module" }));
var su, M1, oH, lH;
class sH {
  constructor(s) {
    k(this, M1);
    k(this, su);
    I(this, "src", nt(""));
    /**
     * Defines which referrer is sent when fetching the resource.
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLIFrameElement/referrerPolicy}
     */
    I(this, "referrerPolicy", null);
    L(this, su, s), s.setAttribute("frameBorder", "0"), s.setAttribute("aria-hidden", "true"), s.setAttribute(
      "allow",
      "autoplay; fullscreen; encrypted-media; picture-in-picture; accelerometer; gyroscope"
    ), this.referrerPolicy !== null && s.setAttribute("referrerpolicy", this.referrerPolicy);
  }
  get iframe() {
    return l(this, su);
  }
  setup() {
    sn(window, "message", m(this, M1, lH).bind(this)), sn(l(this, su), "load", this.onLoad.bind(this)), K(m(this, M1, oH).bind(this));
  }
  postMessage(s, t) {
    var r;
    Oe || (r = l(this, su).contentWindow) == null || r.postMessage(JSON.stringify(s), t ?? "*");
  }
}
su = new WeakMap(), M1 = new WeakSet(), oH = function() {
  const s = this.src();
  if (!s.length) {
    l(this, su).setAttribute("src", "");
    return;
  }
  const t = fe(() => this.buildParams());
  l(this, su).setAttribute("src", lW(s, t));
}, lH = function(s) {
  var f;
  const t = this.getOrigin();
  if ((s.source === null || s.source === ((f = l(this, su)) == null ? void 0 : f.contentWindow)) && (!qe(t) || t === s.origin)) {
    try {
      const v = JSON.parse(s.data);
      v && this.onMessage(v, s);
      return;
    } catch {
    }
    s.data && this.onMessage(s.data, s);
  }
};
const Cee = /(?:https:\/\/)?(?:player\.)?vimeo(?:\.com)?\/(?:video\/)?(\d+)(?:(?:\?hash=|\?h=|\/)(.*))?/, f7 = /* @__PURE__ */ new Map(), Yb = /* @__PURE__ */ new Map();
function uH(c) {
  const s = c.match(Cee);
  return { videoId: s == null ? void 0 : s[1], hash: s == null ? void 0 : s[2] };
}
async function cH(c, s, t) {
  if (f7.has(c)) return f7.get(c);
  if (Yb.has(c)) return Yb.get(c);
  let r = `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${c}`;
  t && (r = r.concat(`?h=${t}`));
  const f = window.fetch(r, {
    mode: "cors",
    signal: s.signal
  }).then((v) => v.json()).then((v) => {
    var P, A;
    const g = /vimeocdn.com\/video\/(.*)?_/, T = (A = (P = v == null ? void 0 : v.thumbnail_url) == null ? void 0 : P.match(g)) == null ? void 0 : A[1], x = T ? `https://i.vimeocdn.com/video/${T}_1920x1080.webp` : "", $ = {
      title: (v == null ? void 0 : v.title) ?? "",
      duration: (v == null ? void 0 : v.duration) ?? 0,
      poster: x,
      pro: v.account_type !== "basic"
    };
    return f7.set(c, $), $;
  }).finally(() => Yb.delete(c));
  return Yb.set(c, f), f;
}
const See = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getVimeoVideoInfo: cH,
  resolveVimeoVideoId: uH
}, Symbol.toStringTag, { value: "Module" })), bee = [
  "bufferend",
  "bufferstart",
  // 'cuechange',
  "durationchange",
  "ended",
  "enterpictureinpicture",
  "error",
  "fullscreenchange",
  "leavepictureinpicture",
  "loaded",
  // 'loadeddata',
  // 'loadedmetadata',
  // 'loadstart',
  "playProgress",
  "loadProgress",
  "pause",
  "play",
  "playbackratechange",
  // 'progress',
  "qualitychange",
  "seeked",
  "seeking",
  // 'texttrackchange',
  "timeupdate",
  "volumechange",
  "waiting"
  // 'adstarted',
  // 'adcompleted',
  // 'aderror',
  // 'adskipped',
  // 'adallcompleted',
  // 'adclicked',
  // 'chapterchange',
  // 'chromecastconnected',
  // 'remoteplaybackavailabilitychange',
  // 'remoteplaybackconnecting',
  // 'remoteplaybackconnect',
  // 'remoteplaybackdisconnect',
  // 'liveeventended',
  // 'liveeventstarted',
  // 'livestreamoffline',
  // 'livestreamonline',
];
var Xe, ou, Kf, Vm, g1, L0, Zf, C1, sw, Um, Xf, S1, pe, dH, fH, hH, pH, zm, mH, vH, yH, j8, gH, CH, SH, bH, wH, G8, TH, EH, kH, Q8, xH, Y8, RH, W8, LH, $H, Vi, K8, Z8;
class wee extends sH {
  constructor(t, r) {
    super(t);
    k(this, pe);
    I(this, "$$PROVIDER_TYPE", "VIMEO");
    I(this, "scope", Xc());
    I(this, "fullscreen");
    k(this, Xe);
    k(this, ou, nt(""));
    k(this, Kf, nt(!1));
    k(this, Vm, null);
    k(this, g1, null);
    k(this, L0, !1);
    k(this, Zf, new Ui(0, 0));
    k(this, C1, new U0(m(this, pe, pH).bind(this)));
    k(this, sw, null);
    k(this, Um, null);
    k(this, Xf, /* @__PURE__ */ new Map());
    k(this, S1, null);
    /**
     * Whether tracking session data should be enabled on the embed, including cookies and analytics.
     * This is turned off by default to be GDPR-compliant.
     *
     * @defaultValue `false`
     */
    I(this, "cookies", !1);
    I(this, "title", !0);
    I(this, "byline", !0);
    I(this, "portrait", !0);
    I(this, "color", "00ADEF");
    // Embed will sometimes dispatch 0 at end of playback.
    k(this, zm, !1);
    L(this, Xe, r);
    const f = this;
    this.fullscreen = {
      get active() {
        return l(f, L0);
      },
      supported: !0,
      enter: () => m(this, pe, Vi).call(this, "requestFullscreen"),
      exit: () => m(this, pe, Vi).call(this, "exitFullscreen")
    };
  }
  get type() {
    return "vimeo";
  }
  get currentSrc() {
    return l(this, g1);
  }
  get videoId() {
    return l(this, ou).call(this);
  }
  get hash() {
    return l(this, Vm);
  }
  get isPro() {
    return l(this, Kf).call(this);
  }
  preconnect() {
    ld(this.getOrigin());
  }
  setup() {
    super.setup(), K(m(this, pe, dH).bind(this)), K(m(this, pe, fH).bind(this)), K(m(this, pe, hH).bind(this)), l(this, Xe).notify("provider-setup", this);
  }
  destroy() {
    m(this, pe, K8).call(this), this.fullscreen = void 0;
    const t = "provider destroyed";
    for (const r of l(this, Xf).values())
      for (const { reject: f } of r) f(t);
    l(this, Xf).clear(), m(this, pe, Vi).call(this, "destroy");
  }
  async play() {
    return m(this, pe, Vi).call(this, "play");
  }
  async pause() {
    return m(this, pe, Vi).call(this, "pause");
  }
  setMuted(t) {
    m(this, pe, Vi).call(this, "setMuted", t);
  }
  setCurrentTime(t) {
    m(this, pe, Vi).call(this, "seekTo", t), l(this, Xe).notify("seeking", t);
  }
  setVolume(t) {
    m(this, pe, Vi).call(this, "setVolume", t), m(this, pe, Vi).call(this, "setMuted", fe(l(this, Xe).$state.muted));
  }
  setPlaybackRate(t) {
    m(this, pe, Vi).call(this, "setPlaybackRate", t);
  }
  async loadSource(t) {
    if (!qe(t.src)) {
      L(this, g1, null), L(this, Vm, null), l(this, ou).set("");
      return;
    }
    const { videoId: r, hash: f } = uH(t.src);
    l(this, ou).set(r ?? ""), L(this, Vm, f ?? null), L(this, g1, t);
  }
  getOrigin() {
    return "https://player.vimeo.com";
  }
  buildParams() {
    const { keyDisabled: t } = l(this, Xe).$props, { playsInline: r, nativeControls: f } = l(this, Xe).$state, v = f();
    return {
      title: this.title,
      byline: this.byline,
      color: this.color,
      portrait: this.portrait,
      controls: v,
      h: this.hash,
      keyboard: v && !t(),
      transparent: !0,
      playsinline: r(),
      dnt: !this.cookies
    };
  }
  onMessage(t, r) {
    t.event ? m(this, pe, LH).call(this, t.event, t.data, r) : t.method && m(this, pe, gH).call(this, t.method, t.value, r);
  }
  onLoad() {
  }
}
Xe = new WeakMap(), ou = new WeakMap(), Kf = new WeakMap(), Vm = new WeakMap(), g1 = new WeakMap(), L0 = new WeakMap(), Zf = new WeakMap(), C1 = new WeakMap(), sw = new WeakMap(), Um = new WeakMap(), Xf = new WeakMap(), S1 = new WeakMap(), pe = new WeakSet(), dH = function() {
  m(this, pe, K8).call(this);
  const t = l(this, ou).call(this);
  if (!t) {
    this.src.set("");
    return;
  }
  this.src.set(`${this.getOrigin()}/video/${t}`), l(this, Xe).notify("load-start");
}, fH = function() {
  const t = l(this, ou).call(this);
  if (!t) return;
  const r = Qm(), f = new AbortController();
  return L(this, S1, r), cH(t, f, l(this, Vm)).then((v) => {
    r.resolve(v);
  }).catch((v) => {
    r.reject();
  }), () => {
    r.reject(), f.abort();
  };
}, hH = function() {
  const t = l(this, Kf).call(this), { $state: r, qualities: f } = l(this, Xe);
  if (r.canSetPlaybackRate.set(t), f[ut.setReadonly](!t), t)
    return sn(f, "change", () => {
      var g;
      if (f.auto) return;
      const v = (g = f.selected) == null ? void 0 : g.id;
      v && m(this, pe, Vi).call(this, "setQuality", v);
    });
}, pH = function() {
  m(this, pe, Vi).call(this, "getCurrentTime");
}, zm = new WeakMap(), mH = function(t, r) {
  if (l(this, zm) && t === 0) return;
  const { realCurrentTime: f, paused: v, bufferedEnd: g, seekableEnd: T, live: x } = l(this, Xe).$state;
  if (f() === t) return;
  const $ = f();
  l(this, Xe).notify("time-change", t, r), Math.abs($ - t) > 1.5 && (l(this, Xe).notify("seeking", t, r), !v() && g() < t && l(this, Xe).notify("waiting", void 0, r)), !x() && T() - t < 0.01 && (l(this, Xe).notify("end", void 0, r), L(this, zm, !0), setTimeout(() => {
    L(this, zm, !1);
  }, 500));
}, vH = function(t, r) {
  l(this, Xe).notify("seeked", t, r);
}, yH = function(t) {
  var f;
  const r = l(this, ou).call(this);
  (f = l(this, S1)) == null || f.promise.then((v) => {
    if (!v) return;
    const { title: g, poster: T, duration: x, pro: $ } = v;
    l(this, Kf).set($), l(this, Xe).notify("title-change", g, t), l(this, Xe).notify("poster-change", T, t), l(this, Xe).notify("duration-change", x, t), m(this, pe, j8).call(this, x, t);
  }).catch(() => {
    r === l(this, ou).call(this) && (m(this, pe, Vi).call(this, "getVideoTitle"), m(this, pe, Vi).call(this, "getDuration"));
  });
}, j8 = function(t, r) {
  const { nativeControls: f } = l(this, Xe).$state, v = f();
  L(this, Zf, new Ui(0, t));
  const g = {
    buffered: new Ui(0, 0),
    seekable: l(this, Zf),
    duration: t
  };
  l(this, Xe).delegate.ready(g, r), v || m(this, pe, Vi).call(this, "_hideOverlay"), m(this, pe, Vi).call(this, "getQualities"), m(this, pe, Vi).call(this, "getChapters");
}, gH = function(t, r, f) {
  var v;
  switch (t) {
    case "getVideoTitle":
      const g = r;
      l(this, Xe).notify("title-change", g, f);
      break;
    case "getDuration":
      const T = r;
      l(this, Xe).$state.canPlay() ? l(this, Xe).notify("duration-change", T, f) : m(this, pe, j8).call(this, T, f);
      break;
    case "getCurrentTime":
      m(this, pe, mH).call(this, r, f);
      break;
    case "getBuffered":
      vr(r) && r.length && m(this, pe, G8).call(this, r[r.length - 1][1], f);
      break;
    case "setMuted":
      m(this, pe, Q8).call(this, fe(l(this, Xe).$state.volume), r, f);
      break;
    // case 'getTextTracks':
    //   this.#onTextTracksChange(data as VimeoTextTrack[], trigger);
    //   break;
    case "getChapters":
      m(this, pe, xH).call(this, r);
      break;
    case "getQualities":
      m(this, pe, RH).call(this, r, f);
      break;
  }
  (v = m(this, pe, Z8).call(this, t)) == null || v.resolve();
}, CH = function() {
  for (const t of bee)
    m(this, pe, Vi).call(this, "addEventListener", t);
}, SH = function(t) {
  l(this, C1).stop(), l(this, Xe).notify("pause", void 0, t);
}, bH = function(t) {
  l(this, C1).start(), l(this, Xe).notify("play", void 0, t);
}, wH = function(t) {
  const { paused: r } = l(this, Xe).$state;
  !r() && !l(this, zm) && l(this, Xe).notify("playing", void 0, t);
}, G8 = function(t, r) {
  const f = {
    buffered: new Ui(0, t),
    seekable: l(this, Zf)
  };
  l(this, Xe).notify("progress", f, r);
}, TH = function(t) {
  l(this, Xe).notify("waiting", void 0, t);
}, EH = function(t) {
  const { paused: r } = l(this, Xe).$state;
  r() || l(this, Xe).notify("playing", void 0, t);
}, kH = function(t) {
  const { paused: r } = l(this, Xe).$state;
  r() && l(this, Xe).notify("play", void 0, t), l(this, Xe).notify("waiting", void 0, t);
}, Q8 = function(t, r, f) {
  const v = { volume: t, muted: r };
  l(this, Xe).notify("volume-change", v, f);
}, // #onTextTrackChange(track: VimeoTextTrack, trigger: Event) {
//   const textTrack = this.#ctx.textTracks.toArray().find((t) => t.language === track.language);
//   if (textTrack) textTrack.mode = track.mode;
// }
// #onTextTracksChange(tracks: VimeoTextTrack[], trigger: Event) {
//   for (const init of tracks) {
//     const textTrack = new TextTrack({
//       ...init,
//       label: init.label.replace('auto-generated', 'auto'),
//     });
//     textTrack[TextTrackSymbol.readyState] = 2;
//     this.#ctx.textTracks.add(textTrack, trigger);
//     textTrack.setMode(init.mode, trigger);
//   }
// }
// #onCueChange(cue: VimeoTextCue, trigger: Event) {
//   const { textTracks, $state } = this.#ctx,
//     { currentTime } = $state,
//     track = textTracks.selected;
//   if (this.#currentCue) track?.removeCue(this.#currentCue, trigger);
//   this.#currentCue = new window.VTTCue(currentTime(), Number.MAX_SAFE_INTEGER, cue.text);
//   track?.addCue(this.#currentCue, trigger);
// }
xH = function(t) {
  if (m(this, pe, Y8).call(this), !t.length) return;
  const r = new Jc({
    kind: "chapters",
    default: !0
  }), { seekableEnd: f } = l(this, Xe).$state;
  for (let v = 0; v < t.length; v++) {
    const g = t[v], T = t[v + 1];
    r.addCue(
      new window.VTTCue(
        g.startTime,
        (T == null ? void 0 : T.startTime) ?? f(),
        g.title
      )
    );
  }
  L(this, Um, r), l(this, Xe).textTracks.add(r);
}, Y8 = function() {
  l(this, Um) && (l(this, Xe).textTracks.remove(l(this, Um)), L(this, Um, null));
}, RH = function(t, r) {
  l(this, Xe).qualities[zr.enableAuto] = t.some((f) => f.id === "auto") ? () => m(this, pe, Vi).call(this, "setQuality", "auto") : void 0;
  for (const f of t) {
    if (f.id === "auto") continue;
    const v = +f.id.slice(0, -1);
    isNaN(v) || l(this, Xe).qualities[ut.add](
      {
        id: f.id,
        width: v * (16 / 9),
        height: v,
        codec: "avc1,h.264",
        bitrate: -1
      },
      r
    );
  }
  m(this, pe, W8).call(this, t.find((f) => f.active), r);
}, W8 = function({ id: t } = {}, r) {
  if (!t) return;
  const f = t === "auto", v = l(this, Xe).qualities.getById(t);
  f ? (l(this, Xe).qualities[zr.setAuto](f, r), l(this, Xe).qualities[ut.select](void 0, !0, r)) : l(this, Xe).qualities[ut.select](v ?? void 0, !0, r);
}, LH = function(t, r, f) {
  switch (t) {
    case "ready":
      m(this, pe, CH).call(this);
      break;
    case "loaded":
      m(this, pe, yH).call(this, f);
      break;
    case "play":
      m(this, pe, bH).call(this, f);
      break;
    case "playProgress":
      m(this, pe, wH).call(this, f);
      break;
    case "pause":
      m(this, pe, SH).call(this, f);
      break;
    case "loadProgress":
      m(this, pe, G8).call(this, r.seconds, f);
      break;
    case "waiting":
      m(this, pe, kH).call(this, f);
      break;
    case "bufferstart":
      m(this, pe, TH).call(this, f);
      break;
    case "bufferend":
      m(this, pe, EH).call(this, f);
      break;
    case "volumechange":
      m(this, pe, Q8).call(this, r.volume, fe(l(this, Xe).$state.muted), f);
      break;
    case "durationchange":
      L(this, Zf, new Ui(0, r.duration)), l(this, Xe).notify("duration-change", r.duration, f);
      break;
    case "playbackratechange":
      l(this, Xe).notify("rate-change", r.playbackRate, f);
      break;
    case "qualitychange":
      m(this, pe, W8).call(this, r, f);
      break;
    case "fullscreenchange":
      L(this, L0, r.fullscreen), l(this, Xe).notify("fullscreen-change", r.fullscreen, f);
      break;
    case "enterpictureinpicture":
      l(this, Xe).notify("picture-in-picture-change", !0, f);
      break;
    case "leavepictureinpicture":
      l(this, Xe).notify("picture-in-picture-change", !1, f);
      break;
    case "ended":
      l(this, Xe).notify("end", void 0, f);
      break;
    case "error":
      m(this, pe, $H).call(this, r, f);
      break;
    case "seek":
    case "seeked":
      m(this, pe, vH).call(this, r.seconds, f);
      break;
  }
}, $H = function(t, r) {
  var g;
  const { message: f, method: v } = t;
  v === "setPlaybackRate" && l(this, Kf).set(!1), v && ((g = m(this, pe, Z8).call(this, v)) == null || g.reject(f));
}, Vi = async function(t, r) {
  let f = Qm(), v = l(this, Xf).get(t);
  return v || l(this, Xf).set(t, v = []), v.push(f), this.postMessage({
    method: t,
    value: r
  }), f.promise;
}, K8 = function() {
  l(this, C1).stop(), L(this, Zf, new Ui(0, 0)), L(this, S1, null), L(this, sw, null), l(this, Kf).set(!1), m(this, pe, Y8).call(this);
}, Z8 = function(t) {
  var r;
  return (r = l(this, Xf).get(t)) == null ? void 0 : r.shift();
};
const Tee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  VimeoProvider: wee
}, Symbol.toStringTag, { value: "Module" })), Eee = /(?:youtu\.be|youtube|youtube\.com|youtube-nocookie\.com)(?:\/shorts)?\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=|)((?:\w|-){11})/, h7 = /* @__PURE__ */ new Map(), Wb = /* @__PURE__ */ new Map();
function DH(c) {
  var s;
  return (s = c.match(Eee)) == null ? void 0 : s[1];
}
async function kee(c, s) {
  if (h7.has(c)) return h7.get(c);
  if (Wb.has(c)) return Wb.get(c);
  const t = new Promise(async (r) => {
    const f = ["maxresdefault", "sddefault", "hqdefault"];
    for (const v of f)
      for (const g of [!0, !1]) {
        const T = xee(c, v, g);
        if ((await fetch(T, {
          mode: "no-cors",
          signal: s.signal
        })).status < 400) {
          h7.set(c, T), r(T);
          return;
        }
      }
  }).catch(() => "").finally(() => Wb.delete(c));
  return Wb.set(c, t), t;
}
function xee(c, s, t) {
  return `https://i.ytimg.com/${t ? "vi_webp" : "vi"}/${c}/${s}.${t ? "webp" : "jpg"}`;
}
const Ree = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  findYouTubePoster: kee,
  resolveYouTubeVideoId: DH
}, Symbol.toStringTag, { value: "Module" })), zp = {
  Ended: 0,
  Playing: 1,
  Paused: 2,
  Buffering: 3,
  Cued: 5
};
var tn, Hm, Fm, b1, Im, Jf, Zc, kt, $ee, Dee, MH, cf, AH, PH, OH, X8, w9, _H, NH, J8, m2, VH;
class Lee extends sH {
  constructor(t, r) {
    super(t);
    k(this, kt);
    I(this, "$$PROVIDER_TYPE", "YOUTUBE");
    I(this, "scope", Xc());
    k(this, tn);
    k(this, Hm, nt(""));
    k(this, Fm, -1);
    k(this, b1, null);
    k(this, Im, -1);
    k(this, Jf, !1);
    k(this, Zc, /* @__PURE__ */ new Map());
    /**
     * Sets the player's interface language. The parameter value is an ISO 639-1 two-letter
     * language code or a fully specified locale. For example, fr and fr-ca are both valid values.
     * Other language input codes, such as IETF language tags (BCP 47) might also be handled properly.
     *
     * The interface language is used for tooltips in the player and also affects the default caption
     * track. Note that YouTube might select a different caption track language for a particular
     * user based on the user's individual language preferences and the availability of caption tracks.
     *
     * @defaultValue 'en'
     */
    I(this, "language", "en");
    I(this, "color", "red");
    /**
     * Whether cookies should be enabled on the embed. This is turned off by default to be
     * GDPR-compliant.
     *
     * @defaultValue `false`
     */
    I(this, "cookies", !1);
    L(this, tn, r);
  }
  get currentSrc() {
    return l(this, b1);
  }
  get type() {
    return "youtube";
  }
  get videoId() {
    return l(this, Hm).call(this);
  }
  preconnect() {
    ld(this.getOrigin());
  }
  setup() {
    super.setup(), K(m(this, kt, MH).bind(this)), l(this, tn).notify("provider-setup", this);
  }
  destroy() {
    m(this, kt, J8).call(this);
    const t = "provider destroyed";
    for (const r of l(this, Zc).values())
      for (const { reject: f } of r) f(t);
    l(this, Zc).clear();
  }
  async play() {
    return m(this, kt, cf).call(this, "playVideo");
  }
  async pause() {
    return m(this, kt, cf).call(this, "pauseVideo");
  }
  setMuted(t) {
    t ? m(this, kt, cf).call(this, "mute") : m(this, kt, cf).call(this, "unMute");
  }
  setCurrentTime(t) {
    m(this, kt, cf).call(this, "seekTo", t), l(this, tn).notify("seeking", t);
  }
  setVolume(t) {
    m(this, kt, cf).call(this, "setVolume", t * 100);
  }
  setPlaybackRate(t) {
    m(this, kt, cf).call(this, "setPlaybackRate", t);
  }
  async loadSource(t) {
    if (!qe(t.src)) {
      L(this, b1, null), l(this, Hm).set("");
      return;
    }
    const r = DH(t.src);
    l(this, Hm).set(r ?? ""), L(this, b1, t);
  }
  getOrigin() {
    return this.cookies ? "https://www.youtube.com" : "https://www.youtube-nocookie.com";
  }
  buildParams() {
    const { keyDisabled: t } = l(this, tn).$props, { muted: r, playsInline: f, nativeControls: v } = l(this, tn).$state, g = v();
    return {
      rel: 0,
      autoplay: 0,
      cc_lang_pref: this.language,
      cc_load_policy: g ? 1 : void 0,
      color: this.color,
      controls: g ? 1 : 0,
      disablekb: !g || t() ? 1 : 0,
      enablejsapi: 1,
      fs: 1,
      hl: this.language,
      iv_load_policy: g ? 1 : 3,
      mute: r() ? 1 : 0,
      playsinline: f() ? 1 : 0
    };
  }
  onLoad() {
    window.setTimeout(() => this.postMessage({ event: "listening" }), 100);
  }
  onMessage({ info: t }, r) {
    var T;
    if (!t) return;
    const { title: f, intrinsicDuration: v, playbackRate: g } = l(this, tn).$state;
    if (kk(t.videoData) && t.videoData.title !== f() && l(this, tn).notify("title-change", t.videoData.title, r), ar(t.duration) && t.duration !== v()) {
      if (ar(t.videoLoadedFraction)) {
        const x = ((T = t.progressState) == null ? void 0 : T.loaded) ?? t.videoLoadedFraction * t.duration, $ = new Ui(0, t.duration);
        m(this, kt, X8).call(this, x, $, r);
      }
      l(this, tn).notify("duration-change", t.duration, r);
    }
    if (ar(t.playbackRate) && t.playbackRate !== g() && l(this, tn).notify("rate-change", t.playbackRate, r), t.progressState) {
      const { current: x, seekableStart: $, seekableEnd: P, loaded: A, duration: U } = t.progressState;
      m(this, kt, OH).call(this, x, r), m(this, kt, X8).call(this, A, new Ui($, P), r), U !== v() && l(this, tn).notify("duration-change", U, r);
    }
    if (ar(t.volume) && iM(t.muted) && !l(this, Jf)) {
      const x = {
        muted: t.muted,
        volume: t.volume / 100
      };
      l(this, tn).notify("volume-change", x, r);
    }
    ar(t.playerState) && t.playerState !== l(this, Fm) && m(this, kt, NH).call(this, t.playerState, r);
  }
}
tn = new WeakMap(), Hm = new WeakMap(), Fm = new WeakMap(), b1 = new WeakMap(), Im = new WeakMap(), Jf = new WeakMap(), Zc = new WeakMap(), kt = new WeakSet(), $ee = function(t) {
  var r;
  (r = m(this, kt, m2).call(this, "playVideo")) == null || r.reject(t);
}, Dee = function(t) {
  var r;
  (r = m(this, kt, m2).call(this, "pauseVideo")) == null || r.reject(t);
}, MH = function() {
  m(this, kt, J8).call(this);
  const t = l(this, Hm).call(this);
  if (!t) {
    this.src.set("");
    return;
  }
  this.src.set(`${this.getOrigin()}/embed/${t}`), l(this, tn).notify("load-start");
}, cf = function(t, r) {
  let f = Qm(), v = l(this, Zc).get(t);
  return v || l(this, Zc).set(t, v = []), v.push(f), this.postMessage({
    event: "command",
    func: t,
    args: r ? [r] : void 0
  }), f.promise;
}, AH = function(t) {
  l(this, tn).notify("loaded-metadata"), l(this, tn).notify("loaded-data"), l(this, tn).delegate.ready(void 0, t);
}, PH = function(t) {
  var r;
  (r = m(this, kt, m2).call(this, "pauseVideo")) == null || r.resolve(), l(this, tn).notify("pause", void 0, t);
}, OH = function(t, r) {
  const { duration: f, realCurrentTime: v } = l(this, tn).$state, g = l(this, Fm) === zp.Ended, T = g ? f() : t;
  l(this, tn).notify("time-change", T, r), !g && Math.abs(T - v()) > 1 && l(this, tn).notify("seeking", T, r);
}, X8 = function(t, r, f) {
  const v = {
    buffered: new Ui(0, t),
    seekable: r
  };
  l(this, tn).notify("progress", v, f);
  const { seeking: g, realCurrentTime: T } = l(this, tn).$state;
  g() && t > T() && m(this, kt, w9).call(this, f);
}, w9 = function(t) {
  const { paused: r, realCurrentTime: f } = l(this, tn).$state;
  window.clearTimeout(l(this, Im)), L(this, Im, window.setTimeout(
    () => {
      l(this, tn).notify("seeked", f(), t), L(this, Im, -1);
    },
    r() ? 100 : 0
  ));
}, _H = function(t) {
  const { seeking: r } = l(this, tn).$state;
  r() && m(this, kt, w9).call(this, t), l(this, tn).notify("pause", void 0, t), l(this, tn).notify("end", void 0, t);
}, NH = function(t, r) {
  var P;
  const { paused: f, seeking: v } = l(this, tn).$state, g = t === zp.Playing, T = t === zp.Buffering, x = m(this, kt, VH).call(this, "playVideo"), $ = f() && (T || g);
  if (T && l(this, tn).notify("waiting", void 0, r), v() && g && m(this, kt, w9).call(this, r), l(this, Jf) && g) {
    this.pause(), L(this, Jf, !1), this.setMuted(l(this, tn).$state.muted());
    return;
  }
  if (!x && $) {
    L(this, Jf, !0), this.setMuted(!0);
    return;
  }
  switch ($ && ((P = m(this, kt, m2).call(this, "playVideo")) == null || P.resolve(), l(this, tn).notify("play", void 0, r)), t) {
    case zp.Cued:
      m(this, kt, AH).call(this, r);
      break;
    case zp.Playing:
      l(this, tn).notify("playing", void 0, r);
      break;
    case zp.Paused:
      m(this, kt, PH).call(this, r);
      break;
    case zp.Ended:
      m(this, kt, _H).call(this, r);
      break;
  }
  L(this, Fm, t);
}, J8 = function() {
  L(this, Fm, -1), L(this, Im, -1), L(this, Jf, !1);
}, m2 = function(t) {
  var r;
  return (r = l(this, Zc).get(t)) == null ? void 0 : r.shift();
}, VH = function(t) {
  var r;
  return !!((r = l(this, Zc).get(t)) != null && r.length);
};
const Mee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  YouTubeProvider: Lee
}, Symbol.toStringTag, { value: "Module" }));
function Aee() {
  return "https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1";
}
function Pee() {
  var c;
  return !!((c = window.cast) != null && c.framework);
}
function Oee() {
  var c, s;
  return !!((s = (c = window.chrome) == null ? void 0 : c.cast) != null && s.isAvailable);
}
function ND() {
  return U1().getCastState() === cast.framework.CastState.CONNECTED;
}
function U1() {
  return window.cast.framework.CastContext.getInstance();
}
function bw() {
  return U1().getCurrentSession();
}
function ww() {
  var c;
  return (c = bw()) == null ? void 0 : c.getSessionObj().media[0];
}
function ek(c) {
  var t;
  return ((t = ww()) == null ? void 0 : t.media.contentId) === (c == null ? void 0 : c.src);
}
function _ee() {
  return {
    language: "en-US",
    autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
    receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
    resumeSavedSession: !0,
    androidReceiverCompatible: !0
  };
}
function ux(c) {
  return `Google Cast Error Code: ${c}`;
}
function UH(c, s) {
  return sn(U1(), c, s);
}
var eh, ua, zH, HH, FH, T9, E9;
class Nee {
  constructor() {
    k(this, ua);
    I(this, "name", "google-cast");
    I(this, "target");
    k(this, eh);
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
   */
  get cast() {
    return U1();
  }
  mediaType() {
    return "video";
  }
  canPlay(s) {
    return vw && !mw && qM(s);
  }
  async prompt(s) {
    var v;
    let t, r, f;
    try {
      t = await m(this, ua, zH).call(this, s), l(this, eh) || (L(this, eh, new cast.framework.RemotePlayer()), new cast.framework.RemotePlayerController(l(this, eh))), r = s.player.createEvent("google-cast-prompt-open", {
        trigger: t
      }), s.player.dispatchEvent(r), m(this, ua, T9).call(this, s, "connecting", r), await m(this, ua, HH).call(this, fe(s.$props.googleCast)), s.$state.remotePlaybackInfo.set({
        deviceName: (v = bw()) == null ? void 0 : v.getCastDevice().friendlyName
      }), ND() && m(this, ua, T9).call(this, s, "connected", r);
    } catch (g) {
      const T = g instanceof Error ? g : m(this, ua, E9).call(this, (g + "").toUpperCase(), "Prompt failed.");
      throw f = s.player.createEvent("google-cast-prompt-error", {
        detail: T,
        trigger: r ?? t,
        cancelable: !0
      }), s.player.dispatch(f), m(this, ua, T9).call(this, s, ND() ? "connected" : "disconnected", f), T;
    } finally {
      s.player.dispatch("google-cast-prompt-close", {
        trigger: f ?? r ?? t
      });
    }
  }
  async load(s) {
    if (Oe)
      throw Error("[vidstack] can not load google cast provider server-side");
    if (!l(this, eh))
      throw Error("[vidstack] google cast player was not initialized");
    return new (await Promise.resolve().then(() => Iee)).GoogleCastProvider(l(this, eh), s);
  }
}
eh = new WeakMap(), ua = new WeakSet(), zH = async function(s) {
  if (Pee()) return;
  const t = s.player.createEvent("google-cast-load-start");
  s.player.dispatch(t), await Uk(Aee()), await customElements.whenDefined("google-cast-launcher");
  const r = s.player.createEvent("google-cast-loaded", { trigger: t });
  if (s.player.dispatch(r), !Oee())
    throw m(this, ua, E9).call(this, "CAST_NOT_AVAILABLE", "Google Cast not available on this platform.");
  return r;
}, HH = async function(s) {
  m(this, ua, FH).call(this, s);
  const t = await this.cast.requestSession();
  if (t)
    throw m(this, ua, E9).call(this, t.toUpperCase(), ux(t));
}, FH = function(s) {
  var t;
  (t = this.cast) == null || t.setOptions({
    ..._ee(),
    ...s
  });
}, T9 = function(s, t, r) {
  const f = { type: "google-cast", state: t };
  s.notify("remote-playback-change", f, r);
}, E9 = function(s, t) {
  const r = Error(t);
  return r.code = s, r;
};
var Vee = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  GoogleCastLoader: Nee
});
const Uee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  getCastContext: U1,
  getCastErrorMessage: ux,
  getCastSession: bw,
  getCastSessionMedia: ww,
  hasActiveCastSession: ek,
  listenCastContextEvent: UH,
  loader: Vee
}, Symbol.toStringTag, { value: "Module" }));
var il, ow, IH;
class zee {
  constructor(s) {
    k(this, ow);
    k(this, il);
    L(this, il, new chrome.cast.media.MediaInfo(s.src, s.type));
  }
  build() {
    return l(this, il);
  }
  setStreamType(s) {
    return s.includes("live") ? l(this, il).streamType = chrome.cast.media.StreamType.LIVE : l(this, il).streamType = chrome.cast.media.StreamType.BUFFERED, this;
  }
  setTracks(s) {
    return l(this, il).tracks = s.map(m(this, ow, IH)), this;
  }
  setMetadata(s, t) {
    return l(this, il).metadata = new chrome.cast.media.GenericMediaMetadata(), l(this, il).metadata.title = s, l(this, il).metadata.images = [{ url: t }], this;
  }
}
il = new WeakMap(), ow = new WeakSet(), IH = function(s, t) {
  const r = new chrome.cast.media.Track(t, chrome.cast.media.TrackType.TEXT);
  return r.name = s.label, r.trackContentId = s.src, r.trackContentType = "text/vtt", r.language = s.language, r.subtype = s.kind.toUpperCase(), r;
};
var th, lu, $0, _n, tk, sg, BH, qH, jH, nk, k9, ik;
class Hee {
  constructor(s, t, r) {
    k(this, _n);
    k(this, th);
    k(this, lu);
    k(this, $0);
    L(this, th, s), L(this, lu, t), L(this, $0, r);
  }
  setup() {
    const s = this.syncRemoteActiveIds.bind(this);
    sn(l(this, lu).audioTracks, "change", s), sn(l(this, lu).textTracks, "mode-change", s), K(m(this, _n, qH).bind(this));
  }
  getLocalTextTracks() {
    return l(this, lu).$state.textTracks().filter((s) => s.src && s.type === "vtt");
  }
  syncRemoteTracks(s) {
    if (!l(this, th).isMediaLoaded) return;
    const t = m(this, _n, tk).call(this), r = this.getLocalTextTracks(), f = m(this, _n, sg).call(this, chrome.cast.media.TrackType.AUDIO), v = m(this, _n, sg).call(this, chrome.cast.media.TrackType.TEXT);
    for (const g of f) {
      if (m(this, _n, nk).call(this, t, g)) continue;
      const x = {
        id: g.trackId.toString(),
        label: g.name,
        language: g.language,
        kind: g.subtype ?? "main",
        selected: !1
      };
      l(this, lu).audioTracks[ut.add](x, s);
    }
    for (const g of v) {
      if (m(this, _n, nk).call(this, r, g)) continue;
      const x = {
        id: g.trackId.toString(),
        src: g.trackContentId,
        label: g.name,
        language: g.language,
        kind: g.subtype.toLowerCase()
      };
      l(this, lu).textTracks.add(x, s);
    }
  }
  syncRemoteActiveIds(s) {
    if (!l(this, th).isMediaLoaded) return;
    const t = m(this, _n, BH).call(this), r = new chrome.cast.media.EditTracksInfoRequest(t);
    m(this, _n, jH).call(this, r).catch((f) => {
    });
  }
}
th = new WeakMap(), lu = new WeakMap(), $0 = new WeakMap(), _n = new WeakSet(), tk = function() {
  return l(this, lu).$state.audioTracks();
}, sg = function(s) {
  var r;
  const t = ((r = l(this, th).mediaInfo) == null ? void 0 : r.tracks) ?? [];
  return s ? t.filter((f) => f.type === s) : t;
}, BH = function() {
  const s = [], t = m(this, _n, tk).call(this).find((f) => f.selected), r = this.getLocalTextTracks().filter((f) => f.mode === "showing");
  if (t) {
    const f = m(this, _n, sg).call(this, chrome.cast.media.TrackType.AUDIO), v = m(this, _n, k9).call(this, f, t);
    v && s.push(v.trackId);
  }
  if (r != null && r.length) {
    const f = m(this, _n, sg).call(this, chrome.cast.media.TrackType.TEXT);
    if (f.length)
      for (const v of r) {
        const g = m(this, _n, k9).call(this, f, v);
        g && s.push(g.trackId);
      }
  }
  return s;
}, qH = function() {
  const s = this.getLocalTextTracks();
  if (!l(this, th).isMediaLoaded) return;
  const t = m(this, _n, sg).call(this, chrome.cast.media.TrackType.TEXT);
  for (const r of s)
    if (!m(this, _n, k9).call(this, t, r)) {
      Gm(() => {
        var v;
        return (v = l(this, $0)) == null ? void 0 : v.call(this);
      });
      break;
    }
}, jH = function(s) {
  const t = ww();
  return new Promise((r, f) => t == null ? void 0 : t.editTracksInfo(s, r, f));
}, nk = function(s, t) {
  return s.find((r) => m(this, _n, ik).call(this, r, t));
}, k9 = function(s, t) {
  return s.find((r) => m(this, _n, ik).call(this, t, r));
}, // Note: we can't rely on id matching because they will differ between local/remote. A local
// track id might not even exist.
ik = function(s, t) {
  return t.name === s.label && t.language === s.language && t.subtype.toLowerCase() === s.kind.toLowerCase();
};
var Rt, Bt, nh, ih, D0, w1, Bm, qm, T1, M0, co, E1, $e, GH, QH, rk, YH, ak, WH, KH, ZH, sk, ok, lk, uk, XH, JH, eF, ck, tF, dk, nF, fk, Tc, iF, rF, hk, aF;
class Fee {
  constructor(s, t) {
    k(this, $e);
    I(this, "$$PROVIDER_TYPE", "GOOGLE_CAST");
    I(this, "scope", Xc());
    k(this, Rt);
    k(this, Bt);
    k(this, nh);
    k(this, ih, null);
    k(this, D0, "disconnected");
    k(this, w1, 0);
    k(this, Bm, 0);
    k(this, qm, new Ui(0, 0));
    k(this, T1, new U0(m(this, $e, KH).bind(this)));
    k(this, M0);
    k(this, co, null);
    k(this, E1, !1);
    L(this, Rt, s), L(this, Bt, t), L(this, nh, new Hee(s, t, m(this, $e, aF).bind(this)));
  }
  get type() {
    return "google-cast";
  }
  get currentSrc() {
    return l(this, ih);
  }
  /**
   * The Google Cast remote player.
   *
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.RemotePlayer}
   */
  get player() {
    return l(this, Rt);
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastContext}
   */
  get cast() {
    return U1();
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/cast.framework.CastSession}
   */
  get session() {
    return bw();
  }
  /**
   * @see {@link https://developers.google.com/cast/docs/reference/web_sender/chrome.cast.media.Media}
   */
  get media() {
    return ww();
  }
  /**
   * Whether the current Google Cast session belongs to this provider.
   */
  get hasActiveSession() {
    return ek(l(this, ih));
  }
  setup() {
    m(this, $e, GH).call(this), m(this, $e, QH).call(this), l(this, nh).setup(), l(this, Bt).notify("provider-setup", this);
  }
  async play() {
    var s;
    if (!(!l(this, Rt).isPaused && !l(this, E1))) {
      if (l(this, E1)) {
        await m(this, $e, hk).call(this, !1, 0);
        return;
      }
      (s = l(this, Rt).controller) == null || s.playOrPause();
    }
  }
  async pause() {
    var s;
    l(this, Rt).isPaused || (s = l(this, Rt).controller) == null || s.playOrPause();
  }
  getMediaStatus(s) {
    return new Promise((t, r) => {
      var f;
      (f = this.media) == null || f.getStatus(s, t, r);
    });
  }
  setMuted(s) {
    var r;
    (s && !l(this, Rt).isMuted || !s && l(this, Rt).isMuted) && ((r = l(this, Rt).controller) == null || r.muteOrUnmute());
  }
  setCurrentTime(s) {
    var t;
    l(this, Rt).currentTime = s, l(this, Bt).notify("seeking", s), (t = l(this, Rt).controller) == null || t.seek();
  }
  setVolume(s) {
    var t;
    l(this, Rt).volumeLevel = s, (t = l(this, Rt).controller) == null || t.setVolumeLevel();
  }
  async loadSource(s) {
    var f;
    if (((f = l(this, co)) == null ? void 0 : f.src) !== s && L(this, co, null), ek(s)) {
      m(this, $e, YH).call(this), L(this, ih, s);
      return;
    }
    l(this, Bt).notify("load-start");
    const t = m(this, $e, rF).call(this, s), r = await this.session.loadMedia(t);
    if (r) {
      L(this, ih, null), l(this, Bt).notify("error", Error(ux(r)));
      return;
    }
    L(this, ih, s);
  }
  destroy() {
    m(this, $e, rk).call(this), m(this, $e, ak).call(this);
  }
}
Rt = new WeakMap(), Bt = new WeakMap(), nh = new WeakMap(), ih = new WeakMap(), D0 = new WeakMap(), w1 = new WeakMap(), Bm = new WeakMap(), qm = new WeakMap(), T1 = new WeakMap(), M0 = new WeakMap(), co = new WeakMap(), E1 = new WeakMap(), $e = new WeakSet(), GH = function() {
  UH(
    cast.framework.CastContextEventType.CAST_STATE_CHANGED,
    m(this, $e, sk).bind(this)
  );
}, QH = function() {
  const s = cast.framework.RemotePlayerEventType, t = {
    [s.IS_CONNECTED_CHANGED]: m(this, $e, sk),
    [s.IS_MEDIA_LOADED_CHANGED]: m(this, $e, ok),
    [s.CAN_CONTROL_VOLUME_CHANGED]: m(this, $e, lk),
    [s.CAN_SEEK_CHANGED]: m(this, $e, uk),
    [s.DURATION_CHANGED]: m(this, $e, eF),
    [s.IS_MUTED_CHANGED]: m(this, $e, ck),
    [s.VOLUME_LEVEL_CHANGED]: m(this, $e, ck),
    [s.IS_PAUSED_CHANGED]: m(this, $e, tF),
    [s.LIVE_SEEKABLE_RANGE_CHANGED]: m(this, $e, dk),
    [s.PLAYER_STATE_CHANGED]: m(this, $e, nF)
  };
  L(this, M0, t);
  const r = m(this, $e, ZH).bind(this);
  for (const f of L7(t))
    l(this, Rt).controller.addEventListener(f, r);
  bt(() => {
    for (const f of L7(t))
      l(this, Rt).controller.removeEventListener(f, r);
  });
}, rk = function() {
  l(this, co) || (L(this, Bm, 0), L(this, qm, new Ui(0, 0))), l(this, T1).stop(), L(this, w1, 0), L(this, co, null);
}, YH = function() {
  const s = new St("resume-session", { detail: this.session });
  m(this, $e, ok).call(this, s);
  const { muted: t, volume: r, savedState: f } = l(this, Bt).$state, v = f();
  this.setCurrentTime(Math.max(l(this, Rt).currentTime, (v == null ? void 0 : v.currentTime) ?? 0)), this.setMuted(t()), this.setVolume(r()), (v == null ? void 0 : v.paused) === !1 && this.play();
}, ak = function() {
  this.cast.endCurrentSession(!0);
  const { remotePlaybackLoader: s } = l(this, Bt).$state;
  s.set(null);
}, WH = function() {
  const { savedState: s } = l(this, Bt).$state;
  s.set({
    paused: l(this, Rt).isPaused,
    currentTime: l(this, Rt).currentTime
  }), m(this, $e, ak).call(this);
}, KH = function() {
  m(this, $e, JH).call(this);
}, ZH = function(s) {
  l(this, M0)[s.type].call(this, s);
}, sk = function(s) {
  const t = this.cast.getCastState(), r = t === cast.framework.CastState.CONNECTED ? "connected" : t === cast.framework.CastState.CONNECTING ? "connecting" : "disconnected";
  if (l(this, D0) === r) return;
  const f = { type: "google-cast", state: r }, v = m(this, $e, Tc).call(this, s);
  L(this, D0, r), l(this, Bt).notify("remote-playback-change", f, v), r === "disconnected" && m(this, $e, WH).call(this);
}, ok = function(s) {
  if (!!!l(this, Rt).isMediaLoaded) return;
  const r = fe(l(this, Bt).$state.source);
  Promise.resolve().then(() => {
    if (r !== fe(l(this, Bt).$state.source) || !l(this, Rt).isMediaLoaded) return;
    m(this, $e, rk).call(this);
    const f = l(this, Rt).duration;
    L(this, qm, new Ui(0, f));
    const v = {
      provider: this,
      duration: f,
      buffered: new Ui(0, 0),
      seekable: m(this, $e, fk).call(this)
    }, g = m(this, $e, Tc).call(this, s);
    l(this, Bt).notify("loaded-metadata", void 0, g), l(this, Bt).notify("loaded-data", void 0, g), l(this, Bt).notify("can-play", v, g), m(this, $e, lk).call(this), m(this, $e, uk).call(this, s);
    const { volume: T, muted: x } = l(this, Bt).$state;
    this.setVolume(T()), this.setMuted(x()), l(this, T1).start(), l(this, nh).syncRemoteTracks(g), l(this, nh).syncRemoteActiveIds(g);
  });
}, lk = function() {
  l(this, Bt).$state.canSetVolume.set(l(this, Rt).canControlVolume);
}, uk = function(s) {
  const t = m(this, $e, Tc).call(this, s);
  l(this, Bt).notify("stream-type-change", m(this, $e, XH).call(this), t);
}, XH = function() {
  var t;
  return ((t = l(this, Rt).mediaInfo) == null ? void 0 : t.streamType) === chrome.cast.media.StreamType.LIVE ? l(this, Rt).canSeek ? "live:dvr" : "live" : "on-demand";
}, JH = function() {
  if (l(this, co)) return;
  const s = l(this, Rt).currentTime;
  s !== l(this, w1) && (l(this, Bt).notify("time-change", s), s > l(this, Bm) && (L(this, Bm, s), m(this, $e, dk).call(this)), l(this, Bt).$state.seeking() && l(this, Bt).notify("seeked", s), L(this, w1, s));
}, eF = function(s) {
  if (!l(this, Rt).isMediaLoaded || l(this, co)) return;
  const t = l(this, Rt).duration, r = m(this, $e, Tc).call(this, s);
  L(this, qm, new Ui(0, t)), l(this, Bt).notify("duration-change", t, r);
}, ck = function(s) {
  if (!l(this, Rt).isMediaLoaded) return;
  const t = {
    muted: l(this, Rt).isMuted,
    volume: l(this, Rt).volumeLevel
  }, r = m(this, $e, Tc).call(this, s);
  l(this, Bt).notify("volume-change", t, r);
}, tF = function(s) {
  const t = m(this, $e, Tc).call(this, s);
  l(this, Rt).isPaused ? l(this, Bt).notify("pause", void 0, t) : l(this, Bt).notify("play", void 0, t);
}, dk = function(s) {
  const t = {
    seekable: m(this, $e, fk).call(this),
    buffered: new Ui(0, l(this, Bm))
  }, r = s ? m(this, $e, Tc).call(this, s) : void 0;
  l(this, Bt).notify("progress", t, r);
}, nF = function(s) {
  const t = l(this, Rt).playerState, r = chrome.cast.media.PlayerState;
  if (L(this, E1, t === r.IDLE), t === r.PAUSED) return;
  const f = m(this, $e, Tc).call(this, s);
  switch (t) {
    case r.PLAYING:
      l(this, Bt).notify("playing", void 0, f);
      break;
    case r.BUFFERING:
      l(this, Bt).notify("waiting", void 0, f);
      break;
    case r.IDLE:
      l(this, T1).stop(), l(this, Bt).notify("pause"), l(this, Bt).notify("end");
      break;
  }
}, fk = function() {
  return l(this, Rt).liveSeekableRange ? new Ui(l(this, Rt).liveSeekableRange.start, l(this, Rt).liveSeekableRange.end) : l(this, qm);
}, Tc = function(s) {
  return s instanceof Event ? s : new St(s.type, { detail: s });
}, iF = function(s) {
  const { streamType: t, title: r, poster: f } = l(this, Bt).$state;
  return new zee(s).setMetadata(r(), f()).setStreamType(t()).setTracks(l(this, nh).getLocalTextTracks()).build();
}, rF = function(s) {
  var v, g;
  const t = m(this, $e, iF).call(this, s), r = new chrome.cast.media.LoadRequest(t), f = l(this, Bt).$state.savedState();
  return r.autoplay = (((v = l(this, co)) == null ? void 0 : v.paused) ?? (f == null ? void 0 : f.paused)) === !1, r.currentTime = ((g = l(this, co)) == null ? void 0 : g.time) ?? (f == null ? void 0 : f.currentTime) ?? 0, r;
}, hk = async function(s, t) {
  const r = fe(l(this, Bt).$state.source);
  L(this, co, { src: r, paused: s, time: t }), await this.loadSource(r);
}, aF = function() {
  m(this, $e, hk).call(this, l(this, Rt).isPaused, l(this, Rt).currentTime).catch((s) => {
  });
};
const Iee = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GoogleCastProvider: Fee
}, Symbol.toStringTag, { value: "Module" }));
export {
  eW as A,
  GJ as C,
  _X as F,
  JJ as M,
  iee as T,
  Tte as a,
  ex as b,
  kte as c,
  bte as d,
  Ete as e,
  CJ as f,
  Gk as g,
  Wee as h,
  os as i,
  Kee as j,
  Xee as k,
  Jee as l,
  Zee as m,
  tee as n,
  yte as o,
  wte as s,
  Cte as t,
  Ste as u,
  gte as v
};
